
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire855c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire855c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fJAss", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $b74756cc4e9d9700$export$ffb0004e005737fa, (v) => $b74756cc4e9d9700$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $b74756cc4e9d9700$export$34b9dba7ce09269b, (v) => $b74756cc4e9d9700$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $b74756cc4e9d9700$export$25062201e9e25d76, (v) => $b74756cc4e9d9700$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b74756cc4e9d9700$export$ffb0004e005737fa;
var $b74756cc4e9d9700$export$34b9dba7ce09269b;
var $b74756cc4e9d9700$export$25062201e9e25d76;
'use strict';

var $dup7A = parcelRequire("dup7A");
var $b74756cc4e9d9700$var$k = Symbol.for("react.element"), $b74756cc4e9d9700$var$l = Symbol.for("react.fragment"), $b74756cc4e9d9700$var$m = Object.prototype.hasOwnProperty, $b74756cc4e9d9700$var$n = $dup7A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $b74756cc4e9d9700$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b74756cc4e9d9700$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$b74756cc4e9d9700$var$m.call(a, b) && !$b74756cc4e9d9700$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $b74756cc4e9d9700$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $b74756cc4e9d9700$var$n.current
    };
}
$b74756cc4e9d9700$export$ffb0004e005737fa = $b74756cc4e9d9700$var$l;
$b74756cc4e9d9700$export$34b9dba7ce09269b = $b74756cc4e9d9700$var$q;
$b74756cc4e9d9700$export$25062201e9e25d76 = $b74756cc4e9d9700$var$q;

});
parcelRegister("dup7A", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fpMhT"));

});
parcelRegister("fpMhT", function(module, exports) {

$parcel$export(module.exports, "Children", () => $b38ea5b65b2045e0$export$dca3b0875bd9a954, (v) => $b38ea5b65b2045e0$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $b38ea5b65b2045e0$export$16fa2f45be04daa8, (v) => $b38ea5b65b2045e0$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $b38ea5b65b2045e0$export$ffb0004e005737fa, (v) => $b38ea5b65b2045e0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $b38ea5b65b2045e0$export$e2c29f18771995cb, (v) => $b38ea5b65b2045e0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $b38ea5b65b2045e0$export$221d75b3f55bb0bd, (v) => $b38ea5b65b2045e0$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $b38ea5b65b2045e0$export$5f8d39834fd61797, (v) => $b38ea5b65b2045e0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $b38ea5b65b2045e0$export$74bf444e3cd11ea5, (v) => $b38ea5b65b2045e0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $b38ea5b65b2045e0$export$ae55be85d98224ed, (v) => $b38ea5b65b2045e0$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $b38ea5b65b2045e0$export$3ba232387fd5d6dd, (v) => $b38ea5b65b2045e0$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $b38ea5b65b2045e0$export$e530037191fcd5d7, (v) => $b38ea5b65b2045e0$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $b38ea5b65b2045e0$export$fd42f52fd3ae1109, (v) => $b38ea5b65b2045e0$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $b38ea5b65b2045e0$export$c8a8987d4410bf2d, (v) => $b38ea5b65b2045e0$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $b38ea5b65b2045e0$export$d38cd72104c1f0e9, (v) => $b38ea5b65b2045e0$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $b38ea5b65b2045e0$export$7d1e3a5e95ceca43, (v) => $b38ea5b65b2045e0$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $b38ea5b65b2045e0$export$257a8862b851cb5b, (v) => $b38ea5b65b2045e0$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $b38ea5b65b2045e0$export$a8257692ac88316c, (v) => $b38ea5b65b2045e0$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $b38ea5b65b2045e0$export$488013bae63b21da, (v) => $b38ea5b65b2045e0$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $b38ea5b65b2045e0$export$7c73462e0d25e514, (v) => $b38ea5b65b2045e0$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $b38ea5b65b2045e0$export$7568632d0d33d16d, (v) => $b38ea5b65b2045e0$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $b38ea5b65b2045e0$export$88948ce120ea2619, (v) => $b38ea5b65b2045e0$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $b38ea5b65b2045e0$export$35808ee640e87ca7, (v) => $b38ea5b65b2045e0$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $b38ea5b65b2045e0$export$fae74005e78b1a27, (v) => $b38ea5b65b2045e0$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $b38ea5b65b2045e0$export$dc8fbce3eb94dc1e, (v) => $b38ea5b65b2045e0$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $b38ea5b65b2045e0$export$6a7bc4e911dc01cf, (v) => $b38ea5b65b2045e0$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $b38ea5b65b2045e0$export$6d9c69b0de29b591, (v) => $b38ea5b65b2045e0$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $b38ea5b65b2045e0$export$f680877a34711e37, (v) => $b38ea5b65b2045e0$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $b38ea5b65b2045e0$export$d5a552a76deda3c2, (v) => $b38ea5b65b2045e0$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $b38ea5b65b2045e0$export$aaabe4eda9ed9969, (v) => $b38ea5b65b2045e0$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $b38ea5b65b2045e0$export$e5c5a5f917a5871c, (v) => $b38ea5b65b2045e0$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $b38ea5b65b2045e0$export$1538c33de8887b59, (v) => $b38ea5b65b2045e0$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $b38ea5b65b2045e0$export$13e3392192263954, (v) => $b38ea5b65b2045e0$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $b38ea5b65b2045e0$export$b8f5890fc79d6aca, (v) => $b38ea5b65b2045e0$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $b38ea5b65b2045e0$export$60241385465d0a34, (v) => $b38ea5b65b2045e0$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $b38ea5b65b2045e0$export$306c0aa65ff9ec16, (v) => $b38ea5b65b2045e0$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $b38ea5b65b2045e0$export$7b286972b8d8ccbf, (v) => $b38ea5b65b2045e0$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $b38ea5b65b2045e0$export$83d89fbfd8236492, (v) => $b38ea5b65b2045e0$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b38ea5b65b2045e0$export$dca3b0875bd9a954;
var $b38ea5b65b2045e0$export$16fa2f45be04daa8;
var $b38ea5b65b2045e0$export$ffb0004e005737fa;
var $b38ea5b65b2045e0$export$e2c29f18771995cb;
var $b38ea5b65b2045e0$export$221d75b3f55bb0bd;
var $b38ea5b65b2045e0$export$5f8d39834fd61797;
var $b38ea5b65b2045e0$export$74bf444e3cd11ea5;
var $b38ea5b65b2045e0$export$ae55be85d98224ed;
var $b38ea5b65b2045e0$export$3ba232387fd5d6dd;
var $b38ea5b65b2045e0$export$e530037191fcd5d7;
var $b38ea5b65b2045e0$export$fd42f52fd3ae1109;
var $b38ea5b65b2045e0$export$c8a8987d4410bf2d;
var $b38ea5b65b2045e0$export$d38cd72104c1f0e9;
var $b38ea5b65b2045e0$export$7d1e3a5e95ceca43;
var $b38ea5b65b2045e0$export$257a8862b851cb5b;
var $b38ea5b65b2045e0$export$a8257692ac88316c;
var $b38ea5b65b2045e0$export$488013bae63b21da;
var $b38ea5b65b2045e0$export$7c73462e0d25e514;
var $b38ea5b65b2045e0$export$7568632d0d33d16d;
var $b38ea5b65b2045e0$export$88948ce120ea2619;
var $b38ea5b65b2045e0$export$35808ee640e87ca7;
var $b38ea5b65b2045e0$export$fae74005e78b1a27;
var $b38ea5b65b2045e0$export$dc8fbce3eb94dc1e;
var $b38ea5b65b2045e0$export$6a7bc4e911dc01cf;
var $b38ea5b65b2045e0$export$6d9c69b0de29b591;
var $b38ea5b65b2045e0$export$f680877a34711e37;
var $b38ea5b65b2045e0$export$d5a552a76deda3c2;
var $b38ea5b65b2045e0$export$aaabe4eda9ed9969;
var $b38ea5b65b2045e0$export$e5c5a5f917a5871c;
var $b38ea5b65b2045e0$export$1538c33de8887b59;
var $b38ea5b65b2045e0$export$13e3392192263954;
var $b38ea5b65b2045e0$export$b8f5890fc79d6aca;
var $b38ea5b65b2045e0$export$60241385465d0a34;
var $b38ea5b65b2045e0$export$306c0aa65ff9ec16;
var $b38ea5b65b2045e0$export$7b286972b8d8ccbf;
var $b38ea5b65b2045e0$export$83d89fbfd8236492;
'use strict';
var $b38ea5b65b2045e0$var$l = Symbol.for("react.element"), $b38ea5b65b2045e0$var$n = Symbol.for("react.portal"), $b38ea5b65b2045e0$var$p = Symbol.for("react.fragment"), $b38ea5b65b2045e0$var$q = Symbol.for("react.strict_mode"), $b38ea5b65b2045e0$var$r = Symbol.for("react.profiler"), $b38ea5b65b2045e0$var$t = Symbol.for("react.provider"), $b38ea5b65b2045e0$var$u = Symbol.for("react.context"), $b38ea5b65b2045e0$var$v = Symbol.for("react.forward_ref"), $b38ea5b65b2045e0$var$w = Symbol.for("react.suspense"), $b38ea5b65b2045e0$var$x = Symbol.for("react.memo"), $b38ea5b65b2045e0$var$y = Symbol.for("react.lazy"), $b38ea5b65b2045e0$var$z = Symbol.iterator;
function $b38ea5b65b2045e0$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b38ea5b65b2045e0$var$z && a[$b38ea5b65b2045e0$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b38ea5b65b2045e0$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b38ea5b65b2045e0$var$C = Object.assign, $b38ea5b65b2045e0$var$D = {};
function $b38ea5b65b2045e0$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b38ea5b65b2045e0$var$D;
    this.updater = e || $b38ea5b65b2045e0$var$B;
}
$b38ea5b65b2045e0$var$E.prototype.isReactComponent = {};
$b38ea5b65b2045e0$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b38ea5b65b2045e0$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b38ea5b65b2045e0$var$F() {}
$b38ea5b65b2045e0$var$F.prototype = $b38ea5b65b2045e0$var$E.prototype;
function $b38ea5b65b2045e0$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b38ea5b65b2045e0$var$D;
    this.updater = e || $b38ea5b65b2045e0$var$B;
}
var $b38ea5b65b2045e0$var$H = $b38ea5b65b2045e0$var$G.prototype = new $b38ea5b65b2045e0$var$F;
$b38ea5b65b2045e0$var$H.constructor = $b38ea5b65b2045e0$var$G;
$b38ea5b65b2045e0$var$C($b38ea5b65b2045e0$var$H, $b38ea5b65b2045e0$var$E.prototype);
$b38ea5b65b2045e0$var$H.isPureReactComponent = !0;
var $b38ea5b65b2045e0$var$I = Array.isArray, $b38ea5b65b2045e0$var$J = Object.prototype.hasOwnProperty, $b38ea5b65b2045e0$var$K = {
    current: null
}, $b38ea5b65b2045e0$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b38ea5b65b2045e0$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b38ea5b65b2045e0$var$J.call(b, d) && !$b38ea5b65b2045e0$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b38ea5b65b2045e0$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b38ea5b65b2045e0$var$K.current
    };
}
function $b38ea5b65b2045e0$var$N(a, b) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b38ea5b65b2045e0$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b38ea5b65b2045e0$var$l;
}
function $b38ea5b65b2045e0$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b38ea5b65b2045e0$var$P = /\/+/g;
function $b38ea5b65b2045e0$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b38ea5b65b2045e0$var$escape("" + a.key) : b.toString(36);
}
function $b38ea5b65b2045e0$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b38ea5b65b2045e0$var$l:
                case $b38ea5b65b2045e0$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b38ea5b65b2045e0$var$Q(h, 0) : d, $b38ea5b65b2045e0$var$I(c) ? (e = "", null != a && (e = a.replace($b38ea5b65b2045e0$var$P, "$&/") + "/"), $b38ea5b65b2045e0$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b38ea5b65b2045e0$var$O(c) && (c = $b38ea5b65b2045e0$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b38ea5b65b2045e0$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b38ea5b65b2045e0$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b38ea5b65b2045e0$var$Q(k, g);
        h += $b38ea5b65b2045e0$var$R(k, b, e, f, c);
    }
    else if (f = $b38ea5b65b2045e0$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b38ea5b65b2045e0$var$Q(k, g++), h += $b38ea5b65b2045e0$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b38ea5b65b2045e0$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b38ea5b65b2045e0$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b38ea5b65b2045e0$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b38ea5b65b2045e0$var$U = {
    current: null
}, $b38ea5b65b2045e0$var$V = {
    transition: null
}, $b38ea5b65b2045e0$var$W = {
    ReactCurrentDispatcher: $b38ea5b65b2045e0$var$U,
    ReactCurrentBatchConfig: $b38ea5b65b2045e0$var$V,
    ReactCurrentOwner: $b38ea5b65b2045e0$var$K
};
function $b38ea5b65b2045e0$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b38ea5b65b2045e0$export$dca3b0875bd9a954 = {
    map: $b38ea5b65b2045e0$var$S,
    forEach: function(a, b, e) {
        $b38ea5b65b2045e0$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b38ea5b65b2045e0$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b38ea5b65b2045e0$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b38ea5b65b2045e0$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b38ea5b65b2045e0$export$16fa2f45be04daa8 = $b38ea5b65b2045e0$var$E;
$b38ea5b65b2045e0$export$ffb0004e005737fa = $b38ea5b65b2045e0$var$p;
$b38ea5b65b2045e0$export$e2c29f18771995cb = $b38ea5b65b2045e0$var$r;
$b38ea5b65b2045e0$export$221d75b3f55bb0bd = $b38ea5b65b2045e0$var$G;
$b38ea5b65b2045e0$export$5f8d39834fd61797 = $b38ea5b65b2045e0$var$q;
$b38ea5b65b2045e0$export$74bf444e3cd11ea5 = $b38ea5b65b2045e0$var$w;
$b38ea5b65b2045e0$export$ae55be85d98224ed = $b38ea5b65b2045e0$var$W;
$b38ea5b65b2045e0$export$3ba232387fd5d6dd = $b38ea5b65b2045e0$var$X;
$b38ea5b65b2045e0$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b38ea5b65b2045e0$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b38ea5b65b2045e0$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b38ea5b65b2045e0$var$J.call(b, f) && !$b38ea5b65b2045e0$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b38ea5b65b2045e0$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b38ea5b65b2045e0$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b38ea5b65b2045e0$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b38ea5b65b2045e0$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b38ea5b65b2045e0$export$c8a8987d4410bf2d = $b38ea5b65b2045e0$var$M;
$b38ea5b65b2045e0$export$d38cd72104c1f0e9 = function(a) {
    var b = $b38ea5b65b2045e0$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b38ea5b65b2045e0$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b38ea5b65b2045e0$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$v,
        render: a
    };
};
$b38ea5b65b2045e0$export$a8257692ac88316c = $b38ea5b65b2045e0$var$O;
$b38ea5b65b2045e0$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b38ea5b65b2045e0$var$T
    };
};
$b38ea5b65b2045e0$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b38ea5b65b2045e0$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b38ea5b65b2045e0$export$7568632d0d33d16d = function(a) {
    var b = $b38ea5b65b2045e0$var$V.transition;
    $b38ea5b65b2045e0$var$V.transition = {};
    try {
        a();
    } finally{
        $b38ea5b65b2045e0$var$V.transition = b;
    }
};
$b38ea5b65b2045e0$export$88948ce120ea2619 = $b38ea5b65b2045e0$var$X;
$b38ea5b65b2045e0$export$35808ee640e87ca7 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useCallback(a, b);
};
$b38ea5b65b2045e0$export$fae74005e78b1a27 = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useContext(a);
};
$b38ea5b65b2045e0$export$dc8fbce3eb94dc1e = function() {};
$b38ea5b65b2045e0$export$6a7bc4e911dc01cf = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useDeferredValue(a);
};
$b38ea5b65b2045e0$export$6d9c69b0de29b591 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useEffect(a, b);
};
$b38ea5b65b2045e0$export$f680877a34711e37 = function() {
    return $b38ea5b65b2045e0$var$U.current.useId();
};
$b38ea5b65b2045e0$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b38ea5b65b2045e0$var$U.current.useImperativeHandle(a, b, e);
};
$b38ea5b65b2045e0$export$aaabe4eda9ed9969 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useInsertionEffect(a, b);
};
$b38ea5b65b2045e0$export$e5c5a5f917a5871c = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useLayoutEffect(a, b);
};
$b38ea5b65b2045e0$export$1538c33de8887b59 = function(a, b) {
    return $b38ea5b65b2045e0$var$U.current.useMemo(a, b);
};
$b38ea5b65b2045e0$export$13e3392192263954 = function(a, b, e) {
    return $b38ea5b65b2045e0$var$U.current.useReducer(a, b, e);
};
$b38ea5b65b2045e0$export$b8f5890fc79d6aca = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useRef(a);
};
$b38ea5b65b2045e0$export$60241385465d0a34 = function(a) {
    return $b38ea5b65b2045e0$var$U.current.useState(a);
};
$b38ea5b65b2045e0$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b38ea5b65b2045e0$var$U.current.useSyncExternalStore(a, b, e);
};
$b38ea5b65b2045e0$export$7b286972b8d8ccbf = function() {
    return $b38ea5b65b2045e0$var$U.current.useTransition();
};
$b38ea5b65b2045e0$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("dpuiw", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $9c351ca3251b0a6f$export$ae55be85d98224ed, (v) => $9c351ca3251b0a6f$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $9c351ca3251b0a6f$export$d39a5bbd09211389, (v) => $9c351ca3251b0a6f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $9c351ca3251b0a6f$export$882461b6382ed46c, (v) => $9c351ca3251b0a6f$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $9c351ca3251b0a6f$export$466bfc07425424d5, (v) => $9c351ca3251b0a6f$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $9c351ca3251b0a6f$export$cd75ccfd720a3cd4, (v) => $9c351ca3251b0a6f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $9c351ca3251b0a6f$export$fa8d919ba61d84db, (v) => $9c351ca3251b0a6f$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $9c351ca3251b0a6f$export$757ceba2d55c277e, (v) => $9c351ca3251b0a6f$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $9c351ca3251b0a6f$export$b3890eb0ae9dca99, (v) => $9c351ca3251b0a6f$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $9c351ca3251b0a6f$export$502457920280e6be, (v) => $9c351ca3251b0a6f$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $9c351ca3251b0a6f$export$c78a37762a8d58e1, (v) => $9c351ca3251b0a6f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $9c351ca3251b0a6f$export$dc54d992c10e8a18, (v) => $9c351ca3251b0a6f$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $9c351ca3251b0a6f$export$83d89fbfd8236492, (v) => $9c351ca3251b0a6f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $9c351ca3251b0a6f$export$ae55be85d98224ed;
var $9c351ca3251b0a6f$export$d39a5bbd09211389;
var $9c351ca3251b0a6f$export$882461b6382ed46c;
var $9c351ca3251b0a6f$export$466bfc07425424d5;
var $9c351ca3251b0a6f$export$cd75ccfd720a3cd4;
var $9c351ca3251b0a6f$export$fa8d919ba61d84db;
var $9c351ca3251b0a6f$export$757ceba2d55c277e;
var $9c351ca3251b0a6f$export$b3890eb0ae9dca99;
var $9c351ca3251b0a6f$export$502457920280e6be;
var $9c351ca3251b0a6f$export$c78a37762a8d58e1;
var $9c351ca3251b0a6f$export$dc54d992c10e8a18;
var $9c351ca3251b0a6f$export$83d89fbfd8236492;
'use strict';

var $dup7A = parcelRequire("dup7A");

var $4xoBZ = parcelRequire("4xoBZ");
function $9c351ca3251b0a6f$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $9c351ca3251b0a6f$var$da = new Set, $9c351ca3251b0a6f$var$ea = {};
function $9c351ca3251b0a6f$var$fa(a, b) {
    $9c351ca3251b0a6f$var$ha(a, b);
    $9c351ca3251b0a6f$var$ha(a + "Capture", b);
}
function $9c351ca3251b0a6f$var$ha(a, b) {
    $9c351ca3251b0a6f$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$9c351ca3251b0a6f$var$da.add(b[a]);
}
var $9c351ca3251b0a6f$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $9c351ca3251b0a6f$var$ja = Object.prototype.hasOwnProperty, $9c351ca3251b0a6f$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $9c351ca3251b0a6f$var$la = {}, $9c351ca3251b0a6f$var$ma = {};
function $9c351ca3251b0a6f$var$oa(a) {
    if ($9c351ca3251b0a6f$var$ja.call($9c351ca3251b0a6f$var$ma, a)) return !0;
    if ($9c351ca3251b0a6f$var$ja.call($9c351ca3251b0a6f$var$la, a)) return !1;
    if ($9c351ca3251b0a6f$var$ka.test(a)) return $9c351ca3251b0a6f$var$ma[a] = !0;
    $9c351ca3251b0a6f$var$la[a] = !0;
    return !1;
}
function $9c351ca3251b0a6f$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $9c351ca3251b0a6f$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $9c351ca3251b0a6f$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $9c351ca3251b0a6f$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $9c351ca3251b0a6f$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $9c351ca3251b0a6f$var$ra = /[\-:]([a-z])/g;
function $9c351ca3251b0a6f$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($9c351ca3251b0a6f$var$ra, $9c351ca3251b0a6f$var$sa);
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($9c351ca3251b0a6f$var$ra, $9c351ca3251b0a6f$var$sa);
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($9c351ca3251b0a6f$var$ra, $9c351ca3251b0a6f$var$sa);
    $9c351ca3251b0a6f$var$z[b] = new $9c351ca3251b0a6f$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$9c351ca3251b0a6f$var$z.xlinkHref = new $9c351ca3251b0a6f$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $9c351ca3251b0a6f$var$z[a] = new $9c351ca3251b0a6f$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $9c351ca3251b0a6f$var$ta(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$z.hasOwnProperty(b) ? $9c351ca3251b0a6f$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $9c351ca3251b0a6f$var$qa(b, c, e, d) && (c = null), d || null === e ? $9c351ca3251b0a6f$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $9c351ca3251b0a6f$var$ua = $dup7A.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $9c351ca3251b0a6f$var$va = Symbol.for("react.element"), $9c351ca3251b0a6f$var$wa = Symbol.for("react.portal"), $9c351ca3251b0a6f$var$ya = Symbol.for("react.fragment"), $9c351ca3251b0a6f$var$za = Symbol.for("react.strict_mode"), $9c351ca3251b0a6f$var$Aa = Symbol.for("react.profiler"), $9c351ca3251b0a6f$var$Ba = Symbol.for("react.provider"), $9c351ca3251b0a6f$var$Ca = Symbol.for("react.context"), $9c351ca3251b0a6f$var$Da = Symbol.for("react.forward_ref"), $9c351ca3251b0a6f$var$Ea = Symbol.for("react.suspense"), $9c351ca3251b0a6f$var$Fa = Symbol.for("react.suspense_list"), $9c351ca3251b0a6f$var$Ga = Symbol.for("react.memo"), $9c351ca3251b0a6f$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $9c351ca3251b0a6f$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $9c351ca3251b0a6f$var$Ja = Symbol.iterator;
function $9c351ca3251b0a6f$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $9c351ca3251b0a6f$var$Ja && a[$9c351ca3251b0a6f$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $9c351ca3251b0a6f$var$A = Object.assign, $9c351ca3251b0a6f$var$La;
function $9c351ca3251b0a6f$var$Ma(a) {
    if (void 0 === $9c351ca3251b0a6f$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $9c351ca3251b0a6f$var$La = b && b[1] || "";
    }
    return "\n" + $9c351ca3251b0a6f$var$La + a;
}
var $9c351ca3251b0a6f$var$Na = !1;
function $9c351ca3251b0a6f$var$Oa(a, b) {
    if (!a || $9c351ca3251b0a6f$var$Na) return "";
    $9c351ca3251b0a6f$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $9c351ca3251b0a6f$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $9c351ca3251b0a6f$var$Ma(a) : "";
}
function $9c351ca3251b0a6f$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $9c351ca3251b0a6f$var$Ma(a.type);
        case 16:
            return $9c351ca3251b0a6f$var$Ma("Lazy");
        case 13:
            return $9c351ca3251b0a6f$var$Ma("Suspense");
        case 19:
            return $9c351ca3251b0a6f$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $9c351ca3251b0a6f$var$Oa(a.type, !1), a;
        case 11:
            return a = $9c351ca3251b0a6f$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $9c351ca3251b0a6f$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $9c351ca3251b0a6f$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $9c351ca3251b0a6f$var$ya:
            return "Fragment";
        case $9c351ca3251b0a6f$var$wa:
            return "Portal";
        case $9c351ca3251b0a6f$var$Aa:
            return "Profiler";
        case $9c351ca3251b0a6f$var$za:
            return "StrictMode";
        case $9c351ca3251b0a6f$var$Ea:
            return "Suspense";
        case $9c351ca3251b0a6f$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $9c351ca3251b0a6f$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $9c351ca3251b0a6f$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $9c351ca3251b0a6f$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $9c351ca3251b0a6f$var$Ga:
            return b = a.displayName || null, null !== b ? b : $9c351ca3251b0a6f$var$Qa(a.type) || "Memo";
        case $9c351ca3251b0a6f$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $9c351ca3251b0a6f$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $9c351ca3251b0a6f$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $9c351ca3251b0a6f$var$Qa(b);
        case 8:
            return b === $9c351ca3251b0a6f$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $9c351ca3251b0a6f$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $9c351ca3251b0a6f$var$Ua(a) {
    var b = $9c351ca3251b0a6f$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $9c351ca3251b0a6f$var$Va(a) {
    a._valueTracker || (a._valueTracker = $9c351ca3251b0a6f$var$Ua(a));
}
function $9c351ca3251b0a6f$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $9c351ca3251b0a6f$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $9c351ca3251b0a6f$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $9c351ca3251b0a6f$var$Ya(a, b) {
    var c = b.checked;
    return $9c351ca3251b0a6f$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $9c351ca3251b0a6f$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $9c351ca3251b0a6f$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $9c351ca3251b0a6f$var$ab(a, b) {
    b = b.checked;
    null != b && $9c351ca3251b0a6f$var$ta(a, "checked", b, !1);
}
function $9c351ca3251b0a6f$var$bb(a, b) {
    $9c351ca3251b0a6f$var$ab(a, b);
    var c = $9c351ca3251b0a6f$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $9c351ca3251b0a6f$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $9c351ca3251b0a6f$var$cb(a, b.type, $9c351ca3251b0a6f$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $9c351ca3251b0a6f$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $9c351ca3251b0a6f$var$cb(a, b, c) {
    if ("number" !== b || $9c351ca3251b0a6f$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $9c351ca3251b0a6f$var$eb = Array.isArray;
function $9c351ca3251b0a6f$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $9c351ca3251b0a6f$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $9c351ca3251b0a6f$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($9c351ca3251b0a6f$var$p(91));
    return $9c351ca3251b0a6f$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $9c351ca3251b0a6f$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($9c351ca3251b0a6f$var$p(92));
            if ($9c351ca3251b0a6f$var$eb(c)) {
                if (1 < c.length) throw Error($9c351ca3251b0a6f$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $9c351ca3251b0a6f$var$Sa(c)
    };
}
function $9c351ca3251b0a6f$var$ib(a, b) {
    var c = $9c351ca3251b0a6f$var$Sa(b.value), d = $9c351ca3251b0a6f$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $9c351ca3251b0a6f$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $9c351ca3251b0a6f$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $9c351ca3251b0a6f$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $9c351ca3251b0a6f$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $9c351ca3251b0a6f$var$mb, $9c351ca3251b0a6f$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $9c351ca3251b0a6f$var$mb = $9c351ca3251b0a6f$var$mb || document.createElement("div");
        $9c351ca3251b0a6f$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $9c351ca3251b0a6f$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $9c351ca3251b0a6f$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $9c351ca3251b0a6f$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $9c351ca3251b0a6f$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($9c351ca3251b0a6f$var$pb).forEach(function(a) {
    $9c351ca3251b0a6f$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $9c351ca3251b0a6f$var$pb[b] = $9c351ca3251b0a6f$var$pb[a];
    });
});
function $9c351ca3251b0a6f$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $9c351ca3251b0a6f$var$pb.hasOwnProperty(a) && $9c351ca3251b0a6f$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $9c351ca3251b0a6f$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $9c351ca3251b0a6f$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $9c351ca3251b0a6f$var$tb = $9c351ca3251b0a6f$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $9c351ca3251b0a6f$var$ub(a, b) {
    if (b) {
        if ($9c351ca3251b0a6f$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($9c351ca3251b0a6f$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($9c351ca3251b0a6f$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($9c351ca3251b0a6f$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($9c351ca3251b0a6f$var$p(62));
    }
}
function $9c351ca3251b0a6f$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $9c351ca3251b0a6f$var$wb = null;
function $9c351ca3251b0a6f$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $9c351ca3251b0a6f$var$yb = null, $9c351ca3251b0a6f$var$zb = null, $9c351ca3251b0a6f$var$Ab = null;
function $9c351ca3251b0a6f$var$Bb(a) {
    if (a = $9c351ca3251b0a6f$var$Cb(a)) {
        if ("function" !== typeof $9c351ca3251b0a6f$var$yb) throw Error($9c351ca3251b0a6f$var$p(280));
        var b = a.stateNode;
        b && (b = $9c351ca3251b0a6f$var$Db(b), $9c351ca3251b0a6f$var$yb(a.stateNode, a.type, b));
    }
}
function $9c351ca3251b0a6f$var$Eb(a) {
    $9c351ca3251b0a6f$var$zb ? $9c351ca3251b0a6f$var$Ab ? $9c351ca3251b0a6f$var$Ab.push(a) : $9c351ca3251b0a6f$var$Ab = [
        a
    ] : $9c351ca3251b0a6f$var$zb = a;
}
function $9c351ca3251b0a6f$var$Fb() {
    if ($9c351ca3251b0a6f$var$zb) {
        var a = $9c351ca3251b0a6f$var$zb, b = $9c351ca3251b0a6f$var$Ab;
        $9c351ca3251b0a6f$var$Ab = $9c351ca3251b0a6f$var$zb = null;
        $9c351ca3251b0a6f$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$9c351ca3251b0a6f$var$Bb(b[a]);
    }
}
function $9c351ca3251b0a6f$var$Gb(a, b) {
    return a(b);
}
function $9c351ca3251b0a6f$var$Hb() {}
var $9c351ca3251b0a6f$var$Ib = !1;
function $9c351ca3251b0a6f$var$Jb(a, b, c) {
    if ($9c351ca3251b0a6f$var$Ib) return a(b, c);
    $9c351ca3251b0a6f$var$Ib = !0;
    try {
        return $9c351ca3251b0a6f$var$Gb(a, b, c);
    } finally{
        if ($9c351ca3251b0a6f$var$Ib = !1, null !== $9c351ca3251b0a6f$var$zb || null !== $9c351ca3251b0a6f$var$Ab) $9c351ca3251b0a6f$var$Hb(), $9c351ca3251b0a6f$var$Fb();
    }
}
function $9c351ca3251b0a6f$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $9c351ca3251b0a6f$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($9c351ca3251b0a6f$var$p(231, b, typeof c));
    return c;
}
var $9c351ca3251b0a6f$var$Lb = !1;
if ($9c351ca3251b0a6f$var$ia) try {
    var $9c351ca3251b0a6f$var$Mb = {};
    Object.defineProperty($9c351ca3251b0a6f$var$Mb, "passive", {
        get: function() {
            $9c351ca3251b0a6f$var$Lb = !0;
        }
    });
    window.addEventListener("test", $9c351ca3251b0a6f$var$Mb, $9c351ca3251b0a6f$var$Mb);
    window.removeEventListener("test", $9c351ca3251b0a6f$var$Mb, $9c351ca3251b0a6f$var$Mb);
} catch (a) {
    $9c351ca3251b0a6f$var$Lb = !1;
}
function $9c351ca3251b0a6f$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $9c351ca3251b0a6f$var$Ob = !1, $9c351ca3251b0a6f$var$Pb = null, $9c351ca3251b0a6f$var$Qb = !1, $9c351ca3251b0a6f$var$Rb = null, $9c351ca3251b0a6f$var$Sb = {
    onError: function(a) {
        $9c351ca3251b0a6f$var$Ob = !0;
        $9c351ca3251b0a6f$var$Pb = a;
    }
};
function $9c351ca3251b0a6f$var$Tb(a, b, c, d, e, f, g, h, k) {
    $9c351ca3251b0a6f$var$Ob = !1;
    $9c351ca3251b0a6f$var$Pb = null;
    $9c351ca3251b0a6f$var$Nb.apply($9c351ca3251b0a6f$var$Sb, arguments);
}
function $9c351ca3251b0a6f$var$Ub(a, b, c, d, e, f, g, h, k) {
    $9c351ca3251b0a6f$var$Tb.apply(this, arguments);
    if ($9c351ca3251b0a6f$var$Ob) {
        if ($9c351ca3251b0a6f$var$Ob) {
            var l = $9c351ca3251b0a6f$var$Pb;
            $9c351ca3251b0a6f$var$Ob = !1;
            $9c351ca3251b0a6f$var$Pb = null;
        } else throw Error($9c351ca3251b0a6f$var$p(198));
        $9c351ca3251b0a6f$var$Qb || ($9c351ca3251b0a6f$var$Qb = !0, $9c351ca3251b0a6f$var$Rb = l);
    }
}
function $9c351ca3251b0a6f$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $9c351ca3251b0a6f$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Xb(a) {
    if ($9c351ca3251b0a6f$var$Vb(a) !== a) throw Error($9c351ca3251b0a6f$var$p(188));
}
function $9c351ca3251b0a6f$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $9c351ca3251b0a6f$var$Vb(a);
        if (null === b) throw Error($9c351ca3251b0a6f$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $9c351ca3251b0a6f$var$Xb(e), a;
                if (f === d) return $9c351ca3251b0a6f$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($9c351ca3251b0a6f$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($9c351ca3251b0a6f$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($9c351ca3251b0a6f$var$p(190));
    }
    if (3 !== c.tag) throw Error($9c351ca3251b0a6f$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $9c351ca3251b0a6f$var$Zb(a) {
    a = $9c351ca3251b0a6f$var$Yb(a);
    return null !== a ? $9c351ca3251b0a6f$var$$b(a) : null;
}
function $9c351ca3251b0a6f$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $9c351ca3251b0a6f$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $9c351ca3251b0a6f$var$ac = $4xoBZ.unstable_scheduleCallback, $9c351ca3251b0a6f$var$bc = $4xoBZ.unstable_cancelCallback, $9c351ca3251b0a6f$var$cc = $4xoBZ.unstable_shouldYield, $9c351ca3251b0a6f$var$dc = $4xoBZ.unstable_requestPaint, $9c351ca3251b0a6f$var$B = $4xoBZ.unstable_now, $9c351ca3251b0a6f$var$ec = $4xoBZ.unstable_getCurrentPriorityLevel, $9c351ca3251b0a6f$var$fc = $4xoBZ.unstable_ImmediatePriority, $9c351ca3251b0a6f$var$gc = $4xoBZ.unstable_UserBlockingPriority, $9c351ca3251b0a6f$var$hc = $4xoBZ.unstable_NormalPriority, $9c351ca3251b0a6f$var$ic = $4xoBZ.unstable_LowPriority, $9c351ca3251b0a6f$var$jc = $4xoBZ.unstable_IdlePriority, $9c351ca3251b0a6f$var$kc = null, $9c351ca3251b0a6f$var$lc = null;
function $9c351ca3251b0a6f$var$mc(a) {
    if ($9c351ca3251b0a6f$var$lc && "function" === typeof $9c351ca3251b0a6f$var$lc.onCommitFiberRoot) try {
        $9c351ca3251b0a6f$var$lc.onCommitFiberRoot($9c351ca3251b0a6f$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $9c351ca3251b0a6f$var$oc = Math.clz32 ? Math.clz32 : $9c351ca3251b0a6f$var$nc, $9c351ca3251b0a6f$var$pc = Math.log, $9c351ca3251b0a6f$var$qc = Math.LN2;
function $9c351ca3251b0a6f$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($9c351ca3251b0a6f$var$pc(a) / $9c351ca3251b0a6f$var$qc | 0) | 0;
}
var $9c351ca3251b0a6f$var$rc = 64, $9c351ca3251b0a6f$var$sc = 4194304;
function $9c351ca3251b0a6f$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $9c351ca3251b0a6f$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $9c351ca3251b0a6f$var$tc(h) : (f &= g, 0 !== f && (d = $9c351ca3251b0a6f$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $9c351ca3251b0a6f$var$tc(g) : 0 !== f && (d = $9c351ca3251b0a6f$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $9c351ca3251b0a6f$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $9c351ca3251b0a6f$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $9c351ca3251b0a6f$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $9c351ca3251b0a6f$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $9c351ca3251b0a6f$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $9c351ca3251b0a6f$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $9c351ca3251b0a6f$var$yc() {
    var a = $9c351ca3251b0a6f$var$rc;
    $9c351ca3251b0a6f$var$rc <<= 1;
    0 === ($9c351ca3251b0a6f$var$rc & 4194240) && ($9c351ca3251b0a6f$var$rc = 64);
    return a;
}
function $9c351ca3251b0a6f$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $9c351ca3251b0a6f$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $9c351ca3251b0a6f$var$oc(b);
    a[b] = c;
}
function $9c351ca3251b0a6f$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $9c351ca3251b0a6f$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $9c351ca3251b0a6f$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $9c351ca3251b0a6f$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $9c351ca3251b0a6f$var$C = 0;
function $9c351ca3251b0a6f$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $9c351ca3251b0a6f$var$Ec, $9c351ca3251b0a6f$var$Fc, $9c351ca3251b0a6f$var$Gc, $9c351ca3251b0a6f$var$Hc, $9c351ca3251b0a6f$var$Ic, $9c351ca3251b0a6f$var$Jc = !1, $9c351ca3251b0a6f$var$Kc = [], $9c351ca3251b0a6f$var$Lc = null, $9c351ca3251b0a6f$var$Mc = null, $9c351ca3251b0a6f$var$Nc = null, $9c351ca3251b0a6f$var$Oc = new Map, $9c351ca3251b0a6f$var$Pc = new Map, $9c351ca3251b0a6f$var$Qc = [], $9c351ca3251b0a6f$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $9c351ca3251b0a6f$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $9c351ca3251b0a6f$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $9c351ca3251b0a6f$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $9c351ca3251b0a6f$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $9c351ca3251b0a6f$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $9c351ca3251b0a6f$var$Pc.delete(b.pointerId);
    }
}
function $9c351ca3251b0a6f$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $9c351ca3251b0a6f$var$Cb(b), null !== b && $9c351ca3251b0a6f$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $9c351ca3251b0a6f$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $9c351ca3251b0a6f$var$Lc = $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $9c351ca3251b0a6f$var$Mc = $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $9c351ca3251b0a6f$var$Nc = $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $9c351ca3251b0a6f$var$Oc.set(f, $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $9c351ca3251b0a6f$var$Pc.set(f, $9c351ca3251b0a6f$var$Tc($9c351ca3251b0a6f$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $9c351ca3251b0a6f$var$Vc(a) {
    var b = $9c351ca3251b0a6f$var$Wc(a.target);
    if (null !== b) {
        var c = $9c351ca3251b0a6f$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $9c351ca3251b0a6f$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $9c351ca3251b0a6f$var$Ic(a.priority, function() {
                        $9c351ca3251b0a6f$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $9c351ca3251b0a6f$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $9c351ca3251b0a6f$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $9c351ca3251b0a6f$var$wb = d;
            c.target.dispatchEvent(d);
            $9c351ca3251b0a6f$var$wb = null;
        } else return b = $9c351ca3251b0a6f$var$Cb(c), null !== b && $9c351ca3251b0a6f$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $9c351ca3251b0a6f$var$Zc(a, b, c) {
    $9c351ca3251b0a6f$var$Xc(a) && c.delete(b);
}
function $9c351ca3251b0a6f$var$$c() {
    $9c351ca3251b0a6f$var$Jc = !1;
    null !== $9c351ca3251b0a6f$var$Lc && $9c351ca3251b0a6f$var$Xc($9c351ca3251b0a6f$var$Lc) && ($9c351ca3251b0a6f$var$Lc = null);
    null !== $9c351ca3251b0a6f$var$Mc && $9c351ca3251b0a6f$var$Xc($9c351ca3251b0a6f$var$Mc) && ($9c351ca3251b0a6f$var$Mc = null);
    null !== $9c351ca3251b0a6f$var$Nc && $9c351ca3251b0a6f$var$Xc($9c351ca3251b0a6f$var$Nc) && ($9c351ca3251b0a6f$var$Nc = null);
    $9c351ca3251b0a6f$var$Oc.forEach($9c351ca3251b0a6f$var$Zc);
    $9c351ca3251b0a6f$var$Pc.forEach($9c351ca3251b0a6f$var$Zc);
}
function $9c351ca3251b0a6f$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $9c351ca3251b0a6f$var$Jc || ($9c351ca3251b0a6f$var$Jc = !0, $4xoBZ.unstable_scheduleCallback($4xoBZ.unstable_NormalPriority, $9c351ca3251b0a6f$var$$c)));
}
function $9c351ca3251b0a6f$var$bd(a) {
    function b(b) {
        return $9c351ca3251b0a6f$var$ad(b, a);
    }
    if (0 < $9c351ca3251b0a6f$var$Kc.length) {
        $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Kc[0], a);
        for(var c = 1; c < $9c351ca3251b0a6f$var$Kc.length; c++){
            var d = $9c351ca3251b0a6f$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $9c351ca3251b0a6f$var$Lc && $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Lc, a);
    null !== $9c351ca3251b0a6f$var$Mc && $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Mc, a);
    null !== $9c351ca3251b0a6f$var$Nc && $9c351ca3251b0a6f$var$ad($9c351ca3251b0a6f$var$Nc, a);
    $9c351ca3251b0a6f$var$Oc.forEach(b);
    $9c351ca3251b0a6f$var$Pc.forEach(b);
    for(c = 0; c < $9c351ca3251b0a6f$var$Qc.length; c++)d = $9c351ca3251b0a6f$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $9c351ca3251b0a6f$var$Qc.length && (c = $9c351ca3251b0a6f$var$Qc[0], null === c.blockedOn);)$9c351ca3251b0a6f$var$Vc(c), null === c.blockedOn && $9c351ca3251b0a6f$var$Qc.shift();
}
var $9c351ca3251b0a6f$var$cd = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig, $9c351ca3251b0a6f$var$dd = !0;
function $9c351ca3251b0a6f$var$ed(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$C, f = $9c351ca3251b0a6f$var$cd.transition;
    $9c351ca3251b0a6f$var$cd.transition = null;
    try {
        $9c351ca3251b0a6f$var$C = 1, $9c351ca3251b0a6f$var$fd(a, b, c, d);
    } finally{
        $9c351ca3251b0a6f$var$C = e, $9c351ca3251b0a6f$var$cd.transition = f;
    }
}
function $9c351ca3251b0a6f$var$gd(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$C, f = $9c351ca3251b0a6f$var$cd.transition;
    $9c351ca3251b0a6f$var$cd.transition = null;
    try {
        $9c351ca3251b0a6f$var$C = 4, $9c351ca3251b0a6f$var$fd(a, b, c, d);
    } finally{
        $9c351ca3251b0a6f$var$C = e, $9c351ca3251b0a6f$var$cd.transition = f;
    }
}
function $9c351ca3251b0a6f$var$fd(a, b, c, d) {
    if ($9c351ca3251b0a6f$var$dd) {
        var e = $9c351ca3251b0a6f$var$Yc(a, b, c, d);
        if (null === e) $9c351ca3251b0a6f$var$hd(a, b, d, $9c351ca3251b0a6f$var$id, c), $9c351ca3251b0a6f$var$Sc(a, d);
        else if ($9c351ca3251b0a6f$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($9c351ca3251b0a6f$var$Sc(a, d), b & 4 && -1 < $9c351ca3251b0a6f$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $9c351ca3251b0a6f$var$Cb(e);
                null !== f && $9c351ca3251b0a6f$var$Ec(f);
                f = $9c351ca3251b0a6f$var$Yc(a, b, c, d);
                null === f && $9c351ca3251b0a6f$var$hd(a, b, d, $9c351ca3251b0a6f$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $9c351ca3251b0a6f$var$hd(a, b, d, null, c);
    }
}
var $9c351ca3251b0a6f$var$id = null;
function $9c351ca3251b0a6f$var$Yc(a, b, c, d) {
    $9c351ca3251b0a6f$var$id = null;
    a = $9c351ca3251b0a6f$var$xb(d);
    a = $9c351ca3251b0a6f$var$Wc(a);
    if (null !== a) {
        if (b = $9c351ca3251b0a6f$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $9c351ca3251b0a6f$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $9c351ca3251b0a6f$var$id = a;
    return null;
}
function $9c351ca3251b0a6f$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($9c351ca3251b0a6f$var$ec()){
                case $9c351ca3251b0a6f$var$fc:
                    return 1;
                case $9c351ca3251b0a6f$var$gc:
                    return 4;
                case $9c351ca3251b0a6f$var$hc:
                case $9c351ca3251b0a6f$var$ic:
                    return 16;
                case $9c351ca3251b0a6f$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $9c351ca3251b0a6f$var$kd = null, $9c351ca3251b0a6f$var$ld = null, $9c351ca3251b0a6f$var$md = null;
function $9c351ca3251b0a6f$var$nd() {
    if ($9c351ca3251b0a6f$var$md) return $9c351ca3251b0a6f$var$md;
    var a, b = $9c351ca3251b0a6f$var$ld, c = b.length, d, e = "value" in $9c351ca3251b0a6f$var$kd ? $9c351ca3251b0a6f$var$kd.value : $9c351ca3251b0a6f$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $9c351ca3251b0a6f$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $9c351ca3251b0a6f$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $9c351ca3251b0a6f$var$pd() {
    return !0;
}
function $9c351ca3251b0a6f$var$qd() {
    return !1;
}
function $9c351ca3251b0a6f$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $9c351ca3251b0a6f$var$pd : $9c351ca3251b0a6f$var$qd;
        this.isPropagationStopped = $9c351ca3251b0a6f$var$qd;
        return this;
    }
    $9c351ca3251b0a6f$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $9c351ca3251b0a6f$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $9c351ca3251b0a6f$var$pd);
        },
        persist: function() {},
        isPersistent: $9c351ca3251b0a6f$var$pd
    });
    return b;
}
var $9c351ca3251b0a6f$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $9c351ca3251b0a6f$var$td = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$sd), $9c351ca3251b0a6f$var$ud = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    view: 0,
    detail: 0
}), $9c351ca3251b0a6f$var$vd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$ud), $9c351ca3251b0a6f$var$wd, $9c351ca3251b0a6f$var$xd, $9c351ca3251b0a6f$var$yd, $9c351ca3251b0a6f$var$Ad = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $9c351ca3251b0a6f$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $9c351ca3251b0a6f$var$yd && ($9c351ca3251b0a6f$var$yd && "mousemove" === a.type ? ($9c351ca3251b0a6f$var$wd = a.screenX - $9c351ca3251b0a6f$var$yd.screenX, $9c351ca3251b0a6f$var$xd = a.screenY - $9c351ca3251b0a6f$var$yd.screenY) : $9c351ca3251b0a6f$var$xd = $9c351ca3251b0a6f$var$wd = 0, $9c351ca3251b0a6f$var$yd = a);
        return $9c351ca3251b0a6f$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $9c351ca3251b0a6f$var$xd;
    }
}), $9c351ca3251b0a6f$var$Bd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Ad), $9c351ca3251b0a6f$var$Cd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$Ad, {
    dataTransfer: 0
}), $9c351ca3251b0a6f$var$Dd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Cd), $9c351ca3251b0a6f$var$Ed = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    relatedTarget: 0
}), $9c351ca3251b0a6f$var$Fd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Ed), $9c351ca3251b0a6f$var$Gd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9c351ca3251b0a6f$var$Hd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Gd), $9c351ca3251b0a6f$var$Id = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $9c351ca3251b0a6f$var$Jd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Id), $9c351ca3251b0a6f$var$Kd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    data: 0
}), $9c351ca3251b0a6f$var$Ld = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Kd), $9c351ca3251b0a6f$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $9c351ca3251b0a6f$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $9c351ca3251b0a6f$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $9c351ca3251b0a6f$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $9c351ca3251b0a6f$var$Od[a]) ? !!b[a] : !1;
}
function $9c351ca3251b0a6f$var$zd() {
    return $9c351ca3251b0a6f$var$Pd;
}
var $9c351ca3251b0a6f$var$Qd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $9c351ca3251b0a6f$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $9c351ca3251b0a6f$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $9c351ca3251b0a6f$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $9c351ca3251b0a6f$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $9c351ca3251b0a6f$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $9c351ca3251b0a6f$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $9c351ca3251b0a6f$var$Rd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Qd), $9c351ca3251b0a6f$var$Sd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $9c351ca3251b0a6f$var$Td = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Sd), $9c351ca3251b0a6f$var$Ud = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $9c351ca3251b0a6f$var$zd
}), $9c351ca3251b0a6f$var$Vd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Ud), $9c351ca3251b0a6f$var$Wd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $9c351ca3251b0a6f$var$Xd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Wd), $9c351ca3251b0a6f$var$Yd = $9c351ca3251b0a6f$var$A({}, $9c351ca3251b0a6f$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $9c351ca3251b0a6f$var$Zd = $9c351ca3251b0a6f$var$rd($9c351ca3251b0a6f$var$Yd), $9c351ca3251b0a6f$var$$d = [
    9,
    13,
    27,
    32
], $9c351ca3251b0a6f$var$ae = $9c351ca3251b0a6f$var$ia && "CompositionEvent" in window, $9c351ca3251b0a6f$var$be = null;
$9c351ca3251b0a6f$var$ia && "documentMode" in document && ($9c351ca3251b0a6f$var$be = document.documentMode);
var $9c351ca3251b0a6f$var$ce = $9c351ca3251b0a6f$var$ia && "TextEvent" in window && !$9c351ca3251b0a6f$var$be, $9c351ca3251b0a6f$var$de = $9c351ca3251b0a6f$var$ia && (!$9c351ca3251b0a6f$var$ae || $9c351ca3251b0a6f$var$be && 8 < $9c351ca3251b0a6f$var$be && 11 >= $9c351ca3251b0a6f$var$be), $9c351ca3251b0a6f$var$ee = String.fromCharCode(32), $9c351ca3251b0a6f$var$fe = !1;
function $9c351ca3251b0a6f$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $9c351ca3251b0a6f$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $9c351ca3251b0a6f$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $9c351ca3251b0a6f$var$ie = !1;
function $9c351ca3251b0a6f$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $9c351ca3251b0a6f$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $9c351ca3251b0a6f$var$fe = !0;
            return $9c351ca3251b0a6f$var$ee;
        case "textInput":
            return a = b.data, a === $9c351ca3251b0a6f$var$ee && $9c351ca3251b0a6f$var$fe ? null : a;
        default:
            return null;
    }
}
function $9c351ca3251b0a6f$var$ke(a, b) {
    if ($9c351ca3251b0a6f$var$ie) return "compositionend" === a || !$9c351ca3251b0a6f$var$ae && $9c351ca3251b0a6f$var$ge(a, b) ? (a = $9c351ca3251b0a6f$var$nd(), $9c351ca3251b0a6f$var$md = $9c351ca3251b0a6f$var$ld = $9c351ca3251b0a6f$var$kd = null, $9c351ca3251b0a6f$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $9c351ca3251b0a6f$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $9c351ca3251b0a6f$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $9c351ca3251b0a6f$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$9c351ca3251b0a6f$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $9c351ca3251b0a6f$var$ne(a, b, c, d) {
    $9c351ca3251b0a6f$var$Eb(d);
    b = $9c351ca3251b0a6f$var$oe(b, "onChange");
    0 < b.length && (c = new $9c351ca3251b0a6f$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $9c351ca3251b0a6f$var$pe = null, $9c351ca3251b0a6f$var$qe = null;
function $9c351ca3251b0a6f$var$re(a) {
    $9c351ca3251b0a6f$var$se(a, 0);
}
function $9c351ca3251b0a6f$var$te(a) {
    var b = $9c351ca3251b0a6f$var$ue(a);
    if ($9c351ca3251b0a6f$var$Wa(b)) return a;
}
function $9c351ca3251b0a6f$var$ve(a, b) {
    if ("change" === a) return b;
}
var $9c351ca3251b0a6f$var$we = !1;
if ($9c351ca3251b0a6f$var$ia) {
    var $9c351ca3251b0a6f$var$xe;
    if ($9c351ca3251b0a6f$var$ia) {
        var $9c351ca3251b0a6f$var$ye = "oninput" in document;
        if (!$9c351ca3251b0a6f$var$ye) {
            var $9c351ca3251b0a6f$var$ze = document.createElement("div");
            $9c351ca3251b0a6f$var$ze.setAttribute("oninput", "return;");
            $9c351ca3251b0a6f$var$ye = "function" === typeof $9c351ca3251b0a6f$var$ze.oninput;
        }
        $9c351ca3251b0a6f$var$xe = $9c351ca3251b0a6f$var$ye;
    } else $9c351ca3251b0a6f$var$xe = !1;
    $9c351ca3251b0a6f$var$we = $9c351ca3251b0a6f$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $9c351ca3251b0a6f$var$Ae() {
    $9c351ca3251b0a6f$var$pe && ($9c351ca3251b0a6f$var$pe.detachEvent("onpropertychange", $9c351ca3251b0a6f$var$Be), $9c351ca3251b0a6f$var$qe = $9c351ca3251b0a6f$var$pe = null);
}
function $9c351ca3251b0a6f$var$Be(a) {
    if ("value" === a.propertyName && $9c351ca3251b0a6f$var$te($9c351ca3251b0a6f$var$qe)) {
        var b = [];
        $9c351ca3251b0a6f$var$ne(b, $9c351ca3251b0a6f$var$qe, a, $9c351ca3251b0a6f$var$xb(a));
        $9c351ca3251b0a6f$var$Jb($9c351ca3251b0a6f$var$re, b);
    }
}
function $9c351ca3251b0a6f$var$Ce(a, b, c) {
    "focusin" === a ? ($9c351ca3251b0a6f$var$Ae(), $9c351ca3251b0a6f$var$pe = b, $9c351ca3251b0a6f$var$qe = c, $9c351ca3251b0a6f$var$pe.attachEvent("onpropertychange", $9c351ca3251b0a6f$var$Be)) : "focusout" === a && $9c351ca3251b0a6f$var$Ae();
}
function $9c351ca3251b0a6f$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $9c351ca3251b0a6f$var$te($9c351ca3251b0a6f$var$qe);
}
function $9c351ca3251b0a6f$var$Ee(a, b) {
    if ("click" === a) return $9c351ca3251b0a6f$var$te(b);
}
function $9c351ca3251b0a6f$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $9c351ca3251b0a6f$var$te(b);
}
function $9c351ca3251b0a6f$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $9c351ca3251b0a6f$var$He = "function" === typeof Object.is ? Object.is : $9c351ca3251b0a6f$var$Ge;
function $9c351ca3251b0a6f$var$Ie(a, b) {
    if ($9c351ca3251b0a6f$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$9c351ca3251b0a6f$var$ja.call(b, e) || !$9c351ca3251b0a6f$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $9c351ca3251b0a6f$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $9c351ca3251b0a6f$var$Ke(a, b) {
    var c = $9c351ca3251b0a6f$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $9c351ca3251b0a6f$var$Je(c);
    }
}
function $9c351ca3251b0a6f$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $9c351ca3251b0a6f$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $9c351ca3251b0a6f$var$Me() {
    for(var a = window, b = $9c351ca3251b0a6f$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $9c351ca3251b0a6f$var$Xa(a.document);
    }
    return b;
}
function $9c351ca3251b0a6f$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $9c351ca3251b0a6f$var$Oe(a) {
    var b = $9c351ca3251b0a6f$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $9c351ca3251b0a6f$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $9c351ca3251b0a6f$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $9c351ca3251b0a6f$var$Ke(c, f);
                var g = $9c351ca3251b0a6f$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $9c351ca3251b0a6f$var$Pe = $9c351ca3251b0a6f$var$ia && "documentMode" in document && 11 >= document.documentMode, $9c351ca3251b0a6f$var$Qe = null, $9c351ca3251b0a6f$var$Re = null, $9c351ca3251b0a6f$var$Se = null, $9c351ca3251b0a6f$var$Te = !1;
function $9c351ca3251b0a6f$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $9c351ca3251b0a6f$var$Te || null == $9c351ca3251b0a6f$var$Qe || $9c351ca3251b0a6f$var$Qe !== $9c351ca3251b0a6f$var$Xa(d) || (d = $9c351ca3251b0a6f$var$Qe, "selectionStart" in d && $9c351ca3251b0a6f$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $9c351ca3251b0a6f$var$Se && $9c351ca3251b0a6f$var$Ie($9c351ca3251b0a6f$var$Se, d) || ($9c351ca3251b0a6f$var$Se = d, d = $9c351ca3251b0a6f$var$oe($9c351ca3251b0a6f$var$Re, "onSelect"), 0 < d.length && (b = new $9c351ca3251b0a6f$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $9c351ca3251b0a6f$var$Qe)));
}
function $9c351ca3251b0a6f$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $9c351ca3251b0a6f$var$We = {
    animationend: $9c351ca3251b0a6f$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $9c351ca3251b0a6f$var$Ve("Animation", "AnimationIteration"),
    animationstart: $9c351ca3251b0a6f$var$Ve("Animation", "AnimationStart"),
    transitionend: $9c351ca3251b0a6f$var$Ve("Transition", "TransitionEnd")
}, $9c351ca3251b0a6f$var$Xe = {}, $9c351ca3251b0a6f$var$Ye = {};
$9c351ca3251b0a6f$var$ia && ($9c351ca3251b0a6f$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $9c351ca3251b0a6f$var$We.animationend.animation, delete $9c351ca3251b0a6f$var$We.animationiteration.animation, delete $9c351ca3251b0a6f$var$We.animationstart.animation), "TransitionEvent" in window || delete $9c351ca3251b0a6f$var$We.transitionend.transition);
function $9c351ca3251b0a6f$var$Ze(a) {
    if ($9c351ca3251b0a6f$var$Xe[a]) return $9c351ca3251b0a6f$var$Xe[a];
    if (!$9c351ca3251b0a6f$var$We[a]) return a;
    var b = $9c351ca3251b0a6f$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $9c351ca3251b0a6f$var$Ye) return $9c351ca3251b0a6f$var$Xe[a] = b[c];
    return a;
}
var $9c351ca3251b0a6f$var$$e = $9c351ca3251b0a6f$var$Ze("animationend"), $9c351ca3251b0a6f$var$af = $9c351ca3251b0a6f$var$Ze("animationiteration"), $9c351ca3251b0a6f$var$bf = $9c351ca3251b0a6f$var$Ze("animationstart"), $9c351ca3251b0a6f$var$cf = $9c351ca3251b0a6f$var$Ze("transitionend"), $9c351ca3251b0a6f$var$df = new Map, $9c351ca3251b0a6f$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $9c351ca3251b0a6f$var$ff(a, b) {
    $9c351ca3251b0a6f$var$df.set(a, b);
    $9c351ca3251b0a6f$var$fa(b, [
        a
    ]);
}
for(var $9c351ca3251b0a6f$var$gf = 0; $9c351ca3251b0a6f$var$gf < $9c351ca3251b0a6f$var$ef.length; $9c351ca3251b0a6f$var$gf++){
    var $9c351ca3251b0a6f$var$hf = $9c351ca3251b0a6f$var$ef[$9c351ca3251b0a6f$var$gf], $9c351ca3251b0a6f$var$jf = $9c351ca3251b0a6f$var$hf.toLowerCase(), $9c351ca3251b0a6f$var$kf = $9c351ca3251b0a6f$var$hf[0].toUpperCase() + $9c351ca3251b0a6f$var$hf.slice(1);
    $9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$jf, "on" + $9c351ca3251b0a6f$var$kf);
}
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$$e, "onAnimationEnd");
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$af, "onAnimationIteration");
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$bf, "onAnimationStart");
$9c351ca3251b0a6f$var$ff("dblclick", "onDoubleClick");
$9c351ca3251b0a6f$var$ff("focusin", "onFocus");
$9c351ca3251b0a6f$var$ff("focusout", "onBlur");
$9c351ca3251b0a6f$var$ff($9c351ca3251b0a6f$var$cf, "onTransitionEnd");
$9c351ca3251b0a6f$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$9c351ca3251b0a6f$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$9c351ca3251b0a6f$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$9c351ca3251b0a6f$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$9c351ca3251b0a6f$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$9c351ca3251b0a6f$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$9c351ca3251b0a6f$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$9c351ca3251b0a6f$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$9c351ca3251b0a6f$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$9c351ca3251b0a6f$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $9c351ca3251b0a6f$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $9c351ca3251b0a6f$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($9c351ca3251b0a6f$var$lf));
function $9c351ca3251b0a6f$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $9c351ca3251b0a6f$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $9c351ca3251b0a6f$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9c351ca3251b0a6f$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $9c351ca3251b0a6f$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($9c351ca3251b0a6f$var$Qb) throw a = $9c351ca3251b0a6f$var$Rb, $9c351ca3251b0a6f$var$Qb = !1, $9c351ca3251b0a6f$var$Rb = null, a;
}
function $9c351ca3251b0a6f$var$D(a, b) {
    var c = b[$9c351ca3251b0a6f$var$of];
    void 0 === c && (c = b[$9c351ca3251b0a6f$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($9c351ca3251b0a6f$var$pf(b, a, 2, !1), c.add(d));
}
function $9c351ca3251b0a6f$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $9c351ca3251b0a6f$var$pf(c, a, d, b);
}
var $9c351ca3251b0a6f$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $9c351ca3251b0a6f$var$sf(a) {
    if (!a[$9c351ca3251b0a6f$var$rf]) {
        a[$9c351ca3251b0a6f$var$rf] = !0;
        $9c351ca3251b0a6f$var$da.forEach(function(b) {
            "selectionchange" !== b && ($9c351ca3251b0a6f$var$mf.has(b) || $9c351ca3251b0a6f$var$qf(b, !1, a), $9c351ca3251b0a6f$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$9c351ca3251b0a6f$var$rf] || (b[$9c351ca3251b0a6f$var$rf] = !0, $9c351ca3251b0a6f$var$qf("selectionchange", !1, b));
    }
}
function $9c351ca3251b0a6f$var$pf(a, b, c, d) {
    switch($9c351ca3251b0a6f$var$jd(b)){
        case 1:
            var e = $9c351ca3251b0a6f$var$ed;
            break;
        case 4:
            e = $9c351ca3251b0a6f$var$gd;
            break;
        default:
            e = $9c351ca3251b0a6f$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$9c351ca3251b0a6f$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $9c351ca3251b0a6f$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $9c351ca3251b0a6f$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $9c351ca3251b0a6f$var$Jb(function() {
        var d = f, e = $9c351ca3251b0a6f$var$xb(c), g = [];
        a: {
            var h = $9c351ca3251b0a6f$var$df.get(a);
            if (void 0 !== h) {
                var k = $9c351ca3251b0a6f$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $9c351ca3251b0a6f$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $9c351ca3251b0a6f$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $9c351ca3251b0a6f$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $9c351ca3251b0a6f$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $9c351ca3251b0a6f$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $9c351ca3251b0a6f$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $9c351ca3251b0a6f$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $9c351ca3251b0a6f$var$Vd;
                        break;
                    case $9c351ca3251b0a6f$var$$e:
                    case $9c351ca3251b0a6f$var$af:
                    case $9c351ca3251b0a6f$var$bf:
                        k = $9c351ca3251b0a6f$var$Hd;
                        break;
                    case $9c351ca3251b0a6f$var$cf:
                        k = $9c351ca3251b0a6f$var$Xd;
                        break;
                    case "scroll":
                        k = $9c351ca3251b0a6f$var$vd;
                        break;
                    case "wheel":
                        k = $9c351ca3251b0a6f$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $9c351ca3251b0a6f$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $9c351ca3251b0a6f$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $9c351ca3251b0a6f$var$Kb(w, x), null != F && t.push($9c351ca3251b0a6f$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $9c351ca3251b0a6f$var$wb && (n = c.relatedTarget || c.fromElement) && ($9c351ca3251b0a6f$var$Wc(n) || n[$9c351ca3251b0a6f$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $9c351ca3251b0a6f$var$Wc(n) : null, null !== n && (J = $9c351ca3251b0a6f$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $9c351ca3251b0a6f$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $9c351ca3251b0a6f$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $9c351ca3251b0a6f$var$ue(k);
                        u = null == n ? h : $9c351ca3251b0a6f$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $9c351ca3251b0a6f$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $9c351ca3251b0a6f$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $9c351ca3251b0a6f$var$vf(F))u++;
                            for(; 0 < w - u;)t = $9c351ca3251b0a6f$var$vf(t), w--;
                            for(; 0 < u - w;)x = $9c351ca3251b0a6f$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $9c351ca3251b0a6f$var$vf(t);
                                x = $9c351ca3251b0a6f$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $9c351ca3251b0a6f$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $9c351ca3251b0a6f$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $9c351ca3251b0a6f$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $9c351ca3251b0a6f$var$ve;
                else if ($9c351ca3251b0a6f$var$me(h)) {
                    if ($9c351ca3251b0a6f$var$we) na = $9c351ca3251b0a6f$var$Fe;
                    else {
                        na = $9c351ca3251b0a6f$var$De;
                        var xa = $9c351ca3251b0a6f$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $9c351ca3251b0a6f$var$Ee);
                if (na && (na = na(a, d))) {
                    $9c351ca3251b0a6f$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $9c351ca3251b0a6f$var$cb(h, "number", h.value);
            }
            xa = d ? $9c351ca3251b0a6f$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($9c351ca3251b0a6f$var$me(xa) || "true" === xa.contentEditable) $9c351ca3251b0a6f$var$Qe = xa, $9c351ca3251b0a6f$var$Re = d, $9c351ca3251b0a6f$var$Se = null;
                    break;
                case "focusout":
                    $9c351ca3251b0a6f$var$Se = $9c351ca3251b0a6f$var$Re = $9c351ca3251b0a6f$var$Qe = null;
                    break;
                case "mousedown":
                    $9c351ca3251b0a6f$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $9c351ca3251b0a6f$var$Te = !1;
                    $9c351ca3251b0a6f$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($9c351ca3251b0a6f$var$Pe) break;
                case "keydown":
                case "keyup":
                    $9c351ca3251b0a6f$var$Ue(g, c, e);
            }
            var $a;
            if ($9c351ca3251b0a6f$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $9c351ca3251b0a6f$var$ie ? $9c351ca3251b0a6f$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($9c351ca3251b0a6f$var$de && "ko" !== c.locale && ($9c351ca3251b0a6f$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $9c351ca3251b0a6f$var$ie && ($a = $9c351ca3251b0a6f$var$nd()) : ($9c351ca3251b0a6f$var$kd = e, $9c351ca3251b0a6f$var$ld = "value" in $9c351ca3251b0a6f$var$kd ? $9c351ca3251b0a6f$var$kd.value : $9c351ca3251b0a6f$var$kd.textContent, $9c351ca3251b0a6f$var$ie = !0)), xa = $9c351ca3251b0a6f$var$oe(d, ba), 0 < xa.length && (ba = new $9c351ca3251b0a6f$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $9c351ca3251b0a6f$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $9c351ca3251b0a6f$var$ce ? $9c351ca3251b0a6f$var$je(a, c) : $9c351ca3251b0a6f$var$ke(a, c)) d = $9c351ca3251b0a6f$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $9c351ca3251b0a6f$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $9c351ca3251b0a6f$var$se(g, b);
    });
}
function $9c351ca3251b0a6f$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $9c351ca3251b0a6f$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $9c351ca3251b0a6f$var$Kb(a, c), null != f && d.unshift($9c351ca3251b0a6f$var$tf(a, f, e)), f = $9c351ca3251b0a6f$var$Kb(a, b), null != f && d.push($9c351ca3251b0a6f$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $9c351ca3251b0a6f$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $9c351ca3251b0a6f$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $9c351ca3251b0a6f$var$Kb(c, f), null != k && g.unshift($9c351ca3251b0a6f$var$tf(c, k, h))) : e || (k = $9c351ca3251b0a6f$var$Kb(c, f), null != k && g.push($9c351ca3251b0a6f$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $9c351ca3251b0a6f$var$xf = /\r\n?/g, $9c351ca3251b0a6f$var$yf = /\u0000|\uFFFD/g;
function $9c351ca3251b0a6f$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($9c351ca3251b0a6f$var$xf, "\n").replace($9c351ca3251b0a6f$var$yf, "");
}
function $9c351ca3251b0a6f$var$Af(a, b, c) {
    b = $9c351ca3251b0a6f$var$zf(b);
    if ($9c351ca3251b0a6f$var$zf(a) !== b && c) throw Error($9c351ca3251b0a6f$var$p(425));
}
function $9c351ca3251b0a6f$var$Bf() {}
var $9c351ca3251b0a6f$var$Cf = null, $9c351ca3251b0a6f$var$Df = null;
function $9c351ca3251b0a6f$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $9c351ca3251b0a6f$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $9c351ca3251b0a6f$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $9c351ca3251b0a6f$var$Hf = "function" === typeof Promise ? Promise : void 0, $9c351ca3251b0a6f$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $9c351ca3251b0a6f$var$Hf ? function(a) {
    return $9c351ca3251b0a6f$var$Hf.resolve(null).then(a).catch($9c351ca3251b0a6f$var$If);
} : $9c351ca3251b0a6f$var$Ff;
function $9c351ca3251b0a6f$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $9c351ca3251b0a6f$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $9c351ca3251b0a6f$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $9c351ca3251b0a6f$var$bd(b);
}
function $9c351ca3251b0a6f$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $9c351ca3251b0a6f$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $9c351ca3251b0a6f$var$Nf = Math.random().toString(36).slice(2), $9c351ca3251b0a6f$var$Of = "__reactFiber$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$Pf = "__reactProps$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$uf = "__reactContainer$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$of = "__reactEvents$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$Qf = "__reactListeners$" + $9c351ca3251b0a6f$var$Nf, $9c351ca3251b0a6f$var$Rf = "__reactHandles$" + $9c351ca3251b0a6f$var$Nf;
function $9c351ca3251b0a6f$var$Wc(a) {
    var b = a[$9c351ca3251b0a6f$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$9c351ca3251b0a6f$var$uf] || c[$9c351ca3251b0a6f$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $9c351ca3251b0a6f$var$Mf(a); null !== a;){
                if (c = a[$9c351ca3251b0a6f$var$Of]) return c;
                a = $9c351ca3251b0a6f$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Cb(a) {
    a = a[$9c351ca3251b0a6f$var$Of] || a[$9c351ca3251b0a6f$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $9c351ca3251b0a6f$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($9c351ca3251b0a6f$var$p(33));
}
function $9c351ca3251b0a6f$var$Db(a) {
    return a[$9c351ca3251b0a6f$var$Pf] || null;
}
var $9c351ca3251b0a6f$var$Sf = [], $9c351ca3251b0a6f$var$Tf = -1;
function $9c351ca3251b0a6f$var$Uf(a) {
    return {
        current: a
    };
}
function $9c351ca3251b0a6f$var$E(a) {
    0 > $9c351ca3251b0a6f$var$Tf || (a.current = $9c351ca3251b0a6f$var$Sf[$9c351ca3251b0a6f$var$Tf], $9c351ca3251b0a6f$var$Sf[$9c351ca3251b0a6f$var$Tf] = null, $9c351ca3251b0a6f$var$Tf--);
}
function $9c351ca3251b0a6f$var$G(a, b) {
    $9c351ca3251b0a6f$var$Tf++;
    $9c351ca3251b0a6f$var$Sf[$9c351ca3251b0a6f$var$Tf] = a.current;
    a.current = b;
}
var $9c351ca3251b0a6f$var$Vf = {}, $9c351ca3251b0a6f$var$H = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$Vf), $9c351ca3251b0a6f$var$Wf = $9c351ca3251b0a6f$var$Uf(!1), $9c351ca3251b0a6f$var$Xf = $9c351ca3251b0a6f$var$Vf;
function $9c351ca3251b0a6f$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $9c351ca3251b0a6f$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $9c351ca3251b0a6f$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $9c351ca3251b0a6f$var$$f() {
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H);
}
function $9c351ca3251b0a6f$var$ag(a, b, c) {
    if ($9c351ca3251b0a6f$var$H.current !== $9c351ca3251b0a6f$var$Vf) throw Error($9c351ca3251b0a6f$var$p(168));
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$H, b);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wf, c);
}
function $9c351ca3251b0a6f$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($9c351ca3251b0a6f$var$p(108, $9c351ca3251b0a6f$var$Ra(a) || "Unknown", e));
    return $9c351ca3251b0a6f$var$A({}, c, d);
}
function $9c351ca3251b0a6f$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $9c351ca3251b0a6f$var$Vf;
    $9c351ca3251b0a6f$var$Xf = $9c351ca3251b0a6f$var$H.current;
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$H, a);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wf, $9c351ca3251b0a6f$var$Wf.current);
    return !0;
}
function $9c351ca3251b0a6f$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($9c351ca3251b0a6f$var$p(169));
    c ? (a = $9c351ca3251b0a6f$var$bg(a, b, $9c351ca3251b0a6f$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H), $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$H, a)) : $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wf, c);
}
var $9c351ca3251b0a6f$var$eg = null, $9c351ca3251b0a6f$var$fg = !1, $9c351ca3251b0a6f$var$gg = !1;
function $9c351ca3251b0a6f$var$hg(a) {
    null === $9c351ca3251b0a6f$var$eg ? $9c351ca3251b0a6f$var$eg = [
        a
    ] : $9c351ca3251b0a6f$var$eg.push(a);
}
function $9c351ca3251b0a6f$var$ig(a) {
    $9c351ca3251b0a6f$var$fg = !0;
    $9c351ca3251b0a6f$var$hg(a);
}
function $9c351ca3251b0a6f$var$jg() {
    if (!$9c351ca3251b0a6f$var$gg && null !== $9c351ca3251b0a6f$var$eg) {
        $9c351ca3251b0a6f$var$gg = !0;
        var a = 0, b = $9c351ca3251b0a6f$var$C;
        try {
            var c = $9c351ca3251b0a6f$var$eg;
            for($9c351ca3251b0a6f$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $9c351ca3251b0a6f$var$eg = null;
            $9c351ca3251b0a6f$var$fg = !1;
        } catch (e) {
            throw null !== $9c351ca3251b0a6f$var$eg && ($9c351ca3251b0a6f$var$eg = $9c351ca3251b0a6f$var$eg.slice(a + 1)), $9c351ca3251b0a6f$var$ac($9c351ca3251b0a6f$var$fc, $9c351ca3251b0a6f$var$jg), e;
        } finally{
            $9c351ca3251b0a6f$var$C = b, $9c351ca3251b0a6f$var$gg = !1;
        }
    }
    return null;
}
var $9c351ca3251b0a6f$var$kg = [], $9c351ca3251b0a6f$var$lg = 0, $9c351ca3251b0a6f$var$mg = null, $9c351ca3251b0a6f$var$ng = 0, $9c351ca3251b0a6f$var$og = [], $9c351ca3251b0a6f$var$pg = 0, $9c351ca3251b0a6f$var$qg = null, $9c351ca3251b0a6f$var$rg = 1, $9c351ca3251b0a6f$var$sg = "";
function $9c351ca3251b0a6f$var$tg(a, b) {
    $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg++] = $9c351ca3251b0a6f$var$ng;
    $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg++] = $9c351ca3251b0a6f$var$mg;
    $9c351ca3251b0a6f$var$mg = a;
    $9c351ca3251b0a6f$var$ng = b;
}
function $9c351ca3251b0a6f$var$ug(a, b, c) {
    $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$rg;
    $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$sg;
    $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$qg;
    $9c351ca3251b0a6f$var$qg = a;
    var d = $9c351ca3251b0a6f$var$rg;
    a = $9c351ca3251b0a6f$var$sg;
    var e = 32 - $9c351ca3251b0a6f$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $9c351ca3251b0a6f$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $9c351ca3251b0a6f$var$rg = 1 << 32 - $9c351ca3251b0a6f$var$oc(b) + e | c << e | d;
        $9c351ca3251b0a6f$var$sg = f + a;
    } else $9c351ca3251b0a6f$var$rg = 1 << f | c << e | d, $9c351ca3251b0a6f$var$sg = a;
}
function $9c351ca3251b0a6f$var$vg(a) {
    null !== a.return && ($9c351ca3251b0a6f$var$tg(a, 1), $9c351ca3251b0a6f$var$ug(a, 1, 0));
}
function $9c351ca3251b0a6f$var$wg(a) {
    for(; a === $9c351ca3251b0a6f$var$mg;)$9c351ca3251b0a6f$var$mg = $9c351ca3251b0a6f$var$kg[--$9c351ca3251b0a6f$var$lg], $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg] = null, $9c351ca3251b0a6f$var$ng = $9c351ca3251b0a6f$var$kg[--$9c351ca3251b0a6f$var$lg], $9c351ca3251b0a6f$var$kg[$9c351ca3251b0a6f$var$lg] = null;
    for(; a === $9c351ca3251b0a6f$var$qg;)$9c351ca3251b0a6f$var$qg = $9c351ca3251b0a6f$var$og[--$9c351ca3251b0a6f$var$pg], $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg] = null, $9c351ca3251b0a6f$var$sg = $9c351ca3251b0a6f$var$og[--$9c351ca3251b0a6f$var$pg], $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg] = null, $9c351ca3251b0a6f$var$rg = $9c351ca3251b0a6f$var$og[--$9c351ca3251b0a6f$var$pg], $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg] = null;
}
var $9c351ca3251b0a6f$var$xg = null, $9c351ca3251b0a6f$var$yg = null, $9c351ca3251b0a6f$var$I = !1, $9c351ca3251b0a6f$var$zg = null;
function $9c351ca3251b0a6f$var$Ag(a, b) {
    var c = $9c351ca3251b0a6f$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $9c351ca3251b0a6f$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $9c351ca3251b0a6f$var$xg = a, $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $9c351ca3251b0a6f$var$xg = a, $9c351ca3251b0a6f$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $9c351ca3251b0a6f$var$qg ? {
                id: $9c351ca3251b0a6f$var$rg,
                overflow: $9c351ca3251b0a6f$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $9c351ca3251b0a6f$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $9c351ca3251b0a6f$var$xg = a, $9c351ca3251b0a6f$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $9c351ca3251b0a6f$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $9c351ca3251b0a6f$var$Eg(a) {
    if ($9c351ca3251b0a6f$var$I) {
        var b = $9c351ca3251b0a6f$var$yg;
        if (b) {
            var c = b;
            if (!$9c351ca3251b0a6f$var$Cg(a, b)) {
                if ($9c351ca3251b0a6f$var$Dg(a)) throw Error($9c351ca3251b0a6f$var$p(418));
                b = $9c351ca3251b0a6f$var$Lf(c.nextSibling);
                var d = $9c351ca3251b0a6f$var$xg;
                b && $9c351ca3251b0a6f$var$Cg(a, b) ? $9c351ca3251b0a6f$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $9c351ca3251b0a6f$var$I = !1, $9c351ca3251b0a6f$var$xg = a);
            }
        } else {
            if ($9c351ca3251b0a6f$var$Dg(a)) throw Error($9c351ca3251b0a6f$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $9c351ca3251b0a6f$var$I = !1;
            $9c351ca3251b0a6f$var$xg = a;
        }
    }
}
function $9c351ca3251b0a6f$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $9c351ca3251b0a6f$var$xg = a;
}
function $9c351ca3251b0a6f$var$Gg(a) {
    if (a !== $9c351ca3251b0a6f$var$xg) return !1;
    if (!$9c351ca3251b0a6f$var$I) return $9c351ca3251b0a6f$var$Fg(a), $9c351ca3251b0a6f$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$9c351ca3251b0a6f$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $9c351ca3251b0a6f$var$yg)) {
        if ($9c351ca3251b0a6f$var$Dg(a)) throw $9c351ca3251b0a6f$var$Hg(), Error($9c351ca3251b0a6f$var$p(418));
        for(; b;)$9c351ca3251b0a6f$var$Ag(a, b), b = $9c351ca3251b0a6f$var$Lf(b.nextSibling);
    }
    $9c351ca3251b0a6f$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($9c351ca3251b0a6f$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $9c351ca3251b0a6f$var$yg = null;
        }
    } else $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$xg ? $9c351ca3251b0a6f$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $9c351ca3251b0a6f$var$Hg() {
    for(var a = $9c351ca3251b0a6f$var$yg; a;)a = $9c351ca3251b0a6f$var$Lf(a.nextSibling);
}
function $9c351ca3251b0a6f$var$Ig() {
    $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$xg = null;
    $9c351ca3251b0a6f$var$I = !1;
}
function $9c351ca3251b0a6f$var$Jg(a) {
    null === $9c351ca3251b0a6f$var$zg ? $9c351ca3251b0a6f$var$zg = [
        a
    ] : $9c351ca3251b0a6f$var$zg.push(a);
}
var $9c351ca3251b0a6f$var$Kg = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig;
function $9c351ca3251b0a6f$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($9c351ca3251b0a6f$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($9c351ca3251b0a6f$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($9c351ca3251b0a6f$var$p(284));
        if (!c._owner) throw Error($9c351ca3251b0a6f$var$p(290, a));
    }
    return a;
}
function $9c351ca3251b0a6f$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($9c351ca3251b0a6f$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $9c351ca3251b0a6f$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $9c351ca3251b0a6f$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $9c351ca3251b0a6f$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $9c351ca3251b0a6f$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $9c351ca3251b0a6f$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $9c351ca3251b0a6f$var$Ha && $9c351ca3251b0a6f$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $9c351ca3251b0a6f$var$Lg(a, b, c), d.return = a, d;
        d = $9c351ca3251b0a6f$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $9c351ca3251b0a6f$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $9c351ca3251b0a6f$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $9c351ca3251b0a6f$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $9c351ca3251b0a6f$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    return c = $9c351ca3251b0a6f$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $9c351ca3251b0a6f$var$Lg(a, null, b), c.return = a, c;
                case $9c351ca3251b0a6f$var$wa:
                    return b = $9c351ca3251b0a6f$var$Sg(b, a.mode, c), b.return = a, b;
                case $9c351ca3251b0a6f$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($9c351ca3251b0a6f$var$eb(b) || $9c351ca3251b0a6f$var$Ka(b)) return b = $9c351ca3251b0a6f$var$Tg(b, a.mode, c, null), b.return = a, b;
            $9c351ca3251b0a6f$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $9c351ca3251b0a6f$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $9c351ca3251b0a6f$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($9c351ca3251b0a6f$var$eb(c) || $9c351ca3251b0a6f$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $9c351ca3251b0a6f$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $9c351ca3251b0a6f$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $9c351ca3251b0a6f$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($9c351ca3251b0a6f$var$eb(d) || $9c351ca3251b0a6f$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $9c351ca3251b0a6f$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $9c351ca3251b0a6f$var$Ka(h);
        if ("function" !== typeof l) throw Error($9c351ca3251b0a6f$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($9c351ca3251b0a6f$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $9c351ca3251b0a6f$var$I && $9c351ca3251b0a6f$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $9c351ca3251b0a6f$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $9c351ca3251b0a6f$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $9c351ca3251b0a6f$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $9c351ca3251b0a6f$var$Ha && $9c351ca3251b0a6f$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $9c351ca3251b0a6f$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $9c351ca3251b0a6f$var$ya ? (d = $9c351ca3251b0a6f$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $9c351ca3251b0a6f$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $9c351ca3251b0a6f$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $9c351ca3251b0a6f$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $9c351ca3251b0a6f$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $9c351ca3251b0a6f$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($9c351ca3251b0a6f$var$eb(f)) return n(a, d, f, h);
            if ($9c351ca3251b0a6f$var$Ka(f)) return t(a, d, f, h);
            $9c351ca3251b0a6f$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $9c351ca3251b0a6f$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $9c351ca3251b0a6f$var$Ug = $9c351ca3251b0a6f$var$Og(!0), $9c351ca3251b0a6f$var$Vg = $9c351ca3251b0a6f$var$Og(!1), $9c351ca3251b0a6f$var$Wg = $9c351ca3251b0a6f$var$Uf(null), $9c351ca3251b0a6f$var$Xg = null, $9c351ca3251b0a6f$var$Yg = null, $9c351ca3251b0a6f$var$Zg = null;
function $9c351ca3251b0a6f$var$$g() {
    $9c351ca3251b0a6f$var$Zg = $9c351ca3251b0a6f$var$Yg = $9c351ca3251b0a6f$var$Xg = null;
}
function $9c351ca3251b0a6f$var$ah(a) {
    var b = $9c351ca3251b0a6f$var$Wg.current;
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wg);
    a._currentValue = b;
}
function $9c351ca3251b0a6f$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $9c351ca3251b0a6f$var$ch(a, b) {
    $9c351ca3251b0a6f$var$Xg = a;
    $9c351ca3251b0a6f$var$Zg = $9c351ca3251b0a6f$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($9c351ca3251b0a6f$var$dh = !0), a.firstContext = null);
}
function $9c351ca3251b0a6f$var$eh(a) {
    var b = a._currentValue;
    if ($9c351ca3251b0a6f$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $9c351ca3251b0a6f$var$Yg) {
            if (null === $9c351ca3251b0a6f$var$Xg) throw Error($9c351ca3251b0a6f$var$p(308));
            $9c351ca3251b0a6f$var$Yg = a;
            $9c351ca3251b0a6f$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $9c351ca3251b0a6f$var$Yg = $9c351ca3251b0a6f$var$Yg.next = a;
    }
    return b;
}
var $9c351ca3251b0a6f$var$fh = null;
function $9c351ca3251b0a6f$var$gh(a) {
    null === $9c351ca3251b0a6f$var$fh ? $9c351ca3251b0a6f$var$fh = [
        a
    ] : $9c351ca3251b0a6f$var$fh.push(a);
}
function $9c351ca3251b0a6f$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $9c351ca3251b0a6f$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $9c351ca3251b0a6f$var$ih(a, d);
}
function $9c351ca3251b0a6f$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $9c351ca3251b0a6f$var$jh = !1;
function $9c351ca3251b0a6f$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $9c351ca3251b0a6f$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $9c351ca3251b0a6f$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $9c351ca3251b0a6f$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($9c351ca3251b0a6f$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $9c351ca3251b0a6f$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $9c351ca3251b0a6f$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $9c351ca3251b0a6f$var$ih(a, c);
}
function $9c351ca3251b0a6f$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9c351ca3251b0a6f$var$Cc(a, c);
    }
}
function $9c351ca3251b0a6f$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $9c351ca3251b0a6f$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $9c351ca3251b0a6f$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $9c351ca3251b0a6f$var$A({}, q, r);
                            break a;
                        case 2:
                            $9c351ca3251b0a6f$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $9c351ca3251b0a6f$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $9c351ca3251b0a6f$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($9c351ca3251b0a6f$var$p(191, e));
            e.call(d);
        }
    }
}
var $9c351ca3251b0a6f$var$th = {}, $9c351ca3251b0a6f$var$uh = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$th), $9c351ca3251b0a6f$var$vh = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$th), $9c351ca3251b0a6f$var$wh = $9c351ca3251b0a6f$var$Uf($9c351ca3251b0a6f$var$th);
function $9c351ca3251b0a6f$var$xh(a) {
    if (a === $9c351ca3251b0a6f$var$th) throw Error($9c351ca3251b0a6f$var$p(174));
    return a;
}
function $9c351ca3251b0a6f$var$yh(a, b) {
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$wh, b);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$vh, a);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$uh, $9c351ca3251b0a6f$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $9c351ca3251b0a6f$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $9c351ca3251b0a6f$var$lb(b, a);
    }
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$uh);
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$uh, b);
}
function $9c351ca3251b0a6f$var$zh() {
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$uh);
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$vh);
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$wh);
}
function $9c351ca3251b0a6f$var$Ah(a) {
    $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$wh.current);
    var b = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
    var c = $9c351ca3251b0a6f$var$lb(b, a.type);
    b !== c && ($9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$vh, a), $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$uh, c));
}
function $9c351ca3251b0a6f$var$Bh(a) {
    $9c351ca3251b0a6f$var$vh.current === a && ($9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$uh), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$vh));
}
var $9c351ca3251b0a6f$var$L = $9c351ca3251b0a6f$var$Uf(0);
function $9c351ca3251b0a6f$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $9c351ca3251b0a6f$var$Dh = [];
function $9c351ca3251b0a6f$var$Eh() {
    for(var a = 0; a < $9c351ca3251b0a6f$var$Dh.length; a++)$9c351ca3251b0a6f$var$Dh[a]._workInProgressVersionPrimary = null;
    $9c351ca3251b0a6f$var$Dh.length = 0;
}
var $9c351ca3251b0a6f$var$Fh = $9c351ca3251b0a6f$var$ua.ReactCurrentDispatcher, $9c351ca3251b0a6f$var$Gh = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig, $9c351ca3251b0a6f$var$Hh = 0, $9c351ca3251b0a6f$var$M = null, $9c351ca3251b0a6f$var$N = null, $9c351ca3251b0a6f$var$O = null, $9c351ca3251b0a6f$var$Ih = !1, $9c351ca3251b0a6f$var$Jh = !1, $9c351ca3251b0a6f$var$Kh = 0, $9c351ca3251b0a6f$var$Lh = 0;
function $9c351ca3251b0a6f$var$P() {
    throw Error($9c351ca3251b0a6f$var$p(321));
}
function $9c351ca3251b0a6f$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$9c351ca3251b0a6f$var$He(a[c], b[c])) return !1;
    return !0;
}
function $9c351ca3251b0a6f$var$Nh(a, b, c, d, e, f) {
    $9c351ca3251b0a6f$var$Hh = f;
    $9c351ca3251b0a6f$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $9c351ca3251b0a6f$var$Fh.current = null === a || null === a.memoizedState ? $9c351ca3251b0a6f$var$Oh : $9c351ca3251b0a6f$var$Ph;
    a = c(d, e);
    if ($9c351ca3251b0a6f$var$Jh) {
        f = 0;
        do {
            $9c351ca3251b0a6f$var$Jh = !1;
            $9c351ca3251b0a6f$var$Kh = 0;
            if (25 <= f) throw Error($9c351ca3251b0a6f$var$p(301));
            f += 1;
            $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$N = null;
            b.updateQueue = null;
            $9c351ca3251b0a6f$var$Fh.current = $9c351ca3251b0a6f$var$Qh;
            a = c(d, e);
        }while ($9c351ca3251b0a6f$var$Jh);
    }
    $9c351ca3251b0a6f$var$Fh.current = $9c351ca3251b0a6f$var$Rh;
    b = null !== $9c351ca3251b0a6f$var$N && null !== $9c351ca3251b0a6f$var$N.next;
    $9c351ca3251b0a6f$var$Hh = 0;
    $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$N = $9c351ca3251b0a6f$var$M = null;
    $9c351ca3251b0a6f$var$Ih = !1;
    if (b) throw Error($9c351ca3251b0a6f$var$p(300));
    return a;
}
function $9c351ca3251b0a6f$var$Sh() {
    var a = 0 !== $9c351ca3251b0a6f$var$Kh;
    $9c351ca3251b0a6f$var$Kh = 0;
    return a;
}
function $9c351ca3251b0a6f$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $9c351ca3251b0a6f$var$O ? $9c351ca3251b0a6f$var$M.memoizedState = $9c351ca3251b0a6f$var$O = a : $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$O.next = a;
    return $9c351ca3251b0a6f$var$O;
}
function $9c351ca3251b0a6f$var$Uh() {
    if (null === $9c351ca3251b0a6f$var$N) {
        var a = $9c351ca3251b0a6f$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $9c351ca3251b0a6f$var$N.next;
    var b = null === $9c351ca3251b0a6f$var$O ? $9c351ca3251b0a6f$var$M.memoizedState : $9c351ca3251b0a6f$var$O.next;
    if (null !== b) $9c351ca3251b0a6f$var$O = b, $9c351ca3251b0a6f$var$N = a;
    else {
        if (null === a) throw Error($9c351ca3251b0a6f$var$p(310));
        $9c351ca3251b0a6f$var$N = a;
        a = {
            memoizedState: $9c351ca3251b0a6f$var$N.memoizedState,
            baseState: $9c351ca3251b0a6f$var$N.baseState,
            baseQueue: $9c351ca3251b0a6f$var$N.baseQueue,
            queue: $9c351ca3251b0a6f$var$N.queue,
            next: null
        };
        null === $9c351ca3251b0a6f$var$O ? $9c351ca3251b0a6f$var$M.memoizedState = $9c351ca3251b0a6f$var$O = a : $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$O.next = a;
    }
    return $9c351ca3251b0a6f$var$O;
}
function $9c351ca3251b0a6f$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $9c351ca3251b0a6f$var$Wh(a) {
    var b = $9c351ca3251b0a6f$var$Uh(), c = b.queue;
    if (null === c) throw Error($9c351ca3251b0a6f$var$p(311));
    c.lastRenderedReducer = a;
    var d = $9c351ca3251b0a6f$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($9c351ca3251b0a6f$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $9c351ca3251b0a6f$var$M.lanes |= m;
                $9c351ca3251b0a6f$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $9c351ca3251b0a6f$var$He(d, b.memoizedState) || ($9c351ca3251b0a6f$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $9c351ca3251b0a6f$var$M.lanes |= f, $9c351ca3251b0a6f$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $9c351ca3251b0a6f$var$Xh(a) {
    var b = $9c351ca3251b0a6f$var$Uh(), c = b.queue;
    if (null === c) throw Error($9c351ca3251b0a6f$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $9c351ca3251b0a6f$var$He(f, b.memoizedState) || ($9c351ca3251b0a6f$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $9c351ca3251b0a6f$var$Yh() {}
function $9c351ca3251b0a6f$var$Zh(a, b) {
    var c = $9c351ca3251b0a6f$var$M, d = $9c351ca3251b0a6f$var$Uh(), e = b(), f = !$9c351ca3251b0a6f$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $9c351ca3251b0a6f$var$dh = !0);
    d = d.queue;
    $9c351ca3251b0a6f$var$$h($9c351ca3251b0a6f$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $9c351ca3251b0a6f$var$O && $9c351ca3251b0a6f$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $9c351ca3251b0a6f$var$bi(9, $9c351ca3251b0a6f$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $9c351ca3251b0a6f$var$Q) throw Error($9c351ca3251b0a6f$var$p(349));
        0 !== ($9c351ca3251b0a6f$var$Hh & 30) || $9c351ca3251b0a6f$var$di(c, b, e);
    }
    return e;
}
function $9c351ca3251b0a6f$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $9c351ca3251b0a6f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9c351ca3251b0a6f$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $9c351ca3251b0a6f$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $9c351ca3251b0a6f$var$ei(b) && $9c351ca3251b0a6f$var$fi(a);
}
function $9c351ca3251b0a6f$var$ai(a, b, c) {
    return c(function() {
        $9c351ca3251b0a6f$var$ei(b) && $9c351ca3251b0a6f$var$fi(a);
    });
}
function $9c351ca3251b0a6f$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$9c351ca3251b0a6f$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $9c351ca3251b0a6f$var$fi(a) {
    var b = $9c351ca3251b0a6f$var$ih(a, 1);
    null !== b && $9c351ca3251b0a6f$var$gi(b, a, 1, -1);
}
function $9c351ca3251b0a6f$var$hi(a) {
    var b = $9c351ca3251b0a6f$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $9c351ca3251b0a6f$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $9c351ca3251b0a6f$var$ii.bind(null, $9c351ca3251b0a6f$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $9c351ca3251b0a6f$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $9c351ca3251b0a6f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $9c351ca3251b0a6f$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $9c351ca3251b0a6f$var$ji() {
    return $9c351ca3251b0a6f$var$Uh().memoizedState;
}
function $9c351ca3251b0a6f$var$ki(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$Th();
    $9c351ca3251b0a6f$var$M.flags |= a;
    e.memoizedState = $9c351ca3251b0a6f$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $9c351ca3251b0a6f$var$li(a, b, c, d) {
    var e = $9c351ca3251b0a6f$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $9c351ca3251b0a6f$var$N) {
        var g = $9c351ca3251b0a6f$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $9c351ca3251b0a6f$var$Mh(d, g.deps)) {
            e.memoizedState = $9c351ca3251b0a6f$var$bi(b, c, f, d);
            return;
        }
    }
    $9c351ca3251b0a6f$var$M.flags |= a;
    e.memoizedState = $9c351ca3251b0a6f$var$bi(1 | b, c, f, d);
}
function $9c351ca3251b0a6f$var$mi(a, b) {
    return $9c351ca3251b0a6f$var$ki(8390656, 8, a, b);
}
function $9c351ca3251b0a6f$var$$h(a, b) {
    return $9c351ca3251b0a6f$var$li(2048, 8, a, b);
}
function $9c351ca3251b0a6f$var$ni(a, b) {
    return $9c351ca3251b0a6f$var$li(4, 2, a, b);
}
function $9c351ca3251b0a6f$var$oi(a, b) {
    return $9c351ca3251b0a6f$var$li(4, 4, a, b);
}
function $9c351ca3251b0a6f$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $9c351ca3251b0a6f$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $9c351ca3251b0a6f$var$li(4, 4, $9c351ca3251b0a6f$var$pi.bind(null, b, a), c);
}
function $9c351ca3251b0a6f$var$ri() {}
function $9c351ca3251b0a6f$var$si(a, b) {
    var c = $9c351ca3251b0a6f$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9c351ca3251b0a6f$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9c351ca3251b0a6f$var$ti(a, b) {
    var c = $9c351ca3251b0a6f$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $9c351ca3251b0a6f$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $9c351ca3251b0a6f$var$ui(a, b, c) {
    if (0 === ($9c351ca3251b0a6f$var$Hh & 21)) return a.baseState && (a.baseState = !1, $9c351ca3251b0a6f$var$dh = !0), a.memoizedState = c;
    $9c351ca3251b0a6f$var$He(c, b) || (c = $9c351ca3251b0a6f$var$yc(), $9c351ca3251b0a6f$var$M.lanes |= c, $9c351ca3251b0a6f$var$rh |= c, a.baseState = !0);
    return b;
}
function $9c351ca3251b0a6f$var$vi(a, b) {
    var c = $9c351ca3251b0a6f$var$C;
    $9c351ca3251b0a6f$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $9c351ca3251b0a6f$var$Gh.transition;
    $9c351ca3251b0a6f$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $9c351ca3251b0a6f$var$C = c, $9c351ca3251b0a6f$var$Gh.transition = d;
    }
}
function $9c351ca3251b0a6f$var$wi() {
    return $9c351ca3251b0a6f$var$Uh().memoizedState;
}
function $9c351ca3251b0a6f$var$xi(a, b, c) {
    var d = $9c351ca3251b0a6f$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9c351ca3251b0a6f$var$zi(a)) $9c351ca3251b0a6f$var$Ai(b, c);
    else if (c = $9c351ca3251b0a6f$var$hh(a, b, c, d), null !== c) {
        var e = $9c351ca3251b0a6f$var$R();
        $9c351ca3251b0a6f$var$gi(c, a, d, e);
        $9c351ca3251b0a6f$var$Bi(c, b, d);
    }
}
function $9c351ca3251b0a6f$var$ii(a, b, c) {
    var d = $9c351ca3251b0a6f$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($9c351ca3251b0a6f$var$zi(a)) $9c351ca3251b0a6f$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($9c351ca3251b0a6f$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $9c351ca3251b0a6f$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $9c351ca3251b0a6f$var$hh(a, b, e, d);
        null !== c && (e = $9c351ca3251b0a6f$var$R(), $9c351ca3251b0a6f$var$gi(c, a, d, e), $9c351ca3251b0a6f$var$Bi(c, b, d));
    }
}
function $9c351ca3251b0a6f$var$zi(a) {
    var b = a.alternate;
    return a === $9c351ca3251b0a6f$var$M || null !== b && b === $9c351ca3251b0a6f$var$M;
}
function $9c351ca3251b0a6f$var$Ai(a, b) {
    $9c351ca3251b0a6f$var$Jh = $9c351ca3251b0a6f$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $9c351ca3251b0a6f$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $9c351ca3251b0a6f$var$Cc(a, c);
    }
}
var $9c351ca3251b0a6f$var$Rh = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: $9c351ca3251b0a6f$var$P,
    useContext: $9c351ca3251b0a6f$var$P,
    useEffect: $9c351ca3251b0a6f$var$P,
    useImperativeHandle: $9c351ca3251b0a6f$var$P,
    useInsertionEffect: $9c351ca3251b0a6f$var$P,
    useLayoutEffect: $9c351ca3251b0a6f$var$P,
    useMemo: $9c351ca3251b0a6f$var$P,
    useReducer: $9c351ca3251b0a6f$var$P,
    useRef: $9c351ca3251b0a6f$var$P,
    useState: $9c351ca3251b0a6f$var$P,
    useDebugValue: $9c351ca3251b0a6f$var$P,
    useDeferredValue: $9c351ca3251b0a6f$var$P,
    useTransition: $9c351ca3251b0a6f$var$P,
    useMutableSource: $9c351ca3251b0a6f$var$P,
    useSyncExternalStore: $9c351ca3251b0a6f$var$P,
    useId: $9c351ca3251b0a6f$var$P,
    unstable_isNewReconciler: !1
}, $9c351ca3251b0a6f$var$Oh = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: function(a, b) {
        $9c351ca3251b0a6f$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $9c351ca3251b0a6f$var$eh,
    useEffect: $9c351ca3251b0a6f$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $9c351ca3251b0a6f$var$ki(4194308, 4, $9c351ca3251b0a6f$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $9c351ca3251b0a6f$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $9c351ca3251b0a6f$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $9c351ca3251b0a6f$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $9c351ca3251b0a6f$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $9c351ca3251b0a6f$var$xi.bind(null, $9c351ca3251b0a6f$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $9c351ca3251b0a6f$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $9c351ca3251b0a6f$var$hi,
    useDebugValue: $9c351ca3251b0a6f$var$ri,
    useDeferredValue: function(a) {
        return $9c351ca3251b0a6f$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $9c351ca3251b0a6f$var$hi(!1), b = a[0];
        a = $9c351ca3251b0a6f$var$vi.bind(null, a[1]);
        $9c351ca3251b0a6f$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $9c351ca3251b0a6f$var$M, e = $9c351ca3251b0a6f$var$Th();
        if ($9c351ca3251b0a6f$var$I) {
            if (void 0 === c) throw Error($9c351ca3251b0a6f$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $9c351ca3251b0a6f$var$Q) throw Error($9c351ca3251b0a6f$var$p(349));
            0 !== ($9c351ca3251b0a6f$var$Hh & 30) || $9c351ca3251b0a6f$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $9c351ca3251b0a6f$var$mi($9c351ca3251b0a6f$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $9c351ca3251b0a6f$var$bi(9, $9c351ca3251b0a6f$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $9c351ca3251b0a6f$var$Th(), b = $9c351ca3251b0a6f$var$Q.identifierPrefix;
        if ($9c351ca3251b0a6f$var$I) {
            var c = $9c351ca3251b0a6f$var$sg;
            var d = $9c351ca3251b0a6f$var$rg;
            c = (d & ~(1 << 32 - $9c351ca3251b0a6f$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $9c351ca3251b0a6f$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $9c351ca3251b0a6f$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $9c351ca3251b0a6f$var$Ph = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: $9c351ca3251b0a6f$var$si,
    useContext: $9c351ca3251b0a6f$var$eh,
    useEffect: $9c351ca3251b0a6f$var$$h,
    useImperativeHandle: $9c351ca3251b0a6f$var$qi,
    useInsertionEffect: $9c351ca3251b0a6f$var$ni,
    useLayoutEffect: $9c351ca3251b0a6f$var$oi,
    useMemo: $9c351ca3251b0a6f$var$ti,
    useReducer: $9c351ca3251b0a6f$var$Wh,
    useRef: $9c351ca3251b0a6f$var$ji,
    useState: function() {
        return $9c351ca3251b0a6f$var$Wh($9c351ca3251b0a6f$var$Vh);
    },
    useDebugValue: $9c351ca3251b0a6f$var$ri,
    useDeferredValue: function(a) {
        var b = $9c351ca3251b0a6f$var$Uh();
        return $9c351ca3251b0a6f$var$ui(b, $9c351ca3251b0a6f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9c351ca3251b0a6f$var$Wh($9c351ca3251b0a6f$var$Vh)[0], b = $9c351ca3251b0a6f$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9c351ca3251b0a6f$var$Yh,
    useSyncExternalStore: $9c351ca3251b0a6f$var$Zh,
    useId: $9c351ca3251b0a6f$var$wi,
    unstable_isNewReconciler: !1
}, $9c351ca3251b0a6f$var$Qh = {
    readContext: $9c351ca3251b0a6f$var$eh,
    useCallback: $9c351ca3251b0a6f$var$si,
    useContext: $9c351ca3251b0a6f$var$eh,
    useEffect: $9c351ca3251b0a6f$var$$h,
    useImperativeHandle: $9c351ca3251b0a6f$var$qi,
    useInsertionEffect: $9c351ca3251b0a6f$var$ni,
    useLayoutEffect: $9c351ca3251b0a6f$var$oi,
    useMemo: $9c351ca3251b0a6f$var$ti,
    useReducer: $9c351ca3251b0a6f$var$Xh,
    useRef: $9c351ca3251b0a6f$var$ji,
    useState: function() {
        return $9c351ca3251b0a6f$var$Xh($9c351ca3251b0a6f$var$Vh);
    },
    useDebugValue: $9c351ca3251b0a6f$var$ri,
    useDeferredValue: function(a) {
        var b = $9c351ca3251b0a6f$var$Uh();
        return null === $9c351ca3251b0a6f$var$N ? b.memoizedState = a : $9c351ca3251b0a6f$var$ui(b, $9c351ca3251b0a6f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $9c351ca3251b0a6f$var$Xh($9c351ca3251b0a6f$var$Vh)[0], b = $9c351ca3251b0a6f$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $9c351ca3251b0a6f$var$Yh,
    useSyncExternalStore: $9c351ca3251b0a6f$var$Zh,
    useId: $9c351ca3251b0a6f$var$wi,
    unstable_isNewReconciler: !1
};
function $9c351ca3251b0a6f$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $9c351ca3251b0a6f$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $9c351ca3251b0a6f$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $9c351ca3251b0a6f$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $9c351ca3251b0a6f$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $9c351ca3251b0a6f$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9c351ca3251b0a6f$var$R(), e = $9c351ca3251b0a6f$var$yi(a), f = $9c351ca3251b0a6f$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9c351ca3251b0a6f$var$nh(a, f, e);
        null !== b && ($9c351ca3251b0a6f$var$gi(b, a, e, d), $9c351ca3251b0a6f$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $9c351ca3251b0a6f$var$R(), e = $9c351ca3251b0a6f$var$yi(a), f = $9c351ca3251b0a6f$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $9c351ca3251b0a6f$var$nh(a, f, e);
        null !== b && ($9c351ca3251b0a6f$var$gi(b, a, e, d), $9c351ca3251b0a6f$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $9c351ca3251b0a6f$var$R(), d = $9c351ca3251b0a6f$var$yi(a), e = $9c351ca3251b0a6f$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $9c351ca3251b0a6f$var$nh(a, e, d);
        null !== b && ($9c351ca3251b0a6f$var$gi(b, a, d, c), $9c351ca3251b0a6f$var$oh(b, a, d));
    }
};
function $9c351ca3251b0a6f$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$9c351ca3251b0a6f$var$Ie(c, d) || !$9c351ca3251b0a6f$var$Ie(e, f) : !0;
}
function $9c351ca3251b0a6f$var$Gi(a, b, c) {
    var d = !1, e = $9c351ca3251b0a6f$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $9c351ca3251b0a6f$var$eh(f) : (e = $9c351ca3251b0a6f$var$Zf(b) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $9c351ca3251b0a6f$var$Yf(a, e) : $9c351ca3251b0a6f$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $9c351ca3251b0a6f$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $9c351ca3251b0a6f$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $9c351ca3251b0a6f$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $9c351ca3251b0a6f$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $9c351ca3251b0a6f$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $9c351ca3251b0a6f$var$eh(f) : (f = $9c351ca3251b0a6f$var$Zf(b) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, e.context = $9c351ca3251b0a6f$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($9c351ca3251b0a6f$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $9c351ca3251b0a6f$var$Ei.enqueueReplaceState(e, e.state, null), $9c351ca3251b0a6f$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $9c351ca3251b0a6f$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $9c351ca3251b0a6f$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $9c351ca3251b0a6f$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $9c351ca3251b0a6f$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $9c351ca3251b0a6f$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $9c351ca3251b0a6f$var$Ni(a, b, c) {
    c = $9c351ca3251b0a6f$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $9c351ca3251b0a6f$var$Oi || ($9c351ca3251b0a6f$var$Oi = !0, $9c351ca3251b0a6f$var$Pi = d);
        $9c351ca3251b0a6f$var$Li(a, b);
    };
    return c;
}
function $9c351ca3251b0a6f$var$Qi(a, b, c) {
    c = $9c351ca3251b0a6f$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $9c351ca3251b0a6f$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $9c351ca3251b0a6f$var$Li(a, b);
        "function" !== typeof d && (null === $9c351ca3251b0a6f$var$Ri ? $9c351ca3251b0a6f$var$Ri = new Set([
            this
        ]) : $9c351ca3251b0a6f$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $9c351ca3251b0a6f$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $9c351ca3251b0a6f$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $9c351ca3251b0a6f$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $9c351ca3251b0a6f$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $9c351ca3251b0a6f$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $9c351ca3251b0a6f$var$mh(-1, 1), b.tag = 2, $9c351ca3251b0a6f$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $9c351ca3251b0a6f$var$Wi = $9c351ca3251b0a6f$var$ua.ReactCurrentOwner, $9c351ca3251b0a6f$var$dh = !1;
function $9c351ca3251b0a6f$var$Xi(a, b, c, d) {
    b.child = null === a ? $9c351ca3251b0a6f$var$Vg(b, null, c, d) : $9c351ca3251b0a6f$var$Ug(b, a.child, c, d);
}
function $9c351ca3251b0a6f$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $9c351ca3251b0a6f$var$ch(b, e);
    d = $9c351ca3251b0a6f$var$Nh(a, b, c, d, f, e);
    c = $9c351ca3251b0a6f$var$Sh();
    if (null !== a && !$9c351ca3251b0a6f$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9c351ca3251b0a6f$var$Zi(a, b, e);
    $9c351ca3251b0a6f$var$I && c && $9c351ca3251b0a6f$var$vg(b);
    b.flags |= 1;
    $9c351ca3251b0a6f$var$Xi(a, b, d, e);
    return b.child;
}
function $9c351ca3251b0a6f$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$9c351ca3251b0a6f$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $9c351ca3251b0a6f$var$bj(a, b, f, d, e);
        a = $9c351ca3251b0a6f$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $9c351ca3251b0a6f$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $9c351ca3251b0a6f$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $9c351ca3251b0a6f$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $9c351ca3251b0a6f$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($9c351ca3251b0a6f$var$Ie(f, d) && a.ref === b.ref) {
            if ($9c351ca3251b0a6f$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($9c351ca3251b0a6f$var$dh = !0);
            else return b.lanes = a.lanes, $9c351ca3251b0a6f$var$Zi(a, b, e);
        }
    }
    return $9c351ca3251b0a6f$var$cj(a, b, c, d, e);
}
function $9c351ca3251b0a6f$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj), $9c351ca3251b0a6f$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj), $9c351ca3251b0a6f$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj);
            $9c351ca3251b0a6f$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$ej, $9c351ca3251b0a6f$var$fj), $9c351ca3251b0a6f$var$fj |= d;
    $9c351ca3251b0a6f$var$Xi(a, b, e, c);
    return b.child;
}
function $9c351ca3251b0a6f$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $9c351ca3251b0a6f$var$cj(a, b, c, d, e) {
    var f = $9c351ca3251b0a6f$var$Zf(c) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current;
    f = $9c351ca3251b0a6f$var$Yf(b, f);
    $9c351ca3251b0a6f$var$ch(b, e);
    c = $9c351ca3251b0a6f$var$Nh(a, b, c, d, f, e);
    d = $9c351ca3251b0a6f$var$Sh();
    if (null !== a && !$9c351ca3251b0a6f$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $9c351ca3251b0a6f$var$Zi(a, b, e);
    $9c351ca3251b0a6f$var$I && d && $9c351ca3251b0a6f$var$vg(b);
    b.flags |= 1;
    $9c351ca3251b0a6f$var$Xi(a, b, c, e);
    return b.child;
}
function $9c351ca3251b0a6f$var$hj(a, b, c, d, e) {
    if ($9c351ca3251b0a6f$var$Zf(c)) {
        var f = !0;
        $9c351ca3251b0a6f$var$cg(b);
    } else f = !1;
    $9c351ca3251b0a6f$var$ch(b, e);
    if (null === b.stateNode) $9c351ca3251b0a6f$var$ij(a, b), $9c351ca3251b0a6f$var$Gi(b, c, d), $9c351ca3251b0a6f$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $9c351ca3251b0a6f$var$eh(l) : (l = $9c351ca3251b0a6f$var$Zf(c) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, l = $9c351ca3251b0a6f$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $9c351ca3251b0a6f$var$Hi(b, g, d, l);
        $9c351ca3251b0a6f$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $9c351ca3251b0a6f$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $9c351ca3251b0a6f$var$Wf.current || $9c351ca3251b0a6f$var$jh ? ("function" === typeof m && ($9c351ca3251b0a6f$var$Di(b, c, m, d), k = b.memoizedState), (h = $9c351ca3251b0a6f$var$jh || $9c351ca3251b0a6f$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $9c351ca3251b0a6f$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $9c351ca3251b0a6f$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $9c351ca3251b0a6f$var$eh(k) : (k = $9c351ca3251b0a6f$var$Zf(c) ? $9c351ca3251b0a6f$var$Xf : $9c351ca3251b0a6f$var$H.current, k = $9c351ca3251b0a6f$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $9c351ca3251b0a6f$var$Hi(b, g, d, k);
        $9c351ca3251b0a6f$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $9c351ca3251b0a6f$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $9c351ca3251b0a6f$var$Wf.current || $9c351ca3251b0a6f$var$jh ? ("function" === typeof y && ($9c351ca3251b0a6f$var$Di(b, c, y, d), n = b.memoizedState), (l = $9c351ca3251b0a6f$var$jh || $9c351ca3251b0a6f$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $9c351ca3251b0a6f$var$jj(a, b, c, d, f, e);
}
function $9c351ca3251b0a6f$var$jj(a, b, c, d, e, f) {
    $9c351ca3251b0a6f$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $9c351ca3251b0a6f$var$dg(b, c, !1), $9c351ca3251b0a6f$var$Zi(a, b, f);
    d = b.stateNode;
    $9c351ca3251b0a6f$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $9c351ca3251b0a6f$var$Ug(b, a.child, null, f), b.child = $9c351ca3251b0a6f$var$Ug(b, null, h, f)) : $9c351ca3251b0a6f$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $9c351ca3251b0a6f$var$dg(b, c, !0);
    return b.child;
}
function $9c351ca3251b0a6f$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $9c351ca3251b0a6f$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $9c351ca3251b0a6f$var$ag(a, b.context, !1);
    $9c351ca3251b0a6f$var$yh(a, b.containerInfo);
}
function $9c351ca3251b0a6f$var$lj(a, b, c, d, e) {
    $9c351ca3251b0a6f$var$Ig();
    $9c351ca3251b0a6f$var$Jg(e);
    b.flags |= 256;
    $9c351ca3251b0a6f$var$Xi(a, b, c, d);
    return b.child;
}
var $9c351ca3251b0a6f$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $9c351ca3251b0a6f$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $9c351ca3251b0a6f$var$oj(a, b, c) {
    var d = b.pendingProps, e = $9c351ca3251b0a6f$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, e & 1);
    if (null === a) {
        $9c351ca3251b0a6f$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $9c351ca3251b0a6f$var$pj(g, d, 0, null), a = $9c351ca3251b0a6f$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $9c351ca3251b0a6f$var$nj(c), b.memoizedState = $9c351ca3251b0a6f$var$mj, a) : $9c351ca3251b0a6f$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $9c351ca3251b0a6f$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $9c351ca3251b0a6f$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $9c351ca3251b0a6f$var$Pg(h, f) : (f = $9c351ca3251b0a6f$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $9c351ca3251b0a6f$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $9c351ca3251b0a6f$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $9c351ca3251b0a6f$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $9c351ca3251b0a6f$var$qj(a, b) {
    b = $9c351ca3251b0a6f$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $9c351ca3251b0a6f$var$sj(a, b, c, d) {
    null !== d && $9c351ca3251b0a6f$var$Jg(d);
    $9c351ca3251b0a6f$var$Ug(b, a.child, null, c);
    a = $9c351ca3251b0a6f$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $9c351ca3251b0a6f$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $9c351ca3251b0a6f$var$Ki(Error($9c351ca3251b0a6f$var$p(422))), $9c351ca3251b0a6f$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $9c351ca3251b0a6f$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $9c351ca3251b0a6f$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $9c351ca3251b0a6f$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $9c351ca3251b0a6f$var$nj(g);
        b.memoizedState = $9c351ca3251b0a6f$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $9c351ca3251b0a6f$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($9c351ca3251b0a6f$var$p(419));
        d = $9c351ca3251b0a6f$var$Ki(f, d, void 0);
        return $9c351ca3251b0a6f$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($9c351ca3251b0a6f$var$dh || h) {
        d = $9c351ca3251b0a6f$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $9c351ca3251b0a6f$var$ih(a, e), $9c351ca3251b0a6f$var$gi(d, a, e, -1));
        }
        $9c351ca3251b0a6f$var$tj();
        d = $9c351ca3251b0a6f$var$Ki(Error($9c351ca3251b0a6f$var$p(421)));
        return $9c351ca3251b0a6f$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $9c351ca3251b0a6f$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(e.nextSibling);
    $9c351ca3251b0a6f$var$xg = b;
    $9c351ca3251b0a6f$var$I = !0;
    $9c351ca3251b0a6f$var$zg = null;
    null !== a && ($9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$rg, $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$sg, $9c351ca3251b0a6f$var$og[$9c351ca3251b0a6f$var$pg++] = $9c351ca3251b0a6f$var$qg, $9c351ca3251b0a6f$var$rg = a.id, $9c351ca3251b0a6f$var$sg = a.overflow, $9c351ca3251b0a6f$var$qg = b);
    b = $9c351ca3251b0a6f$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $9c351ca3251b0a6f$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $9c351ca3251b0a6f$var$bh(a.return, b, c);
}
function $9c351ca3251b0a6f$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $9c351ca3251b0a6f$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $9c351ca3251b0a6f$var$Xi(a, b, d.children, c);
    d = $9c351ca3251b0a6f$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $9c351ca3251b0a6f$var$vj(a, c, b);
            else if (19 === a.tag) $9c351ca3251b0a6f$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $9c351ca3251b0a6f$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $9c351ca3251b0a6f$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $9c351ca3251b0a6f$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $9c351ca3251b0a6f$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $9c351ca3251b0a6f$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $9c351ca3251b0a6f$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $9c351ca3251b0a6f$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $9c351ca3251b0a6f$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($9c351ca3251b0a6f$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $9c351ca3251b0a6f$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $9c351ca3251b0a6f$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $9c351ca3251b0a6f$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $9c351ca3251b0a6f$var$kj(b);
            $9c351ca3251b0a6f$var$Ig();
            break;
        case 5:
            $9c351ca3251b0a6f$var$Ah(b);
            break;
        case 1:
            $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$cg(b);
            break;
        case 4:
            $9c351ca3251b0a6f$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $9c351ca3251b0a6f$var$oj(a, b, c);
                $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1);
                a = $9c351ca3251b0a6f$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $9c351ca3251b0a6f$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $9c351ca3251b0a6f$var$dj(a, b, c);
    }
    return $9c351ca3251b0a6f$var$Zi(a, b, c);
}
var $9c351ca3251b0a6f$var$zj, $9c351ca3251b0a6f$var$Aj, $9c351ca3251b0a6f$var$Bj, $9c351ca3251b0a6f$var$Cj;
$9c351ca3251b0a6f$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$9c351ca3251b0a6f$var$Aj = function() {};
$9c351ca3251b0a6f$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $9c351ca3251b0a6f$var$Ya(a, e);
                d = $9c351ca3251b0a6f$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $9c351ca3251b0a6f$var$A({}, e, {
                    value: void 0
                });
                d = $9c351ca3251b0a6f$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $9c351ca3251b0a6f$var$gb(a, e);
                d = $9c351ca3251b0a6f$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $9c351ca3251b0a6f$var$Bf);
        }
        $9c351ca3251b0a6f$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($9c351ca3251b0a6f$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($9c351ca3251b0a6f$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $9c351ca3251b0a6f$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$9c351ca3251b0a6f$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $9c351ca3251b0a6f$var$Dj(a, b) {
    if (!$9c351ca3251b0a6f$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $9c351ca3251b0a6f$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $9c351ca3251b0a6f$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $9c351ca3251b0a6f$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $9c351ca3251b0a6f$var$S(b), null;
        case 1:
            return $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$$f(), $9c351ca3251b0a6f$var$S(b), null;
        case 3:
            d = b.stateNode;
            $9c351ca3251b0a6f$var$zh();
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H);
            $9c351ca3251b0a6f$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $9c351ca3251b0a6f$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $9c351ca3251b0a6f$var$zg && ($9c351ca3251b0a6f$var$Fj($9c351ca3251b0a6f$var$zg), $9c351ca3251b0a6f$var$zg = null));
            $9c351ca3251b0a6f$var$Aj(a, b);
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 5:
            $9c351ca3251b0a6f$var$Bh(b);
            var e = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $9c351ca3251b0a6f$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($9c351ca3251b0a6f$var$p(166));
                    $9c351ca3251b0a6f$var$S(b);
                    return null;
                }
                a = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
                if ($9c351ca3251b0a6f$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$9c351ca3251b0a6f$var$Of] = b;
                    d[$9c351ca3251b0a6f$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $9c351ca3251b0a6f$var$D("cancel", d);
                            $9c351ca3251b0a6f$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $9c351ca3251b0a6f$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $9c351ca3251b0a6f$var$lf.length; e++)$9c351ca3251b0a6f$var$D($9c351ca3251b0a6f$var$lf[e], d);
                            break;
                        case "source":
                            $9c351ca3251b0a6f$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $9c351ca3251b0a6f$var$D("error", d);
                            $9c351ca3251b0a6f$var$D("load", d);
                            break;
                        case "details":
                            $9c351ca3251b0a6f$var$D("toggle", d);
                            break;
                        case "input":
                            $9c351ca3251b0a6f$var$Za(d, f);
                            $9c351ca3251b0a6f$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $9c351ca3251b0a6f$var$D("invalid", d);
                            break;
                        case "textarea":
                            $9c351ca3251b0a6f$var$hb(d, f), $9c351ca3251b0a6f$var$D("invalid", d);
                    }
                    $9c351ca3251b0a6f$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $9c351ca3251b0a6f$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $9c351ca3251b0a6f$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $9c351ca3251b0a6f$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $9c351ca3251b0a6f$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $9c351ca3251b0a6f$var$Va(d);
                            $9c351ca3251b0a6f$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $9c351ca3251b0a6f$var$Va(d);
                            $9c351ca3251b0a6f$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $9c351ca3251b0a6f$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $9c351ca3251b0a6f$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$9c351ca3251b0a6f$var$Of] = b;
                    a[$9c351ca3251b0a6f$var$Pf] = d;
                    $9c351ca3251b0a6f$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $9c351ca3251b0a6f$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $9c351ca3251b0a6f$var$D("cancel", a);
                                $9c351ca3251b0a6f$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $9c351ca3251b0a6f$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $9c351ca3251b0a6f$var$lf.length; e++)$9c351ca3251b0a6f$var$D($9c351ca3251b0a6f$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $9c351ca3251b0a6f$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $9c351ca3251b0a6f$var$D("error", a);
                                $9c351ca3251b0a6f$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $9c351ca3251b0a6f$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $9c351ca3251b0a6f$var$Za(a, d);
                                e = $9c351ca3251b0a6f$var$Ya(a, d);
                                $9c351ca3251b0a6f$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $9c351ca3251b0a6f$var$A({}, d, {
                                    value: void 0
                                });
                                $9c351ca3251b0a6f$var$D("invalid", a);
                                break;
                            case "textarea":
                                $9c351ca3251b0a6f$var$hb(a, d);
                                e = $9c351ca3251b0a6f$var$gb(a, d);
                                $9c351ca3251b0a6f$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $9c351ca3251b0a6f$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $9c351ca3251b0a6f$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $9c351ca3251b0a6f$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $9c351ca3251b0a6f$var$ob(a, k) : "number" === typeof k && $9c351ca3251b0a6f$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($9c351ca3251b0a6f$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $9c351ca3251b0a6f$var$D("scroll", a) : null != k && $9c351ca3251b0a6f$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $9c351ca3251b0a6f$var$Va(a);
                                $9c351ca3251b0a6f$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $9c351ca3251b0a6f$var$Va(a);
                                $9c351ca3251b0a6f$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $9c351ca3251b0a6f$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $9c351ca3251b0a6f$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $9c351ca3251b0a6f$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $9c351ca3251b0a6f$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $9c351ca3251b0a6f$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($9c351ca3251b0a6f$var$p(166));
                c = $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$wh.current);
                $9c351ca3251b0a6f$var$xh($9c351ca3251b0a6f$var$uh.current);
                if ($9c351ca3251b0a6f$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$9c351ca3251b0a6f$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $9c351ca3251b0a6f$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $9c351ca3251b0a6f$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $9c351ca3251b0a6f$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$9c351ca3251b0a6f$var$Of] = b, b.stateNode = d;
            }
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 13:
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($9c351ca3251b0a6f$var$I && null !== $9c351ca3251b0a6f$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $9c351ca3251b0a6f$var$Hg(), $9c351ca3251b0a6f$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $9c351ca3251b0a6f$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($9c351ca3251b0a6f$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($9c351ca3251b0a6f$var$p(317));
                        f[$9c351ca3251b0a6f$var$Of] = b;
                    } else $9c351ca3251b0a6f$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $9c351ca3251b0a6f$var$S(b);
                    f = !1;
                } else null !== $9c351ca3251b0a6f$var$zg && ($9c351ca3251b0a6f$var$Fj($9c351ca3251b0a6f$var$zg), $9c351ca3251b0a6f$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($9c351ca3251b0a6f$var$L.current & 1) ? 0 === $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$T = 3) : $9c351ca3251b0a6f$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 4:
            return $9c351ca3251b0a6f$var$zh(), $9c351ca3251b0a6f$var$Aj(a, b), null === a && $9c351ca3251b0a6f$var$sf(b.stateNode.containerInfo), $9c351ca3251b0a6f$var$S(b), null;
        case 10:
            return $9c351ca3251b0a6f$var$ah(b.type._context), $9c351ca3251b0a6f$var$S(b), null;
        case 17:
            return $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$$f(), $9c351ca3251b0a6f$var$S(b), null;
        case 19:
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
            f = b.memoizedState;
            if (null === f) return $9c351ca3251b0a6f$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $9c351ca3251b0a6f$var$Dj(f, !1);
                else {
                    if (0 !== $9c351ca3251b0a6f$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $9c351ca3251b0a6f$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $9c351ca3251b0a6f$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, $9c351ca3251b0a6f$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $9c351ca3251b0a6f$var$B() > $9c351ca3251b0a6f$var$Gj && (b.flags |= 128, d = !0, $9c351ca3251b0a6f$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $9c351ca3251b0a6f$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $9c351ca3251b0a6f$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$9c351ca3251b0a6f$var$I) return $9c351ca3251b0a6f$var$S(b), null;
                    } else 2 * $9c351ca3251b0a6f$var$B() - f.renderingStartTime > $9c351ca3251b0a6f$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $9c351ca3251b0a6f$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $9c351ca3251b0a6f$var$B(), b.sibling = null, c = $9c351ca3251b0a6f$var$L.current, $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$L, d ? c & 1 | 2 : c & 1), b;
            $9c351ca3251b0a6f$var$S(b);
            return null;
        case 22:
        case 23:
            return $9c351ca3251b0a6f$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($9c351ca3251b0a6f$var$fj & 1073741824) && ($9c351ca3251b0a6f$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $9c351ca3251b0a6f$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($9c351ca3251b0a6f$var$p(156, b.tag));
}
function $9c351ca3251b0a6f$var$Ij(a, b) {
    $9c351ca3251b0a6f$var$wg(b);
    switch(b.tag){
        case 1:
            return $9c351ca3251b0a6f$var$Zf(b.type) && $9c351ca3251b0a6f$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $9c351ca3251b0a6f$var$zh(), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf), $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H), $9c351ca3251b0a6f$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $9c351ca3251b0a6f$var$Bh(b), null;
        case 13:
            $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($9c351ca3251b0a6f$var$p(340));
                $9c351ca3251b0a6f$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L), null;
        case 4:
            return $9c351ca3251b0a6f$var$zh(), null;
        case 10:
            return $9c351ca3251b0a6f$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $9c351ca3251b0a6f$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $9c351ca3251b0a6f$var$Jj = !1, $9c351ca3251b0a6f$var$U = !1, $9c351ca3251b0a6f$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $9c351ca3251b0a6f$var$V = null;
function $9c351ca3251b0a6f$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $9c351ca3251b0a6f$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $9c351ca3251b0a6f$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $9c351ca3251b0a6f$var$W(a, b, d);
    }
}
var $9c351ca3251b0a6f$var$Nj = !1;
function $9c351ca3251b0a6f$var$Oj(a, b) {
    $9c351ca3251b0a6f$var$Cf = $9c351ca3251b0a6f$var$dd;
    a = $9c351ca3251b0a6f$var$Me();
    if ($9c351ca3251b0a6f$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $9c351ca3251b0a6f$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $9c351ca3251b0a6f$var$dd = !1;
    for($9c351ca3251b0a6f$var$V = b; null !== $9c351ca3251b0a6f$var$V;)if (b = $9c351ca3251b0a6f$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $9c351ca3251b0a6f$var$V = a;
    else for(; null !== $9c351ca3251b0a6f$var$V;){
        b = $9c351ca3251b0a6f$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $9c351ca3251b0a6f$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($9c351ca3251b0a6f$var$p(163));
            }
        } catch (F) {
            $9c351ca3251b0a6f$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $9c351ca3251b0a6f$var$V = a;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
    n = $9c351ca3251b0a6f$var$Nj;
    $9c351ca3251b0a6f$var$Nj = !1;
    return n;
}
function $9c351ca3251b0a6f$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $9c351ca3251b0a6f$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $9c351ca3251b0a6f$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $9c351ca3251b0a6f$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $9c351ca3251b0a6f$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $9c351ca3251b0a6f$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$9c351ca3251b0a6f$var$Of], delete b[$9c351ca3251b0a6f$var$Pf], delete b[$9c351ca3251b0a6f$var$of], delete b[$9c351ca3251b0a6f$var$Qf], delete b[$9c351ca3251b0a6f$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $9c351ca3251b0a6f$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $9c351ca3251b0a6f$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $9c351ca3251b0a6f$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $9c351ca3251b0a6f$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $9c351ca3251b0a6f$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($9c351ca3251b0a6f$var$Vj(a, b, c), a = a.sibling; null !== a;)$9c351ca3251b0a6f$var$Vj(a, b, c), a = a.sibling;
}
function $9c351ca3251b0a6f$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($9c351ca3251b0a6f$var$Wj(a, b, c), a = a.sibling; null !== a;)$9c351ca3251b0a6f$var$Wj(a, b, c), a = a.sibling;
}
var $9c351ca3251b0a6f$var$X = null, $9c351ca3251b0a6f$var$Xj = !1;
function $9c351ca3251b0a6f$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$9c351ca3251b0a6f$var$Zj(a, b, c), c = c.sibling;
}
function $9c351ca3251b0a6f$var$Zj(a, b, c) {
    if ($9c351ca3251b0a6f$var$lc && "function" === typeof $9c351ca3251b0a6f$var$lc.onCommitFiberUnmount) try {
        $9c351ca3251b0a6f$var$lc.onCommitFiberUnmount($9c351ca3251b0a6f$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $9c351ca3251b0a6f$var$U || $9c351ca3251b0a6f$var$Lj(c, b);
        case 6:
            var d = $9c351ca3251b0a6f$var$X, e = $9c351ca3251b0a6f$var$Xj;
            $9c351ca3251b0a6f$var$X = null;
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            $9c351ca3251b0a6f$var$X = d;
            $9c351ca3251b0a6f$var$Xj = e;
            null !== $9c351ca3251b0a6f$var$X && ($9c351ca3251b0a6f$var$Xj ? (a = $9c351ca3251b0a6f$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $9c351ca3251b0a6f$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $9c351ca3251b0a6f$var$X && ($9c351ca3251b0a6f$var$Xj ? (a = $9c351ca3251b0a6f$var$X, c = c.stateNode, 8 === a.nodeType ? $9c351ca3251b0a6f$var$Kf(a.parentNode, c) : 1 === a.nodeType && $9c351ca3251b0a6f$var$Kf(a, c), $9c351ca3251b0a6f$var$bd(a)) : $9c351ca3251b0a6f$var$Kf($9c351ca3251b0a6f$var$X, c.stateNode));
            break;
        case 4:
            d = $9c351ca3251b0a6f$var$X;
            e = $9c351ca3251b0a6f$var$Xj;
            $9c351ca3251b0a6f$var$X = c.stateNode.containerInfo;
            $9c351ca3251b0a6f$var$Xj = !0;
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            $9c351ca3251b0a6f$var$X = d;
            $9c351ca3251b0a6f$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$9c351ca3251b0a6f$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $9c351ca3251b0a6f$var$Mj(c, b, g) : 0 !== (f & 4) && $9c351ca3251b0a6f$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        case 1:
            if (!$9c351ca3251b0a6f$var$U && ($9c351ca3251b0a6f$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $9c351ca3251b0a6f$var$W(c, b, h);
            }
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        case 21:
            $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($9c351ca3251b0a6f$var$U = (d = $9c351ca3251b0a6f$var$U) || null !== c.memoizedState, $9c351ca3251b0a6f$var$Yj(a, b, c), $9c351ca3251b0a6f$var$U = d) : $9c351ca3251b0a6f$var$Yj(a, b, c);
            break;
        default:
            $9c351ca3251b0a6f$var$Yj(a, b, c);
    }
}
function $9c351ca3251b0a6f$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $9c351ca3251b0a6f$var$Kj);
        b.forEach(function(b) {
            var d = $9c351ca3251b0a6f$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $9c351ca3251b0a6f$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $9c351ca3251b0a6f$var$X = h.stateNode;
                        $9c351ca3251b0a6f$var$Xj = !1;
                        break a;
                    case 3:
                        $9c351ca3251b0a6f$var$X = h.stateNode.containerInfo;
                        $9c351ca3251b0a6f$var$Xj = !0;
                        break a;
                    case 4:
                        $9c351ca3251b0a6f$var$X = h.stateNode.containerInfo;
                        $9c351ca3251b0a6f$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $9c351ca3251b0a6f$var$X) throw Error($9c351ca3251b0a6f$var$p(160));
            $9c351ca3251b0a6f$var$Zj(f, g, e);
            $9c351ca3251b0a6f$var$X = null;
            $9c351ca3251b0a6f$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $9c351ca3251b0a6f$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$9c351ca3251b0a6f$var$dk(b, a), b = b.sibling;
}
function $9c351ca3251b0a6f$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 4) {
                try {
                    $9c351ca3251b0a6f$var$Pj(3, a, a.return), $9c351ca3251b0a6f$var$Qj(3, a);
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
                try {
                    $9c351ca3251b0a6f$var$Pj(5, a, a.return);
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            d & 512 && null !== c && $9c351ca3251b0a6f$var$Lj(c, c.return);
            break;
        case 5:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            d & 512 && null !== c && $9c351ca3251b0a6f$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $9c351ca3251b0a6f$var$ob(e, "");
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $9c351ca3251b0a6f$var$ab(e, f);
                    $9c351ca3251b0a6f$var$vb(h, g);
                    var l = $9c351ca3251b0a6f$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $9c351ca3251b0a6f$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $9c351ca3251b0a6f$var$nb(e, q) : "children" === m ? $9c351ca3251b0a6f$var$ob(e, q) : $9c351ca3251b0a6f$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $9c351ca3251b0a6f$var$bb(e, f);
                            break;
                        case "textarea":
                            $9c351ca3251b0a6f$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $9c351ca3251b0a6f$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $9c351ca3251b0a6f$var$fb(e, !!f.multiple, f.defaultValue, !0) : $9c351ca3251b0a6f$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$9c351ca3251b0a6f$var$Pf] = f;
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($9c351ca3251b0a6f$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $9c351ca3251b0a6f$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $9c351ca3251b0a6f$var$bd(b.containerInfo);
            } catch (t) {
                $9c351ca3251b0a6f$var$W(a, a.return, t);
            }
            break;
        case 4:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            break;
        case 13:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($9c351ca3251b0a6f$var$fk = $9c351ca3251b0a6f$var$B()));
            d & 4 && $9c351ca3251b0a6f$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($9c351ca3251b0a6f$var$U = (l = $9c351ca3251b0a6f$var$U) || m, $9c351ca3251b0a6f$var$ck(b, a), $9c351ca3251b0a6f$var$U = l) : $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($9c351ca3251b0a6f$var$V = a, m = a.child; null !== m;){
                    for(q = $9c351ca3251b0a6f$var$V = m; null !== $9c351ca3251b0a6f$var$V;){
                        r = $9c351ca3251b0a6f$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $9c351ca3251b0a6f$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $9c351ca3251b0a6f$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $9c351ca3251b0a6f$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $9c351ca3251b0a6f$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $9c351ca3251b0a6f$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $9c351ca3251b0a6f$var$V = y) : $9c351ca3251b0a6f$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $9c351ca3251b0a6f$var$rb("display", g));
                            } catch (t) {
                                $9c351ca3251b0a6f$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $9c351ca3251b0a6f$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $9c351ca3251b0a6f$var$ck(b, a);
            $9c351ca3251b0a6f$var$ek(a);
            d & 4 && $9c351ca3251b0a6f$var$ak(a);
            break;
        case 21:
            break;
        default:
            $9c351ca3251b0a6f$var$ck(b, a), $9c351ca3251b0a6f$var$ek(a);
    }
}
function $9c351ca3251b0a6f$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($9c351ca3251b0a6f$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($9c351ca3251b0a6f$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($9c351ca3251b0a6f$var$ob(e, ""), d.flags &= -33);
                    var f = $9c351ca3251b0a6f$var$Uj(a);
                    $9c351ca3251b0a6f$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $9c351ca3251b0a6f$var$Uj(a);
                    $9c351ca3251b0a6f$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($9c351ca3251b0a6f$var$p(161));
            }
        } catch (k) {
            $9c351ca3251b0a6f$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $9c351ca3251b0a6f$var$hk(a, b, c) {
    $9c351ca3251b0a6f$var$V = a;
    $9c351ca3251b0a6f$var$ik(a, b, c);
}
function $9c351ca3251b0a6f$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $9c351ca3251b0a6f$var$V;){
        var e = $9c351ca3251b0a6f$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $9c351ca3251b0a6f$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $9c351ca3251b0a6f$var$U;
                h = $9c351ca3251b0a6f$var$Jj;
                var l = $9c351ca3251b0a6f$var$U;
                $9c351ca3251b0a6f$var$Jj = g;
                if (($9c351ca3251b0a6f$var$U = k) && !l) for($9c351ca3251b0a6f$var$V = e; null !== $9c351ca3251b0a6f$var$V;)g = $9c351ca3251b0a6f$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $9c351ca3251b0a6f$var$jk(e) : null !== k ? (k.return = g, $9c351ca3251b0a6f$var$V = k) : $9c351ca3251b0a6f$var$jk(e);
                for(; null !== f;)$9c351ca3251b0a6f$var$V = f, $9c351ca3251b0a6f$var$ik(f, b, c), f = f.sibling;
                $9c351ca3251b0a6f$var$V = e;
                $9c351ca3251b0a6f$var$Jj = h;
                $9c351ca3251b0a6f$var$U = l;
            }
            $9c351ca3251b0a6f$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $9c351ca3251b0a6f$var$V = f) : $9c351ca3251b0a6f$var$kk(a, b, c);
    }
}
function $9c351ca3251b0a6f$var$kk(a) {
    for(; null !== $9c351ca3251b0a6f$var$V;){
        var b = $9c351ca3251b0a6f$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $9c351ca3251b0a6f$var$U || $9c351ca3251b0a6f$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$9c351ca3251b0a6f$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $9c351ca3251b0a6f$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $9c351ca3251b0a6f$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $9c351ca3251b0a6f$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $9c351ca3251b0a6f$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($9c351ca3251b0a6f$var$p(163));
                }
                $9c351ca3251b0a6f$var$U || b.flags & 512 && $9c351ca3251b0a6f$var$Rj(b);
            } catch (r) {
                $9c351ca3251b0a6f$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $9c351ca3251b0a6f$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9c351ca3251b0a6f$var$V = c;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
}
function $9c351ca3251b0a6f$var$gk(a) {
    for(; null !== $9c351ca3251b0a6f$var$V;){
        var b = $9c351ca3251b0a6f$var$V;
        if (b === a) {
            $9c351ca3251b0a6f$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $9c351ca3251b0a6f$var$V = c;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
}
function $9c351ca3251b0a6f$var$jk(a) {
    for(; null !== $9c351ca3251b0a6f$var$V;){
        var b = $9c351ca3251b0a6f$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $9c351ca3251b0a6f$var$Qj(4, b);
                    } catch (k) {
                        $9c351ca3251b0a6f$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $9c351ca3251b0a6f$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $9c351ca3251b0a6f$var$Rj(b);
                    } catch (k) {
                        $9c351ca3251b0a6f$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $9c351ca3251b0a6f$var$Rj(b);
                    } catch (k) {
                        $9c351ca3251b0a6f$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $9c351ca3251b0a6f$var$W(b, b.return, k);
        }
        if (b === a) {
            $9c351ca3251b0a6f$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $9c351ca3251b0a6f$var$V = h;
            break;
        }
        $9c351ca3251b0a6f$var$V = b.return;
    }
}
var $9c351ca3251b0a6f$var$lk = Math.ceil, $9c351ca3251b0a6f$var$mk = $9c351ca3251b0a6f$var$ua.ReactCurrentDispatcher, $9c351ca3251b0a6f$var$nk = $9c351ca3251b0a6f$var$ua.ReactCurrentOwner, $9c351ca3251b0a6f$var$ok = $9c351ca3251b0a6f$var$ua.ReactCurrentBatchConfig, $9c351ca3251b0a6f$var$K = 0, $9c351ca3251b0a6f$var$Q = null, $9c351ca3251b0a6f$var$Y = null, $9c351ca3251b0a6f$var$Z = 0, $9c351ca3251b0a6f$var$fj = 0, $9c351ca3251b0a6f$var$ej = $9c351ca3251b0a6f$var$Uf(0), $9c351ca3251b0a6f$var$T = 0, $9c351ca3251b0a6f$var$pk = null, $9c351ca3251b0a6f$var$rh = 0, $9c351ca3251b0a6f$var$qk = 0, $9c351ca3251b0a6f$var$rk = 0, $9c351ca3251b0a6f$var$sk = null, $9c351ca3251b0a6f$var$tk = null, $9c351ca3251b0a6f$var$fk = 0, $9c351ca3251b0a6f$var$Gj = Infinity, $9c351ca3251b0a6f$var$uk = null, $9c351ca3251b0a6f$var$Oi = !1, $9c351ca3251b0a6f$var$Pi = null, $9c351ca3251b0a6f$var$Ri = null, $9c351ca3251b0a6f$var$vk = !1, $9c351ca3251b0a6f$var$wk = null, $9c351ca3251b0a6f$var$xk = 0, $9c351ca3251b0a6f$var$yk = 0, $9c351ca3251b0a6f$var$zk = null, $9c351ca3251b0a6f$var$Ak = -1, $9c351ca3251b0a6f$var$Bk = 0;
function $9c351ca3251b0a6f$var$R() {
    return 0 !== ($9c351ca3251b0a6f$var$K & 6) ? $9c351ca3251b0a6f$var$B() : -1 !== $9c351ca3251b0a6f$var$Ak ? $9c351ca3251b0a6f$var$Ak : $9c351ca3251b0a6f$var$Ak = $9c351ca3251b0a6f$var$B();
}
function $9c351ca3251b0a6f$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($9c351ca3251b0a6f$var$K & 2) && 0 !== $9c351ca3251b0a6f$var$Z) return $9c351ca3251b0a6f$var$Z & -$9c351ca3251b0a6f$var$Z;
    if (null !== $9c351ca3251b0a6f$var$Kg.transition) return 0 === $9c351ca3251b0a6f$var$Bk && ($9c351ca3251b0a6f$var$Bk = $9c351ca3251b0a6f$var$yc()), $9c351ca3251b0a6f$var$Bk;
    a = $9c351ca3251b0a6f$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $9c351ca3251b0a6f$var$jd(a.type);
    return a;
}
function $9c351ca3251b0a6f$var$gi(a, b, c, d) {
    if (50 < $9c351ca3251b0a6f$var$yk) throw $9c351ca3251b0a6f$var$yk = 0, $9c351ca3251b0a6f$var$zk = null, Error($9c351ca3251b0a6f$var$p(185));
    $9c351ca3251b0a6f$var$Ac(a, c, d);
    if (0 === ($9c351ca3251b0a6f$var$K & 2) || a !== $9c351ca3251b0a6f$var$Q) a === $9c351ca3251b0a6f$var$Q && (0 === ($9c351ca3251b0a6f$var$K & 2) && ($9c351ca3251b0a6f$var$qk |= c), 4 === $9c351ca3251b0a6f$var$T && $9c351ca3251b0a6f$var$Ck(a, $9c351ca3251b0a6f$var$Z)), $9c351ca3251b0a6f$var$Dk(a, d), 1 === c && 0 === $9c351ca3251b0a6f$var$K && 0 === (b.mode & 1) && ($9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$fg && $9c351ca3251b0a6f$var$jg());
}
function $9c351ca3251b0a6f$var$Dk(a, b) {
    var c = a.callbackNode;
    $9c351ca3251b0a6f$var$wc(a, b);
    var d = $9c351ca3251b0a6f$var$uc(a, a === $9c351ca3251b0a6f$var$Q ? $9c351ca3251b0a6f$var$Z : 0);
    if (0 === d) null !== c && $9c351ca3251b0a6f$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $9c351ca3251b0a6f$var$bc(c);
        if (1 === b) 0 === a.tag ? $9c351ca3251b0a6f$var$ig($9c351ca3251b0a6f$var$Ek.bind(null, a)) : $9c351ca3251b0a6f$var$hg($9c351ca3251b0a6f$var$Ek.bind(null, a)), $9c351ca3251b0a6f$var$Jf(function() {
            0 === ($9c351ca3251b0a6f$var$K & 6) && $9c351ca3251b0a6f$var$jg();
        }), c = null;
        else {
            switch($9c351ca3251b0a6f$var$Dc(d)){
                case 1:
                    c = $9c351ca3251b0a6f$var$fc;
                    break;
                case 4:
                    c = $9c351ca3251b0a6f$var$gc;
                    break;
                case 16:
                    c = $9c351ca3251b0a6f$var$hc;
                    break;
                case 536870912:
                    c = $9c351ca3251b0a6f$var$jc;
                    break;
                default:
                    c = $9c351ca3251b0a6f$var$hc;
            }
            c = $9c351ca3251b0a6f$var$Fk(c, $9c351ca3251b0a6f$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $9c351ca3251b0a6f$var$Gk(a, b) {
    $9c351ca3251b0a6f$var$Ak = -1;
    $9c351ca3251b0a6f$var$Bk = 0;
    if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(327));
    var c = a.callbackNode;
    if ($9c351ca3251b0a6f$var$Hk() && a.callbackNode !== c) return null;
    var d = $9c351ca3251b0a6f$var$uc(a, a === $9c351ca3251b0a6f$var$Q ? $9c351ca3251b0a6f$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $9c351ca3251b0a6f$var$Ik(a, d);
    else {
        b = d;
        var e = $9c351ca3251b0a6f$var$K;
        $9c351ca3251b0a6f$var$K |= 2;
        var f = $9c351ca3251b0a6f$var$Jk();
        if ($9c351ca3251b0a6f$var$Q !== a || $9c351ca3251b0a6f$var$Z !== b) $9c351ca3251b0a6f$var$uk = null, $9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$Kk(a, b);
        for(;;)try {
            $9c351ca3251b0a6f$var$Lk();
            break;
        } catch (h) {
            $9c351ca3251b0a6f$var$Mk(a, h);
        }
        $9c351ca3251b0a6f$var$$g();
        $9c351ca3251b0a6f$var$mk.current = f;
        $9c351ca3251b0a6f$var$K = e;
        null !== $9c351ca3251b0a6f$var$Y ? b = 0 : ($9c351ca3251b0a6f$var$Q = null, $9c351ca3251b0a6f$var$Z = 0, b = $9c351ca3251b0a6f$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $9c351ca3251b0a6f$var$xc(a), 0 !== e && (d = e, b = $9c351ca3251b0a6f$var$Nk(a, e)));
        if (1 === b) throw c = $9c351ca3251b0a6f$var$pk, $9c351ca3251b0a6f$var$Kk(a, 0), $9c351ca3251b0a6f$var$Ck(a, d), $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), c;
        if (6 === b) $9c351ca3251b0a6f$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$9c351ca3251b0a6f$var$Ok(e) && (b = $9c351ca3251b0a6f$var$Ik(a, d), 2 === b && (f = $9c351ca3251b0a6f$var$xc(a), 0 !== f && (d = f, b = $9c351ca3251b0a6f$var$Nk(a, f))), 1 === b)) throw c = $9c351ca3251b0a6f$var$pk, $9c351ca3251b0a6f$var$Kk(a, 0), $9c351ca3251b0a6f$var$Ck(a, d), $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($9c351ca3251b0a6f$var$p(345));
                case 2:
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                case 3:
                    $9c351ca3251b0a6f$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $9c351ca3251b0a6f$var$fk + 500 - $9c351ca3251b0a6f$var$B(), 10 < b)) {
                        if (0 !== $9c351ca3251b0a6f$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $9c351ca3251b0a6f$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $9c351ca3251b0a6f$var$Ff($9c351ca3251b0a6f$var$Pk.bind(null, a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk), b);
                        break;
                    }
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                case 4:
                    $9c351ca3251b0a6f$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $9c351ca3251b0a6f$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $9c351ca3251b0a6f$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $9c351ca3251b0a6f$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $9c351ca3251b0a6f$var$Ff($9c351ca3251b0a6f$var$Pk.bind(null, a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk), d);
                        break;
                    }
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                case 5:
                    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
                    break;
                default:
                    throw Error($9c351ca3251b0a6f$var$p(329));
            }
        }
    }
    $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B());
    return a.callbackNode === c ? $9c351ca3251b0a6f$var$Gk.bind(null, a) : null;
}
function $9c351ca3251b0a6f$var$Nk(a, b) {
    var c = $9c351ca3251b0a6f$var$sk;
    a.current.memoizedState.isDehydrated && ($9c351ca3251b0a6f$var$Kk(a, b).flags |= 256);
    a = $9c351ca3251b0a6f$var$Ik(a, b);
    2 !== a && (b = $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$tk = c, null !== b && $9c351ca3251b0a6f$var$Fj(b));
    return a;
}
function $9c351ca3251b0a6f$var$Fj(a) {
    null === $9c351ca3251b0a6f$var$tk ? $9c351ca3251b0a6f$var$tk = a : $9c351ca3251b0a6f$var$tk.push.apply($9c351ca3251b0a6f$var$tk, a);
}
function $9c351ca3251b0a6f$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$9c351ca3251b0a6f$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $9c351ca3251b0a6f$var$Ck(a, b) {
    b &= ~$9c351ca3251b0a6f$var$rk;
    b &= ~$9c351ca3251b0a6f$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $9c351ca3251b0a6f$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $9c351ca3251b0a6f$var$Ek(a) {
    if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(327));
    $9c351ca3251b0a6f$var$Hk();
    var b = $9c351ca3251b0a6f$var$uc(a, 0);
    if (0 === (b & 1)) return $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), null;
    var c = $9c351ca3251b0a6f$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $9c351ca3251b0a6f$var$xc(a);
        0 !== d && (b = d, c = $9c351ca3251b0a6f$var$Nk(a, d));
    }
    if (1 === c) throw c = $9c351ca3251b0a6f$var$pk, $9c351ca3251b0a6f$var$Kk(a, 0), $9c351ca3251b0a6f$var$Ck(a, b), $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B()), c;
    if (6 === c) throw Error($9c351ca3251b0a6f$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $9c351ca3251b0a6f$var$Pk(a, $9c351ca3251b0a6f$var$tk, $9c351ca3251b0a6f$var$uk);
    $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B());
    return null;
}
function $9c351ca3251b0a6f$var$Qk(a, b) {
    var c = $9c351ca3251b0a6f$var$K;
    $9c351ca3251b0a6f$var$K |= 1;
    try {
        return a(b);
    } finally{
        $9c351ca3251b0a6f$var$K = c, 0 === $9c351ca3251b0a6f$var$K && ($9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$fg && $9c351ca3251b0a6f$var$jg());
    }
}
function $9c351ca3251b0a6f$var$Rk(a) {
    null !== $9c351ca3251b0a6f$var$wk && 0 === $9c351ca3251b0a6f$var$wk.tag && 0 === ($9c351ca3251b0a6f$var$K & 6) && $9c351ca3251b0a6f$var$Hk();
    var b = $9c351ca3251b0a6f$var$K;
    $9c351ca3251b0a6f$var$K |= 1;
    var c = $9c351ca3251b0a6f$var$ok.transition, d = $9c351ca3251b0a6f$var$C;
    try {
        if ($9c351ca3251b0a6f$var$ok.transition = null, $9c351ca3251b0a6f$var$C = 1, a) return a();
    } finally{
        $9c351ca3251b0a6f$var$C = d, $9c351ca3251b0a6f$var$ok.transition = c, $9c351ca3251b0a6f$var$K = b, 0 === ($9c351ca3251b0a6f$var$K & 6) && $9c351ca3251b0a6f$var$jg();
    }
}
function $9c351ca3251b0a6f$var$Hj() {
    $9c351ca3251b0a6f$var$fj = $9c351ca3251b0a6f$var$ej.current;
    $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$ej);
}
function $9c351ca3251b0a6f$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $9c351ca3251b0a6f$var$Gf(c));
    if (null !== $9c351ca3251b0a6f$var$Y) for(c = $9c351ca3251b0a6f$var$Y.return; null !== c;){
        var d = c;
        $9c351ca3251b0a6f$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $9c351ca3251b0a6f$var$$f();
                break;
            case 3:
                $9c351ca3251b0a6f$var$zh();
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$Wf);
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$H);
                $9c351ca3251b0a6f$var$Eh();
                break;
            case 5:
                $9c351ca3251b0a6f$var$Bh(d);
                break;
            case 4:
                $9c351ca3251b0a6f$var$zh();
                break;
            case 13:
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
                break;
            case 19:
                $9c351ca3251b0a6f$var$E($9c351ca3251b0a6f$var$L);
                break;
            case 10:
                $9c351ca3251b0a6f$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $9c351ca3251b0a6f$var$Hj();
        }
        c = c.return;
    }
    $9c351ca3251b0a6f$var$Q = a;
    $9c351ca3251b0a6f$var$Y = a = $9c351ca3251b0a6f$var$Pg(a.current, null);
    $9c351ca3251b0a6f$var$Z = $9c351ca3251b0a6f$var$fj = b;
    $9c351ca3251b0a6f$var$T = 0;
    $9c351ca3251b0a6f$var$pk = null;
    $9c351ca3251b0a6f$var$rk = $9c351ca3251b0a6f$var$qk = $9c351ca3251b0a6f$var$rh = 0;
    $9c351ca3251b0a6f$var$tk = $9c351ca3251b0a6f$var$sk = null;
    if (null !== $9c351ca3251b0a6f$var$fh) {
        for(b = 0; b < $9c351ca3251b0a6f$var$fh.length; b++)if (c = $9c351ca3251b0a6f$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $9c351ca3251b0a6f$var$fh = null;
    }
    return a;
}
function $9c351ca3251b0a6f$var$Mk(a, b) {
    do {
        var c = $9c351ca3251b0a6f$var$Y;
        try {
            $9c351ca3251b0a6f$var$$g();
            $9c351ca3251b0a6f$var$Fh.current = $9c351ca3251b0a6f$var$Rh;
            if ($9c351ca3251b0a6f$var$Ih) {
                for(var d = $9c351ca3251b0a6f$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $9c351ca3251b0a6f$var$Ih = !1;
            }
            $9c351ca3251b0a6f$var$Hh = 0;
            $9c351ca3251b0a6f$var$O = $9c351ca3251b0a6f$var$N = $9c351ca3251b0a6f$var$M = null;
            $9c351ca3251b0a6f$var$Jh = !1;
            $9c351ca3251b0a6f$var$Kh = 0;
            $9c351ca3251b0a6f$var$nk.current = null;
            if (null === c || null === c.return) {
                $9c351ca3251b0a6f$var$T = 1;
                $9c351ca3251b0a6f$var$pk = b;
                $9c351ca3251b0a6f$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $9c351ca3251b0a6f$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $9c351ca3251b0a6f$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $9c351ca3251b0a6f$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $9c351ca3251b0a6f$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $9c351ca3251b0a6f$var$Si(f, l, b);
                            $9c351ca3251b0a6f$var$tj();
                            break a;
                        }
                        k = Error($9c351ca3251b0a6f$var$p(426));
                    }
                } else if ($9c351ca3251b0a6f$var$I && h.mode & 1) {
                    var J = $9c351ca3251b0a6f$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $9c351ca3251b0a6f$var$Vi(J, g, h, f, b);
                        $9c351ca3251b0a6f$var$Jg($9c351ca3251b0a6f$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $9c351ca3251b0a6f$var$Ji(k, h);
                4 !== $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$T = 2);
                null === $9c351ca3251b0a6f$var$sk ? $9c351ca3251b0a6f$var$sk = [
                    f
                ] : $9c351ca3251b0a6f$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $9c351ca3251b0a6f$var$Ni(f, k, b);
                            $9c351ca3251b0a6f$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $9c351ca3251b0a6f$var$Ri || !$9c351ca3251b0a6f$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $9c351ca3251b0a6f$var$Qi(f, h, b);
                                $9c351ca3251b0a6f$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $9c351ca3251b0a6f$var$Sk(c);
        } catch (na) {
            b = na;
            $9c351ca3251b0a6f$var$Y === c && null !== c && ($9c351ca3251b0a6f$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $9c351ca3251b0a6f$var$Jk() {
    var a = $9c351ca3251b0a6f$var$mk.current;
    $9c351ca3251b0a6f$var$mk.current = $9c351ca3251b0a6f$var$Rh;
    return null === a ? $9c351ca3251b0a6f$var$Rh : a;
}
function $9c351ca3251b0a6f$var$tj() {
    if (0 === $9c351ca3251b0a6f$var$T || 3 === $9c351ca3251b0a6f$var$T || 2 === $9c351ca3251b0a6f$var$T) $9c351ca3251b0a6f$var$T = 4;
    null === $9c351ca3251b0a6f$var$Q || 0 === ($9c351ca3251b0a6f$var$rh & 268435455) && 0 === ($9c351ca3251b0a6f$var$qk & 268435455) || $9c351ca3251b0a6f$var$Ck($9c351ca3251b0a6f$var$Q, $9c351ca3251b0a6f$var$Z);
}
function $9c351ca3251b0a6f$var$Ik(a, b) {
    var c = $9c351ca3251b0a6f$var$K;
    $9c351ca3251b0a6f$var$K |= 2;
    var d = $9c351ca3251b0a6f$var$Jk();
    if ($9c351ca3251b0a6f$var$Q !== a || $9c351ca3251b0a6f$var$Z !== b) $9c351ca3251b0a6f$var$uk = null, $9c351ca3251b0a6f$var$Kk(a, b);
    for(;;)try {
        $9c351ca3251b0a6f$var$Tk();
        break;
    } catch (e) {
        $9c351ca3251b0a6f$var$Mk(a, e);
    }
    $9c351ca3251b0a6f$var$$g();
    $9c351ca3251b0a6f$var$K = c;
    $9c351ca3251b0a6f$var$mk.current = d;
    if (null !== $9c351ca3251b0a6f$var$Y) throw Error($9c351ca3251b0a6f$var$p(261));
    $9c351ca3251b0a6f$var$Q = null;
    $9c351ca3251b0a6f$var$Z = 0;
    return $9c351ca3251b0a6f$var$T;
}
function $9c351ca3251b0a6f$var$Tk() {
    for(; null !== $9c351ca3251b0a6f$var$Y;)$9c351ca3251b0a6f$var$Uk($9c351ca3251b0a6f$var$Y);
}
function $9c351ca3251b0a6f$var$Lk() {
    for(; null !== $9c351ca3251b0a6f$var$Y && !$9c351ca3251b0a6f$var$cc();)$9c351ca3251b0a6f$var$Uk($9c351ca3251b0a6f$var$Y);
}
function $9c351ca3251b0a6f$var$Uk(a) {
    var b = $9c351ca3251b0a6f$var$Vk(a.alternate, a, $9c351ca3251b0a6f$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $9c351ca3251b0a6f$var$Sk(a) : $9c351ca3251b0a6f$var$Y = b;
    $9c351ca3251b0a6f$var$nk.current = null;
}
function $9c351ca3251b0a6f$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $9c351ca3251b0a6f$var$Ej(c, b, $9c351ca3251b0a6f$var$fj), null !== c) {
                $9c351ca3251b0a6f$var$Y = c;
                return;
            }
        } else {
            c = $9c351ca3251b0a6f$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $9c351ca3251b0a6f$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $9c351ca3251b0a6f$var$T = 6;
                $9c351ca3251b0a6f$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $9c351ca3251b0a6f$var$Y = b;
            return;
        }
        $9c351ca3251b0a6f$var$Y = b = a;
    }while (null !== b);
    0 === $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$T = 5);
}
function $9c351ca3251b0a6f$var$Pk(a, b, c) {
    var d = $9c351ca3251b0a6f$var$C, e = $9c351ca3251b0a6f$var$ok.transition;
    try {
        $9c351ca3251b0a6f$var$ok.transition = null, $9c351ca3251b0a6f$var$C = 1, $9c351ca3251b0a6f$var$Wk(a, b, c, d);
    } finally{
        $9c351ca3251b0a6f$var$ok.transition = e, $9c351ca3251b0a6f$var$C = d;
    }
    return null;
}
function $9c351ca3251b0a6f$var$Wk(a, b, c, d) {
    do $9c351ca3251b0a6f$var$Hk();
    while (null !== $9c351ca3251b0a6f$var$wk);
    if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($9c351ca3251b0a6f$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $9c351ca3251b0a6f$var$Bc(a, f);
    a === $9c351ca3251b0a6f$var$Q && ($9c351ca3251b0a6f$var$Y = $9c351ca3251b0a6f$var$Q = null, $9c351ca3251b0a6f$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $9c351ca3251b0a6f$var$vk || ($9c351ca3251b0a6f$var$vk = !0, $9c351ca3251b0a6f$var$Fk($9c351ca3251b0a6f$var$hc, function() {
        $9c351ca3251b0a6f$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $9c351ca3251b0a6f$var$ok.transition;
        $9c351ca3251b0a6f$var$ok.transition = null;
        var g = $9c351ca3251b0a6f$var$C;
        $9c351ca3251b0a6f$var$C = 1;
        var h = $9c351ca3251b0a6f$var$K;
        $9c351ca3251b0a6f$var$K |= 4;
        $9c351ca3251b0a6f$var$nk.current = null;
        $9c351ca3251b0a6f$var$Oj(a, c);
        $9c351ca3251b0a6f$var$dk(c, a);
        $9c351ca3251b0a6f$var$Oe($9c351ca3251b0a6f$var$Df);
        $9c351ca3251b0a6f$var$dd = !!$9c351ca3251b0a6f$var$Cf;
        $9c351ca3251b0a6f$var$Df = $9c351ca3251b0a6f$var$Cf = null;
        a.current = c;
        $9c351ca3251b0a6f$var$hk(c, a, e);
        $9c351ca3251b0a6f$var$dc();
        $9c351ca3251b0a6f$var$K = h;
        $9c351ca3251b0a6f$var$C = g;
        $9c351ca3251b0a6f$var$ok.transition = f;
    } else a.current = c;
    $9c351ca3251b0a6f$var$vk && ($9c351ca3251b0a6f$var$vk = !1, $9c351ca3251b0a6f$var$wk = a, $9c351ca3251b0a6f$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($9c351ca3251b0a6f$var$Ri = null);
    $9c351ca3251b0a6f$var$mc(c.stateNode, d);
    $9c351ca3251b0a6f$var$Dk(a, $9c351ca3251b0a6f$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($9c351ca3251b0a6f$var$Oi) throw $9c351ca3251b0a6f$var$Oi = !1, a = $9c351ca3251b0a6f$var$Pi, $9c351ca3251b0a6f$var$Pi = null, a;
    0 !== ($9c351ca3251b0a6f$var$xk & 1) && 0 !== a.tag && $9c351ca3251b0a6f$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $9c351ca3251b0a6f$var$zk ? $9c351ca3251b0a6f$var$yk++ : ($9c351ca3251b0a6f$var$yk = 0, $9c351ca3251b0a6f$var$zk = a) : $9c351ca3251b0a6f$var$yk = 0;
    $9c351ca3251b0a6f$var$jg();
    return null;
}
function $9c351ca3251b0a6f$var$Hk() {
    if (null !== $9c351ca3251b0a6f$var$wk) {
        var a = $9c351ca3251b0a6f$var$Dc($9c351ca3251b0a6f$var$xk), b = $9c351ca3251b0a6f$var$ok.transition, c = $9c351ca3251b0a6f$var$C;
        try {
            $9c351ca3251b0a6f$var$ok.transition = null;
            $9c351ca3251b0a6f$var$C = 16 > a ? 16 : a;
            if (null === $9c351ca3251b0a6f$var$wk) var d = !1;
            else {
                a = $9c351ca3251b0a6f$var$wk;
                $9c351ca3251b0a6f$var$wk = null;
                $9c351ca3251b0a6f$var$xk = 0;
                if (0 !== ($9c351ca3251b0a6f$var$K & 6)) throw Error($9c351ca3251b0a6f$var$p(331));
                var e = $9c351ca3251b0a6f$var$K;
                $9c351ca3251b0a6f$var$K |= 4;
                for($9c351ca3251b0a6f$var$V = a.current; null !== $9c351ca3251b0a6f$var$V;){
                    var f = $9c351ca3251b0a6f$var$V, g = f.child;
                    if (0 !== ($9c351ca3251b0a6f$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($9c351ca3251b0a6f$var$V = l; null !== $9c351ca3251b0a6f$var$V;){
                                    var m = $9c351ca3251b0a6f$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $9c351ca3251b0a6f$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $9c351ca3251b0a6f$var$V = q;
                                    else for(; null !== $9c351ca3251b0a6f$var$V;){
                                        m = $9c351ca3251b0a6f$var$V;
                                        var r = m.sibling, y = m.return;
                                        $9c351ca3251b0a6f$var$Sj(m);
                                        if (m === l) {
                                            $9c351ca3251b0a6f$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $9c351ca3251b0a6f$var$V = r;
                                            break;
                                        }
                                        $9c351ca3251b0a6f$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $9c351ca3251b0a6f$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $9c351ca3251b0a6f$var$V = g;
                    else b: for(; null !== $9c351ca3251b0a6f$var$V;){
                        f = $9c351ca3251b0a6f$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $9c351ca3251b0a6f$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $9c351ca3251b0a6f$var$V = x;
                            break b;
                        }
                        $9c351ca3251b0a6f$var$V = f.return;
                    }
                }
                var w = a.current;
                for($9c351ca3251b0a6f$var$V = w; null !== $9c351ca3251b0a6f$var$V;){
                    g = $9c351ca3251b0a6f$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $9c351ca3251b0a6f$var$V = u;
                    else b: for(g = w; null !== $9c351ca3251b0a6f$var$V;){
                        h = $9c351ca3251b0a6f$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $9c351ca3251b0a6f$var$Qj(9, h);
                            }
                        } catch (na) {
                            $9c351ca3251b0a6f$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $9c351ca3251b0a6f$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $9c351ca3251b0a6f$var$V = F;
                            break b;
                        }
                        $9c351ca3251b0a6f$var$V = h.return;
                    }
                }
                $9c351ca3251b0a6f$var$K = e;
                $9c351ca3251b0a6f$var$jg();
                if ($9c351ca3251b0a6f$var$lc && "function" === typeof $9c351ca3251b0a6f$var$lc.onPostCommitFiberRoot) try {
                    $9c351ca3251b0a6f$var$lc.onPostCommitFiberRoot($9c351ca3251b0a6f$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $9c351ca3251b0a6f$var$C = c, $9c351ca3251b0a6f$var$ok.transition = b;
        }
    }
    return !1;
}
function $9c351ca3251b0a6f$var$Xk(a, b, c) {
    b = $9c351ca3251b0a6f$var$Ji(c, b);
    b = $9c351ca3251b0a6f$var$Ni(a, b, 1);
    a = $9c351ca3251b0a6f$var$nh(a, b, 1);
    b = $9c351ca3251b0a6f$var$R();
    null !== a && ($9c351ca3251b0a6f$var$Ac(a, 1, b), $9c351ca3251b0a6f$var$Dk(a, b));
}
function $9c351ca3251b0a6f$var$W(a, b, c) {
    if (3 === a.tag) $9c351ca3251b0a6f$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $9c351ca3251b0a6f$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $9c351ca3251b0a6f$var$Ri || !$9c351ca3251b0a6f$var$Ri.has(d))) {
                a = $9c351ca3251b0a6f$var$Ji(c, a);
                a = $9c351ca3251b0a6f$var$Qi(b, a, 1);
                b = $9c351ca3251b0a6f$var$nh(b, a, 1);
                a = $9c351ca3251b0a6f$var$R();
                null !== b && ($9c351ca3251b0a6f$var$Ac(b, 1, a), $9c351ca3251b0a6f$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $9c351ca3251b0a6f$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $9c351ca3251b0a6f$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $9c351ca3251b0a6f$var$Q === a && ($9c351ca3251b0a6f$var$Z & c) === c && (4 === $9c351ca3251b0a6f$var$T || 3 === $9c351ca3251b0a6f$var$T && ($9c351ca3251b0a6f$var$Z & 130023424) === $9c351ca3251b0a6f$var$Z && 500 > $9c351ca3251b0a6f$var$B() - $9c351ca3251b0a6f$var$fk ? $9c351ca3251b0a6f$var$Kk(a, 0) : $9c351ca3251b0a6f$var$rk |= c);
    $9c351ca3251b0a6f$var$Dk(a, b);
}
function $9c351ca3251b0a6f$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $9c351ca3251b0a6f$var$sc, $9c351ca3251b0a6f$var$sc <<= 1, 0 === ($9c351ca3251b0a6f$var$sc & 130023424) && ($9c351ca3251b0a6f$var$sc = 4194304)));
    var c = $9c351ca3251b0a6f$var$R();
    a = $9c351ca3251b0a6f$var$ih(a, b);
    null !== a && ($9c351ca3251b0a6f$var$Ac(a, b, c), $9c351ca3251b0a6f$var$Dk(a, c));
}
function $9c351ca3251b0a6f$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $9c351ca3251b0a6f$var$Yk(a, c);
}
function $9c351ca3251b0a6f$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($9c351ca3251b0a6f$var$p(314));
    }
    null !== d && d.delete(b);
    $9c351ca3251b0a6f$var$Yk(a, c);
}
var $9c351ca3251b0a6f$var$Vk;
$9c351ca3251b0a6f$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $9c351ca3251b0a6f$var$Wf.current) $9c351ca3251b0a6f$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $9c351ca3251b0a6f$var$dh = !1, $9c351ca3251b0a6f$var$yj(a, b, c);
            $9c351ca3251b0a6f$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $9c351ca3251b0a6f$var$dh = !1, $9c351ca3251b0a6f$var$I && 0 !== (b.flags & 1048576) && $9c351ca3251b0a6f$var$ug(b, $9c351ca3251b0a6f$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $9c351ca3251b0a6f$var$ij(a, b);
            a = b.pendingProps;
            var e = $9c351ca3251b0a6f$var$Yf(b, $9c351ca3251b0a6f$var$H.current);
            $9c351ca3251b0a6f$var$ch(b, c);
            e = $9c351ca3251b0a6f$var$Nh(null, b, d, a, e, c);
            var f = $9c351ca3251b0a6f$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $9c351ca3251b0a6f$var$Zf(d) ? (f = !0, $9c351ca3251b0a6f$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $9c351ca3251b0a6f$var$kh(b), e.updater = $9c351ca3251b0a6f$var$Ei, b.stateNode = e, e._reactInternals = b, $9c351ca3251b0a6f$var$Ii(b, d, a, c), b = $9c351ca3251b0a6f$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $9c351ca3251b0a6f$var$I && f && $9c351ca3251b0a6f$var$vg(b), $9c351ca3251b0a6f$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $9c351ca3251b0a6f$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $9c351ca3251b0a6f$var$Zk(d);
                a = $9c351ca3251b0a6f$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $9c351ca3251b0a6f$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $9c351ca3251b0a6f$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $9c351ca3251b0a6f$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $9c351ca3251b0a6f$var$$i(null, b, d, $9c351ca3251b0a6f$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($9c351ca3251b0a6f$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $9c351ca3251b0a6f$var$kj(b);
                if (null === a) throw Error($9c351ca3251b0a6f$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $9c351ca3251b0a6f$var$lh(a, b);
                $9c351ca3251b0a6f$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $9c351ca3251b0a6f$var$Ji(Error($9c351ca3251b0a6f$var$p(423)), b);
                        b = $9c351ca3251b0a6f$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $9c351ca3251b0a6f$var$Ji(Error($9c351ca3251b0a6f$var$p(424)), b);
                        b = $9c351ca3251b0a6f$var$lj(a, b, d, c, e);
                        break a;
                    } else for($9c351ca3251b0a6f$var$yg = $9c351ca3251b0a6f$var$Lf(b.stateNode.containerInfo.firstChild), $9c351ca3251b0a6f$var$xg = b, $9c351ca3251b0a6f$var$I = !0, $9c351ca3251b0a6f$var$zg = null, c = $9c351ca3251b0a6f$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $9c351ca3251b0a6f$var$Ig();
                    if (d === e) {
                        b = $9c351ca3251b0a6f$var$Zi(a, b, c);
                        break a;
                    }
                    $9c351ca3251b0a6f$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $9c351ca3251b0a6f$var$Ah(b), null === a && $9c351ca3251b0a6f$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $9c351ca3251b0a6f$var$Ef(d, e) ? g = null : null !== f && $9c351ca3251b0a6f$var$Ef(d, f) && (b.flags |= 32), $9c351ca3251b0a6f$var$gj(a, b), $9c351ca3251b0a6f$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $9c351ca3251b0a6f$var$Eg(b), null;
        case 13:
            return $9c351ca3251b0a6f$var$oj(a, b, c);
        case 4:
            return $9c351ca3251b0a6f$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $9c351ca3251b0a6f$var$Ug(b, null, d, c) : $9c351ca3251b0a6f$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$Yi(a, b, d, e, c);
        case 7:
            return $9c351ca3251b0a6f$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $9c351ca3251b0a6f$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $9c351ca3251b0a6f$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $9c351ca3251b0a6f$var$G($9c351ca3251b0a6f$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($9c351ca3251b0a6f$var$He(f.value, g)) {
                        if (f.children === e.children && !$9c351ca3251b0a6f$var$Wf.current) {
                            b = $9c351ca3251b0a6f$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $9c351ca3251b0a6f$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $9c351ca3251b0a6f$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($9c351ca3251b0a6f$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $9c351ca3251b0a6f$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $9c351ca3251b0a6f$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $9c351ca3251b0a6f$var$ch(b, c), e = $9c351ca3251b0a6f$var$eh(e), d = d(e), b.flags |= 1, $9c351ca3251b0a6f$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $9c351ca3251b0a6f$var$Ci(d, b.pendingProps), e = $9c351ca3251b0a6f$var$Ci(d.type, e), $9c351ca3251b0a6f$var$$i(a, b, d, e, c);
        case 15:
            return $9c351ca3251b0a6f$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $9c351ca3251b0a6f$var$Ci(d, e), $9c351ca3251b0a6f$var$ij(a, b), b.tag = 1, $9c351ca3251b0a6f$var$Zf(d) ? (a = !0, $9c351ca3251b0a6f$var$cg(b)) : a = !1, $9c351ca3251b0a6f$var$ch(b, c), $9c351ca3251b0a6f$var$Gi(b, d, e), $9c351ca3251b0a6f$var$Ii(b, d, e, c), $9c351ca3251b0a6f$var$jj(null, b, d, !0, a, c);
        case 19:
            return $9c351ca3251b0a6f$var$xj(a, b, c);
        case 22:
            return $9c351ca3251b0a6f$var$dj(a, b, c);
    }
    throw Error($9c351ca3251b0a6f$var$p(156, b.tag));
};
function $9c351ca3251b0a6f$var$Fk(a, b) {
    return $9c351ca3251b0a6f$var$ac(a, b);
}
function $9c351ca3251b0a6f$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $9c351ca3251b0a6f$var$Bg(a, b, c, d) {
    return new $9c351ca3251b0a6f$var$$k(a, b, c, d);
}
function $9c351ca3251b0a6f$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $9c351ca3251b0a6f$var$Zk(a) {
    if ("function" === typeof a) return $9c351ca3251b0a6f$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $9c351ca3251b0a6f$var$Da) return 11;
        if (a === $9c351ca3251b0a6f$var$Ga) return 14;
    }
    return 2;
}
function $9c351ca3251b0a6f$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $9c351ca3251b0a6f$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $9c351ca3251b0a6f$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $9c351ca3251b0a6f$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $9c351ca3251b0a6f$var$ya:
            return $9c351ca3251b0a6f$var$Tg(c.children, e, f, b);
        case $9c351ca3251b0a6f$var$za:
            g = 8;
            e |= 8;
            break;
        case $9c351ca3251b0a6f$var$Aa:
            return a = $9c351ca3251b0a6f$var$Bg(12, c, b, e | 2), a.elementType = $9c351ca3251b0a6f$var$Aa, a.lanes = f, a;
        case $9c351ca3251b0a6f$var$Ea:
            return a = $9c351ca3251b0a6f$var$Bg(13, c, b, e), a.elementType = $9c351ca3251b0a6f$var$Ea, a.lanes = f, a;
        case $9c351ca3251b0a6f$var$Fa:
            return a = $9c351ca3251b0a6f$var$Bg(19, c, b, e), a.elementType = $9c351ca3251b0a6f$var$Fa, a.lanes = f, a;
        case $9c351ca3251b0a6f$var$Ia:
            return $9c351ca3251b0a6f$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $9c351ca3251b0a6f$var$Ba:
                    g = 10;
                    break a;
                case $9c351ca3251b0a6f$var$Ca:
                    g = 9;
                    break a;
                case $9c351ca3251b0a6f$var$Da:
                    g = 11;
                    break a;
                case $9c351ca3251b0a6f$var$Ga:
                    g = 14;
                    break a;
                case $9c351ca3251b0a6f$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($9c351ca3251b0a6f$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $9c351ca3251b0a6f$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $9c351ca3251b0a6f$var$Tg(a, b, c, d) {
    a = $9c351ca3251b0a6f$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $9c351ca3251b0a6f$var$pj(a, b, c, d) {
    a = $9c351ca3251b0a6f$var$Bg(22, a, d, b);
    a.elementType = $9c351ca3251b0a6f$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $9c351ca3251b0a6f$var$Qg(a, b, c) {
    a = $9c351ca3251b0a6f$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $9c351ca3251b0a6f$var$Sg(a, b, c) {
    b = $9c351ca3251b0a6f$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $9c351ca3251b0a6f$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $9c351ca3251b0a6f$var$zc(0);
    this.expirationTimes = $9c351ca3251b0a6f$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $9c351ca3251b0a6f$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $9c351ca3251b0a6f$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $9c351ca3251b0a6f$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $9c351ca3251b0a6f$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $9c351ca3251b0a6f$var$kh(f);
    return a;
}
function $9c351ca3251b0a6f$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $9c351ca3251b0a6f$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $9c351ca3251b0a6f$var$dl(a) {
    if (!a) return $9c351ca3251b0a6f$var$Vf;
    a = a._reactInternals;
    a: {
        if ($9c351ca3251b0a6f$var$Vb(a) !== a || 1 !== a.tag) throw Error($9c351ca3251b0a6f$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($9c351ca3251b0a6f$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($9c351ca3251b0a6f$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($9c351ca3251b0a6f$var$Zf(c)) return $9c351ca3251b0a6f$var$bg(a, c, b);
    }
    return b;
}
function $9c351ca3251b0a6f$var$el(a, b, c, d, e, f, g, h, k) {
    a = $9c351ca3251b0a6f$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $9c351ca3251b0a6f$var$dl(null);
    c = a.current;
    d = $9c351ca3251b0a6f$var$R();
    e = $9c351ca3251b0a6f$var$yi(c);
    f = $9c351ca3251b0a6f$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $9c351ca3251b0a6f$var$nh(c, f, e);
    a.current.lanes = e;
    $9c351ca3251b0a6f$var$Ac(a, e, d);
    $9c351ca3251b0a6f$var$Dk(a, d);
    return a;
}
function $9c351ca3251b0a6f$var$fl(a, b, c, d) {
    var e = b.current, f = $9c351ca3251b0a6f$var$R(), g = $9c351ca3251b0a6f$var$yi(e);
    c = $9c351ca3251b0a6f$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $9c351ca3251b0a6f$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $9c351ca3251b0a6f$var$nh(e, b, g);
    null !== a && ($9c351ca3251b0a6f$var$gi(a, e, g, f), $9c351ca3251b0a6f$var$oh(a, e, g));
    return g;
}
function $9c351ca3251b0a6f$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $9c351ca3251b0a6f$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $9c351ca3251b0a6f$var$il(a, b) {
    $9c351ca3251b0a6f$var$hl(a, b);
    (a = a.alternate) && $9c351ca3251b0a6f$var$hl(a, b);
}
function $9c351ca3251b0a6f$var$jl() {
    return null;
}
var $9c351ca3251b0a6f$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $9c351ca3251b0a6f$var$ll(a) {
    this._internalRoot = a;
}
$9c351ca3251b0a6f$var$ml.prototype.render = $9c351ca3251b0a6f$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($9c351ca3251b0a6f$var$p(409));
    $9c351ca3251b0a6f$var$fl(a, b, null, null);
};
$9c351ca3251b0a6f$var$ml.prototype.unmount = $9c351ca3251b0a6f$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $9c351ca3251b0a6f$var$Rk(function() {
            $9c351ca3251b0a6f$var$fl(null, a, null, null);
        });
        b[$9c351ca3251b0a6f$var$uf] = null;
    }
};
function $9c351ca3251b0a6f$var$ml(a) {
    this._internalRoot = a;
}
$9c351ca3251b0a6f$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $9c351ca3251b0a6f$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $9c351ca3251b0a6f$var$Qc.length && 0 !== b && b < $9c351ca3251b0a6f$var$Qc[c].priority; c++);
        $9c351ca3251b0a6f$var$Qc.splice(c, 0, a);
        0 === c && $9c351ca3251b0a6f$var$Vc(a);
    }
};
function $9c351ca3251b0a6f$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $9c351ca3251b0a6f$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $9c351ca3251b0a6f$var$pl() {}
function $9c351ca3251b0a6f$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $9c351ca3251b0a6f$var$gl(g);
                f.call(a);
            };
        }
        var g = $9c351ca3251b0a6f$var$el(b, d, a, 0, null, !1, !1, "", $9c351ca3251b0a6f$var$pl);
        a._reactRootContainer = g;
        a[$9c351ca3251b0a6f$var$uf] = g.current;
        $9c351ca3251b0a6f$var$sf(8 === a.nodeType ? a.parentNode : a);
        $9c351ca3251b0a6f$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $9c351ca3251b0a6f$var$gl(k);
            h.call(a);
        };
    }
    var k = $9c351ca3251b0a6f$var$bl(a, 0, !1, null, null, !1, !1, "", $9c351ca3251b0a6f$var$pl);
    a._reactRootContainer = k;
    a[$9c351ca3251b0a6f$var$uf] = k.current;
    $9c351ca3251b0a6f$var$sf(8 === a.nodeType ? a.parentNode : a);
    $9c351ca3251b0a6f$var$Rk(function() {
        $9c351ca3251b0a6f$var$fl(b, k, c, d);
    });
    return k;
}
function $9c351ca3251b0a6f$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $9c351ca3251b0a6f$var$gl(g);
                h.call(a);
            };
        }
        $9c351ca3251b0a6f$var$fl(b, g, a, e);
    } else g = $9c351ca3251b0a6f$var$ql(c, b, a, e, d);
    return $9c351ca3251b0a6f$var$gl(g);
}
$9c351ca3251b0a6f$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $9c351ca3251b0a6f$var$tc(b.pendingLanes);
                0 !== c && ($9c351ca3251b0a6f$var$Cc(b, c | 1), $9c351ca3251b0a6f$var$Dk(b, $9c351ca3251b0a6f$var$B()), 0 === ($9c351ca3251b0a6f$var$K & 6) && ($9c351ca3251b0a6f$var$Gj = $9c351ca3251b0a6f$var$B() + 500, $9c351ca3251b0a6f$var$jg()));
            }
            break;
        case 13:
            $9c351ca3251b0a6f$var$Rk(function() {
                var b = $9c351ca3251b0a6f$var$ih(a, 1);
                if (null !== b) {
                    var c = $9c351ca3251b0a6f$var$R();
                    $9c351ca3251b0a6f$var$gi(b, a, 1, c);
                }
            }), $9c351ca3251b0a6f$var$il(a, 1);
    }
};
$9c351ca3251b0a6f$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $9c351ca3251b0a6f$var$ih(a, 134217728);
        if (null !== b) {
            var c = $9c351ca3251b0a6f$var$R();
            $9c351ca3251b0a6f$var$gi(b, a, 134217728, c);
        }
        $9c351ca3251b0a6f$var$il(a, 134217728);
    }
};
$9c351ca3251b0a6f$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $9c351ca3251b0a6f$var$yi(a), c = $9c351ca3251b0a6f$var$ih(a, b);
        if (null !== c) {
            var d = $9c351ca3251b0a6f$var$R();
            $9c351ca3251b0a6f$var$gi(c, a, b, d);
        }
        $9c351ca3251b0a6f$var$il(a, b);
    }
};
$9c351ca3251b0a6f$var$Hc = function() {
    return $9c351ca3251b0a6f$var$C;
};
$9c351ca3251b0a6f$var$Ic = function(a, b) {
    var c = $9c351ca3251b0a6f$var$C;
    try {
        return $9c351ca3251b0a6f$var$C = a, b();
    } finally{
        $9c351ca3251b0a6f$var$C = c;
    }
};
$9c351ca3251b0a6f$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $9c351ca3251b0a6f$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $9c351ca3251b0a6f$var$Db(d);
                        if (!e) throw Error($9c351ca3251b0a6f$var$p(90));
                        $9c351ca3251b0a6f$var$Wa(d);
                        $9c351ca3251b0a6f$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $9c351ca3251b0a6f$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $9c351ca3251b0a6f$var$fb(a, !!c.multiple, b, !1);
    }
};
$9c351ca3251b0a6f$var$Gb = $9c351ca3251b0a6f$var$Qk;
$9c351ca3251b0a6f$var$Hb = $9c351ca3251b0a6f$var$Rk;
var $9c351ca3251b0a6f$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $9c351ca3251b0a6f$var$Cb,
        $9c351ca3251b0a6f$var$ue,
        $9c351ca3251b0a6f$var$Db,
        $9c351ca3251b0a6f$var$Eb,
        $9c351ca3251b0a6f$var$Fb,
        $9c351ca3251b0a6f$var$Qk
    ]
}, $9c351ca3251b0a6f$var$tl = {
    findFiberByHostInstance: $9c351ca3251b0a6f$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $9c351ca3251b0a6f$var$ul = {
    bundleType: $9c351ca3251b0a6f$var$tl.bundleType,
    version: $9c351ca3251b0a6f$var$tl.version,
    rendererPackageName: $9c351ca3251b0a6f$var$tl.rendererPackageName,
    rendererConfig: $9c351ca3251b0a6f$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $9c351ca3251b0a6f$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $9c351ca3251b0a6f$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $9c351ca3251b0a6f$var$tl.findFiberByHostInstance || $9c351ca3251b0a6f$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $9c351ca3251b0a6f$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$9c351ca3251b0a6f$var$vl.isDisabled && $9c351ca3251b0a6f$var$vl.supportsFiber) try {
        $9c351ca3251b0a6f$var$kc = $9c351ca3251b0a6f$var$vl.inject($9c351ca3251b0a6f$var$ul), $9c351ca3251b0a6f$var$lc = $9c351ca3251b0a6f$var$vl;
    } catch (a) {}
}
$9c351ca3251b0a6f$export$ae55be85d98224ed = $9c351ca3251b0a6f$var$sl;
$9c351ca3251b0a6f$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$9c351ca3251b0a6f$var$nl(b)) throw Error($9c351ca3251b0a6f$var$p(200));
    return $9c351ca3251b0a6f$var$cl(a, b, null, c);
};
$9c351ca3251b0a6f$export$882461b6382ed46c = function(a, b) {
    if (!$9c351ca3251b0a6f$var$nl(a)) throw Error($9c351ca3251b0a6f$var$p(299));
    var c = !1, d = "", e = $9c351ca3251b0a6f$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $9c351ca3251b0a6f$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$9c351ca3251b0a6f$var$uf] = b.current;
    $9c351ca3251b0a6f$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $9c351ca3251b0a6f$var$ll(b);
};
$9c351ca3251b0a6f$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($9c351ca3251b0a6f$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($9c351ca3251b0a6f$var$p(268, a));
    }
    a = $9c351ca3251b0a6f$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$9c351ca3251b0a6f$export$cd75ccfd720a3cd4 = function(a) {
    return $9c351ca3251b0a6f$var$Rk(a);
};
$9c351ca3251b0a6f$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$9c351ca3251b0a6f$var$ol(b)) throw Error($9c351ca3251b0a6f$var$p(200));
    return $9c351ca3251b0a6f$var$rl(null, a, b, !0, c);
};
$9c351ca3251b0a6f$export$757ceba2d55c277e = function(a, b, c) {
    if (!$9c351ca3251b0a6f$var$nl(a)) throw Error($9c351ca3251b0a6f$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $9c351ca3251b0a6f$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $9c351ca3251b0a6f$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$9c351ca3251b0a6f$var$uf] = b.current;
    $9c351ca3251b0a6f$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $9c351ca3251b0a6f$var$ml(b);
};
$9c351ca3251b0a6f$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$9c351ca3251b0a6f$var$ol(b)) throw Error($9c351ca3251b0a6f$var$p(200));
    return $9c351ca3251b0a6f$var$rl(null, a, b, !1, c);
};
$9c351ca3251b0a6f$export$502457920280e6be = function(a) {
    if (!$9c351ca3251b0a6f$var$ol(a)) throw Error($9c351ca3251b0a6f$var$p(40));
    return a._reactRootContainer ? ($9c351ca3251b0a6f$var$Rk(function() {
        $9c351ca3251b0a6f$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$9c351ca3251b0a6f$var$uf] = null;
        });
    }), !0) : !1;
};
$9c351ca3251b0a6f$export$c78a37762a8d58e1 = $9c351ca3251b0a6f$var$Qk;
$9c351ca3251b0a6f$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$9c351ca3251b0a6f$var$ol(c)) throw Error($9c351ca3251b0a6f$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($9c351ca3251b0a6f$var$p(38));
    return $9c351ca3251b0a6f$var$rl(a, b, c, !1, d);
};
$9c351ca3251b0a6f$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("4xoBZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5yJQ8"));

});
parcelRegister("5yJQ8", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $40c3af8d98807125$export$c4744153514ff05d, (v) => $40c3af8d98807125$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $40c3af8d98807125$export$3e506c1ccc9cc1a7, (v) => $40c3af8d98807125$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $40c3af8d98807125$export$e26fe2ed2fa76875, (v) => $40c3af8d98807125$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $40c3af8d98807125$export$502329bbf4b505b1, (v) => $40c3af8d98807125$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $40c3af8d98807125$export$6e3807111c4874c4, (v) => $40c3af8d98807125$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $40c3af8d98807125$export$c27134553091fb3a, (v) => $40c3af8d98807125$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $40c3af8d98807125$export$33ee1acdc04fd2a2, (v) => $40c3af8d98807125$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $40c3af8d98807125$export$b00a404bbd5edef2, (v) => $40c3af8d98807125$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $40c3af8d98807125$export$8352ce38b91d0c62, (v) => $40c3af8d98807125$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $40c3af8d98807125$export$d66a1c1c77bd778b, (v) => $40c3af8d98807125$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $40c3af8d98807125$export$d3dfb8e4810cb555, (v) => $40c3af8d98807125$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $40c3af8d98807125$export$839f9183b0465a69, (v) => $40c3af8d98807125$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $40c3af8d98807125$export$72fdf0e06517287b, (v) => $40c3af8d98807125$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $40c3af8d98807125$export$4b844e58a3e414b4, (v) => $40c3af8d98807125$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $40c3af8d98807125$export$816d2913ae6b83b1, (v) => $40c3af8d98807125$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $40c3af8d98807125$export$61bcfe829111a1d0, (v) => $40c3af8d98807125$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $40c3af8d98807125$export$7ee8c9beb337bc3f, (v) => $40c3af8d98807125$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $40c3af8d98807125$export$b5836b71941fa3ed, (v) => $40c3af8d98807125$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $40c3af8d98807125$export$cf845f2c119da08a, (v) => $40c3af8d98807125$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $40c3af8d98807125$export$c4744153514ff05d;
var $40c3af8d98807125$export$3e506c1ccc9cc1a7;
var $40c3af8d98807125$export$e26fe2ed2fa76875;
var $40c3af8d98807125$export$502329bbf4b505b1;
var $40c3af8d98807125$export$6e3807111c4874c4;
var $40c3af8d98807125$export$c27134553091fb3a;
var $40c3af8d98807125$export$33ee1acdc04fd2a2;
var $40c3af8d98807125$export$b00a404bbd5edef2;
var $40c3af8d98807125$export$8352ce38b91d0c62;
var $40c3af8d98807125$export$d66a1c1c77bd778b;
var $40c3af8d98807125$export$d3dfb8e4810cb555;
var $40c3af8d98807125$export$839f9183b0465a69;
var $40c3af8d98807125$export$72fdf0e06517287b;
var $40c3af8d98807125$export$4b844e58a3e414b4;
var $40c3af8d98807125$export$816d2913ae6b83b1;
var $40c3af8d98807125$export$61bcfe829111a1d0;
var $40c3af8d98807125$export$7ee8c9beb337bc3f;
var $40c3af8d98807125$export$b5836b71941fa3ed;
var $40c3af8d98807125$export$cf845f2c119da08a;
'use strict';
function $40c3af8d98807125$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $40c3af8d98807125$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $40c3af8d98807125$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $40c3af8d98807125$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $40c3af8d98807125$var$g(C, c)) n < e && 0 > $40c3af8d98807125$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $40c3af8d98807125$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $40c3af8d98807125$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $40c3af8d98807125$var$l = performance;
    $40c3af8d98807125$export$c4744153514ff05d = function() {
        return $40c3af8d98807125$var$l.now();
    };
} else {
    var $40c3af8d98807125$var$p = Date, $40c3af8d98807125$var$q = $40c3af8d98807125$var$p.now();
    $40c3af8d98807125$export$c4744153514ff05d = function() {
        return $40c3af8d98807125$var$p.now() - $40c3af8d98807125$var$q;
    };
}
var $40c3af8d98807125$var$r = [], $40c3af8d98807125$var$t = [], $40c3af8d98807125$var$u = 1, $40c3af8d98807125$var$v = null, $40c3af8d98807125$var$y = 3, $40c3af8d98807125$var$z = !1, $40c3af8d98807125$var$A = !1, $40c3af8d98807125$var$B = !1, $40c3af8d98807125$var$D = "function" === typeof setTimeout ? setTimeout : null, $40c3af8d98807125$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $40c3af8d98807125$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $40c3af8d98807125$var$G(a) {
    for(var b = $40c3af8d98807125$var$h($40c3af8d98807125$var$t); null !== b;){
        if (null === b.callback) $40c3af8d98807125$var$k($40c3af8d98807125$var$t);
        else if (b.startTime <= a) $40c3af8d98807125$var$k($40c3af8d98807125$var$t), b.sortIndex = b.expirationTime, $40c3af8d98807125$var$f($40c3af8d98807125$var$r, b);
        else break;
        b = $40c3af8d98807125$var$h($40c3af8d98807125$var$t);
    }
}
function $40c3af8d98807125$var$H(a) {
    $40c3af8d98807125$var$B = !1;
    $40c3af8d98807125$var$G(a);
    if (!$40c3af8d98807125$var$A) {
        if (null !== $40c3af8d98807125$var$h($40c3af8d98807125$var$r)) $40c3af8d98807125$var$A = !0, $40c3af8d98807125$var$I($40c3af8d98807125$var$J);
        else {
            var b = $40c3af8d98807125$var$h($40c3af8d98807125$var$t);
            null !== b && $40c3af8d98807125$var$K($40c3af8d98807125$var$H, b.startTime - a);
        }
    }
}
function $40c3af8d98807125$var$J(a, b) {
    $40c3af8d98807125$var$A = !1;
    $40c3af8d98807125$var$B && ($40c3af8d98807125$var$B = !1, $40c3af8d98807125$var$E($40c3af8d98807125$var$L), $40c3af8d98807125$var$L = -1);
    $40c3af8d98807125$var$z = !0;
    var c = $40c3af8d98807125$var$y;
    try {
        $40c3af8d98807125$var$G(b);
        for($40c3af8d98807125$var$v = $40c3af8d98807125$var$h($40c3af8d98807125$var$r); null !== $40c3af8d98807125$var$v && (!($40c3af8d98807125$var$v.expirationTime > b) || a && !$40c3af8d98807125$var$M());){
            var d = $40c3af8d98807125$var$v.callback;
            if ("function" === typeof d) {
                $40c3af8d98807125$var$v.callback = null;
                $40c3af8d98807125$var$y = $40c3af8d98807125$var$v.priorityLevel;
                var e = d($40c3af8d98807125$var$v.expirationTime <= b);
                b = $40c3af8d98807125$export$c4744153514ff05d();
                "function" === typeof e ? $40c3af8d98807125$var$v.callback = e : $40c3af8d98807125$var$v === $40c3af8d98807125$var$h($40c3af8d98807125$var$r) && $40c3af8d98807125$var$k($40c3af8d98807125$var$r);
                $40c3af8d98807125$var$G(b);
            } else $40c3af8d98807125$var$k($40c3af8d98807125$var$r);
            $40c3af8d98807125$var$v = $40c3af8d98807125$var$h($40c3af8d98807125$var$r);
        }
        if (null !== $40c3af8d98807125$var$v) var w = !0;
        else {
            var m = $40c3af8d98807125$var$h($40c3af8d98807125$var$t);
            null !== m && $40c3af8d98807125$var$K($40c3af8d98807125$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $40c3af8d98807125$var$v = null, $40c3af8d98807125$var$y = c, $40c3af8d98807125$var$z = !1;
    }
}
var $40c3af8d98807125$var$N = !1, $40c3af8d98807125$var$O = null, $40c3af8d98807125$var$L = -1, $40c3af8d98807125$var$P = 5, $40c3af8d98807125$var$Q = -1;
function $40c3af8d98807125$var$M() {
    return $40c3af8d98807125$export$c4744153514ff05d() - $40c3af8d98807125$var$Q < $40c3af8d98807125$var$P ? !1 : !0;
}
function $40c3af8d98807125$var$R() {
    if (null !== $40c3af8d98807125$var$O) {
        var a = $40c3af8d98807125$export$c4744153514ff05d();
        $40c3af8d98807125$var$Q = a;
        var b = !0;
        try {
            b = $40c3af8d98807125$var$O(!0, a);
        } finally{
            b ? $40c3af8d98807125$var$S() : ($40c3af8d98807125$var$N = !1, $40c3af8d98807125$var$O = null);
        }
    } else $40c3af8d98807125$var$N = !1;
}
var $40c3af8d98807125$var$S;
if ("function" === typeof $40c3af8d98807125$var$F) $40c3af8d98807125$var$S = function() {
    $40c3af8d98807125$var$F($40c3af8d98807125$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $40c3af8d98807125$var$T = new MessageChannel, $40c3af8d98807125$var$U = $40c3af8d98807125$var$T.port2;
    $40c3af8d98807125$var$T.port1.onmessage = $40c3af8d98807125$var$R;
    $40c3af8d98807125$var$S = function() {
        $40c3af8d98807125$var$U.postMessage(null);
    };
} else $40c3af8d98807125$var$S = function() {
    $40c3af8d98807125$var$D($40c3af8d98807125$var$R, 0);
};
function $40c3af8d98807125$var$I(a) {
    $40c3af8d98807125$var$O = a;
    $40c3af8d98807125$var$N || ($40c3af8d98807125$var$N = !0, $40c3af8d98807125$var$S());
}
function $40c3af8d98807125$var$K(a, b) {
    $40c3af8d98807125$var$L = $40c3af8d98807125$var$D(function() {
        a($40c3af8d98807125$export$c4744153514ff05d());
    }, b);
}
$40c3af8d98807125$export$3e506c1ccc9cc1a7 = 5;
$40c3af8d98807125$export$e26fe2ed2fa76875 = 1;
$40c3af8d98807125$export$502329bbf4b505b1 = 4;
$40c3af8d98807125$export$6e3807111c4874c4 = 3;
$40c3af8d98807125$export$c27134553091fb3a = null;
$40c3af8d98807125$export$33ee1acdc04fd2a2 = 2;
$40c3af8d98807125$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$40c3af8d98807125$export$8352ce38b91d0c62 = function() {
    $40c3af8d98807125$var$A || $40c3af8d98807125$var$z || ($40c3af8d98807125$var$A = !0, $40c3af8d98807125$var$I($40c3af8d98807125$var$J));
};
$40c3af8d98807125$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $40c3af8d98807125$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$40c3af8d98807125$export$d3dfb8e4810cb555 = function() {
    return $40c3af8d98807125$var$y;
};
$40c3af8d98807125$export$839f9183b0465a69 = function() {
    return $40c3af8d98807125$var$h($40c3af8d98807125$var$r);
};
$40c3af8d98807125$export$72fdf0e06517287b = function(a) {
    switch($40c3af8d98807125$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $40c3af8d98807125$var$y;
    }
    var c = $40c3af8d98807125$var$y;
    $40c3af8d98807125$var$y = b;
    try {
        return a();
    } finally{
        $40c3af8d98807125$var$y = c;
    }
};
$40c3af8d98807125$export$4b844e58a3e414b4 = function() {};
$40c3af8d98807125$export$816d2913ae6b83b1 = function() {};
$40c3af8d98807125$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $40c3af8d98807125$var$y;
    $40c3af8d98807125$var$y = a;
    try {
        return b();
    } finally{
        $40c3af8d98807125$var$y = c;
    }
};
$40c3af8d98807125$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $40c3af8d98807125$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $40c3af8d98807125$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $40c3af8d98807125$var$f($40c3af8d98807125$var$t, a), null === $40c3af8d98807125$var$h($40c3af8d98807125$var$r) && a === $40c3af8d98807125$var$h($40c3af8d98807125$var$t) && ($40c3af8d98807125$var$B ? ($40c3af8d98807125$var$E($40c3af8d98807125$var$L), $40c3af8d98807125$var$L = -1) : $40c3af8d98807125$var$B = !0, $40c3af8d98807125$var$K($40c3af8d98807125$var$H, c - d))) : (a.sortIndex = e, $40c3af8d98807125$var$f($40c3af8d98807125$var$r, a), $40c3af8d98807125$var$A || $40c3af8d98807125$var$z || ($40c3af8d98807125$var$A = !0, $40c3af8d98807125$var$I($40c3af8d98807125$var$J)));
    return a;
};
$40c3af8d98807125$export$b5836b71941fa3ed = $40c3af8d98807125$var$M;
$40c3af8d98807125$export$cf845f2c119da08a = function(a) {
    var b = $40c3af8d98807125$var$y;
    return function() {
        var c = $40c3af8d98807125$var$y;
        $40c3af8d98807125$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $40c3af8d98807125$var$y = c;
        }
    };
};

});



parcelRegister("hFL7V", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $cddad265fba5de75$export$a7c73072b1a182ae, (v) => $cddad265fba5de75$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $cddad265fba5de75$export$9f27bc3417b4524d, (v) => $cddad265fba5de75$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $cddad265fba5de75$export$db77ccec0bb4ccac, (v) => $cddad265fba5de75$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $cddad265fba5de75$export$8392c0c9d3dcbd35, (v) => $cddad265fba5de75$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $cddad265fba5de75$export$ffb0004e005737fa, (v) => $cddad265fba5de75$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $cddad265fba5de75$export$b624eff549462981, (v) => $cddad265fba5de75$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $cddad265fba5de75$export$7897aa7841a5380c, (v) => $cddad265fba5de75$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $cddad265fba5de75$export$602eac185826482c, (v) => $cddad265fba5de75$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $cddad265fba5de75$export$e2c29f18771995cb, (v) => $cddad265fba5de75$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $cddad265fba5de75$export$5f8d39834fd61797, (v) => $cddad265fba5de75$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $cddad265fba5de75$export$74bf444e3cd11ea5, (v) => $cddad265fba5de75$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $cddad265fba5de75$export$998bcd577473dd93, (v) => $cddad265fba5de75$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $cddad265fba5de75$export$92387174baf9b227, (v) => $cddad265fba5de75$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $cddad265fba5de75$export$ec112efeb987d9c6, (v) => $cddad265fba5de75$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $cddad265fba5de75$export$b706b080d889d2c9, (v) => $cddad265fba5de75$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $cddad265fba5de75$export$5be5a87408f70ddc, (v) => $cddad265fba5de75$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $cddad265fba5de75$export$45a5e7f76e0caa8d, (v) => $cddad265fba5de75$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $cddad265fba5de75$export$455c2e768291efa6, (v) => $cddad265fba5de75$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $cddad265fba5de75$export$9522e17588c12572, (v) => $cddad265fba5de75$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $cddad265fba5de75$export$2110ac352bb060b9, (v) => $cddad265fba5de75$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $cddad265fba5de75$export$56885ab8b9c456ab, (v) => $cddad265fba5de75$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $cddad265fba5de75$export$d927fcb6adf8f9de, (v) => $cddad265fba5de75$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $cddad265fba5de75$export$b82d16f27459e05a, (v) => $cddad265fba5de75$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $cddad265fba5de75$export$522c17b4f5e123e8, (v) => $cddad265fba5de75$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $cddad265fba5de75$export$1aabd8a0274ecfd6, (v) => $cddad265fba5de75$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $cddad265fba5de75$export$3d6c20d97e46b957, (v) => $cddad265fba5de75$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $cddad265fba5de75$export$9b621391a187a31a, (v) => $cddad265fba5de75$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $cddad265fba5de75$export$f5bbd400c2f4426f, (v) => $cddad265fba5de75$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cddad265fba5de75$export$a7c73072b1a182ae;
var $cddad265fba5de75$export$9f27bc3417b4524d;
var $cddad265fba5de75$export$db77ccec0bb4ccac;
var $cddad265fba5de75$export$8392c0c9d3dcbd35;
var $cddad265fba5de75$export$ffb0004e005737fa;
var $cddad265fba5de75$export$b624eff549462981;
var $cddad265fba5de75$export$7897aa7841a5380c;
var $cddad265fba5de75$export$602eac185826482c;
var $cddad265fba5de75$export$e2c29f18771995cb;
var $cddad265fba5de75$export$5f8d39834fd61797;
var $cddad265fba5de75$export$74bf444e3cd11ea5;
var $cddad265fba5de75$export$998bcd577473dd93;
var $cddad265fba5de75$export$92387174baf9b227;
var $cddad265fba5de75$export$ec112efeb987d9c6;
var $cddad265fba5de75$export$b706b080d889d2c9;
var $cddad265fba5de75$export$5be5a87408f70ddc;
var $cddad265fba5de75$export$45a5e7f76e0caa8d;
var $cddad265fba5de75$export$455c2e768291efa6;
var $cddad265fba5de75$export$9522e17588c12572;
var $cddad265fba5de75$export$2110ac352bb060b9;
var $cddad265fba5de75$export$56885ab8b9c456ab;
var $cddad265fba5de75$export$d927fcb6adf8f9de;
var $cddad265fba5de75$export$b82d16f27459e05a;
var $cddad265fba5de75$export$522c17b4f5e123e8;
var $cddad265fba5de75$export$1aabd8a0274ecfd6;
var $cddad265fba5de75$export$3d6c20d97e46b957;
var $cddad265fba5de75$export$9b621391a187a31a;
var $cddad265fba5de75$export$f5bbd400c2f4426f;
'use strict';
var $cddad265fba5de75$var$b = Symbol.for("react.element"), $cddad265fba5de75$var$c = Symbol.for("react.portal"), $cddad265fba5de75$var$d = Symbol.for("react.fragment"), $cddad265fba5de75$var$e = Symbol.for("react.strict_mode"), $cddad265fba5de75$var$f = Symbol.for("react.profiler"), $cddad265fba5de75$var$g = Symbol.for("react.provider"), $cddad265fba5de75$var$h = Symbol.for("react.context"), $cddad265fba5de75$var$k = Symbol.for("react.server_context"), $cddad265fba5de75$var$l = Symbol.for("react.forward_ref"), $cddad265fba5de75$var$m = Symbol.for("react.suspense"), $cddad265fba5de75$var$n = Symbol.for("react.suspense_list"), $cddad265fba5de75$var$p = Symbol.for("react.memo"), $cddad265fba5de75$var$q = Symbol.for("react.lazy"), $cddad265fba5de75$var$t = Symbol.for("react.offscreen"), $cddad265fba5de75$var$u;
$cddad265fba5de75$var$u = Symbol.for("react.module.reference");
function $cddad265fba5de75$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $cddad265fba5de75$var$b:
                switch(a = a.type, a){
                    case $cddad265fba5de75$var$d:
                    case $cddad265fba5de75$var$f:
                    case $cddad265fba5de75$var$e:
                    case $cddad265fba5de75$var$m:
                    case $cddad265fba5de75$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $cddad265fba5de75$var$k:
                            case $cddad265fba5de75$var$h:
                            case $cddad265fba5de75$var$l:
                            case $cddad265fba5de75$var$q:
                            case $cddad265fba5de75$var$p:
                            case $cddad265fba5de75$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $cddad265fba5de75$var$c:
                return r;
        }
    }
}
$cddad265fba5de75$export$a7c73072b1a182ae = $cddad265fba5de75$var$h;
$cddad265fba5de75$export$9f27bc3417b4524d = $cddad265fba5de75$var$g;
$cddad265fba5de75$export$db77ccec0bb4ccac = $cddad265fba5de75$var$b;
$cddad265fba5de75$export$8392c0c9d3dcbd35 = $cddad265fba5de75$var$l;
$cddad265fba5de75$export$ffb0004e005737fa = $cddad265fba5de75$var$d;
$cddad265fba5de75$export$b624eff549462981 = $cddad265fba5de75$var$q;
$cddad265fba5de75$export$7897aa7841a5380c = $cddad265fba5de75$var$p;
$cddad265fba5de75$export$602eac185826482c = $cddad265fba5de75$var$c;
$cddad265fba5de75$export$e2c29f18771995cb = $cddad265fba5de75$var$f;
$cddad265fba5de75$export$5f8d39834fd61797 = $cddad265fba5de75$var$e;
$cddad265fba5de75$export$74bf444e3cd11ea5 = $cddad265fba5de75$var$m;
$cddad265fba5de75$export$998bcd577473dd93 = $cddad265fba5de75$var$n;
$cddad265fba5de75$export$92387174baf9b227 = function() {
    return !1;
};
$cddad265fba5de75$export$ec112efeb987d9c6 = function() {
    return !1;
};
$cddad265fba5de75$export$b706b080d889d2c9 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$h;
};
$cddad265fba5de75$export$5be5a87408f70ddc = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$g;
};
$cddad265fba5de75$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $cddad265fba5de75$var$b;
};
$cddad265fba5de75$export$455c2e768291efa6 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$l;
};
$cddad265fba5de75$export$9522e17588c12572 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$d;
};
$cddad265fba5de75$export$2110ac352bb060b9 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$q;
};
$cddad265fba5de75$export$56885ab8b9c456ab = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$p;
};
$cddad265fba5de75$export$d927fcb6adf8f9de = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$c;
};
$cddad265fba5de75$export$b82d16f27459e05a = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$f;
};
$cddad265fba5de75$export$522c17b4f5e123e8 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$e;
};
$cddad265fba5de75$export$1aabd8a0274ecfd6 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$m;
};
$cddad265fba5de75$export$3d6c20d97e46b957 = function(a) {
    return $cddad265fba5de75$var$v(a) === $cddad265fba5de75$var$n;
};
$cddad265fba5de75$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $cddad265fba5de75$var$d || a === $cddad265fba5de75$var$f || a === $cddad265fba5de75$var$e || a === $cddad265fba5de75$var$m || a === $cddad265fba5de75$var$n || a === $cddad265fba5de75$var$t || "object" === typeof a && null !== a && (a.$$typeof === $cddad265fba5de75$var$q || a.$$typeof === $cddad265fba5de75$var$p || a.$$typeof === $cddad265fba5de75$var$g || a.$$typeof === $cddad265fba5de75$var$h || a.$$typeof === $cddad265fba5de75$var$l || a.$$typeof === $cddad265fba5de75$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$cddad265fba5de75$export$f5bbd400c2f4426f = $cddad265fba5de75$var$v;

});

parcelRegister("19kfS", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $0d6657f4f2c16313$export$2b8d127b894957b9, (v) => $0d6657f4f2c16313$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $0d6657f4f2c16313$export$cea3a54a6425200c, (v) => $0d6657f4f2c16313$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $0d6657f4f2c16313$export$a7c73072b1a182ae, (v) => $0d6657f4f2c16313$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $0d6657f4f2c16313$export$9f27bc3417b4524d, (v) => $0d6657f4f2c16313$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $0d6657f4f2c16313$export$db77ccec0bb4ccac, (v) => $0d6657f4f2c16313$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $0d6657f4f2c16313$export$8392c0c9d3dcbd35, (v) => $0d6657f4f2c16313$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $0d6657f4f2c16313$export$ffb0004e005737fa, (v) => $0d6657f4f2c16313$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $0d6657f4f2c16313$export$b624eff549462981, (v) => $0d6657f4f2c16313$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $0d6657f4f2c16313$export$7897aa7841a5380c, (v) => $0d6657f4f2c16313$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $0d6657f4f2c16313$export$602eac185826482c, (v) => $0d6657f4f2c16313$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $0d6657f4f2c16313$export$e2c29f18771995cb, (v) => $0d6657f4f2c16313$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $0d6657f4f2c16313$export$5f8d39834fd61797, (v) => $0d6657f4f2c16313$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $0d6657f4f2c16313$export$74bf444e3cd11ea5, (v) => $0d6657f4f2c16313$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $0d6657f4f2c16313$export$92387174baf9b227, (v) => $0d6657f4f2c16313$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $0d6657f4f2c16313$export$ec112efeb987d9c6, (v) => $0d6657f4f2c16313$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $0d6657f4f2c16313$export$b706b080d889d2c9, (v) => $0d6657f4f2c16313$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $0d6657f4f2c16313$export$5be5a87408f70ddc, (v) => $0d6657f4f2c16313$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $0d6657f4f2c16313$export$45a5e7f76e0caa8d, (v) => $0d6657f4f2c16313$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $0d6657f4f2c16313$export$455c2e768291efa6, (v) => $0d6657f4f2c16313$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $0d6657f4f2c16313$export$9522e17588c12572, (v) => $0d6657f4f2c16313$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $0d6657f4f2c16313$export$2110ac352bb060b9, (v) => $0d6657f4f2c16313$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $0d6657f4f2c16313$export$56885ab8b9c456ab, (v) => $0d6657f4f2c16313$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $0d6657f4f2c16313$export$d927fcb6adf8f9de, (v) => $0d6657f4f2c16313$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $0d6657f4f2c16313$export$b82d16f27459e05a, (v) => $0d6657f4f2c16313$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $0d6657f4f2c16313$export$522c17b4f5e123e8, (v) => $0d6657f4f2c16313$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $0d6657f4f2c16313$export$1aabd8a0274ecfd6, (v) => $0d6657f4f2c16313$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $0d6657f4f2c16313$export$9b621391a187a31a, (v) => $0d6657f4f2c16313$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $0d6657f4f2c16313$export$f5bbd400c2f4426f, (v) => $0d6657f4f2c16313$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0d6657f4f2c16313$export$2b8d127b894957b9;
var $0d6657f4f2c16313$export$cea3a54a6425200c;
var $0d6657f4f2c16313$export$a7c73072b1a182ae;
var $0d6657f4f2c16313$export$9f27bc3417b4524d;
var $0d6657f4f2c16313$export$db77ccec0bb4ccac;
var $0d6657f4f2c16313$export$8392c0c9d3dcbd35;
var $0d6657f4f2c16313$export$ffb0004e005737fa;
var $0d6657f4f2c16313$export$b624eff549462981;
var $0d6657f4f2c16313$export$7897aa7841a5380c;
var $0d6657f4f2c16313$export$602eac185826482c;
var $0d6657f4f2c16313$export$e2c29f18771995cb;
var $0d6657f4f2c16313$export$5f8d39834fd61797;
var $0d6657f4f2c16313$export$74bf444e3cd11ea5;
var $0d6657f4f2c16313$export$92387174baf9b227;
var $0d6657f4f2c16313$export$ec112efeb987d9c6;
var $0d6657f4f2c16313$export$b706b080d889d2c9;
var $0d6657f4f2c16313$export$5be5a87408f70ddc;
var $0d6657f4f2c16313$export$45a5e7f76e0caa8d;
var $0d6657f4f2c16313$export$455c2e768291efa6;
var $0d6657f4f2c16313$export$9522e17588c12572;
var $0d6657f4f2c16313$export$2110ac352bb060b9;
var $0d6657f4f2c16313$export$56885ab8b9c456ab;
var $0d6657f4f2c16313$export$d927fcb6adf8f9de;
var $0d6657f4f2c16313$export$b82d16f27459e05a;
var $0d6657f4f2c16313$export$522c17b4f5e123e8;
var $0d6657f4f2c16313$export$1aabd8a0274ecfd6;
var $0d6657f4f2c16313$export$9b621391a187a31a;
var $0d6657f4f2c16313$export$f5bbd400c2f4426f;
'use strict';
var $0d6657f4f2c16313$var$b = "function" === typeof Symbol && Symbol.for, $0d6657f4f2c16313$var$c = $0d6657f4f2c16313$var$b ? Symbol.for("react.element") : 60103, $0d6657f4f2c16313$var$d = $0d6657f4f2c16313$var$b ? Symbol.for("react.portal") : 60106, $0d6657f4f2c16313$var$e = $0d6657f4f2c16313$var$b ? Symbol.for("react.fragment") : 60107, $0d6657f4f2c16313$var$f = $0d6657f4f2c16313$var$b ? Symbol.for("react.strict_mode") : 60108, $0d6657f4f2c16313$var$g = $0d6657f4f2c16313$var$b ? Symbol.for("react.profiler") : 60114, $0d6657f4f2c16313$var$h = $0d6657f4f2c16313$var$b ? Symbol.for("react.provider") : 60109, $0d6657f4f2c16313$var$k = $0d6657f4f2c16313$var$b ? Symbol.for("react.context") : 60110, $0d6657f4f2c16313$var$l = $0d6657f4f2c16313$var$b ? Symbol.for("react.async_mode") : 60111, $0d6657f4f2c16313$var$m = $0d6657f4f2c16313$var$b ? Symbol.for("react.concurrent_mode") : 60111, $0d6657f4f2c16313$var$n = $0d6657f4f2c16313$var$b ? Symbol.for("react.forward_ref") : 60112, $0d6657f4f2c16313$var$p = $0d6657f4f2c16313$var$b ? Symbol.for("react.suspense") : 60113, $0d6657f4f2c16313$var$q = $0d6657f4f2c16313$var$b ? Symbol.for("react.suspense_list") : 60120, $0d6657f4f2c16313$var$r = $0d6657f4f2c16313$var$b ? Symbol.for("react.memo") : 60115, $0d6657f4f2c16313$var$t = $0d6657f4f2c16313$var$b ? Symbol.for("react.lazy") : 60116, $0d6657f4f2c16313$var$v = $0d6657f4f2c16313$var$b ? Symbol.for("react.block") : 60121, $0d6657f4f2c16313$var$w = $0d6657f4f2c16313$var$b ? Symbol.for("react.fundamental") : 60117, $0d6657f4f2c16313$var$x = $0d6657f4f2c16313$var$b ? Symbol.for("react.responder") : 60118, $0d6657f4f2c16313$var$y = $0d6657f4f2c16313$var$b ? Symbol.for("react.scope") : 60119;
function $0d6657f4f2c16313$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $0d6657f4f2c16313$var$c:
                switch(a = a.type, a){
                    case $0d6657f4f2c16313$var$l:
                    case $0d6657f4f2c16313$var$m:
                    case $0d6657f4f2c16313$var$e:
                    case $0d6657f4f2c16313$var$g:
                    case $0d6657f4f2c16313$var$f:
                    case $0d6657f4f2c16313$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $0d6657f4f2c16313$var$k:
                            case $0d6657f4f2c16313$var$n:
                            case $0d6657f4f2c16313$var$t:
                            case $0d6657f4f2c16313$var$r:
                            case $0d6657f4f2c16313$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $0d6657f4f2c16313$var$d:
                return u;
        }
    }
}
function $0d6657f4f2c16313$var$A(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$m;
}
$0d6657f4f2c16313$export$2b8d127b894957b9 = $0d6657f4f2c16313$var$l;
$0d6657f4f2c16313$export$cea3a54a6425200c = $0d6657f4f2c16313$var$m;
$0d6657f4f2c16313$export$a7c73072b1a182ae = $0d6657f4f2c16313$var$k;
$0d6657f4f2c16313$export$9f27bc3417b4524d = $0d6657f4f2c16313$var$h;
$0d6657f4f2c16313$export$db77ccec0bb4ccac = $0d6657f4f2c16313$var$c;
$0d6657f4f2c16313$export$8392c0c9d3dcbd35 = $0d6657f4f2c16313$var$n;
$0d6657f4f2c16313$export$ffb0004e005737fa = $0d6657f4f2c16313$var$e;
$0d6657f4f2c16313$export$b624eff549462981 = $0d6657f4f2c16313$var$t;
$0d6657f4f2c16313$export$7897aa7841a5380c = $0d6657f4f2c16313$var$r;
$0d6657f4f2c16313$export$602eac185826482c = $0d6657f4f2c16313$var$d;
$0d6657f4f2c16313$export$e2c29f18771995cb = $0d6657f4f2c16313$var$g;
$0d6657f4f2c16313$export$5f8d39834fd61797 = $0d6657f4f2c16313$var$f;
$0d6657f4f2c16313$export$74bf444e3cd11ea5 = $0d6657f4f2c16313$var$p;
$0d6657f4f2c16313$export$92387174baf9b227 = function(a) {
    return $0d6657f4f2c16313$var$A(a) || $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$l;
};
$0d6657f4f2c16313$export$ec112efeb987d9c6 = $0d6657f4f2c16313$var$A;
$0d6657f4f2c16313$export$b706b080d889d2c9 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$k;
};
$0d6657f4f2c16313$export$5be5a87408f70ddc = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$h;
};
$0d6657f4f2c16313$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $0d6657f4f2c16313$var$c;
};
$0d6657f4f2c16313$export$455c2e768291efa6 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$n;
};
$0d6657f4f2c16313$export$9522e17588c12572 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$e;
};
$0d6657f4f2c16313$export$2110ac352bb060b9 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$t;
};
$0d6657f4f2c16313$export$56885ab8b9c456ab = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$r;
};
$0d6657f4f2c16313$export$d927fcb6adf8f9de = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$d;
};
$0d6657f4f2c16313$export$b82d16f27459e05a = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$g;
};
$0d6657f4f2c16313$export$522c17b4f5e123e8 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$f;
};
$0d6657f4f2c16313$export$1aabd8a0274ecfd6 = function(a) {
    return $0d6657f4f2c16313$var$z(a) === $0d6657f4f2c16313$var$p;
};
$0d6657f4f2c16313$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $0d6657f4f2c16313$var$e || a === $0d6657f4f2c16313$var$m || a === $0d6657f4f2c16313$var$g || a === $0d6657f4f2c16313$var$f || a === $0d6657f4f2c16313$var$p || a === $0d6657f4f2c16313$var$q || "object" === typeof a && null !== a && (a.$$typeof === $0d6657f4f2c16313$var$t || a.$$typeof === $0d6657f4f2c16313$var$r || a.$$typeof === $0d6657f4f2c16313$var$h || a.$$typeof === $0d6657f4f2c16313$var$k || a.$$typeof === $0d6657f4f2c16313$var$n || a.$$typeof === $0d6657f4f2c16313$var$w || a.$$typeof === $0d6657f4f2c16313$var$x || a.$$typeof === $0d6657f4f2c16313$var$y || a.$$typeof === $0d6657f4f2c16313$var$v);
};
$0d6657f4f2c16313$export$f5bbd400c2f4426f = $0d6657f4f2c16313$var$z;

});

parcelRegister("hWy5B", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lKqck = parcelRequire("lKqck");
function $d1024be949a4fae7$var$emptyFunction() {}
function $d1024be949a4fae7$var$emptyFunctionWithReset() {}
$d1024be949a4fae7$var$emptyFunctionWithReset.resetWarningCache = $d1024be949a4fae7$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lKqck) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d1024be949a4fae7$var$emptyFunctionWithReset,
        resetWarningCache: $d1024be949a4fae7$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lKqck", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fd523734c7da616c$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fd523734c7da616c$var$ReactPropTypesSecret;

});


parcelRegister("03MXH", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $00b642bf4502144a$export$306c0aa65ff9ec16, (v) => $00b642bf4502144a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $00b642bf4502144a$export$306c0aa65ff9ec16;
"use strict";

var $dup7A = parcelRequire("dup7A");
function $00b642bf4502144a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $00b642bf4502144a$var$objectIs = "function" === typeof Object.is ? Object.is : $00b642bf4502144a$var$is, $00b642bf4502144a$var$useState = $dup7A.useState, $00b642bf4502144a$var$useEffect = $dup7A.useEffect, $00b642bf4502144a$var$useLayoutEffect = $dup7A.useLayoutEffect, $00b642bf4502144a$var$useDebugValue = $dup7A.useDebugValue;
function $00b642bf4502144a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $00b642bf4502144a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $00b642bf4502144a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $00b642bf4502144a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $00b642bf4502144a$var$useEffect(function() {
        $00b642bf4502144a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $00b642bf4502144a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $00b642bf4502144a$var$useDebugValue(value);
    return value;
}
function $00b642bf4502144a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$00b642bf4502144a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $00b642bf4502144a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $00b642bf4502144a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $00b642bf4502144a$var$useSyncExternalStore$1 : $00b642bf4502144a$var$useSyncExternalStore$2;
$00b642bf4502144a$export$306c0aa65ff9ec16 = void 0 !== $dup7A.useSyncExternalStore ? $dup7A.useSyncExternalStore : $00b642bf4502144a$var$shim;

});

parcelRegister("aUQjb", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

var $975c4832af85a2cd$exports = {};
'use strict';

$975c4832af85a2cd$exports = (parcelRequire("fJAss"));



var $dup7A = parcelRequire("dup7A");
var $1c1c7e7d360f5af6$export$882461b6382ed46c;
var $1c1c7e7d360f5af6$export$757ceba2d55c277e;
'use strict';
var $e10f5070fc836746$exports = {};
'use strict';
function $e10f5070fc836746$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($e10f5070fc836746$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$e10f5070fc836746$var$checkDCE();

$e10f5070fc836746$exports = (parcelRequire("dpuiw"));


var $1c1c7e7d360f5af6$var$i;
$1c1c7e7d360f5af6$export$882461b6382ed46c = $e10f5070fc836746$exports.createRoot;
$1c1c7e7d360f5af6$export$757ceba2d55c277e = $e10f5070fc836746$exports.hydrateRoot;


var $e9f8389e4f70b5af$exports = {};

$parcel$defineInteropFlag($e9f8389e4f70b5af$exports);

$parcel$export($e9f8389e4f70b5af$exports, "isStyledComponent", () => $e9f8389e4f70b5af$export$7ba318d8d2f06c76);
$parcel$export($e9f8389e4f70b5af$exports, "version", () => $e9f8389e4f70b5af$export$83d89fbfd8236492);
$parcel$export($e9f8389e4f70b5af$exports, "StyleSheetContext", () => $e9f8389e4f70b5af$export$8c190ef828af4c86);
$parcel$export($e9f8389e4f70b5af$exports, "StyleSheetConsumer", () => $e9f8389e4f70b5af$export$91317688fc694efa);
$parcel$export($e9f8389e4f70b5af$exports, "StyleSheetManager", () => $e9f8389e4f70b5af$export$a473771da2f0ff7c);
$parcel$export($e9f8389e4f70b5af$exports, "css", () => $e9f8389e4f70b5af$export$dbf350e5966cf602);
$parcel$export($e9f8389e4f70b5af$exports, "ThemeContext", () => $e9f8389e4f70b5af$export$2c657da244d00bd6);
$parcel$export($e9f8389e4f70b5af$exports, "ThemeConsumer", () => $e9f8389e4f70b5af$export$b631efc24e9d5e2f);
$parcel$export($e9f8389e4f70b5af$exports, "ThemeProvider", () => $e9f8389e4f70b5af$export$d8964aec282183a3);
$parcel$export($e9f8389e4f70b5af$exports, "createGlobalStyle", () => $e9f8389e4f70b5af$export$f0f03736edb61697);
$parcel$export($e9f8389e4f70b5af$exports, "keyframes", () => $e9f8389e4f70b5af$export$d25ddfdf17c3ad3e);
$parcel$export($e9f8389e4f70b5af$exports, "ServerStyleSheet", () => $e9f8389e4f70b5af$export$ae8c7d15c8b89a20);
$parcel$export($e9f8389e4f70b5af$exports, "withTheme", () => $e9f8389e4f70b5af$export$e8748c6a27b910dc);
$parcel$export($e9f8389e4f70b5af$exports, "useTheme", () => $e9f8389e4f70b5af$export$93d4e7f90805808f);
$parcel$export($e9f8389e4f70b5af$exports, "__PRIVATE__", () => $e9f8389e4f70b5af$export$5c87cfe6c475f500);
$parcel$export($e9f8389e4f70b5af$exports, "default", () => $e9f8389e4f70b5af$export$2e2bcd8739ae039);
var $631d850cd54a09cf$exports = {};
'use strict';

$631d850cd54a09cf$exports = (parcelRequire("hFL7V"));



var $dup7A = parcelRequire("dup7A");
var $0a4832c5d1c5a3de$exports = {};
//
$0a4832c5d1c5a3de$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $aabbad6795e7f5aa$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $aabbad6795e7f5aa$export$2e2bcd8739ae039 = $aabbad6795e7f5aa$var$stylis_min;


var $092131f013bcfd2b$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $092131f013bcfd2b$export$2e2bcd8739ae039 = $092131f013bcfd2b$var$unitlessKeys;


function $76cf8ffebe5a31cc$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $181baee5022e6156$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $181baee5022e6156$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $76cf8ffebe5a31cc$export$2e2bcd8739ae039)(function(prop) {
    return $181baee5022e6156$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $3d6085f04296be4e$exports = {};
'use strict';
var $818bc5a517e1ff7b$exports = {};
'use strict';

$818bc5a517e1ff7b$exports = (parcelRequire("19kfS"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $3d6085f04296be4e$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $3d6085f04296be4e$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $3d6085f04296be4e$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $3d6085f04296be4e$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $3d6085f04296be4e$var$TYPE_STATICS = {};
$3d6085f04296be4e$var$TYPE_STATICS[$818bc5a517e1ff7b$exports.ForwardRef] = $3d6085f04296be4e$var$FORWARD_REF_STATICS;
$3d6085f04296be4e$var$TYPE_STATICS[$818bc5a517e1ff7b$exports.Memo] = $3d6085f04296be4e$var$MEMO_STATICS;
function $3d6085f04296be4e$var$getStatics(component) {
    // React v16.11 and below
    if ($818bc5a517e1ff7b$exports.isMemo(component)) return $3d6085f04296be4e$var$MEMO_STATICS;
     // React v16.12 and above
    return $3d6085f04296be4e$var$TYPE_STATICS[component['$$typeof']] || $3d6085f04296be4e$var$REACT_STATICS;
}
var $3d6085f04296be4e$var$defineProperty = Object.defineProperty;
var $3d6085f04296be4e$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $3d6085f04296be4e$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3d6085f04296be4e$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $3d6085f04296be4e$var$getPrototypeOf = Object.getPrototypeOf;
var $3d6085f04296be4e$var$objectPrototype = Object.prototype;
function $3d6085f04296be4e$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($3d6085f04296be4e$var$objectPrototype) {
            var inheritedComponent = $3d6085f04296be4e$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $3d6085f04296be4e$var$objectPrototype) $3d6085f04296be4e$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $3d6085f04296be4e$var$getOwnPropertyNames(sourceComponent);
        if ($3d6085f04296be4e$var$getOwnPropertySymbols) keys = keys.concat($3d6085f04296be4e$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $3d6085f04296be4e$var$getStatics(targetComponent);
        var sourceStatics = $3d6085f04296be4e$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$3d6085f04296be4e$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $3d6085f04296be4e$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $3d6085f04296be4e$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$3d6085f04296be4e$exports = $3d6085f04296be4e$var$hoistNonReactStatics;


function $e9f8389e4f70b5af$var$y() {
    return ($e9f8389e4f70b5af$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $e9f8389e4f70b5af$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $e9f8389e4f70b5af$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $631d850cd54a09cf$exports.typeOf)(t);
}, $e9f8389e4f70b5af$var$S = Object.freeze([]), $e9f8389e4f70b5af$var$w = Object.freeze({});
function $e9f8389e4f70b5af$var$E(e) {
    return "function" == typeof e;
}
function $e9f8389e4f70b5af$var$b(e) {
    return e.displayName || e.name || "Component";
}
function $e9f8389e4f70b5af$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $e9f8389e4f70b5af$var$N = "data-styled", $e9f8389e4f70b5af$export$83d89fbfd8236492 = "5.3.11", $e9f8389e4f70b5af$var$C = "undefined" != typeof window && "HTMLElement" in window, $e9f8389e4f70b5af$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $e9f8389e4f70b5af$var$P = {}, $e9f8389e4f70b5af$var$O = {};
function $e9f8389e4f70b5af$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $e9f8389e4f70b5af$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $e9f8389e4f70b5af$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $e9f8389e4f70b5af$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $e9f8389e4f70b5af$var$T = new Map, $e9f8389e4f70b5af$var$x = new Map, $e9f8389e4f70b5af$var$k = 1, $e9f8389e4f70b5af$var$V = function(e) {
    if ($e9f8389e4f70b5af$var$T.has(e)) return $e9f8389e4f70b5af$var$T.get(e);
    for(; $e9f8389e4f70b5af$var$x.has($e9f8389e4f70b5af$var$k);)$e9f8389e4f70b5af$var$k++;
    var t = $e9f8389e4f70b5af$var$k++;
    return $e9f8389e4f70b5af$var$T.set(e, t), $e9f8389e4f70b5af$var$x.set(t, e), t;
}, $e9f8389e4f70b5af$var$B = function(e) {
    return $e9f8389e4f70b5af$var$x.get(e);
}, $e9f8389e4f70b5af$var$z = function(e, t) {
    t >= $e9f8389e4f70b5af$var$k && ($e9f8389e4f70b5af$var$k = t + 1), $e9f8389e4f70b5af$var$T.set(e, t), $e9f8389e4f70b5af$var$x.set(t, e);
}, $e9f8389e4f70b5af$var$M = "style[" + $e9f8389e4f70b5af$var$N + '][data-styled-version="5.3.11"]', $e9f8389e4f70b5af$var$G = new RegExp("^" + $e9f8389e4f70b5af$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $e9f8389e4f70b5af$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $e9f8389e4f70b5af$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($e9f8389e4f70b5af$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($e9f8389e4f70b5af$var$z(u, c), $e9f8389e4f70b5af$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $e9f8389e4f70b5af$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $e9f8389e4f70b5af$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($e9f8389e4f70b5af$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($e9f8389e4f70b5af$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $e9f8389e4f70b5af$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $e9f8389e4f70b5af$var$H = function() {
    function e(e) {
        var t = this.element = $e9f8389e4f70b5af$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $e9f8389e4f70b5af$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $e9f8389e4f70b5af$var$$ = function() {
    function e(e) {
        var t = this.element = $e9f8389e4f70b5af$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $e9f8389e4f70b5af$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $e9f8389e4f70b5af$var$U = $e9f8389e4f70b5af$var$C, $e9f8389e4f70b5af$var$J = {
    isServer: !$e9f8389e4f70b5af$var$C,
    useCSSOMInjection: !$e9f8389e4f70b5af$var$I
}, $e9f8389e4f70b5af$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $e9f8389e4f70b5af$var$w), void 0 === t && (t = {}), this.options = $e9f8389e4f70b5af$var$y({}, $e9f8389e4f70b5af$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $e9f8389e4f70b5af$var$C && $e9f8389e4f70b5af$var$U && ($e9f8389e4f70b5af$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($e9f8389e4f70b5af$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($e9f8389e4f70b5af$var$N) && ($e9f8389e4f70b5af$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $e9f8389e4f70b5af$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($e9f8389e4f70b5af$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $e9f8389e4f70b5af$var$W(o) : r ? new $e9f8389e4f70b5af$var$H(o) : new $e9f8389e4f70b5af$var$$(o), new $e9f8389e4f70b5af$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($e9f8389e4f70b5af$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($e9f8389e4f70b5af$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($e9f8389e4f70b5af$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $e9f8389e4f70b5af$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $e9f8389e4f70b5af$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $e9f8389e4f70b5af$var$Z = /(a)(d)/gi, $e9f8389e4f70b5af$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $e9f8389e4f70b5af$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $e9f8389e4f70b5af$var$K(t % 52) + n;
    return ($e9f8389e4f70b5af$var$K(t % 52) + n).replace($e9f8389e4f70b5af$var$Z, "$1-$2");
}
var $e9f8389e4f70b5af$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $e9f8389e4f70b5af$var$te = function(e) {
    return $e9f8389e4f70b5af$var$ee(5381, e);
};
function $e9f8389e4f70b5af$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($e9f8389e4f70b5af$var$E(n) && !$e9f8389e4f70b5af$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $e9f8389e4f70b5af$var$re = $e9f8389e4f70b5af$var$te("5.3.11"), $e9f8389e4f70b5af$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $e9f8389e4f70b5af$var$ne(e), this.componentId = t, this.baseHash = $e9f8389e4f70b5af$var$ee($e9f8389e4f70b5af$var$re, t), this.baseStyle = n, $e9f8389e4f70b5af$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $e9f8389e4f70b5af$var$_e(this.rules, e, t, n).join(""), i = $e9f8389e4f70b5af$var$Q($e9f8389e4f70b5af$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $e9f8389e4f70b5af$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $e9f8389e4f70b5af$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $e9f8389e4f70b5af$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $e9f8389e4f70b5af$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $e9f8389e4f70b5af$var$se = /^\s*\/\/.*$/gm, $e9f8389e4f70b5af$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $e9f8389e4f70b5af$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $e9f8389e4f70b5af$var$w : e, i = s.options, a = void 0 === i ? $e9f8389e4f70b5af$var$w : i, c = s.plugins, u = void 0 === c ? $e9f8389e4f70b5af$var$S : c, l = new (0, $aabbad6795e7f5aa$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $e9f8389e4f70b5af$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($e9f8389e4f70b5af$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $e9f8389e4f70b5af$var$D(15), $e9f8389e4f70b5af$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $e9f8389e4f70b5af$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(), $e9f8389e4f70b5af$export$91317688fc694efa = $e9f8389e4f70b5af$export$8c190ef828af4c86.Consumer, $e9f8389e4f70b5af$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(), $e9f8389e4f70b5af$var$de = ($e9f8389e4f70b5af$var$le.Consumer, new $e9f8389e4f70b5af$var$X), $e9f8389e4f70b5af$var$he = $e9f8389e4f70b5af$var$ae();
function $e9f8389e4f70b5af$var$pe() {
    return (0, $dup7A.useContext)($e9f8389e4f70b5af$export$8c190ef828af4c86) || $e9f8389e4f70b5af$var$de;
}
function $e9f8389e4f70b5af$var$fe() {
    return (0, $dup7A.useContext)($e9f8389e4f70b5af$var$le) || $e9f8389e4f70b5af$var$he;
}
function $e9f8389e4f70b5af$export$a473771da2f0ff7c(e) {
    var t = (0, $dup7A.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $e9f8389e4f70b5af$var$pe(), u = (0, $dup7A.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $dup7A.useMemo)(function() {
        return $e9f8389e4f70b5af$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $dup7A.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($0a4832c5d1c5a3de$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$var$le.Provider, {
        value: l
    }, (0, e.children)));
}
var $e9f8389e4f70b5af$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $e9f8389e4f70b5af$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $e9f8389e4f70b5af$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $e9f8389e4f70b5af$var$he), this.name + e.hash;
    }, e;
}(), $e9f8389e4f70b5af$var$ve = /([A-Z])/, $e9f8389e4f70b5af$var$ge = /([A-Z])/g, $e9f8389e4f70b5af$var$Se = /^ms-/, $e9f8389e4f70b5af$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $e9f8389e4f70b5af$var$Ee(e) {
    return $e9f8389e4f70b5af$var$ve.test(e) ? e.replace($e9f8389e4f70b5af$var$ge, $e9f8389e4f70b5af$var$we).replace($e9f8389e4f70b5af$var$Se, "-ms-") : e;
}
var $e9f8389e4f70b5af$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $e9f8389e4f70b5af$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $e9f8389e4f70b5af$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($e9f8389e4f70b5af$var$be(e)) return "";
    if ($e9f8389e4f70b5af$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($e9f8389e4f70b5af$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $e9f8389e4f70b5af$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $e9f8389e4f70b5af$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $e9f8389e4f70b5af$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$e9f8389e4f70b5af$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $e9f8389e4f70b5af$var$E(t[i]) ? s.push($e9f8389e4f70b5af$var$Ee(i) + ":", t[i], ";") : $e9f8389e4f70b5af$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($e9f8389e4f70b5af$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $092131f013bcfd2b$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $e9f8389e4f70b5af$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $e9f8389e4f70b5af$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $e9f8389e4f70b5af$var$E(e) || $e9f8389e4f70b5af$var$g(e) ? $e9f8389e4f70b5af$var$Ne($e9f8389e4f70b5af$var$_e($e9f8389e4f70b5af$var$v($e9f8389e4f70b5af$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $e9f8389e4f70b5af$var$Ne($e9f8389e4f70b5af$var$_e($e9f8389e4f70b5af$var$v(e, n)));
}
var $e9f8389e4f70b5af$var$Ce = /invalid hook call/i, $e9f8389e4f70b5af$var$Ie = new Set, $e9f8389e4f70b5af$var$Pe = function(e, t) {
    var n, r, o, e1;
}, $e9f8389e4f70b5af$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $e9f8389e4f70b5af$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $e9f8389e4f70b5af$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $e9f8389e4f70b5af$var$De = /(^-|-$)/g;
function $e9f8389e4f70b5af$var$je(e) {
    return e.replace($e9f8389e4f70b5af$var$Re, "-").replace($e9f8389e4f70b5af$var$De, "");
}
var $e9f8389e4f70b5af$var$Te = function(e) {
    return $e9f8389e4f70b5af$var$Q($e9f8389e4f70b5af$var$te(e) >>> 0);
};
function $e9f8389e4f70b5af$var$xe(e) {
    return "string" == typeof e && true;
}
var $e9f8389e4f70b5af$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $e9f8389e4f70b5af$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $e9f8389e4f70b5af$var$Be(e, t, n) {
    var r = e[n];
    $e9f8389e4f70b5af$var$ke(t) && $e9f8389e4f70b5af$var$ke(r) ? $e9f8389e4f70b5af$var$ze(r, t) : e[n] = t;
}
function $e9f8389e4f70b5af$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($e9f8389e4f70b5af$var$ke(i)) for(var a in i)$e9f8389e4f70b5af$var$Ve(a) && $e9f8389e4f70b5af$var$Be(e, i[a], a);
    }
    return e;
}
var $e9f8389e4f70b5af$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createContext(), $e9f8389e4f70b5af$export$b631efc24e9d5e2f = $e9f8389e4f70b5af$export$2c657da244d00bd6.Consumer;
function $e9f8389e4f70b5af$export$d8964aec282183a3(e) {
    var t = (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), n = (0, $dup7A.useMemo)(function() {
        return function(e, t) {
            if (!e) return $e9f8389e4f70b5af$var$D(14);
            if ($e9f8389e4f70b5af$var$E(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $e9f8389e4f70b5af$var$D(8) : t ? $e9f8389e4f70b5af$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $e9f8389e4f70b5af$var$Fe = {};
function $e9f8389e4f70b5af$var$Ye(e, t, n) {
    var o = $e9f8389e4f70b5af$export$7ba318d8d2f06c76(e), i = !$e9f8389e4f70b5af$var$xe(e), a = t.attrs, c = void 0 === a ? $e9f8389e4f70b5af$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $e9f8389e4f70b5af$var$je(e);
        $e9f8389e4f70b5af$var$Fe[n] = ($e9f8389e4f70b5af$var$Fe[n] || 0) + 1;
        var r = n + "-" + $e9f8389e4f70b5af$var$Te("5.3.11" + n + $e9f8389e4f70b5af$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $e9f8389e4f70b5af$var$xe(e) ? "styled." + e : "Styled(" + $e9f8389e4f70b5af$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $e9f8389e4f70b5af$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $e9f8389e4f70b5af$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $e9f8389e4f70b5af$var$w);
                var r = $e9f8389e4f70b5af$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $e9f8389e4f70b5af$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($e9f8389e4f70b5af$var$Oe(t, (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), a) || $e9f8389e4f70b5af$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $e9f8389e4f70b5af$var$pe(), s = $e9f8389e4f70b5af$var$fe(), i = t ? e.generateAndInjectStyles($e9f8389e4f70b5af$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, m, void 0), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $e9f8389e4f70b5af$var$xe(b), N = v !== t ? $e9f8389e4f70b5af$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $181baee5022e6156$export$2e2bcd8739ae039), b) : !_ || (0, $181baee5022e6156$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $e9f8389e4f70b5af$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $dup7A.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $e9f8389e4f70b5af$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($e9f8389e4f70b5af$var$xe(e) ? e : $e9f8389e4f70b5af$var$je($e9f8389e4f70b5af$var$b(e)));
        return $e9f8389e4f70b5af$var$Ye(e, $e9f8389e4f70b5af$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $e9f8389e4f70b5af$var$ze({}, e.defaultProps, t) : t;
        }
    }), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($3d6085f04296be4e$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $e9f8389e4f70b5af$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $e9f8389e4f70b5af$var$w), !(0, $631d850cd54a09cf$exports.isValidElementType)(r)) return $e9f8389e4f70b5af$var$D(1, String(r));
        var s = function() {
            return t(r, o, $e9f8389e4f70b5af$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $e9f8389e4f70b5af$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $e9f8389e4f70b5af$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($e9f8389e4f70b5af$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $e9f8389e4f70b5af$var$qe[e] = $e9f8389e4f70b5af$var$qe(e);
});
var $e9f8389e4f70b5af$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $e9f8389e4f70b5af$var$ne(e), $e9f8389e4f70b5af$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($e9f8389e4f70b5af$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $e9f8389e4f70b5af$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $e9f8389e4f70b5af$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $e9f8389e4f70b5af$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $e9f8389e4f70b5af$var$Te(JSON.stringify(i)), u = new $e9f8389e4f70b5af$var$He(i, a);
    function d(e) {
        var t = $e9f8389e4f70b5af$var$pe(), n = $e9f8389e4f70b5af$var$fe(), o = (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), d = (0, $dup7A.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(d, e, t, o, n), (0, $dup7A.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $e9f8389e4f70b5af$var$P, n, o);
        else {
            var s = $e9f8389e4f70b5af$var$y({}, t, {
                theme: $e9f8389e4f70b5af$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).memo(d);
}
function $e9f8389e4f70b5af$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $e9f8389e4f70b5af$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $e9f8389e4f70b5af$var$Te(o);
    return new $e9f8389e4f70b5af$var$ye(s, o);
}
var $e9f8389e4f70b5af$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $e9f8389e4f70b5af$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $e9f8389e4f70b5af$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $e9f8389e4f70b5af$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $e9f8389e4f70b5af$var$D(2);
            var n = ((t = {})[$e9f8389e4f70b5af$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $e9f8389e4f70b5af$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("style", $e9f8389e4f70b5af$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $e9f8389e4f70b5af$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $e9f8389e4f70b5af$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement($e9f8389e4f70b5af$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $e9f8389e4f70b5af$var$D(3);
    }, e;
}(), $e9f8389e4f70b5af$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef(function(t, n) {
        var o = (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6), i = e.defaultProps, a = $e9f8389e4f70b5af$var$Oe(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(e, $e9f8389e4f70b5af$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($3d6085f04296be4e$exports)))(t, e), t.displayName = "WithTheme(" + $e9f8389e4f70b5af$var$b(e) + ")", t;
}, $e9f8389e4f70b5af$export$93d4e7f90805808f = function() {
    return (0, $dup7A.useContext)($e9f8389e4f70b5af$export$2c657da244d00bd6);
}, $e9f8389e4f70b5af$export$5c87cfe6c475f500 = {
    StyleSheet: $e9f8389e4f70b5af$var$X,
    masterSheet: $e9f8389e4f70b5af$var$de
};
var $e9f8389e4f70b5af$export$2e2bcd8739ae039 = $e9f8389e4f70b5af$var$qe;




const $9c70c842094d28bf$export$863f8b1efd907ec3 = (style)=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
  @media (max-width: 1250px) {
    ${style.toString()}
  }
`;


const $8869b1e060a1f334$export$f05794e648629f6c = (0, $e9f8389e4f70b5af$export$f0f03736edb61697)`
  html {
    box-sizing: border-box;
    margin: 0px;
    overflow-x: hidden;
    margin-right: calc(-1 * (100vw - 100%));

  }
  *, *:before, *:after {
    box-sizing: inherit;
    margin: 0px;
  }
  body {
    font-family: "Oxanium", sans-serif;
    background-color: ${({ theme: theme })=>theme.color.dark};
  }
  h1 {
    font-family: "Major Mono Display";
    font-size: 6rem;
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      font-size: calc(64px + (98 - 64) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 600;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h2 {
    font-family: "Major Mono Display";
    font-size: 3rem;
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      font-size: calc(32px + (48 - 32) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 400;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h3 {
    font-family: "Major Mono Display";
    font-size: 2rem;
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      font-size: calc(24px + (32 - 24) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 600;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h4 {
    font-family: "Major Mono Display";
    font-size: 2rem;
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      font-size: calc(24px + (32 - 24) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 400;
    color: ${({ theme: theme })=>theme.color.white};
  }
  h5 {
    font-family: "Major Mono Display";
    font-size: 1.5rem;
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      font-size: calc(16px + (24 - 16) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 400;
    color: ${({ theme: theme })=>theme.color.white};
  }
  p {
    line-height: 1.25rem;
    font-size: 1.25rem;
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      font-size: calc(16px + (24 - 16) * (100vw - 300px) / (1250 - 300));
    `)}
    font-weight: 300;
    color: ${({ theme: theme })=>theme.color.white};
  }
  small {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    font-family: "Oxanium";
    color: ${({ theme: theme })=>theme.color.white};
  }
  label{
  font-size: 16px;
  line-height: 20px;
  font-weight: 600;
  font-family: "Oxanium";
  color: ${({ theme: theme })=>theme.color.pink} !important;
  }
  button {
    all: unset;
    box-sizing: border-box;
    :hover {
      cursor: pointer;
    }
  }
  hr {
    opacity: 1;
  }
  svg, img {
    display: inline-block;
    visibility: visible;
    vertical-align: middle;
  }

  *::-webkit-scrollbar {
    width: 12px;
  }

  *::-webkit-scrollbar-track {
    background-color: ${({ theme: theme })=>theme.color.lightBlue}80;
  }

  *::-webkit-scrollbar-thumb {
    background-color: ${({ theme: theme })=>theme.color.pink}80;
    border-radius: 12px;
    border: 2px solid transparent;
  }
`;




var $dup7A = parcelRequire("dup7A");
var $43afcb05ca3681f6$exports = {};


var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
var $b550f30cec538bc8$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $b550f30cec538bc8$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $b550f30cec538bc8$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $b550f30cec538bc8$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $b550f30cec538bc8$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $b550f30cec538bc8$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b550f30cec538bc8$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b550f30cec538bc8$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b550f30cec538bc8$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $b550f30cec538bc8$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $b550f30cec538bc8$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $b550f30cec538bc8$var$root = $b550f30cec538bc8$var$freeGlobal || $b550f30cec538bc8$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $b550f30cec538bc8$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b550f30cec538bc8$var$objectToString = $b550f30cec538bc8$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b550f30cec538bc8$var$nativeMax = Math.max, $b550f30cec538bc8$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $b550f30cec538bc8$var$now = function() {
    return $b550f30cec538bc8$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $b550f30cec538bc8$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($b550f30cec538bc8$var$FUNC_ERROR_TEXT);
    wait = $b550f30cec538bc8$var$toNumber(wait) || 0;
    if ($b550f30cec538bc8$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $b550f30cec538bc8$var$nativeMax($b550f30cec538bc8$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $b550f30cec538bc8$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $b550f30cec538bc8$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($b550f30cec538bc8$var$now());
    }
    function debounced() {
        var time = $b550f30cec538bc8$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $b550f30cec538bc8$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b550f30cec538bc8$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b550f30cec538bc8$var$isSymbol(value) {
    return typeof value == 'symbol' || $b550f30cec538bc8$var$isObjectLike(value) && $b550f30cec538bc8$var$objectToString.call(value) == $b550f30cec538bc8$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b550f30cec538bc8$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($b550f30cec538bc8$var$isSymbol(value)) return $b550f30cec538bc8$var$NAN;
    if ($b550f30cec538bc8$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $b550f30cec538bc8$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($b550f30cec538bc8$var$reTrim, '');
    var isBinary = $b550f30cec538bc8$var$reIsBinary.test(value);
    return isBinary || $b550f30cec538bc8$var$reIsOctal.test(value) ? $b550f30cec538bc8$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b550f30cec538bc8$var$reIsBadHex.test(value) ? $b550f30cec538bc8$var$NAN : +value;
}
$b550f30cec538bc8$exports = $b550f30cec538bc8$var$debounce;


// src/useBoolean/useBoolean.ts
function $554092f59a7e7485$export$c32275ecbd12948f(defaultValue) {
    const [value, setValue] = (0, $dup7A.useState)(!!defaultValue);
    const setTrue = (0, $dup7A.useCallback)(()=>{
        setValue(true);
    }, []);
    const setFalse = (0, $dup7A.useCallback)(()=>{
        setValue(false);
    }, []);
    const toggle = (0, $dup7A.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return {
        value: value,
        setValue: setValue,
        setTrue: setTrue,
        setFalse: setFalse,
        toggle: toggle
    };
}
var $554092f59a7e7485$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $dup7A.useLayoutEffect) : (0, $dup7A.useEffect);
// src/useEventListener/useEventListener.ts
function $554092f59a7e7485$export$7080b3e976bc91ab(eventName, handler, element, options) {
    const savedHandler = (0, $dup7A.useRef)(handler);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        savedHandler.current = handler;
    }, [
        handler
    ]);
    (0, $dup7A.useEffect)(()=>{
        const targetElement = (element == null ? void 0 : element.current) ?? window;
        if (!(targetElement && targetElement.addEventListener)) return;
        const listener = (event)=>{
            savedHandler.current(event);
        };
        targetElement.addEventListener(eventName, listener, options);
        return ()=>{
            targetElement.removeEventListener(eventName, listener, options);
        };
    }, [
        eventName,
        element,
        options
    ]);
}
// src/useClickAnyWhere/useClickAnyWhere.ts
function $554092f59a7e7485$export$5139c081cbc6c8bb(handler) {
    $554092f59a7e7485$export$7080b3e976bc91ab("click", (event)=>{
        handler(event);
    });
}
function $554092f59a7e7485$export$b2199c37e85de4a7() {
    const [copiedText, setCopiedText] = (0, $dup7A.useState)(null);
    const copy = (0, $dup7A.useCallback)(async (text)=>{
        if (!(navigator == null ? void 0 : navigator.clipboard)) {
            console.warn("Clipboard not supported");
            return false;
        }
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            return true;
        } catch (error) {
            console.warn("Copy failed", error);
            setCopiedText(null);
            return false;
        }
    }, []);
    return [
        copiedText,
        copy
    ];
}
function $554092f59a7e7485$export$70c4067197c60e2d(initialValue) {
    const [count, setCount] = (0, $dup7A.useState)(initialValue ?? 0);
    const increment = ()=>{
        setCount((x)=>x + 1);
    };
    const decrement = ()=>{
        setCount((x)=>x - 1);
    };
    const reset = ()=>{
        setCount(initialValue ?? 0);
    };
    return {
        count: count,
        increment: increment,
        decrement: decrement,
        reset: reset,
        setCount: setCount
    };
}
function $554092f59a7e7485$export$f4b266cd2aae9cb1(callback, delay) {
    const savedCallback = (0, $dup7A.useRef)(callback);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (delay === null) return;
        const id = setInterval(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearInterval(id);
        };
    }, [
        delay
    ]);
}
// src/useCountdown/useCountdown.ts
function $554092f59a7e7485$export$8103f7eb37e19f7b(countdownOptions) {
    let isDeprecated = false;
    let countStart, intervalMs, isIncrement, countStop;
    if ("seconds" in countdownOptions) {
        console.warn("[useCountdown:DEPRECATED] new interface is already available (see https://usehooks-ts.com/react-hook/use-countdown), the old version will retire on usehooks-ts@3.");
        isDeprecated = true;
        countStart = countdownOptions.seconds;
        intervalMs = countdownOptions.interval;
        isIncrement = countdownOptions.isIncrement;
    } else ({ countStart: countStart, intervalMs: intervalMs, isIncrement: isIncrement, countStop: countStop } = countdownOptions);
    intervalMs = intervalMs ?? 1e3;
    isIncrement = isIncrement ?? false;
    countStop = countStop ?? 0;
    const { count: count, increment: increment, decrement: decrement, reset: resetCounter } = $554092f59a7e7485$export$70c4067197c60e2d(countStart);
    const { value: isCountdownRunning, setTrue: startCountdown, setFalse: stopCountdown } = $554092f59a7e7485$export$c32275ecbd12948f(false);
    const resetCountdown = ()=>{
        stopCountdown();
        resetCounter();
    };
    const countdownCallback = (0, $dup7A.useCallback)(()=>{
        if (count === countStop) {
            stopCountdown();
            return;
        }
        if (isIncrement) increment();
        else decrement();
    }, [
        count,
        countStop,
        decrement,
        increment,
        isIncrement,
        stopCountdown
    ]);
    $554092f59a7e7485$export$f4b266cd2aae9cb1(countdownCallback, isCountdownRunning ? intervalMs : null);
    return isDeprecated ? [
        count,
        {
            start: startCountdown,
            stop: stopCountdown,
            reset: resetCountdown
        }
    ] : [
        count,
        {
            startCountdown: startCountdown,
            stopCountdown: stopCountdown,
            resetCountdown: resetCountdown
        }
    ];
}
function $554092f59a7e7485$export$ee5b5d04074a389e(fn) {
    const ref = (0, $dup7A.useRef)(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    return (0, $dup7A.useCallback)((...args)=>ref.current(...args), [
        ref
    ]);
}
// src/useLocalStorage/useLocalStorage.ts
var $554092f59a7e7485$var$IS_SERVER = typeof window === "undefined";
function $554092f59a7e7485$export$86e2cef2561044ac(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $dup7A.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $dup7A.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $dup7A.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($554092f59a7e7485$var$IS_SERVER) return initialValueToUse;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $554092f59a7e7485$export$ee5b5d04074a389e((value)=>{
        if ($554092f59a7e7485$var$IS_SERVER) console.warn(`Tried setting localStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.localStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("local-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting localStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $dup7A.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $dup7A.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("storage", handleStorageChange);
    $554092f59a7e7485$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
var $554092f59a7e7485$var$IS_SERVER2 = typeof window === "undefined";
function $554092f59a7e7485$export$32d5543ab307c01(query, options) {
    const defaultValue = typeof options === "boolean" ? options : (options == null ? void 0 : options.defaultValue) ?? false;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const getMatches = (query2)=>{
        if ($554092f59a7e7485$var$IS_SERVER2) return defaultValue;
        return window.matchMedia(query2).matches;
    };
    const [matches, setMatches] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return getMatches(query);
        return defaultValue;
    });
    function handleChange() {
        setMatches(getMatches(query));
    }
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        const matchMedia = window.matchMedia(query);
        handleChange();
        if (matchMedia.addListener) matchMedia.addListener(handleChange);
        else matchMedia.addEventListener("change", handleChange);
        return ()=>{
            if (matchMedia.removeListener) matchMedia.removeListener(handleChange);
            else matchMedia.removeEventListener("change", handleChange);
        };
    }, [
        query
    ]);
    return matches;
}
// src/useDarkMode/useDarkMode.ts
var $554092f59a7e7485$var$COLOR_SCHEME_QUERY = "(prefers-color-scheme: dark)";
var $554092f59a7e7485$var$LOCAL_STORAGE_KEY = "usehooks-ts-dark-mode";
function $554092f59a7e7485$export$4673cbff94e146e2(options, localStorageKeyProps = $554092f59a7e7485$var$LOCAL_STORAGE_KEY) {
    const counter = (0, $dup7A.useRef)(0);
    counter.current++;
    const defaultValue = typeof options === "boolean" ? options : options == null ? void 0 : options.defaultValue;
    const localStorageKey = typeof options === "boolean" ? localStorageKeyProps ?? $554092f59a7e7485$var$LOCAL_STORAGE_KEY : (options == null ? void 0 : options.localStorageKey) ?? $554092f59a7e7485$var$LOCAL_STORAGE_KEY;
    const initializeWithValue = typeof options === "boolean" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $554092f59a7e7485$export$32d5543ab307c01($554092f59a7e7485$var$COLOR_SCHEME_QUERY, {
        initializeWithValue: initializeWithValue,
        defaultValue: defaultValue
    });
    const [isDarkMode, setDarkMode] = $554092f59a7e7485$export$86e2cef2561044ac(localStorageKey, defaultValue ?? isDarkOS ?? false, {
        initializeWithValue: initializeWithValue
    });
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        if (isDarkOS !== isDarkMode) setDarkMode(isDarkOS);
    }, [
        isDarkOS
    ]);
    return {
        isDarkMode: isDarkMode,
        toggle: ()=>{
            setDarkMode((prev)=>!prev);
        },
        enable: ()=>{
            setDarkMode(true);
        },
        disable: ()=>{
            setDarkMode(false);
        },
        set: (value)=>{
            setDarkMode(value);
        }
    };
}
function $554092f59a7e7485$export$21805fee57372823(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, $dup7A.useState)(value);
    (0, $dup7A.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay ?? 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
function $554092f59a7e7485$export$89e33b3d84d8c331(func) {
    const funcRef = (0, $dup7A.useRef)(func);
    funcRef.current = func;
    (0, $dup7A.useEffect)(()=>()=>{
            funcRef.current();
        }, []);
}
// src/useDebounceCallback/useDebounceCallback.ts
function $554092f59a7e7485$export$40ae01be0011c1e6(func, delay = 500, options) {
    const debouncedFunc = (0, $dup7A.useRef)();
    $554092f59a7e7485$export$89e33b3d84d8c331(()=>{
        if (debouncedFunc.current) debouncedFunc.current.cancel();
    });
    const debounced = (0, $dup7A.useMemo)(()=>{
        const debouncedFuncInstance = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(func, delay, options);
        const wrappedFunc = (...args)=>{
            return debouncedFuncInstance(...args);
        };
        wrappedFunc.cancel = ()=>{
            debouncedFuncInstance.cancel();
        };
        wrappedFunc.isPending = ()=>{
            return !!debouncedFunc.current;
        };
        wrappedFunc.flush = ()=>{
            return debouncedFuncInstance.flush();
        };
        return wrappedFunc;
    }, [
        func,
        delay,
        options
    ]);
    (0, $dup7A.useEffect)(()=>{
        debouncedFunc.current = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(func, delay, options);
    }, [
        func,
        delay,
        options
    ]);
    return debounced;
}
function $554092f59a7e7485$export$52bae15610182273(initialValue, delay, options) {
    const eq = (options == null ? void 0 : options.equalityFn) ?? ((left, right)=>left === right);
    const unwrappedInitialValue = initialValue instanceof Function ? initialValue() : initialValue;
    const [debouncedValue, setDebouncedValue] = (0, $dup7A.useState)(unwrappedInitialValue);
    const previousValueRef = (0, $dup7A.useRef)(unwrappedInitialValue);
    const updateDebouncedValue = $554092f59a7e7485$export$40ae01be0011c1e6(setDebouncedValue, delay, options);
    if (!eq(previousValueRef.current, unwrappedInitialValue)) {
        updateDebouncedValue(unwrappedInitialValue);
        previousValueRef.current = unwrappedInitialValue;
    }
    return [
        debouncedValue,
        updateDebouncedValue
    ];
}
function $554092f59a7e7485$export$4b208edda918084f(title, options = {}) {
    const { preserveTitleOnUnmount: preserveTitleOnUnmount = true } = options;
    const defaultTitle = (0, $dup7A.useRef)(null);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        defaultTitle.current = window.document.title;
    }, []);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        window.document.title = title;
    }, [
        title
    ]);
    $554092f59a7e7485$export$89e33b3d84d8c331(()=>{
        if (!preserveTitleOnUnmount && defaultTitle.current) window.document.title = defaultTitle.current;
    });
}
function $554092f59a7e7485$export$b558662bb0641046(effect) {
    (0, $dup7A.useEffect)(effect, []);
}
function $554092f59a7e7485$export$2b86bedf890eab8(options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const [ref, setRef] = (0, $dup7A.useState)(null);
    const readValue = (0, $dup7A.useCallback)(()=>{
        return {
            width: (ref == null ? void 0 : ref.offsetWidth) ?? void 0,
            height: (ref == null ? void 0 : ref.offsetHeight) ?? void 0
        };
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const [size, setSize] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return {
            width: void 0,
            height: void 0
        };
    });
    const handleSize = (0, $dup7A.useCallback)(()=>{
        setSize(readValue());
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("resize", handleSize);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        handleSize();
    }, [
        ref == null ? void 0 : ref.offsetHeight,
        ref == null ? void 0 : ref.offsetWidth
    ]);
    const result = [
        setRef,
        size
    ];
    result.ref = result[0];
    result.width = size.width;
    result.height = size.height;
    return result;
}
function $554092f59a7e7485$export$d852f5f778460fa4(url, options) {
    const cache = (0, $dup7A.useRef)({});
    const cancelRequest = (0, $dup7A.useRef)(false);
    const initialState = {
        error: void 0,
        data: void 0
    };
    const fetchReducer = (state2, action)=>{
        switch(action.type){
            case "loading":
                return {
                    ...initialState
                };
            case "fetched":
                return {
                    ...initialState,
                    data: action.payload
                };
            case "error":
                return {
                    ...initialState,
                    error: action.payload
                };
            default:
                return state2;
        }
    };
    const [state, dispatch] = (0, $dup7A.useReducer)(fetchReducer, initialState);
    (0, $dup7A.useEffect)(()=>{
        if (!url) return;
        cancelRequest.current = false;
        const fetchData = async ()=>{
            dispatch({
                type: "loading"
            });
            const currentCache = cache.current[url];
            if (currentCache) {
                dispatch({
                    type: "fetched",
                    payload: currentCache
                });
                return;
            }
            try {
                const response = await fetch(url, options);
                if (!response.ok) throw new Error(response.statusText);
                const data = await response.json();
                cache.current[url] = data;
                if (cancelRequest.current) return;
                dispatch({
                    type: "fetched",
                    payload: data
                });
            } catch (error) {
                if (cancelRequest.current) return;
                dispatch({
                    type: "error",
                    payload: error
                });
            }
        };
        fetchData();
        return ()=>{
            cancelRequest.current = true;
        };
    }, [
        url
    ]);
    return state;
}
function $554092f59a7e7485$export$ae780daf29e6d456(elementRef) {
    const [value, setValue] = (0, $dup7A.useState)(false);
    const handleMouseEnter = ()=>{
        setValue(true);
    };
    const handleMouseLeave = ()=>{
        setValue(false);
    };
    $554092f59a7e7485$export$7080b3e976bc91ab("mouseenter", handleMouseEnter, elementRef);
    $554092f59a7e7485$export$7080b3e976bc91ab("mouseleave", handleMouseLeave, elementRef);
    return value;
}
function $554092f59a7e7485$export$c822f44b98c8bbf2() {
    const [isLoaded, setIsLoaded] = (0, $dup7A.useState)(false);
    const handleImageOnLoad = ()=>{
        setIsLoaded(true);
    };
    const css = {
        // Thumbnail style.
        thumbnail: {
            visibility: isLoaded ? "hidden" : "visible",
            filter: "blur(8px)",
            transition: "visibility 0ms ease-out 500ms"
        },
        // Full image style.
        fullSize: {
            opacity: isLoaded ? 1 : 0,
            transition: "opacity 500ms ease-in 0ms"
        }
    };
    return {
        handleImageOnLoad: handleImageOnLoad,
        css: css
    };
}
function $554092f59a7e7485$export$a7395f9832c00176(optionsOrLegacyRef, legacyOptions) {
    var _a;
    const isLegacySignature = "current" in optionsOrLegacyRef;
    const options = isLegacySignature ? legacyOptions : optionsOrLegacyRef;
    const { threshold: threshold = 0, root: root = null, rootMargin: rootMargin = "0%", freezeOnceVisible: freezeOnceVisible = false, initialIsIntersecting: initialIsIntersecting = false } = options ?? {};
    const [newRef, setNewRef] = (0, $dup7A.useState)(null);
    const ref = isLegacySignature ? optionsOrLegacyRef.current : newRef;
    const [state, setState] = (0, $dup7A.useState)(()=>({
            isIntersecting: initialIsIntersecting,
            entry: void 0
        }));
    const callbackRef = (0, $dup7A.useRef)();
    callbackRef.current = options == null ? void 0 : options.onChange;
    const frozen = ((_a = state.entry) == null ? void 0 : _a.isIntersecting) && freezeOnceVisible;
    (0, $dup7A.useEffect)(()=>{
        if (!ref) return;
        if (!("IntersectionObserver" in window)) return;
        if (frozen) return;
        let unobserve;
        const observer = new IntersectionObserver((entries)=>{
            const thresholds = Array.isArray(observer.thresholds) ? observer.thresholds : [
                observer.thresholds
            ];
            entries.forEach((entry)=>{
                const isIntersecting = entry.isIntersecting && thresholds.some((threshold2)=>entry.intersectionRatio >= threshold2);
                setState({
                    isIntersecting: isIntersecting,
                    entry: entry
                });
                if (callbackRef.current) callbackRef.current(isIntersecting, entry);
                if (isIntersecting && freezeOnceVisible && unobserve) {
                    unobserve();
                    unobserve = void 0;
                }
            });
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        observer.observe(ref);
        return ()=>{
            observer.disconnect();
        };
    }, [
        ref,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(threshold),
        root,
        rootMargin,
        frozen,
        freezeOnceVisible
    ]);
    const prevRef = (0, $dup7A.useRef)(null);
    (0, $dup7A.useEffect)(()=>{
        var _a2;
        if (!ref && ((_a2 = state.entry) == null ? void 0 : _a2.target) && !freezeOnceVisible && !frozen && prevRef.current !== state.entry.target) {
            prevRef.current = state.entry.target;
            setState({
                isIntersecting: initialIsIntersecting,
                entry: void 0
            });
        }
    }, [
        ref,
        state.entry,
        freezeOnceVisible,
        frozen,
        initialIsIntersecting
    ]);
    if (isLegacySignature) return state.entry;
    const result = [
        setNewRef,
        !!state.isIntersecting,
        state.entry
    ];
    result.ref = result[0];
    result.isIntersecting = result[1];
    result.entry = result[2];
    return result;
}
function $554092f59a7e7485$export$7c8949515a63d2a1() {
    const [isClient, setClient] = (0, $dup7A.useState)(false);
    (0, $dup7A.useEffect)(()=>{
        setClient(true);
    }, []);
    return isClient;
}
function $554092f59a7e7485$export$5964c316e853650f() {
    const isFirst = (0, $dup7A.useRef)(true);
    if (isFirst.current) {
        isFirst.current = false;
        return true;
    }
    return isFirst.current;
}
function $554092f59a7e7485$export$80c2a3957bcb42ea() {
    const isMounted = (0, $dup7A.useRef)(false);
    (0, $dup7A.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return (0, $dup7A.useCallback)(()=>isMounted.current, []);
}
function $554092f59a7e7485$export$314db5846aaeae6e(initialLocked = false, rootId = "___gatsby") {
    const [locked, setLocked] = (0, $dup7A.useState)(initialLocked);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        if (!locked) return;
        const originalOverflow = document.body.style.overflow;
        const originalPaddingRight = document.body.style.paddingRight;
        document.body.style.overflow = "hidden";
        const root = document.getElementById(rootId);
        const scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        if (scrollBarWidth) document.body.style.paddingRight = `${scrollBarWidth}px`;
        return ()=>{
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) document.body.style.paddingRight = originalPaddingRight;
        };
    }, [
        locked
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (locked !== initialLocked) setLocked(initialLocked);
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
function $554092f59a7e7485$export$86f8f9f08863e403(initialState = /* @__PURE__ */ new Map()) {
    const [map, setMap] = (0, $dup7A.useState)(new Map(initialState));
    const actions = {
        set: (0, $dup7A.useCallback)((key, value)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.set(key, value);
                return copy;
            });
        }, []),
        setAll: (0, $dup7A.useCallback)((entries)=>{
            setMap(()=>new Map(entries));
        }, []),
        remove: (0, $dup7A.useCallback)((key)=>{
            setMap((prev)=>{
                const copy = new Map(prev);
                copy.delete(key);
                return copy;
            });
        }, []),
        reset: (0, $dup7A.useCallback)(()=>{
            setMap(()=>/* @__PURE__ */ new Map());
        }, [])
    };
    return [
        map,
        actions
    ];
}
// src/useOnClickOutside/useOnClickOutside.ts
function $554092f59a7e7485$export$9afc64c180e82dc4(ref, handler, eventType = "mousedown") {
    $554092f59a7e7485$export$7080b3e976bc91ab(eventType, (event)=>{
        const target = event.target;
        if (!target || !target.isConnected) return;
        const isOutside = Array.isArray(ref) ? ref.every((r)=>r.current && !r.current.contains(target)) : ref.current && !ref.current.contains(target);
        if (isOutside) handler(event);
    });
}
var $554092f59a7e7485$var$IS_SERVER3 = typeof window === "undefined";
function $554092f59a7e7485$export$558ff211cfc1c1fe(key, options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($554092f59a7e7485$var$IS_SERVER3) initializeWithValue = false;
    const deserializer = (0, $dup7A.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return null;
        }
        return parsed;
    }, [
        options
    ]);
    const readValue = (0, $dup7A.useCallback)(()=>{
        if ($554092f59a7e7485$var$IS_SERVER3) return null;
        try {
            const raw = window.localStorage.getItem(key);
            return raw ? deserializer(raw) : null;
        } catch (error) {
            console.warn(`Error reading localStorage key \u201C${key}\u201D:`, error);
            return null;
        }
    }, [
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return void 0;
    });
    (0, $dup7A.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $dup7A.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("storage", handleStorageChange);
    $554092f59a7e7485$export$7080b3e976bc91ab("local-storage", handleStorageChange);
    return storedValue;
}
var $554092f59a7e7485$var$initialSize = {
    width: void 0,
    height: void 0
};
function $554092f59a7e7485$export$683480f191c0e3ea(options) {
    const { ref: ref, box: box = "content-box" } = options;
    const [{ width: width, height: height }, setSize] = (0, $dup7A.useState)($554092f59a7e7485$var$initialSize);
    const isMounted = $554092f59a7e7485$export$80c2a3957bcb42ea();
    const previousSize = (0, $dup7A.useRef)({
        ...$554092f59a7e7485$var$initialSize
    });
    const onResize = (0, $dup7A.useRef)(void 0);
    onResize.current = options == null ? void 0 : options.onResize;
    (0, $dup7A.useEffect)(()=>{
        if (!(ref == null ? void 0 : ref.current)) return;
        if (typeof window === "undefined" || !("ResizeObserver" in window)) return;
        const observer = new ResizeObserver(([entry])=>{
            const boxProp = box === "border-box" ? "borderBoxSize" : box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
            const newWidth = $554092f59a7e7485$var$extractSize(entry, boxProp, "inlineSize");
            const newHeight = $554092f59a7e7485$var$extractSize(entry, boxProp, "blockSize");
            const hasChanged = previousSize.current.width !== newWidth || previousSize.current.height !== newHeight;
            if (hasChanged) {
                const newSize = {
                    width: newWidth,
                    height: newHeight
                };
                previousSize.current.width = newWidth;
                previousSize.current.height = newHeight;
                if (onResize == null ? void 0 : onResize.current) onResize.current(newSize);
                else if (isMounted()) setSize(newSize);
            }
        });
        observer.observe(ref.current, {
            box: box
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        box,
        ref,
        isMounted
    ]);
    return {
        width: width,
        height: height
    };
}
function $554092f59a7e7485$var$extractSize(entry, box, sizeType) {
    if (!entry[box]) {
        if (box === "contentBoxSize") return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
        return void 0;
    }
    return Array.isArray(entry[box]) ? entry[box][0][sizeType] : // @ts-ignore Support Firefox's non-standard behavior
    entry[box][sizeType];
}
var $554092f59a7e7485$var$IS_SERVER4 = typeof window === "undefined";
function $554092f59a7e7485$export$654d3fb7a8fef387(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($554092f59a7e7485$var$IS_SERVER4) initializeWithValue = false;
    const readScreen = ()=>{
        if ($554092f59a7e7485$var$IS_SERVER4) return void 0;
        return window.screen;
    };
    const [screen, setScreen] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readScreen();
        return void 0;
    });
    const debouncedSetScreen = $554092f59a7e7485$export$40ae01be0011c1e6(setScreen, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const newScreen = readScreen();
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetScreen : setScreen;
        if (newScreen) {
            const { width: width, height: height, availHeight: availHeight, availWidth: availWidth, colorDepth: colorDepth, orientation: orientation, pixelDepth: pixelDepth } = newScreen;
            setSize({
                width: width,
                height: height,
                availHeight: availHeight,
                availWidth: availWidth,
                colorDepth: colorDepth,
                orientation: orientation,
                pixelDepth: pixelDepth
            });
        }
    }
    $554092f59a7e7485$export$7080b3e976bc91ab("resize", handleSize);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return screen;
}
var $554092f59a7e7485$var$cachedScriptStatuses = /* @__PURE__ */ new Map();
function $554092f59a7e7485$var$getScriptNode(src) {
    const node = document.querySelector(`script[src="${src}"]`);
    const status = node == null ? void 0 : node.getAttribute("data-status");
    return {
        node: node,
        status: status
    };
}
function $554092f59a7e7485$export$1d3955b0b5cace9c(src, options) {
    const [status, setStatus] = (0, $dup7A.useState)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return "idle";
        if (typeof window === "undefined") return "loading";
        return $554092f59a7e7485$var$cachedScriptStatuses.get(src) ?? "loading";
    });
    (0, $dup7A.useEffect)(()=>{
        if (!src || (options == null ? void 0 : options.shouldPreventLoad)) return;
        const cachedScriptStatus = $554092f59a7e7485$var$cachedScriptStatuses.get(src);
        if (cachedScriptStatus === "ready" || cachedScriptStatus === "error") {
            setStatus(cachedScriptStatus);
            return;
        }
        const script = $554092f59a7e7485$var$getScriptNode(src);
        let scriptNode = script.node;
        if (!scriptNode) {
            scriptNode = document.createElement("script");
            scriptNode.src = src;
            scriptNode.async = true;
            if (options == null ? void 0 : options.id) scriptNode.id = options.id;
            scriptNode.setAttribute("data-status", "loading");
            document.body.appendChild(scriptNode);
            const setAttributeFromEvent = (event)=>{
                const scriptStatus = event.type === "load" ? "ready" : "error";
                scriptNode == null || scriptNode.setAttribute("data-status", scriptStatus);
            };
            scriptNode.addEventListener("load", setAttributeFromEvent);
            scriptNode.addEventListener("error", setAttributeFromEvent);
        } else setStatus(script.status ?? cachedScriptStatus ?? "loading");
        const setStateFromEvent = (event)=>{
            const newStatus = event.type === "load" ? "ready" : "error";
            setStatus(newStatus);
            $554092f59a7e7485$var$cachedScriptStatuses.set(src, newStatus);
        };
        scriptNode.addEventListener("load", setStateFromEvent);
        scriptNode.addEventListener("error", setStateFromEvent);
        return ()=>{
            if (scriptNode) {
                scriptNode.removeEventListener("load", setStateFromEvent);
                scriptNode.removeEventListener("error", setStateFromEvent);
            }
            if (scriptNode && (options == null ? void 0 : options.removeOnUnmount)) {
                scriptNode.remove();
                $554092f59a7e7485$var$cachedScriptStatuses.delete(src);
            }
        };
    }, [
        src,
        options == null ? void 0 : options.shouldPreventLoad,
        options == null ? void 0 : options.removeOnUnmount,
        options == null ? void 0 : options.id
    ]);
    return status;
}
var $554092f59a7e7485$var$IS_SERVER5 = typeof window === "undefined";
function $554092f59a7e7485$export$e47ba1b900da5d3b(options = {}) {
    const { autoLock: autoLock = true, lockTarget: lockTarget, widthReflow: widthReflow = true } = options;
    const [isLocked, setIsLocked] = (0, $dup7A.useState)(false);
    const target = (0, $dup7A.useRef)(null);
    const originalStyle = (0, $dup7A.useRef)(null);
    const lock = ()=>{
        if (target.current) {
            const { overflow: overflow, paddingRight: paddingRight } = target.current.style;
            originalStyle.current = {
                overflow: overflow,
                paddingRight: paddingRight
            };
            if (widthReflow) {
                const offsetWidth = target.current === document.body ? window.innerWidth : target.current.offsetWidth;
                const currentPaddingRight = parseInt(window.getComputedStyle(target.current).paddingRight, 10) || 0;
                const scrollbarWidth = offsetWidth - target.current.scrollWidth;
                target.current.style.paddingRight = `${scrollbarWidth + currentPaddingRight}px`;
            }
            target.current.style.overflow = "hidden";
            setIsLocked(true);
        }
    };
    const unlock = ()=>{
        if (target.current && originalStyle.current) {
            target.current.style.overflow = originalStyle.current.overflow;
            if (widthReflow) target.current.style.paddingRight = originalStyle.current.paddingRight;
        }
        setIsLocked(false);
    };
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        if ($554092f59a7e7485$var$IS_SERVER5) return;
        if (lockTarget) target.current = typeof lockTarget === "string" ? document.querySelector(lockTarget) : lockTarget;
        if (!target.current) target.current = document.body;
        if (autoLock) lock();
        return ()=>{
            unlock();
        };
    }, [
        autoLock,
        lockTarget,
        widthReflow
    ]);
    return {
        isLocked: isLocked,
        lock: lock,
        unlock: unlock
    };
}
var $554092f59a7e7485$var$IS_SERVER6 = typeof window === "undefined";
function $554092f59a7e7485$export$864b6828bd07eda6(key, initialValue, options = {}) {
    const { initializeWithValue: initializeWithValue = true } = options;
    const serializer = (0, $dup7A.useCallback)((value)=>{
        if (options.serializer) return options.serializer(value);
        return JSON.stringify(value);
    }, [
        options
    ]);
    const deserializer = (0, $dup7A.useCallback)((value)=>{
        if (options.deserializer) return options.deserializer(value);
        if (value === "undefined") return void 0;
        const defaultValue = initialValue instanceof Function ? initialValue() : initialValue;
        let parsed;
        try {
            parsed = JSON.parse(value);
        } catch (error) {
            console.error("Error parsing JSON:", error);
            return defaultValue;
        }
        return parsed;
    }, [
        options,
        initialValue
    ]);
    const readValue = (0, $dup7A.useCallback)(()=>{
        const initialValueToUse = initialValue instanceof Function ? initialValue() : initialValue;
        if ($554092f59a7e7485$var$IS_SERVER6) return initialValueToUse;
        try {
            const raw = window.sessionStorage.getItem(key);
            return raw ? deserializer(raw) : initialValueToUse;
        } catch (error) {
            console.warn(`Error reading sessionStorage key \u201C${key}\u201D:`, error);
            return initialValueToUse;
        }
    }, [
        initialValue,
        key,
        deserializer
    ]);
    const [storedValue, setStoredValue] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return readValue();
        return initialValue instanceof Function ? initialValue() : initialValue;
    });
    const setValue = $554092f59a7e7485$export$ee5b5d04074a389e((value)=>{
        if ($554092f59a7e7485$var$IS_SERVER6) console.warn(`Tried setting sessionStorage key \u201C${key}\u201D even though environment is not a client`);
        try {
            const newValue = value instanceof Function ? value(readValue()) : value;
            window.sessionStorage.setItem(key, serializer(newValue));
            setStoredValue(newValue);
            window.dispatchEvent(new StorageEvent("session-storage", {
                key: key
            }));
        } catch (error) {
            console.warn(`Error setting sessionStorage key \u201C${key}\u201D:`, error);
        }
    });
    (0, $dup7A.useEffect)(()=>{
        setStoredValue(readValue());
    }, [
        key
    ]);
    const handleStorageChange = (0, $dup7A.useCallback)((event)=>{
        if ((event == null ? void 0 : event.key) && event.key !== key) return;
        setStoredValue(readValue());
    }, [
        key,
        readValue
    ]);
    $554092f59a7e7485$export$7080b3e976bc91ab("storage", handleStorageChange);
    $554092f59a7e7485$export$7080b3e976bc91ab("session-storage", handleStorageChange);
    return [
        storedValue,
        setValue
    ];
}
// src/useSsr/useSsr.ts
function $554092f59a7e7485$export$f4eafc809f5e6ccc() {
    var _a;
    const isDOM = // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    typeof window !== "undefined" && !!((_a = window == null ? void 0 : window.document) == null ? void 0 : _a.documentElement);
    return {
        isBrowser: isDOM,
        isServer: !isDOM
    };
}
function $554092f59a7e7485$export$7896576cb7635832(maxStep) {
    const [currentStep, setCurrentStep] = (0, $dup7A.useState)(1);
    const canGoToNextStep = currentStep + 1 <= maxStep;
    const canGoToPrevStep = currentStep - 1 > 0;
    const setStep = (0, $dup7A.useCallback)((step)=>{
        const newStep = step instanceof Function ? step(currentStep) : step;
        if (newStep >= 1 && newStep <= maxStep) {
            setCurrentStep(newStep);
            return;
        }
        throw new Error("Step not valid");
    }, [
        maxStep,
        currentStep
    ]);
    const goToNextStep = (0, $dup7A.useCallback)(()=>{
        if (canGoToNextStep) setCurrentStep((step)=>step + 1);
    }, [
        canGoToNextStep
    ]);
    const goToPrevStep = (0, $dup7A.useCallback)(()=>{
        if (canGoToPrevStep) setCurrentStep((step)=>step - 1);
    }, [
        canGoToPrevStep
    ]);
    const reset = (0, $dup7A.useCallback)(()=>{
        setCurrentStep(1);
    }, []);
    return [
        currentStep,
        {
            goToNextStep: goToNextStep,
            goToPrevStep: goToPrevStep,
            canGoToNextStep: canGoToNextStep,
            canGoToPrevStep: canGoToPrevStep,
            setStep: setStep,
            reset: reset
        }
    ];
}
// src/useTernaryDarkMode/useTernaryDarkMode.ts
var $554092f59a7e7485$var$COLOR_SCHEME_QUERY2 = "(prefers-color-scheme: dark)";
var $554092f59a7e7485$var$LOCAL_STORAGE_KEY2 = "usehooks-ts-ternary-dark-mode";
function $554092f59a7e7485$export$ec561688e440eda6(options) {
    const defaultValue = typeof options === "string" ? "system" : (options == null ? void 0 : options.defaultValue) ?? "system";
    const localStorageKey = typeof options === "string" ? options : (options == null ? void 0 : options.localStorageKey) ?? $554092f59a7e7485$var$LOCAL_STORAGE_KEY2;
    const initializeWithValue = typeof options === "string" ? void 0 : (options == null ? void 0 : options.initializeWithValue) ?? void 0;
    const isDarkOS = $554092f59a7e7485$export$32d5543ab307c01($554092f59a7e7485$var$COLOR_SCHEME_QUERY2, {
        initializeWithValue: initializeWithValue
    });
    const [mode, setMode] = $554092f59a7e7485$export$86e2cef2561044ac(localStorageKey, defaultValue, {
        initializeWithValue: initializeWithValue
    });
    const isDarkMode = mode === "dark" || mode === "system" && isDarkOS;
    const toggleTernaryDarkMode = ()=>{
        const modes = [
            "light",
            "system",
            "dark"
        ];
        setMode((prevMode)=>{
            const nextIndex = (modes.indexOf(prevMode) + 1) % modes.length;
            return modes[nextIndex];
        });
    };
    return {
        isDarkMode: isDarkMode,
        ternaryDarkMode: mode,
        setTernaryDarkMode: setMode,
        toggleTernaryDarkMode: toggleTernaryDarkMode
    };
}
function $554092f59a7e7485$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $dup7A.useRef)(callback);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>{
            savedCallback.current();
        }, delay);
        return ()=>{
            clearTimeout(id);
        };
    }, [
        delay
    ]);
}
function $554092f59a7e7485$export$cbe85ee05b554577(defaultValue) {
    const [value, setValue] = (0, $dup7A.useState)(!!defaultValue);
    const toggle = (0, $dup7A.useCallback)(()=>{
        setValue((x)=>!x);
    }, []);
    return [
        value,
        toggle,
        setValue
    ];
}
function $554092f59a7e7485$export$496315a1608d9602(effect, deps) {
    const isFirst = $554092f59a7e7485$export$5964c316e853650f();
    (0, $dup7A.useEffect)(()=>{
        if (!isFirst) return effect();
    }, deps);
}
var $554092f59a7e7485$var$IS_SERVER7 = typeof window === "undefined";
function $554092f59a7e7485$export$42c02f33970a2afa(options = {}) {
    let { initializeWithValue: initializeWithValue = true } = options;
    if ($554092f59a7e7485$var$IS_SERVER7) initializeWithValue = false;
    const [windowSize, setWindowSize] = (0, $dup7A.useState)(()=>{
        if (initializeWithValue) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        return {
            width: void 0,
            height: void 0
        };
    });
    const debouncedSetWindowSize = $554092f59a7e7485$export$40ae01be0011c1e6(setWindowSize, options == null ? void 0 : options.debounceDelay);
    function handleSize() {
        const setSize = (options == null ? void 0 : options.debounceDelay) ? debouncedSetWindowSize : setWindowSize;
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    }
    $554092f59a7e7485$export$7080b3e976bc91ab("resize", handleSize);
    $554092f59a7e7485$export$700979bc83e7db82(()=>{
        handleSize();
    }, []);
    return windowSize;
}


var $bbbd8fadaf5f7664$exports = {};

$parcel$defineInteropFlag($bbbd8fadaf5f7664$exports);

$parcel$export($bbbd8fadaf5f7664$exports, "default", () => $bbbd8fadaf5f7664$export$2e2bcd8739ae039);
/**
 * simplebar-react - v2.4.3
 * React component for SimpleBar
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat
 * Under MIT License
 */ 
var $dup7A = parcelRequire("dup7A");
var $4cb0dfe46d0c49b6$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4cb0dfe46d0c49b6$var$ReactIs, $4cb0dfe46d0c49b6$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$4cb0dfe46d0c49b6$exports = (parcelRequire("hWy5B"))();


/**
 * SimpleBar.js - v5.3.9
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ 'use strict';
var $9fd0241d8f6d7609$exports = {};
'use strict';
var $37a62429f4992eb4$exports = {};
'use strict';
var $37a62429f4992eb4$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$37a62429f4992eb4$exports = // eslint-disable-next-line es/no-global-this -- safe
$37a62429f4992eb4$var$check(typeof globalThis == 'object' && globalThis) || $37a62429f4992eb4$var$check(typeof window == 'object' && window) || // eslint-disable-next-line no-restricted-globals -- safe
$37a62429f4992eb4$var$check(typeof self == 'object' && self) || $37a62429f4992eb4$var$check(typeof $parcel$global == 'object' && $parcel$global) || $37a62429f4992eb4$var$check(typeof $37a62429f4992eb4$exports == 'object' && $37a62429f4992eb4$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function('return this')();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $677b298e8fc869eb$export$2d1720544b23b823;
'use strict';
var $cea8a7c76ccddf5d$exports = {};
'use strict';
var $1aa9995203de1dcd$exports = {};
'use strict';
$1aa9995203de1dcd$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$cea8a7c76ccddf5d$exports = !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $6e06bffcfb3013e2$exports = {};
'use strict';
var $e337c262a4702797$exports = {};
'use strict';

$e337c262a4702797$exports = !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != 'function' || test.hasOwnProperty('prototype');
});


var $6e06bffcfb3013e2$var$call = Function.prototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
$6e06bffcfb3013e2$exports = $e337c262a4702797$exports ? $6e06bffcfb3013e2$var$call.bind($6e06bffcfb3013e2$var$call) : function() {
    return $6e06bffcfb3013e2$var$call.apply($6e06bffcfb3013e2$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $1e07dffcb0f5b7ce$export$2d1720544b23b823;
'use strict';
var $1e07dffcb0f5b7ce$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $1e07dffcb0f5b7ce$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $1e07dffcb0f5b7ce$var$NASHORN_BUG = $1e07dffcb0f5b7ce$var$getOwnPropertyDescriptor && !$1e07dffcb0f5b7ce$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$1e07dffcb0f5b7ce$export$2d1720544b23b823 = $1e07dffcb0f5b7ce$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $1e07dffcb0f5b7ce$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $1e07dffcb0f5b7ce$var$$propertyIsEnumerable;


var $2159f71bcf7ac44a$exports = {};
'use strict';
$2159f71bcf7ac44a$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $4115d950804b1b04$exports = {};
'use strict';
var $ef1b385171038d0e$exports = {};
'use strict';
var $3d3a3f96d04dfa01$exports = {};
'use strict';

var $3d3a3f96d04dfa01$var$FunctionPrototype = Function.prototype;
var $3d3a3f96d04dfa01$var$call = $3d3a3f96d04dfa01$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind -- safe
var $3d3a3f96d04dfa01$var$uncurryThisWithBind = $e337c262a4702797$exports && $3d3a3f96d04dfa01$var$FunctionPrototype.bind.bind($3d3a3f96d04dfa01$var$call, $3d3a3f96d04dfa01$var$call);
$3d3a3f96d04dfa01$exports = $e337c262a4702797$exports ? $3d3a3f96d04dfa01$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $3d3a3f96d04dfa01$var$call.apply(fn, arguments);
    };
};



var $3a0f0fc82e93bd49$exports = {};
'use strict';

var $3a0f0fc82e93bd49$var$toString = $3d3a3f96d04dfa01$exports({}.toString);
var $3a0f0fc82e93bd49$var$stringSlice = $3d3a3f96d04dfa01$exports(''.slice);
$3a0f0fc82e93bd49$exports = function(it) {
    return $3a0f0fc82e93bd49$var$stringSlice($3a0f0fc82e93bd49$var$toString(it), 8, -1);
};


var $ef1b385171038d0e$var$$Object = Object;
var $ef1b385171038d0e$var$split = $3d3a3f96d04dfa01$exports(''.split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$ef1b385171038d0e$exports = $1aa9995203de1dcd$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$ef1b385171038d0e$var$$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return $3a0f0fc82e93bd49$exports(it) === 'String' ? $ef1b385171038d0e$var$split(it, '') : $ef1b385171038d0e$var$$Object(it);
} : $ef1b385171038d0e$var$$Object;


var $938881b1bb81812d$exports = {};
'use strict';
var $c3e80151589b4ea3$exports = {};
'use strict';
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$c3e80151589b4ea3$exports = function(it) {
    return it === null || it === undefined;
};


var $938881b1bb81812d$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$938881b1bb81812d$exports = function(it) {
    if ($c3e80151589b4ea3$exports(it)) throw new $938881b1bb81812d$var$$TypeError("Can't call method on " + it);
    return it;
};


$4115d950804b1b04$exports = function(it) {
    return $ef1b385171038d0e$exports($938881b1bb81812d$exports(it));
};


var $895a336d320ed309$exports = {};
'use strict';
var $a9b0addf205e517d$exports = {};
'use strict';

var $d1de49472bdc582c$exports = {};
'use strict';
var $e8bca5b64a857b1a$exports = {};
'use strict';
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $e8bca5b64a857b1a$var$documentAll = typeof document == 'object' && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$e8bca5b64a857b1a$exports = typeof $e8bca5b64a857b1a$var$documentAll == 'undefined' && $e8bca5b64a857b1a$var$documentAll !== undefined ? function(argument) {
    return typeof argument == 'function' || argument === $e8bca5b64a857b1a$var$documentAll;
} : function(argument) {
    return typeof argument == 'function';
};


$d1de49472bdc582c$exports = function(it) {
    return typeof it == 'object' ? it !== null : $e8bca5b64a857b1a$exports(it);
};


var $955cd9ff3d5b5e2b$exports = {};
'use strict';
var $e5002032510f09f3$exports = {};
'use strict';


var $e5002032510f09f3$var$aFunction = function(argument) {
    return $e8bca5b64a857b1a$exports(argument) ? argument : undefined;
};
$e5002032510f09f3$exports = function(namespace, method) {
    return arguments.length < 2 ? $e5002032510f09f3$var$aFunction($37a62429f4992eb4$exports[namespace]) : $37a62429f4992eb4$exports[namespace] && $37a62429f4992eb4$exports[namespace][method];
};



var $13b911265f6ed62e$exports = {};
'use strict';

$13b911265f6ed62e$exports = $3d3a3f96d04dfa01$exports({}.isPrototypeOf);


var $ceb90b1122b4e599$exports = {};
'use strict';
var $07701a9f16daf6f5$exports = {};
'use strict';
var $800ddfa01b593c5d$exports = {};
'use strict';

var $d51ceacb4a64d873$exports = {};
'use strict';

var $d51ceacb4a64d873$var$navigator = $37a62429f4992eb4$exports.navigator;
var $d51ceacb4a64d873$var$userAgent = $d51ceacb4a64d873$var$navigator && $d51ceacb4a64d873$var$navigator.userAgent;
$d51ceacb4a64d873$exports = $d51ceacb4a64d873$var$userAgent ? String($d51ceacb4a64d873$var$userAgent) : '';


var $800ddfa01b593c5d$var$process = $37a62429f4992eb4$exports.process;
var $800ddfa01b593c5d$var$Deno = $37a62429f4992eb4$exports.Deno;
var $800ddfa01b593c5d$var$versions = $800ddfa01b593c5d$var$process && $800ddfa01b593c5d$var$process.versions || $800ddfa01b593c5d$var$Deno && $800ddfa01b593c5d$var$Deno.version;
var $800ddfa01b593c5d$var$v8 = $800ddfa01b593c5d$var$versions && $800ddfa01b593c5d$var$versions.v8;
var $800ddfa01b593c5d$var$match, $800ddfa01b593c5d$var$version;
if ($800ddfa01b593c5d$var$v8) {
    $800ddfa01b593c5d$var$match = $800ddfa01b593c5d$var$v8.split('.');
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $800ddfa01b593c5d$var$version = $800ddfa01b593c5d$var$match[0] > 0 && $800ddfa01b593c5d$var$match[0] < 4 ? 1 : +($800ddfa01b593c5d$var$match[0] + $800ddfa01b593c5d$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$800ddfa01b593c5d$var$version && $d51ceacb4a64d873$exports) {
    $800ddfa01b593c5d$var$match = $d51ceacb4a64d873$exports.match(/Edge\/(\d+)/);
    if (!$800ddfa01b593c5d$var$match || $800ddfa01b593c5d$var$match[1] >= 74) {
        $800ddfa01b593c5d$var$match = $d51ceacb4a64d873$exports.match(/Chrome\/(\d+)/);
        if ($800ddfa01b593c5d$var$match) $800ddfa01b593c5d$var$version = +$800ddfa01b593c5d$var$match[1];
    }
}
$800ddfa01b593c5d$exports = $800ddfa01b593c5d$var$version;




var $07701a9f16daf6f5$var$$String = $37a62429f4992eb4$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$07701a9f16daf6f5$exports = !!Object.getOwnPropertySymbols && !$1aa9995203de1dcd$exports(function() {
    var symbol = Symbol('symbol detection');
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$07701a9f16daf6f5$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $800ddfa01b593c5d$exports && $800ddfa01b593c5d$exports < 41;
});


$ceb90b1122b4e599$exports = $07701a9f16daf6f5$exports && !Symbol.sham && typeof Symbol.iterator == 'symbol';


var $955cd9ff3d5b5e2b$var$$Object = Object;
$955cd9ff3d5b5e2b$exports = $ceb90b1122b4e599$exports ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    var $Symbol = $e5002032510f09f3$exports('Symbol');
    return $e8bca5b64a857b1a$exports($Symbol) && $13b911265f6ed62e$exports($Symbol.prototype, $955cd9ff3d5b5e2b$var$$Object(it));
};


var $af183ff3a7a0320f$exports = {};
'use strict';
var $5f7d5e7ccafe12e0$exports = {};
'use strict';

var $0ee3ded6653f158b$exports = {};
'use strict';
var $0ee3ded6653f158b$var$$String = String;
$0ee3ded6653f158b$exports = function(argument) {
    try {
        return $0ee3ded6653f158b$var$$String(argument);
    } catch (error) {
        return 'Object';
    }
};


var $5f7d5e7ccafe12e0$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$5f7d5e7ccafe12e0$exports = function(argument) {
    if ($e8bca5b64a857b1a$exports(argument)) return argument;
    throw new $5f7d5e7ccafe12e0$var$$TypeError($0ee3ded6653f158b$exports(argument) + ' is not a function');
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$af183ff3a7a0320f$exports = function(V, P) {
    var func = V[P];
    return $c3e80151589b4ea3$exports(func) ? undefined : $5f7d5e7ccafe12e0$exports(func);
};


var $9c2bdf28b02ea4f2$exports = {};
'use strict';



var $9c2bdf28b02ea4f2$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$9c2bdf28b02ea4f2$exports = function(input, pref) {
    var fn, val;
    if (pref === 'string' && $e8bca5b64a857b1a$exports(fn = input.toString) && !$d1de49472bdc582c$exports(val = $6e06bffcfb3013e2$exports(fn, input))) return val;
    if ($e8bca5b64a857b1a$exports(fn = input.valueOf) && !$d1de49472bdc582c$exports(val = $6e06bffcfb3013e2$exports(fn, input))) return val;
    if (pref !== 'string' && $e8bca5b64a857b1a$exports(fn = input.toString) && !$d1de49472bdc582c$exports(val = $6e06bffcfb3013e2$exports(fn, input))) return val;
    throw new $9c2bdf28b02ea4f2$var$$TypeError("Can't convert object to primitive value");
};


var $83f1bf79efdf35c6$exports = {};
'use strict';

var $3231f6153a88e373$exports = {};
'use strict';
var $9485ff83f3c32d3e$exports = {};
'use strict';
var $3d49ff5c72fb9ed5$exports = {};
'use strict';
$3d49ff5c72fb9ed5$exports = false;



var $305fdd2dd2be7f81$exports = {};
'use strict';

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $305fdd2dd2be7f81$var$defineProperty = Object.defineProperty;
$305fdd2dd2be7f81$exports = function(key, value) {
    try {
        $305fdd2dd2be7f81$var$defineProperty($37a62429f4992eb4$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $37a62429f4992eb4$exports[key] = value;
    }
    return value;
};


var $9485ff83f3c32d3e$var$SHARED = '__core-js_shared__';
var $9485ff83f3c32d3e$var$store = $9485ff83f3c32d3e$exports = $37a62429f4992eb4$exports[$9485ff83f3c32d3e$var$SHARED] || $305fdd2dd2be7f81$exports($9485ff83f3c32d3e$var$SHARED, {});
($9485ff83f3c32d3e$var$store.versions || ($9485ff83f3c32d3e$var$store.versions = [])).push({
    version: '3.42.0',
    mode: $3d49ff5c72fb9ed5$exports ? 'pure' : 'global',
    copyright: "\xa9 2014-2025 Denis Pushkarev (zloirock.ru)",
    license: 'https://github.com/zloirock/core-js/blob/v3.42.0/LICENSE',
    source: 'https://github.com/zloirock/core-js'
});


$3231f6153a88e373$exports = function(key, value) {
    return $9485ff83f3c32d3e$exports[key] || ($9485ff83f3c32d3e$exports[key] = value || {});
};


var $6713471208f796ec$exports = {};
'use strict';

var $476d2ef928fdaf21$exports = {};
'use strict';

var $476d2ef928fdaf21$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$476d2ef928fdaf21$exports = function(argument) {
    return $476d2ef928fdaf21$var$$Object($938881b1bb81812d$exports(argument));
};


var $6713471208f796ec$var$hasOwnProperty = $3d3a3f96d04dfa01$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$6713471208f796ec$exports = Object.hasOwn || function hasOwn(it, key) {
    return $6713471208f796ec$var$hasOwnProperty($476d2ef928fdaf21$exports(it), key);
};


var $2ef1f447bc219aea$exports = {};
'use strict';

var $2ef1f447bc219aea$var$id = 0;
var $2ef1f447bc219aea$var$postfix = Math.random();
var $2ef1f447bc219aea$var$toString = $3d3a3f96d04dfa01$exports(1.0.toString);
$2ef1f447bc219aea$exports = function(key) {
    return 'Symbol(' + (key === undefined ? '' : key) + ')_' + $2ef1f447bc219aea$var$toString(++$2ef1f447bc219aea$var$id + $2ef1f447bc219aea$var$postfix, 36);
};




var $83f1bf79efdf35c6$var$Symbol = $37a62429f4992eb4$exports.Symbol;
var $83f1bf79efdf35c6$var$WellKnownSymbolsStore = $3231f6153a88e373$exports('wks');
var $83f1bf79efdf35c6$var$createWellKnownSymbol = $ceb90b1122b4e599$exports ? $83f1bf79efdf35c6$var$Symbol['for'] || $83f1bf79efdf35c6$var$Symbol : $83f1bf79efdf35c6$var$Symbol && $83f1bf79efdf35c6$var$Symbol.withoutSetter || $2ef1f447bc219aea$exports;
$83f1bf79efdf35c6$exports = function(name) {
    if (!$6713471208f796ec$exports($83f1bf79efdf35c6$var$WellKnownSymbolsStore, name)) $83f1bf79efdf35c6$var$WellKnownSymbolsStore[name] = $07701a9f16daf6f5$exports && $6713471208f796ec$exports($83f1bf79efdf35c6$var$Symbol, name) ? $83f1bf79efdf35c6$var$Symbol[name] : $83f1bf79efdf35c6$var$createWellKnownSymbol('Symbol.' + name);
    return $83f1bf79efdf35c6$var$WellKnownSymbolsStore[name];
};


var $a9b0addf205e517d$var$$TypeError = TypeError;
var $a9b0addf205e517d$var$TO_PRIMITIVE = $83f1bf79efdf35c6$exports('toPrimitive');
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$a9b0addf205e517d$exports = function(input, pref) {
    if (!$d1de49472bdc582c$exports(input) || $955cd9ff3d5b5e2b$exports(input)) return input;
    var exoticToPrim = $af183ff3a7a0320f$exports(input, $a9b0addf205e517d$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = 'default';
        result = $6e06bffcfb3013e2$exports(exoticToPrim, input, pref);
        if (!$d1de49472bdc582c$exports(result) || $955cd9ff3d5b5e2b$exports(result)) return result;
        throw new $a9b0addf205e517d$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = 'number';
    return $9c2bdf28b02ea4f2$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$895a336d320ed309$exports = function(argument) {
    var key = $a9b0addf205e517d$exports(argument, 'string');
    return $955cd9ff3d5b5e2b$exports(key) ? key : key + '';
};



var $ef13e207d9d9012b$exports = {};
'use strict';


var $416f618c0bbd719b$exports = {};
'use strict';


var $416f618c0bbd719b$var$document = $37a62429f4992eb4$exports.document;
// typeof document.createElement is 'object' in old IE
var $416f618c0bbd719b$var$EXISTS = $d1de49472bdc582c$exports($416f618c0bbd719b$var$document) && $d1de49472bdc582c$exports($416f618c0bbd719b$var$document.createElement);
$416f618c0bbd719b$exports = function(it) {
    return $416f618c0bbd719b$var$EXISTS ? $416f618c0bbd719b$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$ef13e207d9d9012b$exports = !$cea8a7c76ccddf5d$exports && !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($416f618c0bbd719b$exports('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $677b298e8fc869eb$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$677b298e8fc869eb$export$2d1720544b23b823 = $cea8a7c76ccddf5d$exports ? $677b298e8fc869eb$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $4115d950804b1b04$exports(O);
    P = $895a336d320ed309$exports(P);
    if ($ef13e207d9d9012b$exports) try {
        return $677b298e8fc869eb$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($6713471208f796ec$exports(O, P)) return $2159f71bcf7ac44a$exports(!$6e06bffcfb3013e2$exports($1e07dffcb0f5b7ce$export$2d1720544b23b823, O, P), O[P]);
};


var $9fd0241d8f6d7609$require$getOwnPropertyDescriptor = $677b298e8fc869eb$export$2d1720544b23b823;
var $d13e1e0ab68f4bd6$exports = {};
'use strict';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $ec8f33e5c924d97f$export$2d1720544b23b823;
'use strict';


var $ac4e947f8a7d92c1$exports = {};
'use strict';


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$ac4e947f8a7d92c1$exports = $cea8a7c76ccddf5d$exports && $1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, 'prototype', {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $2d94e296a4d81142$exports = {};
'use strict';

var $2d94e296a4d81142$var$$String = String;
var $2d94e296a4d81142$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$2d94e296a4d81142$exports = function(argument) {
    if ($d1de49472bdc582c$exports(argument)) return argument;
    throw new $2d94e296a4d81142$var$$TypeError($2d94e296a4d81142$var$$String(argument) + ' is not an object');
};



var $ec8f33e5c924d97f$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $ec8f33e5c924d97f$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ec8f33e5c924d97f$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ec8f33e5c924d97f$var$ENUMERABLE = 'enumerable';
var $ec8f33e5c924d97f$var$CONFIGURABLE = 'configurable';
var $ec8f33e5c924d97f$var$WRITABLE = 'writable';
$ec8f33e5c924d97f$export$2d1720544b23b823 = $cea8a7c76ccddf5d$exports ? $ac4e947f8a7d92c1$exports ? function defineProperty(O, P, Attributes) {
    $2d94e296a4d81142$exports(O);
    P = $895a336d320ed309$exports(P);
    $2d94e296a4d81142$exports(Attributes);
    if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && $ec8f33e5c924d97f$var$WRITABLE in Attributes && !Attributes[$ec8f33e5c924d97f$var$WRITABLE]) {
        var current = $ec8f33e5c924d97f$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$ec8f33e5c924d97f$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $ec8f33e5c924d97f$var$CONFIGURABLE in Attributes ? Attributes[$ec8f33e5c924d97f$var$CONFIGURABLE] : current[$ec8f33e5c924d97f$var$CONFIGURABLE],
                enumerable: $ec8f33e5c924d97f$var$ENUMERABLE in Attributes ? Attributes[$ec8f33e5c924d97f$var$ENUMERABLE] : current[$ec8f33e5c924d97f$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $ec8f33e5c924d97f$var$$defineProperty(O, P, Attributes);
} : $ec8f33e5c924d97f$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $2d94e296a4d81142$exports(O);
    P = $895a336d320ed309$exports(P);
    $2d94e296a4d81142$exports(Attributes);
    if ($ef13e207d9d9012b$exports) try {
        return $ec8f33e5c924d97f$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ('get' in Attributes || 'set' in Attributes) throw new $ec8f33e5c924d97f$var$$TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};



$d13e1e0ab68f4bd6$exports = $cea8a7c76ccddf5d$exports ? function(object, key, value) {
    return $ec8f33e5c924d97f$export$2d1720544b23b823(object, key, $2159f71bcf7ac44a$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $1f4601f39377b637$exports = {};
'use strict';


var $d745cb9bd2dfb659$exports = {};
'use strict';





var $775efe7ab5de3db4$exports = {};
'use strict';


var $775efe7ab5de3db4$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $775efe7ab5de3db4$var$getDescriptor = $cea8a7c76ccddf5d$exports && Object.getOwnPropertyDescriptor;
var $775efe7ab5de3db4$var$EXISTS = $6713471208f796ec$exports($775efe7ab5de3db4$var$FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var $775efe7ab5de3db4$var$PROPER = $775efe7ab5de3db4$var$EXISTS && (function something() {}).name === 'something';
var $775efe7ab5de3db4$var$CONFIGURABLE = $775efe7ab5de3db4$var$EXISTS && (!$cea8a7c76ccddf5d$exports || $cea8a7c76ccddf5d$exports && $775efe7ab5de3db4$var$getDescriptor($775efe7ab5de3db4$var$FunctionPrototype, 'name').configurable);
$775efe7ab5de3db4$exports = {
    EXISTS: $775efe7ab5de3db4$var$EXISTS,
    PROPER: $775efe7ab5de3db4$var$PROPER,
    CONFIGURABLE: $775efe7ab5de3db4$var$CONFIGURABLE
};


var $d745cb9bd2dfb659$require$CONFIGURABLE_FUNCTION_NAME = $775efe7ab5de3db4$exports.CONFIGURABLE;
var $97cff4f00fd83461$exports = {};
'use strict';



var $97cff4f00fd83461$var$functionToString = $3d3a3f96d04dfa01$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$e8bca5b64a857b1a$exports($9485ff83f3c32d3e$exports.inspectSource)) $9485ff83f3c32d3e$exports.inspectSource = function(it) {
    return $97cff4f00fd83461$var$functionToString(it);
};
$97cff4f00fd83461$exports = $9485ff83f3c32d3e$exports.inspectSource;


var $7c2e321de999e766$exports = {};
'use strict';
var $734e17bc28988288$exports = {};
'use strict';


var $734e17bc28988288$var$WeakMap = $37a62429f4992eb4$exports.WeakMap;
$734e17bc28988288$exports = $e8bca5b64a857b1a$exports($734e17bc28988288$var$WeakMap) && /native code/.test(String($734e17bc28988288$var$WeakMap));







var $44039bd971d76cb8$exports = {};
'use strict';


var $44039bd971d76cb8$var$keys = $3231f6153a88e373$exports('keys');
$44039bd971d76cb8$exports = function(key) {
    return $44039bd971d76cb8$var$keys[key] || ($44039bd971d76cb8$var$keys[key] = $2ef1f447bc219aea$exports(key));
};


var $60b0be22ef1af955$exports = {};
'use strict';
$60b0be22ef1af955$exports = {};


var $7c2e321de999e766$var$OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var $7c2e321de999e766$var$TypeError = $37a62429f4992eb4$exports.TypeError;
var $7c2e321de999e766$var$WeakMap = $37a62429f4992eb4$exports.WeakMap;
var $7c2e321de999e766$var$set, $7c2e321de999e766$var$get, $7c2e321de999e766$var$has;
var $7c2e321de999e766$var$enforce = function(it) {
    return $7c2e321de999e766$var$has(it) ? $7c2e321de999e766$var$get(it) : $7c2e321de999e766$var$set(it, {});
};
var $7c2e321de999e766$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$d1de49472bdc582c$exports(it) || (state = $7c2e321de999e766$var$get(it)).type !== TYPE) throw new $7c2e321de999e766$var$TypeError('Incompatible receiver, ' + TYPE + ' required');
        return state;
    };
};
if ($734e17bc28988288$exports || $9485ff83f3c32d3e$exports.state) {
    var $7c2e321de999e766$var$store = $9485ff83f3c32d3e$exports.state || ($9485ff83f3c32d3e$exports.state = new $7c2e321de999e766$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $7c2e321de999e766$var$store.get = $7c2e321de999e766$var$store.get;
    $7c2e321de999e766$var$store.has = $7c2e321de999e766$var$store.has;
    $7c2e321de999e766$var$store.set = $7c2e321de999e766$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $7c2e321de999e766$var$set = function(it, metadata) {
        if ($7c2e321de999e766$var$store.has(it)) throw new $7c2e321de999e766$var$TypeError($7c2e321de999e766$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $7c2e321de999e766$var$store.set(it, metadata);
        return metadata;
    };
    $7c2e321de999e766$var$get = function(it) {
        return $7c2e321de999e766$var$store.get(it) || {};
    };
    $7c2e321de999e766$var$has = function(it) {
        return $7c2e321de999e766$var$store.has(it);
    };
} else {
    var $7c2e321de999e766$var$STATE = $44039bd971d76cb8$exports('state');
    $60b0be22ef1af955$exports[$7c2e321de999e766$var$STATE] = true;
    $7c2e321de999e766$var$set = function(it, metadata) {
        if ($6713471208f796ec$exports(it, $7c2e321de999e766$var$STATE)) throw new $7c2e321de999e766$var$TypeError($7c2e321de999e766$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $d13e1e0ab68f4bd6$exports(it, $7c2e321de999e766$var$STATE, metadata);
        return metadata;
    };
    $7c2e321de999e766$var$get = function(it) {
        return $6713471208f796ec$exports(it, $7c2e321de999e766$var$STATE) ? it[$7c2e321de999e766$var$STATE] : {};
    };
    $7c2e321de999e766$var$has = function(it) {
        return $6713471208f796ec$exports(it, $7c2e321de999e766$var$STATE);
    };
}
$7c2e321de999e766$exports = {
    set: $7c2e321de999e766$var$set,
    get: $7c2e321de999e766$var$get,
    has: $7c2e321de999e766$var$has,
    enforce: $7c2e321de999e766$var$enforce,
    getterFor: $7c2e321de999e766$var$getterFor
};


var $d745cb9bd2dfb659$var$enforceInternalState = $7c2e321de999e766$exports.enforce;
var $d745cb9bd2dfb659$var$getInternalState = $7c2e321de999e766$exports.get;
var $d745cb9bd2dfb659$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $d745cb9bd2dfb659$var$defineProperty = Object.defineProperty;
var $d745cb9bd2dfb659$var$stringSlice = $3d3a3f96d04dfa01$exports(''.slice);
var $d745cb9bd2dfb659$var$replace = $3d3a3f96d04dfa01$exports(''.replace);
var $d745cb9bd2dfb659$var$join = $3d3a3f96d04dfa01$exports([].join);
var $d745cb9bd2dfb659$var$CONFIGURABLE_LENGTH = $cea8a7c76ccddf5d$exports && !$1aa9995203de1dcd$exports(function() {
    return $d745cb9bd2dfb659$var$defineProperty(function() {}, 'length', {
        value: 8
    }).length !== 8;
});
var $d745cb9bd2dfb659$var$TEMPLATE = String(String).split('String');
var $d745cb9bd2dfb659$var$makeBuiltIn = $d745cb9bd2dfb659$exports = function(value, name, options) {
    if ($d745cb9bd2dfb659$var$stringSlice($d745cb9bd2dfb659$var$$String(name), 0, 7) === 'Symbol(') name = '[' + $d745cb9bd2dfb659$var$replace($d745cb9bd2dfb659$var$$String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
    if (options && options.getter) name = 'get ' + name;
    if (options && options.setter) name = 'set ' + name;
    if (!$6713471208f796ec$exports(value, 'name') || $d745cb9bd2dfb659$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($cea8a7c76ccddf5d$exports) $d745cb9bd2dfb659$var$defineProperty(value, 'name', {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($d745cb9bd2dfb659$var$CONFIGURABLE_LENGTH && options && $6713471208f796ec$exports(options, 'arity') && value.length !== options.arity) $d745cb9bd2dfb659$var$defineProperty(value, 'length', {
        value: options.arity
    });
    try {
        if (options && $6713471208f796ec$exports(options, 'constructor') && options.constructor) {
            if ($cea8a7c76ccddf5d$exports) $d745cb9bd2dfb659$var$defineProperty(value, 'prototype', {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $d745cb9bd2dfb659$var$enforceInternalState(value);
    if (!$6713471208f796ec$exports(state, 'source')) state.source = $d745cb9bd2dfb659$var$join($d745cb9bd2dfb659$var$TEMPLATE, typeof name == 'string' ? name : '');
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $d745cb9bd2dfb659$var$makeBuiltIn(function toString() {
    return $e8bca5b64a857b1a$exports(this) && $d745cb9bd2dfb659$var$getInternalState(this).source || $97cff4f00fd83461$exports(this);
}, 'toString');



$1f4601f39377b637$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($e8bca5b64a857b1a$exports(value)) $d745cb9bd2dfb659$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $305fdd2dd2be7f81$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $ec8f33e5c924d97f$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $ecce2f9545dca589$exports = {};
'use strict';

var $da5dee507eb1b7b3$exports = {};
'use strict';


var $eb3ab2cab8ae8671$exports = {};

$parcel$export($eb3ab2cab8ae8671$exports, "f", () => $eb3ab2cab8ae8671$export$2d1720544b23b823, (v) => $eb3ab2cab8ae8671$export$2d1720544b23b823 = v);
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $eb3ab2cab8ae8671$export$2d1720544b23b823;
'use strict';
var $848c392f9af002ba$exports = {};
'use strict';



var $18ec349fe9b1dd94$exports = {};
'use strict';

var $6f5ab140d3847165$exports = {};
'use strict';
var $38b1b404f6b944d2$exports = {};
'use strict';
var $5491e71f2d18e0a5$exports = {};
'use strict';
var $5491e71f2d18e0a5$var$ceil = Math.ceil;
var $5491e71f2d18e0a5$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$5491e71f2d18e0a5$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $5491e71f2d18e0a5$var$floor : $5491e71f2d18e0a5$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$38b1b404f6b944d2$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $5491e71f2d18e0a5$exports(number);
};


var $6f5ab140d3847165$var$max = Math.max;
var $6f5ab140d3847165$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$6f5ab140d3847165$exports = function(index, length) {
    var integer = $38b1b404f6b944d2$exports(index);
    return integer < 0 ? $6f5ab140d3847165$var$max(integer + length, 0) : $6f5ab140d3847165$var$min(integer, length);
};


var $b20a724496178f6b$exports = {};
'use strict';
var $eecf4269159770dc$exports = {};
'use strict';

var $eecf4269159770dc$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$eecf4269159770dc$exports = function(argument) {
    var len = $38b1b404f6b944d2$exports(argument);
    return len > 0 ? $eecf4269159770dc$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$b20a724496178f6b$exports = function(obj) {
    return $eecf4269159770dc$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $18ec349fe9b1dd94$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $4115d950804b1b04$exports($this);
        var length = $b20a724496178f6b$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $6f5ab140d3847165$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$18ec349fe9b1dd94$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $18ec349fe9b1dd94$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $18ec349fe9b1dd94$var$createMethod(false)
};


var $848c392f9af002ba$require$indexOf = $18ec349fe9b1dd94$exports.indexOf;

var $848c392f9af002ba$var$push = $3d3a3f96d04dfa01$exports([].push);
$848c392f9af002ba$exports = function(object, names) {
    var O = $4115d950804b1b04$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$6713471208f796ec$exports($60b0be22ef1af955$exports, key) && $6713471208f796ec$exports(O, key) && $848c392f9af002ba$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6713471208f796ec$exports(O, key = names[i++])) ~$848c392f9af002ba$require$indexOf(result, key) || $848c392f9af002ba$var$push(result, key);
    return result;
};


var $05ce5ef981815c5d$exports = {};
'use strict';
// IE8- don't enum bug keys
$05ce5ef981815c5d$exports = [
    'constructor',
    'hasOwnProperty',
    'isPrototypeOf',
    'propertyIsEnumerable',
    'toLocaleString',
    'toString',
    'valueOf'
];


var $eb3ab2cab8ae8671$var$hiddenKeys = $05ce5ef981815c5d$exports.concat('length', 'prototype');
$eb3ab2cab8ae8671$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $848c392f9af002ba$exports(O, $eb3ab2cab8ae8671$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $57496a63b7fc6acb$export$2d1720544b23b823;
'use strict';
$57496a63b7fc6acb$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $da5dee507eb1b7b3$var$concat = $3d3a3f96d04dfa01$exports([].concat);
// all object keys, includes non-enumerable and symbols
$da5dee507eb1b7b3$exports = $e5002032510f09f3$exports('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = $eb3ab2cab8ae8671$export$2d1720544b23b823($2d94e296a4d81142$exports(it));
    var getOwnPropertySymbols = $57496a63b7fc6acb$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $da5dee507eb1b7b3$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$ecce2f9545dca589$exports = function(target, source, exceptions) {
    var keys = $da5dee507eb1b7b3$exports(source);
    var defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $677b298e8fc869eb$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$6713471208f796ec$exports(target, key) && !(exceptions && $6713471208f796ec$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $889e651c47b82e1d$exports = {};
'use strict';


var $889e651c47b82e1d$var$replacement = /#|\.prototype\./;
var $889e651c47b82e1d$var$isForced = function(feature, detection) {
    var value = $889e651c47b82e1d$var$data[$889e651c47b82e1d$var$normalize(feature)];
    return value === $889e651c47b82e1d$var$POLYFILL ? true : value === $889e651c47b82e1d$var$NATIVE ? false : $e8bca5b64a857b1a$exports(detection) ? $1aa9995203de1dcd$exports(detection) : !!detection;
};
var $889e651c47b82e1d$var$normalize = $889e651c47b82e1d$var$isForced.normalize = function(string) {
    return String(string).replace($889e651c47b82e1d$var$replacement, '.').toLowerCase();
};
var $889e651c47b82e1d$var$data = $889e651c47b82e1d$var$isForced.data = {};
var $889e651c47b82e1d$var$NATIVE = $889e651c47b82e1d$var$isForced.NATIVE = 'N';
var $889e651c47b82e1d$var$POLYFILL = $889e651c47b82e1d$var$isForced.POLYFILL = 'P';
$889e651c47b82e1d$exports = $889e651c47b82e1d$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $9fd0241d8f6d7609$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $37a62429f4992eb4$exports;
    else if (STATIC) target = $37a62429f4992eb4$exports[TARGET] || $305fdd2dd2be7f81$exports(TARGET, {});
    else target = $37a62429f4992eb4$exports[TARGET] && $37a62429f4992eb4$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $9fd0241d8f6d7609$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $889e651c47b82e1d$exports(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $ecce2f9545dca589$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $d13e1e0ab68f4bd6$exports(sourceProperty, 'sham', true);
        $1f4601f39377b637$exports(target, key, sourceProperty, options);
    }
};


var $2b3870675553b866$exports = {};
'use strict';



var $5f0738dcc48ec8db$exports = {};
'use strict';
var $7c3bd6d588abdd5b$exports = {};
'use strict';
var $cf9ad08c1dff0f40$exports = {};
'use strict';

var $cf9ad08c1dff0f40$var$TO_STRING_TAG = $83f1bf79efdf35c6$exports('toStringTag');
var $cf9ad08c1dff0f40$var$test = {};
$cf9ad08c1dff0f40$var$test[$cf9ad08c1dff0f40$var$TO_STRING_TAG] = 'z';
$cf9ad08c1dff0f40$exports = String($cf9ad08c1dff0f40$var$test) === '[object z]';





var $7c3bd6d588abdd5b$var$TO_STRING_TAG = $83f1bf79efdf35c6$exports('toStringTag');
var $7c3bd6d588abdd5b$var$$Object = Object;
// ES3 wrong here
var $7c3bd6d588abdd5b$var$CORRECT_ARGUMENTS = $3a0f0fc82e93bd49$exports(function() {
    return arguments;
}()) === 'Arguments';
// fallback for IE11 Script Access Denied error
var $7c3bd6d588abdd5b$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$7c3bd6d588abdd5b$exports = $cf9ad08c1dff0f40$exports ? $3a0f0fc82e93bd49$exports : function(it) {
    var O, tag, result;
    return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = $7c3bd6d588abdd5b$var$tryGet(O = $7c3bd6d588abdd5b$var$$Object(it), $7c3bd6d588abdd5b$var$TO_STRING_TAG)) == 'string' ? tag : $7c3bd6d588abdd5b$var$CORRECT_ARGUMENTS ? $3a0f0fc82e93bd49$exports(O) : (result = $3a0f0fc82e93bd49$exports(O)) === 'Object' && $e8bca5b64a857b1a$exports(O.callee) ? 'Arguments' : result;
};


var $5f0738dcc48ec8db$var$$String = String;
$5f0738dcc48ec8db$exports = function(argument) {
    if ($7c3bd6d588abdd5b$exports(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
    return $5f0738dcc48ec8db$var$$String(argument);
};


var $400332d16a82a52a$exports = {};
'use strict';



var $7e951708847f20df$exports = {};
'use strict';
// a string of all valid unicode whitespaces
$7e951708847f20df$exports = "	\n\v\f\r \xa0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";


var $400332d16a82a52a$var$replace = $3d3a3f96d04dfa01$exports(''.replace);
var $400332d16a82a52a$var$ltrim = RegExp('^[' + $7e951708847f20df$exports + ']+');
var $400332d16a82a52a$var$rtrim = RegExp('(^|[^' + $7e951708847f20df$exports + '])[' + $7e951708847f20df$exports + ']+$');
// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var $400332d16a82a52a$var$createMethod = function(TYPE) {
    return function($this) {
        var string = $5f0738dcc48ec8db$exports($938881b1bb81812d$exports($this));
        if (TYPE & 1) string = $400332d16a82a52a$var$replace(string, $400332d16a82a52a$var$ltrim, '');
        if (TYPE & 2) string = $400332d16a82a52a$var$replace(string, $400332d16a82a52a$var$rtrim, '$1');
        return string;
    };
};
$400332d16a82a52a$exports = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: $400332d16a82a52a$var$createMethod(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: $400332d16a82a52a$var$createMethod(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: $400332d16a82a52a$var$createMethod(3)
};


var $2b3870675553b866$require$trim = $400332d16a82a52a$exports.trim;

var $2b3870675553b866$var$$parseInt = $37a62429f4992eb4$exports.parseInt;
var $2b3870675553b866$var$Symbol = $37a62429f4992eb4$exports.Symbol;
var $2b3870675553b866$var$ITERATOR = $2b3870675553b866$var$Symbol && $2b3870675553b866$var$Symbol.iterator;
var $2b3870675553b866$var$hex = /^[+-]?0x/i;
var $2b3870675553b866$var$exec = $3d3a3f96d04dfa01$exports($2b3870675553b866$var$hex.exec);
var $2b3870675553b866$var$FORCED = $2b3870675553b866$var$$parseInt($7e951708847f20df$exports + '08') !== 8 || $2b3870675553b866$var$$parseInt($7e951708847f20df$exports + '0x16') !== 22 || $2b3870675553b866$var$ITERATOR && !$1aa9995203de1dcd$exports(function() {
    $2b3870675553b866$var$$parseInt(Object($2b3870675553b866$var$ITERATOR));
});
// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$2b3870675553b866$exports = $2b3870675553b866$var$FORCED ? function parseInt(string, radix) {
    var S = $2b3870675553b866$require$trim($5f0738dcc48ec8db$exports(string));
    return $2b3870675553b866$var$$parseInt(S, radix >>> 0 || ($2b3870675553b866$var$exec($2b3870675553b866$var$hex, S) ? 16 : 10));
} : $2b3870675553b866$var$$parseInt;


// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
$9fd0241d8f6d7609$exports({
    global: true,
    forced: parseInt !== $2b3870675553b866$exports
}, {
    parseInt: $2b3870675553b866$exports
});


'use strict';

var $62ad98ebdf144868$exports = {};
'use strict';




var $d1e3b2f1ebb02e4a$exports = {};
'use strict';


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$d1e3b2f1ebb02e4a$exports = Object.keys || function keys(O) {
    return $848c392f9af002ba$exports(O, $05ce5ef981815c5d$exports);
};






// eslint-disable-next-line es/no-object-assign -- safe
var $62ad98ebdf144868$var$$assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var $62ad98ebdf144868$var$defineProperty = Object.defineProperty;
var $62ad98ebdf144868$var$concat = $3d3a3f96d04dfa01$exports([].concat);
// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
$62ad98ebdf144868$exports = !$62ad98ebdf144868$var$$assign || $1aa9995203de1dcd$exports(function() {
    // should have correct order of operations (Edge bug)
    if ($cea8a7c76ccddf5d$exports && $62ad98ebdf144868$var$$assign({
        b: 1
    }, $62ad98ebdf144868$var$$assign($62ad98ebdf144868$var$defineProperty({}, 'a', {
        enumerable: true,
        get: function() {
            $62ad98ebdf144868$var$defineProperty(this, 'b', {
                value: 3,
                enumerable: false
            });
        }
    }), {
        b: 2
    })).b !== 1) return true;
    // should work with symbols and should have deterministic property order (V8 bug)
    var A = {};
    var B = {};
    // eslint-disable-next-line es/no-symbol -- safe
    var symbol = Symbol('assign detection');
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    // eslint-disable-next-line es/no-array-prototype-foreach -- safe
    alphabet.split('').forEach(function(chr) {
        B[chr] = chr;
    });
    return $62ad98ebdf144868$var$$assign({}, A)[symbol] !== 7 || $d1e3b2f1ebb02e4a$exports($62ad98ebdf144868$var$$assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) {
    var T = $476d2ef928fdaf21$exports(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = $57496a63b7fc6acb$export$2d1720544b23b823;
    var propertyIsEnumerable = $1e07dffcb0f5b7ce$export$2d1720544b23b823;
    while(argumentsLength > index){
        var S = $ef1b385171038d0e$exports(arguments[index++]);
        var keys = getOwnPropertySymbols ? $62ad98ebdf144868$var$concat($d1e3b2f1ebb02e4a$exports(S), getOwnPropertySymbols(S)) : $d1e3b2f1ebb02e4a$exports(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$cea8a7c76ccddf5d$exports || $6e06bffcfb3013e2$exports(propertyIsEnumerable, S, key)) T[key] = S[key];
        }
    }
    return T;
} : $62ad98ebdf144868$var$$assign;


// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$9fd0241d8f6d7609$exports({
    target: 'Object',
    stat: true,
    arity: 2,
    forced: Object.assign !== $62ad98ebdf144868$exports
}, {
    assign: $62ad98ebdf144868$exports
});


'use strict';

var $f478770b94881111$exports = {};
'use strict';
var $54c9964c2c5636b3$exports = {};
'use strict';
var $928d634d7319e074$exports = {};
'use strict';


$928d634d7319e074$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($3a0f0fc82e93bd49$exports(fn) === 'Function') return $3d3a3f96d04dfa01$exports(fn);
};




var $54c9964c2c5636b3$var$bind = $928d634d7319e074$exports($928d634d7319e074$exports.bind);
// optional / simple context binding
$54c9964c2c5636b3$exports = function(fn, that) {
    $5f7d5e7ccafe12e0$exports(fn);
    return that === undefined ? fn : $e337c262a4702797$exports ? $54c9964c2c5636b3$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};






var $22872d6ed8de03fa$exports = {};
'use strict';
var $55a97a6fc42d0af6$exports = {};
'use strict';
var $9b96cfe148213656$exports = {};
'use strict';

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
$9b96cfe148213656$exports = Array.isArray || function isArray(argument) {
    return $3a0f0fc82e93bd49$exports(argument) === 'Array';
};


var $48cebf292a5ff3c8$exports = {};
'use strict';






var $48cebf292a5ff3c8$var$noop = function() {};
var $48cebf292a5ff3c8$var$construct = $e5002032510f09f3$exports('Reflect', 'construct');
var $48cebf292a5ff3c8$var$constructorRegExp = /^\s*(?:class|function)\b/;
var $48cebf292a5ff3c8$var$exec = $3d3a3f96d04dfa01$exports($48cebf292a5ff3c8$var$constructorRegExp.exec);
var $48cebf292a5ff3c8$var$INCORRECT_TO_STRING = !$48cebf292a5ff3c8$var$constructorRegExp.test($48cebf292a5ff3c8$var$noop);
var $48cebf292a5ff3c8$var$isConstructorModern = function isConstructor(argument) {
    if (!$e8bca5b64a857b1a$exports(argument)) return false;
    try {
        $48cebf292a5ff3c8$var$construct($48cebf292a5ff3c8$var$noop, [], argument);
        return true;
    } catch (error) {
        return false;
    }
};
var $48cebf292a5ff3c8$var$isConstructorLegacy = function isConstructor(argument) {
    if (!$e8bca5b64a857b1a$exports(argument)) return false;
    switch($7c3bd6d588abdd5b$exports(argument)){
        case 'AsyncFunction':
        case 'GeneratorFunction':
        case 'AsyncGeneratorFunction':
            return false;
    }
    try {
        // we can't check .prototype since constructors produced by .bind haven't it
        // `Function#toString` throws on some built-it function in some legacy engines
        // (for example, `DOMQuad` and similar in FF41-)
        return $48cebf292a5ff3c8$var$INCORRECT_TO_STRING || !!$48cebf292a5ff3c8$var$exec($48cebf292a5ff3c8$var$constructorRegExp, $97cff4f00fd83461$exports(argument));
    } catch (error) {
        return true;
    }
};
$48cebf292a5ff3c8$var$isConstructorLegacy.sham = true;
// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
$48cebf292a5ff3c8$exports = !$48cebf292a5ff3c8$var$construct || $1aa9995203de1dcd$exports(function() {
    var called;
    return $48cebf292a5ff3c8$var$isConstructorModern($48cebf292a5ff3c8$var$isConstructorModern.call) || !$48cebf292a5ff3c8$var$isConstructorModern(Object) || !$48cebf292a5ff3c8$var$isConstructorModern(function() {
        called = true;
    }) || called;
}) ? $48cebf292a5ff3c8$var$isConstructorLegacy : $48cebf292a5ff3c8$var$isConstructorModern;




var $55a97a6fc42d0af6$var$SPECIES = $83f1bf79efdf35c6$exports('species');
var $55a97a6fc42d0af6$var$$Array = Array;
// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$55a97a6fc42d0af6$exports = function(originalArray) {
    var C;
    if ($9b96cfe148213656$exports(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if ($48cebf292a5ff3c8$exports(C) && (C === $55a97a6fc42d0af6$var$$Array || $9b96cfe148213656$exports(C.prototype))) C = undefined;
        else if ($d1de49472bdc582c$exports(C)) {
            C = C[$55a97a6fc42d0af6$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? $55a97a6fc42d0af6$var$$Array : C;
};


// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
$22872d6ed8de03fa$exports = function(originalArray, length) {
    return new ($55a97a6fc42d0af6$exports(originalArray))(length === 0 ? 0 : length);
};


var $f478770b94881111$var$push = $3d3a3f96d04dfa01$exports([].push);
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var $f478770b94881111$var$createMethod = function(TYPE) {
    var IS_MAP = TYPE === 1;
    var IS_FILTER = TYPE === 2;
    var IS_SOME = TYPE === 3;
    var IS_EVERY = TYPE === 4;
    var IS_FIND_INDEX = TYPE === 6;
    var IS_FILTER_REJECT = TYPE === 7;
    var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $476d2ef928fdaf21$exports($this);
        var self = $ef1b385171038d0e$exports(O);
        var length = $b20a724496178f6b$exports(self);
        var boundFunction = $54c9964c2c5636b3$exports(callbackfn, that);
        var index = 0;
        var create = specificCreate || $22872d6ed8de03fa$exports;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            value = self[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $f478770b94881111$var$push(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $f478770b94881111$var$push(target, value); // filterReject
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
$f478770b94881111$exports = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $f478770b94881111$var$createMethod(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $f478770b94881111$var$createMethod(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $f478770b94881111$var$createMethod(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $f478770b94881111$var$createMethod(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $f478770b94881111$var$createMethod(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $f478770b94881111$var$createMethod(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $f478770b94881111$var$createMethod(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: $f478770b94881111$var$createMethod(7)
};


var $6fee3eb7a9663fdc$require$$filter = $f478770b94881111$exports.filter;
var $9a28a86bebcf0bcb$exports = {};
'use strict';



var $9a28a86bebcf0bcb$var$SPECIES = $83f1bf79efdf35c6$exports('species');
$9a28a86bebcf0bcb$exports = function(METHOD_NAME) {
    // We can't use this feature detection in V8 since it causes
    // deoptimization and serious performance degradation
    // https://github.com/zloirock/core-js/issues/677
    return $800ddfa01b593c5d$exports >= 51 || !$1aa9995203de1dcd$exports(function() {
        var array = [];
        var constructor = array.constructor = {};
        constructor[$9a28a86bebcf0bcb$var$SPECIES] = function() {
            return {
                foo: 1
            };
        };
        return array[METHOD_NAME](Boolean).foo !== 1;
    });
};


var $6fee3eb7a9663fdc$var$HAS_SPECIES_SUPPORT = $9a28a86bebcf0bcb$exports('filter');
// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$9fd0241d8f6d7609$exports({
    target: 'Array',
    proto: true,
    forced: !$6fee3eb7a9663fdc$var$HAS_SPECIES_SUPPORT
}, {
    filter: function filter(callbackfn /* , thisArg */ ) {
        return $6fee3eb7a9663fdc$require$$filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});


'use strict';


var $19aa2a04413c8c38$exports = {};
'use strict';


// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
$19aa2a04413c8c38$exports = $cf9ad08c1dff0f40$exports ? ({}).toString : function toString() {
    return '[object ' + $7c3bd6d588abdd5b$exports(this) + ']';
};


// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!$cf9ad08c1dff0f40$exports) $1f4601f39377b637$exports(Object.prototype, 'toString', $19aa2a04413c8c38$exports, {
    unsafe: true
});


var $d5ae8eb900fc9661$exports = {};
'use strict';

var $fd89d156337cbe43$exports = {};
'use strict';

var $f1a832a591ec8b6f$exports = {};
'use strict';

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $2a7099cc2a66c61f$export$2d1720544b23b823;
'use strict';






$2a7099cc2a66c61f$export$2d1720544b23b823 = $cea8a7c76ccddf5d$exports && !$ac4e947f8a7d92c1$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $2d94e296a4d81142$exports(O);
    var props = $4115d950804b1b04$exports(Properties);
    var keys = $d1e3b2f1ebb02e4a$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$ec8f33e5c924d97f$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $6dc10d71896c9c9a$exports = {};
'use strict';

$6dc10d71896c9c9a$exports = $e5002032510f09f3$exports('document', 'documentElement');




var $f1a832a591ec8b6f$var$GT = '>';
var $f1a832a591ec8b6f$var$LT = '<';
var $f1a832a591ec8b6f$var$PROTOTYPE = 'prototype';
var $f1a832a591ec8b6f$var$SCRIPT = 'script';
var $f1a832a591ec8b6f$var$IE_PROTO = $44039bd971d76cb8$exports('IE_PROTO');
var $f1a832a591ec8b6f$var$EmptyConstructor = function() {};
var $f1a832a591ec8b6f$var$scriptTag = function(content) {
    return $f1a832a591ec8b6f$var$LT + $f1a832a591ec8b6f$var$SCRIPT + $f1a832a591ec8b6f$var$GT + content + $f1a832a591ec8b6f$var$LT + '/' + $f1a832a591ec8b6f$var$SCRIPT + $f1a832a591ec8b6f$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $f1a832a591ec8b6f$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($f1a832a591ec8b6f$var$scriptTag(''));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    // eslint-disable-next-line no-useless-assignment -- avoid memory leak
    activeXDocument = null;
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f1a832a591ec8b6f$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $416f618c0bbd719b$exports('iframe');
    var JS = 'java' + $f1a832a591ec8b6f$var$SCRIPT + ':';
    var iframeDocument;
    iframe.style.display = 'none';
    $6dc10d71896c9c9a$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($f1a832a591ec8b6f$var$scriptTag('document.F=Object'));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $f1a832a591ec8b6f$var$activeXDocument;
var $f1a832a591ec8b6f$var$NullProtoObject = function() {
    try {
        $f1a832a591ec8b6f$var$activeXDocument = new ActiveXObject('htmlfile');
    } catch (error) {}
    $f1a832a591ec8b6f$var$NullProtoObject = typeof document != 'undefined' ? document.domain && $f1a832a591ec8b6f$var$activeXDocument ? $f1a832a591ec8b6f$var$NullProtoObjectViaActiveX($f1a832a591ec8b6f$var$activeXDocument) // old IE
     : $f1a832a591ec8b6f$var$NullProtoObjectViaIFrame() : $f1a832a591ec8b6f$var$NullProtoObjectViaActiveX($f1a832a591ec8b6f$var$activeXDocument); // WSH
    var length = $05ce5ef981815c5d$exports.length;
    while(length--)delete $f1a832a591ec8b6f$var$NullProtoObject[$f1a832a591ec8b6f$var$PROTOTYPE][$05ce5ef981815c5d$exports[length]];
    return $f1a832a591ec8b6f$var$NullProtoObject();
};
$60b0be22ef1af955$exports[$f1a832a591ec8b6f$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$f1a832a591ec8b6f$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f1a832a591ec8b6f$var$EmptyConstructor[$f1a832a591ec8b6f$var$PROTOTYPE] = $2d94e296a4d81142$exports(O);
        result = new $f1a832a591ec8b6f$var$EmptyConstructor();
        $f1a832a591ec8b6f$var$EmptyConstructor[$f1a832a591ec8b6f$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f1a832a591ec8b6f$var$IE_PROTO] = O;
    } else result = $f1a832a591ec8b6f$var$NullProtoObject();
    return Properties === undefined ? result : $2a7099cc2a66c61f$export$2d1720544b23b823(result, Properties);
};



var $fd89d156337cbe43$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;
var $fd89d156337cbe43$var$UNSCOPABLES = $83f1bf79efdf35c6$exports('unscopables');
var $fd89d156337cbe43$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($fd89d156337cbe43$var$ArrayPrototype[$fd89d156337cbe43$var$UNSCOPABLES] === undefined) $fd89d156337cbe43$require$defineProperty($fd89d156337cbe43$var$ArrayPrototype, $fd89d156337cbe43$var$UNSCOPABLES, {
    configurable: true,
    value: $f1a832a591ec8b6f$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$fd89d156337cbe43$exports = function(key) {
    $fd89d156337cbe43$var$ArrayPrototype[$fd89d156337cbe43$var$UNSCOPABLES][key] = true;
};


var $909e1f74cd3e640b$exports = {};
'use strict';
$909e1f74cd3e640b$exports = {};




var $d5ae8eb900fc9661$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;
var $02a0ce80172aaf1c$exports = {};
'use strict';





var $91064bc7473274b7$exports = {};
'use strict';
var $8682c88b31f9f06f$exports = {};
'use strict';




var $ecb1e81f5eeec8d6$exports = {};
'use strict';




var $e82868213ee2eaaf$exports = {};
'use strict';

$e82868213ee2eaaf$exports = !$1aa9995203de1dcd$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $ecb1e81f5eeec8d6$var$IE_PROTO = $44039bd971d76cb8$exports('IE_PROTO');
var $ecb1e81f5eeec8d6$var$$Object = Object;
var $ecb1e81f5eeec8d6$var$ObjectPrototype = $ecb1e81f5eeec8d6$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$ecb1e81f5eeec8d6$exports = $e82868213ee2eaaf$exports ? $ecb1e81f5eeec8d6$var$$Object.getPrototypeOf : function(O) {
    var object = $476d2ef928fdaf21$exports(O);
    if ($6713471208f796ec$exports(object, $ecb1e81f5eeec8d6$var$IE_PROTO)) return object[$ecb1e81f5eeec8d6$var$IE_PROTO];
    var constructor = object.constructor;
    if ($e8bca5b64a857b1a$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $ecb1e81f5eeec8d6$var$$Object ? $ecb1e81f5eeec8d6$var$ObjectPrototype : null;
};





var $8682c88b31f9f06f$var$ITERATOR = $83f1bf79efdf35c6$exports('iterator');
var $8682c88b31f9f06f$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $8682c88b31f9f06f$var$IteratorPrototype, $8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype, $8682c88b31f9f06f$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $8682c88b31f9f06f$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!('next' in $8682c88b31f9f06f$var$arrayIterator)) $8682c88b31f9f06f$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype = $ecb1e81f5eeec8d6$exports($ecb1e81f5eeec8d6$exports($8682c88b31f9f06f$var$arrayIterator));
        if ($8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $8682c88b31f9f06f$var$IteratorPrototype = $8682c88b31f9f06f$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $8682c88b31f9f06f$var$NEW_ITERATOR_PROTOTYPE = !$d1de49472bdc582c$exports($8682c88b31f9f06f$var$IteratorPrototype) || $1aa9995203de1dcd$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $8682c88b31f9f06f$var$IteratorPrototype[$8682c88b31f9f06f$var$ITERATOR].call(test) !== test;
});
if ($8682c88b31f9f06f$var$NEW_ITERATOR_PROTOTYPE) $8682c88b31f9f06f$var$IteratorPrototype = {};
else if ($3d49ff5c72fb9ed5$exports) $8682c88b31f9f06f$var$IteratorPrototype = $f1a832a591ec8b6f$exports($8682c88b31f9f06f$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$e8bca5b64a857b1a$exports($8682c88b31f9f06f$var$IteratorPrototype[$8682c88b31f9f06f$var$ITERATOR])) $1f4601f39377b637$exports($8682c88b31f9f06f$var$IteratorPrototype, $8682c88b31f9f06f$var$ITERATOR, function() {
    return this;
});
$8682c88b31f9f06f$exports = {
    IteratorPrototype: $8682c88b31f9f06f$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $8682c88b31f9f06f$var$BUGGY_SAFARI_ITERATORS
};


var $91064bc7473274b7$require$IteratorPrototype = $8682c88b31f9f06f$exports.IteratorPrototype;


var $0b80283a96aa2f97$exports = {};
'use strict';

var $0b80283a96aa2f97$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;


var $0b80283a96aa2f97$var$TO_STRING_TAG = $83f1bf79efdf35c6$exports('toStringTag');
$0b80283a96aa2f97$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$6713471208f796ec$exports(target, $0b80283a96aa2f97$var$TO_STRING_TAG)) $0b80283a96aa2f97$require$defineProperty(target, $0b80283a96aa2f97$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $91064bc7473274b7$var$returnThis = function() {
    return this;
};
$91064bc7473274b7$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + ' Iterator';
    IteratorConstructor.prototype = $f1a832a591ec8b6f$exports($91064bc7473274b7$require$IteratorPrototype, {
        next: $2159f71bcf7ac44a$exports(+!ENUMERABLE_NEXT, next)
    });
    $0b80283a96aa2f97$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $909e1f74cd3e640b$exports[TO_STRING_TAG] = $91064bc7473274b7$var$returnThis;
    return IteratorConstructor;
};



var $ddc9e8d80ccd70f7$exports = {};
'use strict';
var $740ef81bf029da08$exports = {};
'use strict';


$740ef81bf029da08$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $3d3a3f96d04dfa01$exports($5f7d5e7ccafe12e0$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $7f8c1fa98367ca50$exports = {};
'use strict';
var $f9d74d6bdac10302$exports = {};
'use strict';

$f9d74d6bdac10302$exports = function(argument) {
    return $d1de49472bdc582c$exports(argument) || argument === null;
};


var $7f8c1fa98367ca50$var$$String = String;
var $7f8c1fa98367ca50$var$$TypeError = TypeError;
$7f8c1fa98367ca50$exports = function(argument) {
    if ($f9d74d6bdac10302$exports(argument)) return argument;
    throw new $7f8c1fa98367ca50$var$$TypeError("Can't set " + $7f8c1fa98367ca50$var$$String(argument) + ' as a prototype');
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$ddc9e8d80ccd70f7$exports = Object.setPrototypeOf || ('__proto__' in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $740ef81bf029da08$exports(Object.prototype, '__proto__', 'set');
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $938881b1bb81812d$exports(O);
        $7f8c1fa98367ca50$exports(proto);
        if (!$d1de49472bdc582c$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $02a0ce80172aaf1c$var$PROPER_FUNCTION_NAME = $775efe7ab5de3db4$exports.PROPER;
var $02a0ce80172aaf1c$var$CONFIGURABLE_FUNCTION_NAME = $775efe7ab5de3db4$exports.CONFIGURABLE;
var $02a0ce80172aaf1c$var$IteratorPrototype = $8682c88b31f9f06f$exports.IteratorPrototype;
var $02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS = $8682c88b31f9f06f$exports.BUGGY_SAFARI_ITERATORS;
var $02a0ce80172aaf1c$var$ITERATOR = $83f1bf79efdf35c6$exports('iterator');
var $02a0ce80172aaf1c$var$KEYS = 'keys';
var $02a0ce80172aaf1c$var$VALUES = 'values';
var $02a0ce80172aaf1c$var$ENTRIES = 'entries';
var $02a0ce80172aaf1c$var$returnThis = function() {
    return this;
};
$02a0ce80172aaf1c$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $91064bc7473274b7$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $02a0ce80172aaf1c$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $02a0ce80172aaf1c$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $02a0ce80172aaf1c$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + ' Iterator';
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$02a0ce80172aaf1c$var$ITERATOR] || IterablePrototype['@@iterator'] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $ecb1e81f5eeec8d6$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$3d49ff5c72fb9ed5$exports && $ecb1e81f5eeec8d6$exports(CurrentIteratorPrototype) !== $02a0ce80172aaf1c$var$IteratorPrototype) {
                if ($ddc9e8d80ccd70f7$exports) $ddc9e8d80ccd70f7$exports(CurrentIteratorPrototype, $02a0ce80172aaf1c$var$IteratorPrototype);
                else if (!$e8bca5b64a857b1a$exports(CurrentIteratorPrototype[$02a0ce80172aaf1c$var$ITERATOR])) $1f4601f39377b637$exports(CurrentIteratorPrototype, $02a0ce80172aaf1c$var$ITERATOR, $02a0ce80172aaf1c$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $0b80283a96aa2f97$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($3d49ff5c72fb9ed5$exports) $909e1f74cd3e640b$exports[TO_STRING_TAG] = $02a0ce80172aaf1c$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($02a0ce80172aaf1c$var$PROPER_FUNCTION_NAME && DEFAULT === $02a0ce80172aaf1c$var$VALUES && nativeIterator && nativeIterator.name !== $02a0ce80172aaf1c$var$VALUES) {
        if (!$3d49ff5c72fb9ed5$exports && $02a0ce80172aaf1c$var$CONFIGURABLE_FUNCTION_NAME) $d13e1e0ab68f4bd6$exports(IterablePrototype, 'name', $02a0ce80172aaf1c$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $6e06bffcfb3013e2$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($02a0ce80172aaf1c$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($02a0ce80172aaf1c$var$KEYS),
            entries: getIterationMethod($02a0ce80172aaf1c$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $1f4601f39377b637$exports(IterablePrototype, KEY, methods[KEY]);
        } else $9fd0241d8f6d7609$exports({
            target: NAME,
            proto: true,
            forced: $02a0ce80172aaf1c$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$3d49ff5c72fb9ed5$exports || FORCED) && IterablePrototype[$02a0ce80172aaf1c$var$ITERATOR] !== defaultIterator) $1f4601f39377b637$exports(IterablePrototype, $02a0ce80172aaf1c$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $909e1f74cd3e640b$exports[NAME] = defaultIterator;
    return methods;
};


var $3fa88b2bee851856$exports = {};
'use strict';
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$3fa88b2bee851856$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $d5ae8eb900fc9661$var$ARRAY_ITERATOR = 'Array Iterator';
var $d5ae8eb900fc9661$var$setInternalState = $7c2e321de999e766$exports.set;
var $d5ae8eb900fc9661$var$getInternalState = $7c2e321de999e766$exports.getterFor($d5ae8eb900fc9661$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$d5ae8eb900fc9661$exports = $02a0ce80172aaf1c$exports(Array, 'Array', function(iterated, kind) {
    $d5ae8eb900fc9661$var$setInternalState(this, {
        type: $d5ae8eb900fc9661$var$ARRAY_ITERATOR,
        target: $4115d950804b1b04$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $d5ae8eb900fc9661$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = null;
        return $3fa88b2bee851856$exports(undefined, true);
    }
    switch(state.kind){
        case 'keys':
            return $3fa88b2bee851856$exports(index, false);
        case 'values':
            return $3fa88b2bee851856$exports(target[index], false);
    }
    return $3fa88b2bee851856$exports([
        index,
        target[index]
    ], false);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $d5ae8eb900fc9661$var$values = $909e1f74cd3e640b$exports.Arguments = $909e1f74cd3e640b$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$fd89d156337cbe43$exports('keys');
$fd89d156337cbe43$exports('values');
$fd89d156337cbe43$exports('entries');
// V8 ~ Chrome 45- bug
if (!$3d49ff5c72fb9ed5$exports && $cea8a7c76ccddf5d$exports && $d5ae8eb900fc9661$var$values.name !== 'values') try {
    $d5ae8eb900fc9661$require$defineProperty($d5ae8eb900fc9661$var$values, 'name', {
        value: 'values'
    });
} catch (error) {}


'use strict';
var $a971a7ca4b136214$exports = {};
'use strict';




var $a971a7ca4b136214$var$charAt = $3d3a3f96d04dfa01$exports(''.charAt);
var $a971a7ca4b136214$var$charCodeAt = $3d3a3f96d04dfa01$exports(''.charCodeAt);
var $a971a7ca4b136214$var$stringSlice = $3d3a3f96d04dfa01$exports(''.slice);
var $a971a7ca4b136214$var$createMethod = function(CONVERT_TO_STRING) {
    return function($this, pos) {
        var S = $5f0738dcc48ec8db$exports($938881b1bb81812d$exports($this));
        var position = $38b1b404f6b944d2$exports(pos);
        var size = S.length;
        var first, second;
        if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
        first = $a971a7ca4b136214$var$charCodeAt(S, position);
        return first < 0xD800 || first > 0xDBFF || position + 1 === size || (second = $a971a7ca4b136214$var$charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF ? CONVERT_TO_STRING ? $a971a7ca4b136214$var$charAt(S, position) : first : CONVERT_TO_STRING ? $a971a7ca4b136214$var$stringSlice(S, position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
    };
};
$a971a7ca4b136214$exports = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: $a971a7ca4b136214$var$createMethod(false),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: $a971a7ca4b136214$var$createMethod(true)
};


var $958470b00cb61e9e$require$charAt = $a971a7ca4b136214$exports.charAt;




var $958470b00cb61e9e$var$STRING_ITERATOR = 'String Iterator';
var $958470b00cb61e9e$var$setInternalState = $7c2e321de999e766$exports.set;
var $958470b00cb61e9e$var$getInternalState = $7c2e321de999e766$exports.getterFor($958470b00cb61e9e$var$STRING_ITERATOR);
// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
$02a0ce80172aaf1c$exports(String, 'String', function(iterated) {
    $958470b00cb61e9e$var$setInternalState(this, {
        type: $958470b00cb61e9e$var$STRING_ITERATOR,
        string: $5f0738dcc48ec8db$exports(iterated),
        index: 0
    });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
    var state = $958470b00cb61e9e$var$getInternalState(this);
    var string = state.string;
    var index = state.index;
    var point;
    if (index >= string.length) return $3fa88b2bee851856$exports(undefined, true);
    point = $958470b00cb61e9e$require$charAt(string, index);
    state.index += point.length;
    return $3fa88b2bee851856$exports(point, false);
});


'use strict';
'use strict';
var $9394318a06ff3af6$exports = {};
'use strict';

$9394318a06ff3af6$exports = !$1aa9995203de1dcd$exports(function() {
    // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
    return Object.isExtensible(Object.preventExtensions({}));
});




var $6355bfa194afe709$exports = {};
'use strict';

$6355bfa194afe709$exports = function(target, src, options) {
    for(var key in src)$1f4601f39377b637$exports(target, key, src[key], options);
    return target;
};


var $1bf0be5a866787b4$exports = {};
'use strict';






var $1bf0be5a866787b4$require$defineProperty = $ec8f33e5c924d97f$export$2d1720544b23b823;

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $a4b9ceb207984515$export$2d1720544b23b823;
'use strict';



var $a4b9ceb207984515$require$$getOwnPropertyNames = $eb3ab2cab8ae8671$export$2d1720544b23b823;
var $29b3e2107a0a7d47$exports = {};
'use strict';

$29b3e2107a0a7d47$exports = $3d3a3f96d04dfa01$exports([].slice);


var $a4b9ceb207984515$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $a4b9ceb207984515$var$getWindowNames = function(it) {
    try {
        return $a4b9ceb207984515$require$$getOwnPropertyNames(it);
    } catch (error) {
        return $29b3e2107a0a7d47$exports($a4b9ceb207984515$var$windowNames);
    }
};
$a4b9ceb207984515$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $a4b9ceb207984515$var$windowNames && $3a0f0fc82e93bd49$exports(it) === 'Window' ? $a4b9ceb207984515$var$getWindowNames(it) : $a4b9ceb207984515$require$$getOwnPropertyNames($4115d950804b1b04$exports(it));
};


var $c10701267591785c$exports = {};
'use strict';



var $23173e6b22be4529$exports = {};
'use strict';

$23173e6b22be4529$exports = $1aa9995203de1dcd$exports(function() {
    if (typeof ArrayBuffer == 'function') {
        var buffer = new ArrayBuffer(8);
        // eslint-disable-next-line es/no-object-isextensible, es/no-object-defineproperty -- safe
        if (Object.isExtensible(buffer)) Object.defineProperty(buffer, 'a', {
            value: 8
        });
    }
});


// eslint-disable-next-line es/no-object-isextensible -- safe
var $c10701267591785c$var$$isExtensible = Object.isExtensible;
var $c10701267591785c$var$FAILS_ON_PRIMITIVES = $1aa9995203de1dcd$exports(function() {
    $c10701267591785c$var$$isExtensible(1);
});
// `Object.isExtensible` method
// https://tc39.es/ecma262/#sec-object.isextensible
$c10701267591785c$exports = $c10701267591785c$var$FAILS_ON_PRIMITIVES || $23173e6b22be4529$exports ? function isExtensible(it) {
    if (!$d1de49472bdc582c$exports(it)) return false;
    if ($23173e6b22be4529$exports && $3a0f0fc82e93bd49$exports(it) === 'ArrayBuffer') return false;
    return $c10701267591785c$var$$isExtensible ? $c10701267591785c$var$$isExtensible(it) : true;
} : $c10701267591785c$var$$isExtensible;




var $1bf0be5a866787b4$var$REQUIRED = false;
var $1bf0be5a866787b4$var$METADATA = $2ef1f447bc219aea$exports('meta');
var $1bf0be5a866787b4$var$id = 0;
var $1bf0be5a866787b4$var$setMetadata = function(it) {
    $1bf0be5a866787b4$require$defineProperty(it, $1bf0be5a866787b4$var$METADATA, {
        value: {
            objectID: 'O' + $1bf0be5a866787b4$var$id++,
            weakData: {} // weak collections IDs
        }
    });
};
var $1bf0be5a866787b4$var$fastKey = function(it, create) {
    // return a primitive with prefix
    if (!$d1de49472bdc582c$exports(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$6713471208f796ec$exports(it, $1bf0be5a866787b4$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$c10701267591785c$exports(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $1bf0be5a866787b4$var$setMetadata(it);
    // return object ID
    }
    return it[$1bf0be5a866787b4$var$METADATA].objectID;
};
var $1bf0be5a866787b4$var$getWeakData = function(it, create) {
    if (!$6713471208f796ec$exports(it, $1bf0be5a866787b4$var$METADATA)) {
        // can't set metadata to uncaught frozen object
        if (!$c10701267591785c$exports(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $1bf0be5a866787b4$var$setMetadata(it);
    // return the store of weak collections IDs
    }
    return it[$1bf0be5a866787b4$var$METADATA].weakData;
};
// add metadata on freeze-family methods calling
var $1bf0be5a866787b4$var$onFreeze = function(it) {
    if ($9394318a06ff3af6$exports && $1bf0be5a866787b4$var$REQUIRED && $c10701267591785c$exports(it) && !$6713471208f796ec$exports(it, $1bf0be5a866787b4$var$METADATA)) $1bf0be5a866787b4$var$setMetadata(it);
    return it;
};
var $1bf0be5a866787b4$var$enable = function() {
    $1bf0be5a866787b4$var$meta.enable = function() {};
    $1bf0be5a866787b4$var$REQUIRED = true;
    var getOwnPropertyNames = $eb3ab2cab8ae8671$export$2d1720544b23b823;
    var splice = $3d3a3f96d04dfa01$exports([].splice);
    var test = {};
    test[$1bf0be5a866787b4$var$METADATA] = 1;
    // prevent exposing of metadata key
    if (getOwnPropertyNames(test).length) {
        $eb3ab2cab8ae8671$exports.f = function(it) {
            var result = getOwnPropertyNames(it);
            for(var i = 0, length = result.length; i < length; i++)if (result[i] === $1bf0be5a866787b4$var$METADATA) {
                splice(result, i, 1);
                break;
            }
            return result;
        };
        $9fd0241d8f6d7609$exports({
            target: 'Object',
            stat: true,
            forced: true
        }, {
            getOwnPropertyNames: $a4b9ceb207984515$export$2d1720544b23b823
        });
    }
};
var $1bf0be5a866787b4$var$meta = $1bf0be5a866787b4$exports = {
    enable: $1bf0be5a866787b4$var$enable,
    fastKey: $1bf0be5a866787b4$var$fastKey,
    getWeakData: $1bf0be5a866787b4$var$getWeakData,
    onFreeze: $1bf0be5a866787b4$var$onFreeze
};
$60b0be22ef1af955$exports[$1bf0be5a866787b4$var$METADATA] = true;


var $3ea5d594f6193905$exports = {};
'use strict';






var $25ce5bb5ab438b46$exports = {};
'use strict';




var $eca502047a869f63$exports = {};
'use strict';


var $eca502047a869f63$var$ITERATOR = $83f1bf79efdf35c6$exports('iterator');
var $eca502047a869f63$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$eca502047a869f63$exports = function(it) {
    return it !== undefined && ($909e1f74cd3e640b$exports.Array === it || $eca502047a869f63$var$ArrayPrototype[$eca502047a869f63$var$ITERATOR] === it);
};




var $78e90febc0eb3602$exports = {};
'use strict';




var $a94398be8324ce8e$exports = {};
'use strict';





var $a94398be8324ce8e$var$ITERATOR = $83f1bf79efdf35c6$exports('iterator');
$a94398be8324ce8e$exports = function(it) {
    if (!$c3e80151589b4ea3$exports(it)) return $af183ff3a7a0320f$exports(it, $a94398be8324ce8e$var$ITERATOR) || $af183ff3a7a0320f$exports(it, '@@iterator') || $909e1f74cd3e640b$exports[$7c3bd6d588abdd5b$exports(it)];
};


var $78e90febc0eb3602$var$$TypeError = TypeError;
$78e90febc0eb3602$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $a94398be8324ce8e$exports(argument) : usingIterator;
    if ($5f7d5e7ccafe12e0$exports(iteratorMethod)) return $2d94e296a4d81142$exports($6e06bffcfb3013e2$exports(iteratorMethod, argument));
    throw new $78e90febc0eb3602$var$$TypeError($0ee3ded6653f158b$exports(argument) + ' is not iterable');
};



var $f609df8a24e736f4$exports = {};
'use strict';



$f609df8a24e736f4$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $2d94e296a4d81142$exports(iterator);
    try {
        innerResult = $af183ff3a7a0320f$exports(iterator, 'return');
        if (!innerResult) {
            if (kind === 'throw') throw value;
            return value;
        }
        innerResult = $6e06bffcfb3013e2$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === 'throw') throw value;
    if (innerError) throw innerResult;
    $2d94e296a4d81142$exports(innerResult);
    return value;
};


var $25ce5bb5ab438b46$var$$TypeError = TypeError;
var $25ce5bb5ab438b46$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $25ce5bb5ab438b46$var$ResultPrototype = $25ce5bb5ab438b46$var$Result.prototype;
$25ce5bb5ab438b46$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $54c9964c2c5636b3$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $f609df8a24e736f4$exports(iterator, 'normal', condition);
        return new $25ce5bb5ab438b46$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $2d94e296a4d81142$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $a94398be8324ce8e$exports(iterable);
        if (!iterFn) throw new $25ce5bb5ab438b46$var$$TypeError($0ee3ded6653f158b$exports(iterable) + ' is not iterable');
        // optimisation for array iterators
        if ($eca502047a869f63$exports(iterFn)) {
            for(index = 0, length = $b20a724496178f6b$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $13b911265f6ed62e$exports($25ce5bb5ab438b46$var$ResultPrototype, result)) return result;
            }
            return new $25ce5bb5ab438b46$var$Result(false);
        }
        iterator = $78e90febc0eb3602$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $6e06bffcfb3013e2$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $f609df8a24e736f4$exports(iterator, 'throw', error);
        }
        if (typeof result == 'object' && result && $13b911265f6ed62e$exports($25ce5bb5ab438b46$var$ResultPrototype, result)) return result;
    }
    return new $25ce5bb5ab438b46$var$Result(false);
};


var $b9104a2e89b56b2e$exports = {};
'use strict';

var $b9104a2e89b56b2e$var$$TypeError = TypeError;
$b9104a2e89b56b2e$exports = function(it, Prototype) {
    if ($13b911265f6ed62e$exports(Prototype, it)) return it;
    throw new $b9104a2e89b56b2e$var$$TypeError('Incorrect invocation');
};






var $3cf092bc463c3983$exports = {};
'use strict';

var $3cf092bc463c3983$var$ITERATOR = $83f1bf79efdf35c6$exports('iterator');
var $3cf092bc463c3983$var$SAFE_CLOSING = false;
try {
    var $3cf092bc463c3983$var$called = 0;
    var $3cf092bc463c3983$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$3cf092bc463c3983$var$called++
            };
        },
        'return': function() {
            $3cf092bc463c3983$var$SAFE_CLOSING = true;
        }
    };
    $3cf092bc463c3983$var$iteratorWithReturn[$3cf092bc463c3983$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($3cf092bc463c3983$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$3cf092bc463c3983$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$3cf092bc463c3983$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$3cf092bc463c3983$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};



var $89bbd203c6a5945a$exports = {};
'use strict';



// makes subclassing work correct for wrapped built-ins
$89bbd203c6a5945a$exports = function($this, dummy, Wrapper) {
    var NewTarget, NewTargetPrototype;
    if (// it can work only with native `setPrototypeOf`
    $ddc9e8d80ccd70f7$exports && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    $e8bca5b64a857b1a$exports(NewTarget = dummy.constructor) && NewTarget !== Wrapper && $d1de49472bdc582c$exports(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype) $ddc9e8d80ccd70f7$exports($this, NewTargetPrototype);
    return $this;
};


$3ea5d594f6193905$exports = function(CONSTRUCTOR_NAME, wrapper, common) {
    var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
    var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
    var ADDER = IS_MAP ? 'set' : 'add';
    var NativeConstructor = $37a62429f4992eb4$exports[CONSTRUCTOR_NAME];
    var NativePrototype = NativeConstructor && NativeConstructor.prototype;
    var Constructor = NativeConstructor;
    var exported = {};
    var fixMethod = function(KEY) {
        var uncurriedNativeMethod = $3d3a3f96d04dfa01$exports(NativePrototype[KEY]);
        $1f4601f39377b637$exports(NativePrototype, KEY, KEY === 'add' ? function add(value) {
            uncurriedNativeMethod(this, value === 0 ? 0 : value);
            return this;
        } : KEY === 'delete' ? function(key) {
            return IS_WEAK && !$d1de49472bdc582c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'get' ? function get(key) {
            return IS_WEAK && !$d1de49472bdc582c$exports(key) ? undefined : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : KEY === 'has' ? function has(key) {
            return IS_WEAK && !$d1de49472bdc582c$exports(key) ? false : uncurriedNativeMethod(this, key === 0 ? 0 : key);
        } : function set(key, value) {
            uncurriedNativeMethod(this, key === 0 ? 0 : key, value);
            return this;
        });
    };
    var REPLACE = $889e651c47b82e1d$exports(CONSTRUCTOR_NAME, !$e8bca5b64a857b1a$exports(NativeConstructor) || !(IS_WEAK || NativePrototype.forEach && !$1aa9995203de1dcd$exports(function() {
        new NativeConstructor().entries().next();
    })));
    if (REPLACE) {
        // create collection constructor
        Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
        $1bf0be5a866787b4$exports.enable();
    } else if ($889e651c47b82e1d$exports(CONSTRUCTOR_NAME, true)) {
        var instance = new Constructor();
        // early implementations not supports chaining
        var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) !== instance;
        // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
        var THROWS_ON_PRIMITIVES = $1aa9995203de1dcd$exports(function() {
            instance.has(1);
        });
        // most early implementations doesn't supports iterables, most modern - not close it correctly
        // eslint-disable-next-line no-new -- required for testing
        var ACCEPT_ITERABLES = $3cf092bc463c3983$exports(function(iterable) {
            new NativeConstructor(iterable);
        });
        // for early implementations -0 and +0 not the same
        var BUGGY_ZERO = !IS_WEAK && $1aa9995203de1dcd$exports(function() {
            // V8 ~ Chromium 42- fails only with 5+ elements
            var $instance = new NativeConstructor();
            var index = 5;
            while(index--)$instance[ADDER](index, index);
            return !$instance.has(-0);
        });
        if (!ACCEPT_ITERABLES) {
            Constructor = wrapper(function(dummy, iterable) {
                $b9104a2e89b56b2e$exports(dummy, NativePrototype);
                var that = $89bbd203c6a5945a$exports(new NativeConstructor(), dummy, Constructor);
                if (!$c3e80151589b4ea3$exports(iterable)) $25ce5bb5ab438b46$exports(iterable, that[ADDER], {
                    that: that,
                    AS_ENTRIES: IS_MAP
                });
                return that;
            });
            Constructor.prototype = NativePrototype;
            NativePrototype.constructor = Constructor;
        }
        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
            fixMethod('delete');
            fixMethod('has');
            IS_MAP && fixMethod('get');
        }
        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
        // weak collections should not contains .clear method
        if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
    }
    exported[CONSTRUCTOR_NAME] = Constructor;
    $9fd0241d8f6d7609$exports({
        global: true,
        constructor: true,
        forced: Constructor !== NativeConstructor
    }, exported);
    $0b80283a96aa2f97$exports(Constructor, CONSTRUCTOR_NAME);
    if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);
    return Constructor;
};


var $db789142ff971822$exports = {};
'use strict';



var $db789142ff971822$require$getWeakData = $1bf0be5a866787b4$exports.getWeakData;








var $db789142ff971822$var$setInternalState = $7c2e321de999e766$exports.set;
var $db789142ff971822$var$internalStateGetterFor = $7c2e321de999e766$exports.getterFor;
var $db789142ff971822$var$find = $f478770b94881111$exports.find;
var $db789142ff971822$var$findIndex = $f478770b94881111$exports.findIndex;
var $db789142ff971822$var$splice = $3d3a3f96d04dfa01$exports([].splice);
var $db789142ff971822$var$id = 0;
// fallback for uncaught frozen keys
var $db789142ff971822$var$uncaughtFrozenStore = function(state) {
    return state.frozen || (state.frozen = new $db789142ff971822$var$UncaughtFrozenStore());
};
var $db789142ff971822$var$UncaughtFrozenStore = function() {
    this.entries = [];
};
var $db789142ff971822$var$findUncaughtFrozen = function(store, key) {
    return $db789142ff971822$var$find(store.entries, function(it) {
        return it[0] === key;
    });
};
$db789142ff971822$var$UncaughtFrozenStore.prototype = {
    get: function(key) {
        var entry = $db789142ff971822$var$findUncaughtFrozen(this, key);
        if (entry) return entry[1];
    },
    has: function(key) {
        return !!$db789142ff971822$var$findUncaughtFrozen(this, key);
    },
    set: function(key, value) {
        var entry = $db789142ff971822$var$findUncaughtFrozen(this, key);
        if (entry) entry[1] = value;
        else this.entries.push([
            key,
            value
        ]);
    },
    'delete': function(key) {
        var index = $db789142ff971822$var$findIndex(this.entries, function(it) {
            return it[0] === key;
        });
        if (~index) $db789142ff971822$var$splice(this.entries, index, 1);
        return !!~index;
    }
};
$db789142ff971822$exports = {
    getConstructor: function(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
        var Constructor = wrapper(function(that, iterable) {
            $b9104a2e89b56b2e$exports(that, Prototype);
            $db789142ff971822$var$setInternalState(that, {
                type: CONSTRUCTOR_NAME,
                id: $db789142ff971822$var$id++,
                frozen: null
            });
            if (!$c3e80151589b4ea3$exports(iterable)) $25ce5bb5ab438b46$exports(iterable, that[ADDER], {
                that: that,
                AS_ENTRIES: IS_MAP
            });
        });
        var Prototype = Constructor.prototype;
        var getInternalState = $db789142ff971822$var$internalStateGetterFor(CONSTRUCTOR_NAME);
        var define = function(that, key, value) {
            var state = getInternalState(that);
            var data = $db789142ff971822$require$getWeakData($2d94e296a4d81142$exports(key), true);
            if (data === true) $db789142ff971822$var$uncaughtFrozenStore(state).set(key, value);
            else data[state.id] = value;
            return that;
        };
        $6355bfa194afe709$exports(Prototype, {
            // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
            // https://tc39.es/ecma262/#sec-weakset.prototype.delete
            'delete': function(key) {
                var state = getInternalState(this);
                if (!$d1de49472bdc582c$exports(key)) return false;
                var data = $db789142ff971822$require$getWeakData(key);
                if (data === true) return $db789142ff971822$var$uncaughtFrozenStore(state)['delete'](key);
                return data && $6713471208f796ec$exports(data, state.id) && delete data[state.id];
            },
            // `{ WeakMap, WeakSet }.prototype.has(key)` methods
            // https://tc39.es/ecma262/#sec-weakmap.prototype.has
            // https://tc39.es/ecma262/#sec-weakset.prototype.has
            has: function has(key) {
                var state = getInternalState(this);
                if (!$d1de49472bdc582c$exports(key)) return false;
                var data = $db789142ff971822$require$getWeakData(key);
                if (data === true) return $db789142ff971822$var$uncaughtFrozenStore(state).has(key);
                return data && $6713471208f796ec$exports(data, state.id);
            }
        });
        $6355bfa194afe709$exports(Prototype, IS_MAP ? {
            // `WeakMap.prototype.get(key)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.get
            get: function get(key) {
                var state = getInternalState(this);
                if ($d1de49472bdc582c$exports(key)) {
                    var data = $db789142ff971822$require$getWeakData(key);
                    if (data === true) return $db789142ff971822$var$uncaughtFrozenStore(state).get(key);
                    if (data) return data[state.id];
                }
            },
            // `WeakMap.prototype.set(key, value)` method
            // https://tc39.es/ecma262/#sec-weakmap.prototype.set
            set: function set(key, value) {
                return define(this, key, value);
            }
        } : {
            // `WeakSet.prototype.add(value)` method
            // https://tc39.es/ecma262/#sec-weakset.prototype.add
            add: function add(value) {
                return define(this, value, true);
            }
        });
        return Constructor;
    }
};




var $5bcf798a1bb9c1f7$require$enforceInternalState = $7c2e321de999e766$exports.enforce;


var $5bcf798a1bb9c1f7$var$$Object = Object;
// eslint-disable-next-line es/no-array-isarray -- safe
var $5bcf798a1bb9c1f7$var$isArray = Array.isArray;
// eslint-disable-next-line es/no-object-isextensible -- safe
var $5bcf798a1bb9c1f7$var$isExtensible = $5bcf798a1bb9c1f7$var$$Object.isExtensible;
// eslint-disable-next-line es/no-object-isfrozen -- safe
var $5bcf798a1bb9c1f7$var$isFrozen = $5bcf798a1bb9c1f7$var$$Object.isFrozen;
// eslint-disable-next-line es/no-object-issealed -- safe
var $5bcf798a1bb9c1f7$var$isSealed = $5bcf798a1bb9c1f7$var$$Object.isSealed;
// eslint-disable-next-line es/no-object-freeze -- safe
var $5bcf798a1bb9c1f7$var$freeze = $5bcf798a1bb9c1f7$var$$Object.freeze;
// eslint-disable-next-line es/no-object-seal -- safe
var $5bcf798a1bb9c1f7$var$seal = $5bcf798a1bb9c1f7$var$$Object.seal;
var $5bcf798a1bb9c1f7$var$IS_IE11 = !$37a62429f4992eb4$exports.ActiveXObject && 'ActiveXObject' in $37a62429f4992eb4$exports;
var $5bcf798a1bb9c1f7$var$InternalWeakMap;
var $5bcf798a1bb9c1f7$var$wrapper = function(init) {
    return function WeakMap() {
        return init(this, arguments.length ? arguments[0] : undefined);
    };
};
// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $5bcf798a1bb9c1f7$var$$WeakMap = $3ea5d594f6193905$exports('WeakMap', $5bcf798a1bb9c1f7$var$wrapper, $db789142ff971822$exports);
var $5bcf798a1bb9c1f7$var$WeakMapPrototype = $5bcf798a1bb9c1f7$var$$WeakMap.prototype;
var $5bcf798a1bb9c1f7$var$nativeSet = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype.set);
// Chakra Edge bug: adding frozen arrays to WeakMap unfreeze them
var $5bcf798a1bb9c1f7$var$hasMSEdgeFreezingBug = function() {
    return $9394318a06ff3af6$exports && $1aa9995203de1dcd$exports(function() {
        var frozenArray = $5bcf798a1bb9c1f7$var$freeze([]);
        $5bcf798a1bb9c1f7$var$nativeSet(new $5bcf798a1bb9c1f7$var$$WeakMap(), frozenArray, 1);
        return !$5bcf798a1bb9c1f7$var$isFrozen(frozenArray);
    });
};
// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if ($734e17bc28988288$exports) {
    if ($5bcf798a1bb9c1f7$var$IS_IE11) {
        $5bcf798a1bb9c1f7$var$InternalWeakMap = $db789142ff971822$exports.getConstructor($5bcf798a1bb9c1f7$var$wrapper, 'WeakMap', true);
        $1bf0be5a866787b4$exports.enable();
        var $5bcf798a1bb9c1f7$var$nativeDelete = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype['delete']);
        var $5bcf798a1bb9c1f7$var$nativeHas = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype.has);
        var $5bcf798a1bb9c1f7$var$nativeGet = $3d3a3f96d04dfa01$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype.get);
        $6355bfa194afe709$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype, {
            'delete': function(key) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    return $5bcf798a1bb9c1f7$var$nativeDelete(this, key) || state.frozen['delete'](key);
                }
                return $5bcf798a1bb9c1f7$var$nativeDelete(this, key);
            },
            has: function has(key) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    return $5bcf798a1bb9c1f7$var$nativeHas(this, key) || state.frozen.has(key);
                }
                return $5bcf798a1bb9c1f7$var$nativeHas(this, key);
            },
            get: function get(key) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    return $5bcf798a1bb9c1f7$var$nativeHas(this, key) ? $5bcf798a1bb9c1f7$var$nativeGet(this, key) : state.frozen.get(key);
                }
                return $5bcf798a1bb9c1f7$var$nativeGet(this, key);
            },
            set: function set(key, value) {
                if ($d1de49472bdc582c$exports(key) && !$5bcf798a1bb9c1f7$var$isExtensible(key)) {
                    var state = $5bcf798a1bb9c1f7$require$enforceInternalState(this);
                    if (!state.frozen) state.frozen = new $5bcf798a1bb9c1f7$var$InternalWeakMap();
                    $5bcf798a1bb9c1f7$var$nativeHas(this, key) ? $5bcf798a1bb9c1f7$var$nativeSet(this, key, value) : state.frozen.set(key, value);
                } else $5bcf798a1bb9c1f7$var$nativeSet(this, key, value);
                return this;
            }
        });
    // Chakra Edge frozen keys fix
    } else if ($5bcf798a1bb9c1f7$var$hasMSEdgeFreezingBug()) $6355bfa194afe709$exports($5bcf798a1bb9c1f7$var$WeakMapPrototype, {
        set: function set(key, value) {
            var arrayIntegrityLevel;
            if ($5bcf798a1bb9c1f7$var$isArray(key)) {
                if ($5bcf798a1bb9c1f7$var$isFrozen(key)) arrayIntegrityLevel = $5bcf798a1bb9c1f7$var$freeze;
                else if ($5bcf798a1bb9c1f7$var$isSealed(key)) arrayIntegrityLevel = $5bcf798a1bb9c1f7$var$seal;
            }
            $5bcf798a1bb9c1f7$var$nativeSet(this, key, value);
            if (arrayIntegrityLevel) arrayIntegrityLevel(key);
            return this;
        }
    });
}




'use strict';

var $23cbe3e76238b600$exports = {};
'use strict';
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$23cbe3e76238b600$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $c2ab62217a756625$exports = {};
'use strict';

var $c2ab62217a756625$var$classList = $416f618c0bbd719b$exports('span').classList;
var $c2ab62217a756625$var$DOMTokenListPrototype = $c2ab62217a756625$var$classList && $c2ab62217a756625$var$classList.constructor && $c2ab62217a756625$var$classList.constructor.prototype;
$c2ab62217a756625$exports = $c2ab62217a756625$var$DOMTokenListPrototype === Object.prototype ? undefined : $c2ab62217a756625$var$DOMTokenListPrototype;






var $143156ca805ae7b0$var$ITERATOR = $83f1bf79efdf35c6$exports('iterator');
var $143156ca805ae7b0$var$ArrayValues = $d5ae8eb900fc9661$exports.values;
var $143156ca805ae7b0$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$143156ca805ae7b0$var$ITERATOR] !== $143156ca805ae7b0$var$ArrayValues) try {
            $d13e1e0ab68f4bd6$exports(CollectionPrototype, $143156ca805ae7b0$var$ITERATOR, $143156ca805ae7b0$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$143156ca805ae7b0$var$ITERATOR] = $143156ca805ae7b0$var$ArrayValues;
        }
        $0b80283a96aa2f97$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($23cbe3e76238b600$exports[COLLECTION_NAME]) for(var METHOD_NAME in $d5ae8eb900fc9661$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $d5ae8eb900fc9661$exports[METHOD_NAME]) try {
                $d13e1e0ab68f4bd6$exports(CollectionPrototype, METHOD_NAME, $d5ae8eb900fc9661$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $d5ae8eb900fc9661$exports[METHOD_NAME];
            }
        }
    }
};
for(var $143156ca805ae7b0$var$COLLECTION_NAME in $23cbe3e76238b600$exports)$143156ca805ae7b0$var$handlePrototype($37a62429f4992eb4$exports[$143156ca805ae7b0$var$COLLECTION_NAME] && $37a62429f4992eb4$exports[$143156ca805ae7b0$var$COLLECTION_NAME].prototype, $143156ca805ae7b0$var$COLLECTION_NAME);
$143156ca805ae7b0$var$handlePrototype($c2ab62217a756625$exports, 'DOMTokenList');


var $0d7dfa4a4a0f0c8c$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $0d7dfa4a4a0f0c8c$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $0d7dfa4a4a0f0c8c$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $0d7dfa4a4a0f0c8c$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $0d7dfa4a4a0f0c8c$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $0d7dfa4a4a0f0c8c$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0d7dfa4a4a0f0c8c$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0d7dfa4a4a0f0c8c$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0d7dfa4a4a0f0c8c$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $0d7dfa4a4a0f0c8c$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $0d7dfa4a4a0f0c8c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $0d7dfa4a4a0f0c8c$var$root = $0d7dfa4a4a0f0c8c$var$freeGlobal || $0d7dfa4a4a0f0c8c$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $0d7dfa4a4a0f0c8c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0d7dfa4a4a0f0c8c$var$objectToString = $0d7dfa4a4a0f0c8c$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0d7dfa4a4a0f0c8c$var$nativeMax = Math.max, $0d7dfa4a4a0f0c8c$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $0d7dfa4a4a0f0c8c$var$now = function() {
    return $0d7dfa4a4a0f0c8c$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $0d7dfa4a4a0f0c8c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($0d7dfa4a4a0f0c8c$var$FUNC_ERROR_TEXT);
    wait = $0d7dfa4a4a0f0c8c$var$toNumber(wait) || 0;
    if ($0d7dfa4a4a0f0c8c$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $0d7dfa4a4a0f0c8c$var$nativeMax($0d7dfa4a4a0f0c8c$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $0d7dfa4a4a0f0c8c$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $0d7dfa4a4a0f0c8c$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($0d7dfa4a4a0f0c8c$var$now());
    }
    function debounced() {
        var time = $0d7dfa4a4a0f0c8c$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $0d7dfa4a4a0f0c8c$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($0d7dfa4a4a0f0c8c$var$FUNC_ERROR_TEXT);
    if ($0d7dfa4a4a0f0c8c$var$isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $0d7dfa4a4a0f0c8c$var$debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0d7dfa4a4a0f0c8c$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $0d7dfa4a4a0f0c8c$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $0d7dfa4a4a0f0c8c$var$isSymbol(value) {
    return typeof value == 'symbol' || $0d7dfa4a4a0f0c8c$var$isObjectLike(value) && $0d7dfa4a4a0f0c8c$var$objectToString.call(value) == $0d7dfa4a4a0f0c8c$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0d7dfa4a4a0f0c8c$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($0d7dfa4a4a0f0c8c$var$isSymbol(value)) return $0d7dfa4a4a0f0c8c$var$NAN;
    if ($0d7dfa4a4a0f0c8c$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $0d7dfa4a4a0f0c8c$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($0d7dfa4a4a0f0c8c$var$reTrim, '');
    var isBinary = $0d7dfa4a4a0f0c8c$var$reIsBinary.test(value);
    return isBinary || $0d7dfa4a4a0f0c8c$var$reIsOctal.test(value) ? $0d7dfa4a4a0f0c8c$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0d7dfa4a4a0f0c8c$var$reIsBadHex.test(value) ? $0d7dfa4a4a0f0c8c$var$NAN : +value;
}
$0d7dfa4a4a0f0c8c$exports = $0d7dfa4a4a0f0c8c$var$throttle;



var $cab391c968b6f1b1$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $cab391c968b6f1b1$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $cab391c968b6f1b1$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** `Object#toString` result references. */ var $cab391c968b6f1b1$var$funcTag = '[object Function]', $cab391c968b6f1b1$var$genTag = '[object GeneratorFunction]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $cab391c968b6f1b1$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $cab391c968b6f1b1$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $cab391c968b6f1b1$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $cab391c968b6f1b1$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $cab391c968b6f1b1$var$root = $cab391c968b6f1b1$var$freeGlobal || $cab391c968b6f1b1$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $cab391c968b6f1b1$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $cab391c968b6f1b1$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $cab391c968b6f1b1$var$arrayProto = Array.prototype, $cab391c968b6f1b1$var$funcProto = Function.prototype, $cab391c968b6f1b1$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $cab391c968b6f1b1$var$coreJsData = $cab391c968b6f1b1$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $cab391c968b6f1b1$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($cab391c968b6f1b1$var$coreJsData && $cab391c968b6f1b1$var$coreJsData.keys && $cab391c968b6f1b1$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $cab391c968b6f1b1$var$funcToString = $cab391c968b6f1b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $cab391c968b6f1b1$var$hasOwnProperty = $cab391c968b6f1b1$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $cab391c968b6f1b1$var$objectToString = $cab391c968b6f1b1$var$objectProto.toString;
/** Used to detect if a method is native. */ var $cab391c968b6f1b1$var$reIsNative = RegExp('^' + $cab391c968b6f1b1$var$funcToString.call($cab391c968b6f1b1$var$hasOwnProperty).replace($cab391c968b6f1b1$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $cab391c968b6f1b1$var$splice = $cab391c968b6f1b1$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $cab391c968b6f1b1$var$Map = $cab391c968b6f1b1$var$getNative($cab391c968b6f1b1$var$root, 'Map'), $cab391c968b6f1b1$var$nativeCreate = $cab391c968b6f1b1$var$getNative(Object, 'create');
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cab391c968b6f1b1$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $cab391c968b6f1b1$var$hashClear() {
    this.__data__ = $cab391c968b6f1b1$var$nativeCreate ? $cab391c968b6f1b1$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cab391c968b6f1b1$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cab391c968b6f1b1$var$hashGet(key) {
    var data = this.__data__;
    if ($cab391c968b6f1b1$var$nativeCreate) {
        var result = data[key];
        return result === $cab391c968b6f1b1$var$HASH_UNDEFINED ? undefined : result;
    }
    return $cab391c968b6f1b1$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cab391c968b6f1b1$var$hashHas(key) {
    var data = this.__data__;
    return $cab391c968b6f1b1$var$nativeCreate ? data[key] !== undefined : $cab391c968b6f1b1$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $cab391c968b6f1b1$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $cab391c968b6f1b1$var$nativeCreate && value === undefined ? $cab391c968b6f1b1$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$cab391c968b6f1b1$var$Hash.prototype.clear = $cab391c968b6f1b1$var$hashClear;
$cab391c968b6f1b1$var$Hash.prototype['delete'] = $cab391c968b6f1b1$var$hashDelete;
$cab391c968b6f1b1$var$Hash.prototype.get = $cab391c968b6f1b1$var$hashGet;
$cab391c968b6f1b1$var$Hash.prototype.has = $cab391c968b6f1b1$var$hashHas;
$cab391c968b6f1b1$var$Hash.prototype.set = $cab391c968b6f1b1$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cab391c968b6f1b1$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cab391c968b6f1b1$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cab391c968b6f1b1$var$listCacheDelete(key) {
    var data = this.__data__, index = $cab391c968b6f1b1$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $cab391c968b6f1b1$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cab391c968b6f1b1$var$listCacheGet(key) {
    var data = this.__data__, index = $cab391c968b6f1b1$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cab391c968b6f1b1$var$listCacheHas(key) {
    return $cab391c968b6f1b1$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $cab391c968b6f1b1$var$listCacheSet(key, value) {
    var data = this.__data__, index = $cab391c968b6f1b1$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$cab391c968b6f1b1$var$ListCache.prototype.clear = $cab391c968b6f1b1$var$listCacheClear;
$cab391c968b6f1b1$var$ListCache.prototype['delete'] = $cab391c968b6f1b1$var$listCacheDelete;
$cab391c968b6f1b1$var$ListCache.prototype.get = $cab391c968b6f1b1$var$listCacheGet;
$cab391c968b6f1b1$var$ListCache.prototype.has = $cab391c968b6f1b1$var$listCacheHas;
$cab391c968b6f1b1$var$ListCache.prototype.set = $cab391c968b6f1b1$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cab391c968b6f1b1$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $cab391c968b6f1b1$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $cab391c968b6f1b1$var$Hash,
        'map': new ($cab391c968b6f1b1$var$Map || $cab391c968b6f1b1$var$ListCache),
        'string': new $cab391c968b6f1b1$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $cab391c968b6f1b1$var$mapCacheDelete(key) {
    return $cab391c968b6f1b1$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $cab391c968b6f1b1$var$mapCacheGet(key) {
    return $cab391c968b6f1b1$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cab391c968b6f1b1$var$mapCacheHas(key) {
    return $cab391c968b6f1b1$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $cab391c968b6f1b1$var$mapCacheSet(key, value) {
    $cab391c968b6f1b1$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$cab391c968b6f1b1$var$MapCache.prototype.clear = $cab391c968b6f1b1$var$mapCacheClear;
$cab391c968b6f1b1$var$MapCache.prototype['delete'] = $cab391c968b6f1b1$var$mapCacheDelete;
$cab391c968b6f1b1$var$MapCache.prototype.get = $cab391c968b6f1b1$var$mapCacheGet;
$cab391c968b6f1b1$var$MapCache.prototype.has = $cab391c968b6f1b1$var$mapCacheHas;
$cab391c968b6f1b1$var$MapCache.prototype.set = $cab391c968b6f1b1$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $cab391c968b6f1b1$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($cab391c968b6f1b1$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $cab391c968b6f1b1$var$baseIsNative(value) {
    if (!$cab391c968b6f1b1$var$isObject(value) || $cab391c968b6f1b1$var$isMasked(value)) return false;
    var pattern = $cab391c968b6f1b1$var$isFunction(value) || $cab391c968b6f1b1$var$isHostObject(value) ? $cab391c968b6f1b1$var$reIsNative : $cab391c968b6f1b1$var$reIsHostCtor;
    return pattern.test($cab391c968b6f1b1$var$toSource(value));
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $cab391c968b6f1b1$var$getMapData(map, key) {
    var data = map.__data__;
    return $cab391c968b6f1b1$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $cab391c968b6f1b1$var$getNative(object, key) {
    var value = $cab391c968b6f1b1$var$getValue(object, key);
    return $cab391c968b6f1b1$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $cab391c968b6f1b1$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $cab391c968b6f1b1$var$isMasked(func) {
    return !!$cab391c968b6f1b1$var$maskSrcKey && $cab391c968b6f1b1$var$maskSrcKey in func;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $cab391c968b6f1b1$var$toSource(func) {
    if (func != null) {
        try {
            return $cab391c968b6f1b1$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $cab391c968b6f1b1$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($cab391c968b6f1b1$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($cab391c968b6f1b1$var$memoize.Cache || $cab391c968b6f1b1$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$cab391c968b6f1b1$var$memoize.Cache = $cab391c968b6f1b1$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $cab391c968b6f1b1$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $cab391c968b6f1b1$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $cab391c968b6f1b1$var$isObject(value) ? $cab391c968b6f1b1$var$objectToString.call(value) : '';
    return tag == $cab391c968b6f1b1$var$funcTag || tag == $cab391c968b6f1b1$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $cab391c968b6f1b1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
$cab391c968b6f1b1$exports = $cab391c968b6f1b1$var$memoize;


var $0dacb699cf7bde6f$export$402e76927ebf6a24 = [];


var $c010ee072a42dfb7$export$63c81bd924f89474 = function() {
    return (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).some(function(ro) {
        return ro.activeTargets.length > 0;
    });
};



var $df335e0168eb6cb4$export$8ca35300535e324d = function() {
    return (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).some(function(ro) {
        return ro.skippedTargets.length > 0;
    });
};


var $7fa42eef5f344cd5$var$msg = 'ResizeObserver loop completed with undelivered notifications.';
var $7fa42eef5f344cd5$export$888cb69481582149 = function() {
    var event;
    if (typeof ErrorEvent === 'function') event = new ErrorEvent('error', {
        message: $7fa42eef5f344cd5$var$msg
    });
    else {
        event = document.createEvent('Event');
        event.initEvent('error', false, false);
        event.message = $7fa42eef5f344cd5$var$msg;
    }
    window.dispatchEvent(event);
};



var $cb5f134aaeef814d$export$416d111b83cd1483;
(function(ResizeObserverBoxOptions) {
    ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
    ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
    ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})($cb5f134aaeef814d$export$416d111b83cd1483 || ($cb5f134aaeef814d$export$416d111b83cd1483 = {}));


var $4901de7e393b9d46$export$792f3d81ea979f55 = function(obj) {
    return Object.freeze(obj);
};


var $82141eaf453c4dc0$export$c9ad8cdf6bbd331c = function() {
    function ResizeObserverSize(inlineSize, blockSize) {
        this.inlineSize = inlineSize;
        this.blockSize = blockSize;
        (0, $4901de7e393b9d46$export$792f3d81ea979f55)(this);
    }
    return ResizeObserverSize;
}();



var $3e28b28a8ebee037$export$51d7a67026f4e0b7 = function() {
    function DOMRectReadOnly(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.top = this.y;
        this.left = this.x;
        this.bottom = this.top + this.height;
        this.right = this.left + this.width;
        return (0, $4901de7e393b9d46$export$792f3d81ea979f55)(this);
    }
    DOMRectReadOnly.prototype.toJSON = function() {
        var _a = this, x = _a.x, y = _a.y, top = _a.top, right = _a.right, bottom = _a.bottom, left = _a.left, width = _a.width, height = _a.height;
        return {
            x: x,
            y: y,
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height
        };
    };
    DOMRectReadOnly.fromRect = function(rectangle) {
        return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    };
    return DOMRectReadOnly;
}();


var $fe737ba065c58402$export$165b39ed277223c2 = function(target) {
    return target instanceof SVGElement && 'getBBox' in target;
};
var $fe737ba065c58402$export$ee695c13482bb5dd = function(target) {
    if ($fe737ba065c58402$export$165b39ed277223c2(target)) {
        var _a = target.getBBox(), width = _a.width, height = _a.height;
        return !width && !height;
    }
    var _b = target, offsetWidth = _b.offsetWidth, offsetHeight = _b.offsetHeight;
    return !(offsetWidth || offsetHeight || target.getClientRects().length);
};
var $fe737ba065c58402$export$45a5e7f76e0caa8d = function(obj) {
    var _a;
    if (obj instanceof Element) return true;
    var scope = (_a = obj === null || obj === void 0 ? void 0 : obj.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
    return !!(scope && obj instanceof scope.Element);
};
var $fe737ba065c58402$export$a6eb60f7e7c182ba = function(target) {
    switch(target.tagName){
        case 'INPUT':
            if (target.type !== 'image') break;
        case 'VIDEO':
        case 'AUDIO':
        case 'EMBED':
        case 'OBJECT':
        case 'CANVAS':
        case 'IFRAME':
        case 'IMG':
            return true;
    }
    return false;
};



var $3cde5e4b96487237$export$90b4d2ff6acb88af = typeof window !== 'undefined' ? window : {};


var $4badd4e08dca187c$var$cache = new WeakMap();
var $4badd4e08dca187c$var$scrollRegexp = /auto|scroll/;
var $4badd4e08dca187c$var$verticalRegexp = /^tb|vertical/;
var $4badd4e08dca187c$var$IE = /msie|trident/i.test((0, $3cde5e4b96487237$export$90b4d2ff6acb88af).navigator && (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).navigator.userAgent);
var $4badd4e08dca187c$var$parseDimension = function(pixel) {
    return parseFloat(pixel || '0');
};
var $4badd4e08dca187c$var$size = function(inlineSize, blockSize, switchSizes) {
    if (inlineSize === void 0) inlineSize = 0;
    if (blockSize === void 0) blockSize = 0;
    if (switchSizes === void 0) switchSizes = false;
    return new (0, $82141eaf453c4dc0$export$c9ad8cdf6bbd331c)((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};
var $4badd4e08dca187c$var$zeroBoxes = (0, $4901de7e393b9d46$export$792f3d81ea979f55)({
    devicePixelContentBoxSize: $4badd4e08dca187c$var$size(),
    borderBoxSize: $4badd4e08dca187c$var$size(),
    contentBoxSize: $4badd4e08dca187c$var$size(),
    contentRect: new (0, $3e28b28a8ebee037$export$51d7a67026f4e0b7)(0, 0, 0, 0)
});
var $4badd4e08dca187c$export$504d039a9c501c94 = function(target, forceRecalculation) {
    if (forceRecalculation === void 0) forceRecalculation = false;
    if ($4badd4e08dca187c$var$cache.has(target) && !forceRecalculation) return $4badd4e08dca187c$var$cache.get(target);
    if ((0, $fe737ba065c58402$export$ee695c13482bb5dd)(target)) {
        $4badd4e08dca187c$var$cache.set(target, $4badd4e08dca187c$var$zeroBoxes);
        return $4badd4e08dca187c$var$zeroBoxes;
    }
    var cs = getComputedStyle(target);
    var svg = (0, $fe737ba065c58402$export$165b39ed277223c2)(target) && target.ownerSVGElement && target.getBBox();
    var removePadding = !$4badd4e08dca187c$var$IE && cs.boxSizing === 'border-box';
    var switchSizes = $4badd4e08dca187c$var$verticalRegexp.test(cs.writingMode || '');
    var canScrollVertically = !svg && $4badd4e08dca187c$var$scrollRegexp.test(cs.overflowY || '');
    var canScrollHorizontally = !svg && $4badd4e08dca187c$var$scrollRegexp.test(cs.overflowX || '');
    var paddingTop = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingTop);
    var paddingRight = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingRight);
    var paddingBottom = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingBottom);
    var paddingLeft = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.paddingLeft);
    var borderTop = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderTopWidth);
    var borderRight = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderRightWidth);
    var borderBottom = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderBottomWidth);
    var borderLeft = svg ? 0 : $4badd4e08dca187c$var$parseDimension(cs.borderLeftWidth);
    var horizontalPadding = paddingLeft + paddingRight;
    var verticalPadding = paddingTop + paddingBottom;
    var horizontalBorderArea = borderLeft + borderRight;
    var verticalBorderArea = borderTop + borderBottom;
    var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
    var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
    var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
    var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
    var contentWidth = svg ? svg.width : $4badd4e08dca187c$var$parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
    var contentHeight = svg ? svg.height : $4badd4e08dca187c$var$parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
    var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
    var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
    var boxes = (0, $4901de7e393b9d46$export$792f3d81ea979f55)({
        devicePixelContentBoxSize: $4badd4e08dca187c$var$size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
        borderBoxSize: $4badd4e08dca187c$var$size(borderBoxWidth, borderBoxHeight, switchSizes),
        contentBoxSize: $4badd4e08dca187c$var$size(contentWidth, contentHeight, switchSizes),
        contentRect: new (0, $3e28b28a8ebee037$export$51d7a67026f4e0b7)(paddingLeft, paddingTop, contentWidth, contentHeight)
    });
    $4badd4e08dca187c$var$cache.set(target, boxes);
    return boxes;
};
var $4badd4e08dca187c$export$1a78030b04106bdb = function(target, observedBox, forceRecalculation) {
    var _a = $4badd4e08dca187c$export$504d039a9c501c94(target, forceRecalculation), borderBoxSize = _a.borderBoxSize, contentBoxSize = _a.contentBoxSize, devicePixelContentBoxSize = _a.devicePixelContentBoxSize;
    switch(observedBox){
        case (0, $cb5f134aaeef814d$export$416d111b83cd1483).DEVICE_PIXEL_CONTENT_BOX:
            return devicePixelContentBoxSize;
        case (0, $cb5f134aaeef814d$export$416d111b83cd1483).BORDER_BOX:
            return borderBoxSize;
        default:
            return contentBoxSize;
    }
};



var $77fed51082b31934$export$226159b441fc89f8 = function() {
    function ResizeObserverEntry(target) {
        var boxes = (0, $4badd4e08dca187c$export$504d039a9c501c94)(target);
        this.target = target;
        this.contentRect = boxes.contentRect;
        this.borderBoxSize = (0, $4901de7e393b9d46$export$792f3d81ea979f55)([
            boxes.borderBoxSize
        ]);
        this.contentBoxSize = (0, $4901de7e393b9d46$export$792f3d81ea979f55)([
            boxes.contentBoxSize
        ]);
        this.devicePixelContentBoxSize = (0, $4901de7e393b9d46$export$792f3d81ea979f55)([
            boxes.devicePixelContentBoxSize
        ]);
    }
    return ResizeObserverEntry;
}();



var $7cc19e521cfe268c$export$f8c8e3b5da1f41d2 = function(node) {
    if ((0, $fe737ba065c58402$export$ee695c13482bb5dd)(node)) return Infinity;
    var depth = 0;
    var parent = node.parentNode;
    while(parent){
        depth += 1;
        parent = parent.parentNode;
    }
    return depth;
};



var $0f4f571233fdcf43$export$9cac928141e5443b = function() {
    var shallowestDepth = Infinity;
    var callbacks = [];
    (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        if (ro.activeTargets.length === 0) return;
        var entries = [];
        ro.activeTargets.forEach(function processTarget(ot) {
            var entry = new (0, $77fed51082b31934$export$226159b441fc89f8)(ot.target);
            var targetDepth = (0, $7cc19e521cfe268c$export$f8c8e3b5da1f41d2)(ot.target);
            entries.push(entry);
            ot.lastReportedSize = (0, $4badd4e08dca187c$export$1a78030b04106bdb)(ot.target, ot.observedBox);
            if (targetDepth < shallowestDepth) shallowestDepth = targetDepth;
        });
        callbacks.push(function resizeObserverCallback() {
            ro.callback.call(ro.observer, entries, ro.observer);
        });
        ro.activeTargets.splice(0, ro.activeTargets.length);
    });
    for(var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++){
        var callback = callbacks_1[_i];
        callback();
    }
    return shallowestDepth;
};




var $7fd6a7926b3b3b49$export$9c17b8913a2a3572 = function(depth) {
    (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).forEach(function processObserver(ro) {
        ro.activeTargets.splice(0, ro.activeTargets.length);
        ro.skippedTargets.splice(0, ro.skippedTargets.length);
        ro.observationTargets.forEach(function processTarget(ot) {
            if (ot.isActive()) {
                if ((0, $7cc19e521cfe268c$export$f8c8e3b5da1f41d2)(ot.target) > depth) ro.activeTargets.push(ot);
                else ro.skippedTargets.push(ot);
            }
        });
    });
};


var $ca3e4246ee194a0b$export$e54fe5b0f43758f7 = function() {
    var depth = 0;
    (0, $7fd6a7926b3b3b49$export$9c17b8913a2a3572)(depth);
    while((0, $c010ee072a42dfb7$export$63c81bd924f89474)()){
        depth = (0, $0f4f571233fdcf43$export$9cac928141e5443b)();
        (0, $7fd6a7926b3b3b49$export$9c17b8913a2a3572)(depth);
    }
    if ((0, $df335e0168eb6cb4$export$8ca35300535e324d)()) (0, $7fa42eef5f344cd5$export$888cb69481582149)();
    return depth > 0;
};



var $f766f5a76b58878e$var$trigger;
var $f766f5a76b58878e$var$callbacks = [];
var $f766f5a76b58878e$var$notify = function() {
    return $f766f5a76b58878e$var$callbacks.splice(0).forEach(function(cb) {
        return cb();
    });
};
var $f766f5a76b58878e$export$4c995d4933c4abb = function(callback) {
    if (!$f766f5a76b58878e$var$trigger) {
        var toggle_1 = 0;
        var el_1 = document.createTextNode('');
        var config = {
            characterData: true
        };
        new MutationObserver(function() {
            return $f766f5a76b58878e$var$notify();
        }).observe(el_1, config);
        $f766f5a76b58878e$var$trigger = function() {
            el_1.textContent = "".concat(toggle_1 ? toggle_1-- : toggle_1++);
        };
    }
    $f766f5a76b58878e$var$callbacks.push(callback);
    $f766f5a76b58878e$var$trigger();
};


var $0d378bbf225e6322$export$5755c7b572e34c6 = function(cb) {
    (0, $f766f5a76b58878e$export$4c995d4933c4abb)(function ResizeObserver() {
        requestAnimationFrame(cb);
    });
};


var $a4a922d47d90bbfc$var$watching = 0;
var $a4a922d47d90bbfc$var$isWatching = function() {
    return !!$a4a922d47d90bbfc$var$watching;
};
var $a4a922d47d90bbfc$var$CATCH_PERIOD = 250;
var $a4a922d47d90bbfc$var$observerConfig = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
var $a4a922d47d90bbfc$var$events = [
    'resize',
    'load',
    'transitionend',
    'animationend',
    'animationstart',
    'animationiteration',
    'keyup',
    'keydown',
    'mouseup',
    'mousedown',
    'mouseover',
    'mouseout',
    'blur',
    'focus'
];
var $a4a922d47d90bbfc$var$time = function(timeout) {
    if (timeout === void 0) timeout = 0;
    return Date.now() + timeout;
};
var $a4a922d47d90bbfc$var$scheduled = false;
var $a4a922d47d90bbfc$var$Scheduler = function() {
    function Scheduler() {
        var _this = this;
        this.stopped = true;
        this.listener = function() {
            return _this.schedule();
        };
    }
    Scheduler.prototype.run = function(timeout) {
        var _this = this;
        if (timeout === void 0) timeout = $a4a922d47d90bbfc$var$CATCH_PERIOD;
        if ($a4a922d47d90bbfc$var$scheduled) return;
        $a4a922d47d90bbfc$var$scheduled = true;
        var until = $a4a922d47d90bbfc$var$time(timeout);
        (0, $0d378bbf225e6322$export$5755c7b572e34c6)(function() {
            var elementsHaveResized = false;
            try {
                elementsHaveResized = (0, $ca3e4246ee194a0b$export$e54fe5b0f43758f7)();
            } finally{
                $a4a922d47d90bbfc$var$scheduled = false;
                timeout = until - $a4a922d47d90bbfc$var$time();
                if (!$a4a922d47d90bbfc$var$isWatching()) return;
                if (elementsHaveResized) _this.run(1000);
                else if (timeout > 0) _this.run(timeout);
                else _this.start();
            }
        });
    };
    Scheduler.prototype.schedule = function() {
        this.stop();
        this.run();
    };
    Scheduler.prototype.observe = function() {
        var _this = this;
        var cb = function() {
            return _this.observer && _this.observer.observe(document.body, $a4a922d47d90bbfc$var$observerConfig);
        };
        document.body ? cb() : (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).addEventListener('DOMContentLoaded', cb);
    };
    Scheduler.prototype.start = function() {
        var _this = this;
        if (this.stopped) {
            this.stopped = false;
            this.observer = new MutationObserver(this.listener);
            this.observe();
            $a4a922d47d90bbfc$var$events.forEach(function(name) {
                return (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).addEventListener(name, _this.listener, true);
            });
        }
    };
    Scheduler.prototype.stop = function() {
        var _this = this;
        if (!this.stopped) {
            this.observer && this.observer.disconnect();
            $a4a922d47d90bbfc$var$events.forEach(function(name) {
                return (0, $3cde5e4b96487237$export$90b4d2ff6acb88af).removeEventListener(name, _this.listener, true);
            });
            this.stopped = true;
        }
    };
    return Scheduler;
}();
var $a4a922d47d90bbfc$export$d30788f2c20241cd = new $a4a922d47d90bbfc$var$Scheduler();
var $a4a922d47d90bbfc$export$1f18a74d42722835 = function(n) {
    !$a4a922d47d90bbfc$var$watching && n > 0 && $a4a922d47d90bbfc$export$d30788f2c20241cd.start();
    $a4a922d47d90bbfc$var$watching += n;
    !$a4a922d47d90bbfc$var$watching && $a4a922d47d90bbfc$export$d30788f2c20241cd.stop();
};





var $7ed9adf7c892ac00$var$skipNotifyOnElement = function(target) {
    return !(0, $fe737ba065c58402$export$165b39ed277223c2)(target) && !(0, $fe737ba065c58402$export$a6eb60f7e7c182ba)(target) && getComputedStyle(target).display === 'inline';
};
var $7ed9adf7c892ac00$export$fea412043713122 = function() {
    function ResizeObservation(target, observedBox) {
        this.target = target;
        this.observedBox = observedBox || (0, $cb5f134aaeef814d$export$416d111b83cd1483).CONTENT_BOX;
        this.lastReportedSize = {
            inlineSize: 0,
            blockSize: 0
        };
    }
    ResizeObservation.prototype.isActive = function() {
        var size = (0, $4badd4e08dca187c$export$1a78030b04106bdb)(this.target, this.observedBox, true);
        if ($7ed9adf7c892ac00$var$skipNotifyOnElement(this.target)) this.lastReportedSize = size;
        if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) return true;
        return false;
    };
    return ResizeObservation;
}();


var $ac4ac616c0d885dd$export$d86966e6e4bc97e1 = function() {
    function ResizeObserverDetail(resizeObserver, callback) {
        this.activeTargets = [];
        this.skippedTargets = [];
        this.observationTargets = [];
        this.observer = resizeObserver;
        this.callback = callback;
    }
    return ResizeObserverDetail;
}();



var $ba1dd8e3d068b244$var$observerMap = new WeakMap();
var $ba1dd8e3d068b244$var$getObservationIndex = function(observationTargets, target) {
    for(var i = 0; i < observationTargets.length; i += 1){
        if (observationTargets[i].target === target) return i;
    }
    return -1;
};
var $ba1dd8e3d068b244$export$ed99c5bafbaf8300 = function() {
    function ResizeObserverController() {}
    ResizeObserverController.connect = function(resizeObserver, callback) {
        var detail = new (0, $ac4ac616c0d885dd$export$d86966e6e4bc97e1)(resizeObserver, callback);
        $ba1dd8e3d068b244$var$observerMap.set(resizeObserver, detail);
    };
    ResizeObserverController.observe = function(resizeObserver, target, options) {
        var detail = $ba1dd8e3d068b244$var$observerMap.get(resizeObserver);
        var firstObservation = detail.observationTargets.length === 0;
        if ($ba1dd8e3d068b244$var$getObservationIndex(detail.observationTargets, target) < 0) {
            firstObservation && (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).push(detail);
            detail.observationTargets.push(new (0, $7ed9adf7c892ac00$export$fea412043713122)(target, options && options.box));
            (0, $a4a922d47d90bbfc$export$1f18a74d42722835)(1);
            (0, $a4a922d47d90bbfc$export$d30788f2c20241cd).schedule();
        }
    };
    ResizeObserverController.unobserve = function(resizeObserver, target) {
        var detail = $ba1dd8e3d068b244$var$observerMap.get(resizeObserver);
        var index = $ba1dd8e3d068b244$var$getObservationIndex(detail.observationTargets, target);
        var lastObservation = detail.observationTargets.length === 1;
        if (index >= 0) {
            lastObservation && (0, $0dacb699cf7bde6f$export$402e76927ebf6a24).splice((0, $0dacb699cf7bde6f$export$402e76927ebf6a24).indexOf(detail), 1);
            detail.observationTargets.splice(index, 1);
            (0, $a4a922d47d90bbfc$export$1f18a74d42722835)(-1);
        }
    };
    ResizeObserverController.disconnect = function(resizeObserver) {
        var _this = this;
        var detail = $ba1dd8e3d068b244$var$observerMap.get(resizeObserver);
        detail.observationTargets.slice().forEach(function(ot) {
            return _this.unobserve(resizeObserver, ot.target);
        });
        detail.activeTargets.splice(0, detail.activeTargets.length);
    };
    return ResizeObserverController;
}();



var $16f0ad567ed11238$export$9caf76241ca21a11 = function() {
    function ResizeObserver(callback) {
        if (arguments.length === 0) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
        if (typeof callback !== 'function') throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).connect(this, callback);
    }
    ResizeObserver.prototype.observe = function(target, options) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $fe737ba065c58402$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).observe(this, target, options);
    };
    ResizeObserver.prototype.unobserve = function(target) {
        if (arguments.length === 0) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
        if (!(0, $fe737ba065c58402$export$45a5e7f76e0caa8d)(target)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).unobserve(this, target);
    };
    ResizeObserver.prototype.disconnect = function() {
        (0, $ba1dd8e3d068b244$export$ed99c5bafbaf8300).disconnect(this);
    };
    ResizeObserver.toString = function() {
        return 'function ResizeObserver () { [polyfill code] }';
    };
    return ResizeObserver;
}();






var $baf1d31a374e6aa9$exports = {};
var $baf1d31a374e6aa9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
$baf1d31a374e6aa9$exports = $baf1d31a374e6aa9$var$canUseDOM;


'use strict';

var $4cad6323f88545c7$exports = {};
'use strict';




var $4cad6323f88545c7$var$$TypeError = TypeError;
var $4cad6323f88545c7$var$REDUCE_EMPTY = 'Reduce of empty array with no initial value';
// `Array.prototype.{ reduce, reduceRight }` methods implementation
var $4cad6323f88545c7$var$createMethod = function(IS_RIGHT) {
    return function(that, callbackfn, argumentsLength, memo) {
        var O = $476d2ef928fdaf21$exports(that);
        var self = $ef1b385171038d0e$exports(O);
        var length = $b20a724496178f6b$exports(O);
        $5f7d5e7ccafe12e0$exports(callbackfn);
        if (length === 0 && argumentsLength < 2) throw new $4cad6323f88545c7$var$$TypeError($4cad6323f88545c7$var$REDUCE_EMPTY);
        var index = IS_RIGHT ? length - 1 : 0;
        var i = IS_RIGHT ? -1 : 1;
        if (argumentsLength < 2) while(true){
            if (index in self) {
                memo = self[index];
                index += i;
                break;
            }
            index += i;
            if (IS_RIGHT ? index < 0 : length <= index) throw new $4cad6323f88545c7$var$$TypeError($4cad6323f88545c7$var$REDUCE_EMPTY);
        }
        for(; IS_RIGHT ? index >= 0 : length > index; index += i)if (index in self) memo = callbackfn(memo, self[index], index, O);
        return memo;
    };
};
$4cad6323f88545c7$exports = {
    // `Array.prototype.reduce` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduce
    left: $4cad6323f88545c7$var$createMethod(false),
    // `Array.prototype.reduceRight` method
    // https://tc39.es/ecma262/#sec-array.prototype.reduceright
    right: $4cad6323f88545c7$var$createMethod(true)
};


var $ce8468cca1877a4c$require$$reduce = $4cad6323f88545c7$exports.left;
var $dbdccc15ba54ab31$exports = {};
'use strict';

$dbdccc15ba54ab31$exports = function(METHOD_NAME, argument) {
    var method = [][METHOD_NAME];
    return !!method && $1aa9995203de1dcd$exports(function() {
        // eslint-disable-next-line no-useless-call -- required for testing
        method.call(null, argument || function() {
            return 1;
        }, 1);
    });
};



var $299e4c12d12efda7$exports = {};
'use strict';
var $8dd33950de8c7d5b$exports = {};
'use strict';



var $8dd33950de8c7d5b$var$userAgentStartsWith = function(string) {
    return $d51ceacb4a64d873$exports.slice(0, string.length) === string;
};
$8dd33950de8c7d5b$exports = function() {
    if ($8dd33950de8c7d5b$var$userAgentStartsWith('Bun/')) return 'BUN';
    if ($8dd33950de8c7d5b$var$userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
    if ($8dd33950de8c7d5b$var$userAgentStartsWith('Deno/')) return 'DENO';
    if ($8dd33950de8c7d5b$var$userAgentStartsWith('Node.js/')) return 'NODE';
    if ($37a62429f4992eb4$exports.Bun && typeof Bun.version == 'string') return 'BUN';
    if ($37a62429f4992eb4$exports.Deno && typeof Deno.version == 'object') return 'DENO';
    if ($3a0f0fc82e93bd49$exports($37a62429f4992eb4$exports.process) === 'process') return 'NODE';
    if ($37a62429f4992eb4$exports.window && $37a62429f4992eb4$exports.document) return 'BROWSER';
    return 'REST';
}();


$299e4c12d12efda7$exports = $8dd33950de8c7d5b$exports === 'NODE';


// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var $ce8468cca1877a4c$var$CHROME_BUG = !$299e4c12d12efda7$exports && $800ddfa01b593c5d$exports > 79 && $800ddfa01b593c5d$exports < 83;
var $ce8468cca1877a4c$var$FORCED = $ce8468cca1877a4c$var$CHROME_BUG || !$dbdccc15ba54ab31$exports('reduce');
// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$9fd0241d8f6d7609$exports({
    target: 'Array',
    proto: true,
    forced: $ce8468cca1877a4c$var$FORCED
}, {
    reduce: function reduce(callbackfn /* , initialValue */ ) {
        var length = arguments.length;
        return $ce8468cca1877a4c$require$$reduce(this, callbackfn, length, length > 1 ? arguments[1] : undefined);
    }
});


'use strict';

var $9f1c7421fb321906$exports = {};
'use strict';



var $984691af733d2c6d$exports = {};
'use strict';

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$984691af733d2c6d$exports = function() {
    var that = $2d94e296a4d81142$exports(this);
    var result = '';
    if (that.hasIndices) result += 'd';
    if (that.global) result += 'g';
    if (that.ignoreCase) result += 'i';
    if (that.multiline) result += 'm';
    if (that.dotAll) result += 's';
    if (that.unicode) result += 'u';
    if (that.unicodeSets) result += 'v';
    if (that.sticky) result += 'y';
    return result;
};


var $a314baf789497fdc$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $a314baf789497fdc$var$$RegExp = $37a62429f4992eb4$exports.RegExp;
var $a314baf789497fdc$var$UNSUPPORTED_Y = $1aa9995203de1dcd$exports(function() {
    var re = $a314baf789497fdc$var$$RegExp('a', 'y');
    re.lastIndex = 2;
    return re.exec('abcd') !== null;
});
// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var $a314baf789497fdc$var$MISSED_STICKY = $a314baf789497fdc$var$UNSUPPORTED_Y || $1aa9995203de1dcd$exports(function() {
    return !$a314baf789497fdc$var$$RegExp('a', 'y').sticky;
});
var $a314baf789497fdc$var$BROKEN_CARET = $a314baf789497fdc$var$UNSUPPORTED_Y || $1aa9995203de1dcd$exports(function() {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
    var re = $a314baf789497fdc$var$$RegExp('^r', 'gy');
    re.lastIndex = 2;
    return re.exec('str') !== null;
});
$a314baf789497fdc$exports = {
    BROKEN_CARET: $a314baf789497fdc$var$BROKEN_CARET,
    MISSED_STICKY: $a314baf789497fdc$var$MISSED_STICKY,
    UNSUPPORTED_Y: $a314baf789497fdc$var$UNSUPPORTED_Y
};





var $9f1c7421fb321906$require$getInternalState = $7c2e321de999e766$exports.get;
var $5ee76d82519ecf67$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $5ee76d82519ecf67$var$$RegExp = $37a62429f4992eb4$exports.RegExp;
$5ee76d82519ecf67$exports = $1aa9995203de1dcd$exports(function() {
    var re = $5ee76d82519ecf67$var$$RegExp('.', 's');
    return !(re.dotAll && re.test('\n') && re.flags === 's');
});


var $c1a858f27af5c8fe$exports = {};
'use strict';


// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $c1a858f27af5c8fe$var$$RegExp = $37a62429f4992eb4$exports.RegExp;
$c1a858f27af5c8fe$exports = $1aa9995203de1dcd$exports(function() {
    var re = $c1a858f27af5c8fe$var$$RegExp('(?<a>b)', 'g');
    return re.exec('b').groups.a !== 'b' || 'b'.replace(re, '$<a>c') !== 'bc';
});


var $9f1c7421fb321906$var$nativeReplace = $3231f6153a88e373$exports('native-string-replace', String.prototype.replace);
var $9f1c7421fb321906$var$nativeExec = RegExp.prototype.exec;
var $9f1c7421fb321906$var$patchedExec = $9f1c7421fb321906$var$nativeExec;
var $9f1c7421fb321906$var$charAt = $3d3a3f96d04dfa01$exports(''.charAt);
var $9f1c7421fb321906$var$indexOf = $3d3a3f96d04dfa01$exports(''.indexOf);
var $9f1c7421fb321906$var$replace = $3d3a3f96d04dfa01$exports(''.replace);
var $9f1c7421fb321906$var$stringSlice = $3d3a3f96d04dfa01$exports(''.slice);
var $9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG = function() {
    var re1 = /a/;
    var re2 = /b*/g;
    $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeExec, re1, 'a');
    $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeExec, re2, 'a');
    return re1.lastIndex !== 0 || re2.lastIndex !== 0;
}();
var $9f1c7421fb321906$var$UNSUPPORTED_Y = $a314baf789497fdc$exports.BROKEN_CARET;
// nonparticipating capturing group, copied from es5-shim's String#split patch.
var $9f1c7421fb321906$var$NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
var $9f1c7421fb321906$var$PATCH = $9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG || $9f1c7421fb321906$var$NPCG_INCLUDED || $9f1c7421fb321906$var$UNSUPPORTED_Y || $5ee76d82519ecf67$exports || $c1a858f27af5c8fe$exports;
if ($9f1c7421fb321906$var$PATCH) $9f1c7421fb321906$var$patchedExec = function exec(string) {
    var re = this;
    var state = $9f1c7421fb321906$require$getInternalState(re);
    var str = $5f0738dcc48ec8db$exports(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;
    if (raw) {
        raw.lastIndex = re.lastIndex;
        result = $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$patchedExec, raw, str);
        re.lastIndex = raw.lastIndex;
        return result;
    }
    var groups = state.groups;
    var sticky = $9f1c7421fb321906$var$UNSUPPORTED_Y && re.sticky;
    var flags = $6e06bffcfb3013e2$exports($984691af733d2c6d$exports, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;
    if (sticky) {
        flags = $9f1c7421fb321906$var$replace(flags, 'y', '');
        if ($9f1c7421fb321906$var$indexOf(flags, 'g') === -1) flags += 'g';
        strCopy = $9f1c7421fb321906$var$stringSlice(str, re.lastIndex);
        // Support anchored sticky behavior.
        if (re.lastIndex > 0 && (!re.multiline || re.multiline && $9f1c7421fb321906$var$charAt(str, re.lastIndex - 1) !== '\n')) {
            source = '(?: ' + source + ')';
            strCopy = ' ' + strCopy;
            charsAdded++;
        }
        // ^(? + rx + ) is needed, in combination with some str slicing, to
        // simulate the 'y' flag.
        reCopy = new RegExp('^(?:' + source + ')', flags);
    }
    if ($9f1c7421fb321906$var$NPCG_INCLUDED) reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    if ($9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;
    match = $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeExec, sticky ? reCopy : re, strCopy);
    if (sticky) {
        if (match) {
            match.input = $9f1c7421fb321906$var$stringSlice(match.input, charsAdded);
            match[0] = $9f1c7421fb321906$var$stringSlice(match[0], charsAdded);
            match.index = re.lastIndex;
            re.lastIndex += match[0].length;
        } else re.lastIndex = 0;
    } else if ($9f1c7421fb321906$var$UPDATES_LAST_INDEX_WRONG && match) re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    if ($9f1c7421fb321906$var$NPCG_INCLUDED && match && match.length > 1) // Fix browsers whose `exec` methods don't consistently return `undefined`
    // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
    $6e06bffcfb3013e2$exports($9f1c7421fb321906$var$nativeReplace, match[0], reCopy, function() {
        for(i = 1; i < arguments.length - 2; i++)if (arguments[i] === undefined) match[i] = undefined;
    });
    if (match && groups) {
        match.groups = object = $f1a832a591ec8b6f$exports(null);
        for(i = 0; i < groups.length; i++){
            group = groups[i];
            object[group[0]] = match[group[1]];
        }
    }
    return match;
};
$9f1c7421fb321906$exports = $9f1c7421fb321906$var$patchedExec;


// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$9fd0241d8f6d7609$exports({
    target: 'RegExp',
    proto: true,
    forced: /./.exec !== $9f1c7421fb321906$exports
}, {
    exec: $9f1c7421fb321906$exports
});


'use strict';

var $c568811809202a18$exports = {};
'use strict';







var $c568811809202a18$var$SPECIES = $83f1bf79efdf35c6$exports('species');
var $c568811809202a18$var$RegExpPrototype = RegExp.prototype;
$c568811809202a18$exports = function(KEY, exec, FORCED, SHAM) {
    var SYMBOL = $83f1bf79efdf35c6$exports(KEY);
    var DELEGATES_TO_SYMBOL = !$1aa9995203de1dcd$exports(function() {
        // String methods call symbol-named RegExp methods
        var O = {};
        O[SYMBOL] = function() {
            return 7;
        };
        return ''[KEY](O) !== 7;
    });
    var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !$1aa9995203de1dcd$exports(function() {
        // Symbol-named RegExp methods call .exec
        var execCalled = false;
        var re = /a/;
        if (KEY === 'split') {
            // We can't use real regex here since it causes deoptimization
            // and serious performance degradation in V8
            // https://github.com/zloirock/core-js/issues/306
            re = {};
            // RegExp[@@split] doesn't call the regex's exec method, but first creates
            // a new one. We need to return the patched regex when creating the new one.
            re.constructor = {};
            re.constructor[$c568811809202a18$var$SPECIES] = function() {
                return re;
            };
            re.flags = '';
            re[SYMBOL] = /./[SYMBOL];
        }
        re.exec = function() {
            execCalled = true;
            return null;
        };
        re[SYMBOL]('');
        return !execCalled;
    });
    if (!DELEGATES_TO_SYMBOL || !DELEGATES_TO_EXEC || FORCED) {
        var nativeRegExpMethod = /./[SYMBOL];
        var methods = exec(SYMBOL, ''[KEY], function(nativeMethod, regexp, str, arg2, forceStringMethod) {
            var $exec = regexp.exec;
            if ($exec === $9f1c7421fb321906$exports || $exec === $c568811809202a18$var$RegExpPrototype.exec) {
                if (DELEGATES_TO_SYMBOL && !forceStringMethod) // The native String method already delegates to @@method (this
                // polyfilled function), leasing to infinite recursion.
                // We avoid it by directly calling the native @@method method.
                return {
                    done: true,
                    value: $6e06bffcfb3013e2$exports(nativeRegExpMethod, regexp, str, arg2)
                };
                return {
                    done: true,
                    value: $6e06bffcfb3013e2$exports(nativeMethod, str, regexp, arg2)
                };
            }
            return {
                done: false
            };
        });
        $1f4601f39377b637$exports(String.prototype, KEY, methods[0]);
        $1f4601f39377b637$exports($c568811809202a18$var$RegExpPrototype, SYMBOL, methods[1]);
    }
    if (SHAM) $d13e1e0ab68f4bd6$exports($c568811809202a18$var$RegExpPrototype[SYMBOL], 'sham', true);
};








var $892bb45f63d4bd1d$exports = {};
'use strict';

var $892bb45f63d4bd1d$require$charAt = $a971a7ca4b136214$exports.charAt;
// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
$892bb45f63d4bd1d$exports = function(S, index, unicode) {
    return index + (unicode ? $892bb45f63d4bd1d$require$charAt(S, index).length : 1);
};


var $5d44a8180af9165c$exports = {};
'use strict';





var $5d44a8180af9165c$var$$TypeError = TypeError;
// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
$5d44a8180af9165c$exports = function(R, S) {
    var exec = R.exec;
    if ($e8bca5b64a857b1a$exports(exec)) {
        var result = $6e06bffcfb3013e2$exports(exec, R, S);
        if (result !== null) $2d94e296a4d81142$exports(result);
        return result;
    }
    if ($3a0f0fc82e93bd49$exports(R) === 'RegExp') return $6e06bffcfb3013e2$exports($9f1c7421fb321906$exports, R, S);
    throw new $5d44a8180af9165c$var$$TypeError('RegExp#exec called on incompatible receiver');
};


// @@match logic
$c568811809202a18$exports('match', function(MATCH, nativeMatch, maybeCallNative) {
    return [
        // `String.prototype.match` method
        // https://tc39.es/ecma262/#sec-string.prototype.match
        function match(regexp) {
            var O = $938881b1bb81812d$exports(this);
            var matcher = $d1de49472bdc582c$exports(regexp) ? $af183ff3a7a0320f$exports(regexp, MATCH) : undefined;
            return matcher ? $6e06bffcfb3013e2$exports(matcher, regexp, O) : new RegExp(regexp)[MATCH]($5f0738dcc48ec8db$exports(O));
        },
        // `RegExp.prototype[@@match]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
        function(string) {
            var rx = $2d94e296a4d81142$exports(this);
            var S = $5f0738dcc48ec8db$exports(string);
            var res = maybeCallNative(nativeMatch, rx, S);
            if (res.done) return res.value;
            if (!rx.global) return $5d44a8180af9165c$exports(rx, S);
            var fullUnicode = rx.unicode;
            rx.lastIndex = 0;
            var A = [];
            var n = 0;
            var result;
            while((result = $5d44a8180af9165c$exports(rx, S)) !== null){
                var matchStr = $5f0738dcc48ec8db$exports(result[0]);
                A[n] = matchStr;
                if (matchStr === '') rx.lastIndex = $892bb45f63d4bd1d$exports(S, $eecf4269159770dc$exports(rx.lastIndex), fullUnicode);
                n++;
            }
            return n === 0 ? null : A;
        }
    ];
});


'use strict';


var $5fade71c8f1274e5$require$FUNCTION_NAME_EXISTS = $775efe7ab5de3db4$exports.EXISTS;

var $23151cf1a26a9a7c$exports = {};
'use strict';


$23151cf1a26a9a7c$exports = function(target, name, descriptor) {
    if (descriptor.get) $d745cb9bd2dfb659$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $d745cb9bd2dfb659$exports(descriptor.set, name, {
        setter: true
    });
    return $ec8f33e5c924d97f$export$2d1720544b23b823(target, name, descriptor);
};


var $5fade71c8f1274e5$var$FunctionPrototype = Function.prototype;
var $5fade71c8f1274e5$var$functionToString = $3d3a3f96d04dfa01$exports($5fade71c8f1274e5$var$FunctionPrototype.toString);
var $5fade71c8f1274e5$var$nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var $5fade71c8f1274e5$var$regExpExec = $3d3a3f96d04dfa01$exports($5fade71c8f1274e5$var$nameRE.exec);
var $5fade71c8f1274e5$var$NAME = 'name';
// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if ($cea8a7c76ccddf5d$exports && !$5fade71c8f1274e5$require$FUNCTION_NAME_EXISTS) $23151cf1a26a9a7c$exports($5fade71c8f1274e5$var$FunctionPrototype, $5fade71c8f1274e5$var$NAME, {
    configurable: true,
    get: function() {
        try {
            return $5fade71c8f1274e5$var$regExpExec($5fade71c8f1274e5$var$nameRE, $5fade71c8f1274e5$var$functionToString(this))[1];
        } catch (error) {
            return '';
        }
    }
});


'use strict';
var $38596fc07635f05a$exports = {};
'use strict';

var $38596fc07635f05a$var$FunctionPrototype = Function.prototype;
var $38596fc07635f05a$var$apply = $38596fc07635f05a$var$FunctionPrototype.apply;
var $38596fc07635f05a$var$call = $38596fc07635f05a$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
$38596fc07635f05a$exports = typeof Reflect == 'object' && Reflect.apply || ($e337c262a4702797$exports ? $38596fc07635f05a$var$call.bind($38596fc07635f05a$var$apply) : function() {
    return $38596fc07635f05a$var$call.apply($38596fc07635f05a$var$apply, arguments);
});















var $f07126f89ea86001$exports = {};
'use strict';


var $f07126f89ea86001$var$floor = Math.floor;
var $f07126f89ea86001$var$charAt = $3d3a3f96d04dfa01$exports(''.charAt);
var $f07126f89ea86001$var$replace = $3d3a3f96d04dfa01$exports(''.replace);
var $f07126f89ea86001$var$stringSlice = $3d3a3f96d04dfa01$exports(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;
// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
$f07126f89ea86001$exports = function(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
        namedCaptures = $476d2ef928fdaf21$exports(namedCaptures);
        symbols = $f07126f89ea86001$var$SUBSTITUTION_SYMBOLS;
    }
    return $f07126f89ea86001$var$replace(replacement, symbols, function(match, ch) {
        var capture;
        switch($f07126f89ea86001$var$charAt(ch, 0)){
            case '$':
                return '$';
            case '&':
                return matched;
            case '`':
                return $f07126f89ea86001$var$stringSlice(str, 0, position);
            case "'":
                return $f07126f89ea86001$var$stringSlice(str, tailPos);
            case '<':
                capture = namedCaptures[$f07126f89ea86001$var$stringSlice(ch, 1, -1)];
                break;
            default:
                var n = +ch;
                if (n === 0) return match;
                if (n > m) {
                    var f = $f07126f89ea86001$var$floor(n / 10);
                    if (f === 0) return match;
                    if (f <= m) return captures[f - 1] === undefined ? $f07126f89ea86001$var$charAt(ch, 1) : captures[f - 1] + $f07126f89ea86001$var$charAt(ch, 1);
                    return match;
                }
                capture = captures[n - 1];
        }
        return capture === undefined ? '' : capture;
    });
};




var $eb0d28d08e5ca469$var$REPLACE = $83f1bf79efdf35c6$exports('replace');
var $eb0d28d08e5ca469$var$max = Math.max;
var $eb0d28d08e5ca469$var$min = Math.min;
var $eb0d28d08e5ca469$var$concat = $3d3a3f96d04dfa01$exports([].concat);
var $eb0d28d08e5ca469$var$push = $3d3a3f96d04dfa01$exports([].push);
var $eb0d28d08e5ca469$var$stringIndexOf = $3d3a3f96d04dfa01$exports(''.indexOf);
var $eb0d28d08e5ca469$var$stringSlice = $3d3a3f96d04dfa01$exports(''.slice);
var $eb0d28d08e5ca469$var$maybeToString = function(it) {
    return it === undefined ? it : String(it);
};
// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var $eb0d28d08e5ca469$var$REPLACE_KEEPS_$0 = function() {
    // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
    return 'a'.replace(/./, '$0') === '$0';
}();
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var $eb0d28d08e5ca469$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = function() {
    if (/./[$eb0d28d08e5ca469$var$REPLACE]) return /./[$eb0d28d08e5ca469$var$REPLACE]('a', '$0') === '';
    return false;
}();
var $eb0d28d08e5ca469$var$REPLACE_SUPPORTS_NAMED_GROUPS = !$1aa9995203de1dcd$exports(function() {
    var re = /./;
    re.exec = function() {
        var result = [];
        result.groups = {
            a: '7'
        };
        return result;
    };
    // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
    return ''.replace(re, '$<a>') !== '7';
});
// @@replace logic
$c568811809202a18$exports('replace', function(_, nativeReplace, maybeCallNative) {
    var UNSAFE_SUBSTITUTE = $eb0d28d08e5ca469$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';
    return [
        // `String.prototype.replace` method
        // https://tc39.es/ecma262/#sec-string.prototype.replace
        function replace(searchValue, replaceValue) {
            var O = $938881b1bb81812d$exports(this);
            var replacer = $d1de49472bdc582c$exports(searchValue) ? $af183ff3a7a0320f$exports(searchValue, $eb0d28d08e5ca469$var$REPLACE) : undefined;
            return replacer ? $6e06bffcfb3013e2$exports(replacer, searchValue, O, replaceValue) : $6e06bffcfb3013e2$exports(nativeReplace, $5f0738dcc48ec8db$exports(O), searchValue, replaceValue);
        },
        // `RegExp.prototype[@@replace]` method
        // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
        function(string, replaceValue) {
            var rx = $2d94e296a4d81142$exports(this);
            var S = $5f0738dcc48ec8db$exports(string);
            if (typeof replaceValue == 'string' && $eb0d28d08e5ca469$var$stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 && $eb0d28d08e5ca469$var$stringIndexOf(replaceValue, '$<') === -1) {
                var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
                if (res.done) return res.value;
            }
            var functionalReplace = $e8bca5b64a857b1a$exports(replaceValue);
            if (!functionalReplace) replaceValue = $5f0738dcc48ec8db$exports(replaceValue);
            var global = rx.global;
            var fullUnicode;
            if (global) {
                fullUnicode = rx.unicode;
                rx.lastIndex = 0;
            }
            var results = [];
            var result;
            while(true){
                result = $5d44a8180af9165c$exports(rx, S);
                if (result === null) break;
                $eb0d28d08e5ca469$var$push(results, result);
                if (!global) break;
                var matchStr = $5f0738dcc48ec8db$exports(result[0]);
                if (matchStr === '') rx.lastIndex = $892bb45f63d4bd1d$exports(S, $eecf4269159770dc$exports(rx.lastIndex), fullUnicode);
            }
            var accumulatedResult = '';
            var nextSourcePosition = 0;
            for(var i = 0; i < results.length; i++){
                result = results[i];
                var matched = $5f0738dcc48ec8db$exports(result[0]);
                var position = $eb0d28d08e5ca469$var$max($eb0d28d08e5ca469$var$min($38b1b404f6b944d2$exports(result.index), S.length), 0);
                var captures = [];
                var replacement;
                // NOTE: This is equivalent to
                //   captures = result.slice(1).map(maybeToString)
                // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                for(var j = 1; j < result.length; j++)$eb0d28d08e5ca469$var$push(captures, $eb0d28d08e5ca469$var$maybeToString(result[j]));
                var namedCaptures = result.groups;
                if (functionalReplace) {
                    var replacerArgs = $eb0d28d08e5ca469$var$concat([
                        matched
                    ], captures, position, S);
                    if (namedCaptures !== undefined) $eb0d28d08e5ca469$var$push(replacerArgs, namedCaptures);
                    replacement = $5f0738dcc48ec8db$exports($38596fc07635f05a$exports(replaceValue, undefined, replacerArgs));
                } else replacement = $f07126f89ea86001$exports(matched, S, position, captures, namedCaptures, replaceValue);
                if (position >= nextSourcePosition) {
                    accumulatedResult += $eb0d28d08e5ca469$var$stringSlice(S, nextSourcePosition, position) + replacement;
                    nextSourcePosition = position + matched.length;
                }
            }
            return accumulatedResult + $eb0d28d08e5ca469$var$stringSlice(S, nextSourcePosition);
        }
    ];
}, !$eb0d28d08e5ca469$var$REPLACE_SUPPORTS_NAMED_GROUPS || !$eb0d28d08e5ca469$var$REPLACE_KEEPS_$0 || $eb0d28d08e5ca469$var$REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


function $97c917368b9e49ce$var$getElementWindow(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $97c917368b9e49ce$var$getElementDocument(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
var $97c917368b9e49ce$var$cachedScrollbarWidth = null;
var $97c917368b9e49ce$var$cachedDevicePixelRatio = null;
if (0, (/*@__PURE__*/$parcel$interopDefault($baf1d31a374e6aa9$exports))) window.addEventListener('resize', function() {
    if ($97c917368b9e49ce$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $97c917368b9e49ce$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $97c917368b9e49ce$var$cachedScrollbarWidth = null;
    }
});
function $97c917368b9e49ce$var$scrollbarWidth(el) {
    if ($97c917368b9e49ce$var$cachedScrollbarWidth === null) {
        var document1 = $97c917368b9e49ce$var$getElementDocument(el);
        if (typeof document1 === 'undefined') {
            $97c917368b9e49ce$var$cachedScrollbarWidth = 0;
            return $97c917368b9e49ce$var$cachedScrollbarWidth;
        }
        var body = document1.body;
        var box = document1.createElement('div');
        box.classList.add('simplebar-hide-scrollbar');
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $97c917368b9e49ce$var$cachedScrollbarWidth = width;
    }
    return $97c917368b9e49ce$var$cachedScrollbarWidth;
}
var $97c917368b9e49ce$var$SimpleBar = /*#__PURE__*/ function() {
    function SimpleBar(element, options) {
        var _this = this;
        this.onScroll = function() {
            var elWindow = $97c917368b9e49ce$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) {
                _this.showScrollbar('x');
                _this.positionScrollbar('x');
            }
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) {
                _this.showScrollbar('y');
                _this.positionScrollbar('y');
            }
            _this.scrollYTicking = false;
        };
        this.onMouseEnter = function() {
            _this.showScrollbar('x');
            _this.showScrollbar('y');
        };
        this.onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis('y');
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis('y');
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this.onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.hideScrollbars = function() {
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (!_this.isWithinBounds(_this.axis.y.track.rect)) {
                _this.axis.y.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.y.isVisible = false;
            }
            if (!_this.isWithinBounds(_this.axis.x.track.rect)) {
                _this.axis.x.scrollbar.el.classList.remove(_this.classNames.visible);
                _this.axis.x.isVisible = false;
            }
        };
        this.onPointerEvent = function(e) {
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
             // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Preventing the event's default action stops text being
                // selectable during the drag.
                e.preventDefault(); // Prevent event leaking
                e.stopPropagation();
                if (e.type === 'mousedown') {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, 'x');
                        else _this.onTrackClick(e, 'x');
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, 'y');
                        else _this.onTrackClick(e, 'y');
                    }
                }
            }
        };
        this.drag = function(e) {
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = track.rect[_this.axis[_this.draggedAxis].sizeAttr];
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollSizeAttr];
            var hostSize = parseInt(_this.elStyles[_this.axis[_this.draggedAxis].sizeAttr], 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === 'y') eventOffset = e.pageY;
            else eventOffset = e.pageX;
             // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - track.rect[_this.axis[_this.draggedAxis].offsetAttr] - _this.axis[_this.draggedAxis].dragOffset; // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size); // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize); // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === 'x') {
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? scrollPos - (trackSize + scrollbar.size) : scrollPos;
                scrollPos = _this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollPos : scrollPos;
            }
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        this.onEndDrag = function(e) {
            var elDocument = $97c917368b9e49ce$var$getElementDocument(_this.el);
            var elWindow = $97c917368b9e49ce$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            _this.el.classList.remove(_this.classNames.dragging);
            elDocument.removeEventListener('mousemove', _this.drag, true);
            elDocument.removeEventListener('mouseup', _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener('click', _this.preventClick, true);
                elDocument.removeEventListener('dblclick', _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.minScrollbarWidth = 20;
        this.options = Object.assign({}, SimpleBar.defaultOptions, options);
        this.classNames = Object.assign({}, SimpleBar.defaultOptions.classNames, this.options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: 'scrollLeft',
                sizeAttr: 'width',
                scrollSizeAttr: 'scrollWidth',
                offsetSizeAttr: 'offsetWidth',
                offsetAttr: 'left',
                overflowAttr: 'overflowX',
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            },
            y: {
                scrollOffsetAttr: 'scrollTop',
                sizeAttr: 'height',
                scrollSizeAttr: 'scrollHeight',
                offsetSizeAttr: 'offsetHeight',
                offsetAttr: 'top',
                overflowAttr: 'overflowY',
                dragOffset: 0,
                isOverflowing: true,
                isVisible: false,
                forceVisible: false,
                track: {},
                scrollbar: {}
            }
        };
        this.removePreventClickId = null; // Don't re-instantiate over an existing one
        if (SimpleBar.instances.has(this.el)) return;
        this.recalculate = (0, (/*@__PURE__*/$parcel$interopDefault($0d7dfa4a4a0f0c8c$exports)))(this.recalculate.bind(this), 64);
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($0d7dfa4a4a0f0c8c$exports)))(this.onMouseMove.bind(this), 64);
        this.hideScrollbars = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(this.hideScrollbars.bind(this), this.options.timeout);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($b550f30cec538bc8$exports)))(this.onWindowResize.bind(this), 64, {
            leading: true
        });
        SimpleBar.getRtlHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($cab391c968b6f1b1$exports)))(SimpleBar.getRtlHelpers);
        this.init();
    }
    /**
   * Static properties
   */ /**
   * Helper to fix browsers inconsistency on RTL:
   *  - Firefox inverts the scrollbar initial position
   *  - IE11 inverts both scrollbar position and scrolling offset
   * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
   */ SimpleBar.getRtlHelpers = function getRtlHelpers() {
        var dummyDiv = document.createElement('div');
        dummyDiv.innerHTML = '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        document.body.appendChild(scrollbarDummyEl);
        var dummyContainerChild = scrollbarDummyEl.firstElementChild;
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBar.getOffset(scrollbarDummyEl);
        var dummyContainerChildOffset = SimpleBar.getOffset(dummyContainerChild);
        scrollbarDummyEl.scrollLeft = 999;
        var dummyContainerScrollOffsetAfterScroll = SimpleBar.getOffset(dummyContainerChild);
        return {
            // determines if the scrolling is responding with negative values
            isRtlScrollingInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left && dummyContainerChildOffset.left - dummyContainerScrollOffsetAfterScroll.left !== 0,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isRtlScrollbarInverted: dummyContainerOffset.left !== dummyContainerChildOffset.left
        };
    };
    SimpleBar.getOffset = function getOffset(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $97c917368b9e49ce$var$getElementDocument(el);
        var elWindow = $97c917368b9e49ce$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    var _proto = SimpleBar.prototype;
    _proto.init = function init() {
        // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(this.el, this); // We stop here on server-side
        if (0, (/*@__PURE__*/$parcel$interopDefault($baf1d31a374e6aa9$exports))) {
            this.initDOM();
            this.setAccessibilityAttributes();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    _proto.initDOM = function initDOM() {
        var _this2 = this;
        // make sure this element doesn't have the elements yet
        if (Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this2.classNames.wrapper);
        }).length) {
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector("." + this.classNames.wrapper);
            this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector("." + this.classNames.contentWrapper);
            this.contentEl = this.options.contentNode || this.el.querySelector("." + this.classNames.contentEl);
            this.offsetEl = this.el.querySelector("." + this.classNames.offset);
            this.maskEl = this.el.querySelector("." + this.classNames.mask);
            this.placeholderEl = this.findChild(this.wrapperEl, "." + this.classNames.placeholder);
            this.heightAutoObserverWrapperEl = this.el.querySelector("." + this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl = this.el.querySelector("." + this.classNames.heightAutoObserverEl);
            this.axis.x.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.horizontal);
            this.axis.y.track.el = this.findChild(this.el, "." + this.classNames.track + "." + this.classNames.vertical);
        } else {
            // Prepare DOM
            this.wrapperEl = document.createElement('div');
            this.contentWrapperEl = document.createElement('div');
            this.offsetEl = document.createElement('div');
            this.maskEl = document.createElement('div');
            this.contentEl = document.createElement('div');
            this.placeholderEl = document.createElement('div');
            this.heightAutoObserverWrapperEl = document.createElement('div');
            this.heightAutoObserverEl = document.createElement('div');
            this.wrapperEl.classList.add(this.classNames.wrapper);
            this.contentWrapperEl.classList.add(this.classNames.contentWrapper);
            this.offsetEl.classList.add(this.classNames.offset);
            this.maskEl.classList.add(this.classNames.mask);
            this.contentEl.classList.add(this.classNames.contentEl);
            this.placeholderEl.classList.add(this.classNames.placeholder);
            this.heightAutoObserverWrapperEl.classList.add(this.classNames.heightAutoObserverWrapperEl);
            this.heightAutoObserverEl.classList.add(this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement('div');
            var scrollbar = document.createElement('div');
            track.classList.add(this.classNames.track);
            scrollbar.classList.add(this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            this.axis.x.track.el.classList.add(this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            this.axis.y.track.el.classList.add(this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector("." + this.classNames.scrollbar);
        this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector("." + this.classNames.scrollbar);
        if (!this.options.autoHide) {
            this.axis.x.scrollbar.el.classList.add(this.classNames.visible);
            this.axis.y.scrollbar.el.classList.add(this.classNames.visible);
        }
        this.el.setAttribute('data-simplebar', 'init');
    };
    _proto.setAccessibilityAttributes = function setAccessibilityAttributes() {
        var ariaLabel = this.options.ariaLabel || 'scrollable content';
        this.contentWrapperEl.setAttribute('tabindex', '0');
        this.contentWrapperEl.setAttribute('role', 'region');
        this.contentWrapperEl.setAttribute('aria-label', ariaLabel);
    };
    _proto.initListeners = function initListeners() {
        var _this3 = this;
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.addEventListener('mouseenter', this.onMouseEnter);
        [
            'mousedown',
            'click',
            'dblclick'
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, true);
        });
        [
            'touchstart',
            'touchend',
            'touchmove'
        ].forEach(function(e) {
            _this3.el.addEventListener(e, _this3.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.addEventListener('mousemove', this.onMouseMove);
        this.el.addEventListener('mouseleave', this.onMouseLeave);
        this.contentWrapperEl.addEventListener('scroll', this.onScroll); // Browser zoom triggers a window resize
        elWindow.addEventListener('resize', this.onWindowResize); // Hack for https://github.com/WICG/ResizeObserver/issues/38
        var resizeObserverStarted = false;
        var resizeAnimationFrameId = null;
        var resizeObserver = elWindow.ResizeObserver || (0, $16f0ad567ed11238$export$9caf76241ca21a11);
        this.resizeObserver = new resizeObserver(function() {
            if (!resizeObserverStarted || resizeAnimationFrameId !== null) return;
            resizeAnimationFrameId = elWindow.requestAnimationFrame(function() {
                _this3.recalculate();
                resizeAnimationFrameId = null;
            });
        });
        this.resizeObserver.observe(this.el);
        this.resizeObserver.observe(this.contentEl);
        elWindow.requestAnimationFrame(function() {
            resizeObserverStarted = true;
        }); // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(this.recalculate);
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    _proto.recalculate = function recalculate() {
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === 'rtl';
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1;
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = this.elStyles.paddingTop + " " + this.elStyles.paddingRight + " " + this.elStyles.paddingBottom + " " + this.elStyles.paddingLeft;
        this.wrapperEl.style.margin = "-" + this.elStyles.paddingTop + " -" + this.elStyles.paddingRight + " -" + this.elStyles.paddingBottom + " -" + this.elStyles.paddingLeft;
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? 'auto' : '100%'; // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? contentElOffsetWidth + "px" : 'auto';
        this.placeholderEl.style.height = contentElScrollHeight + "px";
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight; // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === 'hidden' ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === 'hidden' ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === 'x' || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === 'y' || this.options.forceVisible === true;
        this.hideNativeScrollbar(); // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize('x');
        this.axis.y.scrollbar.size = this.getScrollbarSize('y');
        this.axis.x.scrollbar.el.style.width = this.axis.x.scrollbar.size + "px";
        this.axis.y.scrollbar.el.style.height = this.axis.y.scrollbar.size + "px";
        this.positionScrollbar('x');
        this.positionScrollbar('y');
        this.toggleTrackVisibility('x');
        this.toggleTrackVisibility('y');
    };
    _proto.getScrollbarSize = function getScrollbarSize(axis) {
        if (axis === void 0) axis = 'y';
        if (!this.axis[axis].isOverflowing) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var scrollbarSize;
        var scrollbarRatio = trackSize / contentSize; // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    _proto.positionScrollbar = function positionScrollbar(axis) {
        if (axis === void 0) axis = 'y';
        if (!this.axis[axis].isOverflowing) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = this.axis[axis].track.el[this.axis[axis].offsetSizeAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollbar = this.axis[axis].scrollbar;
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollingInverted ? -scrollOffset : scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === 'x' && this.isRtl && SimpleBar.getRtlHelpers().isRtlScrollbarInverted ? handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === 'x' ? "translate3d(" + handleOffset + "px, 0, 0)" : "translate3d(0, " + handleOffset + "px, 0)";
    };
    _proto.toggleTrackVisibility = function toggleTrackVisibility(axis) {
        if (axis === void 0) axis = 'y';
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = 'visible';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'scroll';
        } else {
            track.style.visibility = 'hidden';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'hidden';
        } // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = 'block';
        else scrollbar.style.display = 'none';
    };
    _proto.hideNativeScrollbar = function hideNativeScrollbar() {
        this.offsetEl.style[this.isRtl ? 'left' : 'right'] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-" + this.scrollbarWidth + "px" : 0;
    };
    _proto.onMouseMoveForAxis = function onMouseMoveForAxis(axis) {
        if (axis === void 0) axis = 'y';
        this.axis[axis].track.rect = this.axis[axis].track.el.getBoundingClientRect();
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var isWithinScrollbarBoundsX = this.isWithinBounds(this.axis[axis].scrollbar.rect);
        if (isWithinScrollbarBoundsX) this.axis[axis].scrollbar.el.classList.add(this.classNames.hover);
        else this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
        if (this.isWithinBounds(this.axis[axis].track.rect)) {
            this.showScrollbar(axis);
            this.axis[axis].track.el.classList.add(this.classNames.hover);
        } else this.axis[axis].track.el.classList.remove(this.classNames.hover);
    };
    _proto.onMouseLeaveForAxis = function onMouseLeaveForAxis(axis) {
        if (axis === void 0) axis = 'y';
        this.axis[axis].track.el.classList.remove(this.classNames.hover);
        this.axis[axis].scrollbar.el.classList.remove(this.classNames.hover);
    };
    /**
   * Show scrollbar
   */ _proto.showScrollbar = function showScrollbar(axis) {
        if (axis === void 0) axis = 'y';
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!this.axis[axis].isVisible) {
            scrollbar.classList.add(this.classNames.visible);
            this.axis[axis].isVisible = true;
        }
        if (this.options.autoHide) this.hideScrollbars();
    };
    /**
   * on scrollbar handle drag movement starts
   */ _proto.onDragStart = function onDragStart(e, axis) {
        if (axis === void 0) axis = 'y';
        var elDocument = $97c917368b9e49ce$var$getElementDocument(this.el);
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar; // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === 'y' ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - scrollbar.rect[this.axis[axis].offsetAttr];
        this.draggedAxis = axis;
        this.el.classList.add(this.classNames.dragging);
        elDocument.addEventListener('mousemove', this.drag, true);
        elDocument.addEventListener('mouseup', this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener('click', this.preventClick, true);
            elDocument.addEventListener('dblclick', this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    };
    _proto.onTrackClick = function onTrackClick(e, axis) {
        var _this4 = this;
        if (axis === void 0) axis = 'y';
        if (!this.options.clickOnTrack) return;
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = this.axis[axis].scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = scrollbar.rect[this.axis[axis].offsetAttr];
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === 'y' ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var scrollTo = function scrollTo() {
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    var _this4$contentWrapper;
                    scrolled -= _this4.options.clickOnTrackSpeed;
                    _this4.contentWrapperEl.scrollTo((_this4$contentWrapper = {}, _this4$contentWrapper[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper));
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                var _this4$contentWrapper2;
                scrolled += _this4.options.clickOnTrackSpeed;
                _this4.contentWrapperEl.scrollTo((_this4$contentWrapper2 = {}, _this4$contentWrapper2[_this4.axis[axis].offsetAttr] = scrolled, _this4$contentWrapper2));
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    };
    _proto.getContentElement = function getContentElement() {
        return this.contentEl;
    };
    _proto.getScrollElement = function getScrollElement() {
        return this.contentWrapperEl;
    };
    _proto.getScrollbarWidth = function getScrollbarWidth() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (getComputedStyle(this.contentWrapperEl, '::-webkit-scrollbar').display === 'none' || 'scrollbarWidth' in document.documentElement.style || '-ms-overflow-style' in document.documentElement.style) return 0;
            else return $97c917368b9e49ce$var$scrollbarWidth(this.el);
        } catch (e) {
            return $97c917368b9e49ce$var$scrollbarWidth(this.el);
        }
    };
    _proto.removeListeners = function removeListeners() {
        var _this5 = this;
        var elWindow = $97c917368b9e49ce$var$getElementWindow(this.el); // Event listeners
        if (this.options.autoHide) this.el.removeEventListener('mouseenter', this.onMouseEnter);
        [
            'mousedown',
            'click',
            'dblclick'
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, true);
        });
        [
            'touchstart',
            'touchend',
            'touchmove'
        ].forEach(function(e) {
            _this5.el.removeEventListener(e, _this5.onPointerEvent, {
                capture: true,
                passive: true
            });
        });
        this.el.removeEventListener('mousemove', this.onMouseMove);
        this.el.removeEventListener('mouseleave', this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener('scroll', this.onScroll);
        elWindow.removeEventListener('resize', this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
         // Cancel all debounced functions
        this.recalculate.cancel();
        this.onMouseMove.cancel();
        this.hideScrollbars.cancel();
        this.onWindowResize.cancel();
    };
    _proto.unMount = function unMount() {
        this.removeListeners();
        SimpleBar.instances.delete(this.el);
    };
    _proto.isWithinBounds = function isWithinBounds(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    };
    _proto.findChild = function findChild(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    return SimpleBar;
}();
$97c917368b9e49ce$var$SimpleBar.defaultOptions = {
    autoHide: true,
    forceVisible: false,
    clickOnTrack: true,
    clickOnTrackSpeed: 40,
    classNames: {
        contentEl: 'simplebar-content',
        contentWrapper: 'simplebar-content-wrapper',
        offset: 'simplebar-offset',
        mask: 'simplebar-mask',
        wrapper: 'simplebar-wrapper',
        placeholder: 'simplebar-placeholder',
        scrollbar: 'simplebar-scrollbar',
        track: 'simplebar-track',
        heightAutoObserverWrapperEl: 'simplebar-height-auto-observer-wrapper',
        heightAutoObserverEl: 'simplebar-height-auto-observer',
        visible: 'simplebar-visible',
        horizontal: 'simplebar-horizontal',
        vertical: 'simplebar-vertical',
        hover: 'simplebar-hover',
        dragging: 'simplebar-dragging'
    },
    scrollbarMinSize: 25,
    scrollbarMaxSize: 0,
    timeout: 1000
};
$97c917368b9e49ce$var$SimpleBar.instances = new WeakMap();
var $97c917368b9e49ce$export$2e2bcd8739ae039 = $97c917368b9e49ce$var$SimpleBar;


function $bbbd8fadaf5f7664$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bbbd8fadaf5f7664$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bbbd8fadaf5f7664$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bbbd8fadaf5f7664$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bbbd8fadaf5f7664$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bbbd8fadaf5f7664$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bbbd8fadaf5f7664$var$_extends() {
    $bbbd8fadaf5f7664$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bbbd8fadaf5f7664$var$_extends.apply(this, arguments);
}
function $bbbd8fadaf5f7664$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bbbd8fadaf5f7664$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bbbd8fadaf5f7664$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $bbbd8fadaf5f7664$var$_excluded = [
    "children",
    "scrollableNodeProps",
    "tag"
];
/* Deprecated
 * Hardcore this here until we can safely deprecated it.
 * Helper function to retrieve options from element attributes
 */ var $bbbd8fadaf5f7664$var$getOptions = function getOptions(obj) {
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(x, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case 'true':
                    acc[key] = true;
                    break;
                case 'false':
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, {});
    return options;
};
var $bbbd8fadaf5f7664$var$SimpleBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef(function(_ref, ref) {
    var children = _ref.children, _ref$scrollableNodePr = _ref.scrollableNodeProps, scrollableNodeProps = _ref$scrollableNodePr === void 0 ? {} : _ref$scrollableNodePr, _ref$tag = _ref.tag, tag = _ref$tag === void 0 ? 'div' : _ref$tag, otherProps = $bbbd8fadaf5f7664$var$_objectWithoutProperties(_ref, $bbbd8fadaf5f7664$var$_excluded);
    var RootTag = tag;
    var instance;
    var scrollableNodeRef = (0, $dup7A.useRef)();
    var elRef = (0, $dup7A.useRef)();
    var contentNodeRef = (0, $dup7A.useRef)();
    var options = {};
    var rest = {};
    var deprecatedOptions = [];
    Object.keys(otherProps).forEach(function(key) {
        if (Object.prototype.hasOwnProperty.call((0, $97c917368b9e49ce$export$2e2bcd8739ae039).defaultOptions, key)) options[key] = otherProps[key];
        else if (key.match(/data-simplebar-(.+)/) && key !== 'data-simplebar-direction') deprecatedOptions.push({
            name: key,
            value: otherProps[key]
        });
        else rest[key] = otherProps[key];
    });
    if (deprecatedOptions.length) console.warn("simplebar-react: this way of passing options is deprecated. Pass it like normal props instead:\n        'data-simplebar-auto-hide=\"false\"' \u2014> 'autoHide=\"false\"'\n      ");
    (0, $dup7A.useEffect)(function() {
        scrollableNodeRef = scrollableNodeProps.ref || scrollableNodeRef;
        if (elRef.current) {
            instance = new (0, $97c917368b9e49ce$export$2e2bcd8739ae039)(elRef.current, $bbbd8fadaf5f7664$var$_objectSpread2($bbbd8fadaf5f7664$var$_objectSpread2($bbbd8fadaf5f7664$var$_objectSpread2($bbbd8fadaf5f7664$var$_objectSpread2({}, $bbbd8fadaf5f7664$var$getOptions(deprecatedOptions)), options), scrollableNodeRef && {
                scrollableNode: scrollableNodeRef.current
            }), contentNodeRef.current && {
                contentNode: contentNodeRef.current
            }));
            if (typeof ref === 'function') ref(instance);
            else if (ref) ref.current = instance;
        }
        return function() {
            instance.unMount();
            instance = null;
            if (typeof ref === 'function') ref(null);
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(RootTag, $bbbd8fadaf5f7664$var$_extends({
        ref: elRef,
        "data-simplebar": true
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-height-auto-observer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-height-auto-observer"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-mask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-offset"
    }, typeof children === 'function' ? children({
        scrollableNodeRef: scrollableNodeRef,
        contentNodeRef: contentNodeRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", $bbbd8fadaf5f7664$var$_extends({}, scrollableNodeProps, {
        className: "simplebar-content-wrapper".concat(scrollableNodeProps.className ? " ".concat(scrollableNodeProps.className) : '')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-content"
    }, children)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-placeholder"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-track simplebar-horizontal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-scrollbar"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-track simplebar-vertical"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "simplebar-scrollbar"
    })));
});
$bbbd8fadaf5f7664$var$SimpleBar.displayName = 'SimpleBar';
$bbbd8fadaf5f7664$var$SimpleBar.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4cb0dfe46d0c49b6$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($4cb0dfe46d0c49b6$exports))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($4cb0dfe46d0c49b6$exports))).func
    ]),
    scrollableNodeProps: (0, (/*@__PURE__*/$parcel$interopDefault($4cb0dfe46d0c49b6$exports))).object,
    tag: (0, (/*@__PURE__*/$parcel$interopDefault($4cb0dfe46d0c49b6$exports))).string
};
var $bbbd8fadaf5f7664$export$2e2bcd8739ae039 = $bbbd8fadaf5f7664$var$SimpleBar;



var $0535cdc15230b38d$exports = {};

$parcel$defineInteropFlag($0535cdc15230b38d$exports);

$parcel$export($0535cdc15230b38d$exports, "default", () => $0535cdc15230b38d$export$2e2bcd8739ae039);
function $c2186ff521b340c0$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $c2186ff521b340c0$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $c2186ff521b340c0$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $c2186ff521b340c0$var$e(r.overflowY, n) || $c2186ff521b340c0$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $c2186ff521b340c0$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $c2186ff521b340c0$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$c2186ff521b340c0$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $c2186ff521b340c0$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $c2186ff521b340c0$var$n(m) && !$c2186ff521b340c0$var$n(document.documentElement) || null != m && $c2186ff521b340c0$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $c2186ff521b340c0$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $c2186ff521b340c0$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $c2186ff521b340c0$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $c2186ff521b340c0$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


function $ec6949d09184329a$var$isOptionsObject(options) {
    return options === Object(options) && Object.keys(options).length !== 0;
}
function $ec6949d09184329a$var$defaultBehavior(actions, behavior) {
    if (behavior === void 0) behavior = 'auto';
    var canSmoothScroll = 'scrollBehavior' in document.body.style;
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        if (el.scroll && canSmoothScroll) el.scroll({
            top: top,
            left: left,
            behavior: behavior
        });
        else {
            el.scrollTop = top;
            el.scrollLeft = left;
        }
    });
}
function $ec6949d09184329a$var$getOptions(options) {
    if (options === false) return {
        block: 'end',
        inline: 'nearest'
    };
    if ($ec6949d09184329a$var$isOptionsObject(options)) return options;
    return {
        block: 'start',
        inline: 'nearest'
    };
}
function $ec6949d09184329a$var$scrollIntoView(target, options) {
    var isTargetAttached = target.isConnected || target.ownerDocument.documentElement.contains(target);
    if ($ec6949d09184329a$var$isOptionsObject(options) && typeof options.behavior === 'function') return options.behavior(isTargetAttached ? (0, $c2186ff521b340c0$export$2e2bcd8739ae039)(target, options) : []);
    if (!isTargetAttached) return;
    var computeOptions = $ec6949d09184329a$var$getOptions(options);
    return $ec6949d09184329a$var$defaultBehavior((0, $c2186ff521b340c0$export$2e2bcd8739ae039)(target, computeOptions), computeOptions.behavior);
}
var $ec6949d09184329a$export$2e2bcd8739ae039 = $ec6949d09184329a$var$scrollIntoView;


var $0535cdc15230b38d$var$memoizedNow;
var $0535cdc15230b38d$var$now = function now() {
    if (!$0535cdc15230b38d$var$memoizedNow) $0535cdc15230b38d$var$memoizedNow = 'performance' in window ? performance.now.bind(performance) : Date.now;
    return $0535cdc15230b38d$var$memoizedNow();
};
function $0535cdc15230b38d$var$step(context) {
    var time = $0535cdc15230b38d$var$now();
    var elapsed = Math.min((time - context.startTime) / context.duration, 1);
    var value = context.ease(elapsed);
    var currentX = context.startX + (context.x - context.startX) * value;
    var currentY = context.startY + (context.y - context.startY) * value;
    context.method(currentX, currentY);
    if (currentX !== context.x || currentY !== context.y) requestAnimationFrame(function() {
        return $0535cdc15230b38d$var$step(context);
    });
    else context.cb();
}
function $0535cdc15230b38d$var$smoothScroll(el, x, y, duration, ease, cb) {
    if (duration === void 0) duration = 600;
    if (ease === void 0) ease = function ease(t) {
        return 1 + --t * t * t * t * t;
    };
    var scrollable;
    var startX;
    var startY;
    var method;
    scrollable = el;
    startX = el.scrollLeft;
    startY = el.scrollTop;
    method = function method(x, y) {
        el.scrollLeft = Math.ceil(x);
        el.scrollTop = Math.ceil(y);
    };
    $0535cdc15230b38d$var$step({
        scrollable: scrollable,
        method: method,
        startTime: $0535cdc15230b38d$var$now(),
        startX: startX,
        startY: startY,
        x: x,
        y: y,
        duration: duration,
        ease: ease,
        cb: cb
    });
}
var $0535cdc15230b38d$var$shouldSmoothScroll = function shouldSmoothScroll(options) {
    return options && !options.behavior || options.behavior === 'smooth';
};
function $0535cdc15230b38d$var$scroll(target, options) {
    var overrides = options || {};
    if ($0535cdc15230b38d$var$shouldSmoothScroll(overrides)) return (0, $ec6949d09184329a$export$2e2bcd8739ae039)(target, {
        block: overrides.block,
        inline: overrides.inline,
        scrollMode: overrides.scrollMode,
        boundary: overrides.boundary,
        behavior: function behavior(actions) {
            return Promise.all(actions.reduce(function(results, _ref) {
                var el = _ref.el, left = _ref.left, top = _ref.top;
                var startLeft = el.scrollLeft;
                var startTop = el.scrollTop;
                if (startLeft === left && startTop === top) return results;
                return [].concat(results, [
                    new Promise(function(resolve) {
                        return $0535cdc15230b38d$var$smoothScroll(el, left, top, overrides.duration, overrides.ease, function() {
                            return resolve({
                                el: el,
                                left: [
                                    startLeft,
                                    left
                                ],
                                top: [
                                    startTop,
                                    top
                                ]
                            });
                        });
                    })
                ]);
            }, []));
        }
    });
    return Promise.resolve((0, $ec6949d09184329a$export$2e2bcd8739ae039)(target, options));
}
var $0535cdc15230b38d$var$smoothScrollIntoView = $0535cdc15230b38d$var$scroll;
var $0535cdc15230b38d$export$2e2bcd8739ae039 = $0535cdc15230b38d$var$smoothScrollIntoView;


var $53eb3904070cf0e9$exports = {};

$parcel$defineInteropFlag($53eb3904070cf0e9$exports);

$parcel$export($53eb3904070cf0e9$exports, "default", () => $53eb3904070cf0e9$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "Range", () => $51730a1a5a927869$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "Handle", () => $be7cb93b822a2be3$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "createSliderWithTooltip", () => $dadbd822db857fd1$export$2e2bcd8739ae039);
$parcel$export($53eb3904070cf0e9$exports, "SliderTooltip", () => $ee63ddd70979cae1$export$2e2bcd8739ae039);
function $d4e0dd4084a38c17$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $d4e0dd4084a38c17$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d4e0dd4084a38c17$export$2e2bcd8739ae039(o);
}



function $6ab36d11786c9caa$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $a589a0dff6ad512d$export$2e2bcd8739ae039(t) {
    var i = (0, $6ab36d11786c9caa$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $5e86d015ad96e244$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $a589a0dff6ad512d$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $a24d5fade17372a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a24d5fade17372a9$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a24d5fade17372a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a24d5fade17372a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}


function $3a625298bae21416$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}



function $a874d781bdb225e2$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $a589a0dff6ad512d$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $a874d781bdb225e2$export$2e2bcd8739ae039(e, r, t) {
    return r && $a874d781bdb225e2$var$_defineProperties(e.prototype, r), t && $a874d781bdb225e2$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}


function $8355d769ce7c2a91$export$2e2bcd8739ae039(t, e) {
    return $8355d769ce7c2a91$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $8355d769ce7c2a91$export$2e2bcd8739ae039(t, e);
}


function $080b772b018ceec5$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $8355d769ce7c2a91$export$2e2bcd8739ae039)(t, e);
}


function $61e83c07e8369f96$export$2e2bcd8739ae039(t) {
    return $61e83c07e8369f96$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $61e83c07e8369f96$export$2e2bcd8739ae039(t);
}


function $172b16760aa26608$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($172b16760aa26608$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}



function $e3cc1c0a9f4b2276$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $d47c8bc3fef6940e$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(t);
}


function $b608e4f8b4c613fa$export$2e2bcd8739ae039(t) {
    var r = (0, $172b16760aa26608$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $61e83c07e8369f96$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $61e83c07e8369f96$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $d47c8bc3fef6940e$export$2e2bcd8739ae039)(this, e);
    };
}



var $dup7A = parcelRequire("dup7A");
/* eslint-disable no-console */ var $b4cde5d547cd3626$var$warned = {};
var $b4cde5d547cd3626$var$preWarningFns = [];
var $b4cde5d547cd3626$export$61616f168f0e5a05 = function preMessage(fn) {
    $b4cde5d547cd3626$var$preWarningFns.push(fn);
};
function $b4cde5d547cd3626$export$491112666e282270(valid, message) {
    var finalMessage;
}
function $b4cde5d547cd3626$export$a92e4c44d367d0af(valid, message) {
    var finalMessage;
}
function $b4cde5d547cd3626$export$60eef1277fe463e4() {
    $b4cde5d547cd3626$var$warned = {};
}
function $b4cde5d547cd3626$export$848feb93d8f32b9b(method, valid, message) {
    if (!valid && !$b4cde5d547cd3626$var$warned[message]) {
        method(false, message);
        $b4cde5d547cd3626$var$warned[message] = true;
    }
}
function $b4cde5d547cd3626$export$82934adf09101657(valid, message) {
    $b4cde5d547cd3626$export$848feb93d8f32b9b($b4cde5d547cd3626$export$491112666e282270, valid, message);
}
function $b4cde5d547cd3626$export$89ff31684837bbbf(valid, message) {
    $b4cde5d547cd3626$export$848feb93d8f32b9b($b4cde5d547cd3626$export$a92e4c44d367d0af, valid, message);
}
$b4cde5d547cd3626$export$82934adf09101657.preMessage = $b4cde5d547cd3626$export$61616f168f0e5a05;
$b4cde5d547cd3626$export$82934adf09101657.resetWarned = $b4cde5d547cd3626$export$60eef1277fe463e4;
$b4cde5d547cd3626$export$82934adf09101657.noteOnce = $b4cde5d547cd3626$export$89ff31684837bbbf;
var $b4cde5d547cd3626$export$2e2bcd8739ae039 = $b4cde5d547cd3626$export$82934adf09101657;





var $dup7A = parcelRequire("dup7A");
var $f07294755a4ae8ec$var$Track = function Track(props) {
    var _ref, _ref2;
    var className = props.className, included = props.included, vertical = props.vertical, style = props.style;
    var length = props.length, offset = props.offset, reverse = props.reverse;
    if (length < 0) {
        reverse = !reverse;
        length = Math.abs(length);
        offset = 100 - offset;
    }
    var positonStyle = vertical ? (_ref = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, "width", "".concat(length, "%")), _ref2);
    var elStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), positonStyle);
    return included ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: className,
        style: elStyle
    }) : null;
};
var $f07294755a4ae8ec$export$2e2bcd8739ae039 = $f07294755a4ae8ec$var$Track;


function $2ad89326f6f07287$export$2e2bcd8739ae039() {
    return $2ad89326f6f07287$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $2ad89326f6f07287$export$2e2bcd8739ae039.apply(null, arguments);
}


function $881d8951ad829f2f$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $fa75eafa4826b919$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $881d8951ad829f2f$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}




function $16c689bb2fdde618$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $81b0cb243c7b4cf3$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $16c689bb2fdde618$export$2e2bcd8739ae039)(r);
}


function $435b24fe7d07ab67$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}



function $89db58488ac3ca79$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $16c689bb2fdde618$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $16c689bb2fdde618$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $d07b6f6a0afb23c8$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $39333a40da2a8fa5$export$2e2bcd8739ae039(r) {
    return (0, $81b0cb243c7b4cf3$export$2e2bcd8739ae039)(r) || (0, $435b24fe7d07ab67$export$2e2bcd8739ae039)(r) || (0, $89db58488ac3ca79$export$2e2bcd8739ae039)(r) || (0, $d07b6f6a0afb23c8$export$2e2bcd8739ae039)();
}





function $3d90446364da0005$export$2e2bcd8739ae039(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = (0, $61e83c07e8369f96$export$2e2bcd8739ae039)(t)););
    return t;
}


function $66e3be070267ec34$export$2e2bcd8739ae039() {
    return $66e3be070267ec34$export$2e2bcd8739ae039 = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = (0, $3d90446364da0005$export$2e2bcd8739ae039)(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $66e3be070267ec34$export$2e2bcd8739ae039.apply(null, arguments);
}






var $dup7A = parcelRequire("dup7A");

function $d43892da47566d6b$export$2e2bcd8739ae039(target, eventType, cb, option) {
    /* eslint camelcase: 2 */ var callback = (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).unstable_batchedUpdates ? function run(e) {
        (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).unstable_batchedUpdates(cb, e);
    } : cb;
    if (target !== null && target !== void 0 && target.addEventListener) target.addEventListener(eventType, callback, option);
    return {
        remove: function remove() {
            if (target !== null && target !== void 0 && target.removeEventListener) target.removeEventListener(eventType, callback, option);
        }
    };
}


var $10902e23ce058af7$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($10902e23ce058af7$exports) {
        classNames.default = classNames;
        $10902e23ce058af7$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();






var $dup7A = parcelRequire("dup7A");


var $cd4751ba8c486af3$var$calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
    (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
    var points = Object.keys(marks).map(parseFloat).sort(function(a, b) {
        return a - b;
    });
    if (dots && step) {
        for(var i = min; i <= max; i += step)if (points.indexOf(i) === -1) points.push(i);
    }
    return points;
};
var $cd4751ba8c486af3$var$Steps = function Steps(_ref) {
    var prefixCls = _ref.prefixCls, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, dots = _ref.dots, step = _ref.step, included = _ref.included, lowerBound = _ref.lowerBound, upperBound = _ref.upperBound, max = _ref.max, min = _ref.min, dotStyle = _ref.dotStyle, activeDotStyle = _ref.activeDotStyle;
    var range = max - min;
    var elements = $cd4751ba8c486af3$var$calcPoints(vertical, marks, dots, step, min, max).map(function(point) {
        var _classNames;
        var offset = "".concat(Math.abs(point - min) / range * 100, "%");
        var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var style = vertical ? (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, reverse ? 'top' : 'bottom', offset)) : (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, dotStyle), {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, reverse ? 'right' : 'left', offset));
        if (isActived) style = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), activeDotStyle);
        var pointClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot"), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-active"), isActived), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("span", {
            className: pointClassName,
            style: style,
            key: point
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: "".concat(prefixCls, "-step")
    }, elements);
};
var $cd4751ba8c486af3$export$2e2bcd8739ae039 = $cd4751ba8c486af3$var$Steps;






var $dup7A = parcelRequire("dup7A");

var $3350efbd2aeb48ae$var$Marks = function Marks(_ref) {
    var className = _ref.className, vertical = _ref.vertical, reverse = _ref.reverse, marks = _ref.marks, included = _ref.included, upperBound = _ref.upperBound, lowerBound = _ref.lowerBound, max = _ref.max, min = _ref.min, onClickLabel = _ref.onClickLabel;
    var marksKeys = Object.keys(marks);
    var range = max - min;
    var elements = marksKeys.map(parseFloat).sort(function(a, b) {
        return a - b;
    }).map(function(point) {
        var _classNames;
        var markPoint = marks[point];
        var markPointIsObject = (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(markPoint) === 'object' && !/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).isValidElement(markPoint);
        var markLabel = markPointIsObject ? markPoint.label : markPoint;
        if (!markLabel && markLabel !== 0) return null;
        var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
        var markClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text"), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(className, "-text-active"), isActive), _classNames));
        var bottomStyle = (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({
            marginBottom: '-50%'
        }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));
        var leftStyle = (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({
            transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
            msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
        }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));
        var style = vertical ? bottomStyle : leftStyle;
        var markStyle = markPointIsObject ? (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), markPoint.style) : style;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("span", {
            className: markClassName,
            style: markStyle,
            key: point,
            onMouseDown: function onMouseDown(e) {
                return onClickLabel(e, point);
            },
            onTouchStart: function onTouchStart(e) {
                return onClickLabel(e, point);
            }
        }, markLabel);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
        className: className
    }, elements);
};
var $3350efbd2aeb48ae$export$2e2bcd8739ae039 = $3350efbd2aeb48ae$var$Marks;











var $dup7A = parcelRequire("dup7A");


var $be7cb93b822a2be3$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Handle, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Handle);
    function Handle() {
        var _this;
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Handle);
        _this = _super.apply(this, arguments);
        _this.state = {
            clickFocused: false
        };
        _this.setHandleRef = function(node) {
            _this.handle = node;
        };
        _this.handleMouseUp = function() {
            if (document.activeElement === _this.handle) _this.setClickFocus(true);
        };
        _this.handleMouseDown = function(e) {
            // avoid selecting text during drag
            // https://github.com/ant-design/ant-design/issues/25010
            e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324
            _this.focus();
        };
        _this.handleBlur = function() {
            _this.setClickFocus(false);
        };
        _this.handleKeyDown = function() {
            _this.setClickFocus(false);
        };
        return _this;
    }
    (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Handle, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                // mouseup won't trigger if mouse moved out of handle,
                // so we listen on document here.
                this.onMouseUpListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(document, 'mouseup', this.handleMouseUp);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.onMouseUpListener) this.onMouseUpListener.remove();
            }
        },
        {
            key: "setClickFocus",
            value: function setClickFocus(focused) {
                this.setState({
                    clickFocused: focused
                });
            }
        },
        {
            key: "clickFocus",
            value: function clickFocus() {
                this.setClickFocus(true);
                this.focus();
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.handle.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.handle.blur();
            }
        },
        {
            key: "render",
            value: function render() {
                var _ref, _ref2;
                var _this$props = this.props, prefixCls = _this$props.prefixCls, vertical = _this$props.vertical, reverse = _this$props.reverse, offset = _this$props.offset, style = _this$props.style, disabled = _this$props.disabled, min = _this$props.min, max = _this$props.max, value = _this$props.value, tabIndex = _this$props.tabIndex, ariaLabel = _this$props.ariaLabel, ariaLabelledBy = _this$props.ariaLabelledBy, ariaValueTextFormatter = _this$props.ariaValueTextFormatter, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_this$props, [
                    "prefixCls",
                    "vertical",
                    "reverse",
                    "offset",
                    "style",
                    "disabled",
                    "min",
                    "max",
                    "value",
                    "tabIndex",
                    "ariaLabel",
                    "ariaLabelledBy",
                    "ariaValueTextFormatter"
                ]);
                var className = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(this.props.className, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
                var positionStyle = vertical ? (_ref = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, reverse ? 'left' : 'right', 'auto'), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);
                var elStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, style), positionStyle);
                var mergedTabIndex = tabIndex || 0;
                if (disabled || tabIndex === null) mergedTabIndex = null;
                var ariaValueText;
                if (ariaValueTextFormatter) ariaValueText = ariaValueTextFormatter(value);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({
                    ref: this.setHandleRef,
                    tabIndex: mergedTabIndex
                }, restProps, {
                    className: className,
                    style: elStyle,
                    onBlur: this.handleBlur,
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleMouseDown // aria attribute
                    ,
                    role: "slider",
                    "aria-valuemin": min,
                    "aria-valuemax": max,
                    "aria-valuenow": value,
                    "aria-disabled": !!disabled,
                    "aria-label": ariaLabel,
                    "aria-labelledby": ariaLabelledBy,
                    "aria-valuetext": ariaValueText
                }));
            }
        }
    ]);
    return Handle;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);




/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var $46d04450f94a049c$var$KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= $46d04450f94a049c$var$KeyCode.F1 && keyCode <= $46d04450f94a049c$var$KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case $46d04450f94a049c$var$KeyCode.ALT:
            case $46d04450f94a049c$var$KeyCode.CAPS_LOCK:
            case $46d04450f94a049c$var$KeyCode.CONTEXT_MENU:
            case $46d04450f94a049c$var$KeyCode.CTRL:
            case $46d04450f94a049c$var$KeyCode.DOWN:
            case $46d04450f94a049c$var$KeyCode.END:
            case $46d04450f94a049c$var$KeyCode.ESC:
            case $46d04450f94a049c$var$KeyCode.HOME:
            case $46d04450f94a049c$var$KeyCode.INSERT:
            case $46d04450f94a049c$var$KeyCode.LEFT:
            case $46d04450f94a049c$var$KeyCode.MAC_FF_META:
            case $46d04450f94a049c$var$KeyCode.META:
            case $46d04450f94a049c$var$KeyCode.NUMLOCK:
            case $46d04450f94a049c$var$KeyCode.NUM_CENTER:
            case $46d04450f94a049c$var$KeyCode.PAGE_DOWN:
            case $46d04450f94a049c$var$KeyCode.PAGE_UP:
            case $46d04450f94a049c$var$KeyCode.PAUSE:
            case $46d04450f94a049c$var$KeyCode.PRINT_SCREEN:
            case $46d04450f94a049c$var$KeyCode.RIGHT:
            case $46d04450f94a049c$var$KeyCode.SHIFT:
            case $46d04450f94a049c$var$KeyCode.UP:
            case $46d04450f94a049c$var$KeyCode.WIN_KEY:
            case $46d04450f94a049c$var$KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= $46d04450f94a049c$var$KeyCode.ZERO && keyCode <= $46d04450f94a049c$var$KeyCode.NINE) return true;
        if (keyCode >= $46d04450f94a049c$var$KeyCode.NUM_ZERO && keyCode <= $46d04450f94a049c$var$KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= $46d04450f94a049c$var$KeyCode.A && keyCode <= $46d04450f94a049c$var$KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case $46d04450f94a049c$var$KeyCode.SPACE:
            case $46d04450f94a049c$var$KeyCode.QUESTION_MARK:
            case $46d04450f94a049c$var$KeyCode.NUM_PLUS:
            case $46d04450f94a049c$var$KeyCode.NUM_MINUS:
            case $46d04450f94a049c$var$KeyCode.NUM_PERIOD:
            case $46d04450f94a049c$var$KeyCode.NUM_DIVISION:
            case $46d04450f94a049c$var$KeyCode.SEMICOLON:
            case $46d04450f94a049c$var$KeyCode.DASH:
            case $46d04450f94a049c$var$KeyCode.EQUALS:
            case $46d04450f94a049c$var$KeyCode.COMMA:
            case $46d04450f94a049c$var$KeyCode.PERIOD:
            case $46d04450f94a049c$var$KeyCode.SLASH:
            case $46d04450f94a049c$var$KeyCode.APOSTROPHE:
            case $46d04450f94a049c$var$KeyCode.SINGLE_QUOTE:
            case $46d04450f94a049c$var$KeyCode.OPEN_SQUARE_BRACKET:
            case $46d04450f94a049c$var$KeyCode.BACKSLASH:
            case $46d04450f94a049c$var$KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
var $46d04450f94a049c$export$2e2bcd8739ae039 = $46d04450f94a049c$var$KeyCode;


function $466699104c68908f$export$597415897f3287c9(e, handles) {
    try {
        return Object.keys(handles).some(function(key) {
            return e.target === (0, $e10f5070fc836746$exports.findDOMNode)(handles[key]);
        });
    } catch (error) {
        return false;
    }
}
function $466699104c68908f$export$f4657b4dc4cc2ea4(value, _ref) {
    var min = _ref.min, max = _ref.max;
    return value < min || value > max;
}
function $466699104c68908f$export$eaf0efc71c45a02(e) {
    return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}
function $466699104c68908f$export$e3e031d5dec39373(val, _ref2) {
    var marks = _ref2.marks, step = _ref2.step, min = _ref2.min, max = _ref2.max;
    var points = Object.keys(marks).map(parseFloat);
    if (step !== null) {
        var baseNum = Math.pow(10, $466699104c68908f$export$e0c74b50bbd10f68(step));
        var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
        var steps = Math.min((val - min) / step, maxSteps);
        var closestStep = Math.round(steps) * step + min;
        points.push(closestStep);
    }
    var diffs = points.map(function(point) {
        return Math.abs(val - point);
    });
    return points[diffs.indexOf(Math.min.apply(Math, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(diffs)))];
}
function $466699104c68908f$export$e0c74b50bbd10f68(step) {
    var stepString = step.toString();
    var precision = 0;
    if (stepString.indexOf('.') >= 0) precision = stepString.length - stepString.indexOf('.') - 1;
    return precision;
}
function $466699104c68908f$export$642213d516a9b928(vertical, e) {
    return vertical ? e.clientY : e.pageX;
}
function $466699104c68908f$export$7e1d3da113d10e8e(vertical, e) {
    return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function $466699104c68908f$export$ec6357f54996b379(vertical, handle) {
    var coords = handle.getBoundingClientRect();
    return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function $466699104c68908f$export$65e4339c6f9d8d24(val, _ref3) {
    var max = _ref3.max, min = _ref3.min;
    if (val <= min) return min;
    if (val >= max) return max;
    return val;
}
function $466699104c68908f$export$5bea24a9dfe5ab1a(val, props) {
    var step = props.step;
    var closestPoint = isFinite($466699104c68908f$export$e3e031d5dec39373(val, props)) ? $466699104c68908f$export$e3e031d5dec39373(val, props) : 0; // eslint-disable-line
    return step === null ? closestPoint : parseFloat(closestPoint.toFixed($466699104c68908f$export$e0c74b50bbd10f68(step)));
}
function $466699104c68908f$export$3f9ffdaf2961f43f(e) {
    e.stopPropagation();
    e.preventDefault();
}
function $466699104c68908f$export$e5722e0a8bbb32d9(func, value, props) {
    var operations = {
        increase: function increase(a, b) {
            return a + b;
        },
        decrease: function decrease(a, b) {
            return a - b;
        }
    };
    var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
    var keyToGet = Object.keys(props.marks)[indexToGet];
    if (props.step) return operations[func](value, props.step);
    if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) return props.marks[keyToGet];
    return value;
}
function $466699104c68908f$export$3bef836a1fb84ee6(e, vertical, reverse) {
    var increase = 'increase';
    var decrease = 'decrease';
    var method = increase;
    switch(e.keyCode){
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).UP:
            method = vertical && reverse ? decrease : increase;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).RIGHT:
            method = !vertical && reverse ? decrease : increase;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).DOWN:
            method = vertical && reverse ? increase : decrease;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).LEFT:
            method = !vertical && reverse ? increase : decrease;
            break;
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).END:
            return function(value, props) {
                return props.max;
            };
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).HOME:
            return function(value, props) {
                return props.min;
            };
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).PAGE_UP:
            return function(value, props) {
                return value + props.step * 2;
            };
        case (0, $46d04450f94a049c$export$2e2bcd8739ae039).PAGE_DOWN:
            return function(value, props) {
                return value - props.step * 2;
            };
        default:
            return undefined;
    }
    return function(value, props) {
        return $466699104c68908f$export$e5722e0a8bbb32d9(method, value, props);
    };
}


/* eslint-disable @typescript-eslint/no-explicit-any */ function $8d0aebb38e624949$var$noop() {}
function $8d0aebb38e624949$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(ComponentEnhancer, _Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(ComponentEnhancer);
        function ComponentEnhancer(props) {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, ComponentEnhancer);
            _this = _super.call(this, props);
            _this.onDown = function(e, position) {
                var p = position;
                var _this$props = _this.props, draggableTrack = _this$props.draggableTrack, isVertical = _this$props.vertical;
                var bounds = _this.state.bounds;
                var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
                var inPoint = $466699104c68908f$export$597415897f3287c9(e, _this.handlesRefs);
                _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function(n, i) {
                    var v = !i ? n >= bounds[i] : true;
                    return i === value.length - 1 ? n <= bounds[i] : v;
                }).some(function(c) {
                    return !c;
                });
                if (_this.dragTrack) {
                    _this.dragOffset = p;
                    _this.startBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(bounds);
                } else {
                    if (!inPoint) _this.dragOffset = 0;
                    else {
                        var handlePosition = $466699104c68908f$export$ec6357f54996b379(isVertical, e.target);
                        _this.dragOffset = p - handlePosition;
                        p = handlePosition;
                    }
                    _this.onStart(p);
                }
            };
            _this.onMouseDown = function(e) {
                if (e.button !== 0) return;
                _this.removeDocumentEvents();
                var isVertical = _this.props.vertical;
                var position = $466699104c68908f$export$642213d516a9b928(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentMouseEvents();
            };
            _this.onTouchStart = function(e) {
                if ($466699104c68908f$export$eaf0efc71c45a02(e)) return;
                var isVertical = _this.props.vertical;
                var position = $466699104c68908f$export$7e1d3da113d10e8e(isVertical, e);
                _this.onDown(e, position);
                _this.addDocumentTouchEvents();
                $466699104c68908f$export$3f9ffdaf2961f43f(e);
            };
            _this.onFocus = function(e) {
                var _this$props2 = _this.props, onFocus = _this$props2.onFocus, vertical = _this$props2.vertical;
                if ($466699104c68908f$export$597415897f3287c9(e, _this.handlesRefs) && !_this.dragTrack) {
                    var handlePosition = $466699104c68908f$export$ec6357f54996b379(vertical, e.target);
                    _this.dragOffset = 0;
                    _this.onStart(handlePosition);
                    $466699104c68908f$export$3f9ffdaf2961f43f(e);
                    if (onFocus) onFocus(e);
                }
            };
            _this.onBlur = function(e) {
                var onBlur = _this.props.onBlur;
                if (!_this.dragTrack) _this.onEnd();
                if (onBlur) onBlur(e);
            };
            _this.onMouseUp = function() {
                if (_this.handlesRefs[_this.prevMovedHandleIndex]) _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
            };
            _this.onMouseMove = function(e) {
                if (!_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $466699104c68908f$export$642213d516a9b928(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onTouchMove = function(e) {
                if ($466699104c68908f$export$eaf0efc71c45a02(e) || !_this.sliderRef) {
                    _this.onEnd();
                    return;
                }
                var position = $466699104c68908f$export$7e1d3da113d10e8e(_this.props.vertical, e);
                _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
            };
            _this.onKeyDown = function(e) {
                if (_this.sliderRef && $466699104c68908f$export$597415897f3287c9(e, _this.handlesRefs)) _this.onKeyboard(e);
            };
            _this.onClickMarkLabel = function(e, value) {
                e.stopPropagation();
                _this.onChange({
                    value: value
                }); // eslint-disable-next-line react/no-unused-state
                _this.setState({
                    value: value
                }, function() {
                    return _this.onEnd(true);
                });
            };
            _this.saveSlider = function(slider) {
                _this.sliderRef = slider;
            };
            var step = props.step, max = props.max, min = props.min;
            var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
            (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
            _this.handlesRefs = {};
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(ComponentEnhancer, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    // Snapshot testing cannot handle refs, so be sure to null-check this.
                    this.document = this.sliderRef && this.sliderRef.ownerDocument;
                    var _this$props3 = this.props, autoFocus = _this$props3.autoFocus, disabled = _this$props3.disabled;
                    if (autoFocus && !disabled) this.focus();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    if ((0, $66e3be070267ec34$export$2e2bcd8739ae039)((0, $61e83c07e8369f96$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this)) (0, $66e3be070267ec34$export$2e2bcd8739ae039)((0, $61e83c07e8369f96$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
                    this.removeDocumentEvents();
                }
            },
            {
                key: "getSliderStart",
                value: function getSliderStart() {
                    var slider = this.sliderRef;
                    var _this$props4 = this.props, vertical = _this$props4.vertical, reverse = _this$props4.reverse;
                    var rect = slider.getBoundingClientRect();
                    if (vertical) return reverse ? rect.bottom : rect.top;
                    return window.pageXOffset + (reverse ? rect.right : rect.left);
                }
            },
            {
                key: "getSliderLength",
                value: function getSliderLength() {
                    var slider = this.sliderRef;
                    if (!slider) return 0;
                    var coords = slider.getBoundingClientRect();
                    return this.props.vertical ? coords.height : coords.width;
                }
            },
            {
                key: "addDocumentTouchEvents",
                value: function addDocumentTouchEvents() {
                    // just work for Chrome iOS Safari and Android Browser
                    this.onTouchMoveListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, 'touchmove', this.onTouchMove);
                    this.onTouchUpListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, 'touchend', this.onEnd);
                }
            },
            {
                key: "addDocumentMouseEvents",
                value: function addDocumentMouseEvents() {
                    this.onMouseMoveListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, 'mousemove', this.onMouseMove);
                    this.onMouseUpListener = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(this.document, 'mouseup', this.onEnd);
                }
            },
            {
                key: "removeDocumentEvents",
                value: function removeDocumentEvents() {
                    /* eslint-disable @typescript-eslint/no-unused-expressions */ this.onTouchMoveListener && this.onTouchMoveListener.remove();
                    this.onTouchUpListener && this.onTouchUpListener.remove();
                    this.onMouseMoveListener && this.onMouseMoveListener.remove();
                    this.onMouseUpListener && this.onMouseUpListener.remove();
                /* eslint-enable no-unused-expressions */ }
            },
            {
                key: "focus",
                value: function focus() {
                    var _this$handlesRefs$;
                    if (this.props.disabled) return;
                    (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 || _this$handlesRefs$.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    var _this2 = this;
                    if (this.props.disabled) return;
                    Object.keys(this.handlesRefs).forEach(function(key) {
                        var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;
                        (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 || (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 || _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
                    });
                }
            },
            {
                key: "calcValue",
                value: function calcValue(offset) {
                    var _this$props5 = this.props, vertical = _this$props5.vertical, min = _this$props5.min, max = _this$props5.max;
                    var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
                    var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
                    return value;
                }
            },
            {
                key: "calcValueByPos",
                value: function calcValueByPos(position) {
                    var sign = this.props.reverse ? -1 : 1;
                    var pixelOffset = sign * (position - this.getSliderStart());
                    var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
                    return nextValue;
                }
            },
            {
                key: "calcOffset",
                value: function calcOffset(value) {
                    var _this$props6 = this.props, min = _this$props6.min, max = _this$props6.max;
                    var ratio = (value - min) / (max - min);
                    return Math.max(0, ratio * 100);
                }
            },
            {
                key: "saveHandle",
                value: function saveHandle(index, handle) {
                    this.handlesRefs[index] = handle;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _classNames;
                    var _this$props7 = this.props, prefixCls = _this$props7.prefixCls, className = _this$props7.className, marks = _this$props7.marks, dots = _this$props7.dots, step = _this$props7.step, included = _this$props7.included, disabled = _this$props7.disabled, vertical = _this$props7.vertical, reverse = _this$props7.reverse, min = _this$props7.min, max = _this$props7.max, children = _this$props7.children, maximumTrackStyle = _this$props7.maximumTrackStyle, style = _this$props7.style, railStyle = _this$props7.railStyle, dotStyle = _this$props7.dotStyle, activeDotStyle = _this$props7.activeDotStyle;
                    var _get$call = (0, $66e3be070267ec34$export$2e2bcd8739ae039)((0, $61e83c07e8369f96$export$2e2bcd8739ae039)(ComponentEnhancer.prototype), "render", this).call(this), tracks = _get$call.tracks, handles = _get$call.handles;
                    var sliderClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(prefixCls, (_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-disabled"), disabled), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(prefixCls, "-vertical"), vertical), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, className, className), _classNames));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
                        ref: this.saveSlider,
                        className: sliderClassName,
                        onTouchStart: disabled ? $8d0aebb38e624949$var$noop : this.onTouchStart,
                        onMouseDown: disabled ? $8d0aebb38e624949$var$noop : this.onMouseDown,
                        onMouseUp: disabled ? $8d0aebb38e624949$var$noop : this.onMouseUp,
                        onKeyDown: disabled ? $8d0aebb38e624949$var$noop : this.onKeyDown,
                        onFocus: disabled ? $8d0aebb38e624949$var$noop : this.onFocus,
                        onBlur: disabled ? $8d0aebb38e624949$var$noop : this.onBlur,
                        style: style
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement("div", {
                        className: "".concat(prefixCls, "-rail"),
                        style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, maximumTrackStyle), railStyle)
                    }), tracks, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $cd4751ba8c486af3$export$2e2bcd8739ae039), {
                        prefixCls: prefixCls,
                        vertical: vertical,
                        reverse: reverse,
                        marks: marks,
                        dots: dots,
                        step: step,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        dotStyle: dotStyle,
                        activeDotStyle: activeDotStyle
                    }), handles, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $3350efbd2aeb48ae$export$2e2bcd8739ae039), {
                        className: "".concat(prefixCls, "-mark"),
                        onClickLabel: disabled ? $8d0aebb38e624949$var$noop : this.onClickMarkLabel,
                        vertical: vertical,
                        marks: marks,
                        included: included,
                        lowerBound: this.getLowerBound(),
                        upperBound: this.getUpperBound(),
                        max: max,
                        min: min,
                        reverse: reverse
                    }), children);
                }
            }
        ]);
        return ComponentEnhancer;
    }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, Component.defaultProps), {}, {
        prefixCls: 'rc-slider',
        className: '',
        min: 0,
        max: 100,
        step: 1,
        marks: {},
        handle: function handle(props) {
            var index = props.index, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(props, [
                "index"
            ]);
            delete restProps.dragging;
            if (restProps.value === null) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $be7cb93b822a2be3$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, restProps, {
                key: index
            }));
        },
        onBeforeChange: $8d0aebb38e624949$var$noop,
        onChange: $8d0aebb38e624949$var$noop,
        onAfterChange: $8d0aebb38e624949$var$noop,
        included: true,
        disabled: false,
        dots: false,
        vertical: false,
        reverse: false,
        trackStyle: [
            {}
        ],
        handleStyle: [
            {}
        ],
        railStyle: {},
        dotStyle: {},
        activeDotStyle: {}
    }), _a;
}



var $ceac921ac672c792$var$Slider = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Slider, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Slider);
    /* eslint-enable */ function Slider(props) {
        var _this;
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Slider);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            return [];
        };
        _this.onEnd = function(force) {
            var dragging = _this.state.dragging;
            _this.removeDocumentEvents();
            if (dragging || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                dragging: false
            });
        };
        var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
        var value = props.value !== undefined ? props.value : defaultValue;
        _this.state = {
            value: _this.trimAlignValue(value),
            dragging: false
        };
        (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
        (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Slider, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this$props = this.props, min = _this$props.min, max = _this$props.max, value = _this$props.value, onChange = _this$props.onChange;
                if (!('min' in this.props || 'max' in this.props)) return;
                var theValue = value !== undefined ? value : prevState.value;
                var nextValue = this.trimAlignValue(theValue, this.props);
                if (nextValue === prevState.value) return;
                 // eslint-disable-next-line
                this.setState({
                    value: nextValue
                });
                if (!(min === prevProps.min && max === prevProps.max) && $466699104c68908f$export$f4657b4dc4cc2ea4(theValue, this.props)) onChange(nextValue);
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                var nextState = state.value > this.props.max ? (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, state), {}, {
                    value: this.props.max
                }) : state;
                if (isNotControlled) this.setState(nextState);
                var changedValue = nextState.value;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                this.setState({
                    dragging: true
                });
                var props = this.props;
                var prevValue = this.getValue();
                props.onBeforeChange(prevValue);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                if (value === prevValue) return;
                this.prevMovedHandleIndex = 0;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position) {
                $466699104c68908f$export$3f9ffdaf2961f43f(e);
                var oldValue = this.state.value;
                var value = this.calcValueByPos(position);
                if (value === oldValue) return;
                this.onChange({
                    value: value
                });
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $466699104c68908f$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $466699104c68908f$export$3f9ffdaf2961f43f(e);
                    var state = this.state;
                    var oldValue = state.value;
                    var mutatedValue = valueMutator(oldValue, this.props);
                    var value = this.trimAlignValue(mutatedValue);
                    if (value === oldValue) return;
                    this.onChange({
                        value: value
                    });
                    this.props.onAfterChange(value);
                    this.onEnd();
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.value;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                var minPoint = this.props.startPoint || this.props.min;
                return this.state.value > minPoint ? minPoint : this.state.value;
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                if (this.state.value < this.props.startPoint) return this.props.startPoint;
                return this.state.value;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(v) {
                var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (v === null) return null;
                var mergedProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, this.props), nextProps);
                var val = $466699104c68908f$export$65e4339c6f9d8d24(v, mergedProps);
                return $466699104c68908f$export$5bea24a9dfe5ab1a(val, mergedProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, prefixCls = _this$props3.prefixCls, vertical = _this$props3.vertical, included = _this$props3.included, disabled = _this$props3.disabled, minimumTrackStyle = _this$props3.minimumTrackStyle, trackStyle = _this$props3.trackStyle, handleStyle = _this$props3.handleStyle, tabIndex = _this$props3.tabIndex, ariaLabelForHandle = _this$props3.ariaLabelForHandle, ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle, ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle, min = _this$props3.min, max = _this$props3.max, startPoint = _this$props3.startPoint, reverse = _this$props3.reverse, handleGenerator = _this$props3.handle;
                var _this$state = this.state, value = _this$state.value, dragging = _this$state.dragging;
                var offset = this.calcOffset(value);
                var handle = handleGenerator({
                    className: "".concat(prefixCls, "-handle"),
                    prefixCls: prefixCls,
                    vertical: vertical,
                    offset: offset,
                    value: value,
                    dragging: dragging,
                    disabled: disabled,
                    min: min,
                    max: max,
                    reverse: reverse,
                    index: 0,
                    tabIndex: tabIndex,
                    ariaLabel: ariaLabelForHandle,
                    ariaLabelledBy: ariaLabelledByForHandle,
                    ariaValueTextFormatter: ariaValueTextFormatterForHandle,
                    style: handleStyle[0] || handleStyle,
                    ref: function ref(h) {
                        return _this2.saveHandle(0, h);
                    }
                });
                var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
                var mergedTrackStyle = trackStyle[0] || trackStyle;
                var track = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $f07294755a4ae8ec$export$2e2bcd8739ae039), {
                    className: "".concat(prefixCls, "-track"),
                    vertical: vertical,
                    included: included,
                    offset: trackOffset,
                    reverse: reverse,
                    length: offset - trackOffset,
                    style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, minimumTrackStyle), mergedTrackStyle)
                });
                return {
                    tracks: track,
                    handles: handle
                };
            }
        }
    ]);
    return Slider;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);
var $ceac921ac672c792$export$2e2bcd8739ae039 = (0, $8d0aebb38e624949$export$2e2bcd8739ae039)($ceac921ac672c792$var$Slider);










var $dup7A = parcelRequire("dup7A");




var $51730a1a5a927869$var$_trimAlignValue = function trimAlignValue(_ref) {
    var value = _ref.value, handle = _ref.handle, bounds = _ref.bounds, props = _ref.props;
    var allowCross = props.allowCross, pushable = props.pushable;
    var thershold = Number(pushable);
    var valInRange = $466699104c68908f$export$65e4339c6f9d8d24(value, props);
    var valNotConflict = valInRange;
    if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) valNotConflict = bounds[handle - 1] + thershold;
        if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) valNotConflict = bounds[handle + 1] - thershold;
    }
    return $466699104c68908f$export$5bea24a9dfe5ab1a(valNotConflict, props);
};
var $51730a1a5a927869$var$Range = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Range, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Range);
    function Range(props) {
        var _this;
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Range);
        _this = _super.call(this, props);
        _this.positionGetValue = function(position) {
            var bounds = _this.getValue();
            var value = _this.calcValueByPos(position);
            var closestBound = _this.getClosestBound(value);
            var index = _this.getBoundNeedMoving(value, closestBound);
            var prevValue = bounds[index];
            if (value === prevValue) return null;
            var nextBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(bounds);
            nextBounds[index] = value;
            return nextBounds;
        };
        _this.onEnd = function(force) {
            var handle = _this.state.handle;
            _this.removeDocumentEvents();
            if (!handle) _this.dragTrack = false;
            if (handle !== null || force) _this.props.onAfterChange(_this.getValue());
            _this.setState({
                handle: null
            });
        };
        var count = props.count, min = props.min, max = props.max;
        var initialValue = Array.apply(void 0, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(Array(count + 1))).map(function() {
            return min;
        });
        var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
        var value = props.value !== undefined ? props.value : defaultValue;
        var bounds = value.map(function(v, i) {
            return $51730a1a5a927869$var$_trimAlignValue({
                value: v,
                handle: i,
                props: props
            });
        });
        var recent = bounds[0] === max ? 0 : bounds.length - 1;
        _this.state = {
            handle: null,
            recent: recent,
            bounds: bounds
        };
        return _this;
    }
    /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */ /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */ (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Range, [
        {
            key: "calcValueByPos",
            value: function calcValueByPos(value) {
                return 0;
            }
        },
        {
            key: "getSliderLength",
            value: function getSliderLength() {
                return 0;
            }
        },
        {
            key: "calcOffset",
            value: function calcOffset(value) {
                return 0;
            }
        },
        {
            key: "saveHandle",
            value: function saveHandle(index, h) {}
        },
        {
            key: "removeDocumentEvents",
            value: function removeDocumentEvents() {}
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _this2 = this;
                var _this$props = this.props, onChange = _this$props.onChange, value = _this$props.value, min = _this$props.min, max = _this$props.max;
                if (!('min' in this.props || 'max' in this.props)) return;
                if (min === prevProps.min && max === prevProps.max) return;
                var currentValue = value || prevState.bounds;
                if (currentValue.some(function(v) {
                    return $466699104c68908f$export$f4657b4dc4cc2ea4(v, _this2.props);
                })) {
                    var newValues = currentValue.map(function(v) {
                        return $466699104c68908f$export$65e4339c6f9d8d24(v, _this2.props);
                    });
                    onChange(newValues);
                }
            }
        },
        {
            key: "onChange",
            value: function onChange(state) {
                var props = this.props;
                var isNotControlled = !('value' in props);
                if (isNotControlled) this.setState(state);
                else {
                    var controlledState = {};
                    [
                        'handle',
                        'recent'
                    ].forEach(function(item) {
                        if (state[item] !== undefined) controlledState[item] = state[item];
                    });
                    if (Object.keys(controlledState).length) this.setState(controlledState);
                }
                var data = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, this.state), state);
                var changedValue = data.bounds;
                props.onChange(changedValue);
            }
        },
        {
            key: "onStart",
            value: function onStart(position) {
                var props = this.props, state = this.state;
                var bounds = this.getValue();
                props.onBeforeChange(bounds);
                var value = this.calcValueByPos(position);
                this.startValue = value;
                this.startPosition = position;
                var closestBound = this.getClosestBound(value);
                this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
                this.setState({
                    handle: this.prevMovedHandleIndex,
                    recent: this.prevMovedHandleIndex
                });
                var prevValue = bounds[this.prevMovedHandleIndex];
                if (value === prevValue) return;
                var nextBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(state.bounds);
                nextBounds[this.prevMovedHandleIndex] = value;
                this.onChange({
                    bounds: nextBounds
                });
            }
        },
        {
            key: "onMove",
            value: function onMove(e, position, dragTrack, startBounds) {
                $466699104c68908f$export$3f9ffdaf2961f43f(e);
                var state = this.state, props = this.props;
                var maxValue = props.max || 100;
                var minValue = props.min || 0;
                if (dragTrack) {
                    var pos = props.vertical ? -position : position;
                    pos = props.reverse ? -pos : pos;
                    var max = maxValue - Math.max.apply(Math, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(startBounds));
                    var min = minValue - Math.min.apply(Math, (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(startBounds));
                    var ratio = Math.min(Math.max(pos / (this.getSliderLength() / (maxValue - minValue)), min), max);
                    var nextBounds = startBounds.map(function(v) {
                        return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
                    });
                    if (state.bounds.map(function(c, i) {
                        return c === nextBounds[i];
                    }).some(function(c) {
                        return !c;
                    })) this.onChange({
                        bounds: nextBounds
                    });
                    return;
                }
                var value = this.calcValueByPos(position);
                var oldValue = state.bounds[state.handle];
                if (value === oldValue) return;
                this.moveTo(value);
            }
        },
        {
            key: "onKeyboard",
            value: function onKeyboard(e) {
                var _this$props2 = this.props, reverse = _this$props2.reverse, vertical = _this$props2.vertical;
                var valueMutator = $466699104c68908f$export$3bef836a1fb84ee6(e, vertical, reverse);
                if (valueMutator) {
                    $466699104c68908f$export$3f9ffdaf2961f43f(e);
                    var state = this.state, props = this.props;
                    var bounds = state.bounds, handle = state.handle;
                    var oldValue = bounds[handle === null ? state.recent : handle];
                    var mutatedValue = valueMutator(oldValue, props);
                    var value = $51730a1a5a927869$var$_trimAlignValue({
                        value: mutatedValue,
                        handle: handle,
                        bounds: state.bounds,
                        props: props
                    });
                    if (value === oldValue) return;
                    var isFromKeyboardEvent = true;
                    this.moveTo(value, isFromKeyboardEvent);
                }
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                return this.state.bounds;
            }
        },
        {
            key: "getClosestBound",
            value: function getClosestBound(value) {
                var bounds = this.state.bounds;
                var closestBound = 0;
                for(var i = 1; i < bounds.length - 1; i += 1)if (value >= bounds[i]) closestBound = i;
                if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) closestBound += 1;
                return closestBound;
            }
        },
        {
            key: "getBoundNeedMoving",
            value: function getBoundNeedMoving(value, closestBound) {
                var _this$state = this.state, bounds = _this$state.bounds, recent = _this$state.recent;
                var boundNeedMoving = closestBound;
                var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
                if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) boundNeedMoving = recent;
                if (isAtTheSamePoint && value !== bounds[closestBound + 1]) boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
                return boundNeedMoving;
            }
        },
        {
            key: "getLowerBound",
            value: function getLowerBound() {
                return this.state.bounds[0];
            }
        },
        {
            key: "getUpperBound",
            value: function getUpperBound() {
                var bounds = this.state.bounds;
                return bounds[bounds.length - 1];
            }
        },
        {
            key: "getPoints",
            value: function getPoints() {
                var _this$props3 = this.props, marks = _this$props3.marks, step = _this$props3.step, min = _this$props3.min, max = _this$props3.max;
                var cache = this.internalPointsCache;
                if (!cache || cache.marks !== marks || cache.step !== step) {
                    var pointsObject = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, marks);
                    if (step !== null) for(var point = min; point <= max; point += step)pointsObject[point] = point;
                    var points = Object.keys(pointsObject).map(parseFloat);
                    points.sort(function(a, b) {
                        return a - b;
                    });
                    this.internalPointsCache = {
                        marks: marks,
                        step: step,
                        points: points
                    };
                }
                return this.internalPointsCache.points;
            }
        },
        {
            key: "moveTo",
            value: function moveTo(value, isFromKeyboardEvent) {
                var _this3 = this;
                var state = this.state, props = this.props;
                var nextBounds = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(state.bounds);
                var handle = state.handle === null ? state.recent : state.handle;
                nextBounds[handle] = value;
                var nextHandle = handle;
                if (props.pushable !== false) this.pushSurroundingHandles(nextBounds, nextHandle);
                else if (props.allowCross) {
                    nextBounds.sort(function(a, b) {
                        return a - b;
                    });
                    nextHandle = nextBounds.indexOf(value);
                }
                this.onChange({
                    recent: nextHandle,
                    handle: nextHandle,
                    bounds: nextBounds
                });
                if (isFromKeyboardEvent) {
                    // known problem: because setState is async,
                    // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
                    // cause onBeforeChange and onAfterChange receive wrong value.
                    // here use setState callback to hack，but not elegant
                    this.props.onAfterChange(nextBounds);
                    this.setState({}, function() {
                        _this3.handlesRefs[nextHandle].focus();
                    });
                    this.onEnd();
                }
            }
        },
        {
            key: "pushSurroundingHandles",
            value: function pushSurroundingHandles(bounds, handle) {
                var value = bounds[handle];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var direction = 0;
                if (bounds[handle + 1] - value < threshold) direction = 1; // push to right
                if (value - bounds[handle - 1] < threshold) direction = -1; // push to left
                if (direction === 0) return;
                var nextHandle = handle + direction;
                var diffToNext = direction * (bounds[nextHandle] - value);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // revert to original value if pushing is impossible
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = bounds[nextHandle] - direction * threshold;
            }
        },
        {
            key: "pushHandle",
            value: function pushHandle(bounds, handle, direction, amount) {
                var originalValue = bounds[handle];
                var currentValue = bounds[handle];
                while(direction * (currentValue - originalValue) < amount){
                    if (!this.pushHandleOnePoint(bounds, handle, direction)) {
                        // can't push handle enough to create the needed `amount` gap, so we
                        // revert its position to the original value
                        // eslint-disable-next-line no-param-reassign
                        bounds[handle] = originalValue;
                        return false;
                    }
                    currentValue = bounds[handle];
                } // the handle was pushed enough to create the needed `amount` gap
                return true;
            }
        },
        {
            key: "pushHandleOnePoint",
            value: function pushHandleOnePoint(bounds, handle, direction) {
                var points = this.getPoints();
                var pointIndex = points.indexOf(bounds[handle]);
                var nextPointIndex = pointIndex + direction;
                if (nextPointIndex >= points.length || nextPointIndex < 0) // reached the minimum or maximum available point, can't push anymore
                return false;
                var nextHandle = handle + direction;
                var nextValue = points[nextPointIndex];
                var pushable = this.props.pushable;
                var threshold = Number(pushable);
                var diffToNext = direction * (bounds[nextHandle] - nextValue);
                if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) // couldn't push next handle, so we won't push this one either
                return false;
                 // push the handle
                // eslint-disable-next-line no-param-reassign
                bounds[handle] = nextValue;
                return true;
            }
        },
        {
            key: "trimAlignValue",
            value: function trimAlignValue(value) {
                var _this$state2 = this.state, handle = _this$state2.handle, bounds = _this$state2.bounds;
                return $51730a1a5a927869$var$_trimAlignValue({
                    value: value,
                    handle: handle,
                    bounds: bounds,
                    props: this.props
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _this$state3 = this.state, handle = _this$state3.handle, bounds = _this$state3.bounds;
                var _this$props4 = this.props, prefixCls = _this$props4.prefixCls, vertical = _this$props4.vertical, included = _this$props4.included, disabled = _this$props4.disabled, min = _this$props4.min, max = _this$props4.max, reverse = _this$props4.reverse, handleGenerator = _this$props4.handle, trackStyle = _this$props4.trackStyle, handleStyle = _this$props4.handleStyle, tabIndex = _this$props4.tabIndex, ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles, ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles, ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
                var offsets = bounds.map(function(v) {
                    return _this4.calcOffset(v);
                });
                var handleClassName = "".concat(prefixCls, "-handle");
                var handles = bounds.map(function(v, i) {
                    var _classNames;
                    var mergedTabIndex = tabIndex[i] || 0;
                    if (disabled || tabIndex[i] === null) mergedTabIndex = null;
                    var dragging = handle === i;
                    return handleGenerator({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, handleClassName, true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
                        prefixCls: prefixCls,
                        vertical: vertical,
                        dragging: dragging,
                        offset: offsets[i],
                        value: v,
                        index: i,
                        tabIndex: mergedTabIndex,
                        min: min,
                        max: max,
                        reverse: reverse,
                        disabled: disabled,
                        style: handleStyle[i],
                        ref: function ref(h) {
                            return _this4.saveHandle(i, h);
                        },
                        ariaLabel: ariaLabelGroupForHandles[i],
                        ariaLabelledBy: ariaLabelledByGroupForHandles[i],
                        ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
                    });
                });
                var tracks = bounds.slice(0, -1).map(function(_, index) {
                    var _classNames2;
                    var i = index + 1;
                    var trackClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((_classNames2 = {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track"), true), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $f07294755a4ae8ec$export$2e2bcd8739ae039), {
                        className: trackClassName,
                        vertical: vertical,
                        reverse: reverse,
                        included: included,
                        offset: offsets[i - 1],
                        length: offsets[i] - offsets[i - 1],
                        style: trackStyle[index],
                        key: i
                    });
                });
                return {
                    tracks: tracks,
                    handles: handles
                };
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (!('value' in props || 'min' in props || 'max' in props)) return null;
                var value = props.value || state.bounds;
                var nextBounds = value.map(function(v, i) {
                    return $51730a1a5a927869$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        bounds: state.bounds,
                        props: props
                    });
                });
                if (state.bounds.length === nextBounds.length) {
                    if (nextBounds.every(function(v, i) {
                        return v === state.bounds[i];
                    })) return null;
                } else nextBounds = value.map(function(v, i) {
                    return $51730a1a5a927869$var$_trimAlignValue({
                        value: v,
                        handle: i,
                        props: props
                    });
                });
                return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, state), {}, {
                    bounds: nextBounds
                });
            }
        }
    ]);
    return Range;
}((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component);
/* eslint-enable */ $51730a1a5a927869$var$Range.displayName = 'Range';
$51730a1a5a927869$var$Range.defaultProps = {
    count: 1,
    allowCross: true,
    pushable: false,
    draggableTrack: false,
    tabIndex: [],
    ariaLabelGroupForHandles: [],
    ariaLabelledByGroupForHandles: [],
    ariaValueTextFormatterGroupForHandles: []
};
var $51730a1a5a927869$export$2e2bcd8739ae039 = (0, $8d0aebb38e624949$export$2e2bcd8739ae039)($51730a1a5a927869$var$Range);












var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");





var $dup7A = parcelRequire("dup7A");









var $dup7A = parcelRequire("dup7A");

var $5ae5867a877ffabb$var$raf = function raf(callback) {
    return +setTimeout(callback, 16);
};
var $5ae5867a877ffabb$var$caf = function caf(num) {
    return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    $5ae5867a877ffabb$var$raf = function raf(callback) {
        return window.requestAnimationFrame(callback);
    };
    $5ae5867a877ffabb$var$caf = function caf(handle) {
        return window.cancelAnimationFrame(handle);
    };
}
var $5ae5867a877ffabb$var$rafUUID = 0;
var $5ae5867a877ffabb$var$rafIds = new Map();
function $5ae5867a877ffabb$var$cleanup(id) {
    $5ae5867a877ffabb$var$rafIds.delete(id);
}
var $5ae5867a877ffabb$var$wrapperRaf = function wrapperRaf(callback) {
    var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    $5ae5867a877ffabb$var$rafUUID += 1;
    var id = $5ae5867a877ffabb$var$rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            $5ae5867a877ffabb$var$cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            var realId = $5ae5867a877ffabb$var$raf(function() {
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            $5ae5867a877ffabb$var$rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
$5ae5867a877ffabb$var$wrapperRaf.cancel = function(id) {
    var realId = $5ae5867a877ffabb$var$rafIds.get(id);
    $5ae5867a877ffabb$var$cleanup(id);
    return $5ae5867a877ffabb$var$caf(realId);
};
var $5ae5867a877ffabb$export$2e2bcd8739ae039 = $5ae5867a877ffabb$var$wrapperRaf;


function $01802a99afaa475f$export$2e2bcd8739ae039(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    var node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}




var $dup7A = parcelRequire("dup7A");

function $0b6fbe60488ddcee$export$41e30d8dd0ba7a50(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function $0b6fbe60488ddcee$export$9aa546fdc20ae5b3(node) {
    if (node && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(node) === 'object' && $0b6fbe60488ddcee$export$41e30d8dd0ba7a50(node.nativeElement)) return node.nativeElement;
    if ($0b6fbe60488ddcee$export$41e30d8dd0ba7a50(node)) return node;
    return null;
}
function $0b6fbe60488ddcee$export$2e2bcd8739ae039(node) {
    var domNode = $0b6fbe60488ddcee$export$9aa546fdc20ae5b3(node);
    if (domNode) return domNode;
    if (node instanceof (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component) {
        var _ReactDOM$findDOMNode;
        return (_ReactDOM$findDOMNode = (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode) === null || _ReactDOM$findDOMNode === void 0 ? void 0 : _ReactDOM$findDOMNode.call((0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))), node);
    }
    return null;
}




var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
function $b1fb345e1a36d9ef$export$2e2bcd8739ae039(getValue, condition, shouldUpdate) {
    var cacheRef = $dup7A.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}



var $60ce54fdf0be5eb8$var$REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
var $60ce54fdf0be5eb8$var$REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
var $60ce54fdf0be5eb8$var$REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function $60ce54fdf0be5eb8$export$2e2bcd8739ae039(object) {
    return(// Base object type
    object && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(object) === 'object' && // React Element type
    (object.$$typeof === $60ce54fdf0be5eb8$var$REACT_ELEMENT_TYPE_18 || object.$$typeof === $60ce54fdf0be5eb8$var$REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === $60ce54fdf0be5eb8$var$REACT_FRAGMENT_TYPE);
}


var $c8cde685aa40b754$var$ReactMajorVersion = Number((0, $dup7A.version).split('.')[0]);
var $c8cde685aa40b754$export$f17fd18fa51dcb5b = function fillRef(ref, node) {
    if (typeof ref === 'function') ref(node);
    else if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(ref) === 'object' && ref && 'current' in ref) ref.current = node;
};
var $c8cde685aa40b754$export$ab452c34e8e05029 = function composeRef() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    var refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return function(node) {
        refs.forEach(function(ref) {
            $c8cde685aa40b754$export$f17fd18fa51dcb5b(ref, node);
        });
    };
};
var $c8cde685aa40b754$export$1d1c999670a1285d = function useComposeRef() {
    for(var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)refs[_key2] = arguments[_key2];
    return (0, $b1fb345e1a36d9ef$export$2e2bcd8739ae039)(function() {
        return $c8cde685aa40b754$export$ab452c34e8e05029.apply(void 0, refs);
    }, refs, function(prev, next) {
        return prev.length !== next.length || prev.every(function(ref, i) {
            return ref !== next[i];
        });
    });
};
var $c8cde685aa40b754$export$c1cec34af06bcf7 = function supportRef(nodeOrComponent) {
    var _type$prototype, _nodeOrComponent$prot;
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if ($c8cde685aa40b754$var$isReactElement(nodeOrComponent) && $c8cde685aa40b754$var$ReactMajorVersion >= 19) return true;
    var type = (0, $631d850cd54a09cf$exports.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !((_type$prototype = type.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render) && type.$$typeof !== (0, $631d850cd54a09cf$exports.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render) && nodeOrComponent.$$typeof !== (0, $631d850cd54a09cf$exports.ForwardRef)) return false;
    return true;
};
function $c8cde685aa40b754$var$isReactElement(node) {
    return /*#__PURE__*/ (0, $dup7A.isValidElement)(node) && !(0, $60ce54fdf0be5eb8$export$2e2bcd8739ae039)(node);
}
var $c8cde685aa40b754$export$b51ae67c7882a242 = function supportNodeRef(node) {
    return $c8cde685aa40b754$var$isReactElement(node) && $c8cde685aa40b754$export$c1cec34af06bcf7(node);
};
var $c8cde685aa40b754$export$7465e5c0bf44f19a = function getNodeRef(node) {
    if (node && $c8cde685aa40b754$var$isReactElement(node)) {
        var ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};




var $dup7A = parcelRequire("dup7A");

function $f3764e1170c3ee8f$export$2e2bcd8739ae039() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}


var $8397b35ed6f4f5c4$var$Portal = /*#__PURE__*/ (0, $dup7A.forwardRef)(function(props, ref) {
    var didUpdate = props.didUpdate, getContainer = props.getContainer, children = props.children;
    var parentRef = (0, $dup7A.useRef)();
    var containerRef = (0, $dup7A.useRef)();
    // Ref return nothing, only for wrapper check exist
    (0, $dup7A.useImperativeHandle)(ref, function() {
        return {};
    });
    // Create container in client side with sync to avoid useEffect not get ref
    var initRef = (0, $dup7A.useRef)(false);
    if (!initRef.current && (0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
    }
    // [Legacy] Used by `rc-trigger`
    (0, $dup7A.useEffect)(function() {
        didUpdate === null || didUpdate === void 0 || didUpdate(props);
    });
    (0, $dup7A.useEffect)(function() {
        // Restore container to original place
        // React 18 StrictMode will unmount first and mount back for effect test:
        // https://reactjs.org/blog/2022/03/29/react-v18.html#new-strict-mode-behaviors
        if (containerRef.current.parentNode === null && parentRef.current !== null) parentRef.current.appendChild(containerRef.current);
        return function() {
            var _containerRef$current;
            // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
            // Since some component use `Portal` directly, we have to keep the logic here.
            (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || (_containerRef$current = _containerRef$current.parentNode) === null || _containerRef$current === void 0 || _containerRef$current.removeChild(containerRef.current);
        };
    }, []);
    return containerRef.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).createPortal(children, containerRef.current) : null;
});
var $8397b35ed6f4f5c4$export$2e2bcd8739ae039 = $8397b35ed6f4f5c4$var$Portal;




function $a0e16b2c473f8d53$var$isPointsEq(a1, a2, isAlignPoint) {
    if (isAlignPoint) return a1[0] === a2[0];
    return a1[0] === a2[0] && a1[1] === a2[1];
}
function $a0e16b2c473f8d53$export$44605b74f7c5d944(builtinPlacements, placementStr, align) {
    var baseAlign = builtinPlacements[placementStr] || {};
    return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, baseAlign), align);
}
function $a0e16b2c473f8d53$export$faa0aa8ed2fe6432(builtinPlacements, prefixCls, align, isAlignPoint) {
    var points = align.points;
    var placements = Object.keys(builtinPlacements);
    for(var i = 0; i < placements.length; i += 1){
        var placement = placements[i];
        if ($a0e16b2c473f8d53$var$isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) return "".concat(prefixCls, "-placement-").concat(placement);
    }
    return '';
}




function $48106157825ba7ff$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $db1311aef62f1ccf$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



function $e9de5687f3ef30e0$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $e3c5c95746af2d29$export$2e2bcd8739ae039(r, e) {
    return (0, $48106157825ba7ff$export$2e2bcd8739ae039)(r) || (0, $db1311aef62f1ccf$export$2e2bcd8739ae039)(r, e) || (0, $89db58488ac3ca79$export$2e2bcd8739ae039)(r, e) || (0, $e9de5687f3ef30e0$export$2e2bcd8739ae039)();
}




var $dup7A = parcelRequire("dup7A");
var $cee396e5c47a9a3c$export$2e2bcd8739ae039 = function() {
    if (typeof navigator === 'undefined' || typeof window === 'undefined') return false;
    var agent = navigator.userAgent || navigator.vendor || window.opera;
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};





var $dup7A = parcelRequire("dup7A");









var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
var $f60a304f067cf82f$var$_excluded = [
    "children"
];
var $f60a304f067cf82f$export$841858b892ce1f4c = /*#__PURE__*/ $dup7A.createContext({});
function $f60a304f067cf82f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, props = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref, $f60a304f067cf82f$var$_excluded);
    return /*#__PURE__*/ $dup7A.createElement($f60a304f067cf82f$export$841858b892ce1f4c.Provider, {
        value: props
    }, children);
}







var $dup7A = parcelRequire("dup7A");
var $eeeff6bdc66797b8$var$DomWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $080b772b018ceec5$export$2e2bcd8739ae039)(DomWrapper, _React$Component);
    var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(DomWrapper);
    function DomWrapper() {
        (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, DomWrapper);
        return _super.apply(this, arguments);
    }
    (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(DomWrapper, [
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return DomWrapper;
}($dup7A.Component);
var $eeeff6bdc66797b8$export$2e2bcd8739ae039 = $eeeff6bdc66797b8$var$DomWrapper;






var $dup7A = parcelRequire("dup7A");
function $bc9b758b429e8edd$export$2e2bcd8739ae039(callback) {
    var fnRef = $dup7A.useRef();
    fnRef.current = callback;
    var memoFn = $dup7A.useCallback(function() {
        var _fnRef$current;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [
            fnRef
        ].concat(args));
    }, []);
    return memoFn;
}





var $dup7A = parcelRequire("dup7A");

/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ var $37eabd4bcc9d6b73$var$useInternalLayoutEffect = (0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)() ? $dup7A.useLayoutEffect : $dup7A.useEffect;
var $37eabd4bcc9d6b73$var$useLayoutEffect = function useLayoutEffect(callback, deps) {
    var firstMountRef = $dup7A.useRef(true);
    $37eabd4bcc9d6b73$var$useInternalLayoutEffect(function() {
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    $37eabd4bcc9d6b73$var$useInternalLayoutEffect(function() {
        firstMountRef.current = false;
        return function() {
            firstMountRef.current = true;
        };
    }, []);
};
var $37eabd4bcc9d6b73$export$9283e56bae2f7b0f = function useLayoutUpdateEffect(callback, deps) {
    $37eabd4bcc9d6b73$var$useLayoutEffect(function(firstMount) {
        if (!firstMount) return callback();
    }, deps);
};
var $37eabd4bcc9d6b73$export$2e2bcd8739ae039 = $37eabd4bcc9d6b73$var$useLayoutEffect;




var $dup7A = parcelRequire("dup7A");
function $c8504fa916dc6fc0$export$2e2bcd8739ae039(defaultValue) {
    var destroyRef = $dup7A.useRef(false);
    var _React$useState = $dup7A.useState(defaultValue), _React$useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
    $dup7A.useEffect(function() {
        destroyRef.current = false;
        return function() {
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}


/** We only think `undefined` is empty */ function $69c6dc4bde0935d9$var$hasValue(value) {
    return value !== undefined;
}
function $69c6dc4bde0935d9$export$2e2bcd8739ae039(defaultStateValue, option) {
    var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
    // ======================= Init =======================
    var _useState = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)(function() {
        if ($69c6dc4bde0935d9$var$hasValue(value)) return value;
        else if ($69c6dc4bde0935d9$var$hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    }), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
    var mergedValue = value !== undefined ? value : innerValue;
    var postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    var onChangeFn = (0, $bc9b758b429e8edd$export$2e2bcd8739ae039)(onChange);
    var _useState3 = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)([
        mergedValue
    ]), _useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
    (0, $37eabd4bcc9d6b73$export$9283e56bae2f7b0f)(function() {
        var prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, $37eabd4bcc9d6b73$export$9283e56bae2f7b0f)(function() {
        if (!$69c6dc4bde0935d9$var$hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    var triggerChange = (0, $bc9b758b429e8edd$export$2e2bcd8739ae039)(function(updater, ignoreDestroy) {
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}



function $d6ddd26696f4af67$export$2e2bcd8739ae039(entity, path) {
    var current = entity;
    for(var i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}









function $a2e83db50ec6252a$export$2e2bcd8739ae039(r) {
    return (0, $48106157825ba7ff$export$2e2bcd8739ae039)(r) || (0, $435b24fe7d07ab67$export$2e2bcd8739ae039)(r) || (0, $89db58488ac3ca79$export$2e2bcd8739ae039)(r) || (0, $e9de5687f3ef30e0$export$2e2bcd8739ae039)();
}



function $230d8433a434e48e$var$internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    var _paths = (0, $a2e83db50ec6252a$export$2e2bcd8739ae039)(paths), path = _paths[0], restPath = _paths.slice(1);
    var clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = (0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(entity);
    else clone = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, entity);
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = $230d8433a434e48e$var$internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function $230d8433a434e48e$export$2e2bcd8739ae039(entity, paths, value) {
    var removeIfUndefined = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, $d6ddd26696f4af67$export$2e2bcd8739ae039)(entity, paths.slice(0, -1))) return entity;
    return $230d8433a434e48e$var$internalSet(entity, paths, value, removeIfUndefined);
}
function $230d8433a434e48e$var$isObject(obj) {
    return (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(obj) === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function $230d8433a434e48e$var$createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
var $230d8433a434e48e$var$keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function $230d8433a434e48e$export$4950aa0f605343fb() {
    for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
    var clone = $230d8433a434e48e$var$createEmpty(sources[0]);
    sources.forEach(function(src) {
        function internalMerge(path, parentLoopSet) {
            var loopSet = new Set(parentLoopSet);
            var value = (0, $d6ddd26696f4af67$export$2e2bcd8739ae039)(src, path);
            var isArr = Array.isArray(value);
            if (isArr || $230d8433a434e48e$var$isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    var originValue = (0, $d6ddd26696f4af67$export$2e2bcd8739ae039)(clone, path);
                    if (isArr) // Array will always be override
                    clone = $230d8433a434e48e$export$2e2bcd8739ae039(clone, path, []);
                    else if (!originValue || (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(originValue) !== 'object') // Init container if not exist
                    clone = $230d8433a434e48e$export$2e2bcd8739ae039(clone, path, $230d8433a434e48e$var$createEmpty(value));
                    $230d8433a434e48e$var$keys(value).forEach(function(key) {
                        internalMerge([].concat((0, $39333a40da2a8fa5$export$2e2bcd8739ae039)(path), [
                            key
                        ]), loopSet);
                    });
                }
            } else clone = $230d8433a434e48e$export$2e2bcd8739ae039(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}








var $dup7A = parcelRequire("dup7A");

function $4372cb7ef7d3f0c4$export$2e2bcd8739ae039(defaultValue) {
    var _React$useReducer = $dup7A.useReducer(function(x) {
        return x + 1;
    }, 0), _React$useReducer2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useReducer, 2), forceUpdate = _React$useReducer2[1];
    var currentValueRef = $dup7A.useRef(defaultValue);
    var getValue = (0, $bc9b758b429e8edd$export$2e2bcd8739ae039)(function() {
        return currentValueRef.current;
    });
    var setValue = (0, $bc9b758b429e8edd$export$2e2bcd8739ae039)(function(updater) {
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}



var $dup7A = parcelRequire("dup7A");
var $7b9ba249efe2d2c5$export$de71442bbf2143da = 'none';
var $7b9ba249efe2d2c5$export$4fc3521687bcacd2 = 'appear';
var $7b9ba249efe2d2c5$export$5d6af549241fe2e8 = 'enter';
var $7b9ba249efe2d2c5$export$59b1c493d29f68e4 = 'leave';
var $7b9ba249efe2d2c5$export$40b34dd77d5522bf = 'none';
var $7b9ba249efe2d2c5$export$1b792916a5fac4fc = 'prepare';
var $7b9ba249efe2d2c5$export$9563153dd25a3ce8 = 'start';
var $7b9ba249efe2d2c5$export$e205886172277ec6 = 'active';
var $7b9ba249efe2d2c5$export$3a846c3d2fac10b8 = 'end';
var $7b9ba249efe2d2c5$export$98351fa4e6b4f204 = 'prepared';



var $dup7A = parcelRequire("dup7A");


// ================= Transition =================
// Event wrapper. Copy from react source code
function $357e98e4510c7b52$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
    prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
    prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
    prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
    return prefixes;
}
function $357e98e4510c7b52$export$6e8b350b1a8958a0(domSupport, win) {
    var prefixes = {
        animationend: $357e98e4510c7b52$var$makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: $357e98e4510c7b52$var$makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
var $357e98e4510c7b52$var$vendorPrefixes = $357e98e4510c7b52$export$6e8b350b1a8958a0((0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)(), typeof window !== 'undefined' ? window : {});
var $357e98e4510c7b52$var$style = {};
if ((0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)()) {
    var $357e98e4510c7b52$var$_document$createEleme = document.createElement('div');
    $357e98e4510c7b52$var$style = $357e98e4510c7b52$var$_document$createEleme.style;
}
var $357e98e4510c7b52$var$prefixedEventNames = {};
function $357e98e4510c7b52$export$a032e4f39350c1d8(eventName) {
    if ($357e98e4510c7b52$var$prefixedEventNames[eventName]) return $357e98e4510c7b52$var$prefixedEventNames[eventName];
    var prefixMap = $357e98e4510c7b52$var$vendorPrefixes[eventName];
    if (prefixMap) {
        var stylePropList = Object.keys(prefixMap);
        var len = stylePropList.length;
        for(var i = 0; i < len; i += 1){
            var styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in $357e98e4510c7b52$var$style) {
                $357e98e4510c7b52$var$prefixedEventNames[eventName] = prefixMap[styleProp];
                return $357e98e4510c7b52$var$prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
var $357e98e4510c7b52$var$internalAnimationEndName = $357e98e4510c7b52$export$a032e4f39350c1d8('animationend');
var $357e98e4510c7b52$var$internalTransitionEndName = $357e98e4510c7b52$export$a032e4f39350c1d8('transitionend');
var $357e98e4510c7b52$export$d28133ed3ad06c8b = !!($357e98e4510c7b52$var$internalAnimationEndName && $357e98e4510c7b52$var$internalTransitionEndName);
var $357e98e4510c7b52$export$760cc9769c51b738 = $357e98e4510c7b52$var$internalAnimationEndName || 'animationend';
var $357e98e4510c7b52$export$44baea64b8602e3c = $357e98e4510c7b52$var$internalTransitionEndName || 'transitionend';
function $357e98e4510c7b52$export$27c72201b1d09951(transitionName, transitionType) {
    if (!transitionName) return null;
    if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(transitionName) === 'object') {
        var type = transitionType.replace(/-\w/g, function(match) {
            return match[1].toUpperCase();
        });
        return transitionName[type];
    }
    return "".concat(transitionName, "-").concat(transitionType);
}


var $6ced532c298b0866$export$2e2bcd8739ae039 = function(onInternalMotionEnd) {
    var cacheElementRef = (0, $dup7A.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, $357e98e4510c7b52$export$44baea64b8602e3c), onInternalMotionEnd);
            element.removeEventListener((0, $357e98e4510c7b52$export$760cc9769c51b738), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, $357e98e4510c7b52$export$44baea64b8602e3c), onInternalMotionEnd);
            element.addEventListener((0, $357e98e4510c7b52$export$760cc9769c51b738), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    $dup7A.useEffect(function() {
        return function() {
            removeMotionEvents(cacheElementRef.current);
        };
    }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};




var $dup7A = parcelRequire("dup7A");
// It's safe to use `useLayoutEffect` but the warning is annoying
var $ab571af64fd4c066$var$useIsomorphicLayoutEffect = (0, $f3764e1170c3ee8f$export$2e2bcd8739ae039)() ? (0, $dup7A.useLayoutEffect) : (0, $dup7A.useEffect);
var $ab571af64fd4c066$export$2e2bcd8739ae039 = $ab571af64fd4c066$var$useIsomorphicLayoutEffect;





var $dup7A = parcelRequire("dup7A");




var $dup7A = parcelRequire("dup7A");
var $dcc27c519e09e68d$export$2e2bcd8739ae039 = function() {
    var nextFrameRef = $dup7A.useRef(null);
    function cancelNextFrame() {
        (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(nextFrameRef.current);
    }
    function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
            if (delay <= 1) callback({
                isCanceled: function isCanceled() {
                    return nextFrameId !== nextFrameRef.current;
                }
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    $dup7A.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};


var $c5db92e7a7f3a512$var$FULL_STEP_QUEUE = [
    (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc),
    (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8),
    (0, $7b9ba249efe2d2c5$export$e205886172277ec6),
    (0, $7b9ba249efe2d2c5$export$3a846c3d2fac10b8)
];
var $c5db92e7a7f3a512$var$SIMPLE_STEP_QUEUE = [
    (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc),
    (0, $7b9ba249efe2d2c5$export$98351fa4e6b4f204)
];
var $c5db92e7a7f3a512$export$c2029bf6cfdbc28a = false;
var $c5db92e7a7f3a512$export$dbee1e282e8c4830 = true;
function $c5db92e7a7f3a512$export$39e04e72f972b885(step) {
    return step === (0, $7b9ba249efe2d2c5$export$e205886172277ec6) || step === (0, $7b9ba249efe2d2c5$export$3a846c3d2fac10b8);
}
var $c5db92e7a7f3a512$export$2e2bcd8739ae039 = function(status, prepareOnly, callback) {
    var _useState = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)((0, $7b9ba249efe2d2c5$export$40b34dd77d5522bf)), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), step = _useState2[0], setStep = _useState2[1];
    var _useNextFrame = (0, $dcc27c519e09e68d$export$2e2bcd8739ae039)(), _useNextFrame2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
    function startQueue() {
        setStep((0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), true);
    }
    var STEP_QUEUE = prepareOnly ? $c5db92e7a7f3a512$var$SIMPLE_STEP_QUEUE : $c5db92e7a7f3a512$var$FULL_STEP_QUEUE;
    (0, $ab571af64fd4c066$export$2e2bcd8739ae039)(function() {
        if (step !== (0, $7b9ba249efe2d2c5$export$40b34dd77d5522bf) && step !== (0, $7b9ba249efe2d2c5$export$3a846c3d2fac10b8)) {
            var index = STEP_QUEUE.indexOf(step);
            var nextStep = STEP_QUEUE[index + 1];
            var result = callback(step);
            if (result === $c5db92e7a7f3a512$export$c2029bf6cfdbc28a) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame(function(info) {
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    $dup7A.useEffect(function() {
        return function() {
            cancelNextFrame();
        };
    }, []);
    return [
        startQueue,
        step
    ];
};


function $0cc9b6c52f2ef3d8$export$2e2bcd8739ae039(supportMotion, visible, getElement, _ref) {
    var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    var _useState = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)(), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
    var _useSyncState = (0, $4372cb7ef7d3f0c4$export$2e2bcd8739ae039)((0, $7b9ba249efe2d2c5$export$de71442bbf2143da)), _useSyncState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useSyncState, 2), getStatus = _useSyncState2[0], setStatus = _useSyncState2[1];
    var _useState3 = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)(null), _useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState3, 2), style = _useState4[0], setStyle = _useState4[1];
    var currentStatus = getStatus();
    var mountedRef = (0, $dup7A.useRef)(false);
    var deadlineRef = (0, $dup7A.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    var activeRef = (0, $dup7A.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, $7b9ba249efe2d2c5$export$de71442bbf2143da));
        setStyle(null, true);
    }
    var onInternalMotionEnd = (0, $bc9b758b429e8edd$export$2e2bcd8739ae039)(function(event) {
        var status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, $7b9ba249efe2d2c5$export$de71442bbf2143da)) return;
        var element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        var currentActive = activeRef.current;
        var canEnd;
        if (status === (0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2) && currentActive) canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
        else if (status === (0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8) && currentActive) canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
        else if (status === (0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4) && currentActive) canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    var _useDomMotionEvents = (0, $6ced532c298b0866$export$2e2bcd8739ae039)(onInternalMotionEnd), _useDomMotionEvents2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
    // ============================= Step =============================
    var getEventHandlers = function getEventHandlers(targetStatus) {
        switch(targetStatus){
            case 0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2:
                return (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), onAppearPrepare), (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8), onAppearStart), (0, $7b9ba249efe2d2c5$export$e205886172277ec6), onAppearActive);
            case 0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8:
                return (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), onEnterPrepare), (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8), onEnterStart), (0, $7b9ba249efe2d2c5$export$e205886172277ec6), onEnterActive);
            case 0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4:
                return (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc), onLeavePrepare), (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8), onLeaveStart), (0, $7b9ba249efe2d2c5$export$e205886172277ec6), onLeaveActive);
            default:
                return {};
        }
    };
    var eventHandlers = $dup7A.useMemo(function() {
        return getEventHandlers(currentStatus);
    }, [
        currentStatus
    ]);
    var _useStepQueue = (0, $c5db92e7a7f3a512$export$2e2bcd8739ae039)(currentStatus, !supportMotion, function(newStep) {
        // Only prepare step can be skip
        if (newStep === (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc)) {
            var onPrepare = eventHandlers[0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc];
            if (!onPrepare) return 0, $c5db92e7a7f3a512$export$c2029bf6cfdbc28a;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) {
            var _eventHandlers$step;
            setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
        }
        if (step === (0, $7b9ba249efe2d2c5$export$e205886172277ec6) && currentStatus !== (0, $7b9ba249efe2d2c5$export$de71442bbf2143da)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(function() {
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, $7b9ba249efe2d2c5$export$98351fa4e6b4f204)) updateMotionEndStatus();
        return 0, $c5db92e7a7f3a512$export$dbee1e282e8c4830;
    }), _useStepQueue2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
    var active = (0, $c5db92e7a7f3a512$export$39e04e72f972b885)(step);
    activeRef.current = active;
    // ============================ Status ============================
    var visibleRef = (0, $dup7A.useRef)(null);
    // Update with new status
    (0, $ab571af64fd4c066$export$2e2bcd8739ae039)(function() {
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        var isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        var nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4);
        var nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, $7b9ba249efe2d2c5$export$de71442bbf2143da));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, $dup7A.useEffect)(function() {
        if (// Cancel appear
        currentStatus === (0, $7b9ba249efe2d2c5$export$4fc3521687bcacd2) && !motionAppear || // Cancel enter
        currentStatus === (0, $7b9ba249efe2d2c5$export$5d6af549241fe2e8) && !motionEnter || // Cancel leave
        currentStatus === (0, $7b9ba249efe2d2c5$export$59b1c493d29f68e4) && !motionLeave) setStatus((0, $7b9ba249efe2d2c5$export$de71442bbf2143da));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, $dup7A.useEffect)(function() {
        return function() {
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        };
    }, []);
    // Trigger `onVisibleChanged`
    var firstMountChangeRef = $dup7A.useRef(false);
    (0, $dup7A.useEffect)(function() {
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, $7b9ba249efe2d2c5$export$de71442bbf2143da)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged === null || onVisibleChanged === void 0 || onVisibleChanged(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    var mergedStyle = style;
    if (eventHandlers[0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc] && step === (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8)) mergedStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({
        transition: 'none'
    }, mergedStyle);
    return [
        currentStatus,
        step,
        mergedStyle,
        asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible
    ];
}





function $ab4f312c3fa5df88$export$e265d52a86a9f199(config) {
    var transitionSupport = config;
    if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(config) === 'object') transitionSupport = config.transitionSupport;
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    var CSSMotion = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
        var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
        var _React$useContext = $dup7A.useContext((0, $f60a304f067cf82f$export$841858b892ce1f4c)), contextMotion = _React$useContext.motion;
        var supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        var nodeRef = (0, $dup7A.useRef)();
        // Ref to the dom wrapper in case ref can not pass to HTMLElement
        var wrapperNodeRef = (0, $dup7A.useRef)();
        function getDomElement() {
            try {
                // Here we're avoiding call for findDOMNode since it's deprecated
                // in strict mode. We're calling it only when node ref is not
                // an instance of DOM HTMLElement. Otherwise use
                // findDOMNode as a final resort
                return nodeRef.current instanceof HTMLElement ? nodeRef.current : (0, $0b6fbe60488ddcee$export$2e2bcd8739ae039)(wrapperNodeRef.current);
            } catch (e) {
                // Only happen when `motionDeadline` trigger but element removed.
                return null;
            }
        }
        var _useStatus = (0, $0cc9b6c52f2ef3d8$export$2e2bcd8739ae039)(supportMotion, visible, getDomElement, props), _useStatus2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        var renderedRef = $dup7A.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        var setNodeRef = $dup7A.useCallback(function(node) {
            nodeRef.current = node;
            (0, $c8cde685aa40b754$export$f17fd18fa51dcb5b)(ref, node);
        }, [
            ref
        ]);
        // ===================== Render =====================
        var motionChildren;
        var mergedProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, eventProps), {}, {
            visible: visible
        });
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, $7b9ba249efe2d2c5$export$de71442bbf2143da)) {
            // Stable children
            if (mergedVisible) motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), setNodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: leavedClassName
            }), setNodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                style: {
                    display: 'none'
                }
            }), setNodeRef);
            else motionChildren = null;
        } else {
            // In motion
            var statusSuffix;
            if (statusStep === (0, $7b9ba249efe2d2c5$export$1b792916a5fac4fc)) statusSuffix = 'prepare';
            else if ((0, $c5db92e7a7f3a512$export$39e04e72f972b885)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, $7b9ba249efe2d2c5$export$9563153dd25a3ce8)) statusSuffix = 'start';
            var motionCls = (0, $357e98e4510c7b52$export$27c72201b1d09951)(motionName, "".concat(status, "-").concat(statusSuffix));
            motionChildren = children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, mergedProps), {}, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))((0, $357e98e4510c7b52$export$27c72201b1d09951)(motionName, status), (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, motionCls, motionCls && statusSuffix), motionName, typeof motionName === 'string')),
                style: statusStyle
            }), setNodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ $dup7A.isValidElement(motionChildren) && (0, $c8cde685aa40b754$export$c1cec34af06bcf7)(motionChildren)) {
            var originNodeRef = (0, $c8cde685aa40b754$export$7465e5c0bf44f19a)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ $dup7A.cloneElement(motionChildren, {
                ref: setNodeRef
            });
        }
        return /*#__PURE__*/ $dup7A.createElement((0, $eeeff6bdc66797b8$export$2e2bcd8739ae039), {
            ref: wrapperNodeRef
        }, motionChildren);
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
var $ab4f312c3fa5df88$export$2e2bcd8739ae039 = $ab4f312c3fa5df88$export$e265d52a86a9f199((0, $357e98e4510c7b52$export$d28133ed3ad06c8b));












var $dup7A = parcelRequire("dup7A");



var $f9cdc5c4cd9c3519$export$3904baa009bc026e = 'add';
var $f9cdc5c4cd9c3519$export$851162f0adad2cbc = 'keep';
var $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85 = 'remove';
var $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a = 'removed';
function $f9cdc5c4cd9c3519$export$c47fd798e598c85c(key) {
    var keyObj;
    if (key && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(key) === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, keyObj), {}, {
        key: String(keyObj.key)
    });
}
function $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72() {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return keys.map($f9cdc5c4cd9c3519$export$c47fd798e598c85c);
}
function $f9cdc5c4cd9c3519$export$14527669107aa301() {
    var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var list = [];
    var currentIndex = 0;
    var currentLen = currentKeys.length;
    var prevKeyObjects = $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72(prevKeys);
    var currentKeyObjects = $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach(function(keyObj) {
        var hit = false;
        for(var i = currentIndex; i < currentLen; i += 1){
            var currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
                        return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, obj), {}, {
                            status: $f9cdc5c4cd9c3519$export$3904baa009bc026e
                        });
                    }));
                    currentIndex = i;
                }
                list.push((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, currentKeyObj), {}, {
                    status: $f9cdc5c4cd9c3519$export$851162f0adad2cbc
                }));
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, keyObj), {}, {
            status: $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85
        }));
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
        return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, obj), {}, {
            status: $f9cdc5c4cd9c3519$export$3904baa009bc026e
        });
    }));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ var keys = {};
    list.forEach(function(_ref) {
        var key = _ref.key;
        keys[key] = (keys[key] || 0) + 1;
    });
    var duplicatedKeys = Object.keys(keys).filter(function(key) {
        return keys[key] > 1;
    });
    duplicatedKeys.forEach(function(matchKey) {
        // Remove `STATUS_REMOVE` node.
        list = list.filter(function(_ref2) {
            var key = _ref2.key, status = _ref2.status;
            return key !== matchKey || status !== $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85;
        });
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach(function(node) {
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = $f9cdc5c4cd9c3519$export$851162f0adad2cbc;
        });
    });
    return list;
}



var $73722d854feea6a1$var$_excluded = [
    "component",
    "children",
    "onVisibleChanged",
    "onAllRemoved"
], $73722d854feea6a1$var$_excluded2 = [
    "status"
];
var $73722d854feea6a1$var$MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function $73722d854feea6a1$export$fcfc62c1d33d5e2e(transitionSupport) {
    var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $ab4f312c3fa5df88$export$2e2bcd8739ae039);
    var CSSMotionList = /*#__PURE__*/ function(_React$Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(CSSMotionList, _React$Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(CSSMotionList);
        function CSSMotionList() {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, CSSMotionList);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "state", {
                keyEntities: []
            });
            // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "removeKey", function(removeKey) {
                _this.setState(function(prevState) {
                    var nextKeyEntities = prevState.keyEntities.map(function(entity) {
                        if (entity.key !== removeKey) return entity;
                        return (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, entity), {}, {
                            status: (0, $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a)
                        });
                    });
                    return {
                        keyEntities: nextKeyEntities
                    };
                }, function() {
                    var keyEntities = _this.state.keyEntities;
                    var restKeysCount = keyEntities.filter(function(_ref) {
                        var status = _ref.status;
                        return status !== (0, $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a);
                    }).length;
                    if (restKeysCount === 0 && _this.props.onAllRemoved) _this.props.onAllRemoved();
                });
            });
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(CSSMotionList, [
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var keyEntities = this.state.keyEntities;
                    var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_this$props, $73722d854feea6a1$var$_excluded);
                    var Component = component || $dup7A.Fragment;
                    var motionProps = {};
                    $73722d854feea6a1$var$MOTION_PROP_NAMES.forEach(function(prop) {
                        motionProps[prop] = restProps[prop];
                        delete restProps[prop];
                    });
                    delete restProps.keys;
                    return /*#__PURE__*/ $dup7A.createElement(Component, restProps, keyEntities.map(function(_ref2, index) {
                        var status = _ref2.status, eventProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref2, $73722d854feea6a1$var$_excluded2);
                        var visible = status === (0, $f9cdc5c4cd9c3519$export$3904baa009bc026e) || status === (0, $f9cdc5c4cd9c3519$export$851162f0adad2cbc);
                        return /*#__PURE__*/ $dup7A.createElement(CSSMotion, (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, motionProps, {
                            key: eventProps.key,
                            visible: visible,
                            eventProps: eventProps,
                            onVisibleChanged: function onVisibleChanged(changedVisible) {
                                _onVisibleChanged === null || _onVisibleChanged === void 0 || _onVisibleChanged(changedVisible, {
                                    key: eventProps.key
                                });
                                if (!changedVisible) _this2.removeKey(eventProps.key);
                            }
                        }), function(props, ref) {
                            return children((0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, props), {}, {
                                index: index
                            }), ref);
                        });
                    }));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref3, _ref4) {
                    var keys = _ref3.keys;
                    var keyEntities = _ref4.keyEntities;
                    var parsedKeyObjects = (0, $f9cdc5c4cd9c3519$export$84bd7bd42ccc0f72)(keys);
                    var mixedKeyEntities = (0, $f9cdc5c4cd9c3519$export$14527669107aa301)(keyEntities, parsedKeyObjects);
                    return {
                        keyEntities: mixedKeyEntities.filter(function(entity) {
                            var prevEntity = keyEntities.find(function(_ref5) {
                                var key = _ref5.key;
                                return entity.key === key;
                            });
                            // Remove if already mark as removed
                            if (prevEntity && prevEntity.status === (0, $f9cdc5c4cd9c3519$export$2ac1bd1808d2e43a) && entity.status === (0, $f9cdc5c4cd9c3519$export$c8b3fb08b68cfc85)) return false;
                            return true;
                        })
                    };
                }
            }
        ]);
        return CSSMotionList;
    }($dup7A.Component);
    (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(CSSMotionList, "defaultProps", {
        component: 'div'
    });
    return CSSMotionList;
}
var $73722d854feea6a1$export$2e2bcd8739ae039 = $73722d854feea6a1$export$fcfc62c1d33d5e2e((0, $357e98e4510c7b52$export$d28133ed3ad06c8b));



var $e2f8ecce9d0083b7$export$2e2bcd8739ae039 = (0, $ab4f312c3fa5df88$export$2e2bcd8739ae039);


function $19b9bb9355821eae$export$7b8936ddc277a29a(_ref) {
    var prefixCls = _ref.prefixCls, motion = _ref.motion, animation = _ref.animation, transitionName = _ref.transitionName;
    if (motion) return motion;
    if (animation) return {
        motionName: "".concat(prefixCls, "-").concat(animation)
    };
    if (transitionName) return {
        motionName: transitionName
    };
    return null;
}


function $f81d310fac5ffb12$export$2e2bcd8739ae039(props) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, mask = props.mask, maskMotion = props.maskMotion, maskAnimation = props.maskAnimation, maskTransitionName = props.maskTransitionName;
    if (!mask) return null;
    var motion = {};
    if (maskMotion || maskTransitionName || maskAnimation) motion = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({
        motionAppear: true
    }, (0, $19b9bb9355821eae$export$7b8936ddc277a29a)({
        motion: maskMotion,
        prefixCls: prefixCls,
        transitionName: maskTransitionName,
        animation: maskAnimation
    }));
    return /*#__PURE__*/ $dup7A.createElement((0, $e2f8ecce9d0083b7$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, motion, {
        visible: visible,
        removeOnLeave: true
    }), function(_ref) {
        var className = _ref.className;
        return /*#__PURE__*/ $dup7A.createElement("div", {
            style: {
                zIndex: zIndex
            },
            className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))("".concat(prefixCls, "-mask"), className)
        });
    });
}






var $dup7A = parcelRequire("dup7A");
// export this package's api


function $ee01477f51c72f40$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ee01477f51c72f40$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $ee01477f51c72f40$var$ownKeys(Object(source), !0).forEach(function(key) {
            $ee01477f51c72f40$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $ee01477f51c72f40$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ee01477f51c72f40$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ee01477f51c72f40$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ee01477f51c72f40$var$_typeof(obj);
}
function $ee01477f51c72f40$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ee01477f51c72f40$var$vendorPrefix;
var $ee01477f51c72f40$var$jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
};
function $ee01477f51c72f40$var$getVendorPrefix() {
    if ($ee01477f51c72f40$var$vendorPrefix !== undefined) return $ee01477f51c72f40$var$vendorPrefix;
    $ee01477f51c72f40$var$vendorPrefix = '';
    var style = document.createElement('p').style;
    var testProp = 'Transform';
    for(var key in $ee01477f51c72f40$var$jsCssMap)if (key + testProp in style) $ee01477f51c72f40$var$vendorPrefix = key;
    return $ee01477f51c72f40$var$vendorPrefix;
}
function $ee01477f51c72f40$var$getTransitionName() {
    return $ee01477f51c72f40$var$getVendorPrefix() ? "".concat($ee01477f51c72f40$var$getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function $ee01477f51c72f40$var$getTransformName() {
    return $ee01477f51c72f40$var$getVendorPrefix() ? "".concat($ee01477f51c72f40$var$getVendorPrefix(), "Transform") : 'transform';
}
function $ee01477f51c72f40$var$setTransitionProperty(node, value) {
    var name = $ee01477f51c72f40$var$getTransitionName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transitionProperty') node.style.transitionProperty = value;
    }
}
function $ee01477f51c72f40$var$setTransform(node, value) {
    var name = $ee01477f51c72f40$var$getTransformName();
    if (name) {
        node.style[name] = value;
        if (name !== 'transform') node.style.transform = value;
    }
}
function $ee01477f51c72f40$var$getTransitionProperty(node) {
    return node.style.transitionProperty || node.style[$ee01477f51c72f40$var$getTransitionName()];
}
function $ee01477f51c72f40$var$getTransformXY(node) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($ee01477f51c72f40$var$getTransformName());
    if (transform && transform !== 'none') {
        var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
        return {
            x: parseFloat(matrix[12] || matrix[4], 0),
            y: parseFloat(matrix[13] || matrix[5], 0)
        };
    }
    return {
        x: 0,
        y: 0
    };
}
var $ee01477f51c72f40$var$matrix2d = /matrix\((.*)\)/;
var $ee01477f51c72f40$var$matrix3d = /matrix3d\((.*)\)/;
function $ee01477f51c72f40$var$setTransformXY(node, xy) {
    var style = window.getComputedStyle(node, null);
    var transform = style.getPropertyValue('transform') || style.getPropertyValue($ee01477f51c72f40$var$getTransformName());
    if (transform && transform !== 'none') {
        var arr;
        var match2d = transform.match($ee01477f51c72f40$var$matrix2d);
        if (match2d) {
            match2d = match2d[1];
            arr = match2d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[4] = xy.x;
            arr[5] = xy.y;
            $ee01477f51c72f40$var$setTransform(node, "matrix(".concat(arr.join(','), ")"));
        } else {
            var match3d = transform.match($ee01477f51c72f40$var$matrix3d)[1];
            arr = match3d.split(',').map(function(item) {
                return parseFloat(item, 10);
            });
            arr[12] = xy.x;
            arr[13] = xy.y;
            $ee01477f51c72f40$var$setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
        }
    } else $ee01477f51c72f40$var$setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
}
var $ee01477f51c72f40$var$RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var $ee01477f51c72f40$var$getComputedStyleX;
// https://stackoverflow.com/a/3485654/3040605
function $ee01477f51c72f40$var$forceRelayout(elem) {
    var originalStyle = elem.style.display;
    elem.style.display = 'none';
    elem.offsetHeight; // eslint-disable-line
    elem.style.display = originalStyle;
}
function $ee01477f51c72f40$var$css(el, name, v) {
    var value = v;
    if ($ee01477f51c72f40$var$_typeof(name) === 'object') {
        for(var i in name)if (name.hasOwnProperty(i)) $ee01477f51c72f40$var$css(el, i, name[i]);
        return undefined;
    }
    if (typeof value !== 'undefined') {
        if (typeof value === 'number') value = "".concat(value, "px");
        el.style[name] = value;
        return undefined;
    }
    return $ee01477f51c72f40$var$getComputedStyleX(el, name);
}
function $ee01477f51c72f40$var$getClientPosition(elem) {
    var box;
    var x;
    var y;
    var doc = elem.ownerDocument;
    var body = doc.body;
    var docElem = doc && doc.documentElement;
    // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
    box = elem.getBoundingClientRect();
    // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
    // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
    // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
    x = Math.floor(box.left);
    y = Math.floor(box.top);
    // In IE, most of the time, 2 extra pixels are added to the top and left
    // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
    // IE6 standards mode, this border can be overridden by setting the
    // document element's border to zero -- thus, we cannot rely on the
    // offset always being 2 pixels.
    // In quirks mode, the offset can be determined by querying the body's
    // clientLeft/clientTop, but in standards mode, it is found by querying
    // the document element's clientLeft/clientTop.  Since we already called
    // getClientBoundingRect we have already forced a reflow, so it is not
    // too expensive just to query them all.
    // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
    // 窗口边框标准是设 documentElement ,quirks 时设置 body
    // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
    // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
    // 标准 ie 下 docElem.clientTop 就是 border-top
    // ie7 html 即窗口边框改变不了。永远为 2
    // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
    x -= docElem.clientLeft || body.clientLeft || 0;
    y -= docElem.clientTop || body.clientTop || 0;
    return {
        left: x,
        top: y
    };
}
function $ee01477f51c72f40$var$getScroll(w, top) {
    var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
    var method = "scroll".concat(top ? 'Top' : 'Left');
    if (typeof ret !== 'number') {
        var d = w.document;
        // ie6,7,8 standard mode
        ret = d.documentElement[method];
        if (typeof ret !== 'number') // quirks mode
        ret = d.body[method];
    }
    return ret;
}
function $ee01477f51c72f40$var$getScrollLeft(w) {
    return $ee01477f51c72f40$var$getScroll(w);
}
function $ee01477f51c72f40$var$getScrollTop(w) {
    return $ee01477f51c72f40$var$getScroll(w, true);
}
function $ee01477f51c72f40$var$getOffset(el) {
    var pos = $ee01477f51c72f40$var$getClientPosition(el);
    var doc = el.ownerDocument;
    var w = doc.defaultView || doc.parentWindow;
    pos.left += $ee01477f51c72f40$var$getScrollLeft(w);
    pos.top += $ee01477f51c72f40$var$getScrollTop(w);
    return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */ function $ee01477f51c72f40$var$isWindow(obj) {
    // must use == for ie8
    /* eslint eqeqeq:0 */ return obj !== null && obj !== undefined && obj == obj.window;
}
function $ee01477f51c72f40$var$getDocument(node) {
    if ($ee01477f51c72f40$var$isWindow(node)) return node.document;
    if (node.nodeType === 9) return node;
    return node.ownerDocument;
}
function $ee01477f51c72f40$var$_getComputedStyle(elem, name, cs) {
    var computedStyle = cs;
    var val = '';
    var d = $ee01477f51c72f40$var$getDocument(elem);
    computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);
    // https://github.com/kissyteam/kissy/issues/61
    if (computedStyle) val = computedStyle.getPropertyValue(name) || computedStyle[name];
    return val;
}
var $ee01477f51c72f40$var$_RE_NUM_NO_PX = new RegExp("^(".concat($ee01477f51c72f40$var$RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var $ee01477f51c72f40$var$RE_POS = /^(top|right|bottom|left)$/;
var $ee01477f51c72f40$var$CURRENT_STYLE = 'currentStyle';
var $ee01477f51c72f40$var$RUNTIME_STYLE = 'runtimeStyle';
var $ee01477f51c72f40$var$LEFT = 'left';
var $ee01477f51c72f40$var$PX = 'px';
function $ee01477f51c72f40$var$_getComputedStyleIE(elem, name) {
    // currentStyle maybe null
    // http://msdn.microsoft.com/en-us/library/ms535231.aspx
    var ret = elem[$ee01477f51c72f40$var$CURRENT_STYLE] && elem[$ee01477f51c72f40$var$CURRENT_STYLE][name];
    // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
    // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
    // 在 ie 下不对，需要直接用 offset 方式
    // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
    // From the awesome hack by Dean Edwards
    // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
    // If we're not dealing with a regular pixel number
    // but a number that has a weird ending, we need to convert it to pixels
    // exclude left right for relativity
    if ($ee01477f51c72f40$var$_RE_NUM_NO_PX.test(ret) && !$ee01477f51c72f40$var$RE_POS.test(name)) {
        // Remember the original values
        var style = elem.style;
        var left = style[$ee01477f51c72f40$var$LEFT];
        var rsLeft = elem[$ee01477f51c72f40$var$RUNTIME_STYLE][$ee01477f51c72f40$var$LEFT];
        // prevent flashing of content
        elem[$ee01477f51c72f40$var$RUNTIME_STYLE][$ee01477f51c72f40$var$LEFT] = elem[$ee01477f51c72f40$var$CURRENT_STYLE][$ee01477f51c72f40$var$LEFT];
        // Put in the new values to get a computed value out
        style[$ee01477f51c72f40$var$LEFT] = name === 'fontSize' ? '1em' : ret || 0;
        ret = style.pixelLeft + $ee01477f51c72f40$var$PX;
        // Revert the changed values
        style[$ee01477f51c72f40$var$LEFT] = left;
        elem[$ee01477f51c72f40$var$RUNTIME_STYLE][$ee01477f51c72f40$var$LEFT] = rsLeft;
    }
    return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') $ee01477f51c72f40$var$getComputedStyleX = window.getComputedStyle ? $ee01477f51c72f40$var$_getComputedStyle : $ee01477f51c72f40$var$_getComputedStyleIE;
function $ee01477f51c72f40$var$getOffsetDirection(dir, option) {
    if (dir === 'left') return option.useCssRight ? 'right' : dir;
    return option.useCssBottom ? 'bottom' : dir;
}
function $ee01477f51c72f40$var$oppositeOffsetDirection(dir) {
    if (dir === 'left') return 'right';
    else if (dir === 'right') return 'left';
    else if (dir === 'top') return 'bottom';
    else if (dir === 'bottom') return 'top';
}
// 设置 elem 相对 elem.ownerDocument 的坐标
function $ee01477f51c72f40$var$setLeftTop(elem, offset, option) {
    // set position first, in-case top/left are set even on static elem
    if ($ee01477f51c72f40$var$css(elem, 'position') === 'static') elem.style.position = 'relative';
    var presetH = -999;
    var presetV = -999;
    var horizontalProperty = $ee01477f51c72f40$var$getOffsetDirection('left', option);
    var verticalProperty = $ee01477f51c72f40$var$getOffsetDirection('top', option);
    var oppositeHorizontalProperty = $ee01477f51c72f40$var$oppositeOffsetDirection(horizontalProperty);
    var oppositeVerticalProperty = $ee01477f51c72f40$var$oppositeOffsetDirection(verticalProperty);
    if (horizontalProperty !== 'left') presetH = 999;
    if (verticalProperty !== 'top') presetV = 999;
    var originalTransition = '';
    var originalOffset = $ee01477f51c72f40$var$getOffset(elem);
    if ('left' in offset || 'top' in offset) {
        originalTransition = $ee01477f51c72f40$var$getTransitionProperty(elem) || '';
        $ee01477f51c72f40$var$setTransitionProperty(elem, 'none');
    }
    if ('left' in offset) {
        elem.style[oppositeHorizontalProperty] = '';
        elem.style[horizontalProperty] = "".concat(presetH, "px");
    }
    if ('top' in offset) {
        elem.style[oppositeVerticalProperty] = '';
        elem.style[verticalProperty] = "".concat(presetV, "px");
    }
    // force relayout
    $ee01477f51c72f40$var$forceRelayout(elem);
    var old = $ee01477f51c72f40$var$getOffset(elem);
    var originalStyle = {};
    for(var key in offset)if (offset.hasOwnProperty(key)) {
        var dir = $ee01477f51c72f40$var$getOffsetDirection(key, option);
        var preset = key === 'left' ? presetH : presetV;
        var off = originalOffset[key] - old[key];
        if (dir === key) originalStyle[dir] = preset + off;
        else originalStyle[dir] = preset - off;
    }
    $ee01477f51c72f40$var$css(elem, originalStyle);
    // force relayout
    $ee01477f51c72f40$var$forceRelayout(elem);
    if ('left' in offset || 'top' in offset) $ee01477f51c72f40$var$setTransitionProperty(elem, originalTransition);
    var ret = {};
    for(var _key in offset)if (offset.hasOwnProperty(_key)) {
        var _dir = $ee01477f51c72f40$var$getOffsetDirection(_key, option);
        var _off = offset[_key] - originalOffset[_key];
        if (_key === _dir) ret[_dir] = originalStyle[_dir] + _off;
        else ret[_dir] = originalStyle[_dir] - _off;
    }
    $ee01477f51c72f40$var$css(elem, ret);
}
function $ee01477f51c72f40$var$setTransform$1(elem, offset) {
    var originalOffset = $ee01477f51c72f40$var$getOffset(elem);
    var originalXY = $ee01477f51c72f40$var$getTransformXY(elem);
    var resultXY = {
        x: originalXY.x,
        y: originalXY.y
    };
    if ('left' in offset) resultXY.x = originalXY.x + offset.left - originalOffset.left;
    if ('top' in offset) resultXY.y = originalXY.y + offset.top - originalOffset.top;
    $ee01477f51c72f40$var$setTransformXY(elem, resultXY);
}
function $ee01477f51c72f40$var$setOffset(elem, offset, option) {
    if (option.ignoreShake) {
        var oriOffset = $ee01477f51c72f40$var$getOffset(elem);
        var oLeft = oriOffset.left.toFixed(0);
        var oTop = oriOffset.top.toFixed(0);
        var tLeft = offset.left.toFixed(0);
        var tTop = offset.top.toFixed(0);
        if (oLeft === tLeft && oTop === tTop) return;
    }
    if (option.useCssRight || option.useCssBottom) $ee01477f51c72f40$var$setLeftTop(elem, offset, option);
    else if (option.useCssTransform && $ee01477f51c72f40$var$getTransformName() in document.body.style) $ee01477f51c72f40$var$setTransform$1(elem, offset);
    else $ee01477f51c72f40$var$setLeftTop(elem, offset, option);
}
function $ee01477f51c72f40$var$each(arr, fn) {
    for(var i = 0; i < arr.length; i++)fn(arr[i]);
}
function $ee01477f51c72f40$var$isBorderBoxFn(elem) {
    return $ee01477f51c72f40$var$getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var $ee01477f51c72f40$var$BOX_MODELS = [
    'margin',
    'border',
    'padding'
];
var $ee01477f51c72f40$var$CONTENT_INDEX = -1;
var $ee01477f51c72f40$var$PADDING_INDEX = 2;
var $ee01477f51c72f40$var$BORDER_INDEX = 1;
var $ee01477f51c72f40$var$MARGIN_INDEX = 0;
function $ee01477f51c72f40$var$swap(elem, options, callback) {
    var old = {};
    var style = elem.style;
    var name;
    // Remember the old values, and insert the new ones
    for(name in options)if (options.hasOwnProperty(name)) {
        old[name] = style[name];
        style[name] = options[name];
    }
    callback.call(elem);
    // Revert the old values
    for(name in options)if (options.hasOwnProperty(name)) style[name] = old[name];
}
function $ee01477f51c72f40$var$getPBMWidth(elem, props, which) {
    var value = 0;
    var prop;
    var j;
    var i;
    for(j = 0; j < props.length; j++){
        prop = props[j];
        if (prop) for(i = 0; i < which.length; i++){
            var cssProp = void 0;
            if (prop === 'border') cssProp = "".concat(prop).concat(which[i], "Width");
            else cssProp = prop + which[i];
            value += parseFloat($ee01477f51c72f40$var$getComputedStyleX(elem, cssProp)) || 0;
        }
    }
    return value;
}
var $ee01477f51c72f40$var$domUtils = {
    getParent: function getParent(element) {
        var parent = element;
        do if (parent.nodeType === 11 && parent.host) parent = parent.host;
        else parent = parent.parentNode;
        while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
        return parent;
    }
};
$ee01477f51c72f40$var$each([
    'Width',
    'Height'
], function(name) {
    $ee01477f51c72f40$var$domUtils["doc".concat(name)] = function(refWin) {
        var d = refWin.document;
        return Math.max(// firefox chrome documentElement.scrollHeight< body.scrollHeight
        // ie standard mode : documentElement.scrollHeight> body.scrollHeight
        d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
        d.body["scroll".concat(name)], $ee01477f51c72f40$var$domUtils["viewport".concat(name)](d));
    };
    $ee01477f51c72f40$var$domUtils["viewport".concat(name)] = function(win) {
        // pc browser includes scrollbar in window.innerWidth
        var prop = "client".concat(name);
        var doc = win.document;
        var body = doc.body;
        var documentElement = doc.documentElement;
        var documentElementProp = documentElement[prop];
        // 标准模式取 documentElement
        // backcompat 取 body
        return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
    };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */ function $ee01477f51c72f40$var$getWH(elem, name, ex) {
    var extra = ex;
    if ($ee01477f51c72f40$var$isWindow(elem)) return name === 'width' ? $ee01477f51c72f40$var$domUtils.viewportWidth(elem) : $ee01477f51c72f40$var$domUtils.viewportHeight(elem);
    else if (elem.nodeType === 9) return name === 'width' ? $ee01477f51c72f40$var$domUtils.docWidth(elem) : $ee01477f51c72f40$var$domUtils.docHeight(elem);
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
    var isBorderBox = $ee01477f51c72f40$var$isBorderBoxFn(elem);
    var cssBoxValue = 0;
    if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
        borderBoxValue = undefined;
        // Fall back to computed then un computed css if necessary
        cssBoxValue = $ee01477f51c72f40$var$getComputedStyleX(elem, name);
        if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) cssBoxValue = elem.style[name] || 0;
        // Normalize '', auto, and prepare for extra
        cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
    }
    if (extra === undefined) extra = isBorderBox ? $ee01477f51c72f40$var$BORDER_INDEX : $ee01477f51c72f40$var$CONTENT_INDEX;
    var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
    var val = borderBoxValue || cssBoxValue;
    if (extra === $ee01477f51c72f40$var$CONTENT_INDEX) {
        if (borderBoxValueOrIsBorderBox) return val - $ee01477f51c72f40$var$getPBMWidth(elem, [
            'border',
            'padding'
        ], which);
        return cssBoxValue;
    } else if (borderBoxValueOrIsBorderBox) {
        if (extra === $ee01477f51c72f40$var$BORDER_INDEX) return val;
        return val + (extra === $ee01477f51c72f40$var$PADDING_INDEX ? -$ee01477f51c72f40$var$getPBMWidth(elem, [
            'border'
        ], which) : $ee01477f51c72f40$var$getPBMWidth(elem, [
            'margin'
        ], which));
    }
    return cssBoxValue + $ee01477f51c72f40$var$getPBMWidth(elem, $ee01477f51c72f40$var$BOX_MODELS.slice(extra), which);
}
var $ee01477f51c72f40$var$cssShow = {
    position: 'absolute',
    visibility: 'hidden',
    display: 'block'
};
// fix #119 : https://github.com/kissyteam/kissy/issues/119
function $ee01477f51c72f40$var$getWHIgnoreDisplay() {
    for(var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++)args[_key2] = arguments[_key2];
    var val;
    var elem = args[0];
    // in case elem is window
    // elem.offsetWidth === undefined
    if (elem.offsetWidth !== 0) val = $ee01477f51c72f40$var$getWH.apply(undefined, args);
    else $ee01477f51c72f40$var$swap(elem, $ee01477f51c72f40$var$cssShow, function() {
        val = $ee01477f51c72f40$var$getWH.apply(undefined, args);
    });
    return val;
}
$ee01477f51c72f40$var$each([
    'width',
    'height'
], function(name) {
    var first = name.charAt(0).toUpperCase() + name.slice(1);
    $ee01477f51c72f40$var$domUtils["outer".concat(first)] = function(el, includeMargin) {
        return el && $ee01477f51c72f40$var$getWHIgnoreDisplay(el, name, includeMargin ? $ee01477f51c72f40$var$MARGIN_INDEX : $ee01477f51c72f40$var$BORDER_INDEX);
    };
    var which = name === 'width' ? [
        'Left',
        'Right'
    ] : [
        'Top',
        'Bottom'
    ];
    $ee01477f51c72f40$var$domUtils[name] = function(elem, v) {
        var val = v;
        if (val !== undefined) {
            if (elem) {
                var isBorderBox = $ee01477f51c72f40$var$isBorderBoxFn(elem);
                if (isBorderBox) val += $ee01477f51c72f40$var$getPBMWidth(elem, [
                    'padding',
                    'border'
                ], which);
                return $ee01477f51c72f40$var$css(elem, name, val);
            }
            return undefined;
        }
        return elem && $ee01477f51c72f40$var$getWHIgnoreDisplay(elem, name, $ee01477f51c72f40$var$CONTENT_INDEX);
    };
});
function $ee01477f51c72f40$var$mix(to, from) {
    for(var i in from)if (from.hasOwnProperty(i)) to[i] = from[i];
    return to;
}
var $ee01477f51c72f40$var$utils = {
    getWindow: function getWindow(node) {
        if (node && node.document && node.setTimeout) return node;
        var doc = node.ownerDocument || node;
        return doc.defaultView || doc.parentWindow;
    },
    getDocument: $ee01477f51c72f40$var$getDocument,
    offset: function offset(el, value, option) {
        if (typeof value !== 'undefined') $ee01477f51c72f40$var$setOffset(el, value, option || {});
        else return $ee01477f51c72f40$var$getOffset(el);
    },
    isWindow: $ee01477f51c72f40$var$isWindow,
    each: $ee01477f51c72f40$var$each,
    css: $ee01477f51c72f40$var$css,
    clone: function clone(obj) {
        var i;
        var ret = {};
        for(i in obj)if (obj.hasOwnProperty(i)) ret[i] = obj[i];
        var overflow = obj.overflow;
        if (overflow) {
            for(i in obj)if (obj.hasOwnProperty(i)) ret.overflow[i] = obj.overflow[i];
        }
        return ret;
    },
    mix: $ee01477f51c72f40$var$mix,
    getWindowScrollLeft: function getWindowScrollLeft(w) {
        return $ee01477f51c72f40$var$getScrollLeft(w);
    },
    getWindowScrollTop: function getWindowScrollTop(w) {
        return $ee01477f51c72f40$var$getScrollTop(w);
    },
    merge: function merge() {
        var ret = {};
        for(var i = 0; i < arguments.length; i++)$ee01477f51c72f40$var$utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
        return ret;
    },
    viewportWidth: 0,
    viewportHeight: 0
};
$ee01477f51c72f40$var$mix($ee01477f51c72f40$var$utils, $ee01477f51c72f40$var$domUtils);
/**
 * 得到会导致元素显示不全的祖先元素
 */ var $ee01477f51c72f40$var$getParent = $ee01477f51c72f40$var$utils.getParent;
function $ee01477f51c72f40$var$getOffsetParent(element) {
    if ($ee01477f51c72f40$var$utils.isWindow(element) || element.nodeType === 9) return null;
    // ie 这个也不是完全可行
    /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */ // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
    //  In other browsers it only includes elements with position absolute, relative or
    // fixed, not elements with overflow set to auto or scroll.
    //        if (UA.ie && ieMode < 8) {
    //            return element.offsetParent;
    //        }
    // 统一的 offsetParent 方法
    var doc = $ee01477f51c72f40$var$utils.getDocument(element);
    var body = doc.body;
    var parent;
    var positionStyle = $ee01477f51c72f40$var$utils.css(element, 'position');
    var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
    if (!skipStatic) return element.nodeName.toLowerCase() === 'html' ? null : $ee01477f51c72f40$var$getParent(element);
    for(parent = $ee01477f51c72f40$var$getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = $ee01477f51c72f40$var$getParent(parent)){
        positionStyle = $ee01477f51c72f40$var$utils.css(parent, 'position');
        if (positionStyle !== 'static') return parent;
    }
    return null;
}
var $ee01477f51c72f40$var$getParent$1 = $ee01477f51c72f40$var$utils.getParent;
function $ee01477f51c72f40$var$isAncestorFixed(element) {
    if ($ee01477f51c72f40$var$utils.isWindow(element) || element.nodeType === 9) return false;
    var doc = $ee01477f51c72f40$var$utils.getDocument(element);
    var body = doc.body;
    var parent = null;
    for(parent = $ee01477f51c72f40$var$getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
    parent && parent !== body && parent !== doc; parent = $ee01477f51c72f40$var$getParent$1(parent)){
        var positionStyle = $ee01477f51c72f40$var$utils.css(parent, 'position');
        if (positionStyle === 'fixed') return true;
    }
    return false;
}
/**
 * 获得元素的显示部分的区域
 */ function $ee01477f51c72f40$var$getVisibleRectForElement(element, alwaysByViewport) {
    var visibleRect = {
        left: 0,
        right: Infinity,
        top: 0,
        bottom: Infinity
    };
    var el = $ee01477f51c72f40$var$getOffsetParent(element);
    var doc = $ee01477f51c72f40$var$utils.getDocument(element);
    var win = doc.defaultView || doc.parentWindow;
    var body = doc.body;
    var documentElement = doc.documentElement;
    // Determine the size of the visible rect by climbing the dom accounting for
    // all scrollable containers.
    while(el){
        // clientWidth is zero for inline block elements in ie.
        if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
        // viewport. In some browsers, el.offsetParent may be
        // document.documentElement, so check for that too.
        el !== body && el !== documentElement && $ee01477f51c72f40$var$utils.css(el, 'overflow') !== 'visible') {
            var pos = $ee01477f51c72f40$var$utils.offset(el);
            // add border
            pos.left += el.clientLeft;
            pos.top += el.clientTop;
            visibleRect.top = Math.max(visibleRect.top, pos.top);
            visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
            pos.left + el.clientWidth);
            visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
            visibleRect.left = Math.max(visibleRect.left, pos.left);
        } else if (el === body || el === documentElement) break;
        el = $ee01477f51c72f40$var$getOffsetParent(el);
    }
    // Set element position to fixed
    // make sure absolute element itself don't affect it's visible area
    // https://github.com/ant-design/ant-design/issues/7601
    var originalPosition = null;
    if (!$ee01477f51c72f40$var$utils.isWindow(element) && element.nodeType !== 9) {
        originalPosition = element.style.position;
        var position = $ee01477f51c72f40$var$utils.css(element, 'position');
        if (position === 'absolute') element.style.position = 'fixed';
    }
    var scrollX = $ee01477f51c72f40$var$utils.getWindowScrollLeft(win);
    var scrollY = $ee01477f51c72f40$var$utils.getWindowScrollTop(win);
    var viewportWidth = $ee01477f51c72f40$var$utils.viewportWidth(win);
    var viewportHeight = $ee01477f51c72f40$var$utils.viewportHeight(win);
    var documentWidth = documentElement.scrollWidth;
    var documentHeight = documentElement.scrollHeight;
    // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
    // We should cut this ourself.
    var bodyStyle = window.getComputedStyle(body);
    if (bodyStyle.overflowX === 'hidden') documentWidth = win.innerWidth;
    if (bodyStyle.overflowY === 'hidden') documentHeight = win.innerHeight;
    // Reset element position after calculate the visible area
    if (element.style) element.style.position = originalPosition;
    if (alwaysByViewport || $ee01477f51c72f40$var$isAncestorFixed(element)) {
        // Clip by viewport's size.
        visibleRect.left = Math.max(visibleRect.left, scrollX);
        visibleRect.top = Math.max(visibleRect.top, scrollY);
        visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
        visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
    } else {
        // Clip by document's size.
        var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
        visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
        var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
        visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
    }
    return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}
function $ee01477f51c72f40$var$adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
    var pos = $ee01477f51c72f40$var$utils.clone(elFuturePos);
    var size = {
        width: elRegion.width,
        height: elRegion.height
    };
    if (overflow.adjustX && pos.left < visibleRect.left) pos.left = visibleRect.left;
    // Left edge inside and right edge outside viewport, try to resize it.
    if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) size.width -= pos.left + size.width - visibleRect.right;
    // Right edge outside viewport, try to move it.
    if (overflow.adjustX && pos.left + size.width > visibleRect.right) // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
    // Top edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top < visibleRect.top) pos.top = visibleRect.top;
    // Top edge inside and bottom edge outside viewport, try to resize it.
    if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) size.height -= pos.top + size.height - visibleRect.bottom;
    // Bottom edge outside viewport, try to move it.
    if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
    return $ee01477f51c72f40$var$utils.mix(pos, size);
}
function $ee01477f51c72f40$var$getRegion(node) {
    var offset;
    var w;
    var h;
    if (!$ee01477f51c72f40$var$utils.isWindow(node) && node.nodeType !== 9) {
        offset = $ee01477f51c72f40$var$utils.offset(node);
        w = $ee01477f51c72f40$var$utils.outerWidth(node);
        h = $ee01477f51c72f40$var$utils.outerHeight(node);
    } else {
        var win = $ee01477f51c72f40$var$utils.getWindow(node);
        offset = {
            left: $ee01477f51c72f40$var$utils.getWindowScrollLeft(win),
            top: $ee01477f51c72f40$var$utils.getWindowScrollTop(win)
        };
        w = $ee01477f51c72f40$var$utils.viewportWidth(win);
        h = $ee01477f51c72f40$var$utils.viewportHeight(win);
    }
    offset.width = w;
    offset.height = h;
    return offset;
}
/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */ function $ee01477f51c72f40$var$getAlignOffset(region, align) {
    var V = align.charAt(0);
    var H = align.charAt(1);
    var w = region.width;
    var h = region.height;
    var x = region.left;
    var y = region.top;
    if (V === 'c') y += h / 2;
    else if (V === 'b') y += h;
    if (H === 'c') x += w / 2;
    else if (H === 'r') x += w;
    return {
        left: x,
        top: y
    };
}
function $ee01477f51c72f40$var$getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
    var p1 = $ee01477f51c72f40$var$getAlignOffset(refNodeRegion, points[1]);
    var p2 = $ee01477f51c72f40$var$getAlignOffset(elRegion, points[0]);
    var diff = [
        p2.left - p1.left,
        p2.top - p1.top
    ];
    return {
        left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
        top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
    };
}
/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */ // http://yiminghe.iteye.com/blog/1124720
function $ee01477f51c72f40$var$isFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function $ee01477f51c72f40$var$isFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function $ee01477f51c72f40$var$isCompleteFailX(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function $ee01477f51c72f40$var$isCompleteFailY(elFuturePos, elRegion, visibleRect) {
    return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function $ee01477f51c72f40$var$flip(points, reg, map) {
    var ret = [];
    $ee01477f51c72f40$var$utils.each(points, function(p) {
        ret.push(p.replace(reg, function(m) {
            return map[m];
        }));
    });
    return ret;
}
function $ee01477f51c72f40$var$flipOffset(offset, index) {
    offset[index] = -offset[index];
    return offset;
}
function $ee01477f51c72f40$var$convertOffset(str, offsetLen) {
    var n;
    if (/%$/.test(str)) n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
    else n = parseInt(str, 10);
    return n || 0;
}
function $ee01477f51c72f40$var$normalizeOffset(offset, el) {
    offset[0] = $ee01477f51c72f40$var$convertOffset(offset[0], el.width);
    offset[1] = $ee01477f51c72f40$var$convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */ function $ee01477f51c72f40$var$doAlign(el, tgtRegion, align, isTgtRegionVisible) {
    var points = align.points;
    var offset = align.offset || [
        0,
        0
    ];
    var targetOffset = align.targetOffset || [
        0,
        0
    ];
    var overflow = align.overflow;
    var source = align.source || el;
    offset = [].concat(offset);
    targetOffset = [].concat(targetOffset);
    overflow = overflow || {};
    var newOverflowCfg = {};
    var fail = 0;
    var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
    // 当前节点可以被放置的显示区域
    var visibleRect = $ee01477f51c72f40$var$getVisibleRectForElement(source, alwaysByViewport);
    // 当前节点所占的区域, left/top/width/height
    var elRegion = $ee01477f51c72f40$var$getRegion(source);
    // 将 offset 转换成数值，支持百分比
    $ee01477f51c72f40$var$normalizeOffset(offset, elRegion);
    $ee01477f51c72f40$var$normalizeOffset(targetOffset, tgtRegion);
    // 当前节点将要被放置的位置
    var elFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
    // 当前节点将要所处的区域
    var newElRegion = $ee01477f51c72f40$var$utils.merge(elRegion, elFuturePos);
    // 如果可视区域不能完全放置当前节点时允许调整
    if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
        if (overflow.adjustX) // 如果横向不能放下
        {
            if ($ee01477f51c72f40$var$isFailX(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var newPoints = $ee01477f51c72f40$var$flip(points, /[lr]/gi, {
                    l: 'r',
                    r: 'l'
                });
                // 偏移量也反下
                var newOffset = $ee01477f51c72f40$var$flipOffset(offset, 0);
                var newTargetOffset = $ee01477f51c72f40$var$flipOffset(targetOffset, 0);
                var newElFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
                if (!$ee01477f51c72f40$var$isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = newPoints;
                    offset = newOffset;
                    targetOffset = newTargetOffset;
                }
            }
        }
        if (overflow.adjustY) // 如果纵向不能放下
        {
            if ($ee01477f51c72f40$var$isFailY(elFuturePos, elRegion, visibleRect)) {
                // 对齐位置反下
                var _newPoints = $ee01477f51c72f40$var$flip(points, /[tb]/gi, {
                    t: 'b',
                    b: 't'
                });
                // 偏移量也反下
                var _newOffset = $ee01477f51c72f40$var$flipOffset(offset, 1);
                var _newTargetOffset = $ee01477f51c72f40$var$flipOffset(targetOffset, 1);
                var _newElFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
                if (!$ee01477f51c72f40$var$isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
                    fail = 1;
                    points = _newPoints;
                    offset = _newOffset;
                    targetOffset = _newTargetOffset;
                }
            }
        }
        // 如果失败，重新计算当前节点将要被放置的位置
        if (fail) {
            elFuturePos = $ee01477f51c72f40$var$getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
            $ee01477f51c72f40$var$utils.mix(newElRegion, elFuturePos);
        }
        var isStillFailX = $ee01477f51c72f40$var$isFailX(elFuturePos, elRegion, visibleRect);
        var isStillFailY = $ee01477f51c72f40$var$isFailY(elFuturePos, elRegion, visibleRect);
        // 检查反下后的位置是否可以放下了，如果仍然放不下：
        // 1. 复原修改过的定位参数
        if (isStillFailX || isStillFailY) {
            var _newPoints2 = points;
            // 重置对应部分的翻转逻辑
            if (isStillFailX) _newPoints2 = $ee01477f51c72f40$var$flip(points, /[lr]/gi, {
                l: 'r',
                r: 'l'
            });
            if (isStillFailY) _newPoints2 = $ee01477f51c72f40$var$flip(points, /[tb]/gi, {
                t: 'b',
                b: 't'
            });
            points = _newPoints2;
            offset = align.offset || [
                0,
                0
            ];
            targetOffset = align.targetOffset || [
                0,
                0
            ];
        }
        // 2. 只有指定了可以调整当前方向才调整
        newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
        newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;
        // 确实要调整，甚至可能会调整高度宽度
        if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) newElRegion = $ee01477f51c72f40$var$adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
    // need judge to in case set fixed with in css on height auto element
    if (newElRegion.width !== elRegion.width) $ee01477f51c72f40$var$utils.css(source, 'width', $ee01477f51c72f40$var$utils.width(source) + newElRegion.width - elRegion.width);
    if (newElRegion.height !== elRegion.height) $ee01477f51c72f40$var$utils.css(source, 'height', $ee01477f51c72f40$var$utils.height(source) + newElRegion.height - elRegion.height);
    // https://github.com/kissyteam/kissy/issues/190
    // 相对于屏幕位置没变，而 left/top 变了
    // 例如 <div 'relative'><el absolute></div>
    $ee01477f51c72f40$var$utils.offset(source, {
        left: newElRegion.left,
        top: newElRegion.top
    }, {
        useCssRight: align.useCssRight,
        useCssBottom: align.useCssBottom,
        useCssTransform: align.useCssTransform,
        ignoreShake: align.ignoreShake
    });
    return {
        points: points,
        offset: offset,
        targetOffset: targetOffset,
        overflow: newOverflowCfg
    };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/ function $ee01477f51c72f40$var$isOutOfVisibleRect(target, alwaysByViewport) {
    var visibleRect = $ee01477f51c72f40$var$getVisibleRectForElement(target, alwaysByViewport);
    var targetRegion = $ee01477f51c72f40$var$getRegion(target);
    return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function $ee01477f51c72f40$export$ec21431d5ee6c534(el, refNode, align) {
    var target = align.target || refNode;
    var refNodeRegion = $ee01477f51c72f40$var$getRegion(target);
    var isTargetNotOutOfVisible = !$ee01477f51c72f40$var$isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
    return $ee01477f51c72f40$var$doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
$ee01477f51c72f40$export$ec21431d5ee6c534.__getOffsetParent = $ee01477f51c72f40$var$getOffsetParent;
$ee01477f51c72f40$export$ec21431d5ee6c534.__getVisibleRectForElement = $ee01477f51c72f40$var$getVisibleRectForElement;
/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */ function $ee01477f51c72f40$export$38f0e12f0aa28098(el, tgtPoint, align) {
    var pageX;
    var pageY;
    var doc = $ee01477f51c72f40$var$utils.getDocument(el);
    var win = doc.defaultView || doc.parentWindow;
    var scrollX = $ee01477f51c72f40$var$utils.getWindowScrollLeft(win);
    var scrollY = $ee01477f51c72f40$var$utils.getWindowScrollTop(win);
    var viewportWidth = $ee01477f51c72f40$var$utils.viewportWidth(win);
    var viewportHeight = $ee01477f51c72f40$var$utils.viewportHeight(win);
    if ('pageX' in tgtPoint) pageX = tgtPoint.pageX;
    else pageX = scrollX + tgtPoint.clientX;
    if ('pageY' in tgtPoint) pageY = tgtPoint.pageY;
    else pageY = scrollY + tgtPoint.clientY;
    var tgtRegion = {
        left: pageX,
        top: pageY,
        width: 0,
        height: 0
    };
    var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;
    // Provide default target point
    var points = [
        align.points[0],
        'cc'
    ];
    return $ee01477f51c72f40$var$doAlign(el, tgtRegion, $ee01477f51c72f40$var$_objectSpread2($ee01477f51c72f40$var$_objectSpread2({}, align), {}, {
        points: points
    }), pointInView);
}
var $ee01477f51c72f40$export$2e2bcd8739ae039 = $ee01477f51c72f40$export$ec21431d5ee6c534;




/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function $b413b124a411084b$var$isEqual(obj1, obj2) {
    var shallow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    var refSet = new Set();
    function deepEqual(a, b) {
        var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
        var circular = refSet.has(a);
        (0, $b4cde5d547cd3626$export$2e2bcd8739ae039)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        var newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(var i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(a) === 'object' && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(b) === 'object') {
            var keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every(function(key) {
                return deepEqual(a[key], b[key], newLevel);
            });
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
var $b413b124a411084b$export$2e2bcd8739ae039 = $b413b124a411084b$var$isEqual;



var $bd5eba434ae00c04$export$2e2bcd8739ae039 = function(element) {
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
            if (_width || _height) return true;
        }
    }
    return false;
};





var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
var $cfd025d245abcd49$export$2e2bcd8739ae039 = function(callback, buffer) {
    var calledRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(false);
    var timeoutRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef(null);
    function cancelTrigger() {
        window.clearTimeout(timeoutRef.current);
    }
    function trigger(force) {
        cancelTrigger();
        if (!calledRef.current || force === true) {
            if (callback(force) === false) // Not delay since callback cancelled self
            return;
            calledRef.current = true;
            timeoutRef.current = window.setTimeout(function() {
                calledRef.current = false;
            }, buffer);
        } else timeoutRef.current = window.setTimeout(function() {
            calledRef.current = false;
            trigger();
        }, buffer);
    }
    return [
        trigger,
        function() {
            calledRef.current = false;
            cancelTrigger();
        }
    ];
};



/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $0dc404c2d121ea4e$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $0dc404c2d121ea4e$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $0dc404c2d121ea4e$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $0dc404c2d121ea4e$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($0dc404c2d121ea4e$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $0dc404c2d121ea4e$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $0dc404c2d121ea4e$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $0dc404c2d121ea4e$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $0dc404c2d121ea4e$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $0dc404c2d121ea4e$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $0dc404c2d121ea4e$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $0dc404c2d121ea4e$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $0dc404c2d121ea4e$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $0dc404c2d121ea4e$var$throttle(this.refresh.bind(this), $0dc404c2d121ea4e$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$0dc404c2d121ea4e$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($0dc404c2d121ea4e$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$0dc404c2d121ea4e$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $0dc404c2d121ea4e$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $0dc404c2d121ea4e$var$defineConfigurable = function(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $0dc404c2d121ea4e$var$getWindowOf = function(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $0dc404c2d121ea4e$var$global$1;
};
// Placeholder of an empty content rectangle.
var $0dc404c2d121ea4e$var$emptyRect = $0dc404c2d121ea4e$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $0dc404c2d121ea4e$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $0dc404c2d121ea4e$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $0dc404c2d121ea4e$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $0dc404c2d121ea4e$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $0dc404c2d121ea4e$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $0dc404c2d121ea4e$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $0dc404c2d121ea4e$var$emptyRect;
    var styles = $0dc404c2d121ea4e$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $0dc404c2d121ea4e$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $0dc404c2d121ea4e$var$toFloat(styles.width), height = $0dc404c2d121ea4e$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $0dc404c2d121ea4e$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $0dc404c2d121ea4e$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$0dc404c2d121ea4e$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $0dc404c2d121ea4e$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $0dc404c2d121ea4e$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $0dc404c2d121ea4e$var$isDocumentElement(target) {
    return target === $0dc404c2d121ea4e$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$getContentRect(target) {
    if (!$0dc404c2d121ea4e$var$isBrowser) return $0dc404c2d121ea4e$var$emptyRect;
    if ($0dc404c2d121ea4e$var$isSVGGraphicsElement(target)) return $0dc404c2d121ea4e$var$getSVGContentRect(target);
    return $0dc404c2d121ea4e$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $0dc404c2d121ea4e$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $0dc404c2d121ea4e$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $0dc404c2d121ea4e$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $0dc404c2d121ea4e$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $0dc404c2d121ea4e$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $0dc404c2d121ea4e$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $0dc404c2d121ea4e$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $0dc404c2d121ea4e$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $0dc404c2d121ea4e$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $0dc404c2d121ea4e$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $0dc404c2d121ea4e$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $0dc404c2d121ea4e$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $0dc404c2d121ea4e$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $0dc404c2d121ea4e$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $0dc404c2d121ea4e$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $0dc404c2d121ea4e$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $0dc404c2d121ea4e$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $0dc404c2d121ea4e$var$ResizeObserverController.getInstance();
        var observer = new $0dc404c2d121ea4e$var$ResizeObserverSPI(callback, controller, this);
        $0dc404c2d121ea4e$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $0dc404c2d121ea4e$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $0dc404c2d121ea4e$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $0dc404c2d121ea4e$var$index = function() {
    // Export existing implementation if available.
    if (typeof $0dc404c2d121ea4e$var$global$1.ResizeObserver !== 'undefined') return $0dc404c2d121ea4e$var$global$1.ResizeObserver;
    return $0dc404c2d121ea4e$var$ResizeObserver;
}();
var $0dc404c2d121ea4e$export$2e2bcd8739ae039 = $0dc404c2d121ea4e$var$index;



function $e73c72d6f5cf5ab6$export$792a4d7b8e9efb33(prev, next) {
    if (prev === next) return true;
    if (!prev || !next) return false;
    if ('pageX' in next && 'pageY' in next) return prev.pageX === next.pageX && prev.pageY === next.pageY;
    if ('clientX' in next && 'clientY' in next) return prev.clientX === next.clientX && prev.clientY === next.clientY;
    return false;
}
function $e73c72d6f5cf5ab6$export$2284e449d64b22d5(activeElement, container) {
    // Focus back if is in the container
    if (activeElement !== document.activeElement && (0, $01802a99afaa475f$export$2e2bcd8739ae039)(container, activeElement) && typeof activeElement.focus === 'function') activeElement.focus();
}
function $e73c72d6f5cf5ab6$export$f56787db9e74dfe(element, callback) {
    var prevWidth = null;
    var prevHeight = null;
    function onResize(_ref) {
        var _ref2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_ref, 1), target = _ref2[0].target;
        if (!document.documentElement.contains(target)) return;
        var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
        var fixedWidth = Math.floor(width);
        var fixedHeight = Math.floor(height);
        if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) // https://webkit.org/blog/9997/resizeobserver-in-webkit/
        Promise.resolve().then(function() {
            callback({
                width: fixedWidth,
                height: fixedHeight
            });
        });
        prevWidth = fixedWidth;
        prevHeight = fixedHeight;
    }
    var resizeObserver = new (0, $0dc404c2d121ea4e$export$2e2bcd8739ae039)(onResize);
    if (element) resizeObserver.observe(element);
    return function() {
        resizeObserver.disconnect();
    };
}


function $fb481fd9c8236790$var$getElement(func) {
    if (typeof func !== 'function') return null;
    return func();
}
function $fb481fd9c8236790$var$getPoint(point) {
    if ((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(point) !== 'object' || !point) return null;
    return point;
}
var $fb481fd9c8236790$var$Align = function Align(_ref, ref) {
    var children = _ref.children, disabled = _ref.disabled, target = _ref.target, align = _ref.align, onAlign = _ref.onAlign, monitorWindowResize = _ref.monitorWindowResize, _ref$monitorBufferTim = _ref.monitorBufferTime, monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
    var cacheRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef({});
    /** Popup node ref */ var nodeRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef();
    var childNode = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Children.only(children); // ===================== Align ======================
    // We save the props here to avoid closure makes props ood
    var forceAlignPropsRef = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useRef({});
    forceAlignPropsRef.current.disabled = disabled;
    forceAlignPropsRef.current.target = target;
    forceAlignPropsRef.current.align = align;
    forceAlignPropsRef.current.onAlign = onAlign;
    var _useBuffer = (0, $cfd025d245abcd49$export$2e2bcd8739ae039)(function() {
        var _forceAlignPropsRef$c = forceAlignPropsRef.current, latestDisabled = _forceAlignPropsRef$c.disabled, latestTarget = _forceAlignPropsRef$c.target, latestAlign = _forceAlignPropsRef$c.align, latestOnAlign = _forceAlignPropsRef$c.onAlign;
        var source = nodeRef.current;
        if (!latestDisabled && latestTarget && source) {
            var _result;
            var _element = $fb481fd9c8236790$var$getElement(latestTarget);
            var _point = $fb481fd9c8236790$var$getPoint(latestTarget);
            cacheRef.current.element = _element;
            cacheRef.current.point = _point;
            cacheRef.current.align = latestAlign; // IE lose focus after element realign
            // We should record activeElement and restore later
            var _document = document, activeElement = _document.activeElement; // We only align when element is visible
            if (_element && (0, $bd5eba434ae00c04$export$2e2bcd8739ae039)(_element)) _result = (0, $ee01477f51c72f40$export$ec21431d5ee6c534)(source, _element, latestAlign);
            else if (_point) _result = (0, $ee01477f51c72f40$export$38f0e12f0aa28098)(source, _point, latestAlign);
            (0, $e73c72d6f5cf5ab6$export$2284e449d64b22d5)(activeElement, source);
            if (latestOnAlign && _result) latestOnAlign(source, _result);
            return true;
        }
        return false;
    }, monitorBufferTime), _useBuffer2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useBuffer, 2), _forceAlign = _useBuffer2[0], cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
    // Handle props change
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(), _React$useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
    var _React$useState3 = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useState(), _React$useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState3, 2), point = _React$useState4[0], setPoint = _React$useState4[1];
    (0, $37eabd4bcc9d6b73$export$2e2bcd8739ae039)(function() {
        setElement($fb481fd9c8236790$var$getElement(target));
        setPoint($fb481fd9c8236790$var$getPoint(target));
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        if (cacheRef.current.element !== element || !(0, $e73c72d6f5cf5ab6$export$792a4d7b8e9efb33)(cacheRef.current.point, point) || !(0, $b413b124a411084b$export$2e2bcd8739ae039)(cacheRef.current.align, align)) _forceAlign();
    }); // Watch popup element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        var cancelFn = (0, $e73c72d6f5cf5ab6$export$f56787db9e74dfe)(nodeRef.current, _forceAlign);
        return cancelFn;
    }, [
        nodeRef.current
    ]); // Watch target element resize
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        var cancelFn = (0, $e73c72d6f5cf5ab6$export$f56787db9e74dfe)(element, _forceAlign);
        return cancelFn;
    }, [
        element
    ]); // Listen for disabled change
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        if (!disabled) _forceAlign();
        else cancelForceAlign();
    }, [
        disabled
    ]); // Listen for window resize
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        if (monitorWindowResize) {
            var cancelFn = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(window, 'resize', _forceAlign);
            return cancelFn.remove;
        }
    }, [
        monitorWindowResize
    ]); // Clear all if unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useEffect(function() {
        return function() {
            cancelForceAlign();
        };
    }, []); // ====================== Ref =======================
    (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {
                return _forceAlign(true);
            }
        };
    }); // ===================== Render =====================
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).isValidElement(childNode)) childNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).cloneElement(childNode, {
        ref: (0, $c8cde685aa40b754$export$ab452c34e8e05029)(childNode.ref, nodeRef)
    });
    return childNode;
};
var $fb481fd9c8236790$var$RcAlign = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).forwardRef($fb481fd9c8236790$var$Align);
$fb481fd9c8236790$var$RcAlign.displayName = 'Align';
var $fb481fd9c8236790$export$2e2bcd8739ae039 = $fb481fd9c8236790$var$RcAlign;


var $56c9493c97b907cd$export$2e2bcd8739ae039 = (0, $fb481fd9c8236790$export$2e2bcd8739ae039);






function $35ad2cb724adf131$export$2e2bcd8739ae039() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ 
    $35ad2cb724adf131$export$2e2bcd8739ae039 = function _regeneratorRuntime() {
        return r;
    };
    var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag";
    function c(t, r, e, n) {
        return Object.defineProperty(t, r, {
            value: e,
            enumerable: !n,
            configurable: !n,
            writable: !n
        });
    }
    try {
        c({}, "");
    } catch (t) {
        c = function c(t, r, e) {
            return t[r] = e;
        };
    }
    function h(r, e, n, o) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype);
        return c(a, "_invoke", function(r, e, n) {
            var o = 1;
            return function(i, a) {
                if (3 === o) throw Error("Generator is already running");
                if (4 === o) {
                    if ("throw" === i) throw a;
                    return {
                        value: t,
                        done: !0
                    };
                }
                for(n.method = i, n.arg = a;;){
                    var u = n.delegate;
                    if (u) {
                        var c = d(u, n);
                        if (c) {
                            if (c === f) continue;
                            return c;
                        }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;
                    else if ("throw" === n.method) {
                        if (1 === o) throw o = 4, n.arg;
                        n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    o = 3;
                    var h = s(r, e, n);
                    if ("normal" === h.type) {
                        if (o = n.done ? 4 : 2, h.arg === f) continue;
                        return {
                            value: h.arg,
                            done: n.done
                        };
                    }
                    "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg);
                }
            };
        }(r, n, new Context(o || [])), !0), a;
    }
    function s(t, r, e) {
        try {
            return {
                type: "normal",
                arg: t.call(r, e)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    r.wrap = h;
    var f = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var l = {};
    c(l, i, function() {
        return this;
    });
    var p = Object.getPrototypeOf, y = p && p(p(x([])));
    y && y !== e && n.call(y, i) && (l = y);
    var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l);
    function g(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(r) {
            c(t, r, function(t) {
                return this._invoke(r, t);
            });
        });
    }
    function AsyncIterator(t, r) {
        function e(o, i, a, u) {
            var c = s(t[o], t, i);
            if ("throw" !== c.type) {
                var h = c.arg, f = h.value;
                return f && "object" == (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function(t) {
                    e("next", t, a, u);
                }, function(t) {
                    e("throw", t, a, u);
                }) : r.resolve(f).then(function(t) {
                    h.value = t, a(h);
                }, function(t) {
                    return e("throw", t, a, u);
                });
            }
            u(c.arg);
        }
        var o;
        c(this, "_invoke", function(t, n) {
            function i() {
                return new r(function(r, o) {
                    e(t, n, r, o);
                });
            }
            return o = o ? o.then(i, i) : i();
        }, !0);
    }
    function d(r, e) {
        var n = e.method, o = r.i[n];
        if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f;
        var i = s(o, r.i, e.arg);
        if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f;
        var a = i.arg;
        return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f);
    }
    function w(t) {
        this.tryEntries.push(t);
    }
    function m(r) {
        var e = r[4] || {};
        e.type = "normal", e.arg = t, r[4] = e;
    }
    function Context(t) {
        this.tryEntries = [
            [
                -1
            ]
        ], t.forEach(w, this), this.reset(!0);
    }
    function x(r) {
        if (null != r) {
            var e = r[i];
            if (e) return e.call(r);
            if ("function" == typeof r.next) return r;
            if (!isNaN(r.length)) {
                var o = -1, a = function e() {
                    for(; ++o < r.length;)if (n.call(r, o)) return e.value = r[o], e.done = !1, e;
                    return e.value = t, e.done = !0, e;
                };
                return a.next = a;
            }
        }
        throw new TypeError((0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(r) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function(t) {
        var r = "function" == typeof t && t.constructor;
        return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name));
    }, r.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t;
    }, r.awrap = function(t) {
        return {
            __await: t
        };
    }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function() {
        return this;
    }), r.AsyncIterator = AsyncIterator, r.async = function(t, e, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(h(t, e, n, o), i);
        return r.isGeneratorFunction(e) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, g(v), c(v, u, "Generator"), c(v, i, function() {
        return this;
    }), c(v, "toString", function() {
        return "[object Generator]";
    }), r.keys = function(t) {
        var r = Object(t), e = [];
        for(var n in r)e.unshift(n);
        return function t() {
            for(; e.length;)if ((n = e.pop()) in r) return t.value = n, t.done = !1, t;
            return t.done = !0, t;
        };
    }, r.values = x, Context.prototype = {
        constructor: Context,
        reset: function reset(r) {
            if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for(var e in this)"t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0][4];
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(r) {
            if (this.done) throw r;
            var e = this;
            function n(t) {
                a.type = "throw", a.arg = r, e.next = t;
            }
            for(var o = e.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2];
                if (-1 === i[0]) return n("end"), !1;
                if (!c && !h) throw Error("try statement without catch or finally");
                if (null != i[0] && i[0] <= u) {
                    if (u < c) return this.method = "next", this.arg = t, n(c), !0;
                    if (u < h) return n(h), !1;
                }
            }
        },
        abrupt: function abrupt(t, r) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var n = this.tryEntries[e];
                if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) {
                    var o = n;
                    break;
                }
            }
            o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null);
            var i = o ? o[4] : {};
            return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i);
        },
        complete: function complete(t, r) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f;
        },
        finish: function finish(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[2] === t) return this.complete(e[4], e[3]), m(e), f;
            }
        },
        "catch": function _catch(t) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var e = this.tryEntries[r];
                if (e[0] === t) {
                    var n = e[4];
                    if ("throw" === n.type) {
                        var o = n.arg;
                        m(e);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(r, e, n) {
            return this.delegate = {
                i: x(r),
                r: e,
                n: n
            }, "next" === this.method && (this.arg = t), f;
        }
    }, r;
}


function $62a39180cabdbc6d$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $62a39180cabdbc6d$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $62a39180cabdbc6d$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $62a39180cabdbc6d$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}




var $dup7A = parcelRequire("dup7A");


/**
 * Popup should follow the steps for each component work correctly:
 * measure - check for the current stretch size
 * align - let component align the position
 * aligned - re-align again in case additional className changed the size
 * afterAlign - choice next step is trigger motion or finished
 * beforeMotion - should reset motion to invisible so that CSSMotion can do normal motion
 * motion - play the motion
 * stable - everything is done
 */ var $5dab434e4bd2d48a$var$StatusQueue = [
    'measure',
    'alignPre',
    'align',
    null,
    'motion'
];
var $5dab434e4bd2d48a$export$2e2bcd8739ae039 = function(visible, doMeasure) {
    var _useState = (0, $c8504fa916dc6fc0$export$2e2bcd8739ae039)(null), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), status = _useState2[0], setInternalStatus = _useState2[1];
    var rafRef = (0, $dup7A.useRef)();
    function setStatus(nextStatus) {
        setInternalStatus(nextStatus, true);
    }
    function cancelRaf() {
        (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function goNextStatus(callback) {
        cancelRaf();
        rafRef.current = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
            // Only align should be manually trigger
            setStatus(function(prev) {
                switch(status){
                    case 'align':
                        return 'motion';
                    case 'motion':
                        return 'stable';
                    default:
                }
                return prev;
            });
            callback === null || callback === void 0 || callback();
        });
    } // Init status
    (0, $dup7A.useEffect)(function() {
        setStatus('measure');
    }, [
        visible
    ]); // Go next status
    (0, $dup7A.useEffect)(function() {
        switch(status){
            case 'measure':
                doMeasure();
                break;
            default:
        }
        if (status) rafRef.current = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $62a39180cabdbc6d$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $35ad2cb724adf131$export$2e2bcd8739ae039)().mark(function _callee() {
            var index, nextStatus;
            return (0, $35ad2cb724adf131$export$2e2bcd8739ae039)().wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        index = $5dab434e4bd2d48a$var$StatusQueue.indexOf(status);
                        nextStatus = $5dab434e4bd2d48a$var$StatusQueue[index + 1];
                        if (nextStatus && index !== -1) setStatus(nextStatus);
                    case 3:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        })));
    }, [
        status
    ]);
    (0, $dup7A.useEffect)(function() {
        return function() {
            cancelRaf();
        };
    }, []);
    return [
        status,
        goNextStatus
    ];
};





var $dup7A = parcelRequire("dup7A");
var $bb943f37c44407d1$export$2e2bcd8739ae039 = function(stretch) {
    var _React$useState = $dup7A.useState({
        width: 0,
        height: 0
    }), _React$useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_React$useState, 2), targetSize = _React$useState2[0], setTargetSize = _React$useState2[1];
    function measureStretch(element) {
        var tgtWidth = element.offsetWidth, tgtHeight = element.offsetHeight;
        var _element$getBoundingC = element.getBoundingClientRect(), width = _element$getBoundingC.width, height = _element$getBoundingC.height; // Rect is more accurate than offset, use if near
        if (Math.abs(tgtWidth - width) < 1 && Math.abs(tgtHeight - height) < 1) {
            tgtWidth = width;
            tgtHeight = height;
        }
        setTargetSize({
            width: tgtWidth,
            height: tgtHeight
        });
    } // Merge stretch style
    var style = $dup7A.useMemo(function() {
        var sizeStyle = {};
        if (stretch) {
            var width = targetSize.width, height = targetSize.height; // Stretch with target
            if (stretch.indexOf('height') !== -1 && height) sizeStyle.height = height;
            else if (stretch.indexOf('minHeight') !== -1 && height) sizeStyle.minHeight = height;
            if (stretch.indexOf('width') !== -1 && width) sizeStyle.width = width;
            else if (stretch.indexOf('minWidth') !== -1 && width) sizeStyle.minWidth = width;
        }
        return sizeStyle;
    }, [
        stretch,
        targetSize
    ]);
    return [
        style,
        measureStretch
    ];
};


var $195532be8f53f650$var$PopupInner = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
    var visible = props.visible, prefixCls = props.prefixCls, className = props.className, style = props.style, children = props.children, zIndex = props.zIndex, stretch = props.stretch, destroyPopupOnHide = props.destroyPopupOnHide, forceRender = props.forceRender, align = props.align, point = props.point, getRootDomNode = props.getRootDomNode, getClassNameFromAlign = props.getClassNameFromAlign, onAlign = props.onAlign, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onMouseDown = props.onMouseDown, onTouchStart = props.onTouchStart, onClick = props.onClick;
    var alignRef = (0, $dup7A.useRef)();
    var elementRef = (0, $dup7A.useRef)();
    var _useState = (0, $dup7A.useState)(), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), alignedClassName = _useState2[0], setAlignedClassName = _useState2[1]; // ======================= Measure ========================
    var _useStretchStyle = (0, $bb943f37c44407d1$export$2e2bcd8739ae039)(stretch), _useStretchStyle2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useStretchStyle, 2), stretchStyle = _useStretchStyle2[0], measureStretchStyle = _useStretchStyle2[1];
    function doMeasure() {
        if (stretch) measureStretchStyle(getRootDomNode());
    } // ======================== Status ========================
    var _useVisibleStatus = (0, $5dab434e4bd2d48a$export$2e2bcd8739ae039)(visible, doMeasure), _useVisibleStatus2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useVisibleStatus, 2), status = _useVisibleStatus2[0], goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================
    /**
   * `alignedClassName` may modify `source` size,
   * which means one time align may not move to the correct position at once.
   *
   * We will reset `alignTimes` for each status switch to `alignPre`
   * and let `rc-align` to align for multiple times to ensure get final stable place.
   * Currently we mark `alignTimes < 2` repeat align, it will increase if user report for align issue.
   * 
   * Update:
   * In React 18. `rc-align` effect of align may faster than ref called trigger `forceAlign`.
   * We adjust this to `alignTimes < 2`.
   * We need refactor `rc-align` to support mark of `forceAlign` call if this still happen.
   */ var _useState3 = (0, $dup7A.useState)(0), _useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState3, 2), alignTimes = _useState4[0], setAlignTimes = _useState4[1];
    var prepareResolveRef = (0, $dup7A.useRef)();
    (0, $37eabd4bcc9d6b73$export$2e2bcd8739ae039)(function() {
        if (status === 'alignPre') setAlignTimes(0);
    }, [
        status
    ]); // `target` on `rc-align` can accept as a function to get the bind element or a point.
    // ref: https://www.npmjs.com/package/rc-align
    function getAlignTarget() {
        if (point) return point;
        return getRootDomNode;
    }
    function forceAlign() {
        var _alignRef$current;
        (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 || _alignRef$current.forceAlign();
    }
    function onInternalAlign(popupDomNode, matchAlign) {
        var nextAlignedClassName = getClassNameFromAlign(matchAlign);
        if (alignedClassName !== nextAlignedClassName) setAlignedClassName(nextAlignedClassName);
         // We will retry multi times to make sure that the element has been align in the right position.
        setAlignTimes(function(val) {
            return val + 1;
        });
        if (status === 'align') onAlign === null || onAlign === void 0 || onAlign(popupDomNode, matchAlign);
    } // Delay to go to next status
    (0, $37eabd4bcc9d6b73$export$2e2bcd8739ae039)(function() {
        if (status === 'align') {
            // Repeat until not more align needed
            if (alignTimes < 3) forceAlign();
            else goNextStatus(function() {
                var _prepareResolveRef$cu;
                (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 || _prepareResolveRef$cu.call(prepareResolveRef);
            });
        }
    }, [
        alignTimes
    ]); // ======================== Motion ========================
    var motion = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, (0, $19b9bb9355821eae$export$7b8936ddc277a29a)(props));
    [
        'onAppearEnd',
        'onEnterEnd',
        'onLeaveEnd'
    ].forEach(function(eventName) {
        var originHandler = motion[eventName];
        motion[eventName] = function(element, event) {
            goNextStatus();
            return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
        };
    });
    function onShowPrepare() {
        return new Promise(function(resolve) {
            prepareResolveRef.current = resolve;
        });
    } // Go to stable directly when motion not provided
    $dup7A.useEffect(function() {
        if (!motion.motionName && status === 'motion') goNextStatus();
    }, [
        motion.motionName,
        status
    ]); // ========================= Refs =========================
    $dup7A.useImperativeHandle(ref, function() {
        return {
            forceAlign: forceAlign,
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, stretchStyle), {}, {
        zIndex: zIndex,
        opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
        // Cannot interact with disappearing elements
        // https://github.com/ant-design/ant-design/issues/35051#issuecomment-1101340714
        pointerEvents: !visible && status !== 'stable' ? 'none' : undefined
    }, style); // Align status
    var alignDisabled = true;
    if (align !== null && align !== void 0 && align.points && (status === 'align' || status === 'stable')) alignDisabled = false;
    var childNode = children; // Wrapper when multiple children
    if ($dup7A.Children.count(children) > 1) childNode = /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
    return /*#__PURE__*/ $dup7A.createElement((0, $e2f8ecce9d0083b7$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
        onAppearPrepare: onShowPrepare,
        onEnterPrepare: onShowPrepare,
        removeOnLeave: destroyPopupOnHide,
        forceRender: forceRender
    }), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(prefixCls, className, alignedClassName, motionClassName);
        return /*#__PURE__*/ $dup7A.createElement((0, $56c9493c97b907cd$export$2e2bcd8739ae039), {
            target: getAlignTarget(),
            key: "popup",
            ref: alignRef,
            monitorWindowResize: true,
            disabled: alignDisabled,
            align: align,
            onAlign: onInternalAlign
        }, /*#__PURE__*/ $dup7A.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onMouseDownCapture: onMouseDown,
            onTouchStartCapture: onTouchStart,
            onClick: onClick,
            style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode));
    });
});
$195532be8f53f650$var$PopupInner.displayName = 'PopupInner';
var $195532be8f53f650$export$2e2bcd8739ae039 = $195532be8f53f650$var$PopupInner;





var $dup7A = parcelRequire("dup7A");


var $616659e41ceab681$var$MobilePopupInner = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
    var prefixCls = props.prefixCls, visible = props.visible, zIndex = props.zIndex, children = props.children, _props$mobile = props.mobile;
    _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
    var popupClassName = _props$mobile.popupClassName, popupStyle = _props$mobile.popupStyle, _props$mobile$popupMo = _props$mobile.popupMotion, popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo, popupRender = _props$mobile.popupRender, onClick = props.onClick;
    var elementRef = $dup7A.useRef(); // ========================= Refs =========================
    $dup7A.useImperativeHandle(ref, function() {
        return {
            forceAlign: function forceAlign() {},
            getElement: function getElement() {
                return elementRef.current;
            }
        };
    }); // ======================== Render ========================
    var mergedStyle = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({
        zIndex: zIndex
    }, popupStyle);
    var childNode = children; // Wrapper when multiple children
    if ($dup7A.Children.count(children) > 1) childNode = /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-content")
    }, children);
     // Mobile support additional render
    if (popupRender) childNode = popupRender(childNode);
    return /*#__PURE__*/ $dup7A.createElement((0, $e2f8ecce9d0083b7$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({
        visible: visible,
        ref: elementRef,
        removeOnLeave: true
    }, popupMotion), function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        var mergedClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(prefixCls, popupClassName, motionClassName);
        return /*#__PURE__*/ $dup7A.createElement("div", {
            ref: motionRef,
            className: mergedClassName,
            onClick: onClick,
            style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, motionStyle), mergedStyle)
        }, childNode);
    });
});
$616659e41ceab681$var$MobilePopupInner.displayName = 'MobilePopupInner';
var $616659e41ceab681$export$2e2bcd8739ae039 = $616659e41ceab681$var$MobilePopupInner;


var $2a84774eafc6a0a8$var$_excluded = [
    "visible",
    "mobile"
];
var $2a84774eafc6a0a8$var$Popup = /*#__PURE__*/ $dup7A.forwardRef(function(_ref, ref) {
    var visible = _ref.visible, mobile = _ref.mobile, props = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref, $2a84774eafc6a0a8$var$_excluded);
    var _useState = (0, $dup7A.useState)(visible), _useState2 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState, 2), innerVisible = _useState2[0], serInnerVisible = _useState2[1];
    var _useState3 = (0, $dup7A.useState)(false), _useState4 = (0, $e3c5c95746af2d29$export$2e2bcd8739ae039)(_useState3, 2), inMobile = _useState4[0], setInMobile = _useState4[1];
    var cloneProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, props), {}, {
        visible: innerVisible
    }); // We check mobile in visible changed here.
    // And this also delay set `innerVisible` to avoid popup component render flash
    (0, $dup7A.useEffect)(function() {
        serInnerVisible(visible);
        if (visible && mobile) setInMobile((0, $cee396e5c47a9a3c$export$2e2bcd8739ae039)());
    }, [
        visible,
        mobile
    ]);
    var popupNode = inMobile ? /*#__PURE__*/ $dup7A.createElement((0, $616659e41ceab681$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, cloneProps, {
        mobile: mobile,
        ref: ref
    })) : /*#__PURE__*/ $dup7A.createElement((0, $195532be8f53f650$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, cloneProps, {
        ref: ref
    })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic
    return /*#__PURE__*/ $dup7A.createElement("div", null, /*#__PURE__*/ $dup7A.createElement((0, $f81d310fac5ffb12$export$2e2bcd8739ae039), cloneProps), popupNode);
});
$2a84774eafc6a0a8$var$Popup.displayName = 'Popup';
var $2a84774eafc6a0a8$export$2e2bcd8739ae039 = $2a84774eafc6a0a8$var$Popup;



var $dup7A = parcelRequire("dup7A");
var $740543d9906a47f1$var$TriggerContext = /*#__PURE__*/ $dup7A.createContext(null);
var $740543d9906a47f1$export$2e2bcd8739ae039 = $740543d9906a47f1$var$TriggerContext;


function $0f4334c3c513f32d$var$noop() {}
function $0f4334c3c513f32d$var$returnEmptyString() {
    return '';
}
function $0f4334c3c513f32d$var$returnDocument(element) {
    if (element) return element.ownerDocument;
    return window.document;
}
var $0f4334c3c513f32d$var$ALL_HANDLERS = [
    'onClick',
    'onMouseDown',
    'onTouchStart',
    'onMouseEnter',
    'onMouseLeave',
    'onFocus',
    'onBlur',
    'onContextMenu'
];
function $0f4334c3c513f32d$export$55e99723d7f71b47(PortalComponent) {
    var Trigger = /*#__PURE__*/ function(_React$Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(Trigger, _React$Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(Trigger);
        // ensure `getContainer` will be called only once
        function Trigger(props) {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, Trigger);
            _this = _super.call(this, props);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "popupRef", /*#__PURE__*/ $dup7A.createRef());
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "triggerRef", /*#__PURE__*/ $dup7A.createRef());
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "portalContainer", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "attachId", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "clickOutsideHandler", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "touchOutsideHandler", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler1", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "contextMenuOutsideHandler2", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "mouseDownTimeout", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "focusTime", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "preClickTime", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "preTouchTime", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "delayTimer", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "hasPopupMouseDown", void 0);
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseEnter", function(e) {
                var mouseEnterDelay = _this.props.mouseEnterDelay;
                _this.fireEvents('onMouseEnter', e);
                _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseMove", function(e) {
                _this.fireEvents('onMouseMove', e);
                _this.setPoint(e);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseLeave", function(e) {
                _this.fireEvents('onMouseLeave', e);
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onPopupMouseEnter", function() {
                _this.clearDelayTimer();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onPopupMouseLeave", function(e) {
                var _this$popupRef$curren;
                // https://github.com/react-component/trigger/pull/13
                // react bug?
                if (e.relatedTarget && !e.relatedTarget.setTimeout && (0, $01802a99afaa475f$export$2e2bcd8739ae039)((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) return;
                _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onFocus", function(e) {
                _this.fireEvents('onFocus', e); // incase focusin and focusout
                _this.clearDelayTimer();
                if (_this.isFocusToShow()) {
                    _this.focusTime = Date.now();
                    _this.delaySetPopupVisible(true, _this.props.focusDelay);
                }
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onMouseDown", function(e) {
                _this.fireEvents('onMouseDown', e);
                _this.preClickTime = Date.now();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onTouchStart", function(e) {
                _this.fireEvents('onTouchStart', e);
                _this.preTouchTime = Date.now();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onBlur", function(e) {
                _this.fireEvents('onBlur', e);
                _this.clearDelayTimer();
                if (_this.isBlurToHide()) _this.delaySetPopupVisible(false, _this.props.blurDelay);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onContextMenu", function(e) {
                e.preventDefault();
                _this.fireEvents('onContextMenu', e);
                _this.setPopupVisible(true, e);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onContextMenuClose", function() {
                if (_this.isContextMenuToShow()) _this.close();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onClick", function(event) {
                _this.fireEvents('onClick', event); // focus will trigger click
                if (_this.focusTime) {
                    var preTime;
                    if (_this.preClickTime && _this.preTouchTime) preTime = Math.min(_this.preClickTime, _this.preTouchTime);
                    else if (_this.preClickTime) preTime = _this.preClickTime;
                    else if (_this.preTouchTime) preTime = _this.preTouchTime;
                    if (Math.abs(preTime - _this.focusTime) < 20) return;
                    _this.focusTime = 0;
                }
                _this.preClickTime = 0;
                _this.preTouchTime = 0; // Only prevent default when all the action is click.
                // https://github.com/ant-design/ant-design/issues/17043
                // https://github.com/ant-design/ant-design/issues/17291
                if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) event.preventDefault();
                var nextVisible = !_this.state.popupVisible;
                if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) _this.setPopupVisible(!_this.state.popupVisible, event);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onPopupMouseDown", function() {
                _this.hasPopupMouseDown = true;
                clearTimeout(_this.mouseDownTimeout);
                _this.mouseDownTimeout = window.setTimeout(function() {
                    _this.hasPopupMouseDown = false;
                }, 0);
                if (_this.context) {
                    var _this$context;
                    (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
                }
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "onDocumentClick", function(event) {
                if (_this.props.mask && !_this.props.maskClosable) return;
                var target = event.target;
                var root = _this.getRootDomNode();
                var popupNode = _this.getPopupDomNode();
                if (// https://github.com/ant-design/ant-design/issues/29853
                (!(0, $01802a99afaa475f$export$2e2bcd8739ae039)(root, target) || _this.isContextMenuOnly()) && !(0, $01802a99afaa475f$export$2e2bcd8739ae039)(popupNode, target) && !_this.hasPopupMouseDown) _this.close();
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getRootDomNode", function() {
                var getTriggerDOMNode = _this.props.getTriggerDOMNode;
                if (getTriggerDOMNode) return getTriggerDOMNode(_this.triggerRef.current);
                try {
                    var domNode = (0, $0b6fbe60488ddcee$export$2e2bcd8739ae039)(_this.triggerRef.current);
                    if (domNode) return domNode;
                } catch (err) {}
                return (0, (/*@__PURE__*/$parcel$interopDefault($e10f5070fc836746$exports))).findDOMNode((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this));
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getPopupClassNameFromAlign", function(align) {
                var className = [];
                var _this$props = _this.props, popupPlacement = _this$props.popupPlacement, builtinPlacements = _this$props.builtinPlacements, prefixCls = _this$props.prefixCls, alignPoint = _this$props.alignPoint, getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;
                if (popupPlacement && builtinPlacements) className.push((0, $a0e16b2c473f8d53$export$faa0aa8ed2fe6432)(builtinPlacements, prefixCls, align, alignPoint));
                if (getPopupClassNameFromAlign) className.push(getPopupClassNameFromAlign(align));
                return className.join(' ');
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getComponent", function() {
                var _this$props2 = _this.props, prefixCls = _this$props2.prefixCls, destroyPopupOnHide = _this$props2.destroyPopupOnHide, popupClassName = _this$props2.popupClassName, onPopupAlign = _this$props2.onPopupAlign, popupMotion = _this$props2.popupMotion, popupAnimation = _this$props2.popupAnimation, popupTransitionName = _this$props2.popupTransitionName, popupStyle = _this$props2.popupStyle, mask = _this$props2.mask, maskAnimation = _this$props2.maskAnimation, maskTransitionName = _this$props2.maskTransitionName, maskMotion = _this$props2.maskMotion, zIndex = _this$props2.zIndex, popup = _this$props2.popup, stretch = _this$props2.stretch, alignPoint = _this$props2.alignPoint, mobile = _this$props2.mobile, forceRender = _this$props2.forceRender, onPopupClick = _this$props2.onPopupClick;
                var _this$state = _this.state, popupVisible = _this$state.popupVisible, point = _this$state.point;
                var align = _this.getPopupAlign();
                var mouseProps = {};
                if (_this.isMouseEnterToShow()) mouseProps.onMouseEnter = _this.onPopupMouseEnter;
                if (_this.isMouseLeaveToHide()) mouseProps.onMouseLeave = _this.onPopupMouseLeave;
                mouseProps.onMouseDown = _this.onPopupMouseDown;
                mouseProps.onTouchStart = _this.onPopupMouseDown;
                return /*#__PURE__*/ $dup7A.createElement((0, $2a84774eafc6a0a8$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({
                    prefixCls: prefixCls,
                    destroyPopupOnHide: destroyPopupOnHide,
                    visible: popupVisible,
                    point: alignPoint && point,
                    className: popupClassName,
                    align: align,
                    onAlign: onPopupAlign,
                    animation: popupAnimation,
                    getClassNameFromAlign: _this.getPopupClassNameFromAlign
                }, mouseProps, {
                    stretch: stretch,
                    getRootDomNode: _this.getRootDomNode,
                    style: popupStyle,
                    mask: mask,
                    zIndex: zIndex,
                    transitionName: popupTransitionName,
                    maskAnimation: maskAnimation,
                    maskTransitionName: maskTransitionName,
                    maskMotion: maskMotion,
                    ref: _this.popupRef,
                    motion: popupMotion,
                    mobile: mobile,
                    forceRender: forceRender,
                    onClick: onPopupClick
                }), typeof popup === 'function' ? popup() : popup);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "attachParent", function(popupContainer) {
                (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(_this.attachId);
                var _this$props3 = _this.props, getPopupContainer = _this$props3.getPopupContainer, getDocument = _this$props3.getDocument;
                var domNode = _this.getRootDomNode();
                var mountNode;
                if (!getPopupContainer) mountNode = getDocument(_this.getRootDomNode()).body;
                else if (domNode || getPopupContainer.length === 0) // Compatible for legacy getPopupContainer with domNode argument.
                // If no need `domNode` argument, will call directly.
                // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
                mountNode = getPopupContainer(domNode);
                if (mountNode) mountNode.appendChild(popupContainer);
                else // Retry after frame render in case parent not ready
                _this.attachId = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
                    _this.attachParent(popupContainer);
                });
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "getContainer", function() {
                if (!_this.portalContainer) {
                    // In React.StrictMode component will call render multiple time in first mount.
                    // When you want to refactor with FC, useRef will also init multiple time and
                    // point to different useRef instance which will create multiple element
                    // (This multiple render will not trigger effect so you can not clean up this
                    // in effect). But this is safe with class component since it always point to same class instance.
                    var getDocument = _this.props.getDocument;
                    var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
                    // https://github.com/react-component/trigger/issues/41
                    popupContainer.style.position = 'absolute';
                    popupContainer.style.top = '0';
                    popupContainer.style.left = '0';
                    popupContainer.style.width = '100%';
                    _this.portalContainer = popupContainer;
                }
                _this.attachParent(_this.portalContainer);
                return _this.portalContainer;
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "setPoint", function(point) {
                var alignPoint = _this.props.alignPoint;
                if (!alignPoint || !point) return;
                _this.setState({
                    point: {
                        pageX: point.pageX,
                        pageY: point.pageY
                    }
                });
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "handlePortalUpdate", function() {
                if (_this.state.prevPopupVisible !== _this.state.popupVisible) _this.props.afterPopupVisibleChange(_this.state.popupVisible);
            });
            (0, $5e86d015ad96e244$export$2e2bcd8739ae039)((0, $e3cc1c0a9f4b2276$export$2e2bcd8739ae039)(_this), "triggerContextValue", {
                onPopupMouseDown: _this.onPopupMouseDown
            });
            var _popupVisible;
            if ('popupVisible' in props) _popupVisible = !!props.popupVisible;
            else _popupVisible = !!props.defaultPopupVisible;
            _this.state = {
                prevPopupVisible: _popupVisible,
                popupVisible: _popupVisible
            };
            $0f4334c3c513f32d$var$ALL_HANDLERS.forEach(function(h) {
                _this["fire".concat(h)] = function(e) {
                    _this.fireEvents(h, e);
                };
            });
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(Trigger, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    this.componentDidUpdate();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    var props = this.props;
                    var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
                    // https://github.com/ant-design/ant-design/issues/5804
                    // https://github.com/react-component/calendar/issues/250
                    // https://github.com/react-component/trigger/issues/50
                    if (state.popupVisible) {
                        var currentDocument;
                        if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
                            currentDocument = props.getDocument(this.getRootDomNode());
                            this.clickOutsideHandler = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(currentDocument, 'mousedown', this.onDocumentClick);
                        } // always hide on mobile
                        if (!this.touchOutsideHandler) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.touchOutsideHandler = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(currentDocument, 'touchstart', this.onDocumentClick);
                        } // close popup when trigger type contains 'onContextMenu' and document is scrolling.
                        if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
                            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
                            this.contextMenuOutsideHandler1 = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(currentDocument, 'scroll', this.onContextMenuClose);
                        } // close popup when trigger type contains 'onContextMenu' and window is blur.
                        if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) this.contextMenuOutsideHandler2 = (0, $d43892da47566d6b$export$2e2bcd8739ae039)(window, 'blur', this.onContextMenuClose);
                        return;
                    }
                    this.clearOutsideHandler();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDelayTimer();
                    this.clearOutsideHandler();
                    clearTimeout(this.mouseDownTimeout);
                    (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(this.attachId);
                }
            },
            {
                key: "getPopupDomNode",
                value: function getPopupDomNode() {
                    var _this$popupRef$curren2;
                    // for test
                    return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
                }
            },
            {
                key: "getPopupAlign",
                value: function getPopupAlign() {
                    var props = this.props;
                    var popupPlacement = props.popupPlacement, popupAlign = props.popupAlign, builtinPlacements = props.builtinPlacements;
                    if (popupPlacement && builtinPlacements) return (0, $a0e16b2c473f8d53$export$44605b74f7c5d944)(builtinPlacements, popupPlacement, popupAlign);
                    return popupAlign;
                }
            },
            {
                key: "setPopupVisible",
                value: /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */ function setPopupVisible(popupVisible, event) {
                    var alignPoint = this.props.alignPoint;
                    var prevPopupVisible = this.state.popupVisible;
                    this.clearDelayTimer();
                    if (prevPopupVisible !== popupVisible) {
                        if (!('popupVisible' in this.props)) this.setState({
                            popupVisible: popupVisible,
                            prevPopupVisible: prevPopupVisible
                        });
                        this.props.onPopupVisibleChange(popupVisible);
                    } // Always record the point position since mouseEnterDelay will delay the show
                    if (alignPoint && event && popupVisible) this.setPoint(event);
                }
            },
            {
                key: "delaySetPopupVisible",
                value: function delaySetPopupVisible(visible, delayS, event) {
                    var _this2 = this;
                    var delay = delayS * 1000;
                    this.clearDelayTimer();
                    if (delay) {
                        var point = event ? {
                            pageX: event.pageX,
                            pageY: event.pageY
                        } : null;
                        this.delayTimer = window.setTimeout(function() {
                            _this2.setPopupVisible(visible, point);
                            _this2.clearDelayTimer();
                        }, delay);
                    } else this.setPopupVisible(visible, event);
                }
            },
            {
                key: "clearDelayTimer",
                value: function clearDelayTimer() {
                    if (this.delayTimer) {
                        clearTimeout(this.delayTimer);
                        this.delayTimer = null;
                    }
                }
            },
            {
                key: "clearOutsideHandler",
                value: function clearOutsideHandler() {
                    if (this.clickOutsideHandler) {
                        this.clickOutsideHandler.remove();
                        this.clickOutsideHandler = null;
                    }
                    if (this.contextMenuOutsideHandler1) {
                        this.contextMenuOutsideHandler1.remove();
                        this.contextMenuOutsideHandler1 = null;
                    }
                    if (this.contextMenuOutsideHandler2) {
                        this.contextMenuOutsideHandler2.remove();
                        this.contextMenuOutsideHandler2 = null;
                    }
                    if (this.touchOutsideHandler) {
                        this.touchOutsideHandler.remove();
                        this.touchOutsideHandler = null;
                    }
                }
            },
            {
                key: "createTwoChains",
                value: function createTwoChains(event) {
                    var childPros = this.props.children.props;
                    var props = this.props;
                    if (childPros[event] && props[event]) return this["fire".concat(event)];
                    return childPros[event] || props[event];
                }
            },
            {
                key: "isClickToShow",
                value: function isClickToShow() {
                    var _this$props4 = this.props, action = _this$props4.action, showAction = _this$props4.showAction;
                    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isContextMenuOnly",
                value: function isContextMenuOnly() {
                    var action = this.props.action;
                    return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
                }
            },
            {
                key: "isContextMenuToShow",
                value: function isContextMenuToShow() {
                    var _this$props5 = this.props, action = _this$props5.action, showAction = _this$props5.showAction;
                    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
                }
            },
            {
                key: "isClickToHide",
                value: function isClickToHide() {
                    var _this$props6 = this.props, action = _this$props6.action, hideAction = _this$props6.hideAction;
                    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
                }
            },
            {
                key: "isMouseEnterToShow",
                value: function isMouseEnterToShow() {
                    var _this$props7 = this.props, action = _this$props7.action, showAction = _this$props7.showAction;
                    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
                }
            },
            {
                key: "isMouseLeaveToHide",
                value: function isMouseLeaveToHide() {
                    var _this$props8 = this.props, action = _this$props8.action, hideAction = _this$props8.hideAction;
                    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
                }
            },
            {
                key: "isFocusToShow",
                value: function isFocusToShow() {
                    var _this$props9 = this.props, action = _this$props9.action, showAction = _this$props9.showAction;
                    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
                }
            },
            {
                key: "isBlurToHide",
                value: function isBlurToHide() {
                    var _this$props10 = this.props, action = _this$props10.action, hideAction = _this$props10.hideAction;
                    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
                }
            },
            {
                key: "forcePopupAlign",
                value: function forcePopupAlign() {
                    if (this.state.popupVisible) {
                        var _this$popupRef$curren3;
                        (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 || _this$popupRef$curren3.forceAlign();
                    }
                }
            },
            {
                key: "fireEvents",
                value: function fireEvents(type, e) {
                    var childCallback = this.props.children.props[type];
                    if (childCallback) childCallback(e);
                    var callback = this.props[type];
                    if (callback) callback(e);
                }
            },
            {
                key: "close",
                value: function close() {
                    this.setPopupVisible(false);
                }
            },
            {
                key: "render",
                value: function render() {
                    var popupVisible = this.state.popupVisible;
                    var _this$props11 = this.props, children = _this$props11.children, forceRender = _this$props11.forceRender, alignPoint = _this$props11.alignPoint, className = _this$props11.className, autoDestroy = _this$props11.autoDestroy;
                    var child = $dup7A.Children.only(children);
                    var newChildProps = {
                        key: 'trigger'
                    }; // ============================== Visible Handlers ==============================
                    // >>> ContextMenu
                    if (this.isContextMenuToShow()) newChildProps.onContextMenu = this.onContextMenu;
                    else newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
                     // >>> Click
                    if (this.isClickToHide() || this.isClickToShow()) {
                        newChildProps.onClick = this.onClick;
                        newChildProps.onMouseDown = this.onMouseDown;
                        newChildProps.onTouchStart = this.onTouchStart;
                    } else {
                        newChildProps.onClick = this.createTwoChains('onClick');
                        newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
                        newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
                    } // >>> Hover(enter)
                    if (this.isMouseEnterToShow()) {
                        newChildProps.onMouseEnter = this.onMouseEnter; // Point align
                        if (alignPoint) newChildProps.onMouseMove = this.onMouseMove;
                    } else newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
                     // >>> Hover(leave)
                    if (this.isMouseLeaveToHide()) newChildProps.onMouseLeave = this.onMouseLeave;
                    else newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
                     // >>> Focus
                    if (this.isFocusToShow() || this.isBlurToHide()) {
                        newChildProps.onFocus = this.onFocus;
                        newChildProps.onBlur = this.onBlur;
                    } else {
                        newChildProps.onFocus = this.createTwoChains('onFocus');
                        newChildProps.onBlur = this.createTwoChains('onBlur');
                    } // =================================== Render ===================================
                    var childrenClassName = (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))(child && child.props && child.props.className, className);
                    if (childrenClassName) newChildProps.className = childrenClassName;
                    var cloneProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, newChildProps);
                    if ((0, $c8cde685aa40b754$export$c1cec34af06bcf7)(child)) cloneProps.ref = (0, $c8cde685aa40b754$export$ab452c34e8e05029)(this.triggerRef, child.ref);
                    var trigger = /*#__PURE__*/ $dup7A.cloneElement(child, cloneProps);
                    var portal; // prevent unmounting after it's rendered
                    if (popupVisible || this.popupRef.current || forceRender) portal = /*#__PURE__*/ $dup7A.createElement(PortalComponent, {
                        key: "portal",
                        getContainer: this.getContainer,
                        didUpdate: this.handlePortalUpdate
                    }, this.getComponent());
                    if (!popupVisible && autoDestroy) portal = null;
                    return /*#__PURE__*/ $dup7A.createElement((0, $740543d9906a47f1$export$2e2bcd8739ae039).Provider, {
                        value: this.triggerContextValue
                    }, trigger, portal);
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(_ref, prevState) {
                    var popupVisible = _ref.popupVisible;
                    var newState = {};
                    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
                        newState.popupVisible = popupVisible;
                        newState.prevPopupVisible = prevState.popupVisible;
                    }
                    return newState;
                }
            }
        ]);
        return Trigger;
    }($dup7A.Component);
    (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(Trigger, "contextType", (0, $740543d9906a47f1$export$2e2bcd8739ae039));
    (0, $5e86d015ad96e244$export$2e2bcd8739ae039)(Trigger, "defaultProps", {
        prefixCls: 'rc-trigger-popup',
        getPopupClassNameFromAlign: $0f4334c3c513f32d$var$returnEmptyString,
        getDocument: $0f4334c3c513f32d$var$returnDocument,
        onPopupVisibleChange: $0f4334c3c513f32d$var$noop,
        afterPopupVisibleChange: $0f4334c3c513f32d$var$noop,
        onPopupAlign: $0f4334c3c513f32d$var$noop,
        popupClassName: '',
        mouseEnterDelay: 0,
        mouseLeaveDelay: 0.1,
        focusDelay: 0,
        blurDelay: 0.15,
        popupStyle: {},
        destroyPopupOnHide: false,
        popupAlign: {},
        defaultPopupVisible: false,
        mask: false,
        maskClosable: true,
        action: [],
        showAction: [],
        hideAction: [],
        autoDestroy: false
    });
    return Trigger;
}
var $0f4334c3c513f32d$export$2e2bcd8739ae039 = $0f4334c3c513f32d$export$55e99723d7f71b47((0, $8397b35ed6f4f5c4$export$2e2bcd8739ae039));


var $bee1cf246e25a401$var$autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
var $bee1cf246e25a401$var$targetOffset = [
    0,
    0
];
var $bee1cf246e25a401$export$803cd8101b6c182b = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: $bee1cf246e25a401$var$autoAdjustOverflow,
        offset: [
            -4,
            0
        ],
        targetOffset: $bee1cf246e25a401$var$targetOffset
    }
};
var $bee1cf246e25a401$export$2e2bcd8739ae039 = $bee1cf246e25a401$export$803cd8101b6c182b;



var $dup7A = parcelRequire("dup7A");

function $d8e60f7dfcdfa318$export$2e2bcd8739ae039(props) {
    var showArrow = props.showArrow, arrowContent = props.arrowContent, children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style = props.style;
    return /*#__PURE__*/ $dup7A.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($10902e23ce058af7$exports)))("".concat(prefixCls, "-content"), className),
        style: style
    }, showArrow !== false && /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-arrow"),
        key: "arrow"
    }, arrowContent), /*#__PURE__*/ $dup7A.createElement("div", {
        className: "".concat(prefixCls, "-inner"),
        id: id,
        role: "tooltip",
        style: overlayInnerStyle
    }, typeof children === 'function' ? children() : children));
}


var $520e9651655308ca$var$_excluded = [
    "overlayClassName",
    "trigger",
    "mouseEnterDelay",
    "mouseLeaveDelay",
    "overlayStyle",
    "prefixCls",
    "children",
    "onVisibleChange",
    "afterVisibleChange",
    "transitionName",
    "animation",
    "motion",
    "placement",
    "align",
    "destroyTooltipOnHide",
    "defaultVisible",
    "getTooltipContainer",
    "overlayInnerStyle",
    "arrowContent",
    "overlay",
    "id",
    "showArrow"
];
var $520e9651655308ca$var$Tooltip = function Tooltip(props, ref) {
    var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? [
        'hover'
    ] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? 'right' : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(props, $520e9651655308ca$var$_excluded);
    var domRef = (0, $dup7A.useRef)(null);
    (0, $dup7A.useImperativeHandle)(ref, function() {
        return domRef.current;
    });
    var extraProps = (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, restProps);
    if ('visible' in props) extraProps.popupVisible = props.visible;
    var getPopupElement = function getPopupElement() {
        return /*#__PURE__*/ $dup7A.createElement((0, $d8e60f7dfcdfa318$export$2e2bcd8739ae039), {
            showArrow: showArrow,
            arrowContent: arrowContent,
            key: "content",
            prefixCls: prefixCls,
            id: id,
            overlayInnerStyle: overlayInnerStyle
        }, overlay);
    };
    var destroyTooltip = false;
    var autoDestroy = false;
    if (typeof destroyTooltipOnHide === 'boolean') destroyTooltip = destroyTooltipOnHide;
    else if (destroyTooltipOnHide && (0, $d4e0dd4084a38c17$export$2e2bcd8739ae039)(destroyTooltipOnHide) === 'object') {
        var keepParent = destroyTooltipOnHide.keepParent;
        destroyTooltip = keepParent === true;
        autoDestroy = keepParent === false;
    }
    return /*#__PURE__*/ $dup7A.createElement((0, $0f4334c3c513f32d$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({
        popupClassName: overlayClassName,
        prefixCls: prefixCls,
        popup: getPopupElement,
        action: trigger,
        builtinPlacements: (0, $bee1cf246e25a401$export$803cd8101b6c182b),
        popupPlacement: placement,
        ref: domRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltip,
        autoDestroy: autoDestroy,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
    }, extraProps), children);
};
var $520e9651655308ca$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $dup7A.forwardRef)($520e9651655308ca$var$Tooltip);



var $b96c472b2580b6a4$export$2e2bcd8739ae039 = (0, $520e9651655308ca$export$2e2bcd8739ae039);




var $ee63ddd70979cae1$var$SliderTooltip = /*#__PURE__*/ $dup7A.forwardRef(function(props, ref) {
    var visible = props.visible, overlay = props.overlay;
    var innerRef = $dup7A.useRef(null);
    var tooltipRef = (0, $c8cde685aa40b754$export$ab452c34e8e05029)(ref, innerRef);
    var rafRef = $dup7A.useRef(null);
    function cancelKeepAlign() {
        (0, $5ae5867a877ffabb$export$2e2bcd8739ae039).cancel(rafRef.current);
    }
    function keepAlign() {
        rafRef.current = (0, $5ae5867a877ffabb$export$2e2bcd8739ae039)(function() {
            var _innerRef$current;
            (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 || _innerRef$current.forcePopupAlign();
        });
    }
    $dup7A.useEffect(function() {
        if (visible) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        visible,
        overlay
    ]);
    return /*#__PURE__*/ $dup7A.createElement((0, $b96c472b2580b6a4$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({
        ref: tooltipRef
    }, props));
});
var $ee63ddd70979cae1$export$2e2bcd8739ae039 = $ee63ddd70979cae1$var$SliderTooltip;



function $dadbd822db857fd1$export$2e2bcd8739ae039(Component) {
    var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return _a = /*#__PURE__*/ function(_React$Component) {
        (0, $080b772b018ceec5$export$2e2bcd8739ae039)(ComponentWrapper, _React$Component);
        var _super = (0, $b608e4f8b4c613fa$export$2e2bcd8739ae039)(ComponentWrapper);
        function ComponentWrapper() {
            var _this;
            (0, $3a625298bae21416$export$2e2bcd8739ae039)(this, ComponentWrapper);
            _this = _super.apply(this, arguments);
            _this.state = {
                visibles: {}
            };
            _this.handleTooltipVisibleChange = function(index, visible) {
                _this.setState(function(prevState) {
                    return {
                        visibles: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)((0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, prevState.visibles), {}, (0, $5e86d015ad96e244$export$2e2bcd8739ae039)({}, index, visible))
                    };
                });
            };
            _this.handleWithTooltip = function(_ref) {
                var value = _ref.value, dragging = _ref.dragging, index = _ref.index, disabled = _ref.disabled, restProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(_ref, [
                    "value",
                    "dragging",
                    "index",
                    "disabled"
                ]);
                var _this$props = _this.props, tipFormatter = _this$props.tipFormatter, tipProps = _this$props.tipProps, handleStyle = _this$props.handleStyle, getTooltipContainer = _this$props.getTooltipContainer;
                var _tipProps$prefixCls = tipProps.prefixCls, prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls, _tipProps$overlay = tipProps.overlay, overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay, _tipProps$placement = tipProps.placement, placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement, _tipProps$visible = tipProps.visible, visible = _tipProps$visible === void 0 ? false : _tipProps$visible, restTooltipProps = (0, $fa75eafa4826b919$export$2e2bcd8739ae039)(tipProps, [
                    "prefixCls",
                    "overlay",
                    "placement",
                    "visible"
                ]);
                var handleStyleWithIndex;
                if (Array.isArray(handleStyle)) handleStyleWithIndex = handleStyle[index] || handleStyle[0];
                else handleStyleWithIndex = handleStyle;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $ee63ddd70979cae1$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, restTooltipProps, {
                    getTooltipContainer: getTooltipContainer,
                    prefixCls: prefixCls,
                    overlay: overlay,
                    placement: placement,
                    visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
                    key: index
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement((0, $be7cb93b822a2be3$export$2e2bcd8739ae039), (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, restProps, {
                    style: (0, $a24d5fade17372a9$export$2e2bcd8739ae039)({}, handleStyleWithIndex),
                    value: value,
                    onMouseEnter: function onMouseEnter() {
                        return _this.handleTooltipVisibleChange(index, true);
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this.handleTooltipVisibleChange(index, false);
                    }
                })));
            };
            return _this;
        }
        (0, $a874d781bdb225e2$export$2e2bcd8739ae039)(ComponentWrapper, [
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).createElement(Component, (0, $2ad89326f6f07287$export$2e2bcd8739ae039)({}, this.props, {
                        handle: this.handleWithTooltip
                    }));
                }
            }
        ]);
        return ComponentWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).Component), _a.defaultProps = {
        tipFormatter: function tipFormatter(value) {
            return value;
        },
        handleStyle: [
            {}
        ],
        tipProps: {},
        getTooltipContainer: function getTooltipContainer(node) {
            return node.parentNode;
        }
    }, _a;
}



var $53eb3904070cf0e9$var$InternalSlider = (0, $ceac921ac672c792$export$2e2bcd8739ae039);
$53eb3904070cf0e9$var$InternalSlider.Range = (0, $51730a1a5a927869$export$2e2bcd8739ae039);
$53eb3904070cf0e9$var$InternalSlider.Handle = (0, $be7cb93b822a2be3$export$2e2bcd8739ae039);
$53eb3904070cf0e9$var$InternalSlider.createSliderWithTooltip = (0, $dadbd822db857fd1$export$2e2bcd8739ae039);
var $53eb3904070cf0e9$export$2e2bcd8739ae039 = $53eb3904070cf0e9$var$InternalSlider;




var $dup7A = parcelRequire("dup7A");
var $48515c484bc5585a$var$a = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
function $48515c484bc5585a$var$i(t) {
    return function(e) {
        var n = e || {}, r = n.width ? String(n.width) : t.defaultWidth;
        return t.formats[r] || t.formats[t.defaultWidth];
    };
}
var $48515c484bc5585a$var$o = {
    date: $48515c484bc5585a$var$i({
        formats: {
            full: 'EEEE, MMMM do, y',
            long: 'MMMM do, y',
            medium: 'MMM d, y',
            short: 'MM/dd/yyyy'
        },
        defaultWidth: 'full'
    }),
    time: $48515c484bc5585a$var$i({
        formats: {
            full: 'h:mm:ss a zzzz',
            long: 'h:mm:ss a z',
            medium: 'h:mm:ss a',
            short: 'h:mm a'
        },
        defaultWidth: 'full'
    }),
    dateTime: $48515c484bc5585a$var$i({
        formats: {
            full: "{{date}} 'at' {{time}}",
            long: "{{date}} 'at' {{time}}",
            medium: '{{date}}, {{time}}',
            short: '{{date}}, {{time}}'
        },
        defaultWidth: 'full'
    })
}, $48515c484bc5585a$var$u = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
function $48515c484bc5585a$var$s(t) {
    return function(e, n) {
        var r, a = n || {};
        if ('formatting' === (a.context ? String(a.context) : 'standalone') && t.formattingValues) {
            var i = t.defaultFormattingWidth || t.defaultWidth, o = a.width ? String(a.width) : i;
            r = t.formattingValues[o] || t.formattingValues[i];
        } else {
            var u = t.defaultWidth, s = a.width ? String(a.width) : t.defaultWidth;
            r = t.values[s] || t.values[u];
        }
        return r[t.argumentCallback ? t.argumentCallback(e) : e];
    };
}
function $48515c484bc5585a$var$c(t) {
    return function(e, n) {
        var r = String(e), a = n || {}, i = a.width, o = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], u = r.match(o);
        if (!u) return null;
        var s, c = u[0], d = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth];
        return s = '[object Array]' === Object.prototype.toString.call(d) ? function(t, e) {
            for(var n = 0; n < t.length; n++)if (e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }) : function(t, e) {
            for(var n in t)if (t.hasOwnProperty(n) && e(t[n])) return n;
        }(d, function(t) {
            return t.test(c);
        }), s = t.valueCallback ? t.valueCallback(s) : s, {
            value: s = a.valueCallback ? a.valueCallback(s) : s,
            rest: r.slice(c.length)
        };
    };
}
var $48515c484bc5585a$var$d, $48515c484bc5585a$var$l = {
    code: 'en-US',
    formatDistance: function(t, e, n) {
        var r;
        return n = n || {}, r = 'string' == typeof $48515c484bc5585a$var$a[t] ? $48515c484bc5585a$var$a[t] : 1 === e ? $48515c484bc5585a$var$a[t].one : $48515c484bc5585a$var$a[t].other.replace('{{count}}', e), n.addSuffix ? n.comparison > 0 ? 'in ' + r : r + ' ago' : r;
    },
    formatLong: $48515c484bc5585a$var$o,
    formatRelative: function(t, e, n, r) {
        return $48515c484bc5585a$var$u[t];
    },
    localize: {
        ordinalNumber: function(t, e) {
            var n = Number(t), r = n % 100;
            if (r > 20 || r < 10) switch(r % 10){
                case 1:
                    return n + 'st';
                case 2:
                    return n + 'nd';
                case 3:
                    return n + 'rd';
            }
            return n + 'th';
        },
        era: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    'B',
                    'A'
                ],
                abbreviated: [
                    'BC',
                    'AD'
                ],
                wide: [
                    'Before Christ',
                    'Anno Domini'
                ]
            },
            defaultWidth: 'wide'
        }),
        quarter: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    '1',
                    '2',
                    '3',
                    '4'
                ],
                abbreviated: [
                    'Q1',
                    'Q2',
                    'Q3',
                    'Q4'
                ],
                wide: [
                    '1st quarter',
                    '2nd quarter',
                    '3rd quarter',
                    '4th quarter'
                ]
            },
            defaultWidth: 'wide',
            argumentCallback: function(t) {
                return Number(t) - 1;
            }
        }),
        month: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    'J',
                    'F',
                    'M',
                    'A',
                    'M',
                    'J',
                    'J',
                    'A',
                    'S',
                    'O',
                    'N',
                    'D'
                ],
                abbreviated: [
                    'Jan',
                    'Feb',
                    'Mar',
                    'Apr',
                    'May',
                    'Jun',
                    'Jul',
                    'Aug',
                    'Sep',
                    'Oct',
                    'Nov',
                    'Dec'
                ],
                wide: [
                    'January',
                    'February',
                    'March',
                    'April',
                    'May',
                    'June',
                    'July',
                    'August',
                    'September',
                    'October',
                    'November',
                    'December'
                ]
            },
            defaultWidth: 'wide'
        }),
        day: $48515c484bc5585a$var$s({
            values: {
                narrow: [
                    'S',
                    'M',
                    'T',
                    'W',
                    'T',
                    'F',
                    'S'
                ],
                short: [
                    'Su',
                    'Mo',
                    'Tu',
                    'We',
                    'Th',
                    'Fr',
                    'Sa'
                ],
                abbreviated: [
                    'Sun',
                    'Mon',
                    'Tue',
                    'Wed',
                    'Thu',
                    'Fri',
                    'Sat'
                ],
                wide: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ]
            },
            defaultWidth: 'wide'
        }),
        dayPeriod: $48515c484bc5585a$var$s({
            values: {
                narrow: {
                    am: 'a',
                    pm: 'p',
                    midnight: 'mi',
                    noon: 'n',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                },
                abbreviated: {
                    am: 'AM',
                    pm: 'PM',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                },
                wide: {
                    am: 'a.m.',
                    pm: 'p.m.',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'morning',
                    afternoon: 'afternoon',
                    evening: 'evening',
                    night: 'night'
                }
            },
            defaultWidth: 'wide',
            formattingValues: {
                narrow: {
                    am: 'a',
                    pm: 'p',
                    midnight: 'mi',
                    noon: 'n',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                },
                abbreviated: {
                    am: 'AM',
                    pm: 'PM',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                },
                wide: {
                    am: 'a.m.',
                    pm: 'p.m.',
                    midnight: 'midnight',
                    noon: 'noon',
                    morning: 'in the morning',
                    afternoon: 'in the afternoon',
                    evening: 'in the evening',
                    night: 'at night'
                }
            },
            defaultFormattingWidth: 'wide'
        })
    },
    match: {
        ordinalNumber: ($48515c484bc5585a$var$d = {
            matchPattern: /^(\d+)(th|st|nd|rd)?/i,
            parsePattern: /\d+/i,
            valueCallback: function(t) {
                return parseInt(t, 10);
            }
        }, function(t, e) {
            var n = String(t), r = e || {}, a = n.match($48515c484bc5585a$var$d.matchPattern);
            if (!a) return null;
            var i = a[0], o = n.match($48515c484bc5585a$var$d.parsePattern);
            if (!o) return null;
            var u = $48515c484bc5585a$var$d.valueCallback ? $48515c484bc5585a$var$d.valueCallback(o[0]) : o[0];
            return {
                value: u = r.valueCallback ? r.valueCallback(u) : u,
                rest: n.slice(i.length)
            };
        }),
        era: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^(b|a)/i,
                abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
                wide: /^(before christ|before common era|anno domini|common era)/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                any: [
                    /^b/i,
                    /^(a|c)/i
                ]
            },
            defaultParseWidth: 'any'
        }),
        quarter: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^[1234]/i,
                abbreviated: /^q[1234]/i,
                wide: /^[1234](th|st|nd|rd)? quarter/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                any: [
                    /1/i,
                    /2/i,
                    /3/i,
                    /4/i
                ]
            },
            defaultParseWidth: 'any',
            valueCallback: function(t) {
                return t + 1;
            }
        }),
        month: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^[jfmasond]/i,
                abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
                wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                narrow: [
                    /^j/i,
                    /^f/i,
                    /^m/i,
                    /^a/i,
                    /^m/i,
                    /^j/i,
                    /^j/i,
                    /^a/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ],
                any: [
                    /^ja/i,
                    /^f/i,
                    /^mar/i,
                    /^ap/i,
                    /^may/i,
                    /^jun/i,
                    /^jul/i,
                    /^au/i,
                    /^s/i,
                    /^o/i,
                    /^n/i,
                    /^d/i
                ]
            },
            defaultParseWidth: 'any'
        }),
        day: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^[smtwf]/i,
                short: /^(su|mo|tu|we|th|fr|sa)/i,
                abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
                wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
            },
            defaultMatchWidth: 'wide',
            parsePatterns: {
                narrow: [
                    /^s/i,
                    /^m/i,
                    /^t/i,
                    /^w/i,
                    /^t/i,
                    /^f/i,
                    /^s/i
                ],
                any: [
                    /^su/i,
                    /^m/i,
                    /^tu/i,
                    /^w/i,
                    /^th/i,
                    /^f/i,
                    /^sa/i
                ]
            },
            defaultParseWidth: 'any'
        }),
        dayPeriod: $48515c484bc5585a$var$c({
            matchPatterns: {
                narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
                any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
            },
            defaultMatchWidth: 'any',
            parsePatterns: {
                any: {
                    am: /^a/i,
                    pm: /^p/i,
                    midnight: /^mi/i,
                    noon: /^no/i,
                    morning: /morning/i,
                    afternoon: /afternoon/i,
                    evening: /evening/i,
                    night: /night/i
                }
            },
            defaultParseWidth: 'any'
        })
    },
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
function $48515c484bc5585a$var$f(t) {
    if (null === t || !0 === t || !1 === t) return NaN;
    var e = Number(t);
    return isNaN(e) ? e : e < 0 ? Math.ceil(e) : Math.floor(e);
}
function $48515c484bc5585a$var$h(t, e) {
    if (e.length < t) throw new TypeError(t + ' argument' + (t > 1 ? 's' : '') + ' required, but only ' + e.length + ' present');
}
function $48515c484bc5585a$var$m(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = Object.prototype.toString.call(t);
    return t instanceof Date || 'object' == typeof t && '[object Date]' === e ? new Date(t.getTime()) : 'number' == typeof t || '[object Number]' === e ? new Date(t) : ('string' != typeof t && '[object String]' !== e || 'undefined' == typeof console || (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"), console.warn(new Error().stack)), new Date(NaN));
}
function $48515c484bc5585a$var$w(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t).getTime(), r = $48515c484bc5585a$var$f(e);
    return new Date(n + r);
}
function $48515c484bc5585a$var$g(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$f(e);
    return $48515c484bc5585a$var$w(t, -n);
}
function $48515c484bc5585a$var$v(t, e) {
    if (null == t) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var n in e = e || {})e.hasOwnProperty(n) && (t[n] = e[n]);
    return t;
}
function $48515c484bc5585a$var$y(t, e) {
    switch(t){
        case 'P':
            return e.date({
                width: 'short'
            });
        case 'PP':
            return e.date({
                width: 'medium'
            });
        case 'PPP':
            return e.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return e.date({
                width: 'full'
            });
    }
}
function $48515c484bc5585a$var$b(t, e) {
    switch(t){
        case 'p':
            return e.time({
                width: 'short'
            });
        case 'pp':
            return e.time({
                width: 'medium'
            });
        case 'ppp':
            return e.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return e.time({
                width: 'full'
            });
    }
}
var $48515c484bc5585a$var$D = {
    p: $48515c484bc5585a$var$b,
    P: function(t, e) {
        var n, r = t.match(/(P+)(p+)?/), a = r[1], i = r[2];
        if (!i) return $48515c484bc5585a$var$y(t, e);
        switch(a){
            case 'P':
                n = e.dateTime({
                    width: 'short'
                });
                break;
            case 'PP':
                n = e.dateTime({
                    width: 'medium'
                });
                break;
            case 'PPP':
                n = e.dateTime({
                    width: 'long'
                });
                break;
            case 'PPPP':
            default:
                n = e.dateTime({
                    width: 'full'
                });
        }
        return n.replace('{{date}}', $48515c484bc5585a$var$y(a, e)).replace('{{time}}', $48515c484bc5585a$var$b(i, e));
    }
};
function $48515c484bc5585a$var$T(t) {
    return t.getTime() % 6e4;
}
function $48515c484bc5585a$var$p(t) {
    var e = new Date(t.getTime()), n = Math.ceil(e.getTimezoneOffset());
    return e.setSeconds(0, 0), 6e4 * n + (n > 0 ? (6e4 + $48515c484bc5585a$var$T(e)) % 6e4 : $48515c484bc5585a$var$T(e));
}
var $48515c484bc5585a$var$k = [
    'D',
    'DD'
], $48515c484bc5585a$var$x = [
    'YY',
    'YYYY'
];
function $48515c484bc5585a$var$C(t) {
    return -1 !== $48515c484bc5585a$var$k.indexOf(t);
}
function $48515c484bc5585a$var$M(t) {
    return -1 !== $48515c484bc5585a$var$x.indexOf(t);
}
function $48515c484bc5585a$var$U(t) {
    if ('YYYY' === t) throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
    if ('YY' === t) throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
    if ('D' === t) throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
    if ('DD' === t) throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
}
function $48515c484bc5585a$var$S(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $48515c484bc5585a$var$f(a), o = null == n.weekStartsOn ? i : $48515c484bc5585a$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var u = $48515c484bc5585a$var$m(t), s = u.getUTCDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setUTCDate(u.getUTCDate() - c), u.setUTCHours(0, 0, 0, 0), u;
}
function $48515c484bc5585a$var$P(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = $48515c484bc5585a$var$m(t, e), r = n.getUTCFullYear(), a = e || {}, i = a.locale, o = i && i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $48515c484bc5585a$var$f(o), s = null == a.firstWeekContainsDate ? u : $48515c484bc5585a$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var c = new Date(0);
    c.setUTCFullYear(r + 1, 0, s), c.setUTCHours(0, 0, 0, 0);
    var d = $48515c484bc5585a$var$S(c, e), l = new Date(0);
    l.setUTCFullYear(r, 0, s), l.setUTCHours(0, 0, 0, 0);
    var w = $48515c484bc5585a$var$S(l, e);
    return n.getTime() >= d.getTime() ? r + 1 : n.getTime() >= w.getTime() ? r : r - 1;
}
function $48515c484bc5585a$var$E(t, e, n) {
    $48515c484bc5585a$var$h(2, arguments);
    var r = n || {}, a = r.locale, i = a && a.options && a.options.weekStartsOn, o = null == i ? 0 : $48515c484bc5585a$var$f(i), u = null == r.weekStartsOn ? o : $48515c484bc5585a$var$f(r.weekStartsOn);
    if (!(u >= 0 && u <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var s = $48515c484bc5585a$var$m(t), c = $48515c484bc5585a$var$f(e), d = s.getUTCDay(), l = c % 7, w = (l + 7) % 7, g = (w < u ? 7 : 0) + c - d;
    return s.setUTCDate(s.getUTCDate() + g), s;
}
function $48515c484bc5585a$var$Y(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = 1, n = $48515c484bc5585a$var$m(t), r = n.getUTCDay(), a = (r < e ? 7 : 0) + r - e;
    return n.setUTCDate(n.getUTCDate() - a), n.setUTCHours(0, 0, 0, 0), n;
}
function $48515c484bc5585a$var$N(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t), n = e.getUTCFullYear(), r = new Date(0);
    r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
    var a = $48515c484bc5585a$var$Y(r), i = new Date(0);
    i.setUTCFullYear(n, 0, 4), i.setUTCHours(0, 0, 0, 0);
    var o = $48515c484bc5585a$var$Y(i);
    return e.getTime() >= a.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function $48515c484bc5585a$var$q(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$N(t), n = new Date(0);
    n.setUTCFullYear(e, 0, 4), n.setUTCHours(0, 0, 0, 0);
    var r = $48515c484bc5585a$var$Y(n);
    return r;
}
function $48515c484bc5585a$var$B(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t), n = $48515c484bc5585a$var$Y(e).getTime() - $48515c484bc5585a$var$q(e).getTime();
    return Math.round(n / 6048e5) + 1;
}
function $48515c484bc5585a$var$O(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.firstWeekContainsDate, i = null == a ? 1 : $48515c484bc5585a$var$f(a), o = null == n.firstWeekContainsDate ? i : $48515c484bc5585a$var$f(n.firstWeekContainsDate), u = $48515c484bc5585a$var$P(t, e), s = new Date(0);
    s.setUTCFullYear(u, 0, o), s.setUTCHours(0, 0, 0, 0);
    var c = $48515c484bc5585a$var$S(s, e);
    return c;
}
function $48515c484bc5585a$var$H(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$S(n, e).getTime() - $48515c484bc5585a$var$O(n, e).getTime();
    return Math.round(r / 6048e5) + 1;
}
var $48515c484bc5585a$var$L = /^(1[0-2]|0?\d)/, $48515c484bc5585a$var$W = /^(3[0-1]|[0-2]?\d)/, $48515c484bc5585a$var$F = /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/, $48515c484bc5585a$var$Q = /^(5[0-3]|[0-4]?\d)/, $48515c484bc5585a$var$R = /^(2[0-3]|[0-1]?\d)/, $48515c484bc5585a$var$I = /^(2[0-4]|[0-1]?\d)/, $48515c484bc5585a$var$X = /^(1[0-1]|0?\d)/, $48515c484bc5585a$var$G = /^(1[0-2]|0?\d)/, $48515c484bc5585a$var$A = /^[0-5]?\d/, $48515c484bc5585a$var$z = /^[0-5]?\d/, $48515c484bc5585a$var$j = /^\d/, $48515c484bc5585a$var$K = /^\d{1,2}/, $48515c484bc5585a$var$J = /^\d{1,3}/, $48515c484bc5585a$var$Z = /^\d{1,4}/, $48515c484bc5585a$var$_ = /^-?\d+/, $48515c484bc5585a$var$$ = /^-?\d/, $48515c484bc5585a$var$V = /^-?\d{1,2}/, $48515c484bc5585a$var$tt = /^-?\d{1,3}/, $48515c484bc5585a$var$et = /^-?\d{1,4}/, $48515c484bc5585a$var$nt = /^([+-])(\d{2})(\d{2})?|Z/, $48515c484bc5585a$var$rt = /^([+-])(\d{2})(\d{2})|Z/, $48515c484bc5585a$var$at = /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/, $48515c484bc5585a$var$it = /^([+-])(\d{2}):(\d{2})|Z/, $48515c484bc5585a$var$ot = /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/;
function $48515c484bc5585a$var$ut(t, e, n) {
    var r = e.match(t);
    if (!r) return null;
    var a = parseInt(r[0], 10);
    return {
        value: n ? n(a) : a,
        rest: e.slice(r[0].length)
    };
}
function $48515c484bc5585a$var$st(t, e) {
    var n = e.match(t);
    return n ? 'Z' === n[0] ? {
        value: 0,
        rest: e.slice(1)
    } : {
        value: ('+' === n[1] ? 1 : -1) * (36e5 * (n[2] ? parseInt(n[2], 10) : 0) + 6e4 * (n[3] ? parseInt(n[3], 10) : 0) + 1e3 * (n[5] ? parseInt(n[5], 10) : 0)),
        rest: e.slice(n[0].length)
    } : null;
}
function $48515c484bc5585a$var$ct(t, e) {
    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$_, t, e);
}
function $48515c484bc5585a$var$dt(t, e, n) {
    switch(t){
        case 1:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$j, e, n);
        case 2:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$K, e, n);
        case 3:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$J, e, n);
        case 4:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$Z, e, n);
        default:
            return $48515c484bc5585a$var$ut(new RegExp('^\\d{1,' + t + '}'), e, n);
    }
}
function $48515c484bc5585a$var$lt(t, e, n) {
    switch(t){
        case 1:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$$, e, n);
        case 2:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$V, e, n);
        case 3:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$tt, e, n);
        case 4:
            return $48515c484bc5585a$var$ut($48515c484bc5585a$var$et, e, n);
        default:
            return $48515c484bc5585a$var$ut(new RegExp('^-?\\d{1,' + t + '}'), e, n);
    }
}
function $48515c484bc5585a$var$ft(t) {
    switch(t){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $48515c484bc5585a$var$ht(t, e) {
    var n, r = e > 0, a = r ? e : 1 - e;
    if (a <= 50) n = t || 100;
    else {
        var i = a + 50;
        n = t + 100 * Math.floor(i / 100) - (t >= i % 100 ? 100 : 0);
    }
    return r ? n : 1 - n;
}
var $48515c484bc5585a$var$mt = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
], $48515c484bc5585a$var$wt = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $48515c484bc5585a$var$gt(t) {
    return t % 400 == 0 || t % 4 == 0 && t % 100 != 0;
}
var $48515c484bc5585a$var$vt = {
    G: {
        priority: 140,
        parse: function(t, e, n, r) {
            switch(e){
                case 'G':
                case 'GG':
                case 'GGG':
                    return n.era(t, {
                        width: 'abbreviated'
                    }) || n.era(t, {
                        width: 'narrow'
                    });
                case 'GGGGG':
                    return n.era(t, {
                        width: 'narrow'
                    });
                case 'GGGG':
                default:
                    return n.era(t, {
                        width: 'wide'
                    }) || n.era(t, {
                        width: 'abbreviated'
                    }) || n.era(t, {
                        width: 'narrow'
                    });
            }
        },
        set: function(t, e, n, r) {
            return e.era = n, t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'R',
            'u',
            't',
            'T'
        ]
    },
    y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: 'yy' === e
                };
            };
            switch(e){
                case 'y':
                    return $48515c484bc5585a$var$dt(4, t, a);
                case 'yo':
                    return n.ordinalNumber(t, {
                        unit: 'year',
                        valueCallback: a
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCFullYear();
            if (n.isTwoDigitYear) {
                var i = $48515c484bc5585a$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
            }
            var o = 'era' in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    Y: {
        priority: 130,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return {
                    year: t,
                    isTwoDigitYear: 'YY' === e
                };
            };
            switch(e){
                case 'Y':
                    return $48515c484bc5585a$var$dt(4, t, a);
                case 'Yo':
                    return n.ordinalNumber(t, {
                        unit: 'year',
                        valueCallback: a
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t, a);
            }
        },
        validate: function(t, e, n) {
            return e.isTwoDigitYear || e.year > 0;
        },
        set: function(t, e, n, r) {
            var a = $48515c484bc5585a$var$P(t, r);
            if (n.isTwoDigitYear) {
                var i = $48515c484bc5585a$var$ht(n.year, a);
                return t.setUTCFullYear(i, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $48515c484bc5585a$var$S(t, r);
            }
            var o = 'era' in e && 1 !== e.era ? 1 - n.year : n.year;
            return t.setUTCFullYear(o, 0, r.firstWeekContainsDate), t.setUTCHours(0, 0, 0, 0), $48515c484bc5585a$var$S(t, r);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    R: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$lt('R' === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            var a = new Date(0);
            return a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0), $48515c484bc5585a$var$Y(a);
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    u: {
        priority: 130,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$lt('u' === e ? 4 : e.length, t);
        },
        set: function(t, e, n, r) {
            return t.setUTCFullYear(n, 0, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    Q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case 'Q':
                case 'QQ':
                    return $48515c484bc5585a$var$dt(e.length, t);
                case 'Qo':
                    return n.ordinalNumber(t, {
                        unit: 'quarter'
                    });
                case 'QQQ':
                    return n.quarter(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQQ':
                    return n.quarter(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'QQQQ':
                default:
                    return n.quarter(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.quarter(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    q: {
        priority: 120,
        parse: function(t, e, n, r) {
            switch(e){
                case 'q':
                case 'qq':
                    return $48515c484bc5585a$var$dt(e.length, t);
                case 'qo':
                    return n.ordinalNumber(t, {
                        unit: 'quarter'
                    });
                case 'qqq':
                    return n.quarter(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqqq':
                    return n.quarter(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'qqqq':
                default:
                    return n.quarter(t, {
                        width: 'wide',
                        context: 'standalone'
                    }) || n.quarter(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.quarter(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 4;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(3 * (n - 1), 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    M: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case 'M':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$L, t, a);
                case 'MM':
                    return $48515c484bc5585a$var$dt(2, t, a);
                case 'Mo':
                    return n.ordinalNumber(t, {
                        unit: 'month',
                        valueCallback: a
                    });
                case 'MMM':
                    return n.month(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMMM':
                    return n.month(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'MMMM':
                default:
                    return n.month(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.month(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    L: {
        priority: 110,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return t - 1;
            };
            switch(e){
                case 'L':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$L, t, a);
                case 'LL':
                    return $48515c484bc5585a$var$dt(2, t, a);
                case 'Lo':
                    return n.ordinalNumber(t, {
                        unit: 'month',
                        valueCallback: a
                    });
                case 'LLL':
                    return n.month(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLLL':
                    return n.month(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'LLLL':
                default:
                    return n.month(t, {
                        width: 'wide',
                        context: 'standalone'
                    }) || n.month(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.month(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(n, 1), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    w: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case 'w':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$Q, t);
                case 'wo':
                    return n.ordinalNumber(t, {
                        unit: 'week'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $48515c484bc5585a$var$S(function(t, e, n) {
                $48515c484bc5585a$var$h(2, arguments);
                var r = $48515c484bc5585a$var$m(t), a = $48515c484bc5585a$var$f(e), i = $48515c484bc5585a$var$H(r, n) - a;
                return r.setUTCDate(r.getUTCDate() - 7 * i), r;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]
    },
    I: {
        priority: 100,
        parse: function(t, e, n, r) {
            switch(e){
                case 'I':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$Q, t);
                case 'Io':
                    return n.ordinalNumber(t, {
                        unit: 'week'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 53;
        },
        set: function(t, e, n, r) {
            return $48515c484bc5585a$var$Y(function(t, e) {
                $48515c484bc5585a$var$h(2, arguments);
                var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$f(e), a = $48515c484bc5585a$var$B(n) - r;
                return n.setUTCDate(n.getUTCDate() - 7 * a), n;
            }(t, n, r), r);
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]
    },
    d: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case 'd':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$W, t);
                case 'do':
                    return n.ordinalNumber(t, {
                        unit: 'date'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            var r = $48515c484bc5585a$var$gt(t.getUTCFullYear()), a = t.getUTCMonth();
            return r ? e >= 1 && e <= $48515c484bc5585a$var$wt[a] : e >= 1 && e <= $48515c484bc5585a$var$mt[a];
        },
        set: function(t, e, n, r) {
            return t.setUTCDate(n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    D: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case 'D':
                case 'DD':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$F, t);
                case 'Do':
                    return n.ordinalNumber(t, {
                        unit: 'date'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return $48515c484bc5585a$var$gt(t.getUTCFullYear()) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
        },
        set: function(t, e, n, r) {
            return t.setUTCMonth(0, n), t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    E: {
        priority: 90,
        parse: function(t, e, n, r) {
            switch(e){
                case 'E':
                case 'EE':
                case 'EEE':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEE':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEEEE':
                    return n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'EEEE':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $48515c484bc5585a$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]
    },
    e: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case 'e':
                case 'ee':
                    return $48515c484bc5585a$var$dt(e.length, t, a);
                case 'eo':
                    return n.ordinalNumber(t, {
                        unit: 'day',
                        valueCallback: a
                    });
                case 'eee':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeee':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeeeee':
                    return n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'eeee':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $48515c484bc5585a$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]
    },
    c: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                var e = 7 * Math.floor((t - 1) / 7);
                return (t + r.weekStartsOn + 6) % 7 + e;
            };
            switch(e){
                case 'c':
                case 'cc':
                    return $48515c484bc5585a$var$dt(e.length, t, a);
                case 'co':
                    return n.ordinalNumber(t, {
                        unit: 'day',
                        valueCallback: a
                    });
                case 'ccc':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'ccccc':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccccc':
                    return n.day(t, {
                        width: 'short',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
                case 'cccc':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'short',
                        context: 'standalone'
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'standalone'
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 6;
        },
        set: function(t, e, n, r) {
            return (t = $48515c484bc5585a$var$E(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]
    },
    i: {
        priority: 90,
        parse: function(t, e, n, r) {
            var a = function(t) {
                return 0 === t ? 7 : t;
            };
            switch(e){
                case 'i':
                case 'ii':
                    return $48515c484bc5585a$var$dt(e.length, t);
                case 'io':
                    return n.ordinalNumber(t, {
                        unit: 'day'
                    });
                case 'iii':
                    return n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
                case 'iiiii':
                    return n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
                case 'iiiiii':
                    return n.day(t, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
                case 'iiii':
                default:
                    return n.day(t, {
                        width: 'wide',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'abbreviated',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'short',
                        context: 'formatting',
                        valueCallback: a
                    }) || n.day(t, {
                        width: 'narrow',
                        context: 'formatting',
                        valueCallback: a
                    });
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 7;
        },
        set: function(t, e, n, r) {
            return (t = function(t, e) {
                $48515c484bc5585a$var$h(2, arguments);
                var n = $48515c484bc5585a$var$f(e);
                n % 7 == 0 && (n -= 7);
                var r = 1, a = $48515c484bc5585a$var$m(t), i = a.getUTCDay(), o = n % 7, u = (o + 7) % 7, s = (u < r ? 7 : 0) + n - i;
                return a.setUTCDate(a.getUTCDate() + s), a;
            }(t, n, r)).setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]
    },
    a: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case 'a':
                case 'aa':
                case 'aaa':
                    return n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaaa':
                    return n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'aaaa':
                default:
                    return n.dayPeriod(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($48515c484bc5585a$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            'b',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    b: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case 'b':
                case 'bb':
                case 'bbb':
                    return n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbbb':
                    return n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'bbbb':
                default:
                    return n.dayPeriod(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($48515c484bc5585a$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'B',
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    B: {
        priority: 80,
        parse: function(t, e, n, r) {
            switch(e){
                case 'B':
                case 'BB':
                case 'BBB':
                    return n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBBB':
                    return n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
                case 'BBBB':
                default:
                    return n.dayPeriod(t, {
                        width: 'wide',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'abbreviated',
                        context: 'formatting'
                    }) || n.dayPeriod(t, {
                        width: 'narrow',
                        context: 'formatting'
                    });
            }
        },
        set: function(t, e, n, r) {
            return t.setUTCHours($48515c484bc5585a$var$ft(n), 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            't',
            'T'
        ]
    },
    h: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'h':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$G, t);
                case 'ho':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 12;
        },
        set: function(t, e, n, r) {
            var a = t.getUTCHours() >= 12;
            return a && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : a || 12 !== n ? t.setUTCHours(n, 0, 0, 0) : t.setUTCHours(0, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'H',
            'K',
            'k',
            't',
            'T'
        ]
    },
    H: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'H':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$R, t);
                case 'Ho':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 23;
        },
        set: function(t, e, n, r) {
            return t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]
    },
    K: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'K':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$X, t);
                case 'Ko':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 11;
        },
        set: function(t, e, n, r) {
            return t.getUTCHours() >= 12 && n < 12 ? t.setUTCHours(n + 12, 0, 0, 0) : t.setUTCHours(n, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'k',
            't',
            'T'
        ]
    },
    k: {
        priority: 70,
        parse: function(t, e, n, r) {
            switch(e){
                case 'k':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$I, t);
                case 'ko':
                    return n.ordinalNumber(t, {
                        unit: 'hour'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 1 && e <= 24;
        },
        set: function(t, e, n, r) {
            var a = n <= 24 ? n % 24 : n;
            return t.setUTCHours(a, 0, 0, 0), t;
        },
        incompatibleTokens: [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]
    },
    m: {
        priority: 60,
        parse: function(t, e, n, r) {
            switch(e){
                case 'm':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$A, t);
                case 'mo':
                    return n.ordinalNumber(t, {
                        unit: 'minute'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCMinutes(n, 0, 0), t;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    s: {
        priority: 50,
        parse: function(t, e, n, r) {
            switch(e){
                case 's':
                    return $48515c484bc5585a$var$ut($48515c484bc5585a$var$z, t);
                case 'so':
                    return n.ordinalNumber(t, {
                        unit: 'second'
                    });
                default:
                    return $48515c484bc5585a$var$dt(e.length, t);
            }
        },
        validate: function(t, e, n) {
            return e >= 0 && e <= 59;
        },
        set: function(t, e, n, r) {
            return t.setUTCSeconds(n, 0), t;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    S: {
        priority: 30,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$dt(e.length, t, function(t) {
                return Math.floor(t * Math.pow(10, 3 - e.length));
            });
        },
        set: function(t, e, n, r) {
            return t.setUTCMilliseconds(n), t;
        },
        incompatibleTokens: [
            't',
            'T'
        ]
    },
    X: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case 'X':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$nt, t);
                case 'XX':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$rt, t);
                case 'XXXX':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$at, t);
                case 'XXXXX':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$ot, t);
                case 'XXX':
                default:
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            't',
            'T',
            'x'
        ]
    },
    x: {
        priority: 10,
        parse: function(t, e, n, r) {
            switch(e){
                case 'x':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$nt, t);
                case 'xx':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$rt, t);
                case 'xxxx':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$at, t);
                case 'xxxxx':
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$ot, t);
                case 'xxx':
                default:
                    return $48515c484bc5585a$var$st($48515c484bc5585a$var$it, t);
            }
        },
        set: function(t, e, n, r) {
            return e.timestampIsSet ? t : new Date(t.getTime() - n);
        },
        incompatibleTokens: [
            't',
            'T',
            'X'
        ]
    },
    t: {
        priority: 40,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(1e3 * n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: '*'
    },
    T: {
        priority: 20,
        parse: function(t, e, n, r) {
            return $48515c484bc5585a$var$ct(t);
        },
        set: function(t, e, n, r) {
            return [
                new Date(n),
                {
                    timestampIsSet: !0
                }
            ];
        },
        incompatibleTokens: '*'
    }
}, $48515c484bc5585a$var$yt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$bt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$Dt = /^'([^]*?)'?$/, $48515c484bc5585a$var$Tt = /''/g, $48515c484bc5585a$var$pt = /\S/, $48515c484bc5585a$var$kt = /[a-zA-Z]/;
function $48515c484bc5585a$export$6b862160d295c8e(t, e, n, r) {
    $48515c484bc5585a$var$h(3, arguments);
    var a = String(t), i = String(e), o = r || {}, u = o.locale || $48515c484bc5585a$var$l;
    if (!u.match) throw new RangeError('locale must contain match property');
    var s = u.options && u.options.firstWeekContainsDate, c = null == s ? 1 : $48515c484bc5585a$var$f(s), d = null == o.firstWeekContainsDate ? c : $48515c484bc5585a$var$f(o.firstWeekContainsDate);
    if (!(d >= 1 && d <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var w = u.options && u.options.weekStartsOn, y = null == w ? 0 : $48515c484bc5585a$var$f(w), b = null == o.weekStartsOn ? y : $48515c484bc5585a$var$f(o.weekStartsOn);
    if (!(b >= 0 && b <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if ('' === i) return '' === a ? $48515c484bc5585a$var$m(n) : new Date(NaN);
    var T, k = {
        firstWeekContainsDate: d,
        weekStartsOn: b,
        locale: u
    }, x = [
        {
            priority: 10,
            set: $48515c484bc5585a$var$Ct,
            index: 0
        }
    ], S = i.match($48515c484bc5585a$var$bt).map(function(t) {
        var e = t[0];
        return 'p' === e || 'P' === e ? (0, $48515c484bc5585a$var$D[e])(t, u.formatLong, k) : t;
    }).join('').match($48515c484bc5585a$var$yt), P = [];
    for(T = 0; T < S.length; T++){
        var E = S[T];
        !o.useAdditionalWeekYearTokens && $48515c484bc5585a$var$M(E) && $48515c484bc5585a$var$U(E), !o.useAdditionalDayOfYearTokens && $48515c484bc5585a$var$C(E) && $48515c484bc5585a$var$U(E);
        var Y = E[0], N = $48515c484bc5585a$var$vt[Y];
        if (N) {
            var q = N.incompatibleTokens;
            if (Array.isArray(q)) {
                for(var B = void 0, O = 0; O < P.length; O++){
                    var H = P[O].token;
                    if (-1 !== q.indexOf(H) || H === Y) {
                        B = P[O];
                        break;
                    }
                }
                if (B) throw new RangeError("The format string mustn't contain `".concat(B.fullToken, '` and `').concat(E, '` at the same time'));
            } else if ('*' === N.incompatibleTokens && P.length) throw new RangeError("The format string mustn't contain `".concat(E, '` and any other token at the same time'));
            P.push({
                token: Y,
                fullToken: E
            });
            var L = N.parse(a, E, u.match, k);
            if (!L) return new Date(NaN);
            x.push({
                priority: N.priority,
                set: N.set,
                validate: N.validate,
                value: L.value,
                index: x.length
            }), a = L.rest;
        } else {
            if (Y.match($48515c484bc5585a$var$kt)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + Y + '`');
            if ("''" === E ? E = "'" : "'" === Y && (E = $48515c484bc5585a$var$Mt(E)), 0 !== a.indexOf(E)) return new Date(NaN);
            a = a.slice(E.length);
        }
    }
    if (a.length > 0 && $48515c484bc5585a$var$pt.test(a)) return new Date(NaN);
    var W = x.map(function(t) {
        return t.priority;
    }).sort(function(t, e) {
        return e - t;
    }).filter(function(t, e, n) {
        return n.indexOf(t) === e;
    }).map(function(t) {
        return x.filter(function(e) {
            return e.priority === t;
        }).reverse();
    }).map(function(t) {
        return t[0];
    }), F = $48515c484bc5585a$var$m(n);
    if (isNaN(F)) return new Date(NaN);
    var Q = $48515c484bc5585a$var$g(F, $48515c484bc5585a$var$p(F)), R = {};
    for(T = 0; T < W.length; T++){
        var I = W[T];
        if (I.validate && !I.validate(Q, I.value, k)) return new Date(NaN);
        var X = I.set(Q, R, I.value, k);
        X[0] ? (Q = X[0], $48515c484bc5585a$var$v(R, X[1])) : Q = X;
    }
    return Q;
}
function $48515c484bc5585a$var$Ct(t, e) {
    if (e.timestampIsSet) return t;
    var n = new Date(0);
    return n.setFullYear(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), n.setHours(t.getUTCHours(), t.getUTCMinutes(), t.getUTCSeconds(), t.getUTCMilliseconds()), n;
}
function $48515c484bc5585a$var$Mt(t) {
    return t.match($48515c484bc5585a$var$Dt)[1].replace($48515c484bc5585a$var$Tt, "'");
}
function $48515c484bc5585a$var$Ut(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t);
    return !isNaN(e);
}
function $48515c484bc5585a$var$St(t, e) {
    for(var n = t < 0 ? '-' : '', r = Math.abs(t).toString(); r.length < e;)r = '0' + r;
    return n + r;
}
var $48515c484bc5585a$var$Pt = function(t, e) {
    var n = t.getUTCFullYear(), r = n > 0 ? n : 1 - n;
    return $48515c484bc5585a$var$St('yy' === e ? r % 100 : r, e.length);
}, $48515c484bc5585a$var$Et = function(t, e) {
    var n = t.getUTCMonth();
    return 'M' === e ? String(n + 1) : $48515c484bc5585a$var$St(n + 1, 2);
}, $48515c484bc5585a$var$Yt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCDate(), e.length);
}, $48515c484bc5585a$var$Nt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCHours() % 12 || 12, e.length);
}, $48515c484bc5585a$var$qt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCHours(), e.length);
}, $48515c484bc5585a$var$Bt = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCMinutes(), e.length);
}, $48515c484bc5585a$var$Ot = function(t, e) {
    return $48515c484bc5585a$var$St(t.getUTCSeconds(), e.length);
}, $48515c484bc5585a$var$Ht = function(t, e) {
    var n = e.length, r = t.getUTCMilliseconds();
    return $48515c484bc5585a$var$St(Math.floor(r * Math.pow(10, n - 3)), e.length);
};
var $48515c484bc5585a$var$Lt = 'midnight', $48515c484bc5585a$var$Wt = 'noon', $48515c484bc5585a$var$Ft = 'morning', $48515c484bc5585a$var$Qt = 'afternoon', $48515c484bc5585a$var$Rt = 'evening', $48515c484bc5585a$var$It = 'night', $48515c484bc5585a$var$Xt = {
    G: function(t, e, n) {
        var r = t.getUTCFullYear() > 0 ? 1 : 0;
        switch(e){
            case 'G':
            case 'GG':
            case 'GGG':
                return n.era(r, {
                    width: 'abbreviated'
                });
            case 'GGGGG':
                return n.era(r, {
                    width: 'narrow'
                });
            case 'GGGG':
            default:
                return n.era(r, {
                    width: 'wide'
                });
        }
    },
    y: function(t, e, n) {
        if ('yo' === e) {
            var r = t.getUTCFullYear(), a = r > 0 ? r : 1 - r;
            return n.ordinalNumber(a, {
                unit: 'year'
            });
        }
        return $48515c484bc5585a$var$Pt(t, e);
    },
    Y: function(t, e, n, r) {
        var a = $48515c484bc5585a$var$P(t, r), i = a > 0 ? a : 1 - a;
        return 'YY' === e ? $48515c484bc5585a$var$St(i % 100, 2) : 'Yo' === e ? n.ordinalNumber(i, {
            unit: 'year'
        }) : $48515c484bc5585a$var$St(i, e.length);
    },
    R: function(t, e) {
        return $48515c484bc5585a$var$St($48515c484bc5585a$var$N(t), e.length);
    },
    u: function(t, e) {
        return $48515c484bc5585a$var$St(t.getUTCFullYear(), e.length);
    },
    Q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case 'Q':
                return String(r);
            case 'QQ':
                return $48515c484bc5585a$var$St(r, 2);
            case 'Qo':
                return n.ordinalNumber(r, {
                    unit: 'quarter'
                });
            case 'QQQ':
                return n.quarter(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'QQQQQ':
                return n.quarter(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'QQQQ':
            default:
                return n.quarter(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    q: function(t, e, n) {
        var r = Math.ceil((t.getUTCMonth() + 1) / 3);
        switch(e){
            case 'q':
                return String(r);
            case 'qq':
                return $48515c484bc5585a$var$St(r, 2);
            case 'qo':
                return n.ordinalNumber(r, {
                    unit: 'quarter'
                });
            case 'qqq':
                return n.quarter(r, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'qqqqq':
                return n.quarter(r, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'qqqq':
            default:
                return n.quarter(r, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    M: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case 'M':
            case 'MM':
                return $48515c484bc5585a$var$Et(t, e);
            case 'Mo':
                return n.ordinalNumber(r + 1, {
                    unit: 'month'
                });
            case 'MMM':
                return n.month(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'MMMMM':
                return n.month(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'MMMM':
            default:
                return n.month(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    L: function(t, e, n) {
        var r = t.getUTCMonth();
        switch(e){
            case 'L':
                return String(r + 1);
            case 'LL':
                return $48515c484bc5585a$var$St(r + 1, 2);
            case 'Lo':
                return n.ordinalNumber(r + 1, {
                    unit: 'month'
                });
            case 'LLL':
                return n.month(r, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'LLLLL':
                return n.month(r, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'LLLL':
            default:
                return n.month(r, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    w: function(t, e, n, r) {
        var a = $48515c484bc5585a$var$H(t, r);
        return 'wo' === e ? n.ordinalNumber(a, {
            unit: 'week'
        }) : $48515c484bc5585a$var$St(a, e.length);
    },
    I: function(t, e, n) {
        var r = $48515c484bc5585a$var$B(t);
        return 'Io' === e ? n.ordinalNumber(r, {
            unit: 'week'
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    d: function(t, e, n) {
        return 'do' === e ? n.ordinalNumber(t.getUTCDate(), {
            unit: 'date'
        }) : $48515c484bc5585a$var$Yt(t, e);
    },
    D: function(t, e, n) {
        var r = function(t) {
            $48515c484bc5585a$var$h(1, arguments);
            var e = $48515c484bc5585a$var$m(t), n = e.getTime();
            e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
            var r = e.getTime(), a = n - r;
            return Math.floor(a / 864e5) + 1;
        }(t);
        return 'Do' === e ? n.ordinalNumber(r, {
            unit: 'dayOfYear'
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    E: function(t, e, n) {
        var r = t.getUTCDay();
        switch(e){
            case 'E':
            case 'EE':
            case 'EEE':
                return n.day(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'EEEEE':
                return n.day(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'EEEEEE':
                return n.day(r, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'EEEE':
            default:
                return n.day(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    e: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case 'e':
                return String(i);
            case 'ee':
                return $48515c484bc5585a$var$St(i, 2);
            case 'eo':
                return n.ordinalNumber(i, {
                    unit: 'day'
                });
            case 'eee':
                return n.day(a, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'eeeee':
                return n.day(a, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'eeeeee':
                return n.day(a, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'eeee':
            default:
                return n.day(a, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    c: function(t, e, n, r) {
        var a = t.getUTCDay(), i = (a - r.weekStartsOn + 8) % 7 || 7;
        switch(e){
            case 'c':
                return String(i);
            case 'cc':
                return $48515c484bc5585a$var$St(i, e.length);
            case 'co':
                return n.ordinalNumber(i, {
                    unit: 'day'
                });
            case 'ccc':
                return n.day(a, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            case 'ccccc':
                return n.day(a, {
                    width: 'narrow',
                    context: 'standalone'
                });
            case 'cccccc':
                return n.day(a, {
                    width: 'short',
                    context: 'standalone'
                });
            case 'cccc':
            default:
                return n.day(a, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    i: function(t, e, n) {
        var r = t.getUTCDay(), a = 0 === r ? 7 : r;
        switch(e){
            case 'i':
                return String(a);
            case 'ii':
                return $48515c484bc5585a$var$St(a, e.length);
            case 'io':
                return n.ordinalNumber(a, {
                    unit: 'day'
                });
            case 'iii':
                return n.day(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'iiiii':
                return n.day(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'iiiiii':
                return n.day(r, {
                    width: 'short',
                    context: 'formatting'
                });
            case 'iiii':
            default:
                return n.day(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    a: function(t, e, n) {
        var r = t.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(e){
            case 'a':
            case 'aa':
            case 'aaa':
                return n.dayPeriod(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaaaa':
                return n.dayPeriod(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return n.dayPeriod(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    b: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = 12 === a ? $48515c484bc5585a$var$Wt : 0 === a ? $48515c484bc5585a$var$Lt : a / 12 >= 1 ? 'pm' : 'am', e){
            case 'b':
            case 'bb':
            case 'bbb':
                return n.dayPeriod(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbbbb':
                return n.dayPeriod(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return n.dayPeriod(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    B: function(t, e, n) {
        var r, a = t.getUTCHours();
        switch(r = a >= 17 ? $48515c484bc5585a$var$Rt : a >= 12 ? $48515c484bc5585a$var$Qt : a >= 4 ? $48515c484bc5585a$var$Ft : $48515c484bc5585a$var$It, e){
            case 'B':
            case 'BB':
            case 'BBB':
                return n.dayPeriod(r, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return n.dayPeriod(r, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return n.dayPeriod(r, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    h: function(t, e, n) {
        if ('ho' === e) {
            var r = t.getUTCHours() % 12;
            return 0 === r && (r = 12), n.ordinalNumber(r, {
                unit: 'hour'
            });
        }
        return $48515c484bc5585a$var$Nt(t, e);
    },
    H: function(t, e, n) {
        return 'Ho' === e ? n.ordinalNumber(t.getUTCHours(), {
            unit: 'hour'
        }) : $48515c484bc5585a$var$qt(t, e);
    },
    K: function(t, e, n) {
        var r = t.getUTCHours() % 12;
        return 'Ko' === e ? n.ordinalNumber(r, {
            unit: 'hour'
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    k: function(t, e, n) {
        var r = t.getUTCHours();
        return 0 === r && (r = 24), 'ko' === e ? n.ordinalNumber(r, {
            unit: 'hour'
        }) : $48515c484bc5585a$var$St(r, e.length);
    },
    m: function(t, e, n) {
        return 'mo' === e ? n.ordinalNumber(t.getUTCMinutes(), {
            unit: 'minute'
        }) : $48515c484bc5585a$var$Bt(t, e);
    },
    s: function(t, e, n) {
        return 'so' === e ? n.ordinalNumber(t.getUTCSeconds(), {
            unit: 'second'
        }) : $48515c484bc5585a$var$Ot(t, e);
    },
    S: function(t, e) {
        return $48515c484bc5585a$var$Ht(t, e);
    },
    X: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        if (0 === a) return 'Z';
        switch(e){
            case 'X':
                return $48515c484bc5585a$var$At(a);
            case 'XXXX':
            case 'XX':
                return $48515c484bc5585a$var$zt(a);
            case 'XXXXX':
            case 'XXX':
            default:
                return $48515c484bc5585a$var$zt(a, ':');
        }
    },
    x: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case 'x':
                return $48515c484bc5585a$var$At(a);
            case 'xxxx':
            case 'xx':
                return $48515c484bc5585a$var$zt(a);
            case 'xxxxx':
            case 'xxx':
            default:
                return $48515c484bc5585a$var$zt(a, ':');
        }
    },
    O: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $48515c484bc5585a$var$Gt(a, ':');
            case 'OOOO':
            default:
                return 'GMT' + $48515c484bc5585a$var$zt(a, ':');
        }
    },
    z: function(t, e, n, r) {
        var a = (r._originalDate || t).getTimezoneOffset();
        switch(e){
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $48515c484bc5585a$var$Gt(a, ':');
            case 'zzzz':
            default:
                return 'GMT' + $48515c484bc5585a$var$zt(a, ':');
        }
    },
    t: function(t, e, n, r) {
        var a = r._originalDate || t;
        return $48515c484bc5585a$var$St(Math.floor(a.getTime() / 1e3), e.length);
    },
    T: function(t, e, n, r) {
        return $48515c484bc5585a$var$St((r._originalDate || t).getTime(), e.length);
    }
};
function $48515c484bc5585a$var$Gt(t, e) {
    var n = t > 0 ? '-' : '+', r = Math.abs(t), a = Math.floor(r / 60), i = r % 60;
    if (0 === i) return n + String(a);
    var o = e || '';
    return n + String(a) + o + $48515c484bc5585a$var$St(i, 2);
}
function $48515c484bc5585a$var$At(t, e) {
    return t % 60 == 0 ? (t > 0 ? '-' : '+') + $48515c484bc5585a$var$St(Math.abs(t) / 60, 2) : $48515c484bc5585a$var$zt(t, e);
}
function $48515c484bc5585a$var$zt(t, e) {
    var n = e || '', r = t > 0 ? '-' : '+', a = Math.abs(t);
    return r + $48515c484bc5585a$var$St(Math.floor(a / 60), 2) + n + $48515c484bc5585a$var$St(a % 60, 2);
}
var $48515c484bc5585a$var$jt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$Kt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, $48515c484bc5585a$var$Jt = /^'([^]*?)'?$/, $48515c484bc5585a$var$Zt = /''/g, $48515c484bc5585a$var$_t = /[a-zA-Z]/;
function $48515c484bc5585a$var$$t(t, e, n) {
    $48515c484bc5585a$var$h(2, arguments);
    var r = String(e), a = n || {}, i = a.locale || $48515c484bc5585a$var$l, o = i.options && i.options.firstWeekContainsDate, u = null == o ? 1 : $48515c484bc5585a$var$f(o), s = null == a.firstWeekContainsDate ? u : $48515c484bc5585a$var$f(a.firstWeekContainsDate);
    if (!(s >= 1 && s <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var c = i.options && i.options.weekStartsOn, d = null == c ? 0 : $48515c484bc5585a$var$f(c), w = null == a.weekStartsOn ? d : $48515c484bc5585a$var$f(a.weekStartsOn);
    if (!(w >= 0 && w <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!i.localize) throw new RangeError('locale must contain localize property');
    if (!i.formatLong) throw new RangeError('locale must contain formatLong property');
    var v = $48515c484bc5585a$var$m(t);
    if (!$48515c484bc5585a$var$Ut(v)) throw new RangeError('Invalid time value');
    var y = $48515c484bc5585a$var$p(v), b = $48515c484bc5585a$var$g(v, y), T = {
        firstWeekContainsDate: s,
        weekStartsOn: w,
        locale: i,
        _originalDate: v
    }, k = r.match($48515c484bc5585a$var$Kt).map(function(t) {
        var e = t[0];
        return 'p' === e || 'P' === e ? (0, $48515c484bc5585a$var$D[e])(t, i.formatLong, T) : t;
    }).join('').match($48515c484bc5585a$var$jt).map(function(t) {
        if ("''" === t) return "'";
        var e = t[0];
        if ("'" === e) return $48515c484bc5585a$var$Vt(t);
        var n = $48515c484bc5585a$var$Xt[e];
        if (n) return !a.useAdditionalWeekYearTokens && $48515c484bc5585a$var$M(t) && $48515c484bc5585a$var$U(t), !a.useAdditionalDayOfYearTokens && $48515c484bc5585a$var$C(t) && $48515c484bc5585a$var$U(t), n(b, t, i.localize, T);
        if (e.match($48515c484bc5585a$var$_t)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + e + '`');
        return t;
    }).join('');
    return k;
}
function $48515c484bc5585a$var$Vt(t) {
    return t.match($48515c484bc5585a$var$Jt)[1].replace($48515c484bc5585a$var$Zt, "'");
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $48515c484bc5585a$var$te(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$f(e);
    return isNaN(r) ? new Date(NaN) : r ? (n.setDate(n.getDate() + r), n) : n;
}
function $48515c484bc5585a$var$ee(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = t || {}, r = $48515c484bc5585a$var$m(n.start), a = $48515c484bc5585a$var$m(n.end), i = a.getTime();
    if (!(r.getTime() <= i)) throw new RangeError('Invalid interval');
    var o = [], u = r;
    u.setHours(0, 0, 0, 0);
    var s = e && 'step' in e ? Number(e.step) : 1;
    if (s < 1 || isNaN(s)) throw new RangeError('`options.step` must be a number greater than 1');
    for(; u.getTime() <= i;)o.push($48515c484bc5585a$var$m(u)), u.setDate(u.getDate() + s), u.setHours(0, 0, 0, 0);
    return o;
}
function $48515c484bc5585a$var$ne(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $48515c484bc5585a$var$f(a), o = null == n.weekStartsOn ? i : $48515c484bc5585a$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var u = $48515c484bc5585a$var$m(t), s = u.getDay(), c = 6 + (s < o ? -7 : 0) - (s - o);
    return u.setDate(u.getDate() + c), u.setHours(23, 59, 59, 999), u;
}
function $48515c484bc5585a$var$re(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t);
    return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function $48515c484bc5585a$var$ae(t, e) {
    $48515c484bc5585a$var$h(1, arguments);
    var n = e || {}, r = n.locale, a = r && r.options && r.options.weekStartsOn, i = null == a ? 0 : $48515c484bc5585a$var$f(a), o = null == n.weekStartsOn ? i : $48515c484bc5585a$var$f(n.weekStartsOn);
    if (!(o >= 0 && o <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var u = $48515c484bc5585a$var$m(t), s = u.getDay(), c = (s < o ? 7 : 0) + s - o;
    return u.setDate(u.getDate() - c), u.setHours(0, 0, 0, 0), u;
}
function $48515c484bc5585a$export$fa1807b86c22c08c(t) {
    var e = void 0 === t ? {} : t, n = e.firstDayOfWeek, r = void 0 === n ? 1 : n, a = e.weekdayLabelFormat, i = void 0 === a ? function(t) {
        return $48515c484bc5585a$var$$t(t, 'iiiiii');
    } : a, o = new Date();
    return $48515c484bc5585a$var$ee({
        start: $48515c484bc5585a$var$te($48515c484bc5585a$var$ae(o), r),
        end: $48515c484bc5585a$var$te($48515c484bc5585a$var$ne(o), r)
    }).reduce(function(t, e) {
        return t.push(i(e)), t;
    }, []);
}
function $48515c484bc5585a$export$5f84d4e06c0693c4(t) {
    var e = t.year, n = t.month, r = t.firstDayOfWeek, a = void 0 === r ? 1 : r, i = t.dayLabelFormat, o = void 0 === i ? function(t) {
        return $48515c484bc5585a$var$$t(t, 'dd');
    } : i, u = new Date(e, n), s = $48515c484bc5585a$var$re(u), c = function(t) {
        $48515c484bc5585a$var$h(1, arguments);
        var e = $48515c484bc5585a$var$m(t), n = e.getDay();
        return n;
    }(s), d = function(t) {
        $48515c484bc5585a$var$h(1, arguments);
        var e = $48515c484bc5585a$var$m(t), n = e.getMonth();
        return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
    }(u);
    return function() {
        for(var t = 0, e = 0, n = arguments.length; e < n; e++)t += arguments[e].length;
        var r = Array(t), a = 0;
        for(e = 0; e < n; e++)for(var i = arguments[e], o = 0, u = i.length; o < u; o++, a++)r[a] = i[o];
        return r;
    }(Array.from(Array(c >= a ? c - a : 6 - a + c + 1).keys()).fill(0), $48515c484bc5585a$var$ee({
        start: s,
        end: d
    }).map(function(t) {
        return {
            date: t,
            dayLabel: o(t)
        };
    }));
}
var $48515c484bc5585a$export$ae8ce18f4c87a98d = function(t) {
    return $48515c484bc5585a$var$$t(t, 'dd');
}, $48515c484bc5585a$export$c91a7ea1bd918f41 = function(t) {
    return $48515c484bc5585a$var$$t(t, 'eeeeee');
}, $48515c484bc5585a$export$85e553ba2321487b = function(t) {
    return $48515c484bc5585a$var$$t(t, 'MMMM yyyy');
};
function $48515c484bc5585a$export$41527c87dc759868(e) {
    var n = e.year, r = e.month, a = e.firstDayOfWeek, i = void 0 === a ? 1 : a, o = e.dayLabelFormat, u = void 0 === o ? $48515c484bc5585a$export$ae8ce18f4c87a98d : o, s = e.weekdayLabelFormat, c = void 0 === s ? $48515c484bc5585a$export$c91a7ea1bd918f41 : s, d = e.monthLabelFormat, l = void 0 === d ? $48515c484bc5585a$export$85e553ba2321487b : d;
    return {
        days: (0, $dup7A.useMemo)(function() {
            return $48515c484bc5585a$export$5f84d4e06c0693c4({
                year: n,
                month: r,
                firstDayOfWeek: i,
                dayLabelFormat: u
            });
        }, [
            n,
            r,
            i,
            u
        ]),
        weekdayLabels: (0, $dup7A.useMemo)(function() {
            return $48515c484bc5585a$export$fa1807b86c22c08c({
                firstDayOfWeek: i,
                weekdayLabelFormat: c
            });
        }, [
            i,
            c
        ]),
        monthLabel: l(new Date(n, r))
    };
}
function $48515c484bc5585a$var$le(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$m(e);
    return n.getTime() < r.getTime();
}
function $48515c484bc5585a$var$fe(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$m(e);
    return n.getTime() > r.getTime();
}
function $48515c484bc5585a$var$he(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = e || {}, r = $48515c484bc5585a$var$m(t).getTime(), a = $48515c484bc5585a$var$m(n.start).getTime(), i = $48515c484bc5585a$var$m(n.end).getTime();
    if (!(a <= i)) throw new RangeError('Invalid interval');
    return r >= a && r <= i;
}
function $48515c484bc5585a$var$me(t) {
    $48515c484bc5585a$var$h(1, arguments);
    var e = $48515c484bc5585a$var$m(t);
    return e.setHours(0, 0, 0, 0), e;
}
function $48515c484bc5585a$var$we(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$me(t), r = $48515c484bc5585a$var$me(e);
    return n.getTime() === r.getTime();
}
function $48515c484bc5585a$var$ge(t, e) {
    $48515c484bc5585a$var$h(2, arguments);
    var n = $48515c484bc5585a$var$m(t), r = $48515c484bc5585a$var$f(e);
    if (isNaN(r)) return new Date(NaN);
    if (!r) return n;
    var a = n.getDate(), i = new Date(n.getTime());
    i.setMonth(n.getMonth() + r + 1, 0);
    var o = i.getDate();
    return a >= o ? i : (n.setFullYear(i.getFullYear(), i.getMonth(), a), n);
}
var $48515c484bc5585a$var$ve = function(t, e) {
    return void 0 === t && (t = []), t.some(function(t) {
        return $48515c484bc5585a$var$we(e, t);
    });
};
function $48515c484bc5585a$export$b165a5bc4ad10935(t, e, n) {
    return !(!e || !n) && $48515c484bc5585a$var$he(t, {
        start: e,
        end: n
    });
}
function $48515c484bc5585a$export$8260647f4936851e(t, e, n) {
    return !!(e && $48515c484bc5585a$var$we(t, e) || n && $48515c484bc5585a$var$we(t, n));
}
function $48515c484bc5585a$export$c8db6e7f6335237c(t, e) {
    return !(!e || !$48515c484bc5585a$var$we(t, e));
}
function $48515c484bc5585a$export$b3c72c1338a4197(t, e) {
    return !(!e || !$48515c484bc5585a$var$we(t, e));
}
function $48515c484bc5585a$export$757515830049c710(t) {
    var e = t.date, n = t.minBookingDate, r = t.maxBookingDate, a = t.isDateBlockedFn, i = t.startDate, o = t.endDate, u = t.minBookingDays, s = void 0 === u ? 1 : u, c = t.unavailableDates, d = void 0 === c ? [] : c, l = n ? new Date(n.getFullYear(), n.getMonth(), n.getDate(), 0, 0, 0) : n, f = r ? new Date(r.getFullYear(), r.getMonth(), r.getDate(), 0, 0, 0) : r;
    return !!($48515c484bc5585a$var$ve(d, e) || l && $48515c484bc5585a$var$le(e, l) || f && $48515c484bc5585a$var$fe(e, f) || i && !o && s > 1 && $48515c484bc5585a$var$he(e, {
        start: i,
        end: $48515c484bc5585a$var$te(i, s - 2)
    }) || a && a(e));
}
function $48515c484bc5585a$export$3046c068c9f01601(t) {
    var e = $48515c484bc5585a$var$re(t);
    return {
        year: function(t) {
            $48515c484bc5585a$var$h(1, arguments);
            var e = $48515c484bc5585a$var$m(t), n = e.getFullYear();
            return n;
        }(e),
        month: function(t) {
            $48515c484bc5585a$var$h(1, arguments);
            var e = $48515c484bc5585a$var$m(t), n = e.getMonth();
            return n;
        }(e),
        date: e
    };
}
function $48515c484bc5585a$export$f446e9d44b503a48() {
    return $48515c484bc5585a$export$3046c068c9f01601($48515c484bc5585a$var$me(Date.now()));
}
function $48515c484bc5585a$export$6b0a3e73eaccfee4(t, e) {
    var n = e ? $48515c484bc5585a$export$3046c068c9f01601(e) : $48515c484bc5585a$export$f446e9d44b503a48(), r = n.date, a = [
        n
    ];
    return t > 1 && (a = Array.from(Array(t - 1).keys()).reduce(function(t) {
        return r = $48515c484bc5585a$var$ge(t[t.length - 1].date, 1), t.concat([
            $48515c484bc5585a$export$3046c068c9f01601(r)
        ]);
    }, a)), a;
}
function $48515c484bc5585a$var$Me(t, e, n, r) {
    var a = t[r ? n > 0 ? 0 : t.length - r : n > 0 ? t.length - 1 : 0].date;
    return Array.from(Array(e).keys()).reduce(function(t) {
        return a = 0 === t.length ? $48515c484bc5585a$var$ge(a, n) : $48515c484bc5585a$var$ge(a, n >= 0 ? 1 : -1), n > 0 ? t.concat([
            $48515c484bc5585a$export$3046c068c9f01601(a)
        ]) : [
            $48515c484bc5585a$export$3046c068c9f01601(a)
        ].concat(t);
    }, []);
}
function $48515c484bc5585a$export$c5e4b84d2ce61726(t, e, n) {
    return t && 'string' == typeof e ? $48515c484bc5585a$var$$t(t, e) : t && 'function' == typeof e ? e(t) : n;
}
function $48515c484bc5585a$var$Se(t) {
    var e = t.startDate, n = t.endDate, r = t.isDateBlocked, a = t.minBookingDays, i = t.exactMinBookingDays, o = t.minBookingDate, u = t.maxBookingDate, s = !o || !$48515c484bc5585a$var$le(e, $48515c484bc5585a$var$te(o, -1)), c = !u || !$48515c484bc5585a$var$fe($48515c484bc5585a$var$te(e, a - 1), u);
    return !(!e || 1 !== a || n || r(e)) || (e && a > 1 && !n && !i || e && a > 0 && i && s && c || e && a > 0 && i && !o && !u ? !$48515c484bc5585a$var$ee({
        start: e,
        end: $48515c484bc5585a$var$te(e, a - 1)
    }).some(function(t) {
        return r(t);
    }) : !(!e || !n || i) && !$48515c484bc5585a$var$le(n, $48515c484bc5585a$var$te(e, a - 1)) && !$48515c484bc5585a$var$ee({
        start: e,
        end: n
    }).some(function(t) {
        return r(t);
    }));
}
var $48515c484bc5585a$export$99a467bcc22b8df9 = 'startDate', $48515c484bc5585a$export$1113b91e67d28ba7 = 'endDate';
function $48515c484bc5585a$export$2d9bfdb55c82a287(t) {
    var a = t.startDate, i = t.endDate, o = t.focusedInput, u = t.minBookingDate, s = t.maxBookingDate, c = t.onDatesChange, d = t.initialVisibleMonth, l = t.exactMinBookingDays, f = void 0 !== l && l, h = t.minBookingDays, m = void 0 === h ? 1 : h, w = t.numberOfMonths, g = void 0 === w ? 2 : w, v = t.firstDayOfWeek, y = void 0 === v ? 1 : v, b = t.isDateBlocked, D = void 0 === b ? function() {
        return !1;
    } : b, T = t.unavailableDates, p = void 0 === T ? [] : T, k = t.changeActiveMonthOnSelect, x = void 0 === k || k, C = (0, $dup7A.useState)(function() {
        return $48515c484bc5585a$export$6b0a3e73eaccfee4(g, a || d || null);
    }), M = C[0], U = C[1], S = (0, $dup7A.useState)(null), P = S[0], E = S[1], Y = (0, $dup7A.useState)(a), N = Y[0], q = Y[1];
    (0, $dup7A.useEffect)(function() {
        return 'undefined' != typeof window && window.addEventListener && window.addEventListener('keydown', L), function() {
            window.removeEventListener && window.removeEventListener('keydown', L);
        };
    });
    var B = function(t) {
        return $48515c484bc5585a$var$ve(p, t) || D(t);
    }, O = function(t) {
        q(t), (!N || N && !$48515c484bc5585a$var$we(t, N)) && U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, t));
    }, H = function(t) {
        return $48515c484bc5585a$export$757515830049c710({
            date: t,
            minBookingDate: u,
            maxBookingDate: s,
            startDate: a,
            endDate: i,
            minBookingDays: m,
            isDateBlockedFn: B
        });
    };
    function L(t) {
        if (('ArrowRight' === t.key || 'ArrowLeft' === t.key || 'ArrowDown' === t.key || 'ArrowUp' === t.key) && !N) {
            var e = M[0];
            O(e.date), U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, e.date));
        }
    }
    var W = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, -1)), q(null);
    }, [
        M,
        g
    ]), F = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, -1, 1)), q(null);
    }, [
        M,
        g
    ]), Q = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, 1)), q(null);
    }, [
        M,
        g
    ]), R = (0, $dup7A.useCallback)(function() {
        U($48515c484bc5585a$var$Me(M, g, 1, 1)), q(null);
    }, [
        M,
        g
    ]), I = (0, $dup7A.useCallback)(function(t) {
        U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, t)), q(null);
    }, [
        g
    ]), X = (0, $dup7A.useCallback)(function(t) {
        void 0 === t && (t = 1), U($48515c484bc5585a$var$Me(M, g, -(12 * t - g + 1))), q(null);
    }, [
        M,
        g
    ]), G = (0, $dup7A.useCallback)(function(t) {
        void 0 === t && (t = 1), U($48515c484bc5585a$var$Me(M, g, 12 * t - g + 1)), q(null);
    }, [
        M,
        g
    ]);
    return {
        firstDayOfWeek: y,
        activeMonths: M,
        isDateSelected: function(t) {
            return $48515c484bc5585a$export$b165a5bc4ad10935(t, a, i);
        },
        isDateHovered: function(t) {
            return function(t) {
                var e = t.date, n = t.startDate, r = t.endDate, a = t.isDateBlocked, i = t.hoveredDate, o = t.minBookingDays, u = t.exactMinBookingDays;
                return i && o > 1 && u && $48515c484bc5585a$var$he(e, {
                    start: i,
                    end: $48515c484bc5585a$var$te(i, o - 1)
                }) ? !$48515c484bc5585a$var$ee({
                    start: i,
                    end: $48515c484bc5585a$var$te(i, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : n && !r && i && $48515c484bc5585a$var$he(e, {
                    start: n,
                    end: $48515c484bc5585a$var$te(n, o - 1)
                }) && $48515c484bc5585a$var$we(n, i) && o > 1 ? !$48515c484bc5585a$var$ee({
                    start: n,
                    end: $48515c484bc5585a$var$te(n, o - 1)
                }).some(function(t) {
                    return a(t);
                }) : !(!n || r || !i || $48515c484bc5585a$var$le(i, n) || !$48515c484bc5585a$var$he(e, {
                    start: n,
                    end: i
                })) && !$48515c484bc5585a$var$ee({
                    start: n,
                    end: i
                }).some(function(t) {
                    return a(t);
                });
            }({
                date: t,
                hoveredDate: P,
                startDate: a,
                endDate: i,
                minBookingDays: m,
                exactMinBookingDays: f,
                isDateBlocked: B
            });
        },
        isFirstOrLastSelectedDate: function(t) {
            return $48515c484bc5585a$export$8260647f4936851e(t, a, i);
        },
        isStartDate: function(t) {
            return $48515c484bc5585a$export$c8db6e7f6335237c(t, a);
        },
        isEndDate: function(t) {
            return $48515c484bc5585a$export$b3c72c1338a4197(t, i);
        },
        isDateBlocked: H,
        numberOfMonths: g,
        isDateFocused: function(t) {
            return !!N && $48515c484bc5585a$var$we(t, N);
        },
        focusedDate: N,
        hoveredDate: P,
        onResetDates: function() {
            c({
                startDate: null,
                endDate: null,
                focusedInput: 'startDate'
            });
        },
        onDateHover: function(t) {
            if (t) {
                if (t) {
                    var e = !H(t) || a && $48515c484bc5585a$var$we(t, a), n = !u || !$48515c484bc5585a$var$le(t, $48515c484bc5585a$var$te(u, -1)), r = !s || !$48515c484bc5585a$var$fe(t, s), o = $48515c484bc5585a$var$te(t, m - 1), c = !u || !$48515c484bc5585a$var$le(o, u), d = !s || !$48515c484bc5585a$var$fe(o, s), l = f && m > 1 && n && r && c && d, h = a && !i && !f && n && r, w = !(m > 1 && a) || $48515c484bc5585a$var$he(t, {
                        start: a,
                        end: $48515c484bc5585a$var$te(a, m - 2)
                    }), g = a && $48515c484bc5585a$var$we(t, a) && w;
                    e && (l || h || g) ? E(t) : null !== P && E(null);
                }
            } else E(null);
        },
        onDateSelect: function(t) {
            ('endDate' === o || 'startDate' === o) && m > 0 && f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                exactMinBookingDays: f,
                minBookingDate: u,
                maxBookingDate: s,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                startDate: t,
                endDate: $48515c484bc5585a$var$te(t, m - 1),
                focusedInput: null
            }) : ('endDate' === o && a && $48515c484bc5585a$var$le(t, a) || 'startDate' === o && i && $48515c484bc5585a$var$fe(t, i)) && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: t,
                endDate: null
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: 'endDate'
            }) : 'startDate' === o && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: i,
                startDate: t
            }) ? c({
                endDate: i,
                startDate: t,
                focusedInput: 'endDate'
            }) : 'startDate' === o && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                endDate: null,
                startDate: t
            }) ? c({
                endDate: null,
                startDate: t,
                focusedInput: 'endDate'
            }) : 'endDate' === o && a && !$48515c484bc5585a$var$le(t, a) && !f && $48515c484bc5585a$var$Se({
                minBookingDays: m,
                isDateBlocked: B,
                startDate: a,
                endDate: t
            }) && c({
                startDate: a,
                endDate: t,
                focusedInput: null
            }), 'endDate' !== o && (!N || N && !$48515c484bc5585a$var$we(t, N)) && x && U($48515c484bc5585a$export$6b0a3e73eaccfee4(g, t));
        },
        onDateFocus: O,
        goToPreviousMonths: W,
        goToPreviousMonthsByOneMonth: F,
        goToNextMonths: Q,
        goToNextMonthsByOneMonth: R,
        goToDate: I,
        goToPreviousYear: X,
        goToNextYear: G
    };
}
function $48515c484bc5585a$export$1937086c6b64f72d(t) {
    var e = t.date, n = t.focusedDate, a = t.isDateSelected, i = t.isDateFocused, o = t.isFirstOrLastSelectedDate, u = t.isDateHovered, s = t.isDateBlocked, c = t.onDateSelect, d = t.onDateFocus, l = t.onDateHover, f = (0, $dup7A.useCallback)(function() {
        return c(e);
    }, [
        e,
        c
    ]), h = (0, $dup7A.useCallback)(function() {
        return l(e);
    }, [
        e,
        l
    ]), m = s(e) && !u(e);
    return {
        tabIndex: null === n || i(e) ? 0 : -1,
        isSelected: a(e),
        isSelectedStartOrEnd: o(e),
        isWithinHoverRange: u(e),
        disabledDate: m,
        onKeyDown: function(t) {
            'ArrowRight' === t.key ? d($48515c484bc5585a$var$te(e, 1)) : 'ArrowLeft' === t.key ? d($48515c484bc5585a$var$te(e, -1)) : 'ArrowUp' === t.key ? d($48515c484bc5585a$var$te(e, -7)) : 'ArrowDown' === t.key && d($48515c484bc5585a$var$te(e, 7));
        },
        onClick: m ? function() {} : f,
        onMouseEnter: h
    };
}


function $43afcb05ca3681f6$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $43afcb05ca3681f6$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Accordion", function() {
    return $43afcb05ca3681f6$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CustomAccordion", function() {
    return $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Button", function() {
    return $43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Card", function() {
    return $43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Box", function() {
    return $43afcb05ca3681f6$var$$476168fcb44518cc$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DisplayLarge", function() {
    return $43afcb05ca3681f6$var$$ec746cba4029e202$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DisplayIcon", function() {
    return $43afcb05ca3681f6$var$$e0180679e35f2273$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DisplaySmall", function() {
    return $43afcb05ca3681f6$var$$d98b0fa15808b520$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DropdownSelect", function() {
    return $43afcb05ca3681f6$var$$69ead81f7adc490a$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "DropdownCascader", function() {
    return $43afcb05ca3681f6$var$$d8e895830981b43b$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Field", function() {
    return $43afcb05ca3681f6$var$$2677d04b7028c72d$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Searchbar", function() {
    return $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Textarea", function() {
    return $43afcb05ca3681f6$var$$870ba58bccab6eec$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Slider", function() {
    return $43afcb05ca3681f6$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "FileUploader", function() {
    return $43afcb05ca3681f6$var$$eab617fde0d2a814$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Datepicker", function() {
    return $43afcb05ca3681f6$var$$1d445195934320ed$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Radio", function() {
    return $43afcb05ca3681f6$var$$86e1d79a67710eda$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Checkbox", function() {
    return $43afcb05ca3681f6$var$$b679852ecf8e9c02$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Switch", function() {
    return $43afcb05ca3681f6$var$$34871b0f15f7c161$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "AlertMessage", function() {
    return $43afcb05ca3681f6$var$$d963730b715e990c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "PushMessage", function() {
    return $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CompactPagination", function() {
    return $43afcb05ca3681f6$var$$831351fb15d68ad0$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "StandardPagination", function() {
    return $43afcb05ca3681f6$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Tabs", function() {
    return $43afcb05ca3681f6$var$$35a1a5ac66949050$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Breadcrumb", function() {
    return $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "LinearProgress", function() {
    return $43afcb05ca3681f6$var$$8688d42e9f1d381a$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CircularProgress", function() {
    return $43afcb05ca3681f6$var$$e09296aea30ed10d$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Steps", function() {
    return $43afcb05ca3681f6$var$$250cfcb8116ed97e$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Timeline", function() {
    return $43afcb05ca3681f6$var$$c3e303edb7751c77$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "CustomTimeline", function() {
    return $43afcb05ca3681f6$var$$a3f868921843a442$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Tag", function() {
    return $43afcb05ca3681f6$var$$4c05722f1abfb34c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Tooltip", function() {
    return $43afcb05ca3681f6$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "ScrollbarContainer", function() {
    return $43afcb05ca3681f6$var$$b252c20c2dedb54c$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "Copiable", function() {
    return $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "lightTheme", function() {
    return $43afcb05ca3681f6$var$$18386f08588a981e$export$f30cb9bc4f736419;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "darkTheme", function() {
    return $43afcb05ca3681f6$var$$18386f08588a981e$export$3e936a8db52a10a0;
});
$43afcb05ca3681f6$var$$parcel$export($43afcb05ca3681f6$exports, "veaTheme", function() {
    return $43afcb05ca3681f6$var$$18386f08588a981e$export$a183395ddd946500;
});
function $43afcb05ca3681f6$var$$e1b614a35dc83093$export$683480f191c0e3ea(element, callback) {
    (0, $dup7A.useLayoutEffect)(()=>{
        if (!element) return;
        const observer = new ResizeObserver((entries)=>{
            callback(element, entries[0]);
        });
        observer.observe(element);
        return ()=>{
            observer.disconnect();
        };
    }, [
        callback,
        element
    ]);
}
var $43afcb05ca3681f6$var$$e1b614a35dc83093$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e1b614a35dc83093$export$683480f191c0e3ea;
function $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2b86bedf890eab8() {
    // Mutable values like 'ref.current' aren't valid dependencies
    // because mutating them doesn't re-render the component.
    // Instead, we use a state as a ref to be reactive.
    const [ref, setRef] = (0, $dup7A.useState)(null);
    const [size, setSize] = (0, $dup7A.useState)({
        width: 0,
        height: 0
    });
    // Prevent too many rendering using useCallback
    const handleSize = (0, $dup7A.useCallback)(()=>{
        setSize({
            width: ref?.offsetWidth || 0,
            height: ref?.offsetHeight || 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    (0, $554092f59a7e7485$export$7080b3e976bc91ab)("resize", handleSize);
    (0, $554092f59a7e7485$export$700979bc83e7db82)(()=>{
        handleSize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth
    ]);
    $43afcb05ca3681f6$var$$e1b614a35dc83093$export$683480f191c0e3ea(ref, handleSize);
    return [
        setRef,
        size
    ];
}
var $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2b86bedf890eab8;
const $43afcb05ca3681f6$var$$f15a4f5132e5ea52$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            clipRule: "evenodd",
            d: "M8.697 0H7.302c-.124 0-.186.06-.186.178v6.977H.186c-.124 0-.186.06-.186.178v1.334c0 .118.062.177.186.177h6.93v6.978c0 .119.062.178.186.178h1.395c.124 0 .186-.06.186-.178V8.844h6.931c.124 0 .186-.059.186-.177V7.333c0-.118-.062-.178-.186-.178h-6.93V.178C8.883.059 8.82 0 8.696 0Z"
        })
    });
var $43afcb05ca3681f6$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$f15a4f5132e5ea52$var$SvgPlus;
const $43afcb05ca3681f6$var$$ed272acf889bf255$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M15.826.333H.174A.174.174 0 0 0 0 .507v1.305c0 .095.078.174.174.174h15.652A.174.174 0 0 0 16 1.812V.507a.174.174 0 0 0-.174-.174Z"
        })
    });
var $43afcb05ca3681f6$var$$ed272acf889bf255$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ed272acf889bf255$var$SvgMinus;
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30 = (styleFn)=>(0, $e9f8389e4f70b5af$exports.css)([
        "@media (max-width:900px){",
        "}"
    ], styleFn());
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:24px;font-weight:600;line-height:33px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:16px;font-weight:600;line-height:22px;margin:0;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:16px;font-weight:400;line-height:22px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-size:14px;font-weight:400;line-height:19px;margin:0;color:",
    ";overflow-wrap:break-word;"
], ({ theme: theme })=>theme.klerosUIComponentsSecondaryText);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$b4adb3f464574dcf = (0, $e9f8389e4f70b5af$exports.css)([
    "opacity:1;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68 = (0, $e9f8389e4f70b5af$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$463b44d9bf3628be = (0, $e9f8389e4f70b5af$exports.css)([
    "display:inline-block;vertical-align:middle;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;text-transform:none;-webkit-appearance:button;:hover:enabled{cursor:pointer;}"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$b7e3ae3d7c15e42e = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;overflow:visible;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$b9d336f245a516e8 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$2e6c959c16ff56b8 = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;text-transform:none;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$a3574df893ffa88d = (0, $e9f8389e4f70b5af$exports.css)([
    "font-family:inherit;font-size:100%;margin:0;border:none;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26 = (0, $e9f8389e4f70b5af$exports.css)([
    "box-sizing:border-box;*,*:before,*:after{box-sizing:border-box;}"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394 = (0, $e9f8389e4f70b5af$exports.css)([
    "transition:0.1s;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$603679fcdd350e3b = (0, $e9f8389e4f70b5af$exports.css)([
    "transition:0.2s;"
]);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$52f70ed6d426e628 = (0, $e9f8389e4f70b5af$exports.css)([
    ":hover{background-color:",
    ";}"
], (props)=>props.theme.klerosUIComponentsMediumBlue);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$360c6850771ad63 = (0, $e9f8389e4f70b5af$exports.css)([
    ":hover{background-color:",
    ";}"
], (props)=>props.theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$49a276e58256b44f$export$82e6205b15e6c637 = (0, $e9f8389e4f70b5af$exports.keyframes)([
    "0%{opacity:0;}50%{opacity:0.5;}100%{opacity:1;}"
]);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$StyledDiv = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion-item__StyledDiv",
    componentId: "sc-17yp2l-0"
})([
    "margin:8px 0px;.accordion-button{",
    " ",
    " ",
    " width:100%;background-color:",
    ";border:1px solid ",
    ";border-radius:3px;padding:11.5px 32px;display:flex;justify-content:space-between;align-items:center;.accordion-svg{",
    " height:16px;width:16px;fill:",
    ";}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$49a276e58256b44f$export$52f70ed6d426e628, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Collapsible = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion-item__Collapsible",
    componentId: "sc-17yp2l-1"
})([
    "height:",
    "px;overflow:",
    ";transition:height ease ",
    ";"
], (props)=>props.expanded ? props.totalHeight.toString() : "0", (props)=>props.expanded ? "visible" : "hidden", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Body = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion-item__Body",
    componentId: "sc-17yp2l-2"
})([
    "padding:32px;"
]);
const $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$AccordionItem = ({ title: title, body: body, index: index, expanded: expanded, setExpanded: setExpanded })=>{
    const [ref, { height: height }] = $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2b86bedf890eab8();
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$33bd37d24f01bb71$var$StyledDiv, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("button", {
                className: "accordion-button",
                onClick: ()=>setExpanded(expanded ? -1 : index),
                children: [
                    title,
                    expanded ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$ed272acf889bf255$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$f15a4f5132e5ea52$export$2e2bcd8739ae039, {
                        className: "accordion-svg"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Collapsible, {
                expanded: expanded,
                totalHeight: height,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$33bd37d24f01bb71$var$Body, {
                    ref: ref,
                    children: [
                        " ",
                        body,
                        " "
                    ]
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$33bd37d24f01bb71$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$33bd37d24f01bb71$var$AccordionItem;
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "accordion__Wrapper",
    componentId: "sc-7o1u6g-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$AccordionTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "accordion__AccordionTitle",
    componentId: "sc-7o1u6g-1"
})([
    "",
    " width:fit-content;font-weight:600;text-align:center;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$DefaultTitle = ({ item: item })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($975c4832af85a2cd$exports.Fragment, {
        children: [
            item.icon ?? (item.Icon && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(item.Icon, {})),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$AccordionTitle, {
                children: item.title
            })
        ]
    });
const $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Accordion = ({ items: items, defaultExpanded: defaultExpanded, ...props })=>{
    const [expanded, setExpanded] = (0, $dup7A.useState)(defaultExpanded ?? -1);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$DefaultTitle, {
                    item: item
                }),
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $43afcb05ca3681f6$var$$906ee81c6c1db5eb$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$906ee81c6c1db5eb$var$Accordion;
const $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-dc5dy3-0"
})([
    "",
    " display:flex;flex-direction:column;width:1000px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$CustomAccordion = ({ items: items, ...props })=>{
    const [expanded, setExpanded] = (0, $dup7A.useState)(-1);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$Wrapper, {
        ...props,
        children: items.map((item, index)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$33bd37d24f01bb71$export$2e2bcd8739ae039, {
                index: index,
                title: item.title,
                body: item.body,
                setExpanded: setExpanded,
                expanded: expanded === index
            }, index))
    });
};
var $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$81cddd8d5c3e47e4$var$CustomAccordion;
const $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$breathing = (0, $e9f8389e4f70b5af$exports.keyframes)([
    "0%{transform:scale(1);}50%{transform:scale(1.3);}100%{transform:scale(1);}"
]);
const $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$BaseButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "base__BaseButton",
    componentId: "sc-15fqe1k-0"
})([
    "",
    " ",
    " position:relative;width:fit-content;height:fit-content;display:flex;flex-direction:row;justify-content:center;align-items:center;padding:",
    ";border-radius:3px;border:none;transition:background ease ",
    ";.button-text{",
    " ",
    " font-weight:600;text-align:center;white-space:pre;}.button-svg{",
    " ",
    " height:16px;width:16px;margin-right:8px;}.button-loading{position:absolute;height:22px;fill:",
    ";animation:",
    " 2s ease-out infinite normal;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>{
    if (props.small) return props.variant === "secondary" ? "5px 23px" : "6px 24px";
    return props.variant === "secondary" ? "10.5px 31px" : "11.5px 32px";
}, (props)=>props.theme.klerosUIComponentsTransitionSpeed, $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ isLoading: isLoading })=>isLoading && "visibility: hidden;", ({ theme: theme })=>theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$breathing);
var $43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$85dbc8aeed51bed3$var$BaseButton;
const $43afcb05ca3681f6$var$$64030e1eefd54f6b$var$PrimaryButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "primary__PrimaryButton",
    componentId: "sc-1cfrthg-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsSecondaryBlue);
var $43afcb05ca3681f6$var$$64030e1eefd54f6b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$64030e1eefd54f6b$var$PrimaryButton;
const $43afcb05ca3681f6$var$$e015af9dc133eba5$var$SecondaryButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "secondary__SecondaryButton",
    componentId: "sc-urt0vi-0"
})([
    "background:",
    ";border:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.disabled ? `1px solid ${props.theme.klerosUIComponentsStroke}` : `1px solid ${props.theme.klerosUIComponentsPrimaryBlue}`, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.disabled ? props.theme.klerosUIComponentsLightGrey : props.theme.klerosUIComponentsMediumBlue);
var $43afcb05ca3681f6$var$$e015af9dc133eba5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e015af9dc133eba5$var$SecondaryButton;
const $43afcb05ca3681f6$var$$a028db5d769593a3$var$TertiaryButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$85dbc8aeed51bed3$export$2e2bcd8739ae039).withConfig({
    displayName: "tertiary__TertiaryButton",
    componentId: "sc-jvmd2g-0"
})([
    "background:",
    ";.button-text{color:",
    ";}.button-svg{fill:",
    ";}.button-loading{fill:",
    ";}:hover{background:",
    ";}"
], (props)=>props.theme.klerosUIComponentsSecondaryPurple, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsWhiteBackground, (props)=>props.theme.klerosUIComponentsPrimaryPurple);
var $43afcb05ca3681f6$var$$a028db5d769593a3$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a028db5d769593a3$var$TertiaryButton;
const $43afcb05ca3681f6$var$$c65a9c2fdb9de77b$var$SvgKleros = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 46 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "m14.545 3.992 21.06.94 8.526 18.92L32.1 41.143 10.929 39.79l-8.68-20.5L14.544 3.993Zm15.44 10.906-15.263 6.66L27.77 31.634l2.214-16.736Zm-1.768-3.337L16.02 6.316l-2.562 11.028 14.76-5.783Zm-3.091 22.608-13.257-9.454.321 12.81 12.936-3.356ZM42.013 23.81l-9.033-9.154-2.384 17.604 11.417-8.45Zm-13.78 12.418-11.18 2.918 13.148.84-1.967-3.758Zm12.015-8.264-9.786 7.28 1.944 3.796 7.842-11.076Zm-4.63-20.388-1.9 3.897 7.075 7.182-5.174-11.08ZM33.252 5.71l-12.424-.504 10.248 4.477 2.176-3.973ZM12.73 7.513 4.028 18.487l5.819 1.23L12.73 7.514ZM9.496 21.871 3.65 20.635l6.1 14.352-.254-13.116Z"
        })
    });
var $43afcb05ca3681f6$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$c65a9c2fdb9de77b$var$SvgKleros;
const $43afcb05ca3681f6$var$$2987665db72ba3c1$var$Button = ({ text: text, variant: variant, Icon: Icon, icon: icon, onClick: onClick, isLoading: isLoading, ...props })=>{
    let ButtonType = $43afcb05ca3681f6$var$$64030e1eefd54f6b$export$2e2bcd8739ae039;
    if (variant === "secondary") ButtonType = $43afcb05ca3681f6$var$$e015af9dc133eba5$export$2e2bcd8739ae039;
    if (variant === "tertiary") ButtonType = $43afcb05ca3681f6$var$$a028db5d769593a3$export$2e2bcd8739ae039;
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)(ButtonType, {
        variant: variant,
        onClick: onClick,
        isLoading: isLoading,
        ...props,
        children: [
            isLoading && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$c65a9c2fdb9de77b$export$2e2bcd8739ae039, {
                className: "button-loading"
            }),
            icon ?? (Icon && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {
                className: "button-svg"
            })),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("p", {
                className: "button-text",
                children: text
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2987665db72ba3c1$var$Button;
const $43afcb05ca3681f6$var$$48087ec110ef8615$var$Card = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "card__Card",
    componentId: "sc-1g2jfm3-0"
})([
    "",
    " ",
    " background-color:",
    ";border:1px solid ",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:",
    ";width:328px;height:200px;",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, ({ round: round })=>round ? "18px" : "3px", ({ theme: theme, hover: hover })=>hover && `
      :hover {
        background-color: ${theme.klerosUIComponentsLightGrey}BB;
        cursor: pointer;
      }
  `);
var $43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$48087ec110ef8615$var$Card;
const $43afcb05ca3681f6$var$$476168fcb44518cc$var$Box = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "box__Box",
    componentId: "sc-1by74ub-0"
})([
    "",
    " background:",
    ";border-radius:18px;width:328px;height:200px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
var $43afcb05ca3681f6$var$$476168fcb44518cc$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$476168fcb44518cc$var$Box;
const $43afcb05ca3681f6$var$$ec746cba4029e202$var$StyledCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "large__StyledCard",
    componentId: "sc-1f0y32e-0"
})([
    "position:relative;height:80px;width:288px;padding:16px;display:flex;flex-direction:column;align-items:start;justify-content:center;.display-icon{",
    " position:absolute;top:16px;right:16px;max-height:16px;max-width:16px;}.display-text{",
    "}.display-label{",
    "}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$ec746cba4029e202$var$DisplayLarge = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$ec746cba4029e202$var$StyledCard, {
        ...props,
        children: [
            Icon && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {
                className: "display-icon"
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("h1", {
                className: "display-text",
                children: text
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                className: "display-label",
                children: label
            })
        ]
    });
var $43afcb05ca3681f6$var$$ec746cba4029e202$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ec746cba4029e202$var$DisplayLarge;
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$StyledCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__StyledCard",
    componentId: "sc-12ixf6j-0"
})([
    "height:80px;width:288px;padding:16px;display:flex;"
]);
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$Text = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "icon__Text",
    componentId: "sc-12ixf6j-1"
})([
    "",
    " height:100%;width:auto;margin-left:16px;flex-direction:column;align-items:start;justify-content:center;.display-text{",
    "}.display-label{",
    "}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$IconCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "icon__IconCard",
    componentId: "sc-12ixf6j-2"
})([
    "height:48px;width:48px;display:flex;justify-content:center;align-items:center;.display-icon{",
    " max-height:32px;max-width:32px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$e0180679e35f2273$var$DisplayIcon = ({ text: text, Icon: Icon, label: label, ...props })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$e0180679e35f2273$var$StyledCard, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$e0180679e35f2273$var$IconCard, {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {
                    className: "display-icon"
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$e0180679e35f2273$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("h1", {
                        className: "display-text",
                        children: text
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                        className: "display-label",
                        children: label
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$e0180679e35f2273$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e0180679e35f2273$var$DisplayIcon;
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "small__Wrapper",
    componentId: "sc-ismyqd-0"
})([
    "",
    " width:217px;display:flex;flex-direction:column;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledLabel = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "small__StyledLabel",
    componentId: "sc-ismyqd-1"
})([
    "",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledCard = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$48087ec110ef8615$export$2e2bcd8739ae039).withConfig({
    displayName: "small__StyledCard",
    componentId: "sc-ismyqd-2"
})([
    "height:45px;width:100%;margin-top:16px;display:flex;align-items:center;padding:0px 16px;.display-icon{",
    " max-height:16px;max-width:16px;margin-right:8px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "small__StyledText",
    componentId: "sc-ismyqd-3"
})([
    "",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$d98b0fa15808b520$var$DisplaySmall = ({ text: text, Icon: Icon, label: label, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledCard, {
                children: [
                    Icon && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {
                        className: "display-icon"
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d98b0fa15808b520$var$StyledText, {
                        children: text
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$d98b0fa15808b520$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d98b0fa15808b520$var$DisplaySmall;
//! type
//eslint-disable-next-line @typescript-eslint/ban-types
function $43afcb05ca3681f6$var$$bfcc265ae6655ec9$var$useFocusOutside(ref, callback) {
    (0, $dup7A.useEffect)(()=>{
        function handleEvent(event) {
            if (ref.current && !ref.current.contains(event.target)) callback();
        }
        document.addEventListener("focusin", handleEvent);
        document.addEventListener("mousedown", handleEvent);
        return ()=>{
            document.removeEventListener("focusin", handleEvent);
            document.removeEventListener("mousedown", handleEvent);
        };
    }, [
        ref,
        callback
    ]);
}
var $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$bfcc265ae6655ec9$var$useFocusOutside;
const $43afcb05ca3681f6$var$$a4b0ebb54b8823c5$var$SvgArrow = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 12 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M11.598.25H.402C.067.25-.121.605.087.847l5.598 6.49c.16.186.468.186.63 0l5.598-6.49c.208-.242.02-.597-.316-.597Z"
        })
    });
var $43afcb05ca3681f6$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a4b0ebb54b8823c5$var$SvgArrow;
const $43afcb05ca3681f6$var$$43d9fcbe58645246$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "button__Container",
    componentId: "sc-wywpa8-0"
})([
    "",
    " ",
    " ",
    " ",
    " width:240px;background-color:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:space-between;padding:0px 16px 0px 0px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$49a276e58256b44f$export$603679fcdd350e3b, $43afcb05ca3681f6$var$$49a276e58256b44f$export$52f70ed6d426e628, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$43d9fcbe58645246$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)(({ ignoredIsOpen: ignoredIsOpen, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "button__StyledArrow",
    componentId: "sc-wywpa8-1"
})([
    "",
    " width:16px;height:16px;fill:",
    ";",
    " transition:transform ease ",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ ignoredIsOpen: ignoredIsOpen })=>ignoredIsOpen && (0, $e9f8389e4f70b5af$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$43d9fcbe58645246$var$DropdownButton = ({ node: node, isOpen: isOpen, setIsOpen: setIsOpen, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$43d9fcbe58645246$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            node,
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$43d9fcbe58645246$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ...props
            })
        ]
    });
var $43afcb05ca3681f6$var$$43d9fcbe58645246$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$43d9fcbe58645246$var$DropdownButton;
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "simple-button__Container",
    componentId: "sc-rpqfxz-0"
})([
    "",
    " ",
    " background:none;display:flex;align-items:center;padding:0px;:hover{small{color:",
    ";}h1{color:",
    ";}svg{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledSmallText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "simple-button__StyledSmallText",
    componentId: "sc-rpqfxz-1"
})([
    "",
    " ",
    " font-weight:600;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledBigText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h1.withConfig({
    displayName: "simple-button__StyledBigText",
    componentId: "sc-rpqfxz-2"
})([
    "",
    " ",
    " font-weight:600;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$448e4850cad7c7b0, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)(({ ignoredIsOpen: ignoredIsOpen, ignoredSmall: ignoredSmall, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a4b0ebb54b8823c5$export$2e2bcd8739ae039, {
        ...props
    })).withConfig({
    displayName: "simple-button__StyledArrow",
    componentId: "sc-rpqfxz-3"
})([
    "",
    " ",
    " width:",
    "px;height:",
    "px;fill:",
    ";",
    " transition:transform ease ",
    ";margin-left:8px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ ignoredSmall: small })=>small ? "8" : "16", ({ ignoredSmall: small })=>small ? "8" : "16", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ ignoredIsOpen: isOpen })=>isOpen && (0, $e9f8389e4f70b5af$exports.css)([
        "transform:rotate(180deg);"
    ]), ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$DropdownButton = ({ text: text, isOpen: isOpen, setIsOpen: setIsOpen, small: small, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$Container, {
        onClick: ()=>setIsOpen(!isOpen),
        ...props,
        children: [
            small ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledSmallText, {
                children: text
            }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledBigText, {
                children: text
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$var$StyledArrow, {
                ignoredIsOpen: isOpen,
                ignoredSmall: small,
                ...props
            })
        ]
    });
var $43afcb05ca3681f6$var$$83ebe14398e57e2d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$83ebe14398e57e2d$var$DropdownButton;
const $43afcb05ca3681f6$var$$b252c20c2dedb54c$var$CustomScrollbarContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$parcel$interopDefault($bbbd8fadaf5f7664$exports)).withConfig({
    displayName: "scrollbar__CustomScrollbarContainer",
    componentId: "sc-16x8nkv-0"
})([
    "",
    " .simplebar-scrollbar:before{background:",
    ";}.simplebar-scrollbar.simplebar-visible:before{opacity:1;}.simplebar-mask{background:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
var $43afcb05ca3681f6$var$$b252c20c2dedb54c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b252c20c2dedb54c$var$CustomScrollbarContainer;
const $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "base-item-container__ItemContainer",
    componentId: "sc-1h7f57o-0"
})([
    "",
    " flex:1;width:238px;height:auto;background:",
    ";padding:16px 0px;display:grid;grid-template-rows:repeat(auto-fill,minmax(0,45px));"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$b252c20c2dedb54c$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item-container__StyledScrollbarContainer",
    componentId: "sc-1h7f57o-1"
})([
    "width:238px;max-height:350px;"
]);
const $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar = ({ children: children, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$StyledScrollbarContainer, {
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainer, {
            children: children
        })
    });
var $43afcb05ca3681f6$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4fc41d5788d8f02e$var$ItemContainerWithScrollbar;
const $43afcb05ca3681f6$var$$66882cfb76c803d6$var$Dot = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dot__Dot",
    componentId: "sc-1v9nycp-0"
})([
    "",
    " background:",
    ";border-radius:50%;width:8px;height:8px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ color: color })=>color);
var $43afcb05ca3681f6$var$$66882cfb76c803d6$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$66882cfb76c803d6$var$Dot;
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$Item = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "base-item__Item",
    componentId: "sc-1q4tyix-0"
})([
    "",
    " ",
    " background-color:",
    ";padding:",
    ";display:flex;align-items:center;",
    " .item-icon{",
    " max-height:16px;max-width:16px;min-height:12px;min-width:12px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsMediumBlue : "", ({ current: current })=>current ? "10.5px 16px 10.5px 13px" : "11.5px 16px 11.5px 13px", (props)=>!props.current && (0, $e9f8389e4f70b5af$exports.css)([
        ":hover{background:",
        ";cursor:pointer;}"
    ], props.theme.klerosUIComponentsMediumBlue), $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "base-item__StyledText",
    componentId: "sc-1q4tyix-1"
})([
    "",
    " font-size:16px;user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledDot = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$66882cfb76c803d6$export$2e2bcd8739ae039).withConfig({
    displayName: "base-item__StyledDot",
    componentId: "sc-1q4tyix-2"
})([
    "margin-right:8px;"
]);
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$CountDisplay = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).label.withConfig({
    displayName: "base-item__CountDisplay",
    componentId: "sc-1q4tyix-3"
})([
    "width:24px;height:24px;border:1px solid ",
    ";border-radius:100%;display:flex;align-items:center;justify-content:center;font-size:12px;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$eff5a32ef289d478$var$BaseItem = ({ text: text, Icon: Icon, icon: icon, dot: dot, onClick: onClick, childrenCount: childrenCount, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$eff5a32ef289d478$var$Item, {
        onKeyPress: (e)=>onClick && e.key === "Enter" ? onClick() : undefined,
        onClick: onClick,
        ...props,
        children: [
            icon ?? (Icon && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {
                className: "item-icon"
            })),
            dot && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledDot, {
                color: dot
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$eff5a32ef289d478$var$StyledText, {
                children: text
            }),
            childrenCount !== undefined ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$eff5a32ef289d478$var$CountDisplay, {
                className: "count-display",
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("span", {
                    children: childrenCount
                })
            }) : null
        ]
    });
var $43afcb05ca3681f6$var$$eff5a32ef289d478$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$eff5a32ef289d478$var$BaseItem;
const $43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4 = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledItem",
    componentId: "sc-b6y23n-0"
})([
    "border-left:3px solid ",
    ";",
    ""
], ({ theme: theme, selected: selected })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsWhiteBackground, ({ theme: theme, selected: selected, current: current })=>!current && (0, $e9f8389e4f70b5af$exports.css)([
        ":hover{border-left:3px solid ",
        ";}"
    ], selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsMediumBlue));
const $43afcb05ca3681f6$var$$bc9b74e06ed8f896$var$ItemContainer = ({ items: items, selected: selected, onChange: onChange })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        children: items.map(({ text: text, Icon: Icon, icon: icon, dot: dot, value: value }, i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
                tabIndex: 0,
                selected: value === selected,
                onClick: ()=>onChange(value),
                text: text,
                dot: dot,
                Icon: Icon,
                icon: icon
            }, i))
    });
var $43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$bc9b74e06ed8f896$var$ItemContainer;
const $43afcb05ca3681f6$var$$2d381104713b6d5d$var$SelectButton = ({ item: item, simple: simple, small: small, isOpen: isOpen, setIsOpen: setIsOpen })=>simple ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$83ebe14398e57e2d$export$2e2bcd8739ae039, {
        text: item.text,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        small: small
    }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        node: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$7c16ae7705e422c4, {
            current: true,
            ...item
        })
    });
var $43afcb05ca3681f6$var$$2d381104713b6d5d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2d381104713b6d5d$var$SelectButton;
const $43afcb05ca3681f6$var$$dad9719307029a16$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown-container__Container",
    componentId: "sc-qkfxj5-0"
})([
    "",
    " ",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme, isOpen: isOpen, alignRight: alignRight })=>(0, $e9f8389e4f70b5af$exports.css)([
        "position:absolute;",
        " z-index:100;visibility:",
        ";transform:scaleY(",
        ");transform-origin:top;transition-property:transform,visibility;transition-duration:",
        ";transition-timing-function:ease;height:auto;background:transparent;box-shadow:0px 2px 3px ",
        ";overflow:hidden;"
    ], alignRight ? "right: 0px;" : "", isOpen ? "visible" : "hidden", isOpen ? "1" : "0", theme.klerosUIComponentsTransitionSpeed, theme.klerosUIComponentsDefaultShadow));
const $43afcb05ca3681f6$var$$dad9719307029a16$var$DropdownContainer = ({ children: children, isOpen: isOpen, alignRight: alignRight, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$dad9719307029a16$var$Container, {
        isOpen: isOpen,
        alignRight: alignRight,
        ...props,
        children: [
            " ",
            children,
            " "
        ]
    });
var $43afcb05ca3681f6$var$$dad9719307029a16$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$dad9719307029a16$var$DropdownContainer;
const $43afcb05ca3681f6$var$$69ead81f7adc490a$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "select__Container",
    componentId: "sc-s4pei-0"
})([
    "position:relative;"
]);
const $43afcb05ca3681f6$var$$69ead81f7adc490a$var$DropdownContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "select__DropdownContainer",
    componentId: "sc-s4pei-1"
})([
    "",
    ""
], ({ theme: theme })=>(0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border:1px solid ",
        ";border-radius:3px;"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsStroke));
const $43afcb05ca3681f6$var$$69ead81f7adc490a$var$Select = ({ items: items, callback: callback, simpleButton: simpleButton, smallButton: smallButton, defaultValue: defaultValue, placeholder: placeholder, alignRight: alignRight, ...props })=>{
    const [isOpen, setIsOpen] = (0, $dup7A.useState)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [selected, setSelected] = (0, $dup7A.useState)(defaultValue);
    const currentItem = items.find(({ value: value })=>value === selected);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$69ead81f7adc490a$var$Container, {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2d381104713b6d5d$export$2e2bcd8739ae039, {
                item: currentItem ? currentItem : placeholder ? placeholder : {
                    text: ""
                },
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                simple: simpleButton,
                small: smallButton
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$69ead81f7adc490a$var$DropdownContainer, {
                isOpen: isOpen,
                alignRight: alignRight,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$bc9b74e06ed8f896$export$2e2bcd8739ae039, {
                    items: items,
                    selected: selected,
                    onChange: (value)=>{
                        new Promise((resolve)=>resolve(callback(value))).then(()=>{
                            setSelected(value);
                            setIsOpen(false);
                        }).catch((error)=>console.error(error));
                    }
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$69ead81f7adc490a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$69ead81f7adc490a$var$Select;
const $43afcb05ca3681f6$var$$be261e7e6de1aa96$var$SvgLightLeft = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        width: 7,
        height: 11,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M6.375 1.143V.107c0-.09-.103-.139-.173-.084L.165 4.739a.427.427 0 0 0 0 .673l6.037 4.716a.107.107 0 0 0 .173-.085V9.008a.217.217 0 0 0-.082-.168L1.472 5.075l4.821-3.765a.217.217 0 0 0 .082-.168Z"
        })
    });
var $43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$be261e7e6de1aa96$var$SvgLightLeft;
const $43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936 = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$eff5a32ef289d478$export$2e2bcd8739ae039).withConfig({
    displayName: "item-container__StyledBaseItem",
    componentId: "sc-gth5to-0"
})([
    "position:relative;.item-icon{position:absolute;transform:rotate(180deg);right:16px;fill:",
    ";}.count-display{position:absolute;right:32px;border-color:",
    ";color:",
    ";}"
], ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke, ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke, ({ selected: selected, theme: theme })=>selected ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2f29ff49e895ab7b$var$ItemContainer = ({ layer: layer, onChange: onChange, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4fc41d5788d8f02e$export$2e2bcd8739ae039, {
        ...props,
        children: layer.items.map((item, i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                tabIndex: 0,
                text: item.label,
                Icon: item.children && $43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039,
                onClick: ()=>onChange(item),
                childrenCount: item.children?.length,
                selected: item.value === layer.selected
            }, i))
    });
var $43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2f29ff49e895ab7b$var$ItemContainer;
const $43afcb05ca3681f6$var$$3b159669545f46c0$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "selector__Wrapper",
    componentId: "sc-1nl16fm-0"
})([
    "",
    " border-bottom-left-radius:3px;border-bottom-right-radius:3px;background:",
    ";padding:8px 16px;display:flex;",
    " justify-content:end;align-items:center;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "justify-content:center;"
    ])));
const $43afcb05ca3681f6$var$$3b159669545f46c0$var$Selector = ({ currentSelection: currentSelection, onSelect: onSelect, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$3b159669545f46c0$var$Wrapper, {
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
            onClick: ()=>onSelect(),
            text: currentSelection ? `Select\n${currentSelection}` : "No Selection",
            disabled: !currentSelection
        })
    });
var $43afcb05ca3681f6$var$$3b159669545f46c0$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$3b159669545f46c0$var$Selector;
const $43afcb05ca3681f6$var$$d8e895830981b43b$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$dad9719307029a16$export$2e2bcd8739ae039).withConfig({
    displayName: "cascader__Wrapper",
    componentId: "sc-x4ug59-0"
})([
    "border:1px solid ",
    ";",
    " border-radius:3px;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "width:240px;"
    ])));
const $43afcb05ca3681f6$var$$d8e895830981b43b$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "cascader__Container",
    componentId: "sc-x4ug59-1"
})([
    "",
    ""
], ({ theme: theme, path: path, isOpen: isOpen })=>(0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border-bottom:1px solid ",
        ";border-radius:3px;display:grid;grid-template-columns:repeat(",
        ",238px) 0px;grid-template-rows:max-content;gap:1px;",
        ""
    ], isOpen ? theme.klerosUIComponentsStroke : theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke, path.length, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
            "overflow:auto;"
        ]))));
const $43afcb05ca3681f6$var$$d8e895830981b43b$var$Cascader = ({ items: items, onSelect: onSelect, placeholder: placeholder, value: value, ...props })=>{
    const [path, setPath] = (0, $dup7A.useState)([
        {
            items: items
        }
    ]);
    const [current, setCurrent] = (0, $dup7A.useState)();
    const [selected, setSelected] = (0, $dup7A.useState)();
    const [isOpen, setIsOpen] = (0, $dup7A.useState)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    const lastElementRef = (0, $dup7A.useRef)(null);
    $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    (0, $dup7A.useEffect)(()=>{
        if (lastElementRef?.current && isOpen) $43afcb05ca3681f6$var$$parcel$interopDefault($0535cdc15230b38d$exports)(lastElementRef.current);
    //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        path
    ]);
    const label = (0, $dup7A.useMemo)(()=>value ? $43afcb05ca3681f6$var$$d8e895830981b43b$var$findLabelByValue(items, value) : undefined, [
        items,
        value
    ]);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("div", {
        ref: containerRef,
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$43d9fcbe58645246$export$2e2bcd8739ae039, {
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                node: selected ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: selected.label
                }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$a1a71dc089009936, {
                    current: true,
                    text: label ?? placeholder
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d8e895830981b43b$var$Wrapper, {
                isOpen: isOpen,
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d8e895830981b43b$var$Container, {
                        path: path,
                        isOpen: isOpen,
                        children: [
                            path.map((layer, depth)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2f29ff49e895ab7b$export$2e2bcd8739ae039, {
                                    layer: layer,
                                    onChange: (item)=>{
                                        let newPath;
                                        if (depth < path.length) newPath = path.slice(0, depth + 1);
                                        else newPath = path;
                                        newPath[depth].selected = item.value;
                                        if (item.children) newPath.push({
                                            items: item.children
                                        });
                                        setPath(newPath);
                                        setCurrent(item);
                                    }
                                }, depth)),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("div", {
                                ref: lastElementRef
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$3b159669545f46c0$export$2e2bcd8739ae039, {
                        onSelect: ()=>{
                            if (current) new Promise((resolve)=>resolve(onSelect(current.value))).then(()=>{
                                setSelected(current);
                                setIsOpen(false);
                            }).catch((error)=>console.error(error));
                        },
                        currentSelection: current?.label
                    })
                ]
            })
        ]
    });
};
/**
 * @param nodes the nodes
 * @param targetValue the value to search, can be string or number
 * @returns the label if the item is found, else returns undefined
 */ function $43afcb05ca3681f6$var$$d8e895830981b43b$var$findLabelByValue(nodes, targetValue) {
    for (const node of nodes){
        if (node.value == targetValue) return node.label;
        if (node.children) {
            const result = $43afcb05ca3681f6$var$$d8e895830981b43b$var$findLabelByValue(node.children, targetValue);
            if (result) return result;
        }
    }
    return undefined;
}
var $43afcb05ca3681f6$var$$d8e895830981b43b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d8e895830981b43b$var$Cascader;
const $43afcb05ca3681f6$var$$1fbc1df023618cf8$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 10.6a.567.567 0 0 1-.923 0L4.545 7.516a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z"
        })
    });
var $43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1fbc1df023618cf8$var$SvgSuccess;
const $43afcb05ca3681f6$var$$773dfb225348757e$var$SvgWarning = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037 3.749a.857.857 0 1 1 1.211-1.212.857.857 0 0 1-1.211 1.212Zm1.034-2.606h-.857A.143.143 0 0 1 7.428 9V4.143c0-.079.065-.143.143-.143h.857c.079 0 .143.064.143.143V9a.143.143 0 0 1-.143.143Z"
        })
    });
var $43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$773dfb225348757e$var$SvgWarning;
const $43afcb05ca3681f6$var$$1055d191a5da0897$var$SvgError = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm9.596-2.967c.079 0 .143.064.143.143 0 .034-.01.068-.032.093L8.741 8.037l2.32 2.766a.148.148 0 0 1 .033.092c0 .08-.064.143-.143.143l-1.178-.005L8 8.919l-1.773 2.116-1.18.005a.143.143 0 0 1-.11-.236L7.26 8.038 4.937 5.271a.149.149 0 0 1-.034-.093c0-.08.065-.143.143-.143l1.18.005L8 7.154l1.775-2.116 1.178-.005Z"
        })
    });
var $43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1055d191a5da0897$var$SvgError;
const $43afcb05ca3681f6$var$$3b81fb62e49a97d5$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M0 8a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8Zm1.357 0a6.644 6.644 0 0 0 13.286 0A6.644 6.644 0 0 0 1.357 8Zm6.037-2.537a.857.857 0 1 1 1.212-1.212.857.857 0 0 1-1.212 1.212Zm.177 1.394h.857c.079 0 .143.064.143.143v4.857a.143.143 0 0 1-.143.143h-.857a.143.143 0 0 1-.143-.143V7c0-.079.065-.143.143-.143Z"
        })
    });
var $43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$3b81fb62e49a97d5$var$SvgInfo;
const $43afcb05ca3681f6$var$$8355cfb0932ae33e$var$SvgFieldArrowUp = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M278.313 48.296a42.667 42.667 0 0 1 15.876 15.876l182.478 319.336c11.691 20.46 4.583 46.523-15.876 58.214a42.667 42.667 0 0 1-21.169 5.621H74.667C51.103 447.343 32 428.241 32 404.677a42.667 42.667 0 0 1 5.622-21.169L220.099 64.172c11.691-20.46 37.755-27.567 58.214-15.876Z",
            fill: "#000",
            fillRule: "evenodd"
        })
    });
var $43afcb05ca3681f6$var$$8355cfb0932ae33e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$8355cfb0932ae33e$var$SvgFieldArrowUp;
const $43afcb05ca3681f6$var$$e594305c09c6e506$var$SvgFieldArrowDown = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg",
        transform: "scale(1 -1)",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M278.313 48.296a42.667 42.667 0 0 1 15.876 15.876l182.478 319.336c11.691 20.46 4.583 46.523-15.876 58.214a42.667 42.667 0 0 1-21.169 5.621H74.667C51.103 447.343 32 428.241 32 404.677a42.667 42.667 0 0 1 5.622-21.169L220.099 64.172c11.691-20.46 37.755-27.567 58.214-15.876Z",
            fill: "#000",
            fillRule: "evenodd"
        })
    });
var $43afcb05ca3681f6$var$$e594305c09c6e506$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e594305c09c6e506$var$SvgFieldArrowDown;
const $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 = (0, $e9f8389e4f70b5af$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "warning") return theme.klerosUIComponentsWarning;
    if (variant === "error") return theme.klerosUIComponentsError;
    if (variant === "success") return theme.klerosUIComponentsSuccess;
    return theme.klerosUIComponentsSecondaryText;
});
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "field__Wrapper",
    componentId: "sc-4pge1s-0"
})([
    "",
    " height:45px;width:278px;position:relative;color:red;.field-svg{",
    " height:16px;width:16px;position:absolute;top:14px;right:16px;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSuccessIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledSuccessIcon",
    componentId: "sc-4pge1s-1"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsSuccess);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledWarningIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledWarningIcon",
    componentId: "sc-4pge1s-2"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsWarning);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledErrorIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039).withConfig({
    displayName: "field__StyledErrorIcon",
    componentId: "sc-4pge1s-3"
})([
    "fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsError);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ceeb223748e25cf7 = (0, $e9f8389e4f70b5af$exports.css)([
    "",
    " ",
    " height:100%;width:100%;background:",
    ";border:1px solid ",
    ";border-radius:3px;color:",
    ";:focus{outline:none;border:1px solid ",
    "40;box-shadow:0px 0px 6px ",
    ";border-radius:3px;}::placeholder{color:",
    ";opacity:0.5;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$52f70ed6d426e628, $43afcb05ca3681f6$var$$49a276e58256b44f$export$603679fcdd350e3b, (props)=>props.theme.klerosUIComponentsWhiteBackground, ({ variant: variant, theme: theme })=>variant ? $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6 : theme.klerosUIComponentsStroke, (props)=>props.theme.klerosUIComponentsPrimaryText, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsPrimaryBlue, (props)=>props.theme.klerosUIComponentsSecondaryText);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.withConfig({
    displayName: "field__StyledInput",
    componentId: "sc-4pge1s-4"
})([
    "padding-top:14px;padding-bottom:14px;padding-left:16px;padding-right:",
    ";::-webkit-outer-spin-button,::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}-moz-appearance:textfield;appearance:textfield;",
    ""
], ({ Icon: Icon, variant: variant, type: type })=>{
    if (Icon) return type === "number" ? "64px" : "56px";
    if (variant) return type === "number" ? "52px" : "44px";
    return type === "number" ? "30px" : "16px";
}, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$ArrowsContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "field__ArrowsContainer",
    componentId: "sc-4pge1s-5"
})([
    "display:flex;flex-direction:column;justify-content:center;align-items:center;position:absolute;height:100%;width:14px;gap:4px;top:0;right:",
    ";"
], ({ Icon: Icon, variant: variant })=>{
    if (Icon) return "48px";
    if (variant) return "36px";
    return "12px";
});
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$ArrowButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "field__ArrowButton",
    componentId: "sc-4pge1s-6"
})([
    "height:14px;width:14px;display:flex;justify-content:center;align-items:center;background:transparent;border:none;border-radius:3px;padding:0;cursor:pointer;:hover{background:",
    ";}"
], (props)=>props.theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledArrowIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "field__StyledArrowIcon",
    componentId: "sc-4pge1s-7"
})([
    "width:8px;height:8px;path{fill:",
    ";}"
], (props)=>props.theme.klerosUIComponentsSecondaryText);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "field__StyledSVG",
    componentId: "sc-4pge1s-8"
})([
    ""
]);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9 = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "field__StyledMessage",
    componentId: "sc-4pge1s-9"
})([
    "margin-top:6px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSmall = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "field__StyledSmall",
    componentId: "sc-4pge1s-10"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$IconContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "field__IconContainer",
    componentId: "sc-4pge1s-11"
})([
    "display:flex;width:44px;height:43px;position:absolute;top:1px;right:1px;align-items:center;justify-content:center;background:",
    ";border-left:1px solid ",
    ";"
], (props)=>props.theme.klerosUIComponentsLightBlue, (props)=>props.theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledIconSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "field__StyledIconSVG",
    componentId: "sc-4pge1s-12"
})([
    "width:24px;height:24px;"
]);
const $43afcb05ca3681f6$var$$2677d04b7028c72d$var$Field = ({ variant: variant, message: message, Icon: Icon, className: className, ...props })=>{
    const wrapperRef = (0, $dup7A.useRef)(null);
    const inputRef = (0, $dup7A.useRef)(null);
    const hovering = (0, $554092f59a7e7485$export$ae780daf29e6d456)(wrapperRef);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$Wrapper, {
        ref: wrapperRef,
        className: className,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledInput, {
                ref: inputRef,
                variant: variant,
                Icon: Icon,
                ...props
            }),
            props.type === "number" && hovering && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$ArrowsContainer, {
                className: "field-arrows",
                variant: variant,
                Icon: Icon,
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$ArrowButton, {
                        "aria-label": "increment",
                        onClick: ()=>inputRef?.current?.stepUp(),
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledArrowIcon, {
                            as: $43afcb05ca3681f6$var$$8355cfb0932ae33e$export$2e2bcd8739ae039
                        })
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$ArrowButton, {
                        "aria-label": "decrement",
                        onClick: ()=>inputRef?.current?.stepDown(),
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledArrowIcon, {
                            as: $43afcb05ca3681f6$var$$e594305c09c6e506$export$2e2bcd8739ae039
                        })
                    })
                ]
            }),
            variant === "success" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSuccessIcon, {
                className: "field-svg"
            }),
            variant === "warning" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledWarningIcon, {
                className: "field-svg"
            }),
            variant === "error" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledErrorIcon, {
                className: "field-svg"
            }),
            Icon && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$IconContainer, {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledIconSVG, {
                    as: Icon
                })
            }),
            message && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2677d04b7028c72d$export$ca8581ef51d2f0a9, {
                variant: variant,
                children: [
                    variant === "info" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2677d04b7028c72d$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
};
$43afcb05ca3681f6$var$$2677d04b7028c72d$var$Field.displayName = "Field";
var $43afcb05ca3681f6$var$$2677d04b7028c72d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2677d04b7028c72d$var$Field;
const $43afcb05ca3681f6$var$$619d93e693d921a0$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "m15.78 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51a6.468 6.468 0 0 0 1.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.885a.753.753 0 0 0 .003-1.062ZM6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4Z"
        })
    });
var $43afcb05ca3681f6$var$$619d93e693d921a0$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$619d93e693d921a0$var$SvgSearch;
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "searchbar__Wrapper",
    componentId: "sc-1lxp2tc-0"
})([
    "",
    " position:relative;width:278px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledField = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2677d04b7028c72d$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledField",
    componentId: "sc-1lxp2tc-1"
})([
    "height:100%;width:100%;input{padding:14px 16px 14px 40px;}"
]);
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$619d93e693d921a0$export$2e2bcd8739ae039).withConfig({
    displayName: "searchbar__StyledSearchIcon",
    componentId: "sc-1lxp2tc-2"
})([
    "position:absolute;left:16px;top:50%;transform:translateY(-50%);width:16px;height:16px;max-width:16px;max-height:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Searchbar = ({ className: className, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledField, {
                placeholder: "Search",
                ...props
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$StyledSearchIcon, {})
        ]
    });
var $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$aa6f4c7dc0f5685c$var$Searchbar;
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "textarea__Wrapper",
    componentId: "sc-bi4jd2-0"
})([
    "",
    " height:115px;width:400px;position:relative;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledTextarea = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).textarea.withConfig({
    displayName: "textarea__StyledTextarea",
    componentId: "sc-bi4jd2-1"
})([
    "resize:none;padding:16px;display:block;font-family:inherit;",
    ""
], $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ceeb223748e25cf7);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "textarea__StyledSVG",
    componentId: "sc-bi4jd2-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Message = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "textarea__Message",
    componentId: "sc-bi4jd2-3"
})([
    "margin-top:12px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSmall = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "textarea__StyledSmall",
    componentId: "sc-bi4jd2-4"
})([
    "",
    " position:relative;text-align:justify;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Textarea = ({ message: message, variant: variant, className: className, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledTextarea, {
                variant: variant,
                ...props
            }),
            message && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$870ba58bccab6eec$var$StyledSmall, {
                        variant: variant,
                        children: message
                    })
                ]
            })
        ]
    });
$43afcb05ca3681f6$var$$870ba58bccab6eec$var$Textarea.displayName = "Textarea";
var $43afcb05ca3681f6$var$$870ba58bccab6eec$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$870ba58bccab6eec$var$Textarea;
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "handle__Wrapper",
    componentId: "sc-no0w1x-0"
})([
    "",
    " display:flex;flex-direction:column;justify-content:flex-start;align-items:flex-start;position:relative;top:8px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Label = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "handle__Label",
    componentId: "sc-no0w1x-1"
})([
    "position:relative;left:",
    "%;transform:translateX(-50%);bottom:44px;color:",
    ";"
], ({ offset: offset })=>offset, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$StyledHandle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($53eb3904070cf0e9$exports.Handle).withConfig({
    displayName: "handle__StyledHandle",
    componentId: "sc-no0w1x-2"
})([
    "width:30px;height:30px;margin-top:-19px;border:3px solid ",
    ";background-color:",
    ";:hover{cursor:pointer;border-color:",
    ";}:active{box-shadow:0 0 5px ",
    ";}"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Handle = ({ label: label, dragging: dragging, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Label, {
                offset: props.offset,
                children: label
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$ba3b8df995d5886a$var$StyledHandle, {
                dragging: dragging.toString(),
                ...props
            })
        ]
    });
var $43afcb05ca3681f6$var$$ba3b8df995d5886a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ba3b8df995d5886a$var$Handle;
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "slider__Wrapper",
    componentId: "sc-5b6ug3-0"
})([
    "",
    " width:500px;margin-top:30px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledSlider = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$parcel$interopDefault($53eb3904070cf0e9$exports)).withConfig({
    displayName: "slider__StyledSlider",
    componentId: "sc-5b6ug3-1"
})([
    "width:100%;.rc-slider-handle-click-focused:focus{border-color:",
    ";}"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledLabel = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "slider__StyledLabel",
    componentId: "sc-5b6ug3-2"
})([
    "",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Labels = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "slider__Labels",
    componentId: "sc-5b6ug3-3"
})([
    "width:100%;margin-top:16px;display:flex;align-items:center;justify-content:space-between;"
]);
const $43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Slider = ({ label: label, min: min, max: max, leftLabel: leftLabel, rightLabel: rightLabel, callback: callback, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledSlider, {
                handle: ({ ref: ignored, ...handleProps })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$ba3b8df995d5886a$export$2e2bcd8739ae039, {
                        label: label,
                        ...handleProps
                    }),
                railStyle: {
                    height: "8px",
                    backgroundColor: props.theme.klerosUIComponentsStroke,
                    borderRadius: "30px",
                    cursor: "pointer"
                },
                trackStyle: [
                    {
                        height: "8px",
                        backgroundColor: props.theme.klerosUIComponentsPrimaryBlue,
                        borderRadius: "30px",
                        cursor: "pointer"
                    }
                ],
                onChange: callback,
                min: min,
                max: max,
                ...props
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Labels, {
                children: [
                    leftLabel && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: leftLabel
                    }),
                    rightLabel && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$StyledLabel, {
                        children: rightLabel
                    })
                ]
            })
        ]
    });
$43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Slider.displayName = "Slider";
var $43afcb05ca3681f6$var$$409b8f5f63cd4acf$export$2e2bcd8739ae039 = (0, $e9f8389e4f70b5af$exports.withTheme)($43afcb05ca3681f6$var$$409b8f5f63cd4acf$var$Slider);
const $43afcb05ca3681f6$var$$a9ca8be356aca825$var$SvgUploadIcon = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M8.406 5.378h2.371V16.91c0 .15.116.273.257.273h1.925c.142 0 .257-.123.257-.273V5.378h2.378c.215 0 .333-.263.202-.44L12.202.105a.26.26 0 0 0-.09-.077.244.244 0 0 0-.224 0 .26.26 0 0 0-.09.077l-3.594 4.83c-.131.18-.013.443.202.443Zm15.337 10.51h-1.925c-.141 0-.257.122-.257.272v5.25H2.44v-5.25c0-.15-.116-.273-.257-.273H.257c-.141 0-.257.123-.257.273v6.75C0 23.511.459 24 1.027 24h21.946c.568 0 1.027-.488 1.027-1.09v-6.75c0-.15-.116-.273-.257-.273Z"
        })
    });
var $43afcb05ca3681f6$var$$a9ca8be356aca825$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a9ca8be356aca825$var$SvgUploadIcon;
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "file-uploader__Wrapper",
    componentId: "sc-18nhvs2-0"
})([
    "",
    " width:200px;height:64px;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$DropZone = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "file-uploader__DropZone",
    componentId: "sc-18nhvs2-1"
})([
    "",
    " ",
    " ",
    " height:100%;width:100%;background-color:",
    ";border:1px dashed ",
    ";border-radius:3px;display:flex;justify-content:center;align-items:center;font-size:14px;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$49a276e58256b44f$export$360c6850771ad63, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledUploadIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$a9ca8be356aca825$export$2e2bcd8739ae039).withConfig({
    displayName: "file-uploader__StyledUploadIcon",
    componentId: "sc-18nhvs2-2"
})([
    "",
    " height:24px;width:24px;fill:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.withConfig({
    displayName: "file-uploader__FileInput",
    componentId: "sc-18nhvs2-3"
})([
    "display:none;"
]);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSmall = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "file-uploader__StyledSmall",
    componentId: "sc-18nhvs2-4"
})([
    "",
    " position:relative;top:-1px;text-align:justify;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "file-uploader__StyledSVG",
    componentId: "sc-18nhvs2-5"
})([
    ""
]);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$Message = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "file-uploader__Message",
    componentId: "sc-18nhvs2-6"
})([
    "margin-top:16px;display:flex;align-items:flex-start;& ",
    "{",
    " min-width:16px;max-width:16px;margin-right:8px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$2677d04b7028c72d$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileUploader = ({ callback: callback, msg: msg, variant: variant, className: className, ...props })=>{
    const fileInputRef = (0, $dup7A.useRef)(); //! type
    const [fileSelected, setFileSelected] = (0, $dup7A.useState)();
    const handleDragEnter = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragLeave = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDragOver = (event)=>{
        event.preventDefault();
        event.stopPropagation();
    };
    const handleDrop = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        fileInputRef.current.files = event.dataTransfer?.files;
        setFileSelected(event.dataTransfer?.files[0]);
        callback(event.dataTransfer?.files[0]);
    };
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$DropZone, {
                onClick: ()=>fileInputRef?.current.click(),
                onDrop: (e)=>handleDrop(e),
                onDragOver: (e)=>handleDragOver(e),
                onDragEnter: (e)=>handleDragEnter(e),
                onDragLeave: (e)=>handleDragLeave(e),
                children: fileSelected ? fileSelected.name : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledUploadIcon, {})
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileInput, {
                ref: fileInputRef,
                type: "file",
                onChange: (event)=>{
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    setFileSelected(event.target.files[0]);
                    //eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    callback(event.target.files[0]);
                },
                ...props
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$Message, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "warning" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "error" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    variant === "info" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {
                        className: $43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSVG.styledComponentId
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$eab617fde0d2a814$var$StyledSmall, {
                        variant: variant,
                        children: msg
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$eab617fde0d2a814$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$eab617fde0d2a814$var$FileUploader;
const $43afcb05ca3681f6$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue = {
    focusedDate: null,
    isDateFocused: ()=>false,
    isDateSelected: ()=>false,
    isDateHovered: ()=>false,
    isDateBlocked: ()=>false,
    isFirstOrLastSelectedDate: ()=>false,
    onDateFocus: ()=>{
    //do nothing
    },
    onDateHover: ()=>{
    //do nothing
    },
    onDateSelect: ()=>{
    //do nothing
    }
};
var $43afcb05ca3681f6$var$$1a85d5c881834fd9$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$parcel$interopDefault($dup7A).createContext($43afcb05ca3681f6$var$$1a85d5c881834fd9$var$datepickerContextDefaultValue);
const $43afcb05ca3681f6$var$$8da322913a568d32$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M5.625 9h-1.25A.376.376 0 0 1 4 8.625v-1.25C4 7.169 4.169 7 4.375 7h1.25c.206 0 .375.169.375.375v1.25A.376.376 0 0 1 5.625 9ZM9 8.625v-1.25A.376.376 0 0 0 8.625 7h-1.25A.376.376 0 0 0 7 7.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 8.625Zm3 0v-1.25A.376.376 0 0 0 11.625 7h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 12 8.625Zm-3 3v-1.25A.376.376 0 0 0 8.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 9 11.625Zm-3 0v-1.25A.376.376 0 0 0 5.625 10h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25A.376.376 0 0 0 6 11.625Zm6 0v-1.25a.376.376 0 0 0-.375-.375h-1.25a.376.376 0 0 0-.375.375v1.25c0 .206.169.375.375.375h1.25a.376.376 0 0 0 .375-.375ZM15 3.5v11a1.5 1.5 0 0 1-1.5 1.5h-11A1.5 1.5 0 0 1 1 14.5v-11A1.5 1.5 0 0 1 2.5 2H4V.375C4 .169 4.169 0 4.375 0h1.25C5.831 0 6 .169 6 .375V2h4V.375c0-.206.169-.375.375-.375h1.25c.206 0 .375.169.375.375V2h1.5A1.5 1.5 0 0 1 15 3.5Zm-1.5 10.813V5h-11v9.313c0 .103.084.187.188.187h10.624a.188.188 0 0 0 .188-.188Z"
        })
    });
var $43afcb05ca3681f6$var$$8da322913a568d32$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$8da322913a568d32$var$SvgCalendar;
const $43afcb05ca3681f6$var$$02569186343496d4$var$StyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "display-button__StyledButton",
    componentId: "sc-1n9stdw-0"
})([
    "",
    " ",
    " ",
    " height:45px;width:330px;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:0px 16px;display:flex;justify-content:flex-start;align-items:center;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$49a276e58256b44f$export$52f70ed6d426e628, $43afcb05ca3681f6$var$$49a276e58256b44f$export$603679fcdd350e3b, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$02569186343496d4$var$StyledDate = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "display-button__StyledDate",
    componentId: "sc-1n9stdw-1"
})([
    "",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $43afcb05ca3681f6$var$$02569186343496d4$var$StyledCalendar = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$8da322913a568d32$export$2e2bcd8739ae039).withConfig({
    displayName: "display-button__StyledCalendar",
    componentId: "sc-1n9stdw-2"
})([
    "position:absolute;right:16px;height:16px;width:16px;fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$02569186343496d4$var$DisplayButton = ({ onClick: onClick, date: date, time: time })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$02569186343496d4$var$StyledButton, {
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$02569186343496d4$var$StyledDate, {
                children: [
                    date.toLocaleDateString(),
                    time && `, ${date.getHours().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })}:${date.getMinutes().toLocaleString("en-US", {
                        minimumIntegerDigits: 2,
                        useGrouping: false
                    })} Local time`
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$02569186343496d4$var$StyledCalendar, {})
        ]
    });
var $43afcb05ca3681f6$var$$02569186343496d4$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$02569186343496d4$var$DisplayButton;
const $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledDayNumber = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "day__StyledDayNumber",
    componentId: "sc-1cckfjj-0"
})([
    "",
    " color:",
    " !important;font-weight:600;cursor:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.isSelected ? props.theme.klerosUIComponentsWhiteBackground : props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsSecondaryText, (props)=>props.disabledDate ? "not-allowed" : "pointer");
const $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "day__StyledButton",
    componentId: "sc-1cckfjj-1"
})([
    "",
    " height:24px;width:24px;border-radius:12px;background-color:",
    ";padding:0;display:flex;justify-content:center;align-items:center;:hover{background-color:",
    ";& ",
    "{color:",
    " !important;}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.isSelected ? props.theme.klerosUIComponentsPrimaryBlue : props.disabledDate ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsSecondaryBlue, $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledDayNumber, (props)=>props.disabledDate ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$Day = ({ date: date, dayLabel: dayLabel })=>{
    const dayRef = (0, $dup7A.useRef)(null);
    const { isSelected: isSelected, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, tabIndex: tabIndex } = (0, $48515c484bc5585a$export$1937086c6b64f72d)({
        dayRef: dayRef,
        date: date,
        ...(0, $dup7A.useContext)($43afcb05ca3681f6$var$$1a85d5c881834fd9$export$2e2bcd8739ae039)
    });
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const isPastDate = date.getTime() < today.getTime();
    const handleClick = ()=>{
        if (!isPastDate) onClick();
    };
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledButton, {
        ref: dayRef,
        isSelected: isSelected,
        onClick: handleClick,
        onKeyDown: onKeyDown,
        onMouseEnter: onMouseEnter,
        tabIndex: tabIndex,
        disabledDate: isPastDate,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$StyledDayNumber, {
            isSelected: isSelected,
            disabledDate: isPastDate,
            children: dayLabel
        })
    });
};
var $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1a3cb6cad04c22a8$var$Day;
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$MonthContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month__MonthContainer",
    componentId: "sc-1lt566d-0"
})([
    "width:330px;height:220px;padding-top:16px;display:flex;justify-content:center;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month__StyledGridContainer",
    componentId: "sc-1lt566d-1"
})([
    "height:26px;width:32px;display:flex;justify-content:center;align-items:center;"
]);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledWeekDay = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "month__StyledWeekDay",
    componentId: "sc-1lt566d-2"
})([
    "",
    " color:",
    ";font-weight:600;user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledMonth = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month__StyledMonth",
    componentId: "sc-1lt566d-3"
})([
    "width:fit-content;height:fit-content;display:grid;grid-template-columns:repeat(7,32px);"
]);
const $43afcb05ca3681f6$var$$b6c83c11430985d2$var$Month = ({ days: days, weekdayLabels: weekdayLabels })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$MonthContainer, {
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledMonth, {
            children: [
                weekdayLabels.map((dayLabel, i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledWeekDay, {
                            children: dayLabel
                        })
                    }, i)),
                days.map((day, i)=>typeof day === "number" ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer, {}, i) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$var$StyledGridContainer, {
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1a3cb6cad04c22a8$export$2e2bcd8739ae039, {
                            ...day
                        }, i)
                    }, i))
            ]
        })
    });
var $43afcb05ca3681f6$var$$b6c83c11430985d2$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b6c83c11430985d2$var$Month;
const $43afcb05ca3681f6$var$$51df4a6e8b413d48$var$SvgSimpleLeft = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "m9.197 14.429-.793.786a.859.859 0 0 1-1.21 0L.252 8.335a.841.841 0 0 1 0-1.201L7.194.25a.859.859 0 0 1 1.21 0l.793.786a.846.846 0 0 1-.014 1.214L4.88 6.316h10.263c.475 0 .857.379.857.85v1.133c0 .471-.382.85-.857.85H4.88l4.303 4.065a.84.84 0 0 1 .014 1.215Z"
        })
    });
var $43afcb05ca3681f6$var$$51df4a6e8b413d48$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$51df4a6e8b413d48$var$SvgSimpleLeft;
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "month-selector__Wrapper",
    componentId: "sc-1tkddgk-0"
})([
    "width:100%;height:64px;padding:24px;display:flex;justify-content:space-between;"
]);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "month-selector__StyledMonthTitle",
    componentId: "sc-1tkddgk-1"
})([
    "",
    " user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "month-selector__StyledArrow",
    componentId: "sc-1tkddgk-2"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";:hover{fill:",
    ";}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$RightArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledArrow).withConfig({
    displayName: "month-selector__RightArrow",
    componentId: "sc-1tkddgk-3"
})([
    "transform:rotate(180deg);"
]);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$UnstyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "month-selector__UnstyledButton",
    componentId: "sc-1tkddgk-4"
})([
    "",
    " background:none;padding:0;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$MonthSelector = ({ monthLabel: monthLabel, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToPreviousMonths,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledArrow, {})
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$StyledMonthTitle, {
                children: monthLabel
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$UnstyledButton, {
                onClick: goToNextMonths,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$RightArrow, {})
            })
        ]
    });
var $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$var$MonthSelector;
const $43afcb05ca3681f6$var$$5b91024d35847b4a$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "date-selector__Wrapper",
    componentId: "sc-dxn9nj-0"
})([
    "display:flex;flex-direction:column;"
]);
const $43afcb05ca3681f6$var$$5b91024d35847b4a$var$DateSelector = ({ year: year, month: month, firstDayOfWeek: firstDayOfWeek, goToNextMonths: goToNextMonths, goToPreviousMonths: goToPreviousMonths })=>{
    const { days: days, weekdayLabels: weekdayLabels, monthLabel: monthLabel } = (0, $48515c484bc5585a$export$41527c87dc759868)({
        year: year,
        month: month,
        firstDayOfWeek: firstDayOfWeek
    });
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$5b91024d35847b4a$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d9b6f601d2dcc8ac$export$2e2bcd8739ae039, {
                monthLabel: monthLabel,
                goToPreviousMonths: goToPreviousMonths,
                goToNextMonths: goToNextMonths
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b6c83c11430985d2$export$2e2bcd8739ae039, {
                days: days,
                weekdayLabels: weekdayLabels
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$5b91024d35847b4a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$5b91024d35847b4a$var$DateSelector;
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControl = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-controls__TimeControl",
    componentId: "sc-198k8z7-0"
})([
    "flex-grow:1;border-top:1px solid ",
    ";border-bottom:1px solid ",
    ";display:flex;flex-direction:column;"
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeDisplay = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-controls__TimeDisplay",
    componentId: "sc-198k8z7-1"
})([
    "width:100%;height:64px;background-color:",
    ";padding:0px 24px;display:flex;justify-content:space-between;align-items:center;"
], ({ theme: theme })=>theme.klerosUIComponentsMediumBlue);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "time-controls__StyledTime",
    componentId: "sc-198k8z7-2"
})([
    "",
    " font-weight:600;color:",
    ";user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeButtons = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeDisplay).withConfig({
    displayName: "time-controls__TimeButtons",
    componentId: "sc-198k8z7-3"
})([
    "flex-grow:1;background-color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$51df4a6e8b413d48$export$2e2bcd8739ae039).withConfig({
    displayName: "time-controls__StyledArrow",
    componentId: "sc-198k8z7-4"
})([
    "",
    " width:16px;height:16px;fill:",
    ";transition:fill ease ",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$UpArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__UpArrow",
    componentId: "sc-198k8z7-5"
})([
    "transform:rotate(90deg);"
]);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$DownArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow).withConfig({
    displayName: "time-controls__DownArrow",
    componentId: "sc-198k8z7-6"
})([
    "transform:rotate(-90deg);"
]);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "time-controls__UnstyledButton",
    componentId: "sc-198k8z7-7"
})([
    "",
    " background:none;padding:0;:hover{& ",
    "{fill:",
    ";}}:disabled{& ",
    "{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue, $43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControls = ({ date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes })=>{
    const today = new Date();
    const disableHourUp = hours === 23;
    const disableMinuteUp = minutes === 59;
    const isToday = date.toDateString() === today.toDateString();
    const currentTime = today.getTime();
    const checkTime = new Date(date).setHours(hours - 1, minutes);
    const disableHourDown = hours === 0 || isToday && (hours - 1 < today.getHours() || hours - 1 === today.getHours() && minutes <= today.getMinutes() || checkTime <= currentTime);
    const disableMinuteDown = minutes === 0 || isToday && (hours < today.getHours() || hours === today.getHours() && minutes - 1 <= today.getMinutes());
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControl, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours + 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourUp,
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UpArrow, {})
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes + 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteUp,
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UpArrow, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeDisplay, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime, {
                        children: hours.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime, {
                        children: ":"
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$StyledTime, {
                        children: minutes.toLocaleString("en-US", {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeButtons, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newHours = hours - 1;
                            setHours(newHours);
                            date.setHours(newHours, minutes);
                        },
                        disabled: disableHourDown,
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$DownArrow, {})
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$UnstyledButton, {
                        onClick: ()=>{
                            const newMinutes = minutes - 1;
                            setMinutes(newMinutes);
                            date.setHours(hours, newMinutes);
                        },
                        disabled: disableMinuteDown,
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$var$DownArrow, {})
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$2dfb31ff65652603$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2dfb31ff65652603$var$TimeControls;
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-selector__Wrapper",
    componentId: "sc-1i0y3my-0"
})([
    "width:118px;height:284px;border-left:1px solid ",
    ";display:flex;flex-direction:column;",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "border:1px solid ",
        ";border-top:none;border-bottom:none;"
    ], ({ theme: theme })=>theme.klerosUIComponentsStroke)));
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$Header = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "time-selector__Header",
    componentId: "sc-1i0y3my-1"
})([
    "height:64px;display:flex;justify-content:center;align-items:center;"
]);
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "time-selector__StyledTitle",
    componentId: "sc-1i0y3my-2"
})([
    "",
    " user-select:none;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$a1eb1518e9214887$var$TimeSelector = (props)=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$a1eb1518e9214887$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a1eb1518e9214887$var$Header, {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a1eb1518e9214887$var$StyledTitle, {
                    children: "Time"
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2dfb31ff65652603$export$2e2bcd8739ae039, {
                ...props
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$a1eb1518e9214887$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a1eb1518e9214887$var$TimeSelector;
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown__Container",
    componentId: "sc-xqzukb-0"
})([
    "position:absolute;z-index:100;overflow:hidden;height:",
    ";width:",
    ";transition:height ease ",
    ";background:",
    ";",
    ";box-shadow:0px 2px 3px ",
    ";border-radius:3px;",
    ""
], ({ isOpen: isOpen })=>isOpen ? "auto" : "0", ({ time: time })=>time ? "450px" : "330px", ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ isOpen: isOpen, theme: theme })=>isOpen ? `border: 1px solid ${theme.klerosUIComponentsStroke}` : "", ({ theme: theme })=>theme.klerosUIComponentsDefaultShadow, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "width:332px;position:static;margin:0;left:0;top:0;"
    ])));
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$Selectors = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown__Selectors",
    componentId: "sc-xqzukb-1"
})([
    "display:flex;",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "flex-direction:column;align-items:center;justify-content:flex-start;"
    ])));
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$ButtonContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "dropdown__ButtonContainer",
    componentId: "sc-xqzukb-2"
})([
    "width:100%;padding:16px 24px;display:flex;justify-content:flex-end;align-items:center;",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "justify-content:center;"
    ])));
const $43afcb05ca3681f6$var$$275ab796fce9757e$var$Dropdown = ({ onSelect: onSelect, isOpen: isOpen, time: time, date: date, hours: hours, minutes: minutes, setHours: setHours, setMinutes: setMinutes, ...dateSelectorProps })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$275ab796fce9757e$var$Container, {
        isOpen: isOpen,
        time: time,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$275ab796fce9757e$var$Selectors, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$5b91024d35847b4a$export$2e2bcd8739ae039, {
                        ...dateSelectorProps
                    }),
                    time && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a1eb1518e9214887$export$2e2bcd8739ae039, {
                        date: date,
                        hours: hours,
                        minutes: minutes,
                        setHours: setHours,
                        setMinutes: setMinutes
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$275ab796fce9757e$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2987665db72ba3c1$export$2e2bcd8739ae039, {
                    small: true,
                    variant: "primary",
                    text: "Select",
                    onClick: onSelect
                })
            })
        ]
    });
var $43afcb05ca3681f6$var$$275ab796fce9757e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$275ab796fce9757e$var$Dropdown;
const $43afcb05ca3681f6$var$$1d445195934320ed$var$PositionedContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "datepicker__PositionedContainer",
    componentId: "sc-1gv6m20-0"
})([
    "",
    " position:relative;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$1d445195934320ed$var$DatePicker = ({ onSelect: onSelect, time: time })=>{
    const [isOpen, setIsOpen] = (0, $dup7A.useState)(false);
    const containerRef = (0, $dup7A.useRef)(null);
    $43afcb05ca3681f6$var$$bfcc265ae6655ec9$export$2e2bcd8739ae039(containerRef, ()=>setIsOpen(false));
    const [date, setDate] = (0, $dup7A.useState)(new Date());
    const [hours, setHours] = (0, $dup7A.useState)(date.getHours());
    const [minutes, setMinutes] = (0, $dup7A.useState)(date.getMinutes());
    const today = new Date();
    const lastSelectableDate = new Date(today);
    lastSelectableDate.setDate(today.getDate());
    const updateDateWithTime = (selectedDate)=>{
        if (selectedDate.toDateString() === lastSelectableDate.toDateString()) {
            const now = new Date();
            selectedDate.setHours(now.getHours(), now.getMinutes());
            setHours(now.getHours());
            setMinutes(now.getMinutes());
        } else selectedDate.setHours(hours, minutes);
        setDate(selectedDate);
        onSelect(selectedDate);
    };
    const { firstDayOfWeek: firstDayOfWeek, activeMonths: activeMonths, isDateHovered: isDateHovered, isFirstOrLastSelectedDate: isFirstOrLastSelectedDate, isDateBlocked: isDateBlocked, isDateFocused: isDateFocused, focusedDate: focusedDate, onDateHover: onDateHover, onDateSelect: handleDateSelect, onDateFocus: onDateFocus, goToPreviousMonths: goToPreviousMonths, goToNextMonths: goToNextMonths } = (0, $48515c484bc5585a$export$2d9bfdb55c82a287)({
        startDate: date,
        endDate: date,
        focusedInput: $48515c484bc5585a$export$99a467bcc22b8df9,
        onDatesChange: (data)=>{
            if (data.startDate) updateDateWithTime(new Date(data.startDate));
        },
        numberOfMonths: 1,
        minBookingDays: 1,
        exactMinBookingDays: true
    });
    const onTimeChange = (newHours, newMinutes)=>{
        const newDate = new Date(date);
        newDate.setHours(newHours, newMinutes);
        setHours(newHours);
        setMinutes(newMinutes);
        setDate(newDate);
        onSelect(newDate);
    };
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1a85d5c881834fd9$export$2e2bcd8739ae039.Provider, {
        value: {
            focusedDate: focusedDate,
            isDateFocused: isDateFocused,
            isDateSelected: (selectedDate)=>{
                return selectedDate.getDate() === date.getDate() && selectedDate.getMonth() === date.getMonth() && selectedDate.getFullYear() === date.getFullYear();
            },
            isDateHovered: isDateHovered,
            isDateBlocked: isDateBlocked,
            isFirstOrLastSelectedDate: isFirstOrLastSelectedDate,
            onDateSelect: (selectedDate)=>{
                handleDateSelect(selectedDate);
                updateDateWithTime(selectedDate);
            },
            onDateFocus: onDateFocus,
            onDateHover: onDateHover
        },
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$1d445195934320ed$var$PositionedContainer, {
            ref: containerRef,
            children: [
                /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$02569186343496d4$export$2e2bcd8739ae039, {
                    date: date,
                    time: time,
                    onClick: ()=>setIsOpen(!isOpen)
                }),
                /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$275ab796fce9757e$export$2e2bcd8739ae039, {
                    ...activeMonths[0],
                    isOpen: isOpen,
                    time: time,
                    firstDayOfWeek: firstDayOfWeek,
                    goToNextMonths: goToNextMonths,
                    goToPreviousMonths: goToPreviousMonths,
                    date: date,
                    hours: hours,
                    minutes: minutes,
                    setHours: (newHours)=>onTimeChange(newHours, minutes),
                    setMinutes: (newMinutes)=>onTimeChange(hours, newMinutes),
                    onSelect: ()=>{
                        date.setHours(hours, minutes);
                        onSelect(date);
                        setIsOpen(false);
                    }
                })
            ]
        })
    });
};
var $43afcb05ca3681f6$var$$1d445195934320ed$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1d445195934320ed$var$DatePicker;
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).label.withConfig({
    displayName: "radio__Wrapper",
    componentId: "sc-1jhzktg-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$HiddenInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.attrs({
    type: "radio"
}).withConfig({
    displayName: "radio__HiddenInput",
    componentId: "sc-1jhzktg-1"
})([
    "position:absolute;opacity:0;cursor:pointer;"
]);
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$StyledRadio = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).span.withConfig({
    displayName: "radio__StyledRadio",
    componentId: "sc-1jhzktg-2"
})([
    "position:absolute;top:0;left:0;border:1px solid ",
    ";border-radius:50%;",
    ' :after{content:"";position:absolute;display:none;border-radius:50%;background:',
    ";",
    "}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "width:16px;height:16px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "width:24px;height:24px;"
    ]), ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "top:3px;left:3px;width:8px;height:8px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "top:5px;left:5px;width:12px;height:12px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border:1px solid ",
        ";:after{display:block;}"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsPrimaryBlue));
const $43afcb05ca3681f6$var$$86e1d79a67710eda$var$Radio = ({ small: small, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$86e1d79a67710eda$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$86e1d79a67710eda$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$86e1d79a67710eda$var$StyledRadio, {
                small: small,
                checked: checked
            })
        ]
    });
var $43afcb05ca3681f6$var$$86e1d79a67710eda$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$86e1d79a67710eda$var$Radio;
const $43afcb05ca3681f6$var$$1d196f635349b3e7$var$SvgCheckmark = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 15 12",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M14.416 0h-1.77c-.384 0-.75.185-.977.502L5.737 8.729 3.05 5a1.207 1.207 0 0 0-.978-.502H.302c-.245 0-.388.28-.245.48l4.702 6.52a1.2 1.2 0 0 0 1.951 0L14.658.48A.3.3 0 0 0 14.416 0Z"
        })
    });
var $43afcb05ca3681f6$var$$1d196f635349b3e7$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1d196f635349b3e7$var$SvgCheckmark;
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).label.withConfig({
    displayName: "checkbox__Wrapper",
    componentId: "sc-1qpo0fn-0"
})([
    "",
    " display:block;position:relative;cursor:pointer;user-select:none;color:",
    ";",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, ({ small: small })=>small ? (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:16px;padding-left:28px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "font-size:22px;padding-left:35px;"
    ]));
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$HiddenInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "checkbox__HiddenInput",
    componentId: "sc-1qpo0fn-1"
})([
    "position:absolute;opacity:0;cursor:pointer;height:0;width:0;"
]);
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$CheckmarkContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "checkbox__CheckmarkContainer",
    componentId: "sc-1qpo0fn-2"
})([
    "position:absolute;top:0;left:0;border-radius:3px;border:1px solid ",
    ";overflow:hidden;",
    " ",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ $small: $small })=>$small ? (0, $e9f8389e4f70b5af$exports.css)([
        "width:16px;height:16px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "width:24px;height:24px;"
    ]), ({ theme: theme, checked: checked })=>checked && (0, $e9f8389e4f70b5af$exports.css)([
        "background:",
        ";border:none;:after{display:block;}"
    ], theme.klerosUIComponentsPrimaryBlue));
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$bouncedIn = (0, $e9f8389e4f70b5af$exports.keyframes)([
    "0%{transform:translateY(100%);}50%{transform:translateY(-5px);}100%{transform:translateY(0);}"
]);
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$StyledCheckmark = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1d196f635349b3e7$export$2e2bcd8739ae039).withConfig({
    displayName: "checkbox__StyledCheckmark",
    componentId: "sc-1qpo0fn-3"
})([
    "",
    " position:absolute;top:1px;width:100%;height:100%;",
    " ",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme, checked: checked })=>checked ? (0, $e9f8389e4f70b5af$exports.css)([
        "fill:",
        ";background:",
        ";animation:",
        " 200ms ease-out;"
    ], theme.klerosUIComponentsWhiteBackground, theme.klerosUIComponentsPrimaryBlue, $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$bouncedIn) : (0, $e9f8389e4f70b5af$exports.css)([
        "fill:transparent;"
    ]), ({ $small: $small })=>$small ? (0, $e9f8389e4f70b5af$exports.css)([
        "padding:0 3px;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        "padding:0 4px;"
    ]));
const $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Checkbox = ({ small: small = false, checked: checked, label: label, className: className, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Wrapper, {
        small: small,
        className: className,
        children: [
            label,
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b679852ecf8e9c02$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b679852ecf8e9c02$var$CheckmarkContainer, {
                $small: small,
                checked: checked,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b679852ecf8e9c02$var$StyledCheckmark, {
                    $small: small,
                    checked: checked
                })
            })
        ]
    });
var $43afcb05ca3681f6$var$$b679852ecf8e9c02$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b679852ecf8e9c02$var$Checkbox;
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSwitch = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).label.withConfig({
    displayName: "switch__StyledSwitch",
    componentId: "sc-1or3qt0-0"
})([
    "",
    " position:relative;display:inline-block;height:",
    ";width:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "16px" : "24px", ({ small: small })=>small ? "32px" : "48px");
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$HiddenInput = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).input.attrs({
    type: "checkbox"
}).withConfig({
    displayName: "switch__HiddenInput",
    componentId: "sc-1or3qt0-1"
})([
    "opacity:0;width:0;height:0;"
]);
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSlider = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).span.withConfig({
    displayName: "switch__StyledSlider",
    componentId: "sc-1or3qt0-2"
})([
    "position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:",
    ';transition:0.4s;border-radius:34px;&:before{position:absolute;content:"";height:',
    ";width:",
    ";left:2px;bottom:2px;border-radius:50%;background-color:white;transition:0.4s;}",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsStroke, ({ small: small })=>small ? "12px" : "20px", ({ small: small })=>small ? "12px" : "20px", ({ checked: checked, theme: theme, small: small })=>checked && (0, $e9f8389e4f70b5af$exports.css)([
        "background-color:",
        ";:before{transform:translateX(",
        ");}"
    ], theme.klerosUIComponentsPrimaryBlue, small ? "16px" : "24px"));
const $43afcb05ca3681f6$var$$34871b0f15f7c161$var$Switch = ({ small: small, checked: checked, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSwitch, {
        small: small,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$34871b0f15f7c161$var$HiddenInput, {
                checked: checked,
                ...props
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$34871b0f15f7c161$var$StyledSlider, {
                small: small,
                checked: checked
            })
        ]
    });
var $43afcb05ca3681f6$var$$34871b0f15f7c161$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$34871b0f15f7c161$var$Switch;
const $43afcb05ca3681f6$var$$d963730b715e990c$var$variantColor = (0, $e9f8389e4f70b5af$exports.css)([
    "",
    ""
], ({ theme: theme, variant: variant })=>{
    switch(variant){
        case "success":
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsSuccess);
        case "warning":
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsWarning);
        case "error":
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsError);
        case "info":
        default:
            return (0, $e9f8389e4f70b5af$exports.css)([
                "color:",
                ";"
            ], theme.klerosUIComponentsPrimaryBlue);
    }
});
const $43afcb05ca3681f6$var$$d963730b715e990c$var$borderColor = ({ theme: theme, variant: variant })=>{
    const colors = {
        success: theme.klerosUIComponentsSuccess,
        warning: theme.klerosUIComponentsWarning,
        error: theme.klerosUIComponentsError,
        info: theme.klerosUIComponentsPrimaryBlue
    };
    return colors[variant];
};
const $43afcb05ca3681f6$var$$d963730b715e990c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "alert__Wrapper",
    componentId: "sc-rckqp0-0"
})([
    "display:grid;grid-template-columns:24px auto;gap:16px;align-items:center;background:",
    ";border:1px solid ",
    ";border-radius:3px;padding:16px 24px 20px 24px;"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, ({ theme: theme, variant: variant })=>$43afcb05ca3681f6$var$$d963730b715e990c$var$borderColor({
        theme: theme,
        variant: variant
    }));
const $43afcb05ca3681f6$var$$d963730b715e990c$var$IconWrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "alert__IconWrapper",
    componentId: "sc-rckqp0-1"
})([
    "",
    " height:24px;width:24px;svg{",
    " fill:currentColor;}"
], $43afcb05ca3681f6$var$$d963730b715e990c$var$variantColor, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$d963730b715e990c$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "alert__StyledTitle",
    componentId: "sc-rckqp0-2"
})([
    "",
    " font-size:16px;margin:0;font-weight:600;line-height:24px;"
], $43afcb05ca3681f6$var$$d963730b715e990c$var$variantColor);
const $43afcb05ca3681f6$var$$d963730b715e990c$var$TitleAndMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "alert__TitleAndMessage",
    componentId: "sc-rckqp0-3"
})([
    "display:flex;flex-direction:column;",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "gap:8px;"
    ])));
const $43afcb05ca3681f6$var$$d963730b715e990c$var$StyledMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "alert__StyledMessage",
    componentId: "sc-rckqp0-4"
})([
    "color:",
    ";font-weight:400;"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$d963730b715e990c$var$Alert = ({ variant: variant, title: title, msg: msg })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d963730b715e990c$var$Wrapper, {
        variant: variant,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d963730b715e990c$var$IconWrapper, {
                variant: variant,
                children: [
                    variant === "success" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039, {}),
                    variant === "warning" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$773dfb225348757e$export$2e2bcd8739ae039, {}),
                    variant === "error" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1055d191a5da0897$export$2e2bcd8739ae039, {}),
                    variant === "info" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$3b81fb62e49a97d5$export$2e2bcd8739ae039, {})
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$d963730b715e990c$var$TitleAndMessage, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d963730b715e990c$var$StyledTitle, {
                        variant: variant,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d963730b715e990c$var$StyledMessage, {
                        children: msg
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$d963730b715e990c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d963730b715e990c$var$Alert;
const $43afcb05ca3681f6$var$$296cff7698ec0f63$var$SvgSolidSuccess = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm6.91 10.775-7.52 10.429a1.136 1.136 0 0 1-1.847 0l-4.454-6.172a.287.287 0 0 1 .232-.453h1.675c.365 0 .711.175.925.475l2.543 3.528 5.615-7.785c.214-.297.557-.475.925-.475h1.675c.232 0 .367.264.232.453Z"
        })
    });
var $43afcb05ca3681f6$var$$296cff7698ec0f63$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$296cff7698ec0f63$var$SvgSolidSuccess;
const $43afcb05ca3681f6$var$$ff1548a205f71f6a$var$SvgSolidError = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 32 32",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0Zm5.907 22.079-2.357-.011L16 17.836l-3.546 4.228-2.361.011a.284.284 0 0 1-.286-.286c0-.068.025-.132.068-.185l4.646-5.536-4.646-5.532a.287.287 0 0 1 .218-.471l2.36.01L16 14.307l3.546-4.228 2.358-.011c.157 0 .285.125.285.286a.297.297 0 0 1-.068.185l-4.639 5.532 4.643 5.536a.287.287 0 0 1-.218.472Z"
        })
    });
var $43afcb05ca3681f6$var$$ff1548a205f71f6a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$ff1548a205f71f6a$var$SvgSolidError;
const $43afcb05ca3681f6$var$$d6917595109333d4$var$SvgSync = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M2.171 11.777a9.807 9.807 0 0 1 2.874-6.726 9.778 9.778 0 0 1 6.951-2.88c1.33 0 2.615.26 3.824.772a9.757 9.757 0 0 1 3.123 2.108c.283.283.548.583.794.898l-1.72 1.342a.229.229 0 0 0 .086.403l5.02 1.229a.23.23 0 0 0 .283-.22l.023-5.169c0-.191-.22-.3-.369-.18l-1.611 1.26A11.967 11.967 0 0 0 11.994 0C5.45 0 .123 5.246 0 11.766A.228.228 0 0 0 .23 12h1.714c.126 0 .226-.1.228-.223Zm21.6.223h-1.714c-.125 0-.226.1-.228.223a9.76 9.76 0 0 1-.769 3.6 9.778 9.778 0 0 1-2.106 3.126 9.786 9.786 0 0 1-6.951 2.88 9.779 9.779 0 0 1-6.949-2.88 9.853 9.853 0 0 1-.794-.898l1.72-1.342a.23.23 0 0 0 .024-.34.229.229 0 0 0-.11-.063l-5.02-1.229a.23.23 0 0 0-.282.22l-.02 5.172c0 .191.22.3.368.18l1.611-1.26A11.973 11.973 0 0 0 12.006 24C18.554 24 23.877 18.751 24 12.234a.229.229 0 0 0-.229-.234Z"
        })
    });
var $43afcb05ca3681f6$var$$d6917595109333d4$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d6917595109333d4$var$SvgSync;
const $43afcb05ca3681f6$var$$88d96d829ac44aee$var$SvgClose = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 8 8",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M4.525 4 7.746.16A.098.098 0 0 0 7.671 0h-.979a.2.2 0 0 0-.15.07L3.884 3.237 1.228.07a.196.196 0 0 0-.15-.07h-.98a.098.098 0 0 0-.075.16L3.244 4 .024 7.84A.098.098 0 0 0 .097 8h.98a.2.2 0 0 0 .15-.07l2.657-3.167L6.54 7.93c.037.044.092.07.151.07h.98a.098.098 0 0 0 .074-.16L4.526 4Z"
        })
    });
var $43afcb05ca3681f6$var$$88d96d829ac44aee$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$88d96d829ac44aee$var$SvgClose;
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "push__StyledSVG",
    componentId: "sc-4wrqai-0"
})([
    ""
]);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "push__Wrapper",
    componentId: "sc-4wrqai-1"
})([
    "",
    " position:relative;height:",
    ";width:",
    ";background:",
    ";border-radius:3px;padding:",
    ";display:flex;align-items:center;& ",
    "{",
    " height:",
    ";width:",
    ";min-height:",
    ";min-width:",
    ";fill:",
    ";}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ small: small })=>small ? "48px" : "100px", ({ small: small })=>small ? "300px" : "422px", ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue, ({ small: small })=>small ? "12px 24px 12px 24px" : "16px 32px 16px 24px", $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ small: small })=>small ? "24px" : "32px", ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "push__StyledTitle",
    componentId: "sc-4wrqai-2"
})([
    "",
    " color:inherit;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "push__StyledMessage",
    componentId: "sc-4wrqai-3"
})([
    "",
    " color:inherit;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Text = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "push__Text",
    componentId: "sc-4wrqai-4"
})([
    "margin-left:16px;color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$CloseButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "push__CloseButton",
    componentId: "sc-4wrqai-5"
})([
    "",
    " position:absolute;top:24px;right:24px;height:8px;width:8px;background:none;padding:0;display:inline-flex;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$88d96d829ac44aee$export$2e2bcd8739ae039).withConfig({
    displayName: "push__StyledCloseIcon",
    componentId: "sc-4wrqai-6"
})([
    "",
    " height:8px;width:8px;min-height:8px;min-width:8px;fill:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground);
const $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Push = ({ variant: variant, title: title, msg: msg, callback: callback, small: small, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Wrapper, {
        small: small,
        ...props,
        children: [
            variant === "success" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$296cff7698ec0f63$export$2e2bcd8739ae039, {
                className: $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "error" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$ff1548a205f71f6a$export$2e2bcd8739ae039, {
                className: $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            variant === "sync" && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$d6917595109333d4$export$2e2bcd8739ae039, {
                className: $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledSVG.styledComponentId
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Text, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledTitle, {
                        children: title
                    }),
                    !small && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledMessage, {
                        children: msg
                    })
                ]
            }),
            !small && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$CloseButton, {
                onClick: ()=>callback(),
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$StyledCloseIcon, {})
            })
        ]
    });
var $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$cadd1c9c3bca1fc9$var$Push;
const $43afcb05ca3681f6$var$$0ef3fc8611d56815$var$usePagination = (currentPage, numPages, callback, onCloseOnLastPage, numNeighbors = 2)=>{
    const incrementPage = ()=>{
        if (currentPage === numPages && onCloseOnLastPage) onCloseOnLastPage();
        else {
            const newPage = Math.min(numPages, currentPage + 1);
            callback(newPage);
        }
    };
    const decrementPage = ()=>{
        const newPage = Math.max(1, currentPage - 1);
        callback(newPage);
    };
    const goToPage = (newPage)=>{
        callback(newPage);
    };
    const minPageReached = currentPage === 1;
    const maxPageReached = currentPage === numPages;
    const getPageRange = ()=>{
        const leftBoundary = Math.max(1, currentPage - numNeighbors - Math.max(0, numNeighbors - (numPages - currentPage)));
        const rightBoundary = Math.min(numPages, currentPage + numNeighbors + Math.max(0, numNeighbors - currentPage + 1));
        return [
            ...Array(rightBoundary - leftBoundary + 1).keys()
        ].map((i)=>i + leftBoundary);
    };
    return [
        {
            incrementPage: incrementPage,
            decrementPage: decrementPage,
            goToPage: goToPage,
            minPageReached: minPageReached,
            maxPageReached: maxPageReached,
            getPageRange: getPageRange
        }
    ];
};
var $43afcb05ca3681f6$var$$0ef3fc8611d56815$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$0ef3fc8611d56815$var$usePagination;
const $43afcb05ca3681f6$var$$1edefcf4055fc9a6$var$SvgCircleLeft = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0Zm-.124 16.697.52-.527a.572.572 0 0 0-.009-.815L9.56 12.626h6.742a.565.565 0 0 0 .563-.57v-.76a.565.565 0 0 0-.563-.57H9.56l2.827-2.73a.576.576 0 0 0 .01-.814l-.521-.528a.556.556 0 0 0-.796 0l-4.56 4.62a.573.573 0 0 0 0 .806l4.56 4.617a.556.556 0 0 0 .796 0Z"
        })
    });
var $43afcb05ca3681f6$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$1edefcf4055fc9a6$var$SvgCircleLeft;
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "compact__Wrapper",
    componentId: "sc-1a5y08h-0"
})([
    "",
    " display:flex;align-items:center;justify-content:end;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "compact__StyledSVG",
    componentId: "sc-1a5y08h-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$ArrowButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "compact__ArrowButton",
    componentId: "sc-1a5y08h-2"
})([
    "",
    " height:24px;width:24px;background:none;padding:0;border-radius:50%;& ",
    "{",
    " height:24px;width:24px;fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryBlue, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledLabel = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "compact__StyledLabel",
    componentId: "sc-1a5y08h-3"
})([
    "",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, (props)=>props.theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$LeftArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__LeftArrow",
    componentId: "sc-1a5y08h-4"
})([
    "margin-left:16px;"
]);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$RightArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__RightArrow",
    componentId: "sc-1a5y08h-5"
})([
    "margin-left:8px;& ",
    "{transform:rotate(180deg);}"
], $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$CloseButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$ArrowButton).withConfig({
    displayName: "compact__CloseButton",
    componentId: "sc-1a5y08h-6"
})([
    "margin-left:8px;& ",
    "{fill:",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG, (props)=>props.theme.klerosUIComponentsPrimaryBlue, $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$831351fb15d68ad0$var$CompactPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, onCloseOnLastPage: onCloseOnLastPage, label: label, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, minPageReached: minPageReached, maxPageReached: maxPageReached }] = $43afcb05ca3681f6$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback, onCloseOnLastPage);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            }),
            currentPage === numPages && onCloseOnLastPage ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$CloseButton, {
                onClick: onCloseOnLastPage,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$ff1548a205f71f6a$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$831351fb15d68ad0$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$1edefcf4055fc9a6$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$831351fb15d68ad0$var$StyledSVG.styledComponentId
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$831351fb15d68ad0$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$831351fb15d68ad0$var$CompactPagination;
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "standard__Wrapper",
    componentId: "sc-n01q9o-0"
})([
    "",
    " display:flex;align-items:center;justify-content:center;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$PageButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "standard__PageButton",
    componentId: "sc-n01q9o-1"
})([
    "",
    " height:32px;width:32px;margin:4px;background:",
    ";border:1px solid ",
    ";border-radius:3px;display:flex;align-items:center;justify-content:center;font-size:14px;color:",
    ";:hover:enabled{background:",
    ";border:1px solid ",
    ";color:",
    ";}:hover:disabled{cursor:default;}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, (props)=>props.selected ? props.theme.klerosUIComponentsLightBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsPrimaryText, (props)=>props.selected ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsLightBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "standard__StyledArrow",
    componentId: "sc-n01q9o-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$ArrowButton = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$PageButton).withConfig({
    displayName: "standard__ArrowButton",
    componentId: "sc-n01q9o-3"
})([
    "& ",
    "{",
    " fill:",
    ";transition:fill ease ",
    ";}:hover:enabled{& ",
    "{fill:",
    ";}}"
], $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, (props)=>props.disabled ? props.theme.klerosUIComponentsStroke : props.theme.klerosUIComponentsPrimaryText, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed, $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow, ({ theme: theme })=>theme.klerosUIComponentsSecondaryBlue);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$LeftArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__LeftArrow",
    componentId: "sc-n01q9o-4"
})([
    "& ",
    "{padding-right:1px;}"
], $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$RightArrow = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$ArrowButton).withConfig({
    displayName: "standard__RightArrow",
    componentId: "sc-n01q9o-5"
})([
    "& ",
    "{padding-left:1px;transform:rotate(180deg);}"
], $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow);
const $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StandardPagination = ({ currentPage: currentPage, numPages: numPages, callback: callback, disableNumbers: disableNumbers, hideNumbers: hideNumbers, className: className })=>{
    const [{ incrementPage: incrementPage, decrementPage: decrementPage, goToPage: goToPage, minPageReached: minPageReached, maxPageReached: maxPageReached, getPageRange: getPageRange }] = $43afcb05ca3681f6$var$$0ef3fc8611d56815$export$2e2bcd8739ae039(currentPage, numPages, callback);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$Wrapper, {
        className: className,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$LeftArrow, {
                disabled: minPageReached,
                onClick: decrementPage,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            }),
            !hideNumbers && getPageRange().map((i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$PageButton, {
                    selected: currentPage === i,
                    onClick: ()=>goToPage(i),
                    disabled: disableNumbers,
                    children: i
                }, i)),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$RightArrow, {
                disabled: maxPageReached,
                onClick: incrementPage,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$be261e7e6de1aa96$export$2e2bcd8739ae039, {
                    className: $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StyledArrow.styledComponentId
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$60c375d8d52bb6d6$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$60c375d8d52bb6d6$var$StandardPagination;
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "tabs__Wrapper",
    componentId: "sc-1dgmogo-0"
})([
    "",
    " height:fit-content;width:500px;display:flex;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledSVG = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "tabs__StyledSVG",
    componentId: "sc-1dgmogo-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledTab = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "tabs__StyledTab",
    componentId: "sc-1dgmogo-2"
})([
    "",
    " ",
    " flex-grow:1;height:45px;background:none;border-bottom:3px solid ",
    ";display:flex;align-items:center;justify-content:center;color:",
    ";",
    " & ",
    "{",
    " ",
    " height:16px;width:16px;margin-right:16px;fill:",
    ";}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, (props)=>props.selected ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
}, (props)=>!props.disabled && !props.selected ? `:hover {
        ${$43afcb05ca3681f6$var$$49a276e58256b44f$export$603679fcdd350e3b}
            border-bottom: 3px solid
              ${props.theme.klerosUIComponentsSecondaryBlue};
          }` : "", $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledSVG, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, (props)=>{
    if (props.selected) return props.theme.klerosUIComponentsPrimaryBlue;
    else if (props.disabled) return props.theme.klerosUIComponentsStroke;
    else return props.theme.klerosUIComponentsPrimaryText;
});
const $43afcb05ca3681f6$var$$35a1a5ac66949050$var$Tabs = ({ items: items, ...props })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$35a1a5ac66949050$var$Wrapper, {
        ...props,
        children: items.map(({ Icon: Icon, icon: icon, text: text, value: value, disabled: disabled })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledTab, {
                disabled: disabled,
                selected: value === props.currentValue,
                onClick: ()=>props.callback(value),
                children: [
                    icon ?? (Icon && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {
                        className: $43afcb05ca3681f6$var$$35a1a5ac66949050$var$StyledSVG.styledComponentId
                    })),
                    text
                ]
            }, value))
    });
};
var $43afcb05ca3681f6$var$$35a1a5ac66949050$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$35a1a5ac66949050$var$Tabs;
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "breadcrumb__Wrapper",
    componentId: "sc-2m5bd-0"
})([
    "",
    " display:flex;flex-wrap:wrap;gap:2px 0;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Element = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "breadcrumb__Element",
    componentId: "sc-2m5bd-1"
})([
    "",
    " background:none;padding:0;:hover{",
    "}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ clickable: clickable, theme: theme })=>clickable ? `small { color: ${theme.klerosUIComponentsPrimaryText}; }` : `cursor: text !important`);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "breadcrumb__Content",
    componentId: "sc-2m5bd-2"
})([
    "",
    " transition:color ease ",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ theme: theme })=>theme.klerosUIComponentsTransitionSpeed);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Separator = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__Separator",
    componentId: "sc-2m5bd-3"
})([
    "margin:0px 8px;"
]);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$ActiveElement = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content).withConfig({
    displayName: "breadcrumb__ActiveElement",
    componentId: "sc-2m5bd-4"
})([
    "color:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Breadcrumb = ({ items: items, callback: callback, clickable: clickable, className: className })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Wrapper, {
        className: className,
        children: items.map(({ text: text, value: value }, i)=>i === items.length - 1 ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$ActiveElement, {
                children: text
            }, i) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$parcel$interopDefault($dup7A).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Element, {
                        onClick: ()=>callback ? callback(value) : null,
                        clickable: clickable,
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Content, {
                            children: text
                        })
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Separator, {
                        children: "/"
                    })
                ]
            }, i))
    });
var $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a6857e6cae2f9c5f$var$Breadcrumb;
const $43afcb05ca3681f6$var$$d623bf354733f290$var$SvgHourglass = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        width: 12,
        height: 15,
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M1.275 14.5h9.31a.66.66 0 0 0 .665-.656v-.438a.66.66 0 0 0-.665-.656c0-2.487-1.414-4.586-3.348-5.25 1.934-.664 3.348-2.763 3.348-5.25a.66.66 0 0 0 .665-.656v-.438A.66.66 0 0 0 10.585.5h-9.31a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656c0 2.487 1.414 4.586 3.348 5.25-1.934.664-3.348 2.763-3.348 5.25a.66.66 0 0 0-.665.656v.438a.66.66 0 0 0 .665.656ZM3.048 2.25h5.764c0 2.118-1.28 3.938-2.882 3.938-1.601 0-2.882-1.82-2.882-3.938Z"
        })
    });
var $43afcb05ca3681f6$var$$d623bf354733f290$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$d623bf354733f290$var$SvgHourglass;
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$progressAnimation = (width)=>(0, $e9f8389e4f70b5af$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], width);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "linear__Wrapper",
    componentId: "sc-bwbdj5-0"
})([
    "",
    " display:flex;flex-direction:column;align-items:center;font-size:14px;color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "linear__StyledText",
    componentId: "sc-bwbdj5-1"
})([
    "",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$BarTimerWrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "linear__BarTimerWrapper",
    componentId: "sc-bwbdj5-2"
})([
    "display:flex;flex-direction:column;align-items:flex-start;"
]);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LinearChart = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "linear__LinearChart",
    componentId: "sc-bwbdj5-3"
})([
    "",
    " stroke:",
    ";display:block;margin:10px auto;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ width: width })=>width);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LineBackground = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "linear__LineBackground",
    componentId: "sc-bwbdj5-4"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Line = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "linear__Line",
    componentId: "sc-bwbdj5-5"
})([
    "stroke:",
    ";",
    ""
], ({ theme: theme })=>theme.klerosUIComponentsSuccess, ({ animated: animated, width: width })=>animated && (0, $e9f8389e4f70b5af$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$progressAnimation(width)));
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledHourglass = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$d623bf354733f290$export$2e2bcd8739ae039).withConfig({
    displayName: "linear__StyledHourglass",
    componentId: "sc-bwbdj5-6"
})([
    "",
    " margin-right:9.75px;fill:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68, ({ theme: theme })=>theme.klerosUIComponentsError);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$TimerMessage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "linear__TimerMessage",
    componentId: "sc-bwbdj5-7"
})([
    "margin-top:5px;display:flex;justify-content:center;align-items:center;color:",
    ";font-weight:600;line-height:1em;"
], ({ theme: theme })=>theme.klerosUIComponentsError);
const $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Linear = ({ text: text, progress: progress, width: width, timerText: timerText, animated: animated = true })=>{
    const sw = 8;
    const linePath = `M ${sw / 2} ${sw / 2} h ${width - sw}`;
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Wrapper, {
        children: [
            text && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledText, {
                children: text
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$BarTimerWrapper, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LinearChart, {
                        width: width,
                        height: sw,
                        fill: "none",
                        strokeWidth: sw,
                        strokeLinecap: "round",
                        children: [
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$LineBackground, {
                                d: linePath
                            }),
                            progress && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Line, {
                                animated: animated,
                                width: width,
                                strokeDasharray: `${progress * width / 100} ${width}`,
                                d: linePath
                            })
                        ]
                    }),
                    timerText && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$TimerMessage, {
                        children: [
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$8688d42e9f1d381a$var$StyledHourglass, {}),
                            timerText
                        ]
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$8688d42e9f1d381a$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$8688d42e9f1d381a$var$Linear;
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$progressAnimation = (circ)=>(0, $e9f8389e4f70b5af$exports.keyframes)([
        "0%{stroke-dasharray:0 ",
        ";}"
    ], circ);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircularChart = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).svg.withConfig({
    displayName: "circular__CircularChart",
    componentId: "sc-73w0na-0"
})([
    "",
    " ",
    " display:block;margin:10px auto;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$7ed1367e7fa1ad68);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircleBackground = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "circular__CircleBackground",
    componentId: "sc-73w0na-1"
})([
    "stroke:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).path.withConfig({
    displayName: "circular__Circle",
    componentId: "sc-73w0na-2"
})([
    "stroke:",
    ";",
    ""
], (props)=>props.progress < 100 ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsSuccess, ({ animated: animated, circ: circ })=>animated && (0, $e9f8389e4f70b5af$exports.css)([
        "animation:",
        " 1s ease-out forwards;"
    ], $43afcb05ca3681f6$var$$e09296aea30ed10d$var$progressAnimation(circ)));
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Percentage = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).text.withConfig({
    displayName: "circular__Percentage",
    componentId: "sc-73w0na-3"
})([
    "fill:",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsPrimaryText);
const $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circular = ({ progress: progress, small: small, animated: animated = true })=>{
    const width = small ? 80 : 120;
    const sw = width / 20; // stroke-width
    const rad = (width - sw) / 2 + 1;
    const dy = width - sw + 2;
    const circ = 2 * Math.PI * rad;
    const circlePath = `M ${(width + sw) / 2} ${sw / 2}
  a ${rad} ${rad} 0 0 1 0 ${dy}
  a ${rad} ${rad} 0 0 1 0 -${dy}`;
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircularChart, {
        fill: "none",
        strokeWidth: sw,
        strokeLinecap: "round",
        width: width + sw,
        height: width + sw,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$CircleBackground, {
                d: circlePath
            }),
            progress && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circle, {
                strokeDasharray: `${circ * progress / 100} ${circ}`,
                progress: progress,
                d: circlePath,
                circ: circ,
                animated: animated
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$e09296aea30ed10d$var$Percentage, {
                fontSize: small ? 16 : 24,
                fontWeight: 600,
                textAnchor: "middle",
                dominantBaseline: "middle",
                x: "50%",
                y: "50%",
                children: [
                    progress,
                    "%"
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$e09296aea30ed10d$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$e09296aea30ed10d$var$Circular;
const $43afcb05ca3681f6$var$$757595619553281c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet-circle__Wrapper",
    componentId: "sc-1bvj53u-0"
})([
    "height:100%;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $43afcb05ca3681f6$var$$757595619553281c$var$StyledSuccess = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$1fbc1df023618cf8$export$2e2bcd8739ae039).withConfig({
    displayName: "bullet-circle__StyledSuccess",
    componentId: "sc-1bvj53u-1"
})([
    "height:24px;width:24px;flex-basis:auto;fill:",
    ";"
], (props)=>props.theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$757595619553281c$var$Circle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet-circle__Circle",
    componentId: "sc-1bvj53u-2"
})([
    "height:24px;width:24px;flex-basis:auto;background-color:",
    ";border-radius:12px;border:1px solid ",
    ";display:flex;justify-content:center;align-items:center;font-size:12px;color:",
    ";"
], (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsWhiteBackground, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke, (props)=>props.active ? props.theme.klerosUIComponentsWhiteBackground : props.theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$757595619553281c$var$Line = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet-circle__Line",
    componentId: "sc-1bvj53u-3"
})([
    "height:auto;width:0px;flex-grow:1;border-left:1px solid ",
    ";margin:8px 0px;"
], (props)=>props.completed ? props.theme.klerosUIComponentsPrimaryBlue : props.theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$757595619553281c$var$BulletCircle = ({ active: active, completed: completed, line: line, index: index, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$757595619553281c$var$Wrapper, {
        ...props,
        children: [
            completed ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$757595619553281c$var$StyledSuccess, {}) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$757595619553281c$var$Circle, {
                active: active,
                children: [
                    " ",
                    index,
                    " "
                ]
            }),
            line && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$757595619553281c$var$Line, {
                completed: completed
            })
        ]
    });
var $43afcb05ca3681f6$var$$757595619553281c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$757595619553281c$var$BulletCircle;
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-1ly7f40-0"
})([
    "flex-basis:0;flex-grow:1;width:fit-content;display:flex;"
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-1ly7f40-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledBody = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "bullet__StyledBody",
    componentId: "sc-1ly7f40-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$TextContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-1ly7f40-3"
})([
    "margin-left:16px;margin-top:2px;& ",
    "{",
    " font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " font-size:12px;line-height:16px;}"
], $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledTitle, $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledBody, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$SubitemsContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__SubitemsContainer",
    componentId: "sc-1ly7f40-4"
})([
    "display:flex;flex-direction:column;"
]);
const $43afcb05ca3681f6$var$$c37ea337805e62b1$var$Bullet = ({ title: title, subitems: subitems, index: index, active: active, completed: completed, line: line, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$757595619553281c$export$2e2bcd8739ae039, {
                index: index,
                active: active,
                completed: completed,
                line: line
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$TextContainer, {
                active: active,
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledTitle, {
                        children: title
                    }),
                    subitems && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$SubitemsContainer, {
                        children: subitems.map((item, i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$c37ea337805e62b1$var$StyledBody, {
                                children: item
                            }, i))
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$c37ea337805e62b1$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$c37ea337805e62b1$var$Bullet;
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "vertical__Wrapper",
    componentId: "sc-1rvtpa4-0"
})([
    "height:100px;display:flex;flex-direction:column;"
]);
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$BulletsContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "vertical__BulletsContainer",
    componentId: "sc-1rvtpa4-1"
})([
    "height:auto;display:flex;flex-direction:column;flex-grow:1;"
]);
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$LastBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$c37ea337805e62b1$export$2e2bcd8739ae039).withConfig({
    displayName: "vertical__LastBullet",
    componentId: "sc-1rvtpa4-2"
})([
    "flex-basis:auto;flex-grow:0;"
]);
const $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Steps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Wrapper, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2f7d25ee5647072f$var$BulletsContainer, {
                children: items.slice(0, -1).map(({ title: title, subitems: subitems }, i)=>/*#__PURE__*/ (0, $dup7A.createElement)($43afcb05ca3681f6$var$$c37ea337805e62b1$export$2e2bcd8739ae039, {
                        title: title,
                        subitems: subitems,
                        completed: i < currentItemIndex,
                        active: i === currentItemIndex,
                        line: !(i + 1 === items.length),
                        index: i + 1,
                        key: i
                    }))
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2f7d25ee5647072f$var$LastBullet, {
                title: lastItem.title,
                subitems: lastItem.subitems,
                completed: items.length - 1 < currentItemIndex,
                active: items.length - 1 === currentItemIndex,
                index: items.length
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$2f7d25ee5647072f$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$2f7d25ee5647072f$var$Steps;
const $43afcb05ca3681f6$var$$cf0f856d949d5193$var$Container = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "horizontal-bullet__Container",
    componentId: "sc-1tljr4r-0"
})([
    "position:relative;height:fit-content;display:flex;justify-content:center;align-items:start;",
    " ",
    ""
], ({ paddingBottom: paddingBottom })=>paddingBottom ? (0, $e9f8389e4f70b5af$exports.css)([
        "",
        ""
    ], $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
            "padding-bottom:",
            "px;"
        ], paddingBottom))) : "", ({ theme: theme, last: last, completed: completed })=>last ? (0, $e9f8389e4f70b5af$exports.css)([
        "flex-grow:0;"
    ]) : (0, $e9f8389e4f70b5af$exports.css)([
        'flex-grow:1;:after{content:"";height:0px;width:auto;flex-grow:1;border-top:1px solid ',
        ";margin:12px 16px;}"
    ], completed ? theme.klerosUIComponentsPrimaryBlue : theme.klerosUIComponentsStroke));
const $43afcb05ca3681f6$var$$cf0f856d949d5193$var$TextWrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "horizontal-bullet__TextWrapper",
    componentId: "sc-1tljr4r-1"
})([
    "margin-left:8px;display:flex;flex-direction:column;align-items:start;> h2{",
    " font-size:14px;line-height:24px;color:",
    ";}> small{",
    " font-size:12px;line-height:16px;}",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, (props)=>props.active ? props.theme.klerosUIComponentsPrimaryText : props.theme.klerosUIComponentsSecondaryText, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, $43afcb05ca3681f6$var$$49a276e58256b44f$export$44eafa1b177a8b30(()=>(0, $e9f8389e4f70b5af$exports.css)([
        "position:absolute;top:24px;left:0;margin-left:0px;transform:translateX(calc(-50% + 12px));align-items:center;text-align:center;> h2{line-height:19px;}"
    ])));
const $43afcb05ca3681f6$var$$cf0f856d949d5193$var$HorizontalBullet = ({ index: index, title: title, subitems: subitems, active: active, last: last, completed: completed, ...props })=>{
    const [textRef, { height: height }] = $43afcb05ca3681f6$var$$2592152d06a7ba66$export$2b86bedf890eab8();
    const paddingBottom = height;
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$cf0f856d949d5193$var$Container, {
        active: active,
        completed: completed,
        last: last,
        paddingBottom: paddingBottom,
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$757595619553281c$export$2e2bcd8739ae039, {
                active: active,
                completed: completed,
                index: index
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$cf0f856d949d5193$var$TextWrapper, {
                ref: textRef,
                active: active,
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("h2", {
                        children: title
                    }),
                    subitems && subitems.map((item, i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                            children: item
                        }, i))
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$cf0f856d949d5193$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$cf0f856d949d5193$var$HorizontalBullet;
const $43afcb05ca3681f6$var$$4987b48a13ec5480$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "horizontal__Wrapper",
    componentId: "sc-12u32gl-0"
})([
    "",
    " width:250px;display:flex;justify-content:center;align-items:start;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$4987b48a13ec5480$var$HorizontalSteps = ({ items: items, currentItemIndex: currentItemIndex, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4987b48a13ec5480$var$Wrapper, {
        ...props,
        children: items.map((item, i)=>/*#__PURE__*/ (0, $dup7A.createElement)($43afcb05ca3681f6$var$$cf0f856d949d5193$export$2e2bcd8739ae039, {
                ...item,
                completed: i < currentItemIndex,
                active: i === currentItemIndex,
                last: i + 1 === items.length,
                index: i + 1,
                key: i
            }))
    });
var $43afcb05ca3681f6$var$$4987b48a13ec5480$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4987b48a13ec5480$var$HorizontalSteps;
const $43afcb05ca3681f6$var$$250cfcb8116ed97e$var$Steps = ({ horizontal: horizontal, ...props })=>horizontal ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4987b48a13ec5480$export$2e2bcd8739ae039, {
        ...props
    }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$2f7d25ee5647072f$export$2e2bcd8739ae039, {
        ...props
    });
var $43afcb05ca3681f6$var$$250cfcb8116ed97e$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$250cfcb8116ed97e$var$Steps;
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "spine__Wrapper",
    componentId: "sc-1nqkm41-0"
})([
    "height:auto;display:flex;flex-direction:column;justify-content:flex-start;align-items:center;"
]);
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$colorRegex = new RegExp("^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$");
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6 = (0, $e9f8389e4f70b5af$exports.css)([
    "",
    ""
], ({ variant: variant, theme: theme })=>{
    if (variant === "accepted") return theme.klerosUIComponentsSuccess;
    if (variant === "refused") return theme.klerosUIComponentsError;
    if (variant && $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$colorRegex.test(variant)) return variant;
    return theme.klerosUIComponentsPrimaryBlue;
});
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Circle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "spine__Circle",
    componentId: "sc-1nqkm41-1"
})([
    "height:16px;width:16px;flex-basis:auto;background-color:",
    ";border-radius:8px;border:2px solid ",
    ";"
], ({ theme: theme })=>theme.klerosUIComponentsWhiteBackground, $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6);
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Line = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "spine__Line",
    componentId: "sc-1nqkm41-2"
})([
    "height:",
    ";width:0px;flex-grow:",
    ";border-left:1px solid ",
    ";"
], ({ topHeight: topHeight })=>topHeight ? `${topHeight}px` : "auto", ({ topHeight: topHeight })=>topHeight ? 0 : 1, ({ theme: theme })=>theme.klerosUIComponentsStroke);
const $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Spine = ({ variant: variant, line: line, Icon: Icon, titleRef: titleRef })=>{
    const [topHeight, setTopHeight] = (0, $dup7A.useState)();
    (0, $dup7A.useEffect)(()=>{
        const handleOffsetTopChange = ()=>{
            if (titleRef?.current) {
                const newOffsetTop = titleRef.current.offsetTop;
                if (newOffsetTop !== topHeight) setTopHeight(newOffsetTop);
            }
        };
        handleOffsetTopChange();
        window.addEventListener("resize", handleOffsetTopChange);
        return ()=>{
            window.removeEventListener("resize", handleOffsetTopChange);
        };
    }, [
        titleRef,
        topHeight
    ]);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Wrapper, {
        children: [
            topHeight ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Line, {
                topHeight: topHeight
            }) : null,
            Icon ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {}) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Circle, {
                variant: variant
            }),
            line && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Line, {})
        ]
    });
};
var $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$b17bb74d528cffb5$var$Spine;
const $43afcb05ca3681f6$var$$febc15bff886858c$var$loading = (0, $e9f8389e4f70b5af$exports.keyframes)([
    "0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}"
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__Wrapper",
    componentId: "sc-6vrqo5-0"
})([
    "display:flex;position:relative;justify-content:",
    ";",
    ""
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end", ({ state: state })=>{
    if (state === "disabled") return (0, $e9f8389e4f70b5af$exports.css)([
        "opacity:0.5;"
    ]);
    if (state === "loading") return (0, $e9f8389e4f70b5af$exports.css)([
        "animation:",
        " 2s ease-in-out infinite normal;"
    ], $43afcb05ca3681f6$var$$febc15bff886858c$var$loading);
    return (0, $e9f8389e4f70b5af$exports.css)([
        "opacity:1;"
    ]);
});
const $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledTitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).h2.withConfig({
    displayName: "bullet__StyledTitle",
    componentId: "sc-6vrqo5-1"
})([
    ""
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledParty = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "bullet__StyledParty",
    componentId: "sc-6vrqo5-2"
})([
    ""
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledSubtitle = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "bullet__StyledSubtitle",
    componentId: "sc-6vrqo5-3"
})([
    ""
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$PartyElementWrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__PartyElementWrapper",
    componentId: "sc-6vrqo5-4"
})([
    "display:inline-flex;"
]);
const $43afcb05ca3681f6$var$$febc15bff886858c$var$TextContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__TextContainer",
    componentId: "sc-6vrqo5-5"
})([
    "margin-",
    ":20px;order:",
    ";display:flex;flex-direction:column;margin-bottom:",
    ";gap:2px;text-align:",
    ";@media (max-width:900px){margin-",
    ":16px;margin-bottom:",
    ";gap:4px;}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{",
    " order:",
    ";font-size:14px;line-height:19px;color:",
    ";}& ",
    "{order:",
    ";max-height:32px;overflow:hidden;}& ",
    "{",
    " align-self:flex-",
    ";font-size:12px;line-height:16px;}"
], ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? 1 : -1, ({ isLast: isLast })=>isLast ? "0" : "18px", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ rightSided: rightSided })=>rightSided ? "left" : "right", ({ isLast: isLast })=>isLast ? "0" : "16px", $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledTitle, $43afcb05ca3681f6$var$$49a276e58256b44f$export$a943aa9a0fca3f0b, ({ rightSided: rightSided })=>rightSided ? 1 : 2, ({ theme: theme })=>theme.klerosUIComponentsPrimaryText, $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledParty, $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, ({ rightSided: rightSided })=>rightSided ? 2 : 1, $43afcb05ca3681f6$var$$b17bb74d528cffb5$export$ce7158e6888ab5d6, $43afcb05ca3681f6$var$$febc15bff886858c$var$PartyElementWrapper, ({ rightSided: rightSided })=>rightSided ? 2 : 1, $43afcb05ca3681f6$var$$febc15bff886858c$var$StyledSubtitle, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, ({ rightSided: rightSided })=>rightSided ? "start" : "end");
const $43afcb05ca3681f6$var$$febc15bff886858c$var$PartyTitleContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "bullet__PartyTitleContainer",
    componentId: "sc-6vrqo5-6"
})([
    "display:flex;position:relative;align-items:center;flex-direction:row;flex-wrap:wrap;gap:4px 8px;justify-content:",
    ";"
], ({ rightSided: rightSided })=>rightSided ? "flex-start" : "flex-end");
const $43afcb05ca3681f6$var$$febc15bff886858c$var$Bullet = (props)=>{
    const { title: title, party: party, subtitle: subtitle, ...restProps } = props;
    const { rightSided: rightSided, variant: variant, line: line, Icon: Icon, isLast: isLast, state: state, ...wrapperProps } = restProps;
    const titleRef = (0, $dup7A.useRef)(null);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$febc15bff886858c$var$Wrapper, {
        rightSided: rightSided,
        state: state,
        ...wrapperProps,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$b17bb74d528cffb5$export$2e2bcd8739ae039, {
                variant: variant,
                line: line,
                Icon: Icon,
                titleRef: titleRef
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$febc15bff886858c$var$TextContainer, {
                className: "text-container",
                variant: variant,
                rightSided: rightSided,
                isLast: isLast,
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$febc15bff886858c$var$PartyTitleContainer, {
                        rightSided: rightSided,
                        children: [
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$var$StyledTitle, {
                                ref: titleRef,
                                children: title
                            }),
                            typeof party === `string` ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$var$StyledParty, {
                                children: party
                            }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$var$PartyElementWrapper, {
                                className: "party-wrapper",
                                children: party
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$var$StyledSubtitle, {
                        children: subtitle
                    })
                ]
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$febc15bff886858c$var$Bullet;
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "timeline__Wrapper",
    componentId: "sc-rxkvqs-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$StyledBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "timeline__StyledBullet",
    componentId: "sc-rxkvqs-1"
})([
    "position:relative;transform:translateX( ",
    " );"
], ({ rightSided: rightSided })=>rightSided ? "calc(50% - 8px)" : "calc(-50% + 8px)");
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$LastBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$StyledBullet).withConfig({
    displayName: "timeline__LastBullet",
    componentId: "sc-rxkvqs-2"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $43afcb05ca3681f6$var$$c3e303edb7751c77$var$Timeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$StyledBullet, {
                    line: true,
                    ...item,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$c3e303edb7751c77$var$LastBullet, {
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$c3e303edb7751c77$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$c3e303edb7751c77$var$Timeline;
const $43afcb05ca3681f6$var$$a3f868921843a442$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "custom__Wrapper",
    componentId: "sc-k2o2ay-0"
})([
    "",
    " display:flex;flex-direction:column;"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26);
const $43afcb05ca3681f6$var$$a3f868921843a442$var$LastBullet = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039).withConfig({
    displayName: "custom__LastBullet",
    componentId: "sc-k2o2ay-1"
})([
    "height:unset;flex-basis:auto;flex-grow:0;"
]);
const $43afcb05ca3681f6$var$$a3f868921843a442$var$CustomTimeline = ({ items: items, ...props })=>{
    const lastItem = items[items.length - 1];
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$a3f868921843a442$var$Wrapper, {
        ...props,
        children: [
            items.slice(0, -1).map((item, i)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$febc15bff886858c$export$2e2bcd8739ae039, {
                    line: true,
                    ...item,
                    rightSided: true,
                    isLast: false
                }, i)),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a3f868921843a442$var$LastBullet, {
                rightSided: true,
                ...lastItem,
                isLast: true
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$a3f868921843a442$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a3f868921843a442$var$CustomTimeline;
const $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$BaseTag = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).button.withConfig({
    displayName: "tag__BaseTag",
    componentId: "sc-19f0jzg-0"
})([
    "",
    " ",
    " height:32px;background-color:",
    ";border:",
    ";border-radius:300px;padding:0 16px;display:flex;justify-content:center;align-items:center;:hover{",
    "}"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, $43afcb05ca3681f6$var$$49a276e58256b44f$export$2ba01fb71ed41cb6, ({ theme: theme })=>theme.klerosUIComponentsMediumBlue, ({ theme: theme, active: active })=>active ? `1px solid ${theme.klerosUIComponentsPrimaryBlue}` : "none", ({ active: active, theme: theme })=>!active && `
      p {
        color: ${theme.klerosUIComponentsSecondaryBlue};
      }
    `);
const $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).p.withConfig({
    displayName: "tag__StyledText",
    componentId: "sc-19f0jzg-1"
})([
    "",
    " ",
    " color:",
    ";"
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ffb5f4729a158638, $43afcb05ca3681f6$var$$49a276e58256b44f$export$112f7a5d7552394, ({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue);
const $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$Tag = ({ text: text, active: active, as: as, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4c05722f1abfb34c$var$BaseTag, {
        active: active,
        as: as,
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4c05722f1abfb34c$var$StyledText, {
            children: text
        })
    });
var $43afcb05ca3681f6$var$$4c05722f1abfb34c$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4c05722f1abfb34c$var$Tag;
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledText = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).small.withConfig({
    displayName: "tooltip__StyledText",
    componentId: "sc-2flh2z-0"
})([
    ""
]);
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Tip = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "tooltip__Tip",
    componentId: "sc-2flh2z-1"
})([
    'content:"";position:absolute;border-width:8px;border-style:solid;::after{content:"";position:absolute;border-style:solid;border-width:7px;}',
    ""
], ({ place: place, theme: theme })=>(0, $e9f8389e4f70b5af$exports.css)([
        "",
        " ",
        " ",
        " ",
        ""
    ], place === "top" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:100%;left:50%;transform:translateX(-50%);border-color:",
        " transparent transparent transparent;::after{left:-7px;top:-8.5px;border-color:",
        " transparent transparent transparent;}"
    ], theme.klerosUIComponentsStroke, theme.klerosUIComponentsLightBlue), place === "right" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:50%;right:100%;transform:translateY(-50%);border-color:transparent ",
        " transparent transparent;::after{left:-5.5px;top:-7px;border-color:transparent ",
        " transparent transparent;}"
    ], theme.klerosUIComponentsStroke, theme.klerosUIComponentsLightBlue), place === "bottom" && (0, $e9f8389e4f70b5af$exports.css)([
        "left:50%;bottom:100%;transform:translateX(-50%);border-color:transparent transparent ",
        " transparent;::after{left:-7px;top:-5.5px;border-color:transparent transparent ",
        " transparent;}"
    ], theme.klerosUIComponentsStroke, theme.klerosUIComponentsLightBlue), place === "left" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:50%;left:100%;transform:translateY(-50%);border-color:transparent transparent transparent ",
        ";::after{left:-8.5px;top:-7px;border-color:transparent transparent transparent ",
        ";}"
    ], theme.klerosUIComponentsStroke, theme.klerosUIComponentsLightBlue)));
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledTooltip = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).span.withConfig({
    displayName: "tooltip__StyledTooltip",
    componentId: "sc-2flh2z-2"
})([
    "",
    " transition:opacity 200ms ease-in,visibility 200ms ease-in;",
    ""
], $43afcb05ca3681f6$var$$49a276e58256b44f$export$ed32643c9618a26, ({ place: place, theme: theme, small: small })=>(0, $e9f8389e4f70b5af$exports.css)([
        "visibility:hidden;opacity:0%;position:absolute;z-index:1;width:max-content;max-width:240px;background:",
        ";border:1px solid ",
        ";border-radius:7px;padding:13px 16px;display:flex;justify-content:center;align-items:center;& ",
        "{",
        " font-weight:100;text-align:",
        ";color:",
        ";}",
        " ",
        " ",
        " ",
        ""
    ], theme.klerosUIComponentsLightBlue, theme.klerosUIComponentsStroke, $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledText, $43afcb05ca3681f6$var$$49a276e58256b44f$export$3c17b0e969a90510, small ? "center" : "left", theme.klerosUIComponentsPrimaryText, place === "top" && (0, $e9f8389e4f70b5af$exports.css)([
        "bottom:calc(100% + 16px);left:50%;transform:translateX(-50%);"
    ]), place === "right" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:50%;left:calc(100% + 16px);transform:translateY(-50%);"
    ]), place === "bottom" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:calc(100% + 16px);left:50%;transform:translateX(-50%);"
    ]), place === "left" && (0, $e9f8389e4f70b5af$exports.css)([
        "top:50%;right:calc(100% + 16px);transform:translateY(-50%);"
    ])));
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "tooltip__Wrapper",
    componentId: "sc-2flh2z-3"
})([
    "position:relative;display:inline-block;&:hover ",
    "{visibility:visible;opacity:100%;}"
], $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledTooltip);
const $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Tooltip = ({ place: place = "top", text: text, children: children, small: small, ...props })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Wrapper, {
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledTooltip, {
                small: small,
                place: place,
                className: "tooltip-container",
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Tip, {
                        place: place
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$StyledText, {
                        className: "tooltip-text",
                        children: text
                    })
                ]
            })
        ]
    });
var $43afcb05ca3681f6$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$4ceeceac8d19d80b$var$Tooltip;
const $43afcb05ca3681f6$var$$a5329119b99a1727$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 15 16",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M13.776 2.06 12.129.44A1.536 1.536 0 0 0 11.05 0H5.587c-.841 0-1.524.672-1.524 1.5V3h-2.54C.684 3 0 3.672 0 4.5v10c0 .828.682 1.5 1.524 1.5h7.11c.843 0 1.525-.672 1.525-1.5V13h2.54c.841 0 1.523-.672 1.523-1.5V3.121c0-.398-.16-.779-.446-1.06ZM8.444 14.5h-6.73a.192.192 0 0 1-.134-.055.186.186 0 0 1-.056-.133V4.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .134-.055h2.35v7c0 .828.682 1.5 1.523 1.5h3.048v1.313c0 .05-.02.097-.056.132a.192.192 0 0 1-.135.055Zm4.064-3h-6.73a.192.192 0 0 1-.135-.055.186.186 0 0 1-.056-.133V1.688c0-.05.02-.098.056-.133a.192.192 0 0 1 .135-.055h3.365v2.75c0 .414.341.75.762.75h2.793v6.313c0 .05-.02.097-.055.132a.192.192 0 0 1-.135.055Zm.19-8h-2.031v-2h.305c.051 0 .1.02.135.055l1.536 1.511a.186.186 0 0 1 .055.133V3.5Z",
            fill: "#009AFF"
        })
    });
var $43afcb05ca3681f6$var$$a5329119b99a1727$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$a5329119b99a1727$var$SvgCopy;
const $43afcb05ca3681f6$var$$24ee0e3ed5abf092$var$SvgCopied = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        viewBox: "0 0 16 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("g", {
            clipPath: "url('#clip0_13289_179292')",
            children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M0 8.5a8 8 0 1 1 16.001.001A8 8 0 0 1 0 8.5Zm1.357 0a6.644 6.644 0 0 0 13.286 0 6.644 6.644 0 0 0-13.286 0Zm9.145-2.84h.837c.116 0 .184.132.114.227L7.694 11.1a.567.567 0 0 1-.923 0L4.545 8.016a.143.143 0 0 1 .116-.227h.837c.184 0 .356.089.463.237l1.271 1.765 2.807-3.893a.569.569 0 0 1 .463-.238Z",
                fill: "#009AFF"
            })
        })
    });
var $43afcb05ca3681f6$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$24ee0e3ed5abf092$var$SvgCopied;
const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Wrapper = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "copiable__Wrapper",
    componentId: "sc-3t2xjv-0"
})([
    "position:relative;display:inline-flex;align-items:center;gap:8px;flex-direction:",
    ";"
], ({ iconPlacement: iconPlacement })=>iconPlacement === "left" ? "row-reverse" : "row");
const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$StyledTooltip = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports)($43afcb05ca3681f6$var$$4ceeceac8d19d80b$export$2e2bcd8739ae039).withConfig({
    displayName: "copiable__StyledTooltip",
    componentId: "sc-3t2xjv-1"
})([
    "> span{padding:8px;}"
]);
const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$IconContainer = $43afcb05ca3681f6$var$$parcel$interopDefault($e9f8389e4f70b5af$exports).div.withConfig({
    displayName: "copiable__IconContainer",
    componentId: "sc-3t2xjv-2"
})([
    "cursor:pointer;display:flex;align-items:center;width:16px;height:16px;"
]);
/**
 * @description Wraps a component to make it copiable.
 * @param copiableContent The text to be copied to user's clipboard
 * @param info Modify the message displayed in the copy button's tooltip
 * @param tooltipProps Copy button's tooltip props
 */ const $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Copiable = ({ copiableContent: copiableContent, info: info, children: children, tooltipProps: tooltipProps, iconPlacement: iconPlacement = "right", ...props })=>{
    const [isCopied, setIsCopied] = (0, $dup7A.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(copiableContent).then(()=>{
            setIsCopied(true);
            setTimeout(()=>setIsCopied(false), 2000);
        }).catch(()=>setIsCopied(false));
    };
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Wrapper, {
        ...props,
        iconPlacement: iconPlacement,
        children: [
            children,
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$StyledTooltip, {
                text: isCopied ? "Copied!" : `${info ?? "Copy"}`,
                ...tooltipProps,
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$IconContainer, {
                    className: "icon-container",
                    children: isCopied ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$24ee0e3ed5abf092$export$2e2bcd8739ae039, {
                        className: "copied-icon"
                    }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($43afcb05ca3681f6$var$$a5329119b99a1727$export$2e2bcd8739ae039, {
                        className: "copy-icon",
                        onClick: handleCopy
                    })
                })
            })
        ]
    });
};
var $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$export$2e2bcd8739ae039 = $43afcb05ca3681f6$var$$f9cf7fe05b87a0bc$var$Copiable;
const $43afcb05ca3681f6$var$$18386f08588a981e$export$f30cb9bc4f736419 = {
    klerosUIComponentsName: "light",
    klerosUIComponentsPrimaryPurple: "#4D00B4",
    klerosUIComponentsSecondaryPurple: "#9013FE",
    klerosUIComponentsMediumPurple: "#F8F1FF",
    klerosUIComponentsLightPurple: "#FBF9FE",
    klerosUIComponentsPrimaryBlue: "#009AFF",
    klerosUIComponentsSecondaryBlue: "#7BCBFF",
    klerosUIComponentsMediumBlue: "#F0F9FF",
    klerosUIComponentsLightBlue: "#FCFEFF",
    klerosUIComponentsPrimaryText: "#333333",
    klerosUIComponentsSecondaryText: "#999999",
    klerosUIComponentsStroke: "#e5e5e5",
    klerosUIComponentsLightGrey: "#FAFAFA",
    klerosUIComponentsWhiteBackground: "#FFFFFF",
    klerosUIComponentsLightBackground: "#FAFBFC",
    klerosUIComponentsDefaultShadow: "#00000002",
    klerosUIComponentsHoveredShadow: "#00000002",
    klerosUIComponentsSuccess: "#00C42B",
    klerosUIComponentsSuccessLight: "#F0FBF2",
    klerosUIComponentsWarning: "#FF9900",
    klerosUIComponentsWarningLight: "#FFF9F0",
    klerosUIComponentsError: "#F60C36",
    klerosUIComponentsErrorLight: "#FEFF0F3",
    klerosUIComponentsTint: "#D14EFF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#F4F0FA",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $43afcb05ca3681f6$var$$18386f08588a981e$export$3e936a8db52a10a0 = {
    klerosUIComponentsName: "dark",
    klerosUIComponentsPrimaryPurple: "#7E1BD4",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#6CC5FF",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#392C74",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#220050",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};
const $43afcb05ca3681f6$var$$18386f08588a981e$export$a183395ddd946500 = {
    klerosUIComponentsPrimaryPurple: "#200F47",
    klerosUIComponentsSecondaryPurple: "#B45FFF",
    klerosUIComponentsMediumPurple: "#390F6C",
    klerosUIComponentsLightPurple: "#FCFBFF",
    klerosUIComponentsPrimaryBlue: "#69C3FC",
    klerosUIComponentsSecondaryBlue: "#A5DBFF",
    klerosUIComponentsMediumBlue: "#2E206C",
    klerosUIComponentsLightBlue: "#2A1260",
    klerosUIComponentsPrimaryText: "#DAF0FF",
    klerosUIComponentsSecondaryText: "#BECCE5",
    klerosUIComponentsStroke: "#42498F",
    klerosUIComponentsLightGrey: "#2D1865",
    klerosUIComponentsWhiteBackground: "#200F47",
    klerosUIComponentsLightBackground: "#1B003F",
    klerosUIComponentsDefaultShadow: "#00000000",
    klerosUIComponentsHoveredShadow: "#42498f80",
    klerosUIComponentsSuccess: "#65DC7F",
    klerosUIComponentsSuccessLight: "#32355B",
    klerosUIComponentsWarning: "#FFC46B",
    klerosUIComponentsWarningLight: "#451F54",
    klerosUIComponentsError: "#FF5A78",
    klerosUIComponentsErrorLight: "#360652",
    klerosUIComponentsTint: "#DDB6FF",
    klerosUIComponentsTintMedium: "#401D6C",
    klerosUIComponentsTintPurple: "#2F0960",
    klerosUIComponentsTransitionSpeed: "0.25s"
};


const $36383d7ccd515376$export$bca14c5b3b88a9c9 = {
    ...(0, $43afcb05ca3681f6$exports.veaTheme),
    color: {
        pink: "#FAD3F1",
        light: "#FFFDF5",
        dark: "#1B003F",
        white: "#FFFFFF",
        black: "#000000",
        blue: "#69C3FC",
        purple: "#1F0847",
        grey: "#E5E5E5",
        lightBlue: "#BECCE5",
        secondaryBlue: "#42498F",
        secondaryPurple: "#200F47",
        lightRed: "#FF5A78",
        lightYellow: "#FFC46B",
        turquoise: "#6CC5FF",
        lightPurple: "#B45FFF",
        darkBlue: "#7E93FF",
        smoke: "#BECCE5",
        teal: "#00B8C4",
        green: "#65DC7F",
        midnightPurple: "#2E206C"
    }
};



var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
function $ee36ba41d59c459d$export$2e2bcd8739ae039(fn, ms) {
    if (ms === void 0) ms = 0;
    var ready = (0, $dup7A.useRef)(false);
    var timeout = (0, $dup7A.useRef)();
    var callback = (0, $dup7A.useRef)(fn);
    var isReady = (0, $dup7A.useCallback)(function() {
        return ready.current;
    }, []);
    var set = (0, $dup7A.useCallback)(function() {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function() {
            ready.current = true;
            callback.current();
        }, ms);
    }, [
        ms
    ]);
    var clear = (0, $dup7A.useCallback)(function() {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0, $dup7A.useEffect)(function() {
        callback.current = fn;
    }, [
        fn
    ]);
    // set on mount, clear on unmount
    (0, $dup7A.useEffect)(function() {
        set();
        return clear;
    }, [
        ms
    ]);
    return [
        isReady,
        clear,
        set
    ];
}


function $3ba985b3701f9241$export$2e2bcd8739ae039(fn, ms, deps) {
    if (ms === void 0) ms = 0;
    if (deps === void 0) deps = [];
    var _a = (0, $ee36ba41d59c459d$export$2e2bcd8739ae039)(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0, $dup7A.useEffect)(reset, deps);
    return [
        isReady,
        cancel
    ];
}


function $e650dbe3a111616d$export$130bc0efb3cce789(_documentNode, fragmentType) {
    return fragmentType;
}
function $e650dbe3a111616d$export$4659cb8f146075(data, _fragment) {
    return data;
}


/* eslint-disable */ /* eslint-disable */ var $992699c82523319f$export$72a9f2d0d5047c2c = /*#__PURE__*/ function(Aggregation_Interval) {
    Aggregation_Interval["Day"] = "day";
    Aggregation_Interval["Hour"] = "hour";
    return Aggregation_Interval;
}({});
var $992699c82523319f$export$ab21e504f34ceea6 = /*#__PURE__*/ function(Challenge_OrderBy) {
    Challenge_OrderBy["Challenger"] = "challenger";
    Challenge_OrderBy["Claim"] = "claim";
    Challenge_OrderBy["ClaimBridger"] = "claim__bridger";
    Challenge_OrderBy["ClaimChallenged"] = "claim__challenged";
    Challenge_OrderBy["ClaimEpoch"] = "claim__epoch";
    Challenge_OrderBy["ClaimHonest"] = "claim__honest";
    Challenge_OrderBy["ClaimId"] = "claim__id";
    Challenge_OrderBy["ClaimStateroot"] = "claim__stateroot";
    Challenge_OrderBy["ClaimTimestamp"] = "claim__timestamp";
    Challenge_OrderBy["ClaimTxHash"] = "claim__txHash";
    Challenge_OrderBy["ClaimVerified"] = "claim__verified";
    Challenge_OrderBy["Honest"] = "honest";
    Challenge_OrderBy["Id"] = "id";
    Challenge_OrderBy["Timestamp"] = "timestamp";
    Challenge_OrderBy["TxHash"] = "txHash";
    return Challenge_OrderBy;
}({});
var $992699c82523319f$export$360e73a0506f34a4 = /*#__PURE__*/ function(Claim_OrderBy) {
    Claim_OrderBy["Bridger"] = "bridger";
    Claim_OrderBy["Challenge"] = "challenge";
    Claim_OrderBy["ChallengeChallenger"] = "challenge__challenger";
    Claim_OrderBy["ChallengeHonest"] = "challenge__honest";
    Claim_OrderBy["ChallengeId"] = "challenge__id";
    Claim_OrderBy["ChallengeTimestamp"] = "challenge__timestamp";
    Claim_OrderBy["ChallengeTxHash"] = "challenge__txHash";
    Claim_OrderBy["Challenged"] = "challenged";
    Claim_OrderBy["Epoch"] = "epoch";
    Claim_OrderBy["Honest"] = "honest";
    Claim_OrderBy["Id"] = "id";
    Claim_OrderBy["Outbox"] = "outbox";
    Claim_OrderBy["OutboxId"] = "outbox__id";
    Claim_OrderBy["Stateroot"] = "stateroot";
    Claim_OrderBy["Timestamp"] = "timestamp";
    Claim_OrderBy["TxHash"] = "txHash";
    Claim_OrderBy["Verification"] = "verification";
    Claim_OrderBy["VerificationId"] = "verification__id";
    Claim_OrderBy["VerificationStartCaller"] = "verification__startCaller";
    Claim_OrderBy["VerificationStartTimestamp"] = "verification__startTimestamp";
    Claim_OrderBy["VerificationStartTxHash"] = "verification__startTxHash";
    Claim_OrderBy["VerificationVerifiedCaller"] = "verification__verifiedCaller";
    Claim_OrderBy["VerificationVerifiedTimestamp"] = "verification__verifiedTimestamp";
    Claim_OrderBy["VerificationVerifiedTxHash"] = "verification__verifiedTxHash";
    Claim_OrderBy["Verified"] = "verified";
    return Claim_OrderBy;
}({});
var $992699c82523319f$export$ccad0d1b2db8c978 = /*#__PURE__*/ function(Fallback_OrderBy) {
    Fallback_OrderBy["Executor"] = "executor";
    Fallback_OrderBy["Id"] = "id";
    Fallback_OrderBy["Snapshot"] = "snapshot";
    Fallback_OrderBy["SnapshotCaller"] = "snapshot__caller";
    Fallback_OrderBy["SnapshotEpoch"] = "snapshot__epoch";
    Fallback_OrderBy["SnapshotEpochString"] = "snapshot__epochString";
    Fallback_OrderBy["SnapshotId"] = "snapshot__id";
    Fallback_OrderBy["SnapshotNumberMessages"] = "snapshot__numberMessages";
    Fallback_OrderBy["SnapshotResolving"] = "snapshot__resolving";
    Fallback_OrderBy["SnapshotSaved"] = "snapshot__saved";
    Fallback_OrderBy["SnapshotStateRoot"] = "snapshot__stateRoot";
    Fallback_OrderBy["SnapshotStateRootString"] = "snapshot__stateRootString";
    Fallback_OrderBy["SnapshotTimestamp"] = "snapshot__timestamp";
    Fallback_OrderBy["SnapshotTxHash"] = "snapshot__txHash";
    Fallback_OrderBy["TicketId"] = "ticketId";
    Fallback_OrderBy["Timestamp"] = "timestamp";
    Fallback_OrderBy["TxHash"] = "txHash";
    return Fallback_OrderBy;
}({});
var $992699c82523319f$export$b7c41bc6b7732308 = /*#__PURE__*/ function(Inbox_OrderBy) {
    Inbox_OrderBy["Id"] = "id";
    Inbox_OrderBy["Messages"] = "messages";
    return Inbox_OrderBy;
}({});
var $992699c82523319f$export$7a57d8e085da290 = /*#__PURE__*/ function(Message_OrderBy) {
    Message_OrderBy["Data"] = "data";
    Message_OrderBy["From"] = "from";
    Message_OrderBy["Id"] = "id";
    Message_OrderBy["Outbox"] = "outbox";
    Message_OrderBy["OutboxId"] = "outbox__id";
    Message_OrderBy["Proof"] = "proof";
    Message_OrderBy["Relayer"] = "relayer";
    Message_OrderBy["Snapshot"] = "snapshot";
    Message_OrderBy["SnapshotCaller"] = "snapshot__caller";
    Message_OrderBy["SnapshotEpoch"] = "snapshot__epoch";
    Message_OrderBy["SnapshotEpochString"] = "snapshot__epochString";
    Message_OrderBy["SnapshotId"] = "snapshot__id";
    Message_OrderBy["SnapshotNumberMessages"] = "snapshot__numberMessages";
    Message_OrderBy["SnapshotResolving"] = "snapshot__resolving";
    Message_OrderBy["SnapshotSaved"] = "snapshot__saved";
    Message_OrderBy["SnapshotStateRoot"] = "snapshot__stateRoot";
    Message_OrderBy["SnapshotStateRootString"] = "snapshot__stateRootString";
    Message_OrderBy["SnapshotTimestamp"] = "snapshot__timestamp";
    Message_OrderBy["SnapshotTxHash"] = "snapshot__txHash";
    Message_OrderBy["Timestamp"] = "timestamp";
    Message_OrderBy["To"] = "to";
    Message_OrderBy["TxHash"] = "txHash";
    return Message_OrderBy;
}({});
var $992699c82523319f$export$6576b9de878968d6 = /*#__PURE__*/ function(OrderDirection) {
    OrderDirection["Asc"] = "asc";
    OrderDirection["Desc"] = "desc";
    return OrderDirection;
}({});
var $992699c82523319f$export$283da6555f4f42b5 = /*#__PURE__*/ function(Outbox_OrderBy) {
    Outbox_OrderBy["Claims"] = "claims";
    Outbox_OrderBy["Id"] = "id";
    return Outbox_OrderBy;
}({});
var $992699c82523319f$export$b0d48e1184eac70d = /*#__PURE__*/ function(Ref_OrderBy) {
    Ref_OrderBy["CurrentSnapshotIndex"] = "currentSnapshotIndex";
    Ref_OrderBy["Id"] = "id";
    Ref_OrderBy["Inbox"] = "inbox";
    Ref_OrderBy["InboxId"] = "inbox__id";
    Ref_OrderBy["NextMessageIndex"] = "nextMessageIndex";
    Ref_OrderBy["Outbox"] = "outbox";
    Ref_OrderBy["OutboxId"] = "outbox__id";
    Ref_OrderBy["TotalChallenges"] = "totalChallenges";
    Ref_OrderBy["TotalClaims"] = "totalClaims";
    Ref_OrderBy["TotalMessages"] = "totalMessages";
    return Ref_OrderBy;
}({});
var $992699c82523319f$export$f4df7d3385133029 = /*#__PURE__*/ function(Snapshot_OrderBy) {
    Snapshot_OrderBy["Caller"] = "caller";
    Snapshot_OrderBy["Epoch"] = "epoch";
    Snapshot_OrderBy["EpochString"] = "epochString";
    Snapshot_OrderBy["Fallback"] = "fallback";
    Snapshot_OrderBy["Id"] = "id";
    Snapshot_OrderBy["Inbox"] = "inbox";
    Snapshot_OrderBy["InboxId"] = "inbox__id";
    Snapshot_OrderBy["Messages"] = "messages";
    Snapshot_OrderBy["NumberMessages"] = "numberMessages";
    Snapshot_OrderBy["Resolving"] = "resolving";
    Snapshot_OrderBy["Saved"] = "saved";
    Snapshot_OrderBy["StateRoot"] = "stateRoot";
    Snapshot_OrderBy["StateRootString"] = "stateRootString";
    Snapshot_OrderBy["Timestamp"] = "timestamp";
    Snapshot_OrderBy["TxHash"] = "txHash";
    return Snapshot_OrderBy;
}({});
var $992699c82523319f$export$33fd1948388e1327 = /*#__PURE__*/ function(Verification_OrderBy) {
    Verification_OrderBy["Claim"] = "claim";
    Verification_OrderBy["ClaimBridger"] = "claim__bridger";
    Verification_OrderBy["ClaimChallenged"] = "claim__challenged";
    Verification_OrderBy["ClaimEpoch"] = "claim__epoch";
    Verification_OrderBy["ClaimHonest"] = "claim__honest";
    Verification_OrderBy["ClaimId"] = "claim__id";
    Verification_OrderBy["ClaimStateroot"] = "claim__stateroot";
    Verification_OrderBy["ClaimTimestamp"] = "claim__timestamp";
    Verification_OrderBy["ClaimTxHash"] = "claim__txHash";
    Verification_OrderBy["ClaimVerified"] = "claim__verified";
    Verification_OrderBy["Id"] = "id";
    Verification_OrderBy["StartCaller"] = "startCaller";
    Verification_OrderBy["StartTimestamp"] = "startTimestamp";
    Verification_OrderBy["StartTxHash"] = "startTxHash";
    Verification_OrderBy["VerifiedCaller"] = "verifiedCaller";
    Verification_OrderBy["VerifiedTimestamp"] = "verifiedTimestamp";
    Verification_OrderBy["VerifiedTxHash"] = "verifiedTxHash";
    return Verification_OrderBy;
}({});
var $992699c82523319f$export$ac48b316845cbda1 = /*#__PURE__*/ function(_SubgraphErrorPolicy_) {
    /** Data will be returned even if the subgraph has indexing errors */ _SubgraphErrorPolicy_["Allow"] = "allow";
    /** If the subgraph has indexing errors, data will be omitted. The default. */ _SubgraphErrorPolicy_["Deny"] = "deny";
    return _SubgraphErrorPolicy_;
}({});
const $992699c82523319f$export$2da192d422e27a44 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getSnapshot"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "epoch"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshots"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "epoch"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "epoch"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "inbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "saved"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$661c79e1579025a1 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshots"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "inbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "saved"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ref"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "0",
                                    block: false
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "currentSnapshotIndex"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$f00557595eb44af0 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getResolvingSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "resolving"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Boolean"
                        }
                    },
                    defaultValue: {
                        kind: "BooleanValue",
                        value: true
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshots"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "resolving"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "resolving"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "inbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "saved"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ref"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "0",
                                    block: false
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "currentSnapshotIndex"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$f02dcd6965c925b3 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "searchSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "value"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshotQuery"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "text"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "value"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "inbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caller"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateRoot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "saved"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "resolving"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "fallback"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderBy"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "timestamp"
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "orderDirection"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "desc"
                                            }
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "executor"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "ticketId"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$9ef9a9e5468b4145 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getMessages"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "skip"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshot"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotID"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "messages"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "5"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "skip"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "skip"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "snapshot"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "snapshot"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "from"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "to"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "data"
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "snapshot"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotID"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numberMessages"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$1b2b78f6cf8e0aa9 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getClaim"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "epoch"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "epoch"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "epoch"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "outbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTimestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedCaller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTxHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$295d5fe4e44dcaf9 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getClaimedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "outbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTimestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedCaller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTxHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$6cf6d16829b07a05 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getChallengedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "outbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTimestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedCaller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTxHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$7f90a767e154c062 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getVerifiedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: false
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "outbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTimestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedCaller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTxHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$d8931e5a8edc5f3 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getResolvedSnapshots"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "snapshotsPerPage"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "Int"
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "lastTimestamp"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "BigInt"
                            }
                        }
                    }
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "contract"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "claims"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "snapshotsPerPage"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderBy"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "timestamp"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "orderDirection"
                                },
                                value: {
                                    kind: "EnumValue",
                                    value: "desc"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "where"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "timestamp_lte"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "lastTimestamp"
                                                }
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "verified"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "challenged"
                                            },
                                            value: {
                                                kind: "BooleanValue",
                                                value: true
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "outbox"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "contract"
                                                }
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "epoch"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "stateroot"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bridger"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenged"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verified"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "challenge"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "timestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "challenger"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "honest"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "txHash"
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "verification"
                                    },
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTimestamp"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedCaller"
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "verifiedTxHash"
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
const $992699c82523319f$export$7c3db7ddc7684a8c = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getRelay"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    }
                }
            ],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "message"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "timestamp"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "txHash"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "relayer"
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "proof"
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};


/**
 * Map of all GraphQL operations in the project.
 *
 * This map has several performance disadvantages:
 * 1. It is not tree-shakeable, so it will include all operations in the project.
 * 2. It is not minifiable, so the string of a GraphQL query will be multiple times inside the bundle.
 * 3. It does not support dead code elimination, so it will add unused operations.
 *
 * Therefore it is highly recommended to use the babel or swc plugin for production.
 */ const $9aed2896e1d7bbe9$var$documents = {
    "\n  query getSnapshot($epoch: BigInt!, $contract: String!) {\n    snapshots(where: { epoch: $epoch, inbox: $contract }) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      saved\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n  }\n": $992699c82523319f$export$2da192d422e27a44,
    '\n  query getSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n    $contract: String!\n  ) {\n    snapshots(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: { timestamp_lte: $lastTimestamp, inbox: $contract }\n    ) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      saved\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n    ref(id: "0") {\n      currentSnapshotIndex\n    }\n  }\n': $992699c82523319f$export$661c79e1579025a1,
    '\n  query getResolvingSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n    $resolving: Boolean = true\n    $contract: String!\n  ) {\n    snapshots(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        resolving: $resolving\n        inbox: $contract\n      }\n    ) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      saved\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n    ref(id: "0") {\n      currentSnapshotIndex\n    }\n  }\n': $992699c82523319f$export$f00557595eb44af0,
    "\n  query searchSnapshots(\n    $snapshotsPerPage: Int\n    $value: String!\n    $contract: String!\n  ) {\n    snapshotQuery(\n      text: $value\n      first: $snapshotsPerPage\n      where: { inbox: $contract }\n    ) {\n      id\n      epoch\n      caller\n      txHash\n      timestamp\n      stateRoot\n      numberMessages\n      saved\n      resolving\n      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {\n        executor\n        timestamp\n        txHash\n        ticketId\n      }\n    }\n  }\n": $992699c82523319f$export$f02dcd6965c925b3,
    "\n  query getMessages($skip: Int!, $snapshot: String!, $snapshotID: ID!) {\n    messages(\n      first: 5\n      skip: $skip\n      orderBy: timestamp\n      orderDirection: desc\n      where: { snapshot: $snapshot }\n    ) {\n      id\n      txHash\n      timestamp\n      from\n      to\n      data\n    }\n    snapshot(id: $snapshotID) {\n      numberMessages\n    }\n  }\n": $992699c82523319f$export$9ef9a9e5468b4145,
    "\n  query getClaim($epoch: BigInt!, $contract: String!) {\n    claims(where: { epoch: $epoch, outbox: $contract }) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        verifiedTimestamp\n        verifiedCaller\n        verifiedTxHash\n      }\n    }\n  }\n": $992699c82523319f$export$1b2b78f6cf8e0aa9,
    "\n  query getClaimedSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n    $contract: String!\n  ) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        verified: false\n        challenged: false\n        outbox: $contract\n      }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        verifiedTimestamp\n        verifiedCaller\n        verifiedTxHash\n      }\n    }\n  }\n": $992699c82523319f$export$295d5fe4e44dcaf9,
    "\n  query getChallengedSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n    $contract: String!\n  ) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        verified: false\n        challenged: true\n        outbox: $contract\n      }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        verifiedTimestamp\n        verifiedCaller\n        verifiedTxHash\n      }\n    }\n  }\n": $992699c82523319f$export$6cf6d16829b07a05,
    "\n  query getVerifiedSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n    $contract: String!\n  ) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        verified: true\n        challenged: false\n        outbox: $contract\n      }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        verifiedTimestamp\n        verifiedCaller\n        verifiedTxHash\n      }\n    }\n  }\n": $992699c82523319f$export$7f90a767e154c062,
    "\n  query getResolvedSnapshots(\n    $snapshotsPerPage: Int\n    $lastTimestamp: BigInt!\n    $contract: String!\n  ) {\n    claims(\n      first: $snapshotsPerPage\n      orderBy: timestamp\n      orderDirection: desc\n      where: {\n        timestamp_lte: $lastTimestamp\n        verified: true\n        challenged: true\n        outbox: $contract\n      }\n    ) {\n      id\n      epoch\n      timestamp\n      stateroot\n      bridger\n      challenged\n      verified\n      txHash\n      challenge {\n        id\n        timestamp\n        challenger\n        honest\n        txHash\n      }\n      verification {\n        verifiedTimestamp\n        verifiedCaller\n        verifiedTxHash\n      }\n    }\n  }\n": $992699c82523319f$export$d8931e5a8edc5f3,
    "\n  query getRelay($id: ID!) {\n    message(id: $id) {\n      timestamp\n      txHash\n      relayer\n      proof\n    }\n  }\n": $992699c82523319f$export$7c3db7ddc7684a8c
};
function $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035(source) {
    return $9aed2896e1d7bbe9$var$documents[source] ?? {};
}




const $72674c05516c5d85$export$2532f3c0a33feede = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getSnapshot($epoch: BigInt!, $contract: String!) {
    snapshots(where: { epoch: $epoch, inbox: $contract }) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      saved
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
  }
`);
const $72674c05516c5d85$export$2c215692068227d4 = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
    $contract: String!
  ) {
    snapshots(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: { timestamp_lte: $lastTimestamp, inbox: $contract }
    ) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      saved
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
    ref(id: "0") {
      currentSnapshotIndex
    }
  }
`);
const $72674c05516c5d85$export$1e6b7e1acb4f66ff = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getResolvingSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
    $resolving: Boolean = true
    $contract: String!
  ) {
    snapshots(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        resolving: $resolving
        inbox: $contract
      }
    ) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      saved
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
    ref(id: "0") {
      currentSnapshotIndex
    }
  }
`);
const $72674c05516c5d85$export$a92bfde441f2bbcc = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query searchSnapshots(
    $snapshotsPerPage: Int
    $value: String!
    $contract: String!
  ) {
    snapshotQuery(
      text: $value
      first: $snapshotsPerPage
      where: { inbox: $contract }
    ) {
      id
      epoch
      caller
      txHash
      timestamp
      stateRoot
      numberMessages
      saved
      resolving
      fallback(first: 1, orderBy: timestamp, orderDirection: desc) {
        executor
        timestamp
        txHash
        ticketId
      }
    }
  }
`);



const $c01bc8aa182cc810$export$4f062a25be074082 = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getClaim($epoch: BigInt!, $contract: String!) {
    claims(where: { epoch: $epoch, outbox: $contract }) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        verifiedTimestamp
        verifiedCaller
        verifiedTxHash
      }
    }
  }
`);
const $c01bc8aa182cc810$export$88ae1b33958ad484 = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getClaimedSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
    $contract: String!
  ) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        verified: false
        challenged: false
        outbox: $contract
      }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        verifiedTimestamp
        verifiedCaller
        verifiedTxHash
      }
    }
  }
`);
const $c01bc8aa182cc810$export$1353c1ff75d0de84 = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getChallengedSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
    $contract: String!
  ) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        verified: false
        challenged: true
        outbox: $contract
      }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        verifiedTimestamp
        verifiedCaller
        verifiedTxHash
      }
    }
  }
`);
const $c01bc8aa182cc810$export$b7a4a1257ef277eb = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getVerifiedSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
    $contract: String!
  ) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        verified: true
        challenged: false
        outbox: $contract
      }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        verifiedTimestamp
        verifiedCaller
        verifiedTxHash
      }
    }
  }
`);
const $c01bc8aa182cc810$export$a098f315450cf75c = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getResolvedSnapshots(
    $snapshotsPerPage: Int
    $lastTimestamp: BigInt!
    $contract: String!
  ) {
    claims(
      first: $snapshotsPerPage
      orderBy: timestamp
      orderDirection: desc
      where: {
        timestamp_lte: $lastTimestamp
        verified: true
        challenged: true
        outbox: $contract
      }
    ) {
      id
      epoch
      timestamp
      stateroot
      bridger
      challenged
      verified
      txHash
      challenge {
        id
        timestamp
        challenger
        honest
        txHash
      }
      verification {
        verifiedTimestamp
        verifiedCaller
        verifiedTxHash
      }
    }
  }
`);


var $fbf2684cb3a1cc27$exports = {};
$fbf2684cb3a1cc27$exports = JSON.parse("{\"address\":\"0x45138BC4E364A16919C4571699171d774A7590BD\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_veaOutboxArbToEth\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes\",\"name\":\"_nodeData\",\"type\":\"bytes\"}],\"name\":\"MessageSent\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_snapshot\",\"type\":\"bytes32\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_count\",\"type\":\"uint64\"}],\"name\":\"SnapshotSaved\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epochSent\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_ticketId\",\"type\":\"bytes32\"}],\"name\":\"SnapshotSent\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"count\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochFinalized\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"saveSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_data\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"sendSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"snapshots\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"veaOutboxArbToEth\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"transactionHash\":\"0x9344dd0c8a68da1c934722ea3a63223f3223be984e829fdbee700e6e1fe73a98\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0x45138BC4E364A16919C4571699171d774A7590BD\",\"transactionIndex\":1,\"gasUsed\":\"793310\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0xe12ed8d88214763b4b4608bd4e907aa00a53d6ce2222722a8f97633512620470\",\"transactionHash\":\"0x9344dd0c8a68da1c934722ea3a63223f3223be984e829fdbee700e6e1fe73a98\",\"logs\":[],\"blockNumber\":189388908,\"cumulativeGasUsed\":\"793310\",\"status\":1,\"byzantium\":true},\"args\":[300,\"0x60af9Fc1dd7d5bce69a66A8AEf456952b03A39C7\"],\"numDeployments\":6,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_veaOutboxArbToEth\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_nodeData\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"MessageSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_snapshot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_count\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"SnapshotSaved\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochSent\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_ticketId\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"SnapshotSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"count\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochFinalized\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"saveSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_data\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"sendSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"snapshots\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"veaOutboxArbToEth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Inbox From Arbitrum to Ethereum. Note: This contract is deployed on Arbitrum.\\\",\\\"events\\\":{\\\"MessageSent(bytes)\\\":{\\\"details\\\":\\\"Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\\\",\\\"params\\\":{\\\"_nodeData\\\":\\\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\"}},\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"params\\\":{\\\"_count\\\":\\\"The count of messages in the merkle tree.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot.\\\",\\\"_snapshot\\\":\\\"The snapshot of the merkle tree state root.\\\"}},\\\"SnapshotSent(uint256,bytes32)\\\":{\\\"details\\\":\\\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\",\\\"params\\\":{\\\"_epochSent\\\":\\\"The epoch of the snapshot.\\\",\\\"_ticketId\\\":\\\"The ticketId of the L2->L1 message.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_epochPeriod\\\":\\\"The duration in seconds between epochs.\\\",\\\"_veaOutboxArbToEth\\\":\\\"The veaOutbox on ethereum.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the epoch from the inbox's point of view using timestamp.\\\",\\\"params\\\":{\\\"_timestamp\\\":\\\"The timestamp to calculate the epoch from.\\\"},\\\"returns\\\":{\\\"epoch\\\":\\\"The calculated epoch.\\\"}},\\\"epochFinalized()\\\":{\\\"details\\\":\\\"Get the most recent epoch for which snapshots are finalized.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"saveSnapshot()\\\":{\\\"details\\\":\\\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\\\"},\\\"sendMessage(address,bytes)\\\":{\\\"details\\\":\\\"Sends an arbitrary message to Ethereum.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\\\",\\\"params\\\":{\\\"_data\\\":\\\"The message data for the receiving gateway.\\\",\\\"_to\\\":\\\"The address of the contract on the receiving chain which receives the calldata.\\\"},\\\"returns\\\":{\\\"_0\\\":\\\"msgId The zero based index of the message in the inbox.\\\"}},\\\"sendSnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the state root snapshot using Arbitrum's canonical bridge.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot requested to send.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"events\\\":{\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"notice\\\":\\\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\"}},\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToEth/VeaInboxArbToEth.sol\\\":\\\"VeaInboxArbToEth\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToEth/VeaInboxArbToEth.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/IArbSys.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/inboxes/IVeaInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Inbox From Arbitrum to Ethereum.\\\\n/// Note: This contract is deployed on Arbitrum.\\\\ncontract VeaInboxArbToEth is IVeaInbox {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    // Arbitrum precompile ArbSys for L2->L1 messaging: https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n    IArbSys internal constant ARB_SYS = IArbSys(address(100));\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    address public immutable veaOutboxArbToEth; // The vea outbox on ethereum.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public snapshots; // epoch => state root snapshot\\\\n\\\\n    // Inbox represents minimum data availability to maintain incremental merkle tree.\\\\n    // Supports a max of 2^64 - 1 messages. See merkle tree docs for details how inbox manages state.\\\\n\\\\n    bytes32[64] internal inbox; // stores minimal set of complete subtree roots of the merkle tree to increment.\\\\n    uint64 public count; // count of messages in the merkle tree\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\\\\n    /// @param _nodeData The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\\n    event MessageSent(bytes _nodeData);\\\\n\\\\n    /// The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\\n    /// @param _snapshot The snapshot of the merkle tree state root.\\\\n    /// @param _epoch The epoch of the snapshot.\\\\n    /// @param _count The count of messages in the merkle tree.\\\\n    event SnapshotSaved(bytes32 _snapshot, uint256 _epoch, uint64 _count);\\\\n\\\\n    /// @dev The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\\n    /// @param _epochSent The epoch of the snapshot.\\\\n    /// @param _ticketId The ticketId of the L2->L1 message.\\\\n    event SnapshotSent(uint256 indexed _epochSent, bytes32 _ticketId);\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _epochPeriod The duration in seconds between epochs.\\\\n    /// @param _veaOutboxArbToEth The veaOutbox on ethereum.\\\\n    constructor(uint256 _epochPeriod, address _veaOutboxArbToEth) {\\\\n        epochPeriod = _epochPeriod;\\\\n        veaOutboxArbToEth = _veaOutboxArbToEth;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Sends an arbitrary message to Ethereum.\\\\n    ///      `O(log(count))` where count is the number of messages already sent.\\\\n    ///      Amortized cost is constant.\\\\n    /// Note: See docs for details how inbox manages merkle tree state.\\\\n    /// @param _to The address of the contract on the receiving chain which receives the calldata.\\\\n    /// @param _data The message data for the receiving gateway.\\\\n    /// @return msgId The zero based index of the message in the inbox.\\\\n    function sendMessage(address _to, bytes calldata _data) external override returns (uint64) {\\\\n        uint64 oldCount = count;\\\\n\\\\n        // Given arbitrum's speed limit of 7 million gas / second, it would take atleast 8 million years of full blocks to overflow.\\\\n        // It *should* be impossible to overflow, but we check to be safe when appending to the tree.\\\\n        require(oldCount < type(uint64).max, \\\\\\\"Inbox is full.\\\\\\\");\\\\n\\\\n        bytes memory nodeData = abi.encodePacked(oldCount, _to, msg.sender, _data);\\\\n\\\\n        // single hashed leaf\\\\n        bytes32 newInboxNode = keccak256(nodeData);\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            // efficient hash using EVM scratch space\\\\n            mstore(0x00, newInboxNode)\\\\n            newInboxNode := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        // increment merkle tree calculating minimal number of hashes\\\\n        unchecked {\\\\n            uint256 height;\\\\n\\\\n            // x = oldCount + 1; acts as a bit mask to determine if a hash is needed\\\\n            // note: x is always non-zero, and x is bit shifted to the right each loop\\\\n            // hence this loop will always terminate in a maximum of log_2(oldCount + 1) iterations\\\\n            for (uint64 x = oldCount + 1; x & 1 == 0; x = x >> 1) {\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                newInboxNode = sortConcatAndHash(inbox[height], newInboxNode);\\\\n                height++;\\\\n            }\\\\n\\\\n            inbox[height] = newInboxNode;\\\\n\\\\n            // finally increment count\\\\n            count = oldCount + 1;\\\\n        }\\\\n\\\\n        emit MessageSent(nodeData);\\\\n\\\\n        // old count is the zero indexed leaf position in the tree, acts as a msgId\\\\n        // gateways should index these msgIds to later relay proofs\\\\n        return oldCount;\\\\n    }\\\\n\\\\n    /// @dev Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    /// Note: See merkle tree docs for details how inbox manages state.\\\\n    function saveSnapshot() external {\\\\n        uint256 epoch;\\\\n        bytes32 stateRoot;\\\\n\\\\n        unchecked {\\\\n            epoch = block.timestamp / epochPeriod;\\\\n\\\\n            // calculate the current root of the incremental merkle tree encoded in the inbox\\\\n\\\\n            uint256 height;\\\\n\\\\n            // x acts as a bit mask to determine if the hash stored in the inbox contributes to the root\\\\n            uint256 x;\\\\n\\\\n            // x is bit shifted to the right each loop, hence this loop will always terminate in a maximum of log_2(count) iterations\\\\n            for (x = uint256(count); x > 0; x = x >> 1) {\\\\n                if ((x & 1) == 1) {\\\\n                    // first hash is special case\\\\n                    // inbox stores the root of complete subtrees\\\\n                    // eg if count = 4 = 0b100, then the first complete subtree is inbox[2]\\\\n                    // inbox = [H(3), H(1,2), H(1,4)], we read inbox[2] directly\\\\n\\\\n                    stateRoot = inbox[height];\\\\n                    break;\\\\n                }\\\\n                height++;\\\\n            }\\\\n\\\\n            // after the first hash, we can calculate the root incrementally\\\\n            for (x = x >> 1; x > 0; x = x >> 1) {\\\\n                height++;\\\\n                if ((x & 1) == 1) {\\\\n                    // sort sibling hashes as a convention for efficient proof validation\\\\n                    stateRoot = sortConcatAndHash(inbox[height], stateRoot);\\\\n                }\\\\n            }\\\\n        }\\\\n\\\\n        snapshots[epoch] = stateRoot;\\\\n\\\\n        emit SnapshotSaved(stateRoot, epoch, count);\\\\n    }\\\\n\\\\n    /// @dev Helper function to calculate merkle tree interior nodes by sorting and concatenating and hashing a pair of children nodes, left and right.\\\\n    /// Note: EVM scratch space is used to efficiently calculate hashes.\\\\n    /// @param _left The left hash.\\\\n    /// @param _right The right hash.\\\\n    /// @return parent The parent hash.\\\\n    function sortConcatAndHash(bytes32 _left, bytes32 _right) internal pure returns (bytes32 parent) {\\\\n        // sort sibling hashes as a convention for efficient proof validation\\\\n        if (_left < _right) {\\\\n            // efficient hash using EVM scratch space\\\\n            assembly {\\\\n                mstore(0x00, _left)\\\\n                mstore(0x20, _right)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        } else {\\\\n            assembly {\\\\n                mstore(0x00, _right)\\\\n                mstore(0x20, _left)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the state root snapshot using Arbitrum's canonical bridge.\\\\n    /// @param _epoch The epoch of the snapshot requested to send.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function sendSnapshot(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        unchecked {\\\\n            require(_epoch < block.timestamp / epochPeriod, \\\\\\\"Can only send past epoch snapshot.\\\\\\\");\\\\n        }\\\\n\\\\n        bytes memory data = abi.encodeCall(IVeaOutboxOnL1.resolveDisputedClaim, (_epoch, snapshots[_epoch], _claim));\\\\n\\\\n        // Arbitrum -> Ethereum message with native bridge\\\\n        // docs: https://developer.arbitrum.io/for-devs/cross-chain-messsaging#arbitrum-to-ethereum-messaging\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/arbitrum/GreeterL2.sol#L25\\\\n        bytes32 ticketID = bytes32(ARB_SYS.sendTxToL1(veaOutboxArbToEth, data));\\\\n\\\\n        emit SnapshotSent(_epoch, ticketID);\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the most recent epoch for which snapshots are finalized.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochFinalized() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    /// @dev Get the epoch from the inbox's point of view using timestamp.\\\\n    /// @param _timestamp The timestamp to calculate the epoch from.\\\\n    /// @return epoch The calculated epoch.\\\\n    function epochAt(uint256 _timestamp) external view returns (uint256 epoch) {\\\\n        epoch = _timestamp / epochPeriod;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x98fa5bf3c9f3ac3b742c2dcfa457412f0ce03a409c81ea97f35db5231bc2e661\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IArbSys.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/39ea5a163afc637e2706d9be29cf7a289c300d00/src/precompiles/ArbSys.sol\\\\n// https://arbiscan.io/address/0x0000000000000000000000000000000000000064#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\n///@title System level functionality\\\\n///@notice For use by contracts to interact with core L2-specific functionality.\\\\n///Precompiled contract that exists in every Arbitrum chain at address(100), 0x0000000000000000000000000000000000000064.\\\\ninterface IArbSys {\\\\n    /// @notice Send a transaction to L1\\\\n    /// @dev it is not possible to execute on the L1 any L2-to-L1 transaction which contains data\\\\n    /// to a contract address without any code (as enforced by the Bridge contract).\\\\n    /// @param destination recipient address on L1\\\\n    /// @param data (optional) calldata for L1 contract call\\\\n    /// @return a unique identifier for this L2-to-L1 transaction.\\\\n    function sendTxToL1(address destination, bytes calldata data) external payable returns (uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x62893c290f2797daa4aebbbb5eb9b2b1d5e7d622b02928b0198450da34bf6293\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/interfaces/inboxes/IVeaInbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IVeaInbox {\\\\n    /// @dev Sends an arbitrary message to receiving chain.\\\\n    /// Note: Calls authenticated by receiving gateway checking the sender argument.\\\\n    /// @param _to The cross-domain contract address which receives the message.\\\\n    /// @param _data The message data.\\\\n    /// @return msgId The index of the message in the inbox, as a message Id, needed to relay the message.\\\\n    function sendMessage(address _to, bytes calldata _data) external returns (uint64 msgId);\\\\n\\\\n    /// @dev Snapshots can be saved a maximum of once per epoch.\\\\n    ///      Saves snapshot of state root.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    function saveSnapshot() external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x035e770f7b6e434b07e14ffb3283e61584eac8563c93ca587e42aa7a85504d02\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\n\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _from The address of the contract on L2 that sent the message, used for authentication.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x6c9a39add549daa58bd882a3949212afa73cabc75bda99a97583545a1d7622da\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Inbox From Arbitrum to Ethereum. Note: This contract is deployed on Arbitrum.\",\"events\":{\"MessageSent(bytes)\":{\"details\":\"Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\",\"params\":{\"_nodeData\":\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\"}},\"SnapshotSaved(bytes32,uint256,uint64)\":{\"params\":{\"_count\":\"The count of messages in the merkle tree.\",\"_epoch\":\"The epoch of the snapshot.\",\"_snapshot\":\"The snapshot of the merkle tree state root.\"}},\"SnapshotSent(uint256,bytes32)\":{\"details\":\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\",\"params\":{\"_epochSent\":\"The epoch of the snapshot.\",\"_ticketId\":\"The ticketId of the L2->L1 message.\"}}},\"kind\":\"dev\",\"methods\":{\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_epochPeriod\":\"The duration in seconds between epochs.\",\"_veaOutboxArbToEth\":\"The veaOutbox on ethereum.\"}},\"epochAt(uint256)\":{\"details\":\"Get the epoch from the inbox's point of view using timestamp.\",\"params\":{\"_timestamp\":\"The timestamp to calculate the epoch from.\"},\"returns\":{\"epoch\":\"The calculated epoch.\"}},\"epochFinalized()\":{\"details\":\"Get the most recent epoch for which snapshots are finalized.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"saveSnapshot()\":{\"details\":\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\"},\"sendMessage(address,bytes)\":{\"details\":\"Sends an arbitrary message to Ethereum.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\",\"params\":{\"_data\":\"The message data for the receiving gateway.\",\"_to\":\"The address of the contract on the receiving chain which receives the calldata.\"},\"returns\":{\"_0\":\"msgId The zero based index of the message in the inbox.\"}},\"sendSnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the state root snapshot using Arbitrum's canonical bridge.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the snapshot requested to send.\"}}},\"version\":1},\"userdoc\":{\"events\":{\"SnapshotSaved(bytes32,uint256,uint64)\":{\"notice\":\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\"}},\"kind\":\"user\",\"methods\":{},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":24,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"snapshots\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":28,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"inbox\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_array(t_bytes32)64_storage\"},{\"astId\":30,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"count\",\"offset\":0,\"slot\":\"65\",\"type\":\"t_uint64\"}],\"types\":{\"t_array(t_bytes32)64_storage\":{\"base\":\"t_bytes32\",\"encoding\":\"inplace\",\"label\":\"bytes32[64]\",\"numberOfBytes\":\"2048\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"},\"t_uint64\":{\"encoding\":\"inplace\",\"label\":\"uint64\",\"numberOfBytes\":\"8\"}}}}");


var $fa03f758eb972340$exports = {};
$fa03f758eb972340$exports = JSON.parse("{\"address\":\"0x60af9Fc1dd7d5bce69a66A8AEf456952b03A39C7\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_deposit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_minChallengePeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timeoutEpochs\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_veaInboxArbToEthDevnet\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_bridge\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_maxMissingBlocks\",\"type\":\"uint256\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_challenger\",\"type\":\"address\"}],\"name\":\"Challenged\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_claimer\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"Claimed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"FailedResolution\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"}],\"name\":\"MessageRelayed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_requestedSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitDecreaseRequested\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitUpdated\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"VerificationStarted\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"Verified\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"BURN_ADDRESS\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"bridge\",\"outputs\":[{\"internalType\":\"contract IBridge\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"burn\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"censorshipTestStatus\",\"outputs\":[{\"internalType\":\"enum VeaOutboxArbToEth.CensorshipTestStatus\",\"name\":\"status\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"},{\"internalType\":\"address\",\"name\":\"_withdrawalAddress\",\"type\":\"address\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_devnetOperator\",\"type\":\"address\"}],\"name\":\"changeDevnetOperator\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"claim\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"claimHashes\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"deposit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"depositPlusReward\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateroot\",\"type\":\"bytes32\"}],\"name\":\"devnetAdvanceState\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"devnetOperator\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"executeSequencerDelayLimitDecreaseRequest\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"hashClaim\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"hashedClaim\",\"type\":\"bytes32\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_msgId\",\"type\":\"uint256\"}],\"name\":\"isMsgRelayed\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"isRelayed\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"latestVerifiedEpoch\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"maxMissingBlocks\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"minChallengePeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"resolveDisputedClaim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes32[]\",\"name\":\"_proof\",\"type\":\"bytes32[]\"},{\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"},{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_from\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_message\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimitDecreaseRequest\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"requestedsequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"startVerification\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stateRoot\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeoutEpochs\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"updateSequencerDelayLimit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"veaInboxArbToEth\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"verifySnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengeDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"transactionHash\":\"0x8998be63a7a9a6a710b1b23280b1c744c28a7f28be6af429b0ff560f70c0a7fa\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0x60af9Fc1dd7d5bce69a66A8AEf456952b03A39C7\",\"transactionIndex\":129,\"gasUsed\":\"2561688\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000040000000000002000000000000000000000000000000000000000000000000000000000000000000000000000000000800000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000100000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x1aa6c8c8bf994e4388653d805baf9bde0ddd88e7d170ef8d96a4b92332976934\",\"transactionHash\":\"0x8998be63a7a9a6a710b1b23280b1c744c28a7f28be6af429b0ff560f70c0a7fa\",\"logs\":[{\"transactionIndex\":129,\"blockNumber\":9100952,\"transactionHash\":\"0x8998be63a7a9a6a710b1b23280b1c744c28a7f28be6af429b0ff560f70c0a7fa\",\"address\":\"0x60af9Fc1dd7d5bce69a66A8AEf456952b03A39C7\",\"topics\":[\"0x823e4a64a225e5e0cfa0d1aae07413331b43ea819eecd97f2cb0293ea048140d\"],\"data\":\"0x0000000000000000000000000000000000000000000000000000000000015180\",\"logIndex\":188,\"blockHash\":\"0x1aa6c8c8bf994e4388653d805baf9bde0ddd88e7d170ef8d96a4b92332976934\"}],\"blockNumber\":9100952,\"cumulativeGasUsed\":\"21022929\",\"status\":1,\"byzantium\":true},\"args\":[\"1000000000000000\",300,0,10000000000000,\"0x45138BC4E364A16919C4571699171d774A7590BD\",\"0x38f918D0E9F1b721EDaA41302E399fa1B79333a9\",10000000000000],\"numDeployments\":6,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_deposit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_minChallengePeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timeoutEpochs\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_veaInboxArbToEthDevnet\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_bridge\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_maxMissingBlocks\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"Challenged\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"Claimed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"FailedResolution\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"MessageRelayed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_requestedSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitDecreaseRequested\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitUpdated\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"VerificationStarted\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"Verified\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"BURN_ADDRESS\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"bridge\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IBridge\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"burn\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"censorshipTestStatus\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"enum VeaOutboxArbToEth.CensorshipTestStatus\\\",\\\"name\\\":\\\"status\\\",\\\"type\\\":\\\"uint8\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_withdrawalAddress\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_devnetOperator\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"changeDevnetOperator\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"claim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"claimHashes\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"deposit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"depositPlusReward\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateroot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"devnetAdvanceState\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"devnetOperator\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"executeSequencerDelayLimitDecreaseRequest\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"hashClaim\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"hashedClaim\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"pure\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"isMsgRelayed\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bool\\\",\\\"name\\\":\\\"isRelayed\\\",\\\"type\\\":\\\"bool\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"latestVerifiedEpoch\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"maxMissingBlocks\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"minChallengePeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"resolveDisputedClaim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"bytes32[]\\\",\\\"name\\\":\\\"_proof\\\",\\\"type\\\":\\\"bytes32[]\\\"},{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_from\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_message\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimitDecreaseRequest\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"requestedsequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"startVerification\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"stateRoot\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timeoutEpochs\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"updateSequencerDelayLimit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"veaInboxArbToEth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"verifySnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengeDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Outbox From arbitrumSepolia to Sepolia. Note: This contract is deployed on Sepolia. Note: This contract is permissioned for developer testing (devnet).\\\",\\\"events\\\":{\\\"Challenged(uint256,address)\\\":{\\\"details\\\":\\\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\",\\\"params\\\":{\\\"_challenger\\\":\\\"The address of the challenger.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenged claim.\\\"}},\\\"Claimed(address,uint256,bytes32)\\\":{\\\"details\\\":\\\"Watchers check this event to challenge fraud.\\\",\\\"params\\\":{\\\"_claimer\\\":\\\"The address of the claimer.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim.\\\",\\\"_stateRoot\\\":\\\"The state root of the claim.\\\"}},\\\"FailedResolution(uint256)\\\":{\\\"details\\\":\\\"This event indicates that a resolution has failed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which resolution failed.\\\"}},\\\"MessageRelayed(uint64)\\\":{\\\"details\\\":\\\"This event indicates that a message has been relayed.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId of the message that was relayed.\\\"}},\\\"SequencerDelayLimitDecreaseRequested(uint256)\\\":{\\\"details\\\":\\\"This event indicates that a request to decrease the sequencer limit has been made.\\\",\\\"params\\\":{\\\"_requestedSequencerDelayLimit\\\":\\\"The new sequencer delay limit requested.\\\"}},\\\"SequencerDelayLimitUpdated(uint256)\\\":{\\\"details\\\":\\\"This event indicates the sequencer limit updated.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The new sequencer delay limit.\\\"}},\\\"VerificationStarted(uint256)\\\":{\\\"details\\\":\\\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that started verification.\\\"}},\\\"Verified(uint256)\\\":{\\\"details\\\":\\\"This events indicates that verification has succeeded. The messages are ready to be relayed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that was verified.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Gets the status of the censorship test for claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to test.\\\"},\\\"returns\\\":{\\\"status\\\":\\\"True if the claim passed the censorship test.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address),address)\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.Allows proxy contracts to batch challenges.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\",\\\"_withdrawalAddress\\\":\\\"The address to withdraw the deposit + reward to.\\\"}},\\\"changeDevnetOperator(address)\\\":{\\\"details\\\":\\\"Changes the devnet operator.\\\",\\\"params\\\":{\\\"_devnetOperator\\\":\\\"The new testnet operator.\\\"}},\\\"claim(uint256,bytes32)\\\":{\\\"details\\\":\\\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateRoot\\\":\\\"The state root to claim.\\\"}},\\\"constructor\\\":{\\\"details\\\":\\\"Constructor.\\\",\\\"params\\\":{\\\"_deposit\\\":\\\"The deposit amount to submit a claim in wei.\\\",\\\"_epochPeriod\\\":\\\"The duration of each epoch.\\\",\\\"_maxMissingBlocks\\\":\\\"The maximum number of blocks that can be missing in a challenge period.\\\",\\\"_minChallengePeriod\\\":\\\"The minimum time window to challenge a claim.\\\",\\\"_timeoutEpochs\\\":\\\"The epochs before the bridge is considered shutdown.\\\",\\\"_veaInboxArbToEthDevnet\\\":\\\"The address of the inbox contract on Arbitrum.\\\"}},\\\"devnetAdvanceState(uint256,bytes32)\\\":{\\\"details\\\":\\\"Testnet operator utility function to claim, validate and withdraw.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateroot\\\":\\\"The state root to claim.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"executeSequencerDelayLimitDecreaseRequest()\\\":{\\\"details\\\":\\\"execute sequencerDelayLimitDecreaseRequest\\\"},\\\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Hashes the claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to hash.\\\"},\\\"returns\\\":{\\\"hashedClaim\\\":\\\"The hash of the claim.\\\"}},\\\"isMsgRelayed(uint256)\\\":{\\\"details\\\":\\\"Get the msg relayed status.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId to check.\\\"},\\\"returns\\\":{\\\"isRelayed\\\":\\\"True if the msg was relayed.\\\"}},\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves any challenge of the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch to verify.\\\",\\\"_stateRoot\\\":\\\"The true state root for the epoch.\\\"}},\\\"sendMessage(bytes32[],uint64,address,address,bytes)\\\":{\\\"details\\\":\\\"Verifies and relays the message. UNTRUSTED.\\\",\\\"params\\\":{\\\"_from\\\":\\\"The address of the contract on Arbitrum that sent the message.\\\",\\\"_message\\\":\\\"The message in the vea inbox.\\\",\\\"_msgId\\\":\\\"The zero based index of the message in the inbox.\\\",\\\"_proof\\\":\\\"The merkle proof to prove the message inclusion in the inbox state root.\\\",\\\"_to\\\":\\\"The address of the contract on Ethereum to call.\\\"}},\\\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Start verification for claim for 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"updateSequencerDelayLimit()\\\":{\\\"details\\\":\\\"Request to decrease the sequencerDelayLimit.\\\"},\\\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the optimistic claim.\\\"}},\\\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenge deposit to withraw.\\\"}},\\\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Bridger if their claim is not successfully challenged. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"notice\\\":\\\"Note: Access restricted to arbitrum  bridge.\\\"}},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol\\\":\\\"VeaOutboxArbToEthDevnet\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToEth/VeaOutboxArbToEth.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/ISequencerInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../canonical/arbitrum/IBridge.sol\\\\\\\";\\\\nimport \\\\\\\"../canonical/arbitrum/IOutbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/gateways/IReceiverGateway.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Ethereum.\\\\n/// Note: This contract is deployed on Ethereum.\\\\ncontract VeaOutboxArbToEth is IVeaOutboxOnL1 {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    IBridge public immutable bridge; // The address of the Arbitrum bridge contract.\\\\n    address public immutable veaInboxArbToEth; // The address of the vea inbox on arbitrum.\\\\n\\\\n    uint256 public immutable deposit; // The deposit in wei required to submit a claim or challenge\\\\n    uint256 public immutable burn; // The amount of wei to burn. deposit / 2\\\\n    uint256 public immutable depositPlusReward; // 2 * deposit - burn\\\\n\\\\n    address public constant BURN_ADDRESS = address(0); // Address to send burned eth\\\\n    uint256 internal constant SLOT_TIME = 12; // Ethereum 12 second slot time\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    uint256 public immutable minChallengePeriod; // Minimum time window to challenge a claim, even with a malicious sequencer.\\\\n\\\\n    uint256 public immutable timeoutEpochs; // The number of epochs without forward progress before the bridge is considered shutdown.\\\\n    uint256 public immutable maxMissingBlocks; // The maximum number of blocks that can be missing in a challenge period.\\\\n\\\\n    bytes32 public stateRoot; // merkle root of the outbox state\\\\n    uint256 public latestVerifiedEpoch; // The latest epoch that has been verified.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public claimHashes; // epoch => claim\\\\n    mapping(uint256 messageId => bytes32) internal relayed; // msgId/256 => packed replay bitmap, preferred over a simple boolean mapping to save 15k gas per message\\\\n\\\\n    uint256 public sequencerDelayLimit; // This is MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox, it is the maximum seconds the sequencer can backdate L2 txns relative to the L1 clock.\\\\n    SequencerDelayLimitDecreaseRequest public sequencerDelayLimitDecreaseRequest; // Decreasing the sequencerDelayLimit requires a delay to avoid griefing by sequencer, so we keep track of the request here.\\\\n\\\\n    struct SequencerDelayLimitDecreaseRequest {\\\\n        uint256 requestedsequencerDelayLimit;\\\\n        uint256 timestamp;\\\\n    }\\\\n\\\\n    enum CensorshipTestStatus {\\\\n        Failed,\\\\n        Passed,\\\\n        NotStarted,\\\\n        InProgress\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Watchers check this event to challenge fraud.\\\\n    /// @param _claimer The address of the claimer.\\\\n    /// @param _epoch The epoch associated with the claim.\\\\n    /// @param _stateRoot The state root of the claim.\\\\n    event Claimed(address indexed _claimer, uint256 indexed _epoch, bytes32 _stateRoot);\\\\n\\\\n    /// @dev This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\\n    /// @param _epoch The epoch associated with the challenged claim.\\\\n    /// @param _challenger The address of the challenger.\\\\n    event Challenged(uint256 indexed _epoch, address indexed _challenger);\\\\n\\\\n    /// @dev This event indicates that a message has been relayed.\\\\n    /// @param _msgId The msgId of the message that was relayed.\\\\n    event MessageRelayed(uint64 _msgId);\\\\n\\\\n    /// @dev This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\\n    /// @param _epoch The epoch that started verification.\\\\n    event VerificationStarted(uint256 indexed _epoch);\\\\n\\\\n    /// @dev This events indicates that verification has succeeded. The messages are ready to be relayed.\\\\n    /// @param _epoch The epoch that was verified.\\\\n    event Verified(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates that a resolution has failed.\\\\n    /// @param _epoch The epoch for which resolution failed.\\\\n    event FailedResolution(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates the sequencer limit updated.\\\\n    /// @param _newSequencerDelayLimit The new sequencer delay limit.\\\\n    event SequencerDelayLimitUpdated(uint256 _newSequencerDelayLimit);\\\\n\\\\n    /// @dev This event indicates that a request to decrease the sequencer limit has been made.\\\\n    /// @param _requestedSequencerDelayLimit The new sequencer delay limit requested.\\\\n    event SequencerDelayLimitDecreaseRequested(uint256 _requestedSequencerDelayLimit);\\\\n\\\\n    // ************************************* //\\\\n    // *        Function Modifiers         * //\\\\n    // ************************************* //\\\\n\\\\n    modifier OnlyBridgeRunning() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch <= timeoutEpochs, \\\\\\\"Bridge Shutdown.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    modifier OnlyBridgeShutdown() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch > timeoutEpochs, \\\\\\\"Bridge Running.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToEth contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _veaInboxArbToEth The address of the inbox contract on Arbitrum.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        address _veaInboxArbToEth,\\\\n        address _bridge,\\\\n        uint256 _maxMissingBlocks\\\\n    ) {\\\\n        deposit = _deposit;\\\\n        // epochPeriod must match the VeaInboxArbToEth contract deployment epochPeriod value.\\\\n        epochPeriod = _epochPeriod;\\\\n        minChallengePeriod = _minChallengePeriod;\\\\n        timeoutEpochs = _timeoutEpochs;\\\\n        veaInboxArbToEth = _veaInboxArbToEth;\\\\n        bridge = IBridge(_bridge);\\\\n        maxMissingBlocks = _maxMissingBlocks;\\\\n\\\\n        updateSequencerDelayLimit();\\\\n\\\\n        // claimant and challenger are not sybil resistant\\\\n        // must burn half deposit to prevent zero cost griefing\\\\n        burn = _deposit / 2;\\\\n        depositPlusReward = 2 * _deposit - burn;\\\\n\\\\n        latestVerifiedEpoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *        Parameter Updates          * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Request to decrease the sequencerDelayLimit.\\\\n    function updateSequencerDelayLimit() public {\\\\n        // the maximum asynchronous lag between the L2 and L1 clocks\\\\n        (, , uint256 newSequencerDelayLimit, ) = ISequencerInbox(bridge.sequencerInbox()).maxTimeVariation();\\\\n\\\\n        if (newSequencerDelayLimit > sequencerDelayLimit) {\\\\n            // For sequencerDelayLimit / epochPeriod > timeoutEpochs, claims cannot be verified by the timeout period and the bridge will shutdown.\\\\n            sequencerDelayLimit = newSequencerDelayLimit;\\\\n            emit SequencerDelayLimitUpdated(newSequencerDelayLimit);\\\\n        } else if (newSequencerDelayLimit < sequencerDelayLimit) {\\\\n            require(\\\\n                sequencerDelayLimitDecreaseRequest.timestamp == 0,\\\\n                \\\\\\\"Sequencer limit decrease request already pending.\\\\\\\"\\\\n            );\\\\n\\\\n            sequencerDelayLimitDecreaseRequest = SequencerDelayLimitDecreaseRequest({\\\\n                requestedsequencerDelayLimit: newSequencerDelayLimit,\\\\n                timestamp: block.timestamp\\\\n            });\\\\n\\\\n            emit SequencerDelayLimitDecreaseRequested(newSequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev execute sequencerDelayLimitDecreaseRequest\\\\n    function executeSequencerDelayLimitDecreaseRequest() external {\\\\n        require(sequencerDelayLimitDecreaseRequest.timestamp != 0, \\\\\\\"No pending sequencer limit decrease request.\\\\\\\");\\\\n        require(\\\\n            block.timestamp > sequencerDelayLimitDecreaseRequest.timestamp + sequencerDelayLimit,\\\\n            \\\\\\\"Sequencer limit decrease request is still pending.\\\\\\\"\\\\n        );\\\\n\\\\n        uint256 requestedsequencerDelayLimit = sequencerDelayLimitDecreaseRequest.requestedsequencerDelayLimit;\\\\n        delete sequencerDelayLimitDecreaseRequest;\\\\n\\\\n        (, , uint256 currentsequencerDelayLimit, ) = ISequencerInbox(bridge.sequencerInbox()).maxTimeVariation();\\\\n\\\\n        // check the request is still consistent with the arbiturm bridge\\\\n        if (currentsequencerDelayLimit == requestedsequencerDelayLimit) {\\\\n            sequencerDelayLimit = requestedsequencerDelayLimit;\\\\n            emit SequencerDelayLimitUpdated(requestedsequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) external payable virtual {\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient claim deposit.\\\\\\\");\\\\n        unchecked {\\\\n            require(_epoch == block.timestamp / epochPeriod - 1, \\\\\\\"Invalid epoch.\\\\\\\");\\\\n        }\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function challenge(uint256 _epoch, Claim memory _claim) external payable {\\\\n        _challenge(_epoch, _claim, msg.sender);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @dev Allows proxy contracts to batch challenges.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _withdrawalAddress The address to withdraw the deposit + reward to.\\\\n    function challenge(uint256 _epoch, Claim memory _claim, address _withdrawalAddress) external payable {\\\\n        _challenge(_epoch, _claim, _withdrawalAddress);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _withdrawAddress The address to withdraw the deposit + reward to.\\\\n    function _challenge(uint256 _epoch, Claim memory _claim, address _withdrawAddress) internal {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient challenge deposit.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim already challenged.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim already verified.\\\\\\\");\\\\n\\\\n        _claim.challenger = _withdrawAddress;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Challenged(_epoch, _withdrawAddress);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        // sequencerDelayLimit + epochPeriod is the worst case time to sync the L2 state compared to L1 clock.\\\\n        // using checked arithmetic incase arbitrum governance sets sequencerDelayLimit to a large value\\\\n        require(\\\\n            block.timestamp - uint256(_claim.timestampClaimed) >= sequencerDelayLimit + epochPeriod,\\\\n            \\\\\\\"Claim must wait atleast maxL2StateSyncDelay.\\\\\\\"\\\\n        );\\\\n\\\\n        CensorshipTestStatus _censorshipTestStatus = censorshipTestStatus(_claim);\\\\n        require(\\\\n            _censorshipTestStatus == CensorshipTestStatus.NotStarted ||\\\\n                _censorshipTestStatus == CensorshipTestStatus.Failed,\\\\n            \\\\\\\"Claim verification in progress or already completed.\\\\\\\"\\\\n        );\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) external virtual OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n        require(censorshipTestStatus(_claim) == CensorshipTestStatus.Passed, \\\\\\\"Censorship test not passed.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// Note: Access restricted to arbitrum  bridge.\\\\n    /// @dev Resolves any challenge of the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(\\\\n        uint256 _epoch,\\\\n        bytes32 _stateRoot,\\\\n        Claim memory _claim\\\\n    ) external virtual OnlyBridgeRunning {\\\\n        // Arbitrum -> Ethereum message sender authentication\\\\n        // docs: https://developer.arbitrum.io/arbos/l2-to-l1-messaging/\\\\n        // example: https://github.com/OpenZeppelin/openzeppelin-contracts/blob/dfef6a68ee18dbd2e1f5a099061a3b8a0e404485/contracts/crosschain/arbitrum/LibArbitrumL1.sol#L34\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/ethereum/GreeterL1.sol#L50\\\\n        // note: we call the bridge for the activeOutbox address\\\\n\\\\n        require(msg.sender == address(bridge), \\\\\\\"Not from native arbitrum bridge.\\\\\\\");\\\\n        require(IOutbox(bridge.activeOutbox()).l2ToL1Sender() == veaInboxArbToEth, \\\\\\\"veaInboxArbToEth only.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch && _stateRoot != bytes32(0)) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _stateRoot;\\\\n        }\\\\n\\\\n        if (claimHashes[_epoch] == hashClaim(_claim)) {\\\\n            if (_claim.stateRoot == _stateRoot) {\\\\n                _claim.honest = Party.Claimer;\\\\n            } else if (_claim.challenger != address(0)) {\\\\n                _claim.honest = Party.Challenger;\\\\n            }\\\\n            claimHashes[_epoch] = hashClaim(_claim);\\\\n            emit Verified(_epoch);\\\\n        } else {\\\\n            emit FailedResolution(_epoch);\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Verifies and relays the message. UNTRUSTED.\\\\n    /// @param _proof The merkle proof to prove the message inclusion in the inbox state root.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address of the contract on Ethereum to call.\\\\n    /// @param _from The address of the contract on Arbitrum that sent the message.\\\\n    /// @param _message The message in the vea inbox.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external {\\\\n        require(_proof.length < 64, \\\\\\\"Proof too long.\\\\\\\");\\\\n\\\\n        bytes32 nodeHash = keccak256(abi.encodePacked(_msgId, _to, _from, _message));\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            mstore(0x00, nodeHash)\\\\n            nodeHash := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        unchecked {\\\\n            for (uint256 i = 0; i < _proof.length; i++) {\\\\n                bytes32 proofElement = _proof[i];\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                if (proofElement > nodeHash)\\\\n                    assembly {\\\\n                        mstore(0x00, nodeHash)\\\\n                        mstore(0x20, proofElement)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n                else\\\\n                    assembly {\\\\n                        mstore(0x00, proofElement)\\\\n                        mstore(0x20, nodeHash)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n            }\\\\n        }\\\\n\\\\n        require(stateRoot == nodeHash, \\\\\\\"Invalid proof.\\\\\\\");\\\\n\\\\n        // msgId is the zero-based index of the message in the inbox.\\\\n        // msgId is also used as an index in the relayed bitmap to prevent replay.\\\\n        // Note: a bitmap is used instead of a simple boolean mapping to save 15k gas per message.\\\\n\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        require(((replay >> offset) & bytes32(uint256(1))) == bytes32(0), \\\\\\\"Message already relayed\\\\\\\");\\\\n        relayed[relayIndex] = replay | bytes32(1 << offset);\\\\n\\\\n        // UNTRUSTED.\\\\n        IReceiverGateway(_to).receiveMessage(_from, _message);\\\\n\\\\n        emit MessageRelayed(_msgId);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim calldata _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            payable(BURN_ADDRESS).send(burn);\\\\n            payable(_claim.claimer).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n        } else {\\\\n            payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\\n    /// @param _epoch The epoch associated with the challenge deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengeDeposit(uint256 _epoch, Claim calldata _claim) external {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Challenger, \\\\\\\"Challenge failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        payable(BURN_ADDRESS).send(burn); // half burnt\\\\n        payable(_claim.challenger).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.claimer != address(0)) {\\\\n            if (_claim.challenger == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n            } else {\\\\n                address claimer = _claim.claimer;\\\\n                _claim.claimer = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                payable(claimer).send(deposit); // User is responsible for accepting ETH.\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            if (_claim.claimer == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                payable(_claim.challenger).send(deposit); // User is responsible for accepting ETH.\\\\n            } else {\\\\n                address challenger = _claim.challenger;\\\\n                _claim.challenger = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                payable(challenger).send(deposit); // User is responsible for accepting ETH.\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Hashes the claim.\\\\n    /// @param _claim The claim to hash.\\\\n    /// @return hashedClaim The hash of the claim.\\\\n    function hashClaim(Claim memory _claim) public pure returns (bytes32 hashedClaim) {\\\\n        return\\\\n            hashedClaim = keccak256(\\\\n                abi.encodePacked(\\\\n                    _claim.stateRoot,\\\\n                    _claim.claimer,\\\\n                    _claim.timestampClaimed,\\\\n                    _claim.timestampVerification,\\\\n                    _claim.blocknumberVerification,\\\\n                    _claim.honest,\\\\n                    _claim.challenger\\\\n                )\\\\n            );\\\\n    }\\\\n\\\\n    /// @dev Gets the status of the censorship test for claim.\\\\n    /// @param _claim The claim to test.\\\\n    /// @return status True if the claim passed the censorship test.\\\\n    function censorshipTestStatus(Claim memory _claim) public view returns (CensorshipTestStatus status) {\\\\n        unchecked {\\\\n            if (uint256(_claim.timestampVerification) == 0) {\\\\n                status = CensorshipTestStatus.NotStarted;\\\\n            } else if (block.timestamp - uint256(_claim.timestampVerification) < minChallengePeriod) {\\\\n                status = CensorshipTestStatus.InProgress;\\\\n            } else {\\\\n                uint256 expectedBlocks = uint256(_claim.blocknumberVerification) +\\\\n                    (block.timestamp - uint256(_claim.timestampVerification)) /\\\\n                    SLOT_TIME;\\\\n                uint256 actualBlocks = block.number;\\\\n                if (expectedBlocks - actualBlocks <= maxMissingBlocks) {\\\\n                    status = CensorshipTestStatus.Passed;\\\\n                } else {\\\\n                    status = CensorshipTestStatus.Failed;\\\\n                }\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochAt(uint256 timestamp) external view returns (uint256 epoch) {\\\\n        epoch = timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the msg relayed status.\\\\n    /// @param _msgId The msgId to check.\\\\n    /// @return isRelayed True if the msg was relayed.\\\\n    function isMsgRelayed(uint256 _msgId) external view returns (bool isRelayed) {\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        isRelayed = (replay >> offset) & bytes32(uint256(1)) == bytes32(uint256(1));\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x94c0bf819839e0fb3e4a7f033246ec372ba556d76d6f790365f7fc955e02bf80\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IBridge.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/IBridge.sol\\\\n// proxy: https://etherscan.io/address/0x8315177aB297bA92A06054cE80a67Ed4DBd7ed3a\\\\n// implementation: https://etherscan.io/address/0x1066cecc8880948fe55e427e94f1ff221d626591#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IBridge {\\\\n    function activeOutbox() external view returns (address);\\\\n\\\\n    function sequencerInbox() external view returns (address);\\\\n\\\\n    function allowedDelayedInboxList(uint256) external returns (address);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x2efbba328710a6e47936917cbd8cbf6bf68a2470c3bcc5ea26cc04254ec99142\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/canonical/arbitrum/IOutbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/IBridge.sol\\\\n// proxy: https://etherscan.io/address/0x0B9857ae2D4A3DBe74ffE1d7DF045bb7F96E4840#code\\\\n// implementation: https://etherscan.io/address/0x0ea7372338a589e7f0b00e463a53aa464ef04e17#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IOutbox {\\\\n    /// @notice When l2ToL1Sender returns a nonzero address, the message was originated by an L2 account\\\\n    ///         When the return value is zero, that means this is a system message\\\\n    /// @dev the l2ToL1Sender behaves as the tx.origin, the msg.sender should be validated to protect against reentrancies\\\\n    function l2ToL1Sender() external view returns (address);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x05ae223a026cf735a62b19b18506463cda83804ea4257888216bb0e242629480\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/canonical/arbitrum/ISequencerInbox.sol\\\":{\\\"content\\\":\\\"// Copyright 2021-2022, Offchain Labs, Inc.\\\\n// For license information, see https://github.com/nitro/blob/master/LICENSE\\\\n// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/ISequencerInbox.sol\\\\n// proxy: https://etherscan.io/address/0x1c479675ad559DC151F6Ec7ed3FbF8ceE79582B6#code\\\\n// implementation: https://etherscan.io/address/0xD03bFe2CE83632F4E618a97299cc91B1335BB2d9#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"./IBridge.sol\\\\\\\";\\\\n\\\\ninterface ISequencerInbox {\\\\n    struct MaxTimeVariation {\\\\n        uint256 delayBlocks;\\\\n        uint256 futureBlocks;\\\\n        uint256 delaySeconds;\\\\n        uint256 futureSeconds;\\\\n    }\\\\n\\\\n    function maxTimeVariation() external view returns (uint256, uint256, uint256, uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xa5bea5a8c2fb9b8ab97143066b8a0764cd4dc4d6efebd04a2c708ba2ad1e315e\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../../arbitrumToEth/VeaOutboxArbToEth.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From arbitrumSepolia to Sepolia.\\\\n/// Note: This contract is deployed on Sepolia.\\\\n/// Note: This contract is permissioned for developer testing (devnet).\\\\ncontract VeaOutboxArbToEthDevnet is VeaOutboxArbToEth {\\\\n    address public devnetOperator; // permissioned devnet operator\\\\n\\\\n    /// @dev Requires that the sender is the devnet operator.\\\\n    modifier onlyByDevnetOperator() {\\\\n        require(devnetOperator == msg.sender);\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Changes the devnet operator.\\\\n    /// @param _devnetOperator The new testnet operator.\\\\n    function changeDevnetOperator(address _devnetOperator) external onlyByDevnetOperator {\\\\n        require(msg.sender == devnetOperator, \\\\\\\"Invalid Testnet Operator\\\\\\\");\\\\n        devnetOperator = _devnetOperator;\\\\n    }\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) public payable override onlyByDevnetOperator {\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient claim deposit.\\\\\\\");\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) public override onlyByDevnetOperator {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Bridger if their claim is not successfully challenged. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim memory _claim) public override {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            payable(BURN_ADDRESS).send(burn);\\\\n            payable(_claim.claimer).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n        } else {\\\\n            payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) public override OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Testnet operator utility function to claim, validate and withdraw.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateroot The state root to claim.\\\\n    function devnetAdvanceState(uint256 _epoch, bytes32 _stateroot) external payable {\\\\n        claim(_epoch, _stateroot);\\\\n        Claim memory claim = Claim({\\\\n            stateRoot: _stateroot,\\\\n            claimer: msg.sender,\\\\n            timestampClaimed: uint32(block.timestamp),\\\\n            timestampVerification: uint32(0),\\\\n            blocknumberVerification: uint32(0),\\\\n            honest: Party.None,\\\\n            challenger: address(0)\\\\n        });\\\\n        claim.timestampClaimed = uint32(block.timestamp);\\\\n        startVerification(_epoch, claim);\\\\n        claim.timestampVerification = uint32(block.timestamp);\\\\n        claim.blocknumberVerification = uint32(block.number);\\\\n        verifySnapshot(_epoch, claim);\\\\n        claim.honest = Party.Claimer;\\\\n        withdrawClaimDeposit(_epoch, claim);\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _veaInboxArbToEthDevnet The address of the inbox contract on Arbitrum.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        address _veaInboxArbToEthDevnet,\\\\n        address _bridge,\\\\n        uint256 _maxMissingBlocks\\\\n    )\\\\n        VeaOutboxArbToEth(\\\\n            _deposit,\\\\n            _epochPeriod,\\\\n            _minChallengePeriod,\\\\n            _timeoutEpochs,\\\\n            _veaInboxArbToEthDevnet,\\\\n            _bridge,\\\\n            _maxMissingBlocks\\\\n        )\\\\n    {\\\\n        devnetOperator = msg.sender;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x13b2137015e414ef3c3a397d007b355706873039fa25cf0b56ad8e8ccce0545c\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/gateways/IReceiverGateway.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IReceiverGateway {\\\\n    function veaOutbox() external view returns (address);\\\\n\\\\n    function senderGateway() external view returns (address);\\\\n\\\\n    function receiveMessage(address msgSender, bytes calldata msgData) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe6917520400ac49fc28bf32acb29cc115d1f97789ad798336d46a4bb7d35a9be\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\n\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _from The address of the contract on L2 that sent the message, used for authentication.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x6c9a39add549daa58bd882a3949212afa73cabc75bda99a97583545a1d7622da\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Outbox From arbitrumSepolia to Sepolia. Note: This contract is deployed on Sepolia. Note: This contract is permissioned for developer testing (devnet).\",\"events\":{\"Challenged(uint256,address)\":{\"details\":\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\",\"params\":{\"_challenger\":\"The address of the challenger.\",\"_epoch\":\"The epoch associated with the challenged claim.\"}},\"Claimed(address,uint256,bytes32)\":{\"details\":\"Watchers check this event to challenge fraud.\",\"params\":{\"_claimer\":\"The address of the claimer.\",\"_epoch\":\"The epoch associated with the claim.\",\"_stateRoot\":\"The state root of the claim.\"}},\"FailedResolution(uint256)\":{\"details\":\"This event indicates that a resolution has failed.\",\"params\":{\"_epoch\":\"The epoch for which resolution failed.\"}},\"MessageRelayed(uint64)\":{\"details\":\"This event indicates that a message has been relayed.\",\"params\":{\"_msgId\":\"The msgId of the message that was relayed.\"}},\"SequencerDelayLimitDecreaseRequested(uint256)\":{\"details\":\"This event indicates that a request to decrease the sequencer limit has been made.\",\"params\":{\"_requestedSequencerDelayLimit\":\"The new sequencer delay limit requested.\"}},\"SequencerDelayLimitUpdated(uint256)\":{\"details\":\"This event indicates the sequencer limit updated.\",\"params\":{\"_newSequencerDelayLimit\":\"The new sequencer delay limit.\"}},\"VerificationStarted(uint256)\":{\"details\":\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\",\"params\":{\"_epoch\":\"The epoch that started verification.\"}},\"Verified(uint256)\":{\"details\":\"This events indicates that verification has succeeded. The messages are ready to be relayed.\",\"params\":{\"_epoch\":\"The epoch that was verified.\"}}},\"kind\":\"dev\",\"methods\":{\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Gets the status of the censorship test for claim.\",\"params\":{\"_claim\":\"The claim to test.\"},\"returns\":{\"status\":\"True if the claim passed the censorship test.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address),address)\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.Allows proxy contracts to batch challenges.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\",\"_withdrawalAddress\":\"The address to withdraw the deposit + reward to.\"}},\"changeDevnetOperator(address)\":{\"details\":\"Changes the devnet operator.\",\"params\":{\"_devnetOperator\":\"The new testnet operator.\"}},\"claim(uint256,bytes32)\":{\"details\":\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateRoot\":\"The state root to claim.\"}},\"constructor\":{\"details\":\"Constructor.\",\"params\":{\"_deposit\":\"The deposit amount to submit a claim in wei.\",\"_epochPeriod\":\"The duration of each epoch.\",\"_maxMissingBlocks\":\"The maximum number of blocks that can be missing in a challenge period.\",\"_minChallengePeriod\":\"The minimum time window to challenge a claim.\",\"_timeoutEpochs\":\"The epochs before the bridge is considered shutdown.\",\"_veaInboxArbToEthDevnet\":\"The address of the inbox contract on Arbitrum.\"}},\"devnetAdvanceState(uint256,bytes32)\":{\"details\":\"Testnet operator utility function to claim, validate and withdraw.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateroot\":\"The state root to claim.\"}},\"epochAt(uint256)\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"executeSequencerDelayLimitDecreaseRequest()\":{\"details\":\"execute sequencerDelayLimitDecreaseRequest\"},\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Hashes the claim.\",\"params\":{\"_claim\":\"The claim to hash.\"},\"returns\":{\"hashedClaim\":\"The hash of the claim.\"}},\"isMsgRelayed(uint256)\":{\"details\":\"Get the msg relayed status.\",\"params\":{\"_msgId\":\"The msgId to check.\"},\"returns\":{\"isRelayed\":\"True if the msg was relayed.\"}},\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves any challenge of the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch to verify.\",\"_stateRoot\":\"The true state root for the epoch.\"}},\"sendMessage(bytes32[],uint64,address,address,bytes)\":{\"details\":\"Verifies and relays the message. UNTRUSTED.\",\"params\":{\"_from\":\"The address of the contract on Arbitrum that sent the message.\",\"_message\":\"The message in the vea inbox.\",\"_msgId\":\"The zero based index of the message in the inbox.\",\"_proof\":\"The merkle proof to prove the message inclusion in the inbox state root.\",\"_to\":\"The address of the contract on Ethereum to call.\"}},\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Start verification for claim for 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"updateSequencerDelayLimit()\":{\"details\":\"Request to decrease the sequencerDelayLimit.\"},\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the optimistic claim.\"}},\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the challenge deposit to withraw.\"}},\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Bridger if their claim is not successfully challenged. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"notice\":\"Note: Access restricted to arbitrum  bridge.\"}},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":432,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"stateRoot\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_bytes32\"},{\"astId\":434,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"latestVerifiedEpoch\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"},{\"astId\":438,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"claimHashes\",\"offset\":0,\"slot\":\"2\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":442,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"relayed\",\"offset\":0,\"slot\":\"3\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":444,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"sequencerDelayLimit\",\"offset\":0,\"slot\":\"4\",\"type\":\"t_uint256\"},{\"astId\":447,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"sequencerDelayLimitDecreaseRequest\",\"offset\":0,\"slot\":\"5\",\"type\":\"t_struct(SequencerDelayLimitDecreaseRequest)452_storage\"},{\"astId\":4239,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"devnetOperator\",\"offset\":0,\"slot\":\"7\",\"type\":\"t_address\"}],\"types\":{\"t_address\":{\"encoding\":\"inplace\",\"label\":\"address\",\"numberOfBytes\":\"20\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_struct(SequencerDelayLimitDecreaseRequest)452_storage\":{\"encoding\":\"inplace\",\"label\":\"struct VeaOutboxArbToEth.SequencerDelayLimitDecreaseRequest\",\"members\":[{\"astId\":449,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"requestedsequencerDelayLimit\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_uint256\"},{\"astId\":451,\"contract\":\"src/devnets/arbitrumToEth/VeaOutboxArbToEthDevnet.sol:VeaOutboxArbToEthDevnet\",\"label\":\"timestamp\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"}],\"numberOfBytes\":\"64\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"}}}}");


var $47fba1a8bf088cdf$exports = {};
$47fba1a8bf088cdf$exports = JSON.parse("{\"address\":\"0x8B925669606026CcCfAFD72840F5b0CAeDA80078\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_veaOutboxArbToEth\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes\",\"name\":\"_nodeData\",\"type\":\"bytes\"}],\"name\":\"MessageSent\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_snapshot\",\"type\":\"bytes32\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_count\",\"type\":\"uint64\"}],\"name\":\"SnapshotSaved\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epochSent\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_ticketId\",\"type\":\"bytes32\"}],\"name\":\"SnapshotSent\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"count\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochFinalized\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"saveSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_data\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"sendSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"snapshots\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"veaOutboxArbToEth\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"transactionHash\":\"0xbb6f7b01c061c5929e2ad6b72d5f1c7b84c7ccda6095bb34b2f603eb33146ecf\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0x8B925669606026CcCfAFD72840F5b0CAeDA80078\",\"transactionIndex\":27,\"gasUsed\":\"793355\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x81354c3e69e862d5bf0f5c712570c0ac19efd8744a5b10b3a58e5afa145e9b76\",\"transactionHash\":\"0xbb6f7b01c061c5929e2ad6b72d5f1c7b84c7ccda6095bb34b2f603eb33146ecf\",\"logs\":[],\"blockNumber\":189388217,\"cumulativeGasUsed\":\"27736779\",\"status\":1,\"byzantium\":true},\"args\":[7200,\"0xf720FA4575FB2FE96c7f05B1b5abc2d281cDa09a\"],\"numDeployments\":3,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_veaOutboxArbToEth\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_nodeData\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"MessageSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_snapshot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_count\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"SnapshotSaved\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochSent\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_ticketId\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"SnapshotSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"count\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochFinalized\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"saveSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_data\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"sendSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"snapshots\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"veaOutboxArbToEth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Inbox From Arbitrum to Ethereum. Note: This contract is deployed on Arbitrum.\\\",\\\"events\\\":{\\\"MessageSent(bytes)\\\":{\\\"details\\\":\\\"Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\\\",\\\"params\\\":{\\\"_nodeData\\\":\\\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\"}},\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"params\\\":{\\\"_count\\\":\\\"The count of messages in the merkle tree.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot.\\\",\\\"_snapshot\\\":\\\"The snapshot of the merkle tree state root.\\\"}},\\\"SnapshotSent(uint256,bytes32)\\\":{\\\"details\\\":\\\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\",\\\"params\\\":{\\\"_epochSent\\\":\\\"The epoch of the snapshot.\\\",\\\"_ticketId\\\":\\\"The ticketId of the L2->L1 message.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_epochPeriod\\\":\\\"The duration in seconds between epochs.\\\",\\\"_veaOutboxArbToEth\\\":\\\"The veaOutbox on ethereum.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the epoch from the inbox's point of view using timestamp.\\\",\\\"params\\\":{\\\"_timestamp\\\":\\\"The timestamp to calculate the epoch from.\\\"},\\\"returns\\\":{\\\"epoch\\\":\\\"The calculated epoch.\\\"}},\\\"epochFinalized()\\\":{\\\"details\\\":\\\"Get the most recent epoch for which snapshots are finalized.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"saveSnapshot()\\\":{\\\"details\\\":\\\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\\\"},\\\"sendMessage(address,bytes)\\\":{\\\"details\\\":\\\"Sends an arbitrary message to Ethereum.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\\\",\\\"params\\\":{\\\"_data\\\":\\\"The message data for the receiving gateway.\\\",\\\"_to\\\":\\\"The address of the contract on the receiving chain which receives the calldata.\\\"},\\\"returns\\\":{\\\"_0\\\":\\\"msgId The zero based index of the message in the inbox.\\\"}},\\\"sendSnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the state root snapshot using Arbitrum's canonical bridge.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot requested to send.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"events\\\":{\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"notice\\\":\\\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\"}},\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToEth/VeaInboxArbToEth.sol\\\":\\\"VeaInboxArbToEth\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToEth/VeaInboxArbToEth.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/IArbSys.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/inboxes/IVeaInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Inbox From Arbitrum to Ethereum.\\\\n/// Note: This contract is deployed on Arbitrum.\\\\ncontract VeaInboxArbToEth is IVeaInbox {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    // Arbitrum precompile ArbSys for L2->L1 messaging: https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n    IArbSys internal constant ARB_SYS = IArbSys(address(100));\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    address public immutable veaOutboxArbToEth; // The vea outbox on ethereum.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public snapshots; // epoch => state root snapshot\\\\n\\\\n    // Inbox represents minimum data availability to maintain incremental merkle tree.\\\\n    // Supports a max of 2^64 - 1 messages. See merkle tree docs for details how inbox manages state.\\\\n\\\\n    bytes32[64] internal inbox; // stores minimal set of complete subtree roots of the merkle tree to increment.\\\\n    uint64 public count; // count of messages in the merkle tree\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\\\\n    /// @param _nodeData The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\\n    event MessageSent(bytes _nodeData);\\\\n\\\\n    /// The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\\n    /// @param _snapshot The snapshot of the merkle tree state root.\\\\n    /// @param _epoch The epoch of the snapshot.\\\\n    /// @param _count The count of messages in the merkle tree.\\\\n    event SnapshotSaved(bytes32 _snapshot, uint256 _epoch, uint64 _count);\\\\n\\\\n    /// @dev The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\\n    /// @param _epochSent The epoch of the snapshot.\\\\n    /// @param _ticketId The ticketId of the L2->L1 message.\\\\n    event SnapshotSent(uint256 indexed _epochSent, bytes32 _ticketId);\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _epochPeriod The duration in seconds between epochs.\\\\n    /// @param _veaOutboxArbToEth The veaOutbox on ethereum.\\\\n    constructor(uint256 _epochPeriod, address _veaOutboxArbToEth) {\\\\n        epochPeriod = _epochPeriod;\\\\n        veaOutboxArbToEth = _veaOutboxArbToEth;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Sends an arbitrary message to Ethereum.\\\\n    ///      `O(log(count))` where count is the number of messages already sent.\\\\n    ///      Amortized cost is constant.\\\\n    /// Note: See docs for details how inbox manages merkle tree state.\\\\n    /// @param _to The address of the contract on the receiving chain which receives the calldata.\\\\n    /// @param _data The message data for the receiving gateway.\\\\n    /// @return msgId The zero based index of the message in the inbox.\\\\n    function sendMessage(address _to, bytes calldata _data) external override returns (uint64) {\\\\n        uint64 oldCount = count;\\\\n\\\\n        // Given arbitrum's speed limit of 7 million gas / second, it would take atleast 8 million years of full blocks to overflow.\\\\n        // It *should* be impossible to overflow, but we check to be safe when appending to the tree.\\\\n        require(oldCount < type(uint64).max, \\\\\\\"Inbox is full.\\\\\\\");\\\\n\\\\n        bytes memory nodeData = abi.encodePacked(oldCount, _to, msg.sender, _data);\\\\n\\\\n        // single hashed leaf\\\\n        bytes32 newInboxNode = keccak256(nodeData);\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            // efficient hash using EVM scratch space\\\\n            mstore(0x00, newInboxNode)\\\\n            newInboxNode := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        // increment merkle tree calculating minimal number of hashes\\\\n        unchecked {\\\\n            uint256 height;\\\\n\\\\n            // x = oldCount + 1; acts as a bit mask to determine if a hash is needed\\\\n            // note: x is always non-zero, and x is bit shifted to the right each loop\\\\n            // hence this loop will always terminate in a maximum of log_2(oldCount + 1) iterations\\\\n            for (uint64 x = oldCount + 1; x & 1 == 0; x = x >> 1) {\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                newInboxNode = sortConcatAndHash(inbox[height], newInboxNode);\\\\n                height++;\\\\n            }\\\\n\\\\n            inbox[height] = newInboxNode;\\\\n\\\\n            // finally increment count\\\\n            count = oldCount + 1;\\\\n        }\\\\n\\\\n        emit MessageSent(nodeData);\\\\n\\\\n        // old count is the zero indexed leaf position in the tree, acts as a msgId\\\\n        // gateways should index these msgIds to later relay proofs\\\\n        return oldCount;\\\\n    }\\\\n\\\\n    /// @dev Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    /// Note: See merkle tree docs for details how inbox manages state.\\\\n    function saveSnapshot() external {\\\\n        uint256 epoch;\\\\n        bytes32 stateRoot;\\\\n\\\\n        unchecked {\\\\n            epoch = block.timestamp / epochPeriod;\\\\n\\\\n            // calculate the current root of the incremental merkle tree encoded in the inbox\\\\n\\\\n            uint256 height;\\\\n\\\\n            // x acts as a bit mask to determine if the hash stored in the inbox contributes to the root\\\\n            uint256 x;\\\\n\\\\n            // x is bit shifted to the right each loop, hence this loop will always terminate in a maximum of log_2(count) iterations\\\\n            for (x = uint256(count); x > 0; x = x >> 1) {\\\\n                if ((x & 1) == 1) {\\\\n                    // first hash is special case\\\\n                    // inbox stores the root of complete subtrees\\\\n                    // eg if count = 4 = 0b100, then the first complete subtree is inbox[2]\\\\n                    // inbox = [H(3), H(1,2), H(1,4)], we read inbox[2] directly\\\\n\\\\n                    stateRoot = inbox[height];\\\\n                    break;\\\\n                }\\\\n                height++;\\\\n            }\\\\n\\\\n            // after the first hash, we can calculate the root incrementally\\\\n            for (x = x >> 1; x > 0; x = x >> 1) {\\\\n                height++;\\\\n                if ((x & 1) == 1) {\\\\n                    // sort sibling hashes as a convention for efficient proof validation\\\\n                    stateRoot = sortConcatAndHash(inbox[height], stateRoot);\\\\n                }\\\\n            }\\\\n        }\\\\n\\\\n        snapshots[epoch] = stateRoot;\\\\n\\\\n        emit SnapshotSaved(stateRoot, epoch, count);\\\\n    }\\\\n\\\\n    /// @dev Helper function to calculate merkle tree interior nodes by sorting and concatenating and hashing a pair of children nodes, left and right.\\\\n    /// Note: EVM scratch space is used to efficiently calculate hashes.\\\\n    /// @param _left The left hash.\\\\n    /// @param _right The right hash.\\\\n    /// @return parent The parent hash.\\\\n    function sortConcatAndHash(bytes32 _left, bytes32 _right) internal pure returns (bytes32 parent) {\\\\n        // sort sibling hashes as a convention for efficient proof validation\\\\n        if (_left < _right) {\\\\n            // efficient hash using EVM scratch space\\\\n            assembly {\\\\n                mstore(0x00, _left)\\\\n                mstore(0x20, _right)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        } else {\\\\n            assembly {\\\\n                mstore(0x00, _right)\\\\n                mstore(0x20, _left)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the state root snapshot using Arbitrum's canonical bridge.\\\\n    /// @param _epoch The epoch of the snapshot requested to send.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function sendSnapshot(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        unchecked {\\\\n            require(_epoch < block.timestamp / epochPeriod, \\\\\\\"Can only send past epoch snapshot.\\\\\\\");\\\\n        }\\\\n\\\\n        bytes memory data = abi.encodeCall(IVeaOutboxOnL1.resolveDisputedClaim, (_epoch, snapshots[_epoch], _claim));\\\\n\\\\n        // Arbitrum -> Ethereum message with native bridge\\\\n        // docs: https://developer.arbitrum.io/for-devs/cross-chain-messsaging#arbitrum-to-ethereum-messaging\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/arbitrum/GreeterL2.sol#L25\\\\n        bytes32 ticketID = bytes32(ARB_SYS.sendTxToL1(veaOutboxArbToEth, data));\\\\n\\\\n        emit SnapshotSent(_epoch, ticketID);\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the most recent epoch for which snapshots are finalized.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochFinalized() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    /// @dev Get the epoch from the inbox's point of view using timestamp.\\\\n    /// @param _timestamp The timestamp to calculate the epoch from.\\\\n    /// @return epoch The calculated epoch.\\\\n    function epochAt(uint256 _timestamp) external view returns (uint256 epoch) {\\\\n        epoch = _timestamp / epochPeriod;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x98fa5bf3c9f3ac3b742c2dcfa457412f0ce03a409c81ea97f35db5231bc2e661\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IArbSys.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/39ea5a163afc637e2706d9be29cf7a289c300d00/src/precompiles/ArbSys.sol\\\\n// https://arbiscan.io/address/0x0000000000000000000000000000000000000064#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\n///@title System level functionality\\\\n///@notice For use by contracts to interact with core L2-specific functionality.\\\\n///Precompiled contract that exists in every Arbitrum chain at address(100), 0x0000000000000000000000000000000000000064.\\\\ninterface IArbSys {\\\\n    /// @notice Send a transaction to L1\\\\n    /// @dev it is not possible to execute on the L1 any L2-to-L1 transaction which contains data\\\\n    /// to a contract address without any code (as enforced by the Bridge contract).\\\\n    /// @param destination recipient address on L1\\\\n    /// @param data (optional) calldata for L1 contract call\\\\n    /// @return a unique identifier for this L2-to-L1 transaction.\\\\n    function sendTxToL1(address destination, bytes calldata data) external payable returns (uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x62893c290f2797daa4aebbbb5eb9b2b1d5e7d622b02928b0198450da34bf6293\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/interfaces/inboxes/IVeaInbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IVeaInbox {\\\\n    /// @dev Sends an arbitrary message to receiving chain.\\\\n    /// Note: Calls authenticated by receiving gateway checking the sender argument.\\\\n    /// @param _to The cross-domain contract address which receives the message.\\\\n    /// @param _data The message data.\\\\n    /// @return msgId The index of the message in the inbox, as a message Id, needed to relay the message.\\\\n    function sendMessage(address _to, bytes calldata _data) external returns (uint64 msgId);\\\\n\\\\n    /// @dev Snapshots can be saved a maximum of once per epoch.\\\\n    ///      Saves snapshot of state root.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    function saveSnapshot() external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x035e770f7b6e434b07e14ffb3283e61584eac8563c93ca587e42aa7a85504d02\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\n\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _from The address of the contract on L2 that sent the message, used for authentication.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x6c9a39add549daa58bd882a3949212afa73cabc75bda99a97583545a1d7622da\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Inbox From Arbitrum to Ethereum. Note: This contract is deployed on Arbitrum.\",\"events\":{\"MessageSent(bytes)\":{\"details\":\"Relayers watch for these events to construct merkle proofs to execute transactions on Ethereum.\",\"params\":{\"_nodeData\":\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\"}},\"SnapshotSaved(bytes32,uint256,uint64)\":{\"params\":{\"_count\":\"The count of messages in the merkle tree.\",\"_epoch\":\"The epoch of the snapshot.\",\"_snapshot\":\"The snapshot of the merkle tree state root.\"}},\"SnapshotSent(uint256,bytes32)\":{\"details\":\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\",\"params\":{\"_epochSent\":\"The epoch of the snapshot.\",\"_ticketId\":\"The ticketId of the L2->L1 message.\"}}},\"kind\":\"dev\",\"methods\":{\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaOutboxArbToEth contract deployment on Ethereum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_epochPeriod\":\"The duration in seconds between epochs.\",\"_veaOutboxArbToEth\":\"The veaOutbox on ethereum.\"}},\"epochAt(uint256)\":{\"details\":\"Get the epoch from the inbox's point of view using timestamp.\",\"params\":{\"_timestamp\":\"The timestamp to calculate the epoch from.\"},\"returns\":{\"epoch\":\"The calculated epoch.\"}},\"epochFinalized()\":{\"details\":\"Get the most recent epoch for which snapshots are finalized.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"saveSnapshot()\":{\"details\":\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\"},\"sendMessage(address,bytes)\":{\"details\":\"Sends an arbitrary message to Ethereum.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\",\"params\":{\"_data\":\"The message data for the receiving gateway.\",\"_to\":\"The address of the contract on the receiving chain which receives the calldata.\"},\"returns\":{\"_0\":\"msgId The zero based index of the message in the inbox.\"}},\"sendSnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the state root snapshot using Arbitrum's canonical bridge.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the snapshot requested to send.\"}}},\"version\":1},\"userdoc\":{\"events\":{\"SnapshotSaved(bytes32,uint256,uint64)\":{\"notice\":\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\"}},\"kind\":\"user\",\"methods\":{},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":24,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"snapshots\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":28,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"inbox\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_array(t_bytes32)64_storage\"},{\"astId\":30,\"contract\":\"src/arbitrumToEth/VeaInboxArbToEth.sol:VeaInboxArbToEth\",\"label\":\"count\",\"offset\":0,\"slot\":\"65\",\"type\":\"t_uint64\"}],\"types\":{\"t_array(t_bytes32)64_storage\":{\"base\":\"t_bytes32\",\"encoding\":\"inplace\",\"label\":\"bytes32[64]\",\"numberOfBytes\":\"2048\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"},\"t_uint64\":{\"encoding\":\"inplace\",\"label\":\"uint64\",\"numberOfBytes\":\"8\"}}}}");


var $fdec65adcbe51676$exports = {};
$fdec65adcbe51676$exports = JSON.parse("{\"address\":\"0xf720FA4575FB2FE96c7f05B1b5abc2d281cDa09a\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_deposit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_minChallengePeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timeoutEpochs\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_veaInboxArbToEth\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_bridge\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_maxMissingBlocks\",\"type\":\"uint256\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_challenger\",\"type\":\"address\"}],\"name\":\"Challenged\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_claimer\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"Claimed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"FailedResolution\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"}],\"name\":\"MessageRelayed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_requestedSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitDecreaseRequested\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitUpdated\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"VerificationStarted\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"Verified\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"BURN_ADDRESS\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"bridge\",\"outputs\":[{\"internalType\":\"contract IBridge\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"burn\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"censorshipTestStatus\",\"outputs\":[{\"internalType\":\"enum VeaOutboxArbToEth.CensorshipTestStatus\",\"name\":\"status\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"},{\"internalType\":\"address\",\"name\":\"_withdrawalAddress\",\"type\":\"address\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"claim\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"claimHashes\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"deposit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"depositPlusReward\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"executeSequencerDelayLimitDecreaseRequest\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"hashClaim\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"hashedClaim\",\"type\":\"bytes32\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_msgId\",\"type\":\"uint256\"}],\"name\":\"isMsgRelayed\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"isRelayed\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"latestVerifiedEpoch\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"maxMissingBlocks\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"minChallengePeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"resolveDisputedClaim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes32[]\",\"name\":\"_proof\",\"type\":\"bytes32[]\"},{\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"},{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_from\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_message\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimitDecreaseRequest\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"requestedsequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"startVerification\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stateRoot\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeoutEpochs\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"updateSequencerDelayLimit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"veaInboxArbToEth\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"verifySnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengeDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"transactionHash\":\"0x4d743955bca272ac992011cd53d971c1581fd4b2a5064941f6582108d0e02f06\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0xf720FA4575FB2FE96c7f05B1b5abc2d281cDa09a\",\"transactionIndex\":47,\"gasUsed\":\"2437845\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000040000000004000000000000100000000000000000000000000002000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000008000000000000000000000000000000000000000000000000000000000000000000000001000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x98c30e8981f81af6a13241ec2506f60e9a39f72347ab0a00aa75d5e893ba3731\",\"transactionHash\":\"0x4d743955bca272ac992011cd53d971c1581fd4b2a5064941f6582108d0e02f06\",\"logs\":[{\"transactionIndex\":47,\"blockNumber\":9100938,\"transactionHash\":\"0x4d743955bca272ac992011cd53d971c1581fd4b2a5064941f6582108d0e02f06\",\"address\":\"0xf720FA4575FB2FE96c7f05B1b5abc2d281cDa09a\",\"topics\":[\"0x823e4a64a225e5e0cfa0d1aae07413331b43ea819eecd97f2cb0293ea048140d\"],\"data\":\"0x0000000000000000000000000000000000000000000000000000000000015180\",\"logIndex\":89,\"blockHash\":\"0x98c30e8981f81af6a13241ec2506f60e9a39f72347ab0a00aa75d5e893ba3731\"}],\"blockNumber\":9100938,\"cumulativeGasUsed\":\"6825642\",\"status\":1,\"byzantium\":true},\"args\":[\"1000000000000000000\",7200,10800,1000000,\"0x8B925669606026CcCfAFD72840F5b0CAeDA80078\",\"0x38f918D0E9F1b721EDaA41302E399fa1B79333a9\",1000000],\"numDeployments\":3,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_deposit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_minChallengePeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timeoutEpochs\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_veaInboxArbToEth\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_bridge\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_maxMissingBlocks\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"Challenged\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"Claimed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"FailedResolution\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"MessageRelayed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_requestedSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitDecreaseRequested\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitUpdated\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"VerificationStarted\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"Verified\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"BURN_ADDRESS\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"bridge\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IBridge\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"burn\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"censorshipTestStatus\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"enum VeaOutboxArbToEth.CensorshipTestStatus\\\",\\\"name\\\":\\\"status\\\",\\\"type\\\":\\\"uint8\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_withdrawalAddress\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"claim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"claimHashes\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"deposit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"depositPlusReward\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"executeSequencerDelayLimitDecreaseRequest\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"hashClaim\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"hashedClaim\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"pure\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"isMsgRelayed\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bool\\\",\\\"name\\\":\\\"isRelayed\\\",\\\"type\\\":\\\"bool\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"latestVerifiedEpoch\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"maxMissingBlocks\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"minChallengePeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"resolveDisputedClaim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"bytes32[]\\\",\\\"name\\\":\\\"_proof\\\",\\\"type\\\":\\\"bytes32[]\\\"},{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_from\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_message\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimitDecreaseRequest\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"requestedsequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"startVerification\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"stateRoot\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timeoutEpochs\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"updateSequencerDelayLimit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"veaInboxArbToEth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"verifySnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengeDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Outbox From Arbitrum to Ethereum. Note: This contract is deployed on Ethereum.\\\",\\\"events\\\":{\\\"Challenged(uint256,address)\\\":{\\\"details\\\":\\\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\",\\\"params\\\":{\\\"_challenger\\\":\\\"The address of the challenger.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenged claim.\\\"}},\\\"Claimed(address,uint256,bytes32)\\\":{\\\"details\\\":\\\"Watchers check this event to challenge fraud.\\\",\\\"params\\\":{\\\"_claimer\\\":\\\"The address of the claimer.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim.\\\",\\\"_stateRoot\\\":\\\"The state root of the claim.\\\"}},\\\"FailedResolution(uint256)\\\":{\\\"details\\\":\\\"This event indicates that a resolution has failed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which resolution failed.\\\"}},\\\"MessageRelayed(uint64)\\\":{\\\"details\\\":\\\"This event indicates that a message has been relayed.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId of the message that was relayed.\\\"}},\\\"SequencerDelayLimitDecreaseRequested(uint256)\\\":{\\\"details\\\":\\\"This event indicates that a request to decrease the sequencer limit has been made.\\\",\\\"params\\\":{\\\"_requestedSequencerDelayLimit\\\":\\\"The new sequencer delay limit requested.\\\"}},\\\"SequencerDelayLimitUpdated(uint256)\\\":{\\\"details\\\":\\\"This event indicates the sequencer limit updated.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The new sequencer delay limit.\\\"}},\\\"VerificationStarted(uint256)\\\":{\\\"details\\\":\\\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that started verification.\\\"}},\\\"Verified(uint256)\\\":{\\\"details\\\":\\\"This events indicates that verification has succeeded. The messages are ready to be relayed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that was verified.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Gets the status of the censorship test for claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to test.\\\"},\\\"returns\\\":{\\\"status\\\":\\\"True if the claim passed the censorship test.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address),address)\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.Allows proxy contracts to batch challenges.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\",\\\"_withdrawalAddress\\\":\\\"The address to withdraw the deposit + reward to.\\\"}},\\\"claim(uint256,bytes32)\\\":{\\\"details\\\":\\\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateRoot\\\":\\\"The state root to claim.\\\"}},\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaInboxArbToEth contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_deposit\\\":\\\"The deposit amount to submit a claim in wei.\\\",\\\"_epochPeriod\\\":\\\"The duration of each epoch.\\\",\\\"_maxMissingBlocks\\\":\\\"The maximum number of blocks that can be missing in a challenge period.\\\",\\\"_minChallengePeriod\\\":\\\"The minimum time window to challenge a claim.\\\",\\\"_timeoutEpochs\\\":\\\"The epochs before the bridge is considered shutdown.\\\",\\\"_veaInboxArbToEth\\\":\\\"The address of the inbox contract on Arbitrum.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"executeSequencerDelayLimitDecreaseRequest()\\\":{\\\"details\\\":\\\"execute sequencerDelayLimitDecreaseRequest\\\"},\\\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Hashes the claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to hash.\\\"},\\\"returns\\\":{\\\"hashedClaim\\\":\\\"The hash of the claim.\\\"}},\\\"isMsgRelayed(uint256)\\\":{\\\"details\\\":\\\"Get the msg relayed status.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId to check.\\\"},\\\"returns\\\":{\\\"isRelayed\\\":\\\"True if the msg was relayed.\\\"}},\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves any challenge of the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch to verify.\\\",\\\"_stateRoot\\\":\\\"The true state root for the epoch.\\\"}},\\\"sendMessage(bytes32[],uint64,address,address,bytes)\\\":{\\\"details\\\":\\\"Verifies and relays the message. UNTRUSTED.\\\",\\\"params\\\":{\\\"_from\\\":\\\"The address of the contract on Arbitrum that sent the message.\\\",\\\"_message\\\":\\\"The message in the vea inbox.\\\",\\\"_msgId\\\":\\\"The zero based index of the message in the inbox.\\\",\\\"_proof\\\":\\\"The merkle proof to prove the message inclusion in the inbox state root.\\\",\\\"_to\\\":\\\"The address of the contract on Ethereum to call.\\\"}},\\\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Start verification for claim for 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"updateSequencerDelayLimit()\\\":{\\\"details\\\":\\\"Request to decrease the sequencerDelayLimit.\\\"},\\\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the optimistic claim.\\\"}},\\\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenge deposit to withraw.\\\"}},\\\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"notice\\\":\\\"Note: Access restricted to arbitrum  bridge.\\\"}},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToEth/VeaOutboxArbToEth.sol\\\":\\\"VeaOutboxArbToEth\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToEth/VeaOutboxArbToEth.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/ISequencerInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../canonical/arbitrum/IBridge.sol\\\\\\\";\\\\nimport \\\\\\\"../canonical/arbitrum/IOutbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/gateways/IReceiverGateway.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Ethereum.\\\\n/// Note: This contract is deployed on Ethereum.\\\\ncontract VeaOutboxArbToEth is IVeaOutboxOnL1 {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    IBridge public immutable bridge; // The address of the Arbitrum bridge contract.\\\\n    address public immutable veaInboxArbToEth; // The address of the vea inbox on arbitrum.\\\\n\\\\n    uint256 public immutable deposit; // The deposit in wei required to submit a claim or challenge\\\\n    uint256 public immutable burn; // The amount of wei to burn. deposit / 2\\\\n    uint256 public immutable depositPlusReward; // 2 * deposit - burn\\\\n\\\\n    address public constant BURN_ADDRESS = address(0); // Address to send burned eth\\\\n    uint256 internal constant SLOT_TIME = 12; // Ethereum 12 second slot time\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    uint256 public immutable minChallengePeriod; // Minimum time window to challenge a claim, even with a malicious sequencer.\\\\n\\\\n    uint256 public immutable timeoutEpochs; // The number of epochs without forward progress before the bridge is considered shutdown.\\\\n    uint256 public immutable maxMissingBlocks; // The maximum number of blocks that can be missing in a challenge period.\\\\n\\\\n    bytes32 public stateRoot; // merkle root of the outbox state\\\\n    uint256 public latestVerifiedEpoch; // The latest epoch that has been verified.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public claimHashes; // epoch => claim\\\\n    mapping(uint256 messageId => bytes32) internal relayed; // msgId/256 => packed replay bitmap, preferred over a simple boolean mapping to save 15k gas per message\\\\n\\\\n    uint256 public sequencerDelayLimit; // This is MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox, it is the maximum seconds the sequencer can backdate L2 txns relative to the L1 clock.\\\\n    SequencerDelayLimitDecreaseRequest public sequencerDelayLimitDecreaseRequest; // Decreasing the sequencerDelayLimit requires a delay to avoid griefing by sequencer, so we keep track of the request here.\\\\n\\\\n    struct SequencerDelayLimitDecreaseRequest {\\\\n        uint256 requestedsequencerDelayLimit;\\\\n        uint256 timestamp;\\\\n    }\\\\n\\\\n    enum CensorshipTestStatus {\\\\n        Failed,\\\\n        Passed,\\\\n        NotStarted,\\\\n        InProgress\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Watchers check this event to challenge fraud.\\\\n    /// @param _claimer The address of the claimer.\\\\n    /// @param _epoch The epoch associated with the claim.\\\\n    /// @param _stateRoot The state root of the claim.\\\\n    event Claimed(address indexed _claimer, uint256 indexed _epoch, bytes32 _stateRoot);\\\\n\\\\n    /// @dev This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\\n    /// @param _epoch The epoch associated with the challenged claim.\\\\n    /// @param _challenger The address of the challenger.\\\\n    event Challenged(uint256 indexed _epoch, address indexed _challenger);\\\\n\\\\n    /// @dev This event indicates that a message has been relayed.\\\\n    /// @param _msgId The msgId of the message that was relayed.\\\\n    event MessageRelayed(uint64 _msgId);\\\\n\\\\n    /// @dev This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\\n    /// @param _epoch The epoch that started verification.\\\\n    event VerificationStarted(uint256 indexed _epoch);\\\\n\\\\n    /// @dev This events indicates that verification has succeeded. The messages are ready to be relayed.\\\\n    /// @param _epoch The epoch that was verified.\\\\n    event Verified(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates that a resolution has failed.\\\\n    /// @param _epoch The epoch for which resolution failed.\\\\n    event FailedResolution(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates the sequencer limit updated.\\\\n    /// @param _newSequencerDelayLimit The new sequencer delay limit.\\\\n    event SequencerDelayLimitUpdated(uint256 _newSequencerDelayLimit);\\\\n\\\\n    /// @dev This event indicates that a request to decrease the sequencer limit has been made.\\\\n    /// @param _requestedSequencerDelayLimit The new sequencer delay limit requested.\\\\n    event SequencerDelayLimitDecreaseRequested(uint256 _requestedSequencerDelayLimit);\\\\n\\\\n    // ************************************* //\\\\n    // *        Function Modifiers         * //\\\\n    // ************************************* //\\\\n\\\\n    modifier OnlyBridgeRunning() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch <= timeoutEpochs, \\\\\\\"Bridge Shutdown.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    modifier OnlyBridgeShutdown() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch > timeoutEpochs, \\\\\\\"Bridge Running.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToEth contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _veaInboxArbToEth The address of the inbox contract on Arbitrum.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        address _veaInboxArbToEth,\\\\n        address _bridge,\\\\n        uint256 _maxMissingBlocks\\\\n    ) {\\\\n        deposit = _deposit;\\\\n        // epochPeriod must match the VeaInboxArbToEth contract deployment epochPeriod value.\\\\n        epochPeriod = _epochPeriod;\\\\n        minChallengePeriod = _minChallengePeriod;\\\\n        timeoutEpochs = _timeoutEpochs;\\\\n        veaInboxArbToEth = _veaInboxArbToEth;\\\\n        bridge = IBridge(_bridge);\\\\n        maxMissingBlocks = _maxMissingBlocks;\\\\n\\\\n        updateSequencerDelayLimit();\\\\n\\\\n        // claimant and challenger are not sybil resistant\\\\n        // must burn half deposit to prevent zero cost griefing\\\\n        burn = _deposit / 2;\\\\n        depositPlusReward = 2 * _deposit - burn;\\\\n\\\\n        latestVerifiedEpoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *        Parameter Updates          * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Request to decrease the sequencerDelayLimit.\\\\n    function updateSequencerDelayLimit() public {\\\\n        // the maximum asynchronous lag between the L2 and L1 clocks\\\\n        (, , uint256 newSequencerDelayLimit, ) = ISequencerInbox(bridge.sequencerInbox()).maxTimeVariation();\\\\n\\\\n        if (newSequencerDelayLimit > sequencerDelayLimit) {\\\\n            // For sequencerDelayLimit / epochPeriod > timeoutEpochs, claims cannot be verified by the timeout period and the bridge will shutdown.\\\\n            sequencerDelayLimit = newSequencerDelayLimit;\\\\n            emit SequencerDelayLimitUpdated(newSequencerDelayLimit);\\\\n        } else if (newSequencerDelayLimit < sequencerDelayLimit) {\\\\n            require(\\\\n                sequencerDelayLimitDecreaseRequest.timestamp == 0,\\\\n                \\\\\\\"Sequencer limit decrease request already pending.\\\\\\\"\\\\n            );\\\\n\\\\n            sequencerDelayLimitDecreaseRequest = SequencerDelayLimitDecreaseRequest({\\\\n                requestedsequencerDelayLimit: newSequencerDelayLimit,\\\\n                timestamp: block.timestamp\\\\n            });\\\\n\\\\n            emit SequencerDelayLimitDecreaseRequested(newSequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev execute sequencerDelayLimitDecreaseRequest\\\\n    function executeSequencerDelayLimitDecreaseRequest() external {\\\\n        require(sequencerDelayLimitDecreaseRequest.timestamp != 0, \\\\\\\"No pending sequencer limit decrease request.\\\\\\\");\\\\n        require(\\\\n            block.timestamp > sequencerDelayLimitDecreaseRequest.timestamp + sequencerDelayLimit,\\\\n            \\\\\\\"Sequencer limit decrease request is still pending.\\\\\\\"\\\\n        );\\\\n\\\\n        uint256 requestedsequencerDelayLimit = sequencerDelayLimitDecreaseRequest.requestedsequencerDelayLimit;\\\\n        delete sequencerDelayLimitDecreaseRequest;\\\\n\\\\n        (, , uint256 currentsequencerDelayLimit, ) = ISequencerInbox(bridge.sequencerInbox()).maxTimeVariation();\\\\n\\\\n        // check the request is still consistent with the arbiturm bridge\\\\n        if (currentsequencerDelayLimit == requestedsequencerDelayLimit) {\\\\n            sequencerDelayLimit = requestedsequencerDelayLimit;\\\\n            emit SequencerDelayLimitUpdated(requestedsequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) external payable virtual {\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient claim deposit.\\\\\\\");\\\\n        unchecked {\\\\n            require(_epoch == block.timestamp / epochPeriod - 1, \\\\\\\"Invalid epoch.\\\\\\\");\\\\n        }\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function challenge(uint256 _epoch, Claim memory _claim) external payable {\\\\n        _challenge(_epoch, _claim, msg.sender);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @dev Allows proxy contracts to batch challenges.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _withdrawalAddress The address to withdraw the deposit + reward to.\\\\n    function challenge(uint256 _epoch, Claim memory _claim, address _withdrawalAddress) external payable {\\\\n        _challenge(_epoch, _claim, _withdrawalAddress);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    /// @param _withdrawAddress The address to withdraw the deposit + reward to.\\\\n    function _challenge(uint256 _epoch, Claim memory _claim, address _withdrawAddress) internal {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(msg.value >= deposit, \\\\\\\"Insufficient challenge deposit.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim already challenged.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim already verified.\\\\\\\");\\\\n\\\\n        _claim.challenger = _withdrawAddress;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Challenged(_epoch, _withdrawAddress);\\\\n\\\\n        // Refund overpayment.\\\\n        if (msg.value > deposit) {\\\\n            uint256 refund = msg.value - deposit;\\\\n            payable(msg.sender).send(refund); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        // sequencerDelayLimit + epochPeriod is the worst case time to sync the L2 state compared to L1 clock.\\\\n        // using checked arithmetic incase arbitrum governance sets sequencerDelayLimit to a large value\\\\n        require(\\\\n            block.timestamp - uint256(_claim.timestampClaimed) >= sequencerDelayLimit + epochPeriod,\\\\n            \\\\\\\"Claim must wait atleast maxL2StateSyncDelay.\\\\\\\"\\\\n        );\\\\n\\\\n        CensorshipTestStatus _censorshipTestStatus = censorshipTestStatus(_claim);\\\\n        require(\\\\n            _censorshipTestStatus == CensorshipTestStatus.NotStarted ||\\\\n                _censorshipTestStatus == CensorshipTestStatus.Failed,\\\\n            \\\\\\\"Claim verification in progress or already completed.\\\\\\\"\\\\n        );\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) external virtual OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n        require(censorshipTestStatus(_claim) == CensorshipTestStatus.Passed, \\\\\\\"Censorship test not passed.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// Note: Access restricted to arbitrum  bridge.\\\\n    /// @dev Resolves any challenge of the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(\\\\n        uint256 _epoch,\\\\n        bytes32 _stateRoot,\\\\n        Claim memory _claim\\\\n    ) external virtual OnlyBridgeRunning {\\\\n        // Arbitrum -> Ethereum message sender authentication\\\\n        // docs: https://developer.arbitrum.io/arbos/l2-to-l1-messaging/\\\\n        // example: https://github.com/OpenZeppelin/openzeppelin-contracts/blob/dfef6a68ee18dbd2e1f5a099061a3b8a0e404485/contracts/crosschain/arbitrum/LibArbitrumL1.sol#L34\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/ethereum/GreeterL1.sol#L50\\\\n        // note: we call the bridge for the activeOutbox address\\\\n\\\\n        require(msg.sender == address(bridge), \\\\\\\"Not from native arbitrum bridge.\\\\\\\");\\\\n        require(IOutbox(bridge.activeOutbox()).l2ToL1Sender() == veaInboxArbToEth, \\\\\\\"veaInboxArbToEth only.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch && _stateRoot != bytes32(0)) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _stateRoot;\\\\n        }\\\\n\\\\n        if (claimHashes[_epoch] == hashClaim(_claim)) {\\\\n            if (_claim.stateRoot == _stateRoot) {\\\\n                _claim.honest = Party.Claimer;\\\\n            } else if (_claim.challenger != address(0)) {\\\\n                _claim.honest = Party.Challenger;\\\\n            }\\\\n            claimHashes[_epoch] = hashClaim(_claim);\\\\n            emit Verified(_epoch);\\\\n        } else {\\\\n            emit FailedResolution(_epoch);\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Verifies and relays the message. UNTRUSTED.\\\\n    /// @param _proof The merkle proof to prove the message inclusion in the inbox state root.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address of the contract on Ethereum to call.\\\\n    /// @param _from The address of the contract on Arbitrum that sent the message.\\\\n    /// @param _message The message in the vea inbox.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external {\\\\n        require(_proof.length < 64, \\\\\\\"Proof too long.\\\\\\\");\\\\n\\\\n        bytes32 nodeHash = keccak256(abi.encodePacked(_msgId, _to, _from, _message));\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            mstore(0x00, nodeHash)\\\\n            nodeHash := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        unchecked {\\\\n            for (uint256 i = 0; i < _proof.length; i++) {\\\\n                bytes32 proofElement = _proof[i];\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                if (proofElement > nodeHash)\\\\n                    assembly {\\\\n                        mstore(0x00, nodeHash)\\\\n                        mstore(0x20, proofElement)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n                else\\\\n                    assembly {\\\\n                        mstore(0x00, proofElement)\\\\n                        mstore(0x20, nodeHash)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n            }\\\\n        }\\\\n\\\\n        require(stateRoot == nodeHash, \\\\\\\"Invalid proof.\\\\\\\");\\\\n\\\\n        // msgId is the zero-based index of the message in the inbox.\\\\n        // msgId is also used as an index in the relayed bitmap to prevent replay.\\\\n        // Note: a bitmap is used instead of a simple boolean mapping to save 15k gas per message.\\\\n\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        require(((replay >> offset) & bytes32(uint256(1))) == bytes32(0), \\\\\\\"Message already relayed\\\\\\\");\\\\n        relayed[relayIndex] = replay | bytes32(1 << offset);\\\\n\\\\n        // UNTRUSTED.\\\\n        IReceiverGateway(_to).receiveMessage(_from, _message);\\\\n\\\\n        emit MessageRelayed(_msgId);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim calldata _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            payable(BURN_ADDRESS).send(burn);\\\\n            payable(_claim.claimer).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n        } else {\\\\n            payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\\n    /// @param _epoch The epoch associated with the challenge deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengeDeposit(uint256 _epoch, Claim calldata _claim) external {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Challenger, \\\\\\\"Challenge failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        payable(BURN_ADDRESS).send(burn); // half burnt\\\\n        payable(_claim.challenger).send(depositPlusReward); // User is responsible for accepting ETH.\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.claimer != address(0)) {\\\\n            if (_claim.challenger == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                payable(_claim.claimer).send(deposit); // User is responsible for accepting ETH.\\\\n            } else {\\\\n                address claimer = _claim.claimer;\\\\n                _claim.claimer = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                payable(claimer).send(deposit); // User is responsible for accepting ETH.\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            if (_claim.claimer == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                payable(_claim.challenger).send(deposit); // User is responsible for accepting ETH.\\\\n            } else {\\\\n                address challenger = _claim.challenger;\\\\n                _claim.challenger = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                payable(challenger).send(deposit); // User is responsible for accepting ETH.\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Hashes the claim.\\\\n    /// @param _claim The claim to hash.\\\\n    /// @return hashedClaim The hash of the claim.\\\\n    function hashClaim(Claim memory _claim) public pure returns (bytes32 hashedClaim) {\\\\n        return\\\\n            hashedClaim = keccak256(\\\\n                abi.encodePacked(\\\\n                    _claim.stateRoot,\\\\n                    _claim.claimer,\\\\n                    _claim.timestampClaimed,\\\\n                    _claim.timestampVerification,\\\\n                    _claim.blocknumberVerification,\\\\n                    _claim.honest,\\\\n                    _claim.challenger\\\\n                )\\\\n            );\\\\n    }\\\\n\\\\n    /// @dev Gets the status of the censorship test for claim.\\\\n    /// @param _claim The claim to test.\\\\n    /// @return status True if the claim passed the censorship test.\\\\n    function censorshipTestStatus(Claim memory _claim) public view returns (CensorshipTestStatus status) {\\\\n        unchecked {\\\\n            if (uint256(_claim.timestampVerification) == 0) {\\\\n                status = CensorshipTestStatus.NotStarted;\\\\n            } else if (block.timestamp - uint256(_claim.timestampVerification) < minChallengePeriod) {\\\\n                status = CensorshipTestStatus.InProgress;\\\\n            } else {\\\\n                uint256 expectedBlocks = uint256(_claim.blocknumberVerification) +\\\\n                    (block.timestamp - uint256(_claim.timestampVerification)) /\\\\n                    SLOT_TIME;\\\\n                uint256 actualBlocks = block.number;\\\\n                if (expectedBlocks - actualBlocks <= maxMissingBlocks) {\\\\n                    status = CensorshipTestStatus.Passed;\\\\n                } else {\\\\n                    status = CensorshipTestStatus.Failed;\\\\n                }\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochAt(uint256 timestamp) external view returns (uint256 epoch) {\\\\n        epoch = timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the msg relayed status.\\\\n    /// @param _msgId The msgId to check.\\\\n    /// @return isRelayed True if the msg was relayed.\\\\n    function isMsgRelayed(uint256 _msgId) external view returns (bool isRelayed) {\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        isRelayed = (replay >> offset) & bytes32(uint256(1)) == bytes32(uint256(1));\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x94c0bf819839e0fb3e4a7f033246ec372ba556d76d6f790365f7fc955e02bf80\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IBridge.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/IBridge.sol\\\\n// proxy: https://etherscan.io/address/0x8315177aB297bA92A06054cE80a67Ed4DBd7ed3a\\\\n// implementation: https://etherscan.io/address/0x1066cecc8880948fe55e427e94f1ff221d626591#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IBridge {\\\\n    function activeOutbox() external view returns (address);\\\\n\\\\n    function sequencerInbox() external view returns (address);\\\\n\\\\n    function allowedDelayedInboxList(uint256) external returns (address);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x2efbba328710a6e47936917cbd8cbf6bf68a2470c3bcc5ea26cc04254ec99142\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/canonical/arbitrum/IOutbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/IBridge.sol\\\\n// proxy: https://etherscan.io/address/0x0B9857ae2D4A3DBe74ffE1d7DF045bb7F96E4840#code\\\\n// implementation: https://etherscan.io/address/0x0ea7372338a589e7f0b00e463a53aa464ef04e17#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IOutbox {\\\\n    /// @notice When l2ToL1Sender returns a nonzero address, the message was originated by an L2 account\\\\n    ///         When the return value is zero, that means this is a system message\\\\n    /// @dev the l2ToL1Sender behaves as the tx.origin, the msg.sender should be validated to protect against reentrancies\\\\n    function l2ToL1Sender() external view returns (address);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x05ae223a026cf735a62b19b18506463cda83804ea4257888216bb0e242629480\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/canonical/arbitrum/ISequencerInbox.sol\\\":{\\\"content\\\":\\\"// Copyright 2021-2022, Offchain Labs, Inc.\\\\n// For license information, see https://github.com/nitro/blob/master/LICENSE\\\\n// SPDX-License-Identifier: BUSL-1.1\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/08ac127e966fa87a4d5ba3d23cd3132b57701132/src/bridge/ISequencerInbox.sol\\\\n// proxy: https://etherscan.io/address/0x1c479675ad559DC151F6Ec7ed3FbF8ceE79582B6#code\\\\n// implementation: https://etherscan.io/address/0xD03bFe2CE83632F4E618a97299cc91B1335BB2d9#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"./IBridge.sol\\\\\\\";\\\\n\\\\ninterface ISequencerInbox {\\\\n    struct MaxTimeVariation {\\\\n        uint256 delayBlocks;\\\\n        uint256 futureBlocks;\\\\n        uint256 delaySeconds;\\\\n        uint256 futureSeconds;\\\\n    }\\\\n\\\\n    function maxTimeVariation() external view returns (uint256, uint256, uint256, uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xa5bea5a8c2fb9b8ab97143066b8a0764cd4dc4d6efebd04a2c708ba2ad1e315e\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/interfaces/gateways/IReceiverGateway.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IReceiverGateway {\\\\n    function veaOutbox() external view returns (address);\\\\n\\\\n    function senderGateway() external view returns (address);\\\\n\\\\n    function receiveMessage(address msgSender, bytes calldata msgData) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe6917520400ac49fc28bf32acb29cc115d1f97789ad798336d46a4bb7d35a9be\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\n\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _from The address of the contract on L2 that sent the message, used for authentication.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x6c9a39add549daa58bd882a3949212afa73cabc75bda99a97583545a1d7622da\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Outbox From Arbitrum to Ethereum. Note: This contract is deployed on Ethereum.\",\"events\":{\"Challenged(uint256,address)\":{\"details\":\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\",\"params\":{\"_challenger\":\"The address of the challenger.\",\"_epoch\":\"The epoch associated with the challenged claim.\"}},\"Claimed(address,uint256,bytes32)\":{\"details\":\"Watchers check this event to challenge fraud.\",\"params\":{\"_claimer\":\"The address of the claimer.\",\"_epoch\":\"The epoch associated with the claim.\",\"_stateRoot\":\"The state root of the claim.\"}},\"FailedResolution(uint256)\":{\"details\":\"This event indicates that a resolution has failed.\",\"params\":{\"_epoch\":\"The epoch for which resolution failed.\"}},\"MessageRelayed(uint64)\":{\"details\":\"This event indicates that a message has been relayed.\",\"params\":{\"_msgId\":\"The msgId of the message that was relayed.\"}},\"SequencerDelayLimitDecreaseRequested(uint256)\":{\"details\":\"This event indicates that a request to decrease the sequencer limit has been made.\",\"params\":{\"_requestedSequencerDelayLimit\":\"The new sequencer delay limit requested.\"}},\"SequencerDelayLimitUpdated(uint256)\":{\"details\":\"This event indicates the sequencer limit updated.\",\"params\":{\"_newSequencerDelayLimit\":\"The new sequencer delay limit.\"}},\"VerificationStarted(uint256)\":{\"details\":\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\",\"params\":{\"_epoch\":\"The epoch that started verification.\"}},\"Verified(uint256)\":{\"details\":\"This events indicates that verification has succeeded. The messages are ready to be relayed.\",\"params\":{\"_epoch\":\"The epoch that was verified.\"}}},\"kind\":\"dev\",\"methods\":{\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Gets the status of the censorship test for claim.\",\"params\":{\"_claim\":\"The claim to test.\"},\"returns\":{\"status\":\"True if the claim passed the censorship test.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address),address)\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.Allows proxy contracts to batch challenges.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\",\"_withdrawalAddress\":\"The address to withdraw the deposit + reward to.\"}},\"claim(uint256,bytes32)\":{\"details\":\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateRoot\":\"The state root to claim.\"}},\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaInboxArbToEth contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_deposit\":\"The deposit amount to submit a claim in wei.\",\"_epochPeriod\":\"The duration of each epoch.\",\"_maxMissingBlocks\":\"The maximum number of blocks that can be missing in a challenge period.\",\"_minChallengePeriod\":\"The minimum time window to challenge a claim.\",\"_timeoutEpochs\":\"The epochs before the bridge is considered shutdown.\",\"_veaInboxArbToEth\":\"The address of the inbox contract on Arbitrum.\"}},\"epochAt(uint256)\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"executeSequencerDelayLimitDecreaseRequest()\":{\"details\":\"execute sequencerDelayLimitDecreaseRequest\"},\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Hashes the claim.\",\"params\":{\"_claim\":\"The claim to hash.\"},\"returns\":{\"hashedClaim\":\"The hash of the claim.\"}},\"isMsgRelayed(uint256)\":{\"details\":\"Get the msg relayed status.\",\"params\":{\"_msgId\":\"The msgId to check.\"},\"returns\":{\"isRelayed\":\"True if the msg was relayed.\"}},\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves any challenge of the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch to verify.\",\"_stateRoot\":\"The true state root for the epoch.\"}},\"sendMessage(bytes32[],uint64,address,address,bytes)\":{\"details\":\"Verifies and relays the message. UNTRUSTED.\",\"params\":{\"_from\":\"The address of the contract on Arbitrum that sent the message.\",\"_message\":\"The message in the vea inbox.\",\"_msgId\":\"The zero based index of the message in the inbox.\",\"_proof\":\"The merkle proof to prove the message inclusion in the inbox state root.\",\"_to\":\"The address of the contract on Ethereum to call.\"}},\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Start verification for claim for 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"updateSequencerDelayLimit()\":{\"details\":\"Request to decrease the sequencerDelayLimit.\"},\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the optimistic claim.\"}},\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the challenge deposit to withraw.\"}},\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"notice\":\"Note: Access restricted to arbitrum  bridge.\"}},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":432,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"stateRoot\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_bytes32\"},{\"astId\":434,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"latestVerifiedEpoch\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"},{\"astId\":438,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"claimHashes\",\"offset\":0,\"slot\":\"2\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":442,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"relayed\",\"offset\":0,\"slot\":\"3\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":444,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"sequencerDelayLimit\",\"offset\":0,\"slot\":\"4\",\"type\":\"t_uint256\"},{\"astId\":447,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"sequencerDelayLimitDecreaseRequest\",\"offset\":0,\"slot\":\"5\",\"type\":\"t_struct(SequencerDelayLimitDecreaseRequest)452_storage\"}],\"types\":{\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_struct(SequencerDelayLimitDecreaseRequest)452_storage\":{\"encoding\":\"inplace\",\"label\":\"struct VeaOutboxArbToEth.SequencerDelayLimitDecreaseRequest\",\"members\":[{\"astId\":449,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"requestedsequencerDelayLimit\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_uint256\"},{\"astId\":451,\"contract\":\"src/arbitrumToEth/VeaOutboxArbToEth.sol:VeaOutboxArbToEth\",\"label\":\"timestamp\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"}],\"numberOfBytes\":\"64\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"}}}}");


var $0c8750bf065f6e58$exports = {};
$0c8750bf065f6e58$exports = JSON.parse("{\"address\":\"0x2E973e20B24088bc74755a7A5cd1A37Dcb53E061\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_routerArbToGnosis\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes\",\"name\":\"_nodeData\",\"type\":\"bytes\"}],\"name\":\"MessageSent\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_snapshot\",\"type\":\"bytes32\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_count\",\"type\":\"uint64\"}],\"name\":\"SnapshotSaved\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epochSent\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_ticketId\",\"type\":\"bytes32\"}],\"name\":\"SnapshotSent\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"count\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochFinalized\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerArbToGnosis\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"saveSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_data\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_gasLimit\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"sendSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"snapshots\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"transactionHash\":\"0x7a40ea8e4b7e2900d8f60876e21492282fb7bcea9abcb73cb9c0e95459ba7b29\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0x2E973e20B24088bc74755a7A5cd1A37Dcb53E061\",\"transactionIndex\":4,\"gasUsed\":\"796559\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x4d8fbb255c78c3964efaba51ab066731372d61933ca4085d5e9768ecb7efd3f4\",\"transactionHash\":\"0x7a40ea8e4b7e2900d8f60876e21492282fb7bcea9abcb73cb9c0e95459ba7b29\",\"logs\":[],\"blockNumber\":189389231,\"cumulativeGasUsed\":\"1004125\",\"status\":1,\"byzantium\":true},\"args\":[300,\"0x879A9F4476D4445A1deCf40175a700C4c829824D\"],\"numDeployments\":4,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_routerArbToGnosis\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_nodeData\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"MessageSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_snapshot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_count\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"SnapshotSaved\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochSent\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_ticketId\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"SnapshotSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"count\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochFinalized\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerArbToGnosis\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"saveSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_data\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_gasLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"sendSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"snapshots\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Inbox From Arbitrum to Gnosis. Note: This contract is deployed on the Arbitrum.\\\",\\\"events\\\":{\\\"MessageSent(bytes)\\\":{\\\"details\\\":\\\"Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\\\",\\\"params\\\":{\\\"_nodeData\\\":\\\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\"}},\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"params\\\":{\\\"_count\\\":\\\"The count of messages in the merkle tree.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot.\\\",\\\"_snapshot\\\":\\\"The snapshot of the merkle tree state root.\\\"}},\\\"SnapshotSent(uint256,bytes32)\\\":{\\\"details\\\":\\\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\",\\\"params\\\":{\\\"_epochSent\\\":\\\"The epoch of the snapshot.\\\",\\\"_ticketId\\\":\\\"The ticketId of the L2->L1 message.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_epochPeriod\\\":\\\"The duration in seconds between epochs.\\\",\\\"_routerArbToGnosis\\\":\\\"The router on Ethereum that routes from Arbitrum to Gnosis.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the epoch from the inbox's point of view using timestamp.\\\",\\\"params\\\":{\\\"_timestamp\\\":\\\"The timestamp to calculate the epoch from.\\\"},\\\"returns\\\":{\\\"epoch\\\":\\\"The calculated epoch.\\\"}},\\\"epochFinalized()\\\":{\\\"details\\\":\\\"Get the most recent epoch for which snapshots are finalized.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"saveSnapshot()\\\":{\\\"details\\\":\\\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\\\"},\\\"sendMessage(address,bytes)\\\":{\\\"details\\\":\\\"Sends an arbitrary message to Gnosis.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\\\",\\\"params\\\":{\\\"_data\\\":\\\"The message data for the receiving gateway.\\\",\\\"_to\\\":\\\"The address of the contract on the receiving chain which receives the message.\\\"},\\\"returns\\\":{\\\"_0\\\":\\\"msgId The zero based index of the message in the inbox.\\\"}},\\\"sendSnapshot(uint256,uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the state root snapshot using Arbitrum's canonical bridge.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot requested to send.\\\",\\\"_gasLimit\\\":\\\"The gas limit for the AMB transaction on Gnosis.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"events\\\":{\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"notice\\\":\\\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\"}},\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol\\\":\\\"VeaInboxArbToGnosis\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/IArbSys.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/inboxes/IVeaInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/routers/IRouterToGnosis.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Inbox From Arbitrum to Gnosis.\\\\n/// Note: This contract is deployed on the Arbitrum.\\\\ncontract VeaInboxArbToGnosis is IVeaInbox {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    // Arbitrum precompile ArbSys for L2->L1 messaging: https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n    IArbSys internal constant ARB_SYS = IArbSys(address(100));\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    address public immutable routerArbToGnosis; // The router on ethereum.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public snapshots; // epoch => state root snapshot\\\\n\\\\n    // Inbox represents minimum data availability to maintain incremental merkle tree.\\\\n    // Supports a max of 2^64 - 1 messages. See merkle tree docs for details how inbox manages state.\\\\n\\\\n    bytes32[64] internal inbox; // stores minimal set of complete subtree roots of the merkle tree to increment.\\\\n    uint64 public count; // count of messages in the merkle tree\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\\\\n    /// @param _nodeData The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\\n    event MessageSent(bytes _nodeData);\\\\n\\\\n    /// The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\\n    /// @param _snapshot The snapshot of the merkle tree state root.\\\\n    /// @param _epoch The epoch of the snapshot.\\\\n    /// @param _count The count of messages in the merkle tree.\\\\n    event SnapshotSaved(bytes32 _snapshot, uint256 _epoch, uint64 _count);\\\\n\\\\n    /// @dev The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\\n    /// @param _epochSent The epoch of the snapshot.\\\\n    /// @param _ticketId The ticketId of the L2->L1 message.\\\\n    event SnapshotSent(uint256 indexed _epochSent, bytes32 _ticketId);\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _epochPeriod The duration in seconds between epochs.\\\\n    /// @param _routerArbToGnosis The router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    constructor(uint256 _epochPeriod, address _routerArbToGnosis) {\\\\n        epochPeriod = _epochPeriod;\\\\n        routerArbToGnosis = _routerArbToGnosis;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Sends an arbitrary message to Gnosis.\\\\n    ///      `O(log(count))` where count is the number of messages already sent.\\\\n    ///      Amortized cost is constant.\\\\n    /// Note: See docs for details how inbox manages merkle tree state.\\\\n    /// @param _to The address of the contract on the receiving chain which receives the message.\\\\n    /// @param _data The message data for the receiving gateway.\\\\n    /// @return msgId The zero based index of the message in the inbox.\\\\n    function sendMessage(address _to, bytes calldata _data) external override returns (uint64) {\\\\n        uint64 oldCount = count;\\\\n\\\\n        // Given arbitrum's speed limit of 7 million gas / second, it would take atleast 8 million years of full blocks to overflow.\\\\n        // It *should* be impossible to overflow, but we check to be safe when appending to the tree.\\\\n        require(oldCount < type(uint64).max, \\\\\\\"Inbox is full.\\\\\\\");\\\\n\\\\n        bytes memory nodeData = abi.encodePacked(oldCount, _to, msg.sender, _data);\\\\n\\\\n        // single hashed leaf\\\\n        bytes32 newInboxNode = keccak256(nodeData);\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            // efficient hash using EVM scratch space\\\\n            mstore(0x00, newInboxNode)\\\\n            newInboxNode := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        // increment merkle tree calculating minimal number of hashes\\\\n        unchecked {\\\\n            uint256 height;\\\\n\\\\n            // x = oldCount + 1; acts as a bit mask to determine if a hash is needed\\\\n            // note: x is always non-zero, and x is bit shifted to the right each loop\\\\n            // hence this loop will always terminate in a maximum of log_2(oldCount + 1) iterations\\\\n            for (uint64 x = oldCount + 1; x & 1 == 0; x = x >> 1) {\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                newInboxNode = sortConcatAndHash(inbox[height], newInboxNode);\\\\n                height++;\\\\n            }\\\\n\\\\n            inbox[height] = newInboxNode;\\\\n\\\\n            // finally increment count\\\\n            count = oldCount + 1;\\\\n        }\\\\n\\\\n        emit MessageSent(nodeData);\\\\n\\\\n        // old count is the zero indexed leaf position in the tree, acts as a msgId\\\\n        // gateways should index these msgIds to later relay proofs\\\\n        return oldCount;\\\\n    }\\\\n\\\\n    /// @dev Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    /// Note: See merkle tree docs for details how inbox manages state.\\\\n    function saveSnapshot() external {\\\\n        uint256 epoch;\\\\n        bytes32 stateRoot;\\\\n\\\\n        unchecked {\\\\n            epoch = block.timestamp / epochPeriod;\\\\n\\\\n            // calculate the current root of the incremental merkle tree encoded in the inbox\\\\n\\\\n            uint256 height;\\\\n\\\\n            // x acts as a bit mask to determine if the hash stored in the inbox contributes to the root\\\\n            uint256 x;\\\\n\\\\n            // x is bit shifted to the right each loop, hence this loop will always terminate in a maximum of log_2(count) iterations\\\\n            for (x = uint256(count); x > 0; x = x >> 1) {\\\\n                if ((x & 1) == 1) {\\\\n                    // first hash is special case\\\\n                    // inbox stores the root of complete subtrees\\\\n                    // eg if count = 4 = 0b100, then the first complete subtree is inbox[2]\\\\n                    // inbox = [H(3), H(1,2), H(1,4)], we read inbox[2] directly\\\\n\\\\n                    stateRoot = inbox[height];\\\\n                    break;\\\\n                }\\\\n                height++;\\\\n            }\\\\n\\\\n            // after the first hash, we can calculate the root incrementally\\\\n            for (x = x >> 1; x > 0; x = x >> 1) {\\\\n                height++;\\\\n                if ((x & 1) == 1) {\\\\n                    // sort sibling hashes as a convention for efficient proof validation\\\\n                    stateRoot = sortConcatAndHash(inbox[height], stateRoot);\\\\n                }\\\\n            }\\\\n        }\\\\n\\\\n        snapshots[epoch] = stateRoot;\\\\n\\\\n        emit SnapshotSaved(stateRoot, epoch, count);\\\\n    }\\\\n\\\\n    /// @dev Helper function to calculate merkle tree interior nodes by sorting and concatenating and hashing a pair of children nodes, left and right.\\\\n    /// Note: EVM scratch space is used to efficiently calculate hashes.\\\\n    /// @param _left The left hash.\\\\n    /// @param _right The right hash.\\\\n    /// @return parent The parent hash.\\\\n    function sortConcatAndHash(bytes32 _left, bytes32 _right) internal pure returns (bytes32 parent) {\\\\n        // sort sibling hashes as a convention for efficient proof validation\\\\n        if (_left < _right) {\\\\n            // efficient hash using EVM scratch space\\\\n            assembly {\\\\n                mstore(0x00, _left)\\\\n                mstore(0x20, _right)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        } else {\\\\n            assembly {\\\\n                mstore(0x00, _right)\\\\n                mstore(0x20, _left)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the state root snapshot using Arbitrum's canonical bridge.\\\\n    /// @param _epoch The epoch of the snapshot requested to send.\\\\n    /// @param _gasLimit The gas limit for the AMB transaction on Gnosis.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function sendSnapshot(uint256 _epoch, uint256 _gasLimit, Claim memory _claim) external virtual {\\\\n        unchecked {\\\\n            require(_epoch < block.timestamp / epochPeriod, \\\\\\\"Can only send past epoch snapshot.\\\\\\\");\\\\n        }\\\\n\\\\n        bytes memory data = abi.encodeCall(IRouterToGnosis.route, (_epoch, snapshots[_epoch], _gasLimit, _claim));\\\\n\\\\n        // Arbitrum -> Ethereum message with native bridge\\\\n        // docs: https://developer.arbitrum.io/for-devs/cross-chain-messsaging#arbitrum-to-ethereum-messaging\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/arbitrum/GreeterL2.sol#L25\\\\n        bytes32 ticketID = bytes32(ARB_SYS.sendTxToL1(routerArbToGnosis, data));\\\\n\\\\n        emit SnapshotSent(_epoch, ticketID);\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the most recent epoch for which snapshots are finalized.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochFinalized() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    /// @dev Get the epoch from the inbox's point of view using timestamp.\\\\n    /// @param _timestamp The timestamp to calculate the epoch from.\\\\n    /// @return epoch The calculated epoch.\\\\n    function epochAt(uint256 _timestamp) external view returns (uint256 epoch) {\\\\n        epoch = _timestamp / epochPeriod;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xf49f7400be9786fb3713bb6dbbc24bab5b0243d164e535c598e19ba073d8c212\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IArbSys.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/39ea5a163afc637e2706d9be29cf7a289c300d00/src/precompiles/ArbSys.sol\\\\n// https://arbiscan.io/address/0x0000000000000000000000000000000000000064#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\n///@title System level functionality\\\\n///@notice For use by contracts to interact with core L2-specific functionality.\\\\n///Precompiled contract that exists in every Arbitrum chain at address(100), 0x0000000000000000000000000000000000000064.\\\\ninterface IArbSys {\\\\n    /// @notice Send a transaction to L1\\\\n    /// @dev it is not possible to execute on the L1 any L2-to-L1 transaction which contains data\\\\n    /// to a contract address without any code (as enforced by the Bridge contract).\\\\n    /// @param destination recipient address on L1\\\\n    /// @param data (optional) calldata for L1 contract call\\\\n    /// @return a unique identifier for this L2-to-L1 transaction.\\\\n    function sendTxToL1(address destination, bytes calldata data) external payable returns (uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x62893c290f2797daa4aebbbb5eb9b2b1d5e7d622b02928b0198450da34bf6293\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/interfaces/inboxes/IVeaInbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IVeaInbox {\\\\n    /// @dev Sends an arbitrary message to receiving chain.\\\\n    /// Note: Calls authenticated by receiving gateway checking the sender argument.\\\\n    /// @param _to The cross-domain contract address which receives the message.\\\\n    /// @param _data The message data.\\\\n    /// @return msgId The index of the message in the inbox, as a message Id, needed to relay the message.\\\\n    function sendMessage(address _to, bytes calldata _data) external returns (uint64 msgId);\\\\n\\\\n    /// @dev Snapshots can be saved a maximum of once per epoch.\\\\n    ///      Saves snapshot of state root.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    function saveSnapshot() external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x035e770f7b6e434b07e14ffb3283e61584eac8563c93ca587e42aa7a85504d02\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/routers/IRouterToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Router which routes messages to Gnosis through the AMB.\\\\n/// @dev eg. L2 on Ethereum -> Ethereum (L1) -> Gnosis (L1), the IRouterToL1 will be deployed on Ethereum (L1) routing messages to Gnosis (L1).\\\\ninterface IRouterToGnosis {\\\\n    /// @dev Routes state root snapshots through intermediary chains to the final destination L1 chain.\\\\n    /// Note: Access restricted to canonical sending-chain bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _gasLimit The gas limit for the AMB message.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function route(uint256 _epoch, bytes32 _stateRoot, uint256 _gasLimit, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe47fe750db4b12bff2825937852c7d525b6f5e7385ab9e1b9fbe54d8e8e44540\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Inbox From Arbitrum to Gnosis. Note: This contract is deployed on the Arbitrum.\",\"events\":{\"MessageSent(bytes)\":{\"details\":\"Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\",\"params\":{\"_nodeData\":\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\"}},\"SnapshotSaved(bytes32,uint256,uint64)\":{\"params\":{\"_count\":\"The count of messages in the merkle tree.\",\"_epoch\":\"The epoch of the snapshot.\",\"_snapshot\":\"The snapshot of the merkle tree state root.\"}},\"SnapshotSent(uint256,bytes32)\":{\"details\":\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\",\"params\":{\"_epochSent\":\"The epoch of the snapshot.\",\"_ticketId\":\"The ticketId of the L2->L1 message.\"}}},\"kind\":\"dev\",\"methods\":{\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_epochPeriod\":\"The duration in seconds between epochs.\",\"_routerArbToGnosis\":\"The router on Ethereum that routes from Arbitrum to Gnosis.\"}},\"epochAt(uint256)\":{\"details\":\"Get the epoch from the inbox's point of view using timestamp.\",\"params\":{\"_timestamp\":\"The timestamp to calculate the epoch from.\"},\"returns\":{\"epoch\":\"The calculated epoch.\"}},\"epochFinalized()\":{\"details\":\"Get the most recent epoch for which snapshots are finalized.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"saveSnapshot()\":{\"details\":\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\"},\"sendMessage(address,bytes)\":{\"details\":\"Sends an arbitrary message to Gnosis.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\",\"params\":{\"_data\":\"The message data for the receiving gateway.\",\"_to\":\"The address of the contract on the receiving chain which receives the message.\"},\"returns\":{\"_0\":\"msgId The zero based index of the message in the inbox.\"}},\"sendSnapshot(uint256,uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the state root snapshot using Arbitrum's canonical bridge.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the snapshot requested to send.\",\"_gasLimit\":\"The gas limit for the AMB transaction on Gnosis.\"}}},\"version\":1},\"userdoc\":{\"events\":{\"SnapshotSaved(bytes32,uint256,uint64)\":{\"notice\":\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\"}},\"kind\":\"user\",\"methods\":{},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":2251,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"snapshots\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":2255,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"inbox\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_array(t_bytes32)64_storage\"},{\"astId\":2257,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"count\",\"offset\":0,\"slot\":\"65\",\"type\":\"t_uint64\"}],\"types\":{\"t_array(t_bytes32)64_storage\":{\"base\":\"t_bytes32\",\"encoding\":\"inplace\",\"label\":\"bytes32[64]\",\"numberOfBytes\":\"2048\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"},\"t_uint64\":{\"encoding\":\"inplace\",\"label\":\"uint64\",\"numberOfBytes\":\"8\"}}}}");


var $96dccd946dfc76eb$exports = {};
$96dccd946dfc76eb$exports = JSON.parse("{\"address\":\"0x879A9F4476D4445A1deCf40175a700C4c829824D\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_deposit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_minChallengePeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timeoutEpochs\",\"type\":\"uint256\"},{\"internalType\":\"contract IAMB\",\"name\":\"_amb\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_routerArbToGnosis\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_sequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_maxMissingBlocks\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_routerChainId\",\"type\":\"uint256\"},{\"internalType\":\"contract IWETH\",\"name\":\"_weth\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_challenger\",\"type\":\"address\"}],\"name\":\"Challenged\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_claimer\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"Claimed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"FailedResolution\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"}],\"name\":\"MessageRelayed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitUpdateReceived\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"VerificationStarted\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"Verified\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"amb\",\"outputs\":[{\"internalType\":\"contract IAMB\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"burn\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"censorshipTestStatus\",\"outputs\":[{\"internalType\":\"enum VeaOutboxArbToGnosis.CensorshipTestStatus\",\"name\":\"status\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_devnetOperator\",\"type\":\"address\"}],\"name\":\"changeDevnetOperator\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"claim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"claimHashes\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"deposit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"depositPlusReward\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateroot\",\"type\":\"bytes32\"}],\"name\":\"devnetAdvanceState\",\"outputs\":[],\"stateMutability\":\"payable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"devnetOperator\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"hashClaim\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"hashedClaim\",\"type\":\"bytes32\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_msgId\",\"type\":\"uint256\"}],\"name\":\"isMsgRelayed\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"isRelayed\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"latestVerifiedEpoch\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"maxMissingBlocks\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"minChallengePeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"resolveDisputedClaim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerArbToGnosis\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerChainId\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes32[]\",\"name\":\"_proof\",\"type\":\"bytes32[]\"},{\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"},{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_from\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_message\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"startVerification\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stateRoot\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeoutEpochs\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timestampDelayUpdated\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"updateSequencerDelayLimit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"verifySnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"weth\",\"outputs\":[{\"internalType\":\"contract IWETH\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengeDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"transactionHash\":\"0x654761b3933e044e32c59992d10e789815f24ffa587149130ee59fc35c5b20ce\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0x879A9F4476D4445A1deCf40175a700C4c829824D\",\"transactionIndex\":3,\"gasUsed\":\"2449176\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x9377cd747a19e295468b12f522fde5b8f6516cd741f0b6931865a713fb8a67a1\",\"transactionHash\":\"0x654761b3933e044e32c59992d10e789815f24ffa587149130ee59fc35c5b20ce\",\"logs\":[],\"blockNumber\":17544965,\"cumulativeGasUsed\":\"2538726\",\"status\":1,\"byzantium\":true},\"args\":[\"100000000000000000\",300,0,10000000000000,\"0x8448E15d0e706C0298dECA99F0b4744030e59d7d\",\"0xfA08cfe2530c01045D953f824b836f6757670cD0\",86400,10000000000000,11155111,\"0x8d74e5e4DA11629537C4575cB0f33b4F0Dfa42EB\"],\"numDeployments\":13,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_deposit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_minChallengePeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timeoutEpochs\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"contract IAMB\\\",\\\"name\\\":\\\"_amb\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_routerArbToGnosis\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_sequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_maxMissingBlocks\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_routerChainId\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"contract IWETH\\\",\\\"name\\\":\\\"_weth\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"Challenged\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"Claimed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"FailedResolution\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"MessageRelayed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitUpdateReceived\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"VerificationStarted\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"Verified\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"amb\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IAMB\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"burn\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"censorshipTestStatus\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"enum VeaOutboxArbToGnosis.CensorshipTestStatus\\\",\\\"name\\\":\\\"status\\\",\\\"type\\\":\\\"uint8\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_devnetOperator\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"changeDevnetOperator\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"claim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"claimHashes\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"deposit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"depositPlusReward\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateroot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"devnetAdvanceState\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"payable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"devnetOperator\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"hashClaim\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"hashedClaim\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"pure\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"isMsgRelayed\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bool\\\",\\\"name\\\":\\\"isRelayed\\\",\\\"type\\\":\\\"bool\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"latestVerifiedEpoch\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"maxMissingBlocks\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"minChallengePeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"resolveDisputedClaim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerArbToGnosis\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerChainId\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"bytes32[]\\\",\\\"name\\\":\\\"_proof\\\",\\\"type\\\":\\\"bytes32[]\\\"},{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_from\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_message\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"startVerification\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"stateRoot\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timeoutEpochs\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timestampDelayUpdated\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"updateSequencerDelayLimit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"verifySnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"weth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IWETH\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengeDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Outbox From Arbitrum to Chiado. Note: This contract is deployed on Chiado. Note: This contract is permissioned for developer testing (devnet).\\\",\\\"events\\\":{\\\"Challenged(uint256,address)\\\":{\\\"details\\\":\\\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\",\\\"params\\\":{\\\"_challenger\\\":\\\"The address of the challenger.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenged claim.\\\"}},\\\"Claimed(address,uint256,bytes32)\\\":{\\\"details\\\":\\\"Watchers check this event to challenge fraud.\\\",\\\"params\\\":{\\\"_claimer\\\":\\\"The address of the claimer.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim.\\\",\\\"_stateRoot\\\":\\\"The state root of the claim.\\\"}},\\\"FailedResolution(uint256)\\\":{\\\"details\\\":\\\"This event indicates that a resolution has failed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which resolution failed.\\\"}},\\\"MessageRelayed(uint64)\\\":{\\\"details\\\":\\\"This event indicates that a message has been relayed.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId of the message that was relayed.\\\"}},\\\"SequencerDelayLimitUpdateReceived(uint256)\\\":{\\\"details\\\":\\\"This event indicates the sequencer limit updated.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The new sequencer delay limit.\\\"}},\\\"VerificationStarted(uint256)\\\":{\\\"details\\\":\\\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that started verification.\\\"}},\\\"Verified(uint256)\\\":{\\\"details\\\":\\\"This events indicates that verification has succeeded. The messages are ready to be relayed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that was verified.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Gets the status of the censorship test for claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to test.\\\"},\\\"returns\\\":{\\\"status\\\":\\\"True if the claim passed the censorship test.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"changeDevnetOperator(address)\\\":{\\\"details\\\":\\\"Changes the devnet operator.\\\",\\\"params\\\":{\\\"_devnetOperator\\\":\\\"The new testnet operator.\\\"}},\\\"claim(uint256,bytes32)\\\":{\\\"details\\\":\\\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateRoot\\\":\\\"The state root to claim.\\\"}},\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_amb\\\":\\\"The address of the AMB contract on Gnosis.\\\",\\\"_deposit\\\":\\\"The deposit amount to submit a claim in wei.\\\",\\\"_epochPeriod\\\":\\\"The duration of each epoch.\\\",\\\"_maxMissingBlocks\\\":\\\"The maximum number of blocks that can be missing in a challenge period.\\\",\\\"_minChallengePeriod\\\":\\\"The minimum time window to challenge a claim.\\\",\\\"_routerArbToGnosis\\\":\\\"The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\",\\\"_routerChainId\\\":\\\"The chain id of the routerArbToGnosis.\\\",\\\"_sequencerDelayLimit\\\":\\\"The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\",\\\"_timeoutEpochs\\\":\\\"The epochs before the bridge is considered shutdown.\\\",\\\"_weth\\\":\\\"The address of the WETH contract on Gnosis.\\\"}},\\\"devnetAdvanceState(uint256,bytes32)\\\":{\\\"details\\\":\\\"Testnet operator utility function to claim, validate and withdraw.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateroot\\\":\\\"The state root to claim.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Hashes the claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to hash.\\\"},\\\"returns\\\":{\\\"hashedClaim\\\":\\\"The hash of the claim.\\\"}},\\\"isMsgRelayed(uint256)\\\":{\\\"details\\\":\\\"Get the msg relayed status.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId to check.\\\"},\\\"returns\\\":{\\\"isRelayed\\\":\\\"True if the msg was relayed.\\\"}},\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves any challenge of the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch to verify.\\\",\\\"_stateRoot\\\":\\\"The true state root for the epoch.\\\"}},\\\"sendMessage(bytes32[],uint64,address,address,bytes)\\\":{\\\"details\\\":\\\"Verifies and relays the message. UNTRUSTED.\\\",\\\"params\\\":{\\\"_from\\\":\\\"The address of the contract on Arbitrum that sent the message.\\\",\\\"_message\\\":\\\"The message in the vea inbox\\\",\\\"_msgId\\\":\\\"The zero based index of the message in the inbox.\\\",\\\"_proof\\\":\\\"The merkle proof to prove the message inclusion in the inbox state root.\\\",\\\"_to\\\":\\\"The address of the contract on Gnosis to call.\\\"}},\\\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Start verification for claim for 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"updateSequencerDelayLimit(uint256,uint256)\\\":{\\\"details\\\":\\\"Set the sequencerDelayLimit by receiving a message from the AMB.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\",\\\"_timestamp\\\":\\\"The timestamp of the message.\\\"}},\\\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the optimistic claim.\\\"}},\\\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenge deposit to withraw.\\\"}},\\\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"notice\\\":\\\"Note: Access restricted to AMB.\\\"}},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol\\\":\\\"VeaOutboxArbToGnosisDevnet\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/gnosis-chain/IAMB.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/updaters/ISequencerDelayUpdatable.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/tokens/gnosis/IWETH.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/gateways/IReceiverGateway.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Gnosis.\\\\n/// Note: This contract is deployed on Gnosis.\\\\ncontract VeaOutboxArbToGnosis is IVeaOutboxOnL1, ISequencerDelayUpdatable {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    IAMB public immutable amb; // The address of the AMB contract on Gnosis.\\\\n    address public immutable routerArbToGnosis; // The address of the router from Arbitrum to Gnosis on ethereum.\\\\n\\\\n    IWETH public immutable weth; // The address of the WETH contract on Gnosis.\\\\n    uint256 public immutable deposit; // The deposit in wei required to submit a claim or challenge\\\\n    uint256 public immutable burn; // The amount of wei to burn. deposit / 2\\\\n    uint256 public immutable depositPlusReward; // 2 * deposit - burn\\\\n\\\\n    uint256 internal constant SLOT_TIME = 5; // Gnosis 5 second slot time\\\\n\\\\n    uint256 public immutable routerChainId; // Router chain id for authentication of messages from the AMB.\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    uint256 public immutable minChallengePeriod; // Minimum time window to challenge a claim, even with a malicious sequencer.\\\\n\\\\n    uint256 public immutable timeoutEpochs; // The number of epochs without forward progress before the bridge is considered shutdown.\\\\n    uint256 public immutable maxMissingBlocks; // The maximum number of blocks that can be missing in a challenge period.\\\\n\\\\n    bytes32 public stateRoot; // merkle root of the outbox state\\\\n    uint256 public latestVerifiedEpoch; // The latest epoch that has been verified.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public claimHashes; // epoch => claim\\\\n    mapping(uint256 messageId => bytes32) internal relayed; // msgId/256 => packed replay bitmap, preferred over a simple boolean mapping to save 15k gas per message\\\\n\\\\n    uint256 public sequencerDelayLimit; // This is MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox, it is the maximum seconds the sequencer can backdate L2 txns relative to the L1 clock.\\\\n    uint256 public timestampDelayUpdated; // The timestamp of the last sequencer delay update.\\\\n\\\\n    enum CensorshipTestStatus {\\\\n        Failed,\\\\n        Passed,\\\\n        NotStarted,\\\\n        InProgress\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Watchers check this event to challenge fraud.\\\\n    /// @param _claimer The address of the claimer.\\\\n    /// @param _epoch The epoch associated with the claim.\\\\n    /// @param _stateRoot The state root of the claim.\\\\n    event Claimed(address indexed _claimer, uint256 indexed _epoch, bytes32 _stateRoot);\\\\n\\\\n    /// @dev This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\\n    /// @param _epoch The epoch associated with the challenged claim.\\\\n    /// @param _challenger The address of the challenger.\\\\n    event Challenged(uint256 indexed _epoch, address indexed _challenger);\\\\n\\\\n    /// @dev This event indicates that a message has been relayed.\\\\n    /// @param _msgId The msgId of the message that was relayed.\\\\n    event MessageRelayed(uint64 _msgId);\\\\n\\\\n    /// @dev This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\\n    /// @param _epoch The epoch that started verification.\\\\n    event VerificationStarted(uint256 indexed _epoch);\\\\n\\\\n    /// @dev This events indicates that verification has succeeded. The messages are ready to be relayed.\\\\n    /// @param _epoch The epoch that was verified.\\\\n    event Verified(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates that a resolution has failed.\\\\n    /// @param _epoch The epoch for which resolution failed.\\\\n    event FailedResolution(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates the sequencer limit updated.\\\\n    /// @param _newSequencerDelayLimit The new sequencer delay limit.\\\\n    event SequencerDelayLimitUpdateReceived(uint256 _newSequencerDelayLimit);\\\\n\\\\n    // ************************************* //\\\\n    // *        Function Modifiers         * //\\\\n    // ************************************* //\\\\n\\\\n    modifier OnlyBridgeRunning() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch <= timeoutEpochs, \\\\\\\"Bridge Shutdown.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    modifier OnlyBridgeShutdown() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch > timeoutEpochs, \\\\\\\"Bridge Running.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _amb The address of the AMB contract on Gnosis.\\\\n    /// @param _routerArbToGnosis The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    /// @param _sequencerDelayLimit The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    /// @param _routerChainId The chain id of the routerArbToGnosis.\\\\n    /// @param _weth The address of the WETH contract on Gnosis.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        IAMB _amb,\\\\n        address _routerArbToGnosis,\\\\n        uint256 _sequencerDelayLimit,\\\\n        uint256 _maxMissingBlocks,\\\\n        uint256 _routerChainId,\\\\n        IWETH _weth\\\\n    ) {\\\\n        deposit = _deposit;\\\\n        // epochPeriod must match the VeaInboxArbToGnosis contract deployment epochPeriod value.\\\\n        epochPeriod = _epochPeriod;\\\\n        timeoutEpochs = _timeoutEpochs;\\\\n        minChallengePeriod = _minChallengePeriod;\\\\n        amb = _amb;\\\\n        routerArbToGnosis = _routerArbToGnosis;\\\\n        // This value is on another chain, so we can't read it, we trust the deployer to set a correct value.\\\\n        sequencerDelayLimit = _sequencerDelayLimit; // MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox\\\\n        maxMissingBlocks = _maxMissingBlocks;\\\\n        routerChainId = _routerChainId;\\\\n        weth = _weth;\\\\n\\\\n        // claimant and challenger are not sybil resistant\\\\n        // must burn half deposit to prevent zero cost griefing\\\\n        burn = _deposit / 2;\\\\n        depositPlusReward = 2 * _deposit - burn;\\\\n\\\\n        latestVerifiedEpoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *        Parameter Updates          * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Set the sequencerDelayLimit by receiving a message from the AMB.\\\\n    /// @param _newSequencerDelayLimit The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\\n    /// @param _timestamp The timestamp of the message.\\\\n    function updateSequencerDelayLimit(uint256 _newSequencerDelayLimit, uint256 _timestamp) external {\\\\n        require(msg.sender == address(amb), \\\\\\\"Not from bridge.\\\\\\\");\\\\n        require(bytes32(routerChainId) == amb.messageSourceChainId(), \\\\\\\"Invalid chain id.\\\\\\\");\\\\n        require(routerArbToGnosis == amb.messageSender(), \\\\\\\"Not from router.\\\\\\\");\\\\n        require(timestampDelayUpdated < _timestamp, \\\\\\\"Message is outdated.\\\\\\\");\\\\n\\\\n        if (sequencerDelayLimit != _newSequencerDelayLimit) {\\\\n            // If _newSequencerDelayLimit > timeout * epochPeriod, then the bridge will shutdown.\\\\n            sequencerDelayLimit = _newSequencerDelayLimit;\\\\n            timestampDelayUpdated = _timestamp;\\\\n            emit SequencerDelayLimitUpdateReceived(_newSequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) external virtual {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        unchecked {\\\\n            require(_epoch == block.timestamp / epochPeriod - 1, \\\\\\\"Epoch has not yet passed.\\\\\\\");\\\\n        }\\\\n\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function challenge(uint256 _epoch, Claim memory _claim) external {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim already challenged.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim already verified.\\\\\\\");\\\\n\\\\n        _claim.challenger = msg.sender;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Challenged(_epoch, msg.sender);\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        // sequencerDelayLimit + epochPeriod is the worst case time to sync the L2 state compared to L1 clock.\\\\n        // using checked arithmetic incase arbitrum governance sets sequencerDelayLimit to a large value\\\\n        require(\\\\n            block.timestamp - uint256(_claim.timestampClaimed) >= sequencerDelayLimit + epochPeriod,\\\\n            \\\\\\\"Claim must wait atleast maxL2StateSyncDelay.\\\\\\\"\\\\n        );\\\\n\\\\n        CensorshipTestStatus _censorshipTestStatus = censorshipTestStatus(_claim);\\\\n        require(\\\\n            _censorshipTestStatus == CensorshipTestStatus.NotStarted ||\\\\n                _censorshipTestStatus == CensorshipTestStatus.Failed,\\\\n            \\\\\\\"Claim verification in progress or already completed.\\\\\\\"\\\\n        );\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) external virtual OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n        require(censorshipTestStatus(_claim) == CensorshipTestStatus.Passed, \\\\\\\"Censorship test not passed.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// Note: Access restricted to AMB.\\\\n    /// @dev Resolves any challenge of the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(\\\\n        uint256 _epoch,\\\\n        bytes32 _stateRoot,\\\\n        Claim memory _claim\\\\n    ) external virtual OnlyBridgeRunning {\\\\n        // Ethereum -> Gnosis message authentication with the AMB, the canonical Ethereum <-> Gnosis bridge.\\\\n        // https://docs.tokenbridge.net/amb-bridge/development-of-a-cross-chain-application/how-to-develop-xchain-apps-by-amb#receive-a-method-call-from-the-amb-bridge\\\\n\\\\n        require(msg.sender == address(amb), \\\\\\\"Not from native Gnosis AMB bridge.\\\\\\\");\\\\n        require(bytes32(routerChainId) == amb.messageSourceChainId(), \\\\\\\"Invalid chain id.\\\\\\\");\\\\n        require(routerArbToGnosis == amb.messageSender(), \\\\\\\"Not from router.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch && _stateRoot != bytes32(0)) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _stateRoot;\\\\n        }\\\\n\\\\n        if (claimHashes[_epoch] == hashClaim(_claim)) {\\\\n            if (_claim.stateRoot == _stateRoot) {\\\\n                _claim.honest = Party.Claimer;\\\\n            } else if (_claim.challenger != address(0)) {\\\\n                _claim.honest = Party.Challenger;\\\\n            }\\\\n            claimHashes[_epoch] = hashClaim(_claim);\\\\n            emit Verified(_epoch);\\\\n        } else {\\\\n            emit FailedResolution(_epoch);\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Verifies and relays the message. UNTRUSTED.\\\\n    /// @param _proof The merkle proof to prove the message inclusion in the inbox state root.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address of the contract on Gnosis to call.\\\\n    /// @param _from The address of the contract on Arbitrum that sent the message.\\\\n    /// @param _message The message in the vea inbox\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external {\\\\n        require(_proof.length < 64, \\\\\\\"Proof too long.\\\\\\\");\\\\n\\\\n        bytes32 nodeHash = keccak256(abi.encodePacked(_msgId, _to, _from, _message));\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            mstore(0x00, nodeHash)\\\\n            nodeHash := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        unchecked {\\\\n            for (uint256 i = 0; i < _proof.length; i++) {\\\\n                bytes32 proofElement = _proof[i];\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                if (proofElement > nodeHash)\\\\n                    assembly {\\\\n                        mstore(0x00, nodeHash)\\\\n                        mstore(0x20, proofElement)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n                else\\\\n                    assembly {\\\\n                        mstore(0x00, proofElement)\\\\n                        mstore(0x20, nodeHash)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n            }\\\\n        }\\\\n\\\\n        require(stateRoot == nodeHash, \\\\\\\"Invalid proof.\\\\\\\");\\\\n\\\\n        // msgId is the zero-based index of the message in the inbox.\\\\n        // msgId is also used as an index in the relayed bitmap to prevent replay.\\\\n        // Note: a bitmap is used instead of a simple boolean mapping to save 15k gas per message.\\\\n\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        require(((replay >> offset) & bytes32(uint256(1))) == bytes32(0), \\\\\\\"Message already relayed\\\\\\\");\\\\n        relayed[relayIndex] = replay | bytes32(1 << offset);\\\\n\\\\n        // UNTRUSTED.\\\\n        IReceiverGateway(_to).receiveMessage(_from, _message);\\\\n\\\\n        emit MessageRelayed(_msgId);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim calldata _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            weth.burn(burn); // no return value to check\\\\n            require(weth.transfer(_claim.claimer, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        } else {\\\\n            require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\\n    /// @param _epoch The epoch associated with the challenge deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengeDeposit(uint256 _epoch, Claim calldata _claim) external {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Challenger, \\\\\\\"Challenge failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        weth.burn(burn); // no return value to check\\\\n        require(weth.transfer(_claim.challenger, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.claimer != address(0)) {\\\\n            if (_claim.challenger == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            } else {\\\\n                address claimer = _claim.claimer;\\\\n                _claim.claimer = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                require(weth.transfer(claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            if (_claim.claimer == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                require(weth.transfer(_claim.challenger, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            } else {\\\\n                address challenger = _claim.challenger;\\\\n                _claim.challenger = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                require(weth.transfer(challenger, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Hashes the claim.\\\\n    /// @param _claim The claim to hash.\\\\n    /// @return hashedClaim The hash of the claim.\\\\n    function hashClaim(Claim memory _claim) public pure returns (bytes32 hashedClaim) {\\\\n        return\\\\n            hashedClaim = keccak256(\\\\n                abi.encodePacked(\\\\n                    _claim.stateRoot,\\\\n                    _claim.claimer,\\\\n                    _claim.timestampClaimed,\\\\n                    _claim.timestampVerification,\\\\n                    _claim.blocknumberVerification,\\\\n                    _claim.honest,\\\\n                    _claim.challenger\\\\n                )\\\\n            );\\\\n    }\\\\n\\\\n    /// @dev Gets the status of the censorship test for claim.\\\\n    /// @param _claim The claim to test.\\\\n    /// @return status True if the claim passed the censorship test.\\\\n    function censorshipTestStatus(Claim memory _claim) public view returns (CensorshipTestStatus status) {\\\\n        unchecked {\\\\n            if (uint256(_claim.timestampVerification) == 0) {\\\\n                status = CensorshipTestStatus.NotStarted;\\\\n            } else if (block.timestamp - uint256(_claim.timestampVerification) < minChallengePeriod) {\\\\n                status = CensorshipTestStatus.InProgress;\\\\n            } else {\\\\n                uint256 expectedBlocks = uint256(_claim.blocknumberVerification) +\\\\n                    (block.timestamp - uint256(_claim.timestampVerification)) /\\\\n                    SLOT_TIME;\\\\n                uint256 actualBlocks = block.number;\\\\n                if (expectedBlocks - actualBlocks <= maxMissingBlocks) {\\\\n                    status = CensorshipTestStatus.Passed;\\\\n                } else {\\\\n                    status = CensorshipTestStatus.Failed;\\\\n                }\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochAt(uint256 timestamp) external view returns (uint256 epoch) {\\\\n        epoch = timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the msg relayed status.\\\\n    /// @param _msgId The msgId to check.\\\\n    /// @return isRelayed True if the msg was relayed.\\\\n    function isMsgRelayed(uint256 _msgId) external view returns (bool isRelayed) {\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        isRelayed = (replay >> offset) & bytes32(uint256(1)) == bytes32(uint256(1));\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe3c55b9bc884071a369179b51e841c737e48aa02581c3cb49a23dc2ce90bfadd\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/gnosis-chain/IAMB.sol\\\":{\\\"content\\\":\\\"// https://docs.gnosischain.com/bridges/tokenbridge/amb-bridge#gnosis\\\\n// https://github.com/omni/tokenbridge-contracts/blob/908a48107919d4ab127f9af07d44d47eac91547e/contracts/interfaces/IAMB.sol\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IAMB {\\\\n    function requireToPassMessage(address _contract, bytes memory _data, uint256 _gas) external returns (bytes32);\\\\n\\\\n    function maxGasPerTx() external view returns (uint256);\\\\n\\\\n    function messageSender() external view returns (address);\\\\n\\\\n    function messageSourceChainId() external view returns (bytes32);\\\\n\\\\n    event AffirmationCompleted(\\\\n        address indexed sender,\\\\n        address indexed executor,\\\\n        bytes32 indexed messageId,\\\\n        bool status\\\\n    );\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x372ecaa3858bc071e7a8a05f9d0695af518b0faa188d4d0bd800e29052ebcefc\\\"},\\\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../../arbitrumToGnosis/VeaOutboxArbToGnosis.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Chiado.\\\\n/// Note: This contract is deployed on Chiado.\\\\n/// Note: This contract is permissioned for developer testing (devnet).\\\\ncontract VeaOutboxArbToGnosisDevnet is VeaOutboxArbToGnosis {\\\\n    address public devnetOperator; // permissioned devnet operator\\\\n\\\\n    /// @dev Requires that the sender is the devnet operator.\\\\n    modifier onlyByDevnetOperator() {\\\\n        require(devnetOperator == msg.sender);\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Changes the devnet operator.\\\\n    /// @param _devnetOperator The new testnet operator.\\\\n    function changeDevnetOperator(address _devnetOperator) external onlyByDevnetOperator {\\\\n        require(msg.sender == devnetOperator, \\\\\\\"Invalid Testnet Operator\\\\\\\");\\\\n        devnetOperator = _devnetOperator;\\\\n    }\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) public override onlyByDevnetOperator {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) public override onlyByDevnetOperator {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim memory _claim) public override {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            weth.burn(burn); // no return value to check\\\\n            require(weth.transfer(_claim.claimer, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        } else {\\\\n            require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) public override OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Testnet operator utility function to claim, validate and withdraw.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateroot The state root to claim.\\\\n    function devnetAdvanceState(uint256 _epoch, bytes32 _stateroot) external payable {\\\\n        claim(_epoch, _stateroot);\\\\n        Claim memory claim = Claim({\\\\n            stateRoot: _stateroot,\\\\n            claimer: msg.sender,\\\\n            timestampClaimed: uint32(block.timestamp),\\\\n            timestampVerification: uint32(0),\\\\n            blocknumberVerification: uint32(0),\\\\n            honest: Party.None,\\\\n            challenger: address(0)\\\\n        });\\\\n        claim.timestampClaimed = uint32(block.timestamp);\\\\n        startVerification(_epoch, claim);\\\\n        claim.timestampVerification = uint32(block.timestamp);\\\\n        claim.blocknumberVerification = uint32(block.number);\\\\n        verifySnapshot(_epoch, claim);\\\\n        claim.honest = Party.Claimer;\\\\n        withdrawClaimDeposit(_epoch, claim);\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _amb The address of the AMB contract on Gnosis.\\\\n    /// @param _routerArbToGnosis The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    /// @param _sequencerDelayLimit The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    /// @param _routerChainId The chain id of the routerArbToGnosis.\\\\n    /// @param _weth The address of the WETH contract on Gnosis.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        IAMB _amb,\\\\n        address _routerArbToGnosis,\\\\n        uint256 _sequencerDelayLimit,\\\\n        uint256 _maxMissingBlocks,\\\\n        uint256 _routerChainId,\\\\n        IWETH _weth\\\\n    )\\\\n        VeaOutboxArbToGnosis(\\\\n            _deposit,\\\\n            _epochPeriod,\\\\n            _minChallengePeriod,\\\\n            _timeoutEpochs,\\\\n            _amb,\\\\n            _routerArbToGnosis,\\\\n            _sequencerDelayLimit,\\\\n            _maxMissingBlocks,\\\\n            _routerChainId,\\\\n            _weth\\\\n        )\\\\n    {\\\\n        devnetOperator = msg.sender;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x34e65c7f0d503df1f1a8be22a720c135c8e4a6746e696852bf9ef72cfaa6baf6\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/gateways/IReceiverGateway.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IReceiverGateway {\\\\n    function veaOutbox() external view returns (address);\\\\n\\\\n    function senderGateway() external view returns (address);\\\\n\\\\n    function receiveMessage(address msgSender, bytes calldata msgData) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe6917520400ac49fc28bf32acb29cc115d1f97789ad798336d46a4bb7d35a9be\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\n\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _from The address of the contract on L2 that sent the message, used for authentication.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x6c9a39add549daa58bd882a3949212afa73cabc75bda99a97583545a1d7622da\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/tokens/gnosis/IWETH.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\npragma solidity ^0.8.0;\\\\n\\\\n// https://github.com/OpenZeppelin/openzeppelin-contracts/blob/5daaf60d11ee2075260d0f3adfb22b1c536db983/contracts/token/ERC20/StandardBurnableToken.sol\\\\n// implementation: https://gnosisscan.io/address/0xf8d1677c8a0c961938bf2f9adc3f3cfda759a9d9#code\\\\n// proxy: https://gnosisscan.io/token/0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1#readProxyContract\\\\n\\\\n/**\\\\n * @title Standard Burnable Token\\\\n * @dev Token that can be irreversibly burned (destroyed).\\\\n */\\\\ninterface IWETH {\\\\n    /**\\\\n     * @dev Burns a specific amount of tokens.\\\\n     * @param _value The amount of token to be burned.\\\\n     */\\\\n    function burn(uint256 _value) external;\\\\n\\\\n    /**\\\\n     * @dev Gets the balance of the specified address.\\\\n     * @param _owner The address to query the the balance of.\\\\n     * @return An uint256 representing the amount owned by the passed address.\\\\n     */\\\\n    function balanceOf(address _owner) external view returns (uint256);\\\\n\\\\n    /**\\\\n     * @dev Transfer tokens from one address to another\\\\n     * @param _from address The address which you want to send tokens from\\\\n     * @param _to address The address which you want to transfer to\\\\n     * @param _value uint256 the amount of tokens to be transferred\\\\n     */\\\\n    function transferFrom(address _from, address _to, uint256 _value) external returns (bool);\\\\n\\\\n    /**\\\\n     * @dev Transfer token for a specified address\\\\n     * @param _to The address to transfer to.\\\\n     * @param _value The amount to be transferred.\\\\n     */\\\\n    function transfer(address _to, uint256 _value) external returns (bool);\\\\n\\\\n    /**\\\\n     * @dev Function to check the amount of tokens that an owner allowed to a spender.\\\\n     * @param _owner address The address which owns the funds.\\\\n     * @param _spender address The address which will spend the funds.\\\\n     * @return A uint256 specifying the amount of tokens still available for the spender.\\\\n     */\\\\n    function allowance(address _owner, address _spender) external view returns (uint256);\\\\n\\\\n    /**\\\\n     * @dev Approve the passed address to spend the specified amount of tokens on behalf of msg.sender.\\\\n     * Beware that changing an allowance with this method brings the risk that someone may use both the old\\\\n     * and the new allowance by unfortunate transaction ordering. One possible solution to mitigate this\\\\n     * race condition is to first reduce the spender's allowance to 0 and set the desired value afterwards:\\\\n     * https://github.com/ethereum/EIPs/issues/20#issuecomment-263524729\\\\n     * @param _spender The address which will spend the funds.\\\\n     * @param _value The amount of tokens to be spent.\\\\n     */\\\\n    function approve(address _spender, uint256 _value) external returns (bool);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xbdda7697ab9595ad33056b937c120f23ab64bd2aac8c2f7e54bf3afd2cdd7a31\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/updaters/ISequencerDelayUpdatable.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\n/// @dev Interface of a contract which is updatable, receiving parameter updates from an L1 contract through a cross-chain call.\\\\n/// @dev eg. Arbitrum (L2) -> Ethereum (L1) -> Gnosis (L1), the veaOutbox on Gnosis will be an ISequencerDelayUpdatable contract which receives updates from the router on Ethereum.\\\\ninterface ISequencerDelayUpdatable {\\\\n    /// @dev Updates the sequencer limit.\\\\n    /// Note: Access restricted to ensure the argument is passed from the Sequencer contract.\\\\n    /// @param _newSequencerDelayLimit The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\\n    /// @param _timestamp The timestamp of the message.\\\\n    function updateSequencerDelayLimit(uint256 _newSequencerDelayLimit, uint256 _timestamp) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x14dc56b2ebfe46008240e891c5a0521343ef535cf56ccb075387ea6323dbc6b8\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"0x6101e0346102ba57601f612d2f38819003918201601f19168301916001600160401b038311848410176102bf57808492610140946040528339810103126102ba578051906020810151906040810151606082015190608083015160018060a01b03811681036102ba5760a0840151906001600160a01b03821682036102ba5760c08501519260e0860151946101206101008801519701519760018060a01b03891689036102ba578960e052610160526101a0526101805260805260a0526004556101c0526101405260c0528060011c80610100528160011b9160018060ff1b0381160361028e57810390811161028e57610120526101605180156102a4574204600019810190811161028e57600155600680546001600160a01b03191633179055604051612a5990816102d6823960805181818161073d015281816109f50152610bac015260a05181818161082c01528181610c9901526118e4015260c05181818161058201528181610da901528181610f3a015281816110950152818161178501528181611bbe015281816125ff01526126fb015260e05181818161055301528181610d7b015281816117470152818161181e015281816118a10152611b8f015261010051818181610f890152818161110a015261264e01526101205181818161100d015261129a0152610140518181816107b301528181610c2101526113ae0152610160518181816106da01528181610a2c01528181611209015281816113f1015281816115b7015281816115fb0152818161192901526128cb0152610180518181816118660152611a8501526101a051818181610709015281816114210152818161157c0152818161162c0152818161195a01526128fb01526101c0518181816115410152611ad90152f35b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052601260045260246000fd5b600080fd5b634e487b7160e01b600052604160045260246000fdfe6080604052600436101561001257600080fd5b60003560e01c806301139b68146102475780630f0adca5146102425780631062b39a1461023d578063222ae786146102385780632639c0601461023357806327ee6bdd1461022e5780632b1fd57b146102295780632c1925191461022457806331d144571461021f5780633ce43cfd1461021a5780633fc8cef31461021557806343b066d51461021057806344df8e701461020b5780634788cb381461020657806349b4299e146102015780634a439cfe146101fc578063541adcca146101f75780637ffc2a6e146101f2578063836e344b146101ed5780638a619a71146101e85780638ad3a8f7146101e35780638d96fdea146101de578063930f28af146101d95780639588eca2146101d4578063aa22a1c6146101cf578063b044397e146101ca578063b5b7a184146101c5578063b633b944146101c0578063c2114a16146101bb578063d0e30db0146101b6578063d5e6a9df146101b1578063da2b7bc4146101ac578063df19e6ff146101a7578063e813a755146101a25763eedcf2a91461019d57600080fd5b611b37565b611b19565b611a2c565b611908565b6118c4565b611889565b61184e565b6115da565b61159f565b611564565b611529565b61150b565b6113d1565b611396565b61136f565b6112bd565b611282565b611264565b61123d565b6111f6565b611154565b61112d565b6110f2565b6110b9565b611075565b610e9a565b610d1e565b610b8b565b610aed565b610a8a565b610a5e565b610a19565b6109d5565b6106b6565b610501565b60e0810190811067ffffffffffffffff82111761026857604052565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b90601f7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe0910116810190811067ffffffffffffffff82111761026857604052565b604051906102e760e083610297565b565b6001600160a01b038116036102fa57565b600080fd5b604435906102e7826102e9565b606435906102e7826102e9565b35906102e7826102e9565b359063ffffffff821682036102fa57565b600311156102fa57565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffdc60e09101126102fa57604051906103768261024c565b816024358152604435610388816102e9565b602082015260643563ffffffff811681036102fa5760408201526103ac6084610324565b60608201526103bb60a4610324565b608082015260c4356103cc81610335565b60a082015260c06103dd60e4610319565b910152565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffbc60e09101126102fa57604051906104198261024c565b81604435815260643561042b816102e9565b602082015260843563ffffffff811681036102fa57604082015261044f60a4610324565b606082015261045e60c4610324565b608082015260e43561046f81610335565b60a082015260c06103dd610104610319565b60031960e09101126102fa576040519061049a8261024c565b8160043581526024356104ac816102e9565b602082015260443563ffffffff811681036102fa5760408201526104d06064610324565b60608201526104df6084610324565b608082015260a4356104f081610335565b60a082015260c06103dd60c4610319565b346102fa576101006003193601126102fa5760043561051f3661033f565b6040517f23b872dd0000000000000000000000000000000000000000000000000000000081523360048201523060248201527f000000000000000000000000000000000000000000000000000000000000000060448201529060208260648160007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03165af19182156106b157610644926105c991600091610682575b50611d50565b6105f06105e0846000526002602052604060002090565b546105ea83612851565b14611d9b565b61063f60c0820161061a6001600160a01b0361061383516001600160a01b031690565b1615611de6565b61063a60a084015161062b81611e31565b61063481611e31565b15611e3b565b339052565b612851565b610658826000526002602052604060002090565b5533907fcfe09ca25f55d949baba5e280f5750c9ba4b9048fca5532f916067d433afe4d7600080a3005b6106a4915060203d6020116106aa575b61069c8183610297565b810190611d2c565b386105c3565b503d610692565b611d44565b346102fa576101206003193601126102fa576004356024356106d7366103e2565b907f000000000000000000000000000000000000000000000000000000000000000080156109c55761073360015491827f0000000000000000000000000000000000000000000000000000000000000000914204031115611eb5565b6001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016610768813314611f00565b604051907f9e307dff000000000000000000000000000000000000000000000000000000008252602082600481845afa9081156106b1576107d8602092600494600091610998575b507f000000000000000000000000000000000000000000000000000000000000000014611f80565b604051928380927fd67bdd250000000000000000000000000000000000000000000000000000000082525afa9081156106b157610852916001600160a01b0391600091610969575b50166001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614611fe3565b831180610960575b61094e575b610873836000526002602052604060002090565b5461087d83612851565b0361091a57916108c2827ff786e7f77ede00a02a5464f8f0555798f42ba99a4a920ef2778db8d75e4656f7946108e79451146000146108ec57600160a0820152612851565b6108d6826000526002602052604060002090565b556040519081529081906020820190565b0390a1005b6001600160a01b0361090860c08301516001600160a01b031690565b161561285157600260a0820152612851565b50506040519081527fd691ce4b76450297347fc7fac60a91a18e6b16decddef79df8b6d67d890a064b9080602081016108e7565b61095783600155565b8060005561085f565b5080151561085a565b61098b915060203d602011610991575b6109838183610297565b810190611fcb565b38610820565b503d610979565b6109b89150843d86116109be575b6109b08183610297565b810190611f71565b386107b0565b503d6109a6565b611e86565b60009103126102fa57565b346102fa5760006003193601126102fa5760206040516001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000168152f35b346102fa5760006003193601126102fa577f000000000000000000000000000000000000000000000000000000000000000080156109c5576020906040519042048152f35b346102fa5760206003193601126102fa5760043560005260026020526020604060002054604051908152f35b346102fa5760006003193601126102fa576020600154604051908152f35b6024359067ffffffffffffffff821682036102fa57565b9181601f840112156102fa5782359167ffffffffffffffff83116102fa57602083818601950101116102fa57565b346102fa5760a06003193601126102fa5760043567ffffffffffffffff81116102fa57366023820112156102fa5780600401359067ffffffffffffffff82116102fa573660248360051b830101116102fa57610b47610aa8565b90610b506102ff565b610b5861030c565b906084359367ffffffffffffffff85116102fa57610b8995610b806024963690600401610abf565b96909501612215565b005b346102fa5760406003193601126102fa576004356024356001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016610bd78133146123fa565b604051907f9e307dff000000000000000000000000000000000000000000000000000000008252602082600481845afa9081156106b157610c4660209260049460009161099857507f000000000000000000000000000000000000000000000000000000000000000014611f80565b604051928380927fd67bdd250000000000000000000000000000000000000000000000000000000082525afa9081156106b157610cbf916001600160a01b03916000916109695750166001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001614611fe3565b610ccc8160055410612445565b8160045403610cd757005b81610d0e6108e792610d097f9c5113f22fcac086268c71488477822578ad93bd46c1993c9ce908d65e6fb2fe95600455565b600555565b6040519081529081906020820190565b346102fa5760406003193601126102fa576004356024356001600160a01b036006541633036102fa576040517f23b872dd0000000000000000000000000000000000000000000000000000000081523360048201523060248201527f0000000000000000000000000000000000000000000000000000000000000000604482015260208160648160007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03165af180156106b157610dea916000916106825750611d50565b610df5811515611d9b565b610e13610e0c836000526002602052604060002090565b5415612490565b610e55610e1e6102d8565b8281523360208201524263ffffffff1660408201525b6000606082015260006080820152600060a0820152600060c0820152612851565b610e69836000526002602052604060002090565b5560405190815233907fd95107f4584744c6c893a04c43058aadd1ce8aac8ca5d64140eaf277de6c1d5790602090a3005b346102fa576101006003193601126102fa5760043560e07fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffdc3601126102fa57610f2f81610f03610ef66000946000526002602052604060002090565b546105ea61063f3661033f565b610f1f6002610f106124db565b610f1981611e31565b146124e7565b6000526002602052604060002090565b556001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016803b156102fa576040517f42966c680000000000000000000000000000000000000000000000000000000081527f0000000000000000000000000000000000000000000000000000000000000000600482015260008160248183865af180156106b1576000926020926110409261105b575b50610fd5612532565b6040517fa9059cbb0000000000000000000000000000000000000000000000000000000081526001600160a01b0390911660048201527f0000000000000000000000000000000000000000000000000000000000000000602482015293849283919082906044820190565b03925af180156106b157610b89916000916106825750611d50565b806110698661106f93610297565b806109ca565b38610fcc565b346102fa5760006003193601126102fa5760206040516001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000168152f35b346102fa5760206003193601126102fa5760206001806004358060081c6000526003845260ff60406000205491161c1614604051908152f35b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa576101006003193601126102fa57610b8960043561114e3661033f565b90612589565b346102fa576101006003193601126102fa576004356111723661033f565b6001600160a01b036006541633036102fa576111c0908260005260026020526111a36040600020546105ea83612851565b63ffffffff4216606082015263ffffffff43166080820152612851565b8160005260026020526040600020557f37b700b61b9b4710dddb0c3316b2be7ef6088ed4b1d7bfe0fb98be8f9a163e16600080a2005b346102fa5760206003193601126102fa577f000000000000000000000000000000000000000000000000000000000000000060043581156109c55760209160405191048152f35b346102fa5760e06003193601126102fa57602061125c61063f36610481565b604051908152f35b346102fa5760006003193601126102fa576020600554604051908152f35b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa5760206003193601126102fa576004356112da816102e9565b600654906001600160a01b0382163381036102fa57330361132b576001600160a01b037fffffffffffffffffffffffff00000000000000000000000000000000000000009116911617600655600080f35b606460405162461bcd60e51b815260206004820152601860248201527f496e76616c696420546573746e6574204f70657261746f7200000000000000006044820152fd5b346102fa5760006003193601126102fa5760206001600160a01b0360065416604051908152f35b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa576101006003193601126102fa576004356113ef3661033f565b7f00000000000000000000000000000000000000000000000000000000000000009182156109c55761144b60015493847f0000000000000000000000000000000000000000000000000000000000000000914204031115611eb5565b8060005260026020526114666040600020546105ea84612851565b6001600160a01b0360c0830151166114c7576108c26108e7927ff786e7f77ede00a02a5464f8f0555798f42ba99a4a920ef2778db8d75e4656f79483116114b4575b600160a0820152612851565b6114bd83600155565b80516000556114a8565b606460405162461bcd60e51b815260206004820152601460248201527f436c61696d206973206368616c6c656e6765642e0000000000000000000000006044820152fd5b346102fa5760006003193601126102fa576020600054604051908152f35b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa576101006003193601126102fa576004356115f83661033f565b907f000000000000000000000000000000000000000000000000000000000000000080156109c557600154611651914204037f00000000000000000000000000000000000000000000000000000000000000001061298d565b611672611668826000526002602052604060002090565b546105ea84612851565b61169260a083015161168381611e31565b61168c81611e31565b156129d8565b60c08201916116a883516001600160a01b031690565b906001600160a01b0382166116b957005b6116dc6116d060208301516001600160a01b031690565b6001600160a01b031690565b6117be57505061170f6117779260006117016020946000526002602052604060002090565b55516001600160a01b031690565b6040517fa9059cbb0000000000000000000000000000000000000000000000000000000081526001600160a01b0390911660048201527f0000000000000000000000000000000000000000000000000000000000000000602482015291829081906044820190565b038160006001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000165af180156106b157610b89916000916106825750611d50565b916117e56117d460209460006117779752612851565b916000526002602052604060002090565b556040517fa9059cbb0000000000000000000000000000000000000000000000000000000081526001600160a01b0390911660048201527f0000000000000000000000000000000000000000000000000000000000000000602482015291829081906044820190565b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa5760006003193601126102fa5760206040517f00000000000000000000000000000000000000000000000000000000000000008152f35b346102fa5760006003193601126102fa5760206040516001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000168152f35b346102fa576101006003193601126102fa576004356119263661033f565b907f000000000000000000000000000000000000000000000000000000000000000080156109c55760015461197f914204037f00000000000000000000000000000000000000000000000000000000000000001061298d565b611996611668826000526002602052604060002090565b6119a760a083015161168381611e31565b60208201916119bd83516001600160a01b031690565b906001600160a01b0382166119ce57005b6116dc6116d060c08301516001600160a01b031690565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b919060208301926004821015611a275752565b6119e5565b346102fa5760e06003193601126102fa57611a4636610481565b611a63611a5a606083015163ffffffff1690565b63ffffffff1690565b80611a80575050611a7c60025b60405191829182611a14565b0390f35b4203907f0000000000000000000000000000000000000000000000000000000000000000821015611ab7575050611a7c6003611a70565b611ace611a5a6080611ad693015163ffffffff1690565b916005900490565b017f0000000000000000000000000000000000000000000000000000000000000000904390031115600014611b0f57611a7c6001611a70565b611a7c6000611a70565b346102fa5760006003193601126102fa576020600454604051908152f35b60406003193601126102fa576004356024356001600160a01b036006541633036102fa576040517f23b872dd0000000000000000000000000000000000000000000000000000000081523360048201523060248201527f000000000000000000000000000000000000000000000000000000000000000060448201529160208360648160007f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03165af19283156106b157610b8993611c04916000916106825750611d50565b611c0f821515611d9b565b611c26610e0c826000526002602052604060002090565b611d2763ffffffff4216611c55611c3b6102d8565b85815233602082015263ffffffff83166040820152610e34565b611c69846000526002602052604060002090565b55604051848152839033907fd95107f4584744c6c893a04c43058aadd1ce8aac8ca5d64140eaf277de6c1d5790602090a3611ca26102d8565b938452336020850152611d176040850191611cc381849063ffffffff169052565b611d0c606087019160008352608088019260008452611cf78260a08b019760008952600060c08d01529063ffffffff169052565b611d018989612734565b9063ffffffff169052565b4363ffffffff169052565b611d2184846128c8565b60019052565b612589565b908160209103126102fa575180151581036102fa5790565b6040513d6000823e3d90fd5b15611d5757565b606460405162461bcd60e51b815260206004820152601560248201527f4661696c65642057455448207472616e736665722e00000000000000000000006044820152fd5b15611da257565b606460405162461bcd60e51b815260206004820152600e60248201527f496e76616c696420636c61696d2e0000000000000000000000000000000000006044820152fd5b15611ded57565b606460405162461bcd60e51b815260206004820152601960248201527f436c61696d20616c7265616479206368616c6c656e6765642e000000000000006044820152fd5b60031115611a2757565b15611e4257565b606460405162461bcd60e51b815260206004820152601760248201527f436c61696d20616c72656164792076657269666965642e0000000000000000006044820152fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b15611ebc57565b606460405162461bcd60e51b815260206004820152601060248201527f4272696467652053687574646f776e2e000000000000000000000000000000006044820152fd5b15611f0757565b608460405162461bcd60e51b815260206004820152602260248201527f4e6f742066726f6d206e617469766520476e6f73697320414d4220627269646760448201527f652e0000000000000000000000000000000000000000000000000000000000006064820152fd5b908160209103126102fa575190565b15611f8757565b606460405162461bcd60e51b815260206004820152601160248201527f496e76616c696420636861696e2069642e0000000000000000000000000000006044820152fd5b908160209103126102fa5751611fe0816102e9565b90565b15611fea57565b606460405162461bcd60e51b815260206004820152601060248201527f4e6f742066726f6d20726f757465722e000000000000000000000000000000006044820152fd5b1561203557565b606460405162461bcd60e51b815260206004820152600f60248201527f50726f6f6620746f6f206c6f6e672e00000000000000000000000000000000006044820152fd5b927fffffffffffffffffffffffffffffffffffffffff0000000000000000000000009081879693947fffffffffffffffff0000000000000000000000000000000000000000000000006030999660c01b16875260601b16600886015260601b16601c8401528483013701016000815290565b91908110156120fb5760051b0190565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b1561213157565b606460405162461bcd60e51b815260206004820152600e60248201527f496e76616c69642070726f6f662e0000000000000000000000000000000000006044820152fd5b1561217c57565b606460405162461bcd60e51b815260206004820152601760248201527f4d65737361676520616c72656164792072656c617965640000000000000000006044820152fd5b9183606094601f926001600160a01b037fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe095168652604060208701528160408701528686013760008582860101520116010190565b9095929194956122276040821061202e565b8560405161226d81612241888c8b8a602086019889612079565b037fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffe08101835282610297565b5190206000526020600020916000915b8083106123b7575050509061229d6001600160a01b03926000541461212a565b6122bc600886901c66ffffffffffffff165b67ffffffffffffffff1690565b6123046122cb60ff88166122af565b60016122e1846000526003602052604060002090565b54916122f18284831c1615612175565b1b17916000526003602052604060002090565b5516803b156102fa5761234b9460008094604051978895869485937fbca8db71000000000000000000000000000000000000000000000000000000008552600485016121c0565b03925af19081156106b1577f54303fab361bc52c2f1f56ace7351189582264f74ce47a6e7c3f478d64c429439261239d926123a2575b5060405167ffffffffffffffff90911681529081906020820190565b0390a1565b8061106960006123b193610297565b38612381565b9091926123c58483856120eb565b3590808211156123e65760005260205260016040600020935b01919061227d565b9060005260205260016040600020936123de565b1561240157565b606460405162461bcd60e51b815260206004820152601060248201527f4e6f742066726f6d206272696467652e000000000000000000000000000000006044820152fd5b1561244c57565b606460405162461bcd60e51b815260206004820152601460248201527f4d657373616765206973206f757464617465642e0000000000000000000000006044820152fd5b1561249757565b606460405162461bcd60e51b815260206004820152601360248201527f436c61696d20616c7265616479206d6164652e000000000000000000000000006044820152fd5b60c435611fe081610335565b156124ee57565b606460405162461bcd60e51b815260206004820152601160248201527f4368616c6c656e6765206661696c65642e0000000000000000000000000000006044820152fd5b60e435611fe0816102e9565b1561254557565b606460405162461bcd60e51b815260206004820152600d60248201527f436c61696d206661696c65642e000000000000000000000000000000000000006044820152fd5b6125d26000916125b06125a6826000526002602052604060002090565b546105ea86612851565b610f1f600160a08601516125c381611e31565b6125cc81611e31565b1461253e565b556001600160a01b036125ef60c08301516001600160a01b031690565b16156126d5576001600160a01b037f000000000000000000000000000000000000000000000000000000000000000016803b156102fa576040517f42966c680000000000000000000000000000000000000000000000000000000081527f000000000000000000000000000000000000000000000000000000000000000060048201529160008360248183865af19182156106b157610fd560206126a69360009682966126c1575b5001516001600160a01b031690565b03925af180156106b1576102e7916000916106825750611d50565b80611069896126cf93610297565b38612697565b602061170f816126ed9301516001600160a01b031690565b038160006001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000165af180156106b1576102e7916000916106825750611d50565b906001600160a01b036006541633036102fa57612766908260005260026020526111a36040600020546105ea83612851565b8160005260026020526040600020557f37b700b61b9b4710dddb0c3316b2be7ef6088ed4b1d7bfe0fb98be8f9a163e16600080a2565b9594927fffffffff000000000000000000000000000000000000000000000000000000009491907fffffffffffffffffffffffffffffffffffffffff000000000000000000000000869485938a5260601b16602089015260e01b16603487015260e01b16603885015260e01b16603c8301526003811015611a27576055927fffffffffffffffffffffffffffffffffffffffff0000000000000000000000009160f81b604084015260601b1660418201520190565b8051906001600160a01b036020820151169063ffffffff6040820151169163ffffffff6060830151169163ffffffff6080820151169260a08201516003811015611a27576128c2946128b060c06122419501516001600160a01b031690565b92604051978896602088019a8b61279c565b51902090565b907f00000000000000000000000000000000000000000000000000000000000000009182156109c55761292560015493847f0000000000000000000000000000000000000000000000000000000000000000914204031115611eb5565b8060005260026020526129406040600020546105ea84612851565b6001600160a01b0360c0830151166114c7576108c261239d927ff786e7f77ede00a02a5464f8f0555798f42ba99a4a920ef2778db8d75e4656f79483116114b457600160a0820152612851565b1561299457565b606460405162461bcd60e51b815260206004820152600f60248201527f4272696467652052756e6e696e672e00000000000000000000000000000000006044820152fd5b156129df57565b606460405162461bcd60e51b815260206004820152600f60248201527f436c61696d207265736f6c7665642e00000000000000000000000000000000006044820152fdfea2646970667358221220ba96dc59c659824a21dbf6311734a3c9706d3a4bb651d45bfd8b4ca70dbf08f064736f6c634300081e0033\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Outbox From Arbitrum to Chiado. Note: This contract is deployed on Chiado. Note: This contract is permissioned for developer testing (devnet).\",\"events\":{\"Challenged(uint256,address)\":{\"details\":\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\",\"params\":{\"_challenger\":\"The address of the challenger.\",\"_epoch\":\"The epoch associated with the challenged claim.\"}},\"Claimed(address,uint256,bytes32)\":{\"details\":\"Watchers check this event to challenge fraud.\",\"params\":{\"_claimer\":\"The address of the claimer.\",\"_epoch\":\"The epoch associated with the claim.\",\"_stateRoot\":\"The state root of the claim.\"}},\"FailedResolution(uint256)\":{\"details\":\"This event indicates that a resolution has failed.\",\"params\":{\"_epoch\":\"The epoch for which resolution failed.\"}},\"MessageRelayed(uint64)\":{\"details\":\"This event indicates that a message has been relayed.\",\"params\":{\"_msgId\":\"The msgId of the message that was relayed.\"}},\"SequencerDelayLimitUpdateReceived(uint256)\":{\"details\":\"This event indicates the sequencer limit updated.\",\"params\":{\"_newSequencerDelayLimit\":\"The new sequencer delay limit.\"}},\"VerificationStarted(uint256)\":{\"details\":\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\",\"params\":{\"_epoch\":\"The epoch that started verification.\"}},\"Verified(uint256)\":{\"details\":\"This events indicates that verification has succeeded. The messages are ready to be relayed.\",\"params\":{\"_epoch\":\"The epoch that was verified.\"}}},\"kind\":\"dev\",\"methods\":{\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Gets the status of the censorship test for claim.\",\"params\":{\"_claim\":\"The claim to test.\"},\"returns\":{\"status\":\"True if the claim passed the censorship test.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"changeDevnetOperator(address)\":{\"details\":\"Changes the devnet operator.\",\"params\":{\"_devnetOperator\":\"The new testnet operator.\"}},\"claim(uint256,bytes32)\":{\"details\":\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateRoot\":\"The state root to claim.\"}},\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_amb\":\"The address of the AMB contract on Gnosis.\",\"_deposit\":\"The deposit amount to submit a claim in wei.\",\"_epochPeriod\":\"The duration of each epoch.\",\"_maxMissingBlocks\":\"The maximum number of blocks that can be missing in a challenge period.\",\"_minChallengePeriod\":\"The minimum time window to challenge a claim.\",\"_routerArbToGnosis\":\"The address of the router on Ethereum that routes from Arbitrum to Gnosis.\",\"_routerChainId\":\"The chain id of the routerArbToGnosis.\",\"_sequencerDelayLimit\":\"The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\",\"_timeoutEpochs\":\"The epochs before the bridge is considered shutdown.\",\"_weth\":\"The address of the WETH contract on Gnosis.\"}},\"devnetAdvanceState(uint256,bytes32)\":{\"details\":\"Testnet operator utility function to claim, validate and withdraw.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateroot\":\"The state root to claim.\"}},\"epochAt(uint256)\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Hashes the claim.\",\"params\":{\"_claim\":\"The claim to hash.\"},\"returns\":{\"hashedClaim\":\"The hash of the claim.\"}},\"isMsgRelayed(uint256)\":{\"details\":\"Get the msg relayed status.\",\"params\":{\"_msgId\":\"The msgId to check.\"},\"returns\":{\"isRelayed\":\"True if the msg was relayed.\"}},\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves any challenge of the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch to verify.\",\"_stateRoot\":\"The true state root for the epoch.\"}},\"sendMessage(bytes32[],uint64,address,address,bytes)\":{\"details\":\"Verifies and relays the message. UNTRUSTED.\",\"params\":{\"_from\":\"The address of the contract on Arbitrum that sent the message.\",\"_message\":\"The message in the vea inbox\",\"_msgId\":\"The zero based index of the message in the inbox.\",\"_proof\":\"The merkle proof to prove the message inclusion in the inbox state root.\",\"_to\":\"The address of the contract on Gnosis to call.\"}},\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Start verification for claim for 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"updateSequencerDelayLimit(uint256,uint256)\":{\"details\":\"Set the sequencerDelayLimit by receiving a message from the AMB.\",\"params\":{\"_newSequencerDelayLimit\":\"The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\",\"_timestamp\":\"The timestamp of the message.\"}},\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the optimistic claim.\"}},\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the challenge deposit to withraw.\"}},\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"notice\":\"Note: Access restricted to AMB.\"}},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":2663,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"stateRoot\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_bytes32\"},{\"astId\":2665,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"latestVerifiedEpoch\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"},{\"astId\":2669,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"claimHashes\",\"offset\":0,\"slot\":\"2\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":2673,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"relayed\",\"offset\":0,\"slot\":\"3\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":2675,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"sequencerDelayLimit\",\"offset\":0,\"slot\":\"4\",\"type\":\"t_uint256\"},{\"astId\":2677,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"timestampDelayUpdated\",\"offset\":0,\"slot\":\"5\",\"type\":\"t_uint256\"},{\"astId\":4706,\"contract\":\"src/devnets/arbitrumToGnosis/VeaOutboxArbToGnosisDevnet.sol:VeaOutboxArbToGnosisDevnet\",\"label\":\"devnetOperator\",\"offset\":0,\"slot\":\"6\",\"type\":\"t_address\"}],\"types\":{\"t_address\":{\"encoding\":\"inplace\",\"label\":\"address\",\"numberOfBytes\":\"20\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"}}}}");


var $b6e6298eee266421$exports = {};
$b6e6298eee266421$exports = JSON.parse("{\"address\":\"0x162f826E18380567CE0548395a3Ad2A54EA87B96\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"address\",\"name\":\"_routerArbToGnosis\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes\",\"name\":\"_nodeData\",\"type\":\"bytes\"}],\"name\":\"MessageSent\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_snapshot\",\"type\":\"bytes32\"},{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_count\",\"type\":\"uint64\"}],\"name\":\"SnapshotSaved\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epochSent\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_ticketId\",\"type\":\"bytes32\"}],\"name\":\"SnapshotSent\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"count\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochFinalized\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerArbToGnosis\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"saveSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_data\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[{\"internalType\":\"uint64\",\"name\":\"\",\"type\":\"uint64\"}],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_gasLimit\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"sendSnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"snapshots\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"}],\"transactionHash\":\"0x08aeaeb11eca9a0015da03a06603079489941d3ce5d41b611ca4c51ff6bacf03\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0x162f826E18380567CE0548395a3Ad2A54EA87B96\",\"transactionIndex\":4,\"gasUsed\":\"796571\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x8e47c21aab960e703808ee0b984c018359ad620021d157b56bda6b07ed37acf1\",\"transactionHash\":\"0x08aeaeb11eca9a0015da03a06603079489941d3ce5d41b611ca4c51ff6bacf03\",\"logs\":[],\"blockNumber\":189389497,\"cumulativeGasUsed\":\"1398712\",\"status\":1,\"byzantium\":true},\"args\":[3600,\"0xd7C54E4cA686a8C51D44534AC6b756676961Fccf\"],\"numDeployments\":5,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_routerArbToGnosis\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_nodeData\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"MessageSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_snapshot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_count\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"SnapshotSaved\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochSent\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_ticketId\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"SnapshotSent\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"count\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochFinalized\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerArbToGnosis\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"saveSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_data\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_gasLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"sendSnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"snapshots\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Inbox From Arbitrum to Gnosis. Note: This contract is deployed on the Arbitrum.\\\",\\\"events\\\":{\\\"MessageSent(bytes)\\\":{\\\"details\\\":\\\"Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\\\",\\\"params\\\":{\\\"_nodeData\\\":\\\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\"}},\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"params\\\":{\\\"_count\\\":\\\"The count of messages in the merkle tree.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot.\\\",\\\"_snapshot\\\":\\\"The snapshot of the merkle tree state root.\\\"}},\\\"SnapshotSent(uint256,bytes32)\\\":{\\\"details\\\":\\\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\",\\\"params\\\":{\\\"_epochSent\\\":\\\"The epoch of the snapshot.\\\",\\\"_ticketId\\\":\\\"The ticketId of the L2->L1 message.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_epochPeriod\\\":\\\"The duration in seconds between epochs.\\\",\\\"_routerArbToGnosis\\\":\\\"The router on Ethereum that routes from Arbitrum to Gnosis.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the epoch from the inbox's point of view using timestamp.\\\",\\\"params\\\":{\\\"_timestamp\\\":\\\"The timestamp to calculate the epoch from.\\\"},\\\"returns\\\":{\\\"epoch\\\":\\\"The calculated epoch.\\\"}},\\\"epochFinalized()\\\":{\\\"details\\\":\\\"Get the most recent epoch for which snapshots are finalized.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The epoch associated with the current inbox block.timestamp\\\"}},\\\"saveSnapshot()\\\":{\\\"details\\\":\\\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\\\"},\\\"sendMessage(address,bytes)\\\":{\\\"details\\\":\\\"Sends an arbitrary message to Gnosis.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\\\",\\\"params\\\":{\\\"_data\\\":\\\"The message data for the receiving gateway.\\\",\\\"_to\\\":\\\"The address of the contract on the receiving chain which receives the message.\\\"},\\\"returns\\\":{\\\"_0\\\":\\\"msgId The zero based index of the message in the inbox.\\\"}},\\\"sendSnapshot(uint256,uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the state root snapshot using Arbitrum's canonical bridge.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the snapshot requested to send.\\\",\\\"_gasLimit\\\":\\\"The gas limit for the AMB transaction on Gnosis.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"events\\\":{\\\"SnapshotSaved(bytes32,uint256,uint64)\\\":{\\\"notice\\\":\\\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\"}},\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol\\\":\\\"VeaInboxArbToGnosis\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/arbitrum/IArbSys.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/inboxes/IVeaInbox.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/routers/IRouterToGnosis.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Inbox From Arbitrum to Gnosis.\\\\n/// Note: This contract is deployed on the Arbitrum.\\\\ncontract VeaInboxArbToGnosis is IVeaInbox {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    // Arbitrum precompile ArbSys for L2->L1 messaging: https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n    IArbSys internal constant ARB_SYS = IArbSys(address(100));\\\\n\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    address public immutable routerArbToGnosis; // The router on ethereum.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public snapshots; // epoch => state root snapshot\\\\n\\\\n    // Inbox represents minimum data availability to maintain incremental merkle tree.\\\\n    // Supports a max of 2^64 - 1 messages. See merkle tree docs for details how inbox manages state.\\\\n\\\\n    bytes32[64] internal inbox; // stores minimal set of complete subtree roots of the merkle tree to increment.\\\\n    uint64 public count; // count of messages in the merkle tree\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\\\\n    /// @param _nodeData The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\\\\n    event MessageSent(bytes _nodeData);\\\\n\\\\n    /// The bridgers can watch this event to claim the stateRoot on the veaOutbox.\\\\n    /// @param _snapshot The snapshot of the merkle tree state root.\\\\n    /// @param _epoch The epoch of the snapshot.\\\\n    /// @param _count The count of messages in the merkle tree.\\\\n    event SnapshotSaved(bytes32 _snapshot, uint256 _epoch, uint64 _count);\\\\n\\\\n    /// @dev The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\\\\n    /// @param _epochSent The epoch of the snapshot.\\\\n    /// @param _ticketId The ticketId of the L2->L1 message.\\\\n    event SnapshotSent(uint256 indexed _epochSent, bytes32 _ticketId);\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _epochPeriod The duration in seconds between epochs.\\\\n    /// @param _routerArbToGnosis The router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    constructor(uint256 _epochPeriod, address _routerArbToGnosis) {\\\\n        epochPeriod = _epochPeriod;\\\\n        routerArbToGnosis = _routerArbToGnosis;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Sends an arbitrary message to Gnosis.\\\\n    ///      `O(log(count))` where count is the number of messages already sent.\\\\n    ///      Amortized cost is constant.\\\\n    /// Note: See docs for details how inbox manages merkle tree state.\\\\n    /// @param _to The address of the contract on the receiving chain which receives the message.\\\\n    /// @param _data The message data for the receiving gateway.\\\\n    /// @return msgId The zero based index of the message in the inbox.\\\\n    function sendMessage(address _to, bytes calldata _data) external override returns (uint64) {\\\\n        uint64 oldCount = count;\\\\n\\\\n        // Given arbitrum's speed limit of 7 million gas / second, it would take atleast 8 million years of full blocks to overflow.\\\\n        // It *should* be impossible to overflow, but we check to be safe when appending to the tree.\\\\n        require(oldCount < type(uint64).max, \\\\\\\"Inbox is full.\\\\\\\");\\\\n\\\\n        bytes memory nodeData = abi.encodePacked(oldCount, _to, msg.sender, _data);\\\\n\\\\n        // single hashed leaf\\\\n        bytes32 newInboxNode = keccak256(nodeData);\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            // efficient hash using EVM scratch space\\\\n            mstore(0x00, newInboxNode)\\\\n            newInboxNode := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        // increment merkle tree calculating minimal number of hashes\\\\n        unchecked {\\\\n            uint256 height;\\\\n\\\\n            // x = oldCount + 1; acts as a bit mask to determine if a hash is needed\\\\n            // note: x is always non-zero, and x is bit shifted to the right each loop\\\\n            // hence this loop will always terminate in a maximum of log_2(oldCount + 1) iterations\\\\n            for (uint64 x = oldCount + 1; x & 1 == 0; x = x >> 1) {\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                newInboxNode = sortConcatAndHash(inbox[height], newInboxNode);\\\\n                height++;\\\\n            }\\\\n\\\\n            inbox[height] = newInboxNode;\\\\n\\\\n            // finally increment count\\\\n            count = oldCount + 1;\\\\n        }\\\\n\\\\n        emit MessageSent(nodeData);\\\\n\\\\n        // old count is the zero indexed leaf position in the tree, acts as a msgId\\\\n        // gateways should index these msgIds to later relay proofs\\\\n        return oldCount;\\\\n    }\\\\n\\\\n    /// @dev Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    /// Note: See merkle tree docs for details how inbox manages state.\\\\n    function saveSnapshot() external {\\\\n        uint256 epoch;\\\\n        bytes32 stateRoot;\\\\n\\\\n        unchecked {\\\\n            epoch = block.timestamp / epochPeriod;\\\\n\\\\n            // calculate the current root of the incremental merkle tree encoded in the inbox\\\\n\\\\n            uint256 height;\\\\n\\\\n            // x acts as a bit mask to determine if the hash stored in the inbox contributes to the root\\\\n            uint256 x;\\\\n\\\\n            // x is bit shifted to the right each loop, hence this loop will always terminate in a maximum of log_2(count) iterations\\\\n            for (x = uint256(count); x > 0; x = x >> 1) {\\\\n                if ((x & 1) == 1) {\\\\n                    // first hash is special case\\\\n                    // inbox stores the root of complete subtrees\\\\n                    // eg if count = 4 = 0b100, then the first complete subtree is inbox[2]\\\\n                    // inbox = [H(3), H(1,2), H(1,4)], we read inbox[2] directly\\\\n\\\\n                    stateRoot = inbox[height];\\\\n                    break;\\\\n                }\\\\n                height++;\\\\n            }\\\\n\\\\n            // after the first hash, we can calculate the root incrementally\\\\n            for (x = x >> 1; x > 0; x = x >> 1) {\\\\n                height++;\\\\n                if ((x & 1) == 1) {\\\\n                    // sort sibling hashes as a convention for efficient proof validation\\\\n                    stateRoot = sortConcatAndHash(inbox[height], stateRoot);\\\\n                }\\\\n            }\\\\n        }\\\\n\\\\n        snapshots[epoch] = stateRoot;\\\\n\\\\n        emit SnapshotSaved(stateRoot, epoch, count);\\\\n    }\\\\n\\\\n    /// @dev Helper function to calculate merkle tree interior nodes by sorting and concatenating and hashing a pair of children nodes, left and right.\\\\n    /// Note: EVM scratch space is used to efficiently calculate hashes.\\\\n    /// @param _left The left hash.\\\\n    /// @param _right The right hash.\\\\n    /// @return parent The parent hash.\\\\n    function sortConcatAndHash(bytes32 _left, bytes32 _right) internal pure returns (bytes32 parent) {\\\\n        // sort sibling hashes as a convention for efficient proof validation\\\\n        if (_left < _right) {\\\\n            // efficient hash using EVM scratch space\\\\n            assembly {\\\\n                mstore(0x00, _left)\\\\n                mstore(0x20, _right)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        } else {\\\\n            assembly {\\\\n                mstore(0x00, _right)\\\\n                mstore(0x20, _left)\\\\n                parent := keccak256(0x00, 0x40)\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the state root snapshot using Arbitrum's canonical bridge.\\\\n    /// @param _epoch The epoch of the snapshot requested to send.\\\\n    /// @param _gasLimit The gas limit for the AMB transaction on Gnosis.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function sendSnapshot(uint256 _epoch, uint256 _gasLimit, Claim memory _claim) external virtual {\\\\n        unchecked {\\\\n            require(_epoch < block.timestamp / epochPeriod, \\\\\\\"Can only send past epoch snapshot.\\\\\\\");\\\\n        }\\\\n\\\\n        bytes memory data = abi.encodeCall(IRouterToGnosis.route, (_epoch, snapshots[_epoch], _gasLimit, _claim));\\\\n\\\\n        // Arbitrum -> Ethereum message with native bridge\\\\n        // docs: https://developer.arbitrum.io/for-devs/cross-chain-messsaging#arbitrum-to-ethereum-messaging\\\\n        // example: https://github.com/OffchainLabs/arbitrum-tutorials/blob/2c1b7d2db8f36efa496e35b561864c0f94123a5f/packages/greeter/contracts/arbitrum/GreeterL2.sol#L25\\\\n        bytes32 ticketID = bytes32(ARB_SYS.sendTxToL1(routerArbToGnosis, data));\\\\n\\\\n        emit SnapshotSent(_epoch, ticketID);\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the most recent epoch for which snapshots are finalized.\\\\n    /// @return epoch The epoch associated with the current inbox block.timestamp\\\\n    function epochFinalized() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    /// @dev Get the epoch from the inbox's point of view using timestamp.\\\\n    /// @param _timestamp The timestamp to calculate the epoch from.\\\\n    /// @return epoch The calculated epoch.\\\\n    function epochAt(uint256 _timestamp) external view returns (uint256 epoch) {\\\\n        epoch = _timestamp / epochPeriod;\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xf49f7400be9786fb3713bb6dbbc24bab5b0243d164e535c598e19ba073d8c212\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/arbitrum/IArbSys.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: BUSL-1.1\\\\n// https://developer.arbitrum.io/arbos/precompiles#arbsys\\\\n// https://github.com/OffchainLabs/nitro-contracts/blob/39ea5a163afc637e2706d9be29cf7a289c300d00/src/precompiles/ArbSys.sol\\\\n// https://arbiscan.io/address/0x0000000000000000000000000000000000000064#code\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\n///@title System level functionality\\\\n///@notice For use by contracts to interact with core L2-specific functionality.\\\\n///Precompiled contract that exists in every Arbitrum chain at address(100), 0x0000000000000000000000000000000000000064.\\\\ninterface IArbSys {\\\\n    /// @notice Send a transaction to L1\\\\n    /// @dev it is not possible to execute on the L1 any L2-to-L1 transaction which contains data\\\\n    /// to a contract address without any code (as enforced by the Bridge contract).\\\\n    /// @param destination recipient address on L1\\\\n    /// @param data (optional) calldata for L1 contract call\\\\n    /// @return a unique identifier for this L2-to-L1 transaction.\\\\n    function sendTxToL1(address destination, bytes calldata data) external payable returns (uint256);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x62893c290f2797daa4aebbbb5eb9b2b1d5e7d622b02928b0198450da34bf6293\\\",\\\"license\\\":\\\"BUSL-1.1\\\"},\\\"src/interfaces/inboxes/IVeaInbox.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IVeaInbox {\\\\n    /// @dev Sends an arbitrary message to receiving chain.\\\\n    /// Note: Calls authenticated by receiving gateway checking the sender argument.\\\\n    /// @param _to The cross-domain contract address which receives the message.\\\\n    /// @param _data The message data.\\\\n    /// @return msgId The index of the message in the inbox, as a message Id, needed to relay the message.\\\\n    function sendMessage(address _to, bytes calldata _data) external returns (uint64 msgId);\\\\n\\\\n    /// @dev Snapshots can be saved a maximum of once per epoch.\\\\n    ///      Saves snapshot of state root.\\\\n    ///      `O(log(count))` where count number of messages in the inbox.\\\\n    function saveSnapshot() external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x035e770f7b6e434b07e14ffb3283e61584eac8563c93ca587e42aa7a85504d02\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/routers/IRouterToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Router which routes messages to Gnosis through the AMB.\\\\n/// @dev eg. L2 on Ethereum -> Ethereum (L1) -> Gnosis (L1), the IRouterToL1 will be deployed on Ethereum (L1) routing messages to Gnosis (L1).\\\\ninterface IRouterToGnosis {\\\\n    /// @dev Routes state root snapshots through intermediary chains to the final destination L1 chain.\\\\n    /// Note: Access restricted to canonical sending-chain bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _gasLimit The gas limit for the AMB message.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function route(uint256 _epoch, bytes32 _stateRoot, uint256 _gasLimit, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe47fe750db4b12bff2825937852c7d525b6f5e7385ab9e1b9fbe54d8e8e44540\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Inbox From Arbitrum to Gnosis. Note: This contract is deployed on the Arbitrum.\",\"events\":{\"MessageSent(bytes)\":{\"details\":\"Relayers watch for these events to construct merkle proofs to execute transactions on Gnosis.\",\"params\":{\"_nodeData\":\"The data to create leaves in the merkle tree. abi.encodePacked(msgId, to, message), outbox relays to.call(message).\"}},\"SnapshotSaved(bytes32,uint256,uint64)\":{\"params\":{\"_count\":\"The count of messages in the merkle tree.\",\"_epoch\":\"The epoch of the snapshot.\",\"_snapshot\":\"The snapshot of the merkle tree state root.\"}},\"SnapshotSent(uint256,bytes32)\":{\"details\":\"The event is emitted when a snapshot is sent through the canonical arbitrum bridge.\",\"params\":{\"_epochSent\":\"The epoch of the snapshot.\",\"_ticketId\":\"The ticketId of the L2->L1 message.\"}}},\"kind\":\"dev\",\"methods\":{\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaOutboxArbToGnosis contract deployment on Gnosis, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_epochPeriod\":\"The duration in seconds between epochs.\",\"_routerArbToGnosis\":\"The router on Ethereum that routes from Arbitrum to Gnosis.\"}},\"epochAt(uint256)\":{\"details\":\"Get the epoch from the inbox's point of view using timestamp.\",\"params\":{\"_timestamp\":\"The timestamp to calculate the epoch from.\"},\"returns\":{\"epoch\":\"The calculated epoch.\"}},\"epochFinalized()\":{\"details\":\"Get the most recent epoch for which snapshots are finalized.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the inbox's point of view using the Arbitrum L2 clock.\",\"returns\":{\"epoch\":\"The epoch associated with the current inbox block.timestamp\"}},\"saveSnapshot()\":{\"details\":\"Saves snapshot of state root. Snapshots can be saved a maximum of once per epoch.      `O(log(count))` where count number of messages in the inbox. Note: See merkle tree docs for details how inbox manages state.\"},\"sendMessage(address,bytes)\":{\"details\":\"Sends an arbitrary message to Gnosis.      `O(log(count))` where count is the number of messages already sent.      Amortized cost is constant. Note: See docs for details how inbox manages merkle tree state.\",\"params\":{\"_data\":\"The message data for the receiving gateway.\",\"_to\":\"The address of the contract on the receiving chain which receives the message.\"},\"returns\":{\"_0\":\"msgId The zero based index of the message in the inbox.\"}},\"sendSnapshot(uint256,uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the state root snapshot using Arbitrum's canonical bridge.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the snapshot requested to send.\",\"_gasLimit\":\"The gas limit for the AMB transaction on Gnosis.\"}}},\"version\":1},\"userdoc\":{\"events\":{\"SnapshotSaved(bytes32,uint256,uint64)\":{\"notice\":\"The bridgers can watch this event to claim the stateRoot on the veaOutbox.\"}},\"kind\":\"user\",\"methods\":{},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":2251,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"snapshots\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":2255,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"inbox\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_array(t_bytes32)64_storage\"},{\"astId\":2257,\"contract\":\"src/arbitrumToGnosis/VeaInboxArbToGnosis.sol:VeaInboxArbToGnosis\",\"label\":\"count\",\"offset\":0,\"slot\":\"65\",\"type\":\"t_uint64\"}],\"types\":{\"t_array(t_bytes32)64_storage\":{\"base\":\"t_bytes32\",\"encoding\":\"inplace\",\"label\":\"bytes32[64]\",\"numberOfBytes\":\"2048\"},\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"},\"t_uint64\":{\"encoding\":\"inplace\",\"label\":\"uint64\",\"numberOfBytes\":\"8\"}}}}");


var $194660b3eb6b0e40$exports = {};
$194660b3eb6b0e40$exports = JSON.parse("{\"address\":\"0x15aC29269b044E1d9042F597513B27Ffa4A7f257\",\"abi\":[{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_deposit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_epochPeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_minChallengePeriod\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timeoutEpochs\",\"type\":\"uint256\"},{\"internalType\":\"contract IAMB\",\"name\":\"_amb\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_routerArbToGnosis\",\"type\":\"address\"},{\"internalType\":\"uint256\",\"name\":\"_sequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_maxMissingBlocks\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_routerChainId\",\"type\":\"uint256\"},{\"internalType\":\"contract IWETH\",\"name\":\"_weth\",\"type\":\"address\"}],\"stateMutability\":\"nonpayable\",\"type\":\"constructor\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_challenger\",\"type\":\"address\"}],\"name\":\"Challenged\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"address\",\"name\":\"_claimer\",\"type\":\"address\"},{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"indexed\":false,\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"Claimed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"FailedResolution\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"}],\"name\":\"MessageRelayed\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"}],\"name\":\"SequencerDelayLimitUpdateReceived\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":true,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"VerificationStarted\",\"type\":\"event\"},{\"anonymous\":false,\"inputs\":[{\"indexed\":false,\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"}],\"name\":\"Verified\",\"type\":\"event\"},{\"inputs\":[],\"name\":\"amb\",\"outputs\":[{\"internalType\":\"contract IAMB\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"burn\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"censorshipTestStatus\",\"outputs\":[{\"internalType\":\"enum VeaOutboxArbToGnosis.CensorshipTestStatus\",\"name\":\"status\",\"type\":\"uint8\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"challenge\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"}],\"name\":\"claim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"name\":\"claimHashes\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"deposit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"depositPlusReward\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"timestamp\",\"type\":\"uint256\"}],\"name\":\"epochAt\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochNow\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"epoch\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"epochPeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"hashClaim\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"hashedClaim\",\"type\":\"bytes32\"}],\"stateMutability\":\"pure\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_msgId\",\"type\":\"uint256\"}],\"name\":\"isMsgRelayed\",\"outputs\":[{\"internalType\":\"bool\",\"name\":\"isRelayed\",\"type\":\"bool\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"latestVerifiedEpoch\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"maxMissingBlocks\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"minChallengePeriod\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"internalType\":\"bytes32\",\"name\":\"_stateRoot\",\"type\":\"bytes32\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"resolveDisputedClaim\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerArbToGnosis\",\"outputs\":[{\"internalType\":\"address\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"routerChainId\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"bytes32[]\",\"name\":\"_proof\",\"type\":\"bytes32[]\"},{\"internalType\":\"uint64\",\"name\":\"_msgId\",\"type\":\"uint64\"},{\"internalType\":\"address\",\"name\":\"_to\",\"type\":\"address\"},{\"internalType\":\"address\",\"name\":\"_from\",\"type\":\"address\"},{\"internalType\":\"bytes\",\"name\":\"_message\",\"type\":\"bytes\"}],\"name\":\"sendMessage\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"sequencerDelayLimit\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"startVerification\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"stateRoot\",\"outputs\":[{\"internalType\":\"bytes32\",\"name\":\"\",\"type\":\"bytes32\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timeoutEpochs\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"timestampDelayUpdated\",\"outputs\":[{\"internalType\":\"uint256\",\"name\":\"\",\"type\":\"uint256\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_newSequencerDelayLimit\",\"type\":\"uint256\"},{\"internalType\":\"uint256\",\"name\":\"_timestamp\",\"type\":\"uint256\"}],\"name\":\"updateSequencerDelayLimit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"verifySnapshot\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[],\"name\":\"weth\",\"outputs\":[{\"internalType\":\"contract IWETH\",\"name\":\"\",\"type\":\"address\"}],\"stateMutability\":\"view\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengeDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawChallengerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimDeposit\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"},{\"inputs\":[{\"internalType\":\"uint256\",\"name\":\"_epoch\",\"type\":\"uint256\"},{\"components\":[{\"internalType\":\"bytes32\",\"name\":\"stateRoot\",\"type\":\"bytes32\"},{\"internalType\":\"address\",\"name\":\"claimer\",\"type\":\"address\"},{\"internalType\":\"uint32\",\"name\":\"timestampClaimed\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"timestampVerification\",\"type\":\"uint32\"},{\"internalType\":\"uint32\",\"name\":\"blocknumberVerification\",\"type\":\"uint32\"},{\"internalType\":\"enum Party\",\"name\":\"honest\",\"type\":\"uint8\"},{\"internalType\":\"address\",\"name\":\"challenger\",\"type\":\"address\"}],\"internalType\":\"struct Claim\",\"name\":\"_claim\",\"type\":\"tuple\"}],\"name\":\"withdrawClaimerEscapeHatch\",\"outputs\":[],\"stateMutability\":\"nonpayable\",\"type\":\"function\"}],\"transactionHash\":\"0x85373ee7393179e085485fd334e00da805be2702b07c3ca679f1da94c61c1566\",\"receipt\":{\"to\":null,\"from\":\"0x33dbD61Eee31551073D9F81cEd96eb924D6f10F7\",\"contractAddress\":\"0x15aC29269b044E1d9042F597513B27Ffa4A7f257\",\"transactionIndex\":0,\"gasUsed\":\"2457219\",\"logsBloom\":\"0x00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000\",\"blockHash\":\"0x5d9e7679a8c01316d85abe2ff4b0a28de7d1d7fd556756db9c1ed035a11abd29\",\"transactionHash\":\"0x85373ee7393179e085485fd334e00da805be2702b07c3ca679f1da94c61c1566\",\"logs\":[],\"blockNumber\":17544978,\"cumulativeGasUsed\":\"2457219\",\"status\":1,\"byzantium\":true},\"args\":[\"200000000000000000\",3600,10800,1000000,\"0x8448E15d0e706C0298dECA99F0b4744030e59d7d\",\"0xd7C54E4cA686a8C51D44534AC6b756676961Fccf\",86400,1000000,11155111,\"0x8d74e5e4DA11629537C4575cB0f33b4F0Dfa42EB\"],\"numDeployments\":4,\"solcInputHash\":\"45d0cd9baa9ba6d097f0473f35665f20\",\"metadata\":\"{\\\"compiler\\\":{\\\"version\\\":\\\"0.8.30+commit.73712a01\\\"},\\\"language\\\":\\\"Solidity\\\",\\\"output\\\":{\\\"abi\\\":[{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_deposit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epochPeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_minChallengePeriod\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timeoutEpochs\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"contract IAMB\\\",\\\"name\\\":\\\"_amb\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_routerArbToGnosis\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_sequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_maxMissingBlocks\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_routerChainId\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"contract IWETH\\\",\\\"name\\\":\\\"_weth\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"constructor\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"name\\\":\\\"Challenged\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"indexed\\\":false,\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"Claimed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"FailedResolution\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"}],\\\"name\\\":\\\"MessageRelayed\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"SequencerDelayLimitUpdateReceived\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":true,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"VerificationStarted\\\",\\\"type\\\":\\\"event\\\"},{\\\"anonymous\\\":false,\\\"inputs\\\":[{\\\"indexed\\\":false,\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"Verified\\\",\\\"type\\\":\\\"event\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"amb\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IAMB\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"burn\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"censorshipTestStatus\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"enum VeaOutboxArbToGnosis.CensorshipTestStatus\\\",\\\"name\\\":\\\"status\\\",\\\"type\\\":\\\"uint8\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"challenge\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"name\\\":\\\"claim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"claimHashes\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"deposit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"depositPlusReward\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"epochAt\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochNow\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"epoch\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"epochPeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"hashClaim\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"hashedClaim\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"pure\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"isMsgRelayed\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bool\\\",\\\"name\\\":\\\"isRelayed\\\",\\\"type\\\":\\\"bool\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"latestVerifiedEpoch\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"maxMissingBlocks\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"minChallengePeriod\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"_stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"resolveDisputedClaim\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerArbToGnosis\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"routerChainId\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"bytes32[]\\\",\\\"name\\\":\\\"_proof\\\",\\\"type\\\":\\\"bytes32[]\\\"},{\\\"internalType\\\":\\\"uint64\\\",\\\"name\\\":\\\"_msgId\\\",\\\"type\\\":\\\"uint64\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_to\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"_from\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"bytes\\\",\\\"name\\\":\\\"_message\\\",\\\"type\\\":\\\"bytes\\\"}],\\\"name\\\":\\\"sendMessage\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"sequencerDelayLimit\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"startVerification\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"stateRoot\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"bytes32\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timeoutEpochs\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"timestampDelayUpdated\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_newSequencerDelayLimit\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_timestamp\\\",\\\"type\\\":\\\"uint256\\\"}],\\\"name\\\":\\\"updateSequencerDelayLimit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"verifySnapshot\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[],\\\"name\\\":\\\"weth\\\",\\\"outputs\\\":[{\\\"internalType\\\":\\\"contract IWETH\\\",\\\"name\\\":\\\"\\\",\\\"type\\\":\\\"address\\\"}],\\\"stateMutability\\\":\\\"view\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengeDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawChallengerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimDeposit\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"},{\\\"inputs\\\":[{\\\"internalType\\\":\\\"uint256\\\",\\\"name\\\":\\\"_epoch\\\",\\\"type\\\":\\\"uint256\\\"},{\\\"components\\\":[{\\\"internalType\\\":\\\"bytes32\\\",\\\"name\\\":\\\"stateRoot\\\",\\\"type\\\":\\\"bytes32\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"claimer\\\",\\\"type\\\":\\\"address\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampClaimed\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"timestampVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"uint32\\\",\\\"name\\\":\\\"blocknumberVerification\\\",\\\"type\\\":\\\"uint32\\\"},{\\\"internalType\\\":\\\"enum Party\\\",\\\"name\\\":\\\"honest\\\",\\\"type\\\":\\\"uint8\\\"},{\\\"internalType\\\":\\\"address\\\",\\\"name\\\":\\\"challenger\\\",\\\"type\\\":\\\"address\\\"}],\\\"internalType\\\":\\\"struct Claim\\\",\\\"name\\\":\\\"_claim\\\",\\\"type\\\":\\\"tuple\\\"}],\\\"name\\\":\\\"withdrawClaimerEscapeHatch\\\",\\\"outputs\\\":[],\\\"stateMutability\\\":\\\"nonpayable\\\",\\\"type\\\":\\\"function\\\"}],\\\"devdoc\\\":{\\\"details\\\":\\\"Vea Outbox From Arbitrum to Gnosis. Note: This contract is deployed on Gnosis.\\\",\\\"events\\\":{\\\"Challenged(uint256,address)\\\":{\\\"details\\\":\\\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\",\\\"params\\\":{\\\"_challenger\\\":\\\"The address of the challenger.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenged claim.\\\"}},\\\"Claimed(address,uint256,bytes32)\\\":{\\\"details\\\":\\\"Watchers check this event to challenge fraud.\\\",\\\"params\\\":{\\\"_claimer\\\":\\\"The address of the claimer.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim.\\\",\\\"_stateRoot\\\":\\\"The state root of the claim.\\\"}},\\\"FailedResolution(uint256)\\\":{\\\"details\\\":\\\"This event indicates that a resolution has failed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which resolution failed.\\\"}},\\\"MessageRelayed(uint64)\\\":{\\\"details\\\":\\\"This event indicates that a message has been relayed.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId of the message that was relayed.\\\"}},\\\"SequencerDelayLimitUpdateReceived(uint256)\\\":{\\\"details\\\":\\\"This event indicates the sequencer limit updated.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The new sequencer delay limit.\\\"}},\\\"VerificationStarted(uint256)\\\":{\\\"details\\\":\\\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that started verification.\\\"}},\\\"Verified(uint256)\\\":{\\\"details\\\":\\\"This events indicates that verification has succeeded. The messages are ready to be relayed.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch that was verified.\\\"}}},\\\"kind\\\":\\\"dev\\\",\\\"methods\\\":{\\\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Gets the status of the censorship test for claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to test.\\\"},\\\"returns\\\":{\\\"status\\\":\\\"True if the claim passed the censorship test.\\\"}},\\\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"claim(uint256,bytes32)\\\":{\\\"details\\\":\\\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\",\\\"params\\\":{\\\"_epoch\\\":\\\"The epoch for which the claim is made.\\\",\\\"_stateRoot\\\":\\\"The state root to claim.\\\"}},\\\"constructor\\\":{\\\"details\\\":\\\"Constructor. Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\",\\\"params\\\":{\\\"_amb\\\":\\\"The address of the AMB contract on Gnosis.\\\",\\\"_deposit\\\":\\\"The deposit amount to submit a claim in wei.\\\",\\\"_epochPeriod\\\":\\\"The duration of each epoch.\\\",\\\"_maxMissingBlocks\\\":\\\"The maximum number of blocks that can be missing in a challenge period.\\\",\\\"_minChallengePeriod\\\":\\\"The minimum time window to challenge a claim.\\\",\\\"_routerArbToGnosis\\\":\\\"The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\",\\\"_routerChainId\\\":\\\"The chain id of the routerArbToGnosis.\\\",\\\"_sequencerDelayLimit\\\":\\\"The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\",\\\"_timeoutEpochs\\\":\\\"The epochs before the bridge is considered shutdown.\\\",\\\"_weth\\\":\\\"The address of the WETH contract on Gnosis.\\\"}},\\\"epochAt(uint256)\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"epochNow()\\\":{\\\"details\\\":\\\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\",\\\"returns\\\":{\\\"epoch\\\":\\\"The hash of the claim.\\\"}},\\\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Hashes the claim.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim to hash.\\\"},\\\"returns\\\":{\\\"hashedClaim\\\":\\\"The hash of the claim.\\\"}},\\\"isMsgRelayed(uint256)\\\":{\\\"details\\\":\\\"Get the msg relayed status.\\\",\\\"params\\\":{\\\"_msgId\\\":\\\"The msgId to check.\\\"},\\\"returns\\\":{\\\"isRelayed\\\":\\\"True if the msg was relayed.\\\"}},\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves any challenge of the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch to verify.\\\",\\\"_stateRoot\\\":\\\"The true state root for the epoch.\\\"}},\\\"sendMessage(bytes32[],uint64,address,address,bytes)\\\":{\\\"details\\\":\\\"Verifies and relays the message. UNTRUSTED.\\\",\\\"params\\\":{\\\"_from\\\":\\\"The address of the contract on Arbitrum that sent the message.\\\",\\\"_message\\\":\\\"The message in the vea inbox\\\",\\\"_msgId\\\":\\\"The zero based index of the message in the inbox.\\\",\\\"_proof\\\":\\\"The merkle proof to prove the message inclusion in the inbox state root.\\\",\\\"_to\\\":\\\"The address of the contract on Gnosis to call.\\\"}},\\\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Start verification for claim for 'epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the claim to challenge.\\\"}},\\\"updateSequencerDelayLimit(uint256,uint256)\\\":{\\\"details\\\":\\\"Set the sequencerDelayLimit by receiving a message from the AMB.\\\",\\\"params\\\":{\\\"_newSequencerDelayLimit\\\":\\\"The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\",\\\"_timestamp\\\":\\\"The timestamp of the message.\\\"}},\\\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Resolves the optimistic claim for '_epoch'.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch of the optimistic claim.\\\"}},\\\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the challenge deposit to withraw.\\\"}},\\\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}},\\\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"details\\\":\\\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\",\\\"params\\\":{\\\"_claim\\\":\\\"The claim associated with the epoch.\\\",\\\"_epoch\\\":\\\"The epoch associated with the claim deposit to withraw.\\\"}}},\\\"version\\\":1},\\\"userdoc\\\":{\\\"kind\\\":\\\"user\\\",\\\"methods\\\":{\\\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\\\":{\\\"notice\\\":\\\"Note: Access restricted to AMB.\\\"}},\\\"version\\\":1}},\\\"settings\\\":{\\\"compilationTarget\\\":{\\\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol\\\":\\\"VeaOutboxArbToGnosis\\\"},\\\"evmVersion\\\":\\\"paris\\\",\\\"libraries\\\":{},\\\"metadata\\\":{\\\"bytecodeHash\\\":\\\"ipfs\\\",\\\"useLiteralContent\\\":true},\\\"optimizer\\\":{\\\"enabled\\\":true,\\\"runs\\\":10000},\\\"remappings\\\":[],\\\"viaIR\\\":true},\\\"sources\\\":{\\\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @mani99brar, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../canonical/gnosis-chain/IAMB.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/outboxes/IVeaOutboxOnL1.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/updaters/ISequencerDelayUpdatable.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/tokens/gnosis/IWETH.sol\\\\\\\";\\\\nimport \\\\\\\"../interfaces/gateways/IReceiverGateway.sol\\\\\\\";\\\\n\\\\n/// @dev Vea Outbox From Arbitrum to Gnosis.\\\\n/// Note: This contract is deployed on Gnosis.\\\\ncontract VeaOutboxArbToGnosis is IVeaOutboxOnL1, ISequencerDelayUpdatable {\\\\n    // ************************************* //\\\\n    // *             Storage               * //\\\\n    // ************************************* //\\\\n\\\\n    IAMB public immutable amb; // The address of the AMB contract on Gnosis.\\\\n    address public immutable routerArbToGnosis; // The address of the router from Arbitrum to Gnosis on ethereum.\\\\n\\\\n    IWETH public immutable weth; // The address of the WETH contract on Gnosis.\\\\n    uint256 public immutable deposit; // The deposit in wei required to submit a claim or challenge\\\\n    uint256 public immutable burn; // The amount of wei to burn. deposit / 2\\\\n    uint256 public immutable depositPlusReward; // 2 * deposit - burn\\\\n\\\\n    uint256 internal constant SLOT_TIME = 5; // Gnosis 5 second slot time\\\\n\\\\n    uint256 public immutable routerChainId; // Router chain id for authentication of messages from the AMB.\\\\n    uint256 public immutable epochPeriod; // Epochs mark the period between potential snapshots.\\\\n    uint256 public immutable minChallengePeriod; // Minimum time window to challenge a claim, even with a malicious sequencer.\\\\n\\\\n    uint256 public immutable timeoutEpochs; // The number of epochs without forward progress before the bridge is considered shutdown.\\\\n    uint256 public immutable maxMissingBlocks; // The maximum number of blocks that can be missing in a challenge period.\\\\n\\\\n    bytes32 public stateRoot; // merkle root of the outbox state\\\\n    uint256 public latestVerifiedEpoch; // The latest epoch that has been verified.\\\\n\\\\n    mapping(uint256 epoch => bytes32) public claimHashes; // epoch => claim\\\\n    mapping(uint256 messageId => bytes32) internal relayed; // msgId/256 => packed replay bitmap, preferred over a simple boolean mapping to save 15k gas per message\\\\n\\\\n    uint256 public sequencerDelayLimit; // This is MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox, it is the maximum seconds the sequencer can backdate L2 txns relative to the L1 clock.\\\\n    uint256 public timestampDelayUpdated; // The timestamp of the last sequencer delay update.\\\\n\\\\n    enum CensorshipTestStatus {\\\\n        Failed,\\\\n        Passed,\\\\n        NotStarted,\\\\n        InProgress\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *              Events               * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Watchers check this event to challenge fraud.\\\\n    /// @param _claimer The address of the claimer.\\\\n    /// @param _epoch The epoch associated with the claim.\\\\n    /// @param _stateRoot The state root of the claim.\\\\n    event Claimed(address indexed _claimer, uint256 indexed _epoch, bytes32 _stateRoot);\\\\n\\\\n    /// @dev This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\\\\n    /// @param _epoch The epoch associated with the challenged claim.\\\\n    /// @param _challenger The address of the challenger.\\\\n    event Challenged(uint256 indexed _epoch, address indexed _challenger);\\\\n\\\\n    /// @dev This event indicates that a message has been relayed.\\\\n    /// @param _msgId The msgId of the message that was relayed.\\\\n    event MessageRelayed(uint64 _msgId);\\\\n\\\\n    /// @dev This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\\\\n    /// @param _epoch The epoch that started verification.\\\\n    event VerificationStarted(uint256 indexed _epoch);\\\\n\\\\n    /// @dev This events indicates that verification has succeeded. The messages are ready to be relayed.\\\\n    /// @param _epoch The epoch that was verified.\\\\n    event Verified(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates that a resolution has failed.\\\\n    /// @param _epoch The epoch for which resolution failed.\\\\n    event FailedResolution(uint256 _epoch);\\\\n\\\\n    /// @dev This event indicates the sequencer limit updated.\\\\n    /// @param _newSequencerDelayLimit The new sequencer delay limit.\\\\n    event SequencerDelayLimitUpdateReceived(uint256 _newSequencerDelayLimit);\\\\n\\\\n    // ************************************* //\\\\n    // *        Function Modifiers         * //\\\\n    // ************************************* //\\\\n\\\\n    modifier OnlyBridgeRunning() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch <= timeoutEpochs, \\\\\\\"Bridge Shutdown.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    modifier OnlyBridgeShutdown() {\\\\n        unchecked {\\\\n            require(block.timestamp / epochPeriod - latestVerifiedEpoch > timeoutEpochs, \\\\\\\"Bridge Running.\\\\\\\");\\\\n        }\\\\n        _;\\\\n    }\\\\n\\\\n    /// @dev Constructor.\\\\n    /// Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\\\\n    /// @param _deposit The deposit amount to submit a claim in wei.\\\\n    /// @param _epochPeriod The duration of each epoch.\\\\n    /// @param _minChallengePeriod The minimum time window to challenge a claim.\\\\n    /// @param _timeoutEpochs The epochs before the bridge is considered shutdown.\\\\n    /// @param _amb The address of the AMB contract on Gnosis.\\\\n    /// @param _routerArbToGnosis The address of the router on Ethereum that routes from Arbitrum to Gnosis.\\\\n    /// @param _sequencerDelayLimit The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\\\\n    /// @param _maxMissingBlocks The maximum number of blocks that can be missing in a challenge period.\\\\n    /// @param _routerChainId The chain id of the routerArbToGnosis.\\\\n    /// @param _weth The address of the WETH contract on Gnosis.\\\\n    constructor(\\\\n        uint256 _deposit,\\\\n        uint256 _epochPeriod,\\\\n        uint256 _minChallengePeriod,\\\\n        uint256 _timeoutEpochs,\\\\n        IAMB _amb,\\\\n        address _routerArbToGnosis,\\\\n        uint256 _sequencerDelayLimit,\\\\n        uint256 _maxMissingBlocks,\\\\n        uint256 _routerChainId,\\\\n        IWETH _weth\\\\n    ) {\\\\n        deposit = _deposit;\\\\n        // epochPeriod must match the VeaInboxArbToGnosis contract deployment epochPeriod value.\\\\n        epochPeriod = _epochPeriod;\\\\n        timeoutEpochs = _timeoutEpochs;\\\\n        minChallengePeriod = _minChallengePeriod;\\\\n        amb = _amb;\\\\n        routerArbToGnosis = _routerArbToGnosis;\\\\n        // This value is on another chain, so we can't read it, we trust the deployer to set a correct value.\\\\n        sequencerDelayLimit = _sequencerDelayLimit; // MaxTimeVariation.delaySeconds from the arbitrum sequencer inbox\\\\n        maxMissingBlocks = _maxMissingBlocks;\\\\n        routerChainId = _routerChainId;\\\\n        weth = _weth;\\\\n\\\\n        // claimant and challenger are not sybil resistant\\\\n        // must burn half deposit to prevent zero cost griefing\\\\n        burn = _deposit / 2;\\\\n        depositPlusReward = 2 * _deposit - burn;\\\\n\\\\n        latestVerifiedEpoch = block.timestamp / epochPeriod - 1;\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *        Parameter Updates          * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Set the sequencerDelayLimit by receiving a message from the AMB.\\\\n    /// @param _newSequencerDelayLimit The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\\n    /// @param _timestamp The timestamp of the message.\\\\n    function updateSequencerDelayLimit(uint256 _newSequencerDelayLimit, uint256 _timestamp) external {\\\\n        require(msg.sender == address(amb), \\\\\\\"Not from bridge.\\\\\\\");\\\\n        require(bytes32(routerChainId) == amb.messageSourceChainId(), \\\\\\\"Invalid chain id.\\\\\\\");\\\\n        require(routerArbToGnosis == amb.messageSender(), \\\\\\\"Not from router.\\\\\\\");\\\\n        require(timestampDelayUpdated < _timestamp, \\\\\\\"Message is outdated.\\\\\\\");\\\\n\\\\n        if (sequencerDelayLimit != _newSequencerDelayLimit) {\\\\n            // If _newSequencerDelayLimit > timeout * epochPeriod, then the bridge will shutdown.\\\\n            sequencerDelayLimit = _newSequencerDelayLimit;\\\\n            timestampDelayUpdated = _timestamp;\\\\n            emit SequencerDelayLimitUpdateReceived(_newSequencerDelayLimit);\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *         State Modifiers           * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Submit a claim about the _stateRoot at _epoch and submit a deposit.\\\\n    /// @param _epoch The epoch for which the claim is made.\\\\n    /// @param _stateRoot The state root to claim.\\\\n    function claim(uint256 _epoch, bytes32 _stateRoot) external virtual {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        unchecked {\\\\n            require(_epoch == block.timestamp / epochPeriod - 1, \\\\\\\"Epoch has not yet passed.\\\\\\\");\\\\n        }\\\\n\\\\n        require(_stateRoot != bytes32(0), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(claimHashes[_epoch] == bytes32(0), \\\\\\\"Claim already made.\\\\\\\");\\\\n\\\\n        claimHashes[_epoch] = hashClaim(\\\\n            Claim({\\\\n                stateRoot: _stateRoot,\\\\n                claimer: msg.sender,\\\\n                timestampClaimed: uint32(block.timestamp),\\\\n                timestampVerification: uint32(0),\\\\n                blocknumberVerification: uint32(0),\\\\n                honest: Party.None,\\\\n                challenger: address(0)\\\\n            })\\\\n        );\\\\n\\\\n        emit Claimed(msg.sender, _epoch, _stateRoot);\\\\n    }\\\\n\\\\n    /// @dev Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function challenge(uint256 _epoch, Claim memory _claim) external {\\\\n        require(weth.transferFrom(msg.sender, address(this), deposit), \\\\\\\"Failed WETH transfer.\\\\\\\");\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim already challenged.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim already verified.\\\\\\\");\\\\n\\\\n        _claim.challenger = msg.sender;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Challenged(_epoch, msg.sender);\\\\n    }\\\\n\\\\n    /// @dev Start verification for claim for 'epoch'.\\\\n    /// @param _epoch The epoch of the claim to challenge.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function startVerification(uint256 _epoch, Claim memory _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n\\\\n        // sequencerDelayLimit + epochPeriod is the worst case time to sync the L2 state compared to L1 clock.\\\\n        // using checked arithmetic incase arbitrum governance sets sequencerDelayLimit to a large value\\\\n        require(\\\\n            block.timestamp - uint256(_claim.timestampClaimed) >= sequencerDelayLimit + epochPeriod,\\\\n            \\\\\\\"Claim must wait atleast maxL2StateSyncDelay.\\\\\\\"\\\\n        );\\\\n\\\\n        CensorshipTestStatus _censorshipTestStatus = censorshipTestStatus(_claim);\\\\n        require(\\\\n            _censorshipTestStatus == CensorshipTestStatus.NotStarted ||\\\\n                _censorshipTestStatus == CensorshipTestStatus.Failed,\\\\n            \\\\\\\"Claim verification in progress or already completed.\\\\\\\"\\\\n        );\\\\n\\\\n        _claim.timestampVerification = uint32(block.timestamp);\\\\n        _claim.blocknumberVerification = uint32(block.number);\\\\n\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit VerificationStarted(_epoch);\\\\n    }\\\\n\\\\n    /// @dev Resolves the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch of the optimistic claim.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function verifySnapshot(uint256 _epoch, Claim memory _claim) external virtual OnlyBridgeRunning {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.challenger == address(0), \\\\\\\"Claim is challenged.\\\\\\\");\\\\n        require(censorshipTestStatus(_claim) == CensorshipTestStatus.Passed, \\\\\\\"Censorship test not passed.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _claim.stateRoot;\\\\n        }\\\\n\\\\n        _claim.honest = Party.Claimer;\\\\n        claimHashes[_epoch] = hashClaim(_claim);\\\\n\\\\n        emit Verified(_epoch);\\\\n    }\\\\n\\\\n    /// Note: Access restricted to AMB.\\\\n    /// @dev Resolves any challenge of the optimistic claim for '_epoch'.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(\\\\n        uint256 _epoch,\\\\n        bytes32 _stateRoot,\\\\n        Claim memory _claim\\\\n    ) external virtual OnlyBridgeRunning {\\\\n        // Ethereum -> Gnosis message authentication with the AMB, the canonical Ethereum <-> Gnosis bridge.\\\\n        // https://docs.tokenbridge.net/amb-bridge/development-of-a-cross-chain-application/how-to-develop-xchain-apps-by-amb#receive-a-method-call-from-the-amb-bridge\\\\n\\\\n        require(msg.sender == address(amb), \\\\\\\"Not from native Gnosis AMB bridge.\\\\\\\");\\\\n        require(bytes32(routerChainId) == amb.messageSourceChainId(), \\\\\\\"Invalid chain id.\\\\\\\");\\\\n        require(routerArbToGnosis == amb.messageSender(), \\\\\\\"Not from router.\\\\\\\");\\\\n\\\\n        if (_epoch > latestVerifiedEpoch && _stateRoot != bytes32(0)) {\\\\n            latestVerifiedEpoch = _epoch;\\\\n            stateRoot = _stateRoot;\\\\n        }\\\\n\\\\n        if (claimHashes[_epoch] == hashClaim(_claim)) {\\\\n            if (_claim.stateRoot == _stateRoot) {\\\\n                _claim.honest = Party.Claimer;\\\\n            } else if (_claim.challenger != address(0)) {\\\\n                _claim.honest = Party.Challenger;\\\\n            }\\\\n            claimHashes[_epoch] = hashClaim(_claim);\\\\n            emit Verified(_epoch);\\\\n        } else {\\\\n            emit FailedResolution(_epoch);\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Verifies and relays the message. UNTRUSTED.\\\\n    /// @param _proof The merkle proof to prove the message inclusion in the inbox state root.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address of the contract on Gnosis to call.\\\\n    /// @param _from The address of the contract on Arbitrum that sent the message.\\\\n    /// @param _message The message in the vea inbox\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external {\\\\n        require(_proof.length < 64, \\\\\\\"Proof too long.\\\\\\\");\\\\n\\\\n        bytes32 nodeHash = keccak256(abi.encodePacked(_msgId, _to, _from, _message));\\\\n\\\\n        // double hashed leaf\\\\n        // avoids second order preimage attacks\\\\n        // https://flawed.net.nz/2018/02/21/attacking-merkle-trees-with-a-second-preimage-attack/\\\\n        assembly {\\\\n            mstore(0x00, nodeHash)\\\\n            nodeHash := keccak256(0x00, 0x20)\\\\n        }\\\\n\\\\n        unchecked {\\\\n            for (uint256 i = 0; i < _proof.length; i++) {\\\\n                bytes32 proofElement = _proof[i];\\\\n                // sort sibling hashes as a convention for efficient proof validation\\\\n                if (proofElement > nodeHash)\\\\n                    assembly {\\\\n                        mstore(0x00, nodeHash)\\\\n                        mstore(0x20, proofElement)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n                else\\\\n                    assembly {\\\\n                        mstore(0x00, proofElement)\\\\n                        mstore(0x20, nodeHash)\\\\n                        nodeHash := keccak256(0x00, 0x40)\\\\n                    }\\\\n            }\\\\n        }\\\\n\\\\n        require(stateRoot == nodeHash, \\\\\\\"Invalid proof.\\\\\\\");\\\\n\\\\n        // msgId is the zero-based index of the message in the inbox.\\\\n        // msgId is also used as an index in the relayed bitmap to prevent replay.\\\\n        // Note: a bitmap is used instead of a simple boolean mapping to save 15k gas per message.\\\\n\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        require(((replay >> offset) & bytes32(uint256(1))) == bytes32(0), \\\\\\\"Message already relayed\\\\\\\");\\\\n        relayed[relayIndex] = replay | bytes32(1 << offset);\\\\n\\\\n        // UNTRUSTED.\\\\n        IReceiverGateway(_to).receiveMessage(_from, _message);\\\\n\\\\n        emit MessageRelayed(_msgId);\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimDeposit(uint256 _epoch, Claim calldata _claim) external virtual {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Claimer, \\\\\\\"Claim failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            weth.burn(burn); // no return value to check\\\\n            require(weth.transfer(_claim.claimer, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        } else {\\\\n            require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\\\\n    /// @param _epoch The epoch associated with the challenge deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengeDeposit(uint256 _epoch, Claim calldata _claim) external {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.Challenger, \\\\\\\"Challenge failed.\\\\\\\");\\\\n\\\\n        delete claimHashes[_epoch];\\\\n\\\\n        weth.burn(burn); // no return value to check\\\\n        require(weth.transfer(_claim.challenger, depositPlusReward), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawClaimerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.claimer != address(0)) {\\\\n            if (_claim.challenger == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                require(weth.transfer(_claim.claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            } else {\\\\n                address claimer = _claim.claimer;\\\\n                _claim.claimer = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                require(weth.transfer(claimer, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\\\\n    /// @param _epoch The epoch associated with the claim deposit to withraw.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function withdrawChallengerEscapeHatch(uint256 _epoch, Claim memory _claim) external OnlyBridgeShutdown {\\\\n        require(claimHashes[_epoch] == hashClaim(_claim), \\\\\\\"Invalid claim.\\\\\\\");\\\\n        require(_claim.honest == Party.None, \\\\\\\"Claim resolved.\\\\\\\");\\\\n\\\\n        if (_claim.challenger != address(0)) {\\\\n            if (_claim.claimer == address(0)) {\\\\n                delete claimHashes[_epoch];\\\\n                require(weth.transfer(_claim.challenger, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            } else {\\\\n                address challenger = _claim.challenger;\\\\n                _claim.challenger = address(0);\\\\n                claimHashes[_epoch] = hashClaim(_claim);\\\\n                require(weth.transfer(challenger, deposit), \\\\\\\"Failed WETH transfer.\\\\\\\"); // should revert on errors, but we check return value anyways\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    // ************************************* //\\\\n    // *           Pure / Views            * //\\\\n    // ************************************* //\\\\n\\\\n    /// @dev Hashes the claim.\\\\n    /// @param _claim The claim to hash.\\\\n    /// @return hashedClaim The hash of the claim.\\\\n    function hashClaim(Claim memory _claim) public pure returns (bytes32 hashedClaim) {\\\\n        return\\\\n            hashedClaim = keccak256(\\\\n                abi.encodePacked(\\\\n                    _claim.stateRoot,\\\\n                    _claim.claimer,\\\\n                    _claim.timestampClaimed,\\\\n                    _claim.timestampVerification,\\\\n                    _claim.blocknumberVerification,\\\\n                    _claim.honest,\\\\n                    _claim.challenger\\\\n                )\\\\n            );\\\\n    }\\\\n\\\\n    /// @dev Gets the status of the censorship test for claim.\\\\n    /// @param _claim The claim to test.\\\\n    /// @return status True if the claim passed the censorship test.\\\\n    function censorshipTestStatus(Claim memory _claim) public view returns (CensorshipTestStatus status) {\\\\n        unchecked {\\\\n            if (uint256(_claim.timestampVerification) == 0) {\\\\n                status = CensorshipTestStatus.NotStarted;\\\\n            } else if (block.timestamp - uint256(_claim.timestampVerification) < minChallengePeriod) {\\\\n                status = CensorshipTestStatus.InProgress;\\\\n            } else {\\\\n                uint256 expectedBlocks = uint256(_claim.blocknumberVerification) +\\\\n                    (block.timestamp - uint256(_claim.timestampVerification)) /\\\\n                    SLOT_TIME;\\\\n                uint256 actualBlocks = block.number;\\\\n                if (expectedBlocks - actualBlocks <= maxMissingBlocks) {\\\\n                    status = CensorshipTestStatus.Passed;\\\\n                } else {\\\\n                    status = CensorshipTestStatus.Failed;\\\\n                }\\\\n            }\\\\n        }\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochNow() external view returns (uint256 epoch) {\\\\n        epoch = block.timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\\\\n    /// @return epoch The hash of the claim.\\\\n    function epochAt(uint256 timestamp) external view returns (uint256 epoch) {\\\\n        epoch = timestamp / epochPeriod;\\\\n    }\\\\n\\\\n    /// @dev Get the msg relayed status.\\\\n    /// @param _msgId The msgId to check.\\\\n    /// @return isRelayed True if the msg was relayed.\\\\n    function isMsgRelayed(uint256 _msgId) external view returns (bool isRelayed) {\\\\n        uint256 relayIndex = _msgId >> 8;\\\\n        uint256 offset;\\\\n\\\\n        unchecked {\\\\n            offset = _msgId % 256;\\\\n        }\\\\n\\\\n        bytes32 replay = relayed[relayIndex];\\\\n\\\\n        isRelayed = (replay >> offset) & bytes32(uint256(1)) == bytes32(uint256(1));\\\\n    }\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe3c55b9bc884071a369179b51e841c737e48aa02581c3cb49a23dc2ce90bfadd\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/canonical/gnosis-chain/IAMB.sol\\\":{\\\"content\\\":\\\"// https://docs.gnosischain.com/bridges/tokenbridge/amb-bridge#gnosis\\\\n// https://github.com/omni/tokenbridge-contracts/blob/908a48107919d4ab127f9af07d44d47eac91547e/contracts/interfaces/IAMB.sol\\\\n// interface is pruned for relevant function stubs\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IAMB {\\\\n    function requireToPassMessage(address _contract, bytes memory _data, uint256 _gas) external returns (bytes32);\\\\n\\\\n    function maxGasPerTx() external view returns (uint256);\\\\n\\\\n    function messageSender() external view returns (address);\\\\n\\\\n    function messageSourceChainId() external view returns (bytes32);\\\\n\\\\n    event AffirmationCompleted(\\\\n        address indexed sender,\\\\n        address indexed executor,\\\\n        bytes32 indexed messageId,\\\\n        bool status\\\\n    );\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x372ecaa3858bc071e7a8a05f9d0695af518b0faa188d4d0bd800e29052ebcefc\\\"},\\\"src/interfaces/gateways/IReceiverGateway.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\ninterface IReceiverGateway {\\\\n    function veaOutbox() external view returns (address);\\\\n\\\\n    function senderGateway() external view returns (address);\\\\n\\\\n    function receiveMessage(address msgSender, bytes calldata msgData) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xe6917520400ac49fc28bf32acb29cc115d1f97789ad798336d46a4bb7d35a9be\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/outboxes/IVeaOutboxOnL1.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nimport \\\\\\\"../types/VeaClaim.sol\\\\\\\";\\\\n\\\\n/// @dev Interface of the Vea Outbox on L1 chains like Ethereum, Gnosis, Polygon POS where storage is expensive.\\\\n\\\\ninterface IVeaOutboxOnL1 {\\\\n    /// @dev Verifies and relays the message.\\\\n    /// @param _proof The merkle proof to prove the message.\\\\n    /// @param _msgId The zero based index of the message in the inbox.\\\\n    /// @param _to The address to send the message to.\\\\n    /// @param _from The address of the contract on L2 that sent the message, used for authentication.\\\\n    /// @param _message The message to relay.\\\\n    function sendMessage(\\\\n        bytes32[] calldata _proof,\\\\n        uint64 _msgId,\\\\n        address _to,\\\\n        address _from,\\\\n        bytes calldata _message\\\\n    ) external;\\\\n\\\\n    /// @dev Resolves any challenge of the optimistic claim for 'epoch' using the canonical bridge.\\\\n    /// Note: Access restricted to canonical bridge.\\\\n    /// @param _epoch The epoch to verify.\\\\n    /// @param _stateRoot The true state root for the epoch.\\\\n    /// @param _claim The claim associated with the epoch.\\\\n    function resolveDisputedClaim(uint256 _epoch, bytes32 _stateRoot, Claim memory _claim) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x6c9a39add549daa58bd882a3949212afa73cabc75bda99a97583545a1d7622da\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/tokens/gnosis/IWETH.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\npragma solidity ^0.8.0;\\\\n\\\\n// https://github.com/OpenZeppelin/openzeppelin-contracts/blob/5daaf60d11ee2075260d0f3adfb22b1c536db983/contracts/token/ERC20/StandardBurnableToken.sol\\\\n// implementation: https://gnosisscan.io/address/0xf8d1677c8a0c961938bf2f9adc3f3cfda759a9d9#code\\\\n// proxy: https://gnosisscan.io/token/0x6a023ccd1ff6f2045c3309768ead9e68f978f6e1#readProxyContract\\\\n\\\\n/**\\\\n * @title Standard Burnable Token\\\\n * @dev Token that can be irreversibly burned (destroyed).\\\\n */\\\\ninterface IWETH {\\\\n    /**\\\\n     * @dev Burns a specific amount of tokens.\\\\n     * @param _value The amount of token to be burned.\\\\n     */\\\\n    function burn(uint256 _value) external;\\\\n\\\\n    /**\\\\n     * @dev Gets the balance of the specified address.\\\\n     * @param _owner The address to query the the balance of.\\\\n     * @return An uint256 representing the amount owned by the passed address.\\\\n     */\\\\n    function balanceOf(address _owner) external view returns (uint256);\\\\n\\\\n    /**\\\\n     * @dev Transfer tokens from one address to another\\\\n     * @param _from address The address which you want to send tokens from\\\\n     * @param _to address The address which you want to transfer to\\\\n     * @param _value uint256 the amount of tokens to be transferred\\\\n     */\\\\n    function transferFrom(address _from, address _to, uint256 _value) external returns (bool);\\\\n\\\\n    /**\\\\n     * @dev Transfer token for a specified address\\\\n     * @param _to The address to transfer to.\\\\n     * @param _value The amount to be transferred.\\\\n     */\\\\n    function transfer(address _to, uint256 _value) external returns (bool);\\\\n\\\\n    /**\\\\n     * @dev Function to check the amount of tokens that an owner allowed to a spender.\\\\n     * @param _owner address The address which owns the funds.\\\\n     * @param _spender address The address which will spend the funds.\\\\n     * @return A uint256 specifying the amount of tokens still available for the spender.\\\\n     */\\\\n    function allowance(address _owner, address _spender) external view returns (uint256);\\\\n\\\\n    /**\\\\n     * @dev Approve the passed address to spend the specified amount of tokens on behalf of msg.sender.\\\\n     * Beware that changing an allowance with this method brings the risk that someone may use both the old\\\\n     * and the new allowance by unfortunate transaction ordering. One possible solution to mitigate this\\\\n     * race condition is to first reduce the spender's allowance to 0 and set the desired value afterwards:\\\\n     * https://github.com/ethereum/EIPs/issues/20#issuecomment-263524729\\\\n     * @param _spender The address which will spend the funds.\\\\n     * @param _value The amount of tokens to be spent.\\\\n     */\\\\n    function approve(address _spender, uint256 _value) external returns (bool);\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0xbdda7697ab9595ad33056b937c120f23ab64bd2aac8c2f7e54bf3afd2cdd7a31\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/types/VeaClaim.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\nenum Party {\\\\n    None,\\\\n    Claimer,\\\\n    Challenger\\\\n}\\\\n\\\\nstruct Claim {\\\\n    bytes32 stateRoot;\\\\n    address claimer;\\\\n    uint32 timestampClaimed;\\\\n    uint32 timestampVerification;\\\\n    uint32 blocknumberVerification;\\\\n    Party honest;\\\\n    address challenger;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x06198ed8d337e829b7cbf8c3acf55227156f83a6cb238b743e6f309cf4e35022\\\",\\\"license\\\":\\\"MIT\\\"},\\\"src/interfaces/updaters/ISequencerDelayUpdatable.sol\\\":{\\\"content\\\":\\\"// SPDX-License-Identifier: MIT\\\\n\\\\n/// @custom:authors: [@jaybuidl, @shotaronowhere]\\\\n/// @custom:reviewers: []\\\\n/// @custom:auditors: []\\\\n/// @custom:bounties: []\\\\n/// @custom:deployments: []\\\\n\\\\npragma solidity ^0.8.24;\\\\n\\\\n/// @dev Interface of a contract which is updatable, receiving parameter updates from an L1 contract through a cross-chain call.\\\\n/// @dev eg. Arbitrum (L2) -> Ethereum (L1) -> Gnosis (L1), the veaOutbox on Gnosis will be an ISequencerDelayUpdatable contract which receives updates from the router on Ethereum.\\\\ninterface ISequencerDelayUpdatable {\\\\n    /// @dev Updates the sequencer limit.\\\\n    /// Note: Access restricted to ensure the argument is passed from the Sequencer contract.\\\\n    /// @param _newSequencerDelayLimit The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\\\\n    /// @param _timestamp The timestamp of the message.\\\\n    function updateSequencerDelayLimit(uint256 _newSequencerDelayLimit, uint256 _timestamp) external;\\\\n}\\\\n\\\",\\\"keccak256\\\":\\\"0x14dc56b2ebfe46008240e891c5a0521343ef535cf56ccb075387ea6323dbc6b8\\\",\\\"license\\\":\\\"MIT\\\"}},\\\"version\\\":1}\",\"bytecode\":\"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\",\"deployedBytecode\":\"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\",\"devdoc\":{\"details\":\"Vea Outbox From Arbitrum to Gnosis. Note: This contract is deployed on Gnosis.\",\"events\":{\"Challenged(uint256,address)\":{\"details\":\"This event indicates that `sendSnapshot(epoch)` should be called in the inbox.\",\"params\":{\"_challenger\":\"The address of the challenger.\",\"_epoch\":\"The epoch associated with the challenged claim.\"}},\"Claimed(address,uint256,bytes32)\":{\"details\":\"Watchers check this event to challenge fraud.\",\"params\":{\"_claimer\":\"The address of the claimer.\",\"_epoch\":\"The epoch associated with the claim.\",\"_stateRoot\":\"The state root of the claim.\"}},\"FailedResolution(uint256)\":{\"details\":\"This event indicates that a resolution has failed.\",\"params\":{\"_epoch\":\"The epoch for which resolution failed.\"}},\"MessageRelayed(uint64)\":{\"details\":\"This event indicates that a message has been relayed.\",\"params\":{\"_msgId\":\"The msgId of the message that was relayed.\"}},\"SequencerDelayLimitUpdateReceived(uint256)\":{\"details\":\"This event indicates the sequencer limit updated.\",\"params\":{\"_newSequencerDelayLimit\":\"The new sequencer delay limit.\"}},\"VerificationStarted(uint256)\":{\"details\":\"This event indicates that the censorship test started and all challengers are ready even in the worst case scenario of a malicious sequencer.\",\"params\":{\"_epoch\":\"The epoch that started verification.\"}},\"Verified(uint256)\":{\"details\":\"This events indicates that verification has succeeded. The messages are ready to be relayed.\",\"params\":{\"_epoch\":\"The epoch that was verified.\"}}},\"kind\":\"dev\",\"methods\":{\"censorshipTestStatus((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Gets the status of the censorship test for claim.\",\"params\":{\"_claim\":\"The claim to test.\"},\"returns\":{\"status\":\"True if the claim passed the censorship test.\"}},\"challenge(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Submit a challenge for the claim of the inbox state root snapshot taken at 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"claim(uint256,bytes32)\":{\"details\":\"Submit a claim about the _stateRoot at _epoch and submit a deposit.\",\"params\":{\"_epoch\":\"The epoch for which the claim is made.\",\"_stateRoot\":\"The state root to claim.\"}},\"constructor\":{\"details\":\"Constructor. Note: epochPeriod must match the VeaInboxArbToGnosis contract deployment on Arbitrum, since it's on a different chain, we can't read it and trust the deployer to set a correct value\",\"params\":{\"_amb\":\"The address of the AMB contract on Gnosis.\",\"_deposit\":\"The deposit amount to submit a claim in wei.\",\"_epochPeriod\":\"The duration of each epoch.\",\"_maxMissingBlocks\":\"The maximum number of blocks that can be missing in a challenge period.\",\"_minChallengePeriod\":\"The minimum time window to challenge a claim.\",\"_routerArbToGnosis\":\"The address of the router on Ethereum that routes from Arbitrum to Gnosis.\",\"_routerChainId\":\"The chain id of the routerArbToGnosis.\",\"_sequencerDelayLimit\":\"The maximum delay in seconds that the Arbitrum sequencer can backdate transactions.\",\"_timeoutEpochs\":\"The epochs before the bridge is considered shutdown.\",\"_weth\":\"The address of the WETH contract on Gnosis.\"}},\"epochAt(uint256)\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"epochNow()\":{\"details\":\"Get the current epoch from the outbox's point of view using the Ethereum L1 clock.\",\"returns\":{\"epoch\":\"The hash of the claim.\"}},\"hashClaim((bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Hashes the claim.\",\"params\":{\"_claim\":\"The claim to hash.\"},\"returns\":{\"hashedClaim\":\"The hash of the claim.\"}},\"isMsgRelayed(uint256)\":{\"details\":\"Get the msg relayed status.\",\"params\":{\"_msgId\":\"The msgId to check.\"},\"returns\":{\"isRelayed\":\"True if the msg was relayed.\"}},\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves any challenge of the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch to verify.\",\"_stateRoot\":\"The true state root for the epoch.\"}},\"sendMessage(bytes32[],uint64,address,address,bytes)\":{\"details\":\"Verifies and relays the message. UNTRUSTED.\",\"params\":{\"_from\":\"The address of the contract on Arbitrum that sent the message.\",\"_message\":\"The message in the vea inbox\",\"_msgId\":\"The zero based index of the message in the inbox.\",\"_proof\":\"The merkle proof to prove the message inclusion in the inbox state root.\",\"_to\":\"The address of the contract on Gnosis to call.\"}},\"startVerification(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Start verification for claim for 'epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the claim to challenge.\"}},\"updateSequencerDelayLimit(uint256,uint256)\":{\"details\":\"Set the sequencerDelayLimit by receiving a message from the AMB.\",\"params\":{\"_newSequencerDelayLimit\":\"The delaySeconds from the MaxTimeVariation struct in the Arbitrum Sequencer contract.\",\"_timestamp\":\"The timestamp of the message.\"}},\"verifySnapshot(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Resolves the optimistic claim for '_epoch'.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch of the optimistic claim.\"}},\"withdrawChallengeDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Challenger if successful. Includes a portion of the Bridger's deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the challenge deposit to withraw.\"}},\"withdrawChallengerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the challenger to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimDeposit(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"Sends the deposit back to the Claimer if successful. Includes a portion of the Challenger's deposit if unsuccessfully challenged.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}},\"withdrawClaimerEscapeHatch(uint256,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"details\":\"When bridge is shutdown, no claim disputes can be resolved. This allows the claimer to withdraw their deposit.\",\"params\":{\"_claim\":\"The claim associated with the epoch.\",\"_epoch\":\"The epoch associated with the claim deposit to withraw.\"}}},\"version\":1},\"userdoc\":{\"kind\":\"user\",\"methods\":{\"resolveDisputedClaim(uint256,bytes32,(bytes32,address,uint32,uint32,uint32,uint8,address))\":{\"notice\":\"Note: Access restricted to AMB.\"}},\"version\":1},\"storageLayout\":{\"storage\":[{\"astId\":2663,\"contract\":\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol:VeaOutboxArbToGnosis\",\"label\":\"stateRoot\",\"offset\":0,\"slot\":\"0\",\"type\":\"t_bytes32\"},{\"astId\":2665,\"contract\":\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol:VeaOutboxArbToGnosis\",\"label\":\"latestVerifiedEpoch\",\"offset\":0,\"slot\":\"1\",\"type\":\"t_uint256\"},{\"astId\":2669,\"contract\":\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol:VeaOutboxArbToGnosis\",\"label\":\"claimHashes\",\"offset\":0,\"slot\":\"2\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":2673,\"contract\":\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol:VeaOutboxArbToGnosis\",\"label\":\"relayed\",\"offset\":0,\"slot\":\"3\",\"type\":\"t_mapping(t_uint256,t_bytes32)\"},{\"astId\":2675,\"contract\":\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol:VeaOutboxArbToGnosis\",\"label\":\"sequencerDelayLimit\",\"offset\":0,\"slot\":\"4\",\"type\":\"t_uint256\"},{\"astId\":2677,\"contract\":\"src/arbitrumToGnosis/VeaOutboxArbToGnosis.sol:VeaOutboxArbToGnosis\",\"label\":\"timestampDelayUpdated\",\"offset\":0,\"slot\":\"5\",\"type\":\"t_uint256\"}],\"types\":{\"t_bytes32\":{\"encoding\":\"inplace\",\"label\":\"bytes32\",\"numberOfBytes\":\"32\"},\"t_mapping(t_uint256,t_bytes32)\":{\"encoding\":\"mapping\",\"key\":\"t_uint256\",\"label\":\"mapping(uint256 => bytes32)\",\"numberOfBytes\":\"32\",\"value\":\"t_bytes32\"},\"t_uint256\":{\"encoding\":\"inplace\",\"label\":\"uint256\",\"numberOfBytes\":\"32\"}}}}");


function $fd56c2b6e5f0e0c1$export$b6380ff64616a4fb(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
}


const $7af05c235ad5da5f$export$21799e7ae6cc115 = /*#__PURE__*/ (0, $fd56c2b6e5f0e0c1$export$b6380ff64616a4fb)({
    id: 421614,
    name: 'Arbitrum Sepolia',
    nativeCurrency: {
        name: 'Arbitrum Sepolia Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://sepolia-rollup.arbitrum.io/rpc'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Arbiscan',
            url: 'https://sepolia.arbiscan.io',
            apiUrl: 'https://api-sepolia.arbiscan.io/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 81930
        }
    },
    testnet: true
});


const $65c2c1915539d26a$export$7a430fb03087826a = /*#__PURE__*/ (0, $fd56c2b6e5f0e0c1$export$b6380ff64616a4fb)({
    id: 10200,
    name: 'Gnosis Chiado',
    nativeCurrency: {
        decimals: 18,
        name: 'Gnosis',
        symbol: 'xDAI'
    },
    rpcUrls: {
        default: {
            http: [
                'https://rpc.chiadochain.net'
            ],
            webSocket: [
                'wss://rpc.chiadochain.net/wss'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://blockscout.chiadochain.net',
            apiUrl: 'https://blockscout.chiadochain.net/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xcA11bde05977b3631167028862bE2a173976CA11',
            blockCreated: 4967313
        }
    },
    testnet: true
});


const $bf1679213569310f$export$31254237fd28c61a = /*#__PURE__*/ (0, $fd56c2b6e5f0e0c1$export$b6380ff64616a4fb)({
    id: 11155111,
    name: 'Sepolia',
    nativeCurrency: {
        name: 'Sepolia Ether',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                'https://sepolia.drpc.org'
            ]
        }
    },
    blockExplorers: {
        default: {
            name: 'Etherscan',
            url: 'https://sepolia.etherscan.io',
            apiUrl: 'https://api-sepolia.etherscan.io/api'
        }
    },
    contracts: {
        multicall3: {
            address: '0xca11bde05977b3631167028862be2a173976ca11',
            blockCreated: 751532
        },
        ensRegistry: {
            address: '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'
        },
        ensUniversalResolver: {
            address: '0xc8Af999e38273D658BE1b921b88A9Ddf005769cC',
            blockCreated: 5317080
        }
    },
    testnet: true
});



parcelRequire("dup7A");
const $78021af630a1bc3c$var$SvgArbitrum = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("g", {
                clipPath: "url(#arbitrum_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("mask", {
                        id: "arbitrum_svg__b",
                        width: 15,
                        height: 16,
                        x: 1,
                        y: 0,
                        maskUnits: "userSpaceOnUse",
                        style: {
                            maskType: "luminance"
                        },
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                            fill: "#fff",
                            d: "M15.184 0H1v16h14.184z"
                        })
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("g", {
                        mask: "url(#arbitrum_svg__b)",
                        children: [
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                                fill: "#213147",
                                d: "M1.539 4.864v6.272c0 .4.214.771.56.97l5.434 3.138c.347.2.773.2 1.12 0l5.433-3.137c.347-.2.561-.57.561-.97V4.863c0-.4-.214-.771-.56-.97L8.653.755c-.347-.2-.773-.2-1.12 0L2.098 3.893c-.347.2-.56.57-.56.97"
                            }),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                                fill: "#69C3FC",
                                d: "m9.278 9.217-.774 2.124a.27.27 0 0 0 0 .183l1.333 3.655 1.542-.89-1.851-5.072a.133.133 0 0 0-.25 0M10.832 5.644a.133.133 0 0 0-.25 0l-.775 2.124a.27.27 0 0 0 0 .183l2.184 5.985 1.542-.89z"
                            }),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                                fill: "#9DCCED",
                                d: "M8.092.991q.058 0 .11.03l5.88 3.394c.069.039.11.113.11.19v6.787a.22.22 0 0 1-.11.19l-5.88 3.395a.2.2 0 0 1-.11.029.23.23 0 0 1-.11-.029l-5.88-3.392a.22.22 0 0 1-.11-.19V4.606a.22.22 0 0 1 .11-.19l5.88-3.394a.2.2 0 0 1 .11-.03m0-.991a1.2 1.2 0 0 0-.607.163L1.607 3.556A1.21 1.21 0 0 0 1 4.606v6.788c0 .433.231.833.607 1.05l5.88 3.394a1.22 1.22 0 0 0 1.213 0l5.88-3.394c.376-.217.607-.617.607-1.05V4.606c0-.433-.231-.833-.607-1.05L8.7.163A1.2 1.2 0 0 0 8.092 0"
                            }),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                                fill: "#213147",
                                d: "m4.203 13.944.541-1.482 1.089.905-1.018.93z"
                            }),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                                fill: "#fff",
                                d: "M7.597 4.12h-1.49a.265.265 0 0 0-.25.175L2.66 13.053l1.542.89L7.722 4.3a.132.132 0 0 0-.125-.179M10.206 4.12H8.715a.265.265 0 0 0-.25.175l-3.648 10 1.542.89L10.33 4.3a.133.133 0 0 0-.124-.179"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("clipPath", {
                    id: "arbitrum_svg__a",
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M1 0h14.184v16H1z"
                    })
                })
            })
        ]
    });
var $78021af630a1bc3c$export$2e2bcd8739ae039 = $78021af630a1bc3c$var$SvgArbitrum;



parcelRequire("dup7A");
const $2763b70e461dc68e$var$SvgEthereum = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fill: "#DAF0FF",
            d: "m12.446 8.15-4.722 2.9L3 8.15 7.724 0zm-4.722 3.831L3 9.081 7.724 16l4.725-6.919z"
        })
    });
var $2763b70e461dc68e$export$2e2bcd8739ae039 = $2763b70e461dc68e$var$SvgEthereum;



parcelRequire("dup7A");
const $ef01ad19e6642d54$var$SvgGnosis = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("g", {
                fill: "#00A6C4",
                clipPath: "url(#gnosis_svg__a)",
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        d: "M4.703 9.11c.46 0 .908-.153 1.27-.433L3.059 5.76a2.083 2.083 0 0 0 .374 2.92c.366.276.811.43 1.27.43M13.376 7.028c0-.46-.154-.908-.434-1.271l-2.916 2.916a2.078 2.078 0 0 0 3.35-1.645"
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        d: "m14.845 3.854-1.29 1.29a2.939 2.939 0 0 1-4.138 4.138L8 10.7 6.587 9.286a2.94 2.94 0 0 1-4.138-4.138l-.662-.662-.628-.632A8 8 0 0 0 8 16a8 8 0 0 0 8-8 8 8 0 0 0-1.155-4.146"
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        d: "M13.787 2.479a7.996 7.996 0 0 0-12.135.654L8 9.484l6.348-6.351a8 8 0 0 0-.561-.654M8 1.047c1.87 0 3.611.721 4.92 2.037L8 8.004l-4.92-4.92A6.88 6.88 0 0 1 8 1.047"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("clipPath", {
                    id: "gnosis_svg__a",
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $ef01ad19e6642d54$export$2e2bcd8739ae039 = $ef01ad19e6642d54$var$SvgGnosis;


var $039e8edd5249fb5b$export$95be4ae94445245a = /*#__PURE__*/ function(Network) {
    Network["DEVNET"] = "devnet";
    Network["TESTNET"] = "testnet";
    return Network;
}({});
const $039e8edd5249fb5b$var$arbToEthContracts = {
    ["devnet"]: {
        veaInbox: (0, (/*@__PURE__*/$parcel$interopDefault($fbf2684cb3a1cc27$exports))).address,
        veaOutbox: (0, (/*@__PURE__*/$parcel$interopDefault($fa03f758eb972340$exports))).address
    },
    ["testnet"]: {
        veaInbox: (0, (/*@__PURE__*/$parcel$interopDefault($47fba1a8bf088cdf$exports))).address,
        veaOutbox: (0, (/*@__PURE__*/$parcel$interopDefault($fdec65adcbe51676$exports))).address
    }
};
const $039e8edd5249fb5b$var$arbToGnosisContracts = {
    ["devnet"]: {
        veaInbox: (0, (/*@__PURE__*/$parcel$interopDefault($0c8750bf065f6e58$exports))).address,
        veaOutbox: (0, (/*@__PURE__*/$parcel$interopDefault($96dccd946dfc76eb$exports))).address
    },
    ["testnet"]: {
        veaInbox: (0, (/*@__PURE__*/$parcel$interopDefault($b6e6298eee266421$exports))).address,
        veaOutbox: (0, (/*@__PURE__*/$parcel$interopDefault($194660b3eb6b0e40$exports))).address
    }
};
const $039e8edd5249fb5b$export$65f4d498acfedc7c = [
    {
        ...(0, $7af05c235ad5da5f$export$21799e7ae6cc115),
        logo: (0, $78021af630a1bc3c$export$2e2bcd8739ae039)
    },
    {
        ...(0, $bf1679213569310f$export$31254237fd28c61a),
        logo: (0, $2763b70e461dc68e$export$2e2bcd8739ae039)
    },
    {
        ...(0, $65c2c1915539d26a$export$7a430fb03087826a),
        logo: (0, $ef01ad19e6642d54$export$2e2bcd8739ae039)
    }
];
const $039e8edd5249fb5b$export$f4608058c83a1dc2 = (id)=>$039e8edd5249fb5b$export$65f4d498acfedc7c.find((chain)=>chain.id === id);
const $039e8edd5249fb5b$export$4cc9423ec3f21f7c = [
    {
        id: 0,
        from: (0, $7af05c235ad5da5f$export$21799e7ae6cc115).id,
        to: (0, $bf1679213569310f$export$31254237fd28c61a).id,
        contracts: $039e8edd5249fb5b$var$arbToEthContracts,
        inboxEndpoint: `https://api.studio.thegraph.com/query/${"61738/veascan-inbox-arb-sepolia/version/latest"}`,
        outboxEndpoint: `https://api.studio.thegraph.com/query/${"61738/veascan-outbox-sepolia/version/latest"}`
    },
    {
        id: 1,
        from: (0, $7af05c235ad5da5f$export$21799e7ae6cc115).id,
        to: (0, $65c2c1915539d26a$export$7a430fb03087826a).id,
        contracts: $039e8edd5249fb5b$var$arbToGnosisContracts,
        inboxEndpoint: `https://api.studio.thegraph.com/query/${"61738/veascan-inbox-arb-sepolia/version/latest"}`,
        outboxEndpoint: `https://api.studio.thegraph.com/query/${"61738/veascan-outbox-chiado/version/latest"}`
    }
];
const $039e8edd5249fb5b$export$f55bcf30472c04eb = (id)=>$039e8edd5249fb5b$export$4cc9423ec3f21f7c.find((bridge)=>bridge.id === id);


const $0cbc3af4abf88a1e$var$InboxQueries = [
    (0, $72674c05516c5d85$export$2c215692068227d4),
    (0, $72674c05516c5d85$export$1e6b7e1acb4f66ff)
];
const $0cbc3af4abf88a1e$export$219a9e7e4111be17 = (query)=>$0cbc3af4abf88a1e$var$InboxQueries.includes(query);
const $0cbc3af4abf88a1e$var$OutboxQueries = [
    (0, $c01bc8aa182cc810$export$88ae1b33958ad484),
    (0, $c01bc8aa182cc810$export$a098f315450cf75c),
    (0, $c01bc8aa182cc810$export$b7a4a1257ef277eb),
    (0, $c01bc8aa182cc810$export$1353c1ff75d0de84)
];
const $0cbc3af4abf88a1e$export$e37e4333115c69c8 = (query)=>$0cbc3af4abf88a1e$var$OutboxQueries.includes(query);
var $0cbc3af4abf88a1e$export$11e75bce9f7ea886 = /*#__PURE__*/ function(ORDER) {
    ORDER[ORDER["firstInbox"] = 0] = "firstInbox";
    ORDER[ORDER["firstOutbox"] = 1] = "firstOutbox";
    return ORDER;
}({});
const $0cbc3af4abf88a1e$var$STATUS_FILTERS = [
    {
        item: {
            text: "All",
            dot: (0, $36383d7ccd515376$export$bca14c5b3b88a9c9).color.white,
            value: 0
        },
        queryInfo: {
            order: 0,
            query: (0, $72674c05516c5d85$export$2c215692068227d4)
        }
    },
    {
        item: {
            text: "Claimed",
            dot: (0, $36383d7ccd515376$export$bca14c5b3b88a9c9).color.turquoise,
            value: 1
        },
        queryInfo: {
            order: 1,
            query: (0, $c01bc8aa182cc810$export$88ae1b33958ad484)
        }
    },
    {
        item: {
            text: "Challenged",
            dot: (0, $36383d7ccd515376$export$bca14c5b3b88a9c9).color.lightPurple,
            value: 2
        },
        queryInfo: {
            order: 1,
            query: (0, $c01bc8aa182cc810$export$1353c1ff75d0de84)
        }
    },
    {
        item: {
            text: "Verified",
            dot: (0, $36383d7ccd515376$export$bca14c5b3b88a9c9).color.darkBlue,
            value: 3
        },
        queryInfo: {
            order: 1,
            query: (0, $c01bc8aa182cc810$export$b7a4a1257ef277eb)
        }
    },
    {
        item: {
            text: "Resolving",
            dot: (0, $36383d7ccd515376$export$bca14c5b3b88a9c9).color.teal,
            value: 4
        },
        queryInfo: {
            order: 0,
            query: (0, $72674c05516c5d85$export$1e6b7e1acb4f66ff)
        }
    },
    {
        item: {
            text: "Resolved",
            dot: (0, $36383d7ccd515376$export$bca14c5b3b88a9c9).color.green,
            value: 5
        },
        queryInfo: {
            order: 1,
            query: (0, $c01bc8aa182cc810$export$a098f315450cf75c)
        }
    }
];
const $0cbc3af4abf88a1e$var$Context = /*#__PURE__*/ (0, $dup7A.createContext)({
    search: "",
    setSearch: ()=>{
    //
    },
    debouncedSearch: "",
    fromChain: 0,
    toChain: 0,
    statusFilter: 0,
    network: (0, $039e8edd5249fb5b$export$95be4ae94445245a).DEVNET,
    setNetwork: ()=>{
    //
    },
    setFromChain: ()=>{
    //
    },
    setToChain: ()=>{
    //
    },
    setStatusFilter: ()=>{
    //
    },
    statusItems: [],
    queryInfo: {
        order: 0,
        query: (0, $72674c05516c5d85$export$2c215692068227d4)
    }
});
const $0cbc3af4abf88a1e$export$2e3feefe77201a07 = ({ children: children })=>{
    const [fromChain, setFromChain] = (0, $dup7A.useState)(0);
    const [toChain, setToChain] = (0, $dup7A.useState)(0);
    const [statusFilter, setStatusFilter] = (0, $dup7A.useState)(0);
    const [search, setSearch] = (0, $dup7A.useState)("");
    const [debouncedSearch, setDebouncedSearch] = (0, $dup7A.useState)("");
    const [network, setNetwork] = (0, $dup7A.useState)((0, $039e8edd5249fb5b$export$95be4ae94445245a).DEVNET);
    (0, $3ba985b3701f9241$export$2e2bcd8739ae039)(()=>setDebouncedSearch(search), 500, [
        search
    ]);
    (0, $dup7A.useEffect)(()=>{
        if (debouncedSearch !== "") setStatusFilter(0);
    }, [
        debouncedSearch
    ]);
    const value = (0, $dup7A.useMemo)(()=>({
            search: search,
            setSearch: setSearch,
            debouncedSearch: debouncedSearch,
            fromChain: fromChain,
            toChain: toChain,
            network: network,
            setNetwork: setNetwork,
            setFromChain: setFromChain,
            setToChain: setToChain,
            statusItems: $0cbc3af4abf88a1e$var$STATUS_FILTERS.map((filter)=>filter.item),
            statusFilter: statusFilter,
            setStatusFilter: setStatusFilter,
            queryInfo: $0cbc3af4abf88a1e$var$STATUS_FILTERS.find((filter)=>filter.item.value === statusFilter).queryInfo
        }), [
        search,
        debouncedSearch,
        fromChain,
        toChain,
        statusFilter,
        network
    ]);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($0cbc3af4abf88a1e$var$Context.Provider, {
        value: value,
        children: [
            " ",
            children,
            " "
        ]
    });
};
const $0cbc3af4abf88a1e$export$616ead5bf0ef583b = ()=>(0, $dup7A.useContext)($0cbc3af4abf88a1e$var$Context);





var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
var $470336380563c84f$var$updateReducer = function(num) {
    return (num + 1) % 1000000;
};
function $470336380563c84f$export$2e2bcd8739ae039() {
    var _a = (0, $dup7A.useReducer)($470336380563c84f$var$updateReducer, 0), update = _a[1];
    return update;
}


function $1e493877dc9f5556$export$efbb6b4f12b20b5e(nextState, currentState) {
    if (typeof nextState === 'function') return nextState.length ? nextState(currentState) : nextState();
    return nextState;
}


function $225f8088c132ce63$var$useList(initialList) {
    if (initialList === void 0) initialList = [];
    var list = (0, $dup7A.useRef)((0, $1e493877dc9f5556$export$efbb6b4f12b20b5e)(initialList));
    var update = (0, $470336380563c84f$export$2e2bcd8739ae039)();
    var actions = (0, $dup7A.useMemo)(function() {
        var a = {
            set: function(newList) {
                list.current = (0, $1e493877dc9f5556$export$efbb6b4f12b20b5e)(newList, list.current);
                update();
            },
            push: function() {
                var items = [];
                for(var _i = 0; _i < arguments.length; _i++)items[_i] = arguments[_i];
                items.length && actions.set(function(curr) {
                    return curr.concat(items);
                });
            },
            updateAt: function(index, item) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    arr[index] = item;
                    return arr;
                });
            },
            insertAt: function(index, item) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    index > arr.length ? arr[index] = item : arr.splice(index, 0, item);
                    return arr;
                });
            },
            update: function(predicate, newItem) {
                actions.set(function(curr) {
                    return curr.map(function(item) {
                        return predicate(item, newItem) ? newItem : item;
                    });
                });
            },
            updateFirst: function(predicate, newItem) {
                var index = list.current.findIndex(function(item) {
                    return predicate(item, newItem);
                });
                index >= 0 && actions.updateAt(index, newItem);
            },
            upsert: function(predicate, newItem) {
                var index = list.current.findIndex(function(item) {
                    return predicate(item, newItem);
                });
                index >= 0 ? actions.updateAt(index, newItem) : actions.push(newItem);
            },
            sort: function(compareFn) {
                actions.set(function(curr) {
                    return curr.slice().sort(compareFn);
                });
            },
            filter: function(callbackFn, thisArg) {
                actions.set(function(curr) {
                    return curr.slice().filter(callbackFn, thisArg);
                });
            },
            removeAt: function(index) {
                actions.set(function(curr) {
                    var arr = curr.slice();
                    arr.splice(index, 1);
                    return arr;
                });
            },
            clear: function() {
                actions.set([]);
            },
            reset: function() {
                actions.set((0, $1e493877dc9f5556$export$efbb6b4f12b20b5e)(initialList).slice());
            }
        };
        /**
         * @deprecated Use removeAt method instead
         */ a.remove = a.removeAt;
        return a;
    }, []);
    return [
        list.current,
        actions
    ];
}
var $225f8088c132ce63$export$2e2bcd8739ae039 = $225f8088c132ce63$var$useList;




parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");



var $dup7A = parcelRequire("dup7A");


var $dup7A = parcelRequire("dup7A");
var $226407d615d776bb$export$8793edee2d425525 = function() {};
function $226407d615d776bb$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $226407d615d776bb$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $226407d615d776bb$export$4e09c449d6c407f7 = typeof window !== 'undefined';
var $226407d615d776bb$export$42e7ac6120dd324e = typeof navigator !== 'undefined';


var $4b2c45c637e46ca6$var$defaultEvents = [
    'mousedown',
    'touchstart'
];
var $4b2c45c637e46ca6$var$useClickAway = function(ref, onClickAway, events) {
    if (events === void 0) events = $4b2c45c637e46ca6$var$defaultEvents;
    var savedCallback = (0, $dup7A.useRef)(onClickAway);
    (0, $dup7A.useEffect)(function() {
        savedCallback.current = onClickAway;
    }, [
        onClickAway
    ]);
    (0, $dup7A.useEffect)(function() {
        var handler = function(event) {
            var el = ref.current;
            el && !el.contains(event.target) && savedCallback.current(event);
        };
        for(var _i = 0, events_1 = events; _i < events_1.length; _i++){
            var eventName = events_1[_i];
            (0, $226407d615d776bb$export$af631764ddc44097)(document, eventName, handler);
        }
        return function() {
            for(var _i = 0, events_2 = events; _i < events_2.length; _i++){
                var eventName = events_2[_i];
                (0, $226407d615d776bb$export$8c8705df4a2dcec9)(document, eventName, handler);
            }
        };
    }, [
        events,
        ref
    ]);
};
var $4b2c45c637e46ca6$export$2e2bcd8739ae039 = $4b2c45c637e46ca6$var$useClickAway;


var $dup7A = parcelRequire("dup7A");
var $8602f0178864630e$var$toggleReducer = function(state, nextValue) {
    return typeof nextValue === 'boolean' ? nextValue : !state;
};
var $8602f0178864630e$var$useToggle = function(initialValue) {
    return (0, $dup7A.useReducer)($8602f0178864630e$var$toggleReducer, initialValue);
};
var $8602f0178864630e$export$2e2bcd8739ae039 = $8602f0178864630e$var$useToggle;



parcelRequire("dup7A");

const $0b9dcc48207a9870$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: block;
  font-family: "Open Sans";
  color: ${({ theme: theme })=>theme.color.lightBlue};
  text-decoration: none;
  svg {
    max-height: 16px;
    max-width: 16px;
    margin-right: 8px;
    fill: ${({ theme: theme })=>theme.color.lightBlue};
  }
  transition: fill 0.25s ease;

  :hover {
    cursor: pointer;
    color: ${({ theme: theme })=>theme.color.blue};
    transform: scale(1.0025);

    svg {
      fill: ${({ theme: theme })=>theme.color.blue};
    }
  }
`;
const $0b9dcc48207a9870$var$MenuLink = ({ text: text, url: url, Icon: Icon })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($0b9dcc48207a9870$var$Container, {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {}),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                children: text
            })
        ]
    });
};
var $0b9dcc48207a9870$export$2e2bcd8739ae039 = $0b9dcc48207a9870$var$MenuLink;



parcelRequire("dup7A");
const $41d80ae2e2afcab0$var$SvgQuestion = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#becce5",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("g", {
                clipPath: "url(#question_svg__a)",
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                    d: "M8 0a8.001 8.001 0 0 0 0 16A8.001 8.001 0 0 0 8 0m0 14.452A6.45 6.45 0 0 1 1.548 8 6.45 6.45 0 0 1 8 1.548 6.45 6.45 0 0 1 14.452 8 6.45 6.45 0 0 1 8 14.452m3.46-8.233c0 2.163-2.337 2.197-2.337 2.996v.204a.387.387 0 0 1-.387.387H7.264a.387.387 0 0 1-.387-.387V9.14c0-1.153.874-1.614 1.534-1.984.567-.318.914-.534.914-.955 0-.556-.71-.925-1.283-.925-.748 0-1.094.354-1.579.967a.387.387 0 0 1-.538.068l-.897-.68a.39.39 0 0 1-.085-.528c.762-1.12 1.732-1.748 3.244-1.748 1.583 0 3.273 1.235 3.273 2.864m-2.105 5.394c0 .747-.608 1.355-1.355 1.355a1.356 1.356 0 0 1-1.355-1.355c0-.747.608-1.355 1.355-1.355s1.355.608 1.355 1.355"
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("clipPath", {
                    id: "question_svg__a",
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $41d80ae2e2afcab0$export$2e2bcd8739ae039 = $41d80ae2e2afcab0$var$SvgQuestion;



parcelRequire("dup7A");
const $24a6610a36f6aae5$var$SvgBug = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("g", {
                clipPath: "url(#bug_svg__a)",
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                    d: "M16 9.028a1.013 1.013 0 0 1-1.02.972h-1.73v.5c0 .683-.153 1.33-.425 1.91l1.882 1.883a1 1 0 0 1-1.414 1.414l-1.71-1.71A4.48 4.48 0 0 1 8.75 15V7.375A.375.375 0 0 0 8.375 7h-.75a.375.375 0 0 0-.375.375V15a4.48 4.48 0 0 1-2.832-1.003l-1.71 1.71a1 1 0 0 1-1.415-1.414l1.882-1.882A4.5 4.5 0 0 1 2.75 10.5V10H1.02A1.014 1.014 0 0 1 0 9.028 1 1 0 0 1 1 8h1.75V6.164L1.293 4.707a1 1 0 0 1 1.414-1.414L4.414 5h7.172l1.707-1.707a1 1 0 0 1 1.414 1.414L13.25 6.164V8H15a1 1 0 0 1 1 1.028M8.03 0a3.5 3.5 0 0 0-3.5 3.5h7a3.5 3.5 0 0 0-3.5-3.5"
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("clipPath", {
                    id: "bug_svg__a",
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $24a6610a36f6aae5$export$2e2bcd8739ae039 = $24a6610a36f6aae5$var$SvgBug;



parcelRequire("dup7A");
const $146e4d053c07705c$var$SvgBook = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M14.838 11.25V.75c0-.416-.33-.75-.741-.75H3.965C2.328 0 1 1.344 1 3v10c0 1.656 1.328 3 2.965 3h10.132c.41 0 .74-.334.74-.75v-.5a.76.76 0 0 0-.274-.584c-.13-.482-.13-1.854 0-2.335a.75.75 0 0 0 .275-.581M4.954 4.188c0-.104.083-.188.185-.188h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.187zm0 2c0-.104.083-.188.185-.188h6.548c.102 0 .186.084.186.188v.625a.187.187 0 0 1-.186.187H5.14a.187.187 0 0 1-.185-.187zM12.78 14H3.965a.993.993 0 0 1-.988-1c0-.55.445-1 .988-1h8.816a11.4 11.4 0 0 0 0 2"
        })
    });
var $146e4d053c07705c$export$2e2bcd8739ae039 = $146e4d053c07705c$var$SvgBook;



parcelRequire("dup7A");
const $50692515133973c6$var$SvgOpenBook = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M15.062 2.002c-1.523.087-4.548.405-6.416 1.563a.43.43 0 0 0-.202.37V14.17c0 .325.351.53.647.38 1.922-.98 4.7-1.247 6.075-1.32a.87.87 0 0 0 .834-.862V2.865a.875.875 0 0 0-.938-.863M7.354 3.565C5.486 2.407 2.46 2.089.938 2.002A.876.876 0 0 0 0 2.865v9.502c0 .457.365.838.834.862 1.375.073 4.155.34 6.077 1.32.295.151.645-.054.645-.378V3.931a.43.43 0 0 0-.202-.366"
        })
    });
var $50692515133973c6$export$2e2bcd8739ae039 = $50692515133973c6$var$SvgOpenBook;



const $1a300f177ba428d2$var$ITEMS = [
    {
        text: "FAQ",
        Icon: (0, $41d80ae2e2afcab0$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja/faq"
    },
    {
        text: "Report a Bug",
        Icon: (0, $24a6610a36f6aae5$export$2e2bcd8739ae039),
        url: "https://github.com/kleros/vea/issues"
    },
    {
        text: "Documentation",
        Icon: (0, $146e4d053c07705c$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja"
    },
    {
        text: "Devs Tutorial",
        Icon: (0, $50692515133973c6$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja/build-xchain-dapps/getting-started"
    },
    {
        text: "Validators Tutorial",
        Icon: (0, $50692515133973c6$export$2e2bcd8739ae039),
        url: "https://docs.vea.ninja/run-a-validator/getting-started"
    }
];
const $1a300f177ba428d2$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 32px;
  padding-left: 32px;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    padding-left: 24px;
  `)}
`;
const $1a300f177ba428d2$var$Wrapper = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  line-height: 0;
  position: relative;
`;
const $1a300f177ba428d2$var$MenuContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  line-height: normal;
  position: absolute;
  min-width: 248px;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1;
  background-color: ${({ theme: theme })=>theme.color.secondaryPurple};
  border: 1px solid ${({ theme: theme })=>theme.color.grey};
  box-shadow: 0px 2px 3px ${({ theme: theme })=>theme.color.black + "03"};
  border-color: ${({ theme: theme })=>theme.color.secondaryBlue};
  display: ${({ isOpen: isOpen })=>isOpen ? "flex" : "none"};
  flex-direction: column;
  gap: 24px;
  padding: 28px 16px;
`;
const $1a300f177ba428d2$var$StyledQuestion = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $41d80ae2e2afcab0$export$2e2bcd8739ae039))`
  height: 16px;
  transition: fill 0.25s ease;

  :hover {
    cursor: pointer;
    transform: scale(1.07);
    fill: ${({ theme: theme })=>theme.color.blue};
  }
`;
const $1a300f177ba428d2$var$Menu = ()=>{
    const ref = (0, $dup7A.useRef)(null);
    (0, $4b2c45c637e46ca6$export$2e2bcd8739ae039)(ref, ()=>{
        toggle(false);
    });
    const [isOpen, toggle] = (0, $8602f0178864630e$export$2e2bcd8739ae039)(false);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($1a300f177ba428d2$var$Container, {
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($1a300f177ba428d2$var$Wrapper, {
            ref: ref,
            children: [
                /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($1a300f177ba428d2$var$StyledQuestion, {
                    onClick: ()=>toggle()
                }),
                /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($1a300f177ba428d2$var$MenuContainer, {
                    isOpen: isOpen,
                    children: $1a300f177ba428d2$var$ITEMS.map((item)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $0b9dcc48207a9870$export$2e2bcd8739ae039), {
                            ...item
                        }, item.text))
                })
            ]
        })
    });
};
var $1a300f177ba428d2$export$2e2bcd8739ae039 = $1a300f177ba428d2$var$Menu;




var $dup7A = parcelRequire("dup7A");



parcelRequire("dup7A");
const $f800237ebc62d762$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fill: "#DAF0FF",
            d: "m15.78 13.833-3.116-3.115a.75.75 0 0 0-.53-.219h-.51a6.47 6.47 0 0 0 1.375-4c0-3.59-2.91-6.499-6.5-6.499S0 2.91 0 6.5s2.91 6.499 6.5 6.499c1.509 0 2.896-.513 3.999-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.885a.753.753 0 0 0 .003-1.062M6.5 10.499c-2.21 0-4-1.787-4-4 0-2.209 1.787-4 4-4 2.209 0 3.999 1.788 3.999 4 0 2.21-1.787 4-4 4"
        })
    });
var $f800237ebc62d762$export$2e2bcd8739ae039 = $f800237ebc62d762$var$SvgSearch;



const $102c4624094b5c77$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: 45px;
  margin-top: 9px;
  margin-bottom: 10px;
  display: flex;
  background-color: transparent;
  color: ${({ theme: theme })=>theme.color.lightBlue};
  border: 1px solid #42498f;
  border-radius: 3px;
  align-items: center;
  width: 33.5vw;

  ::placeholder {
    color: ${({ theme: theme })=>theme.color.lightBlue};
  }
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    width: 77.46vw;
  `)}
`;
const $102c4624094b5c77$var$StyledInput = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).input`
  position: relative;
  background-color: transparent;
  color: ${({ theme: theme })=>theme.color.lightBlue};
  border: none;
  width: 33.5vw;
  margin-left: 4px;

  font-family: "Oxanium";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;

  ::placeholder {
    color: ${({ theme: theme })=>theme.color.lightBlue};
  }

  :focus {
    outline: none;
  }

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    width: 77.46vw;
  `)}
`;
const $102c4624094b5c77$var$SearchIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  height: 16px;
  margin-left: 16px;
  margin-top: 14px;
  margin-bottom: 15px;
`;
const $102c4624094b5c77$var$SearchIconContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: 45px;
`;
const $102c4624094b5c77$var$SearchBar = ()=>{
    const [placeholder, setPlaceholder] = (0, $dup7A.useState)("");
    const { search: search, setSearch: setSearch } = (0, $0cbc3af4abf88a1e$export$616ead5bf0ef583b)();
    (0, $dup7A.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth <= 500) setPlaceholder("Search");
            else setPlaceholder("Search by Epoch ID / State Root");
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($102c4624094b5c77$var$Container, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($102c4624094b5c77$var$SearchIconContainer, {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($102c4624094b5c77$var$SearchIcon, {
                    as: (0, $f800237ebc62d762$export$2e2bcd8739ae039)
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($102c4624094b5c77$var$StyledInput, {
                type: "text",
                value: search,
                onChange: (e)=>setSearch(e.target.value),
                placeholder: placeholder
            })
        ]
    });
};
var $102c4624094b5c77$export$2e2bcd8739ae039 = $102c4624094b5c77$var$SearchBar;



const $fd909920f99348f6$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  height: 68px;
  position: sticky;
  top: 0px;
  z-index: 2;
  background-color: ${({ theme: theme })=>theme.color.secondaryPurple};
  padding: 0 8%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 4px solid;
  border-image-slice: 1;
  ${({ theme: theme })=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    border-image-source: linear-gradient(
      to right,
      ${theme.color.blue},
      ${theme.color.pink}
    );
  `}

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    height: 136px;
    display: flex;
    flex-direction: column;
    align-items: start;
    padding: 0 6%;
  `)}
`;
const $fd909920f99348f6$var$StyledTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h5`
  font-size: 31.5px;
  margin-top: 20px;
  margin-bottom: 20px;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    margin-bottom: 10px;
  `)}
`;
const $fd909920f99348f6$var$StyledSubtitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h5`
  color: ${({ theme: theme })=>theme.color.lightBlue};
  font-size: 15.5px;
  padding-left: 14px;
  margin-top: 26.5px;
  margin-bottom: 24px;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    margin-bottom: 14px;
  `)}
`;
const $fd909920f99348f6$var$StyledLogo = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
`;
const $fd909920f99348f6$var$Navbar = /*#__PURE__*/ (0, $dup7A.forwardRef)((_, ref)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($fd909920f99348f6$var$Container, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($fd909920f99348f6$var$StyledLogo, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($fd909920f99348f6$var$StyledTitle, {
                        children: "VeA"
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($fd909920f99348f6$var$StyledSubtitle, {
                        children: "explorer"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($fd909920f99348f6$var$StyledLogo, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $102c4624094b5c77$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $1a300f177ba428d2$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    }));
$fd909920f99348f6$var$Navbar.displayName = "Navbar";
var $fd909920f99348f6$export$2e2bcd8739ae039 = $fd909920f99348f6$var$Navbar;



parcelRequire("dup7A");


parcelRequire("dup7A");


parcelRequire("dup7A");
const $50a0fd9ac324c9f8$var$SvgBuiltByKleros = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 151 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("g", {
                fill: "#fff",
                fillRule: "evenodd",
                clipPath: "url(#built-by-kleros_svg__a)",
                clipRule: "evenodd",
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                    d: "m63.528 0 13.588.607 5.502 12.223L74.856 24l-13.662-.875-5.601-13.243zm9.962 7.045-9.848 4.303 8.419 6.509zM72.35 4.89l-7.87-3.388-1.654 7.124zm-1.995 14.605-8.553-6.107.206 8.276zm10.897-6.691-5.829-5.914-1.539 11.372zm-8.892 8.022-7.213 1.885 8.483.543zm7.752-5.34-6.314 4.704 1.255 2.452zm-2.986-13.17-1.227 2.518 4.565 4.64zM75.598 1.11 67.581.785l6.613 2.892zm-13.24 1.164-5.616 7.09 3.754.795zM60.27 11.55l-3.772-.799 3.936 9.272zM91.975 11.154h-.456V7.095h-1.222v9.525h1.222v-4.46h.42l3.849 4.698.93-.786-3.703-4.48L96.17 7.59l-.931-.731zm10.636-4.059h-1.223v9.525h6.201v-1.097h-4.978zm9.483 0h5.928v1.097h-4.706v2.852h3.885v1.097h-3.885v3.382h4.706v1.097h-5.928zm14.027 0h-3.229v9.525h1.223v-4.077h1.769l2.425 4.315 1.058-.64-2.334-3.858c1.148-.347 1.932-1.499 1.932-2.669 0-1.846-1.258-2.596-2.844-2.596m1.567 2.596c0 1.08-.784 1.755-1.968 1.755h-1.605V8.192h1.968c1.095 0 1.605.64 1.605 1.5m12.278 2.175c0 .768-.055 4.918-3.375 4.918-1.532 0-3.374-1.096-3.374-4.918 0-3.802 1.806-4.936 3.374-4.936 1.514 0 3.375 1.097 3.375 4.936m-5.472 0c0 1.39.255 3.767 2.097 3.767s2.098-2.377 2.098-3.767c0-1.407-.255-3.784-2.098-3.784s-2.097 2.377-2.097 3.784m13.133 3.767c-1.277 0-1.843-.86-2.08-2.03l-1.094.348c.292 1.7 1.404 2.833 3.174 2.833 1.751 0 3.01-1.024 3.01-2.833 0-.988-.457-1.756-1.314-2.23l-2.025-.897c-.729-.329-1.277-.585-1.277-1.48 0-.86.767-1.262 1.551-1.262 1.04 0 1.532.658 1.751 1.59l1.168-.347c-.383-1.48-1.314-2.395-2.901-2.395-1.496 0-2.791.896-2.791 2.505 0 1.634 1.093 2.082 2.337 2.592l.363.15q.114.048.229.093c.856.345 1.686.68 1.686 1.754 0 1.06-.784 1.609-1.787 1.609"
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                fill: "#fff",
                d: "M1.415 6.643h2.741q1.853 0 2.721.628.868.63.868 1.9 0 .87-.533 1.45-.527.575-1.545.738v.041q1.197.178 1.757.76.567.573.567 1.606 0 1.38-.916 2.126-.915.744-2.597.745H1.415zm.697 4.45h2.201q1.409 0 2.044-.465Q7 10.156 7 9.158q0-.997-.725-1.449-.717-.45-2.146-.451H2.112zm0 .615v4.313h2.352q2.775 0 2.775-2.255 0-2.058-2.926-2.058zM10.61 9.206v4.813q0 1.12.471 1.633.472.507 1.463.506 1.327 0 1.948-.67.63-.67.63-2.18V9.206h.669v7.43h-.574l-.123-1.025h-.041q-.725 1.162-2.577 1.162-2.537 0-2.537-2.713V9.206zM18.956 16.637h-.677V9.206h.677zm-.772-9.495q0-.657.43-.657.212 0 .328.171.123.171.123.486 0 .307-.123.485a.37.37 0 0 1-.328.178q-.43 0-.43-.663M22.128 16.637h-.677V6h.677zM26.585 16.172q.642 0 1.121-.11v.547q-.492.165-1.135.164-.984 0-1.456-.526-.465-.526-.465-1.654V9.794h-1.1v-.397l1.1-.307.342-1.682h.349v1.798h2.18v.588h-2.18v4.703q0 .854.3 1.265.302.41.944.41M36.087 9.063q1.558 0 2.345.984.792.977.793 2.864 0 1.853-.834 2.858-.828 1.005-2.331 1.004-.794 0-1.43-.328a2.5 2.5 0 0 1-1.004-.93h-.061l-.192 1.122h-.424V6h.677v2.673q0 .6-.027 1.107l-.02.581h.047q.423-.669 1.019-.984.6-.315 1.442-.315m-.014.615q-1.312 0-1.88.752t-.567 2.481v.116q0 1.682.588 2.413.595.732 1.846.732 1.215 0 1.832-.848.615-.854.615-2.426 0-3.22-2.434-3.22M40.045 9.206h.697l1.573 4.17q.717 1.92.909 2.59h.04a76 76 0 0 1 .937-2.631l1.572-4.129h.698l-3.33 8.634q-.403 1.053-.676 1.422a1.8 1.8 0 0 1-.643.553q-.361.185-.882.185-.39 0-.868-.144v-.587q.397.11.855.109.348 0 .615-.164t.478-.513q.22-.341.5-1.094.286-.745.369-.97z"
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("clipPath", {
                    id: "built-by-kleros_svg__a",
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M55 0h96v24H55z"
                    })
                })
            })
        ]
    });
var $50a0fd9ac324c9f8$export$2e2bcd8739ae039 = $50a0fd9ac324c9f8$var$SvgBuiltByKleros;


const $32209592bd146b61$var$StyledKlerosLink = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  width: fit-content;
  height: fit-content;
  line-height: 0;
  display: block;
  > svg {
    width: 150px;
    transition: transform 0.25s ease;

    :hover {
      transform: scale(1.05);
    }
  }
`;
const $32209592bd146b61$var$BuiltByKleros = ({ className: className })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($32209592bd146b61$var$StyledKlerosLink, {
        href: "https://www.kleros.io",
        target: "_blank",
        rel: "noopener noreferrer",
        className: className,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $50a0fd9ac324c9f8$export$2e2bcd8739ae039), {})
    });
var $32209592bd146b61$export$2e2bcd8739ae039 = $32209592bd146b61$var$BuiltByKleros;



parcelRequire("dup7A");
const $65a2ee3e19a9b3c0$var$SvgLines = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 1440 149",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                fill: "url(#lines_svg__a)",
                fillRule: "evenodd",
                d: "M348.963 129.469h744.567L1439.3 0l.35.937-345.85 129.5-.09.032H348.784l-.085-.032L.349.937.696 0zm0 9.499h744.567L1439.3 9.5l.35.937-345.85 129.5-.09.031H348.784l-.085-.031L.349 10.437.696 9.5zm744.567 9H348.963L.697 18.5l-.349.937 348.351 129.5.085.031h744.926l.09-.031 345.85-129.5-.35-.937z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("linearGradient", {
                    id: "lines_svg__a",
                    x1: 719.998,
                    x2: 719.998,
                    y1: 0,
                    y2: 148.968,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("stop", {
                            stopColor: "#FFFDF5"
                        }),
                        /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("stop", {
                            offset: 1,
                            stopColor: "#69C3FC"
                        })
                    ]
                })
            })
        ]
    });
var $65a2ee3e19a9b3c0$export$2e2bcd8739ae039 = $65a2ee3e19a9b3c0$var$SvgLines;



parcelRequire("dup7A");
const $9e0ec0c4728e8565$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M5.352 13.026c0 .062-.075.111-.168.111-.107.01-.18-.04-.18-.11 0-.062.073-.111.167-.111.097-.01.18.04.18.11m-1.004-.138c-.022.062.042.132.14.15.083.031.18 0 .2-.06.018-.062-.043-.133-.14-.16-.083-.022-.177.009-.2.07m1.426-.052c-.093.021-.158.08-.148.15.01.062.093.102.19.08.094-.021.158-.08.149-.141-.01-.058-.097-.098-.19-.09M7.897 1.062C3.423 1.062 0 4.297 0 8.559c0 3.407 2.252 6.323 5.468 7.35.413.07.558-.173.558-.372 0-.19-.01-1.242-.01-1.887 0 0-2.258.461-2.732-.915 0 0-.368-.895-.897-1.125 0 0-.739-.482.052-.473 0 0 .803.061 1.245.793.706 1.186 1.89.845 2.351.642.075-.492.284-.833.517-1.036-1.804-.19-3.623-.44-3.623-3.395 0-.845.245-1.269.761-1.81-.084-.2-.358-1.023.084-2.086.674-.2 2.226.83 2.226.83a8 8 0 0 1 2.026-.261c.687 0 1.38.089 2.026.26 0 0 1.551-1.032 2.225-.829.442 1.066.168 1.887.084 2.086.516.544.832.968.832 1.81 0 2.965-1.9 3.202-3.703 3.395.297.243.549.704.549 1.426 0 1.035-.01 2.317-.01 2.569 0 .2.148.442.558.371C13.813 14.882 16 11.966 16 8.56c0-4.262-3.629-7.497-8.103-7.497M3.135 11.659c-.041.03-.032.101.023.16.052.05.126.07.168.03.042-.03.032-.1-.023-.16-.051-.048-.126-.07-.168-.03m-.348-.249c-.022.04.01.09.074.12.052.03.116.022.139-.021.023-.04-.01-.09-.074-.12-.065-.019-.116-.01-.139.021m1.045 1.094c-.051.04-.032.132.042.19.074.071.168.08.21.031.042-.04.022-.132-.042-.19-.071-.07-.168-.08-.21-.03m-.367-.452c-.052.031-.052.111 0 .182.051.07.138.101.18.07.052-.04.052-.12 0-.19-.045-.07-.129-.102-.18-.062"
        })
    });
var $9e0ec0c4728e8565$export$2e2bcd8739ae039 = $9e0ec0c4728e8565$var$SvgGithub;



parcelRequire("dup7A");
const $735b7ab45cb62a6e$var$SvgTelegram = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 14",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "m15.954 1.197-2.414 11.16c-.182.787-.657.983-1.332.612l-3.68-2.657-1.774 1.673c-.197.193-.361.354-.74.354l.265-3.672 6.818-6.038c.297-.26-.064-.403-.46-.144l-8.43 5.202L.578 6.574c-.79-.242-.804-.774.164-1.145L14.937.07c.657-.241 1.232.144 1.017 1.127"
        })
    });
var $735b7ab45cb62a6e$export$2e2bcd8739ae039 = $735b7ab45cb62a6e$var$SvgTelegram;



parcelRequire("dup7A");
const $659e63d54aad9e02$var$SvgTwitter = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            d: "M14.355 5.155c.01.136.01.272.01.407 0 4.14-3.299 8.912-9.33 8.912A9.6 9.6 0 0 1 0 13.068c.264.029.518.039.792.039a6.77 6.77 0 0 0 4.071-1.339c-1.442-.029-2.65-.93-3.066-2.172.203.03.406.049.62.049.294 0 .588-.039.862-.107C1.777 9.248.65 7.987.65 6.464v-.038a3.4 3.4 0 0 0 1.483.397C1.249 6.261.67 5.301.67 4.215c0-.582.162-1.115.447-1.58 1.614 1.9 4.04 3.14 6.761 3.277a3.4 3.4 0 0 1-.081-.718c0-1.726 1.462-3.132 3.28-3.132.943 0 1.796.378 2.395.99a6.6 6.6 0 0 0 2.081-.757 3.15 3.15 0 0 1-1.441 1.726c.66-.068 1.3-.243 1.888-.485a6.9 6.9 0 0 1-1.645 1.62"
        })
    });
var $659e63d54aad9e02$export$2e2bcd8739ae039 = $659e63d54aad9e02$var$SvgTwitter;



const $9136fdf6014f2328$var$LINKS = [
    {
        Icon: (0, $659e63d54aad9e02$export$2e2bcd8739ae039),
        href: "https://www.twitter.com/vea_eth"
    },
    {
        Icon: (0, $9e0ec0c4728e8565$export$2e2bcd8739ae039),
        href: "https://www.github.com/kleros/vea"
    },
    {
        Icon: (0, $735b7ab45cb62a6e$export$2e2bcd8739ae039),
        href: "https://t.me/veabridge"
    }
];
const $9136fdf6014f2328$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  border-bottom: 16px solid;
  border-image-slice: 1;
  ${({ theme: theme })=>(0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    border-image-source: linear-gradient(
      to right,
      ${theme.color.blue},
      ${theme.color.pink}
    );
  `}
`;
const $9136fdf6014f2328$var$InnerContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    margin-bottom: 32px;
    flex-direction: column;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 10px;
  `)}
`;
const $9136fdf6014f2328$var$Logo = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h2`
  text-align: center;
  margin: 20px;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    position: relative;
    font-size: 46px;
  `)}
`;
const $9136fdf6014f2328$var$StyledLink = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  line-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    fill: ${({ theme: theme })=>theme.color.lightBlue};
    width: 32px;
    transition: fill 0.25s ease, transform 0.25s ease;
    :hover {
      fill: ${({ theme: theme })=>theme.color.blue};
      transform: scale(1.05);
    }
  }
`;
const $9136fdf6014f2328$var$SocialMedia = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: absolute;
  top: 50%;
  right: 5%;
  transform: translateY(-50%);
  display: flex;
  gap: 16px;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    position: relative;
    right: 0%;
    margin-top: 30px;
  `)}
`;
const $9136fdf6014f2328$var$StyledBuiltByKleros = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $32209592bd146b61$export$2e2bcd8739ae039))`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 5%;
  display: flex;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    top: 100%;
    position: relative;
    left: 0%;
  `)}
`;
const $9136fdf6014f2328$var$Footer = ()=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($9136fdf6014f2328$var$Container, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $65a2ee3e19a9b3c0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($9136fdf6014f2328$var$InnerContainer, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($9136fdf6014f2328$var$StyledBuiltByKleros, {}),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($9136fdf6014f2328$var$Logo, {
                        children: "VeA"
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($9136fdf6014f2328$var$SocialMedia, {
                        children: $9136fdf6014f2328$var$LINKS.map(({ href: href, Icon: Icon })=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($9136fdf6014f2328$var$StyledLink, {
                                href: href,
                                target: "_blank",
                                rel: "noopener noreferrer",
                                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)(Icon, {})
                            }, href))
                    })
                ]
            })
        ]
    });
var $9136fdf6014f2328$export$2e2bcd8739ae039 = $9136fdf6014f2328$var$Footer;




var $dup7A = parcelRequire("dup7A");
const $85550573afdeb21f$export$c30087714757f312 = ()=>{
    const [ref, setRef] = (0, $dup7A.useState)(null);
    const [position, setPosition] = (0, $dup7A.useState)({
        width: 0,
        height: 0,
        offsetTop: 0,
        offsetLeft: 0
    });
    const handleResize = (0, $dup7A.useCallback)(()=>{
        setPosition({
            width: ref?.offsetWidth || 0,
            height: ref?.offsetHeight || 0,
            offsetTop: ref?.offsetTop || 0,
            offsetLeft: ref?.offsetLeft || 0
        });
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth,
        ref?.offsetTop,
        ref?.offsetLeft
    ]);
    (0, $dup7A.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    });
    (0, $dup7A.useLayoutEffect)(()=>{
        handleResize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ref?.offsetHeight,
        ref?.offsetWidth,
        ref?.offsetTop,
        ref?.offsetLeft
    ]);
    return [
        setRef,
        position
    ];
};


const $96065926c92644df$var$MiddleContent = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    margin: 0 5%;
  `)}
  max-width: 1120px;
`;
const $96065926c92644df$var$Content = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  min-height: calc(100vh - ${({ navbarHeight: navbarHeight })=>navbarHeight}px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const $96065926c92644df$var$Layout = ({ children: children })=>{
    const [ref, { height: navbarHeight }] = (0, $85550573afdeb21f$export$c30087714757f312)();
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $fd909920f99348f6$export$2e2bcd8739ae039), {
                ref: ref
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($96065926c92644df$var$Content, {
                navbarHeight: navbarHeight,
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($96065926c92644df$var$MiddleContent, {
                        children: [
                            " ",
                            children,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $9136fdf6014f2328$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $96065926c92644df$export$2e2bcd8739ae039 = $96065926c92644df$var$Layout;



parcelRequire("dup7A");





var $dup7A = parcelRequire("dup7A");




var $dup7A = parcelRequire("dup7A");




var $dup7A = parcelRequire("dup7A");

parcelRequire("dup7A");


parcelRequire("dup7A");
const $4cc1c2bd58f3df04$var$SvgDocument = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("g", {
                clipPath: "url(#document_svg__a)",
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                    fill: "#69C3FC",
                    d: "M11.23 8.25v.875a.38.38 0 0 1-.384.375H5.462a.38.38 0 0 1-.385-.375V8.25c0-.206.173-.375.385-.375h5.384c.212 0 .385.169.385.375m-.384 2.25H5.462a.38.38 0 0 0-.385.375v.875c0 .206.173.375.385.375h5.384a.38.38 0 0 0 .385-.375v-.875a.38.38 0 0 0-.385-.375m3.462-5.878V15c0 .828-.69 1.5-1.539 1.5H3.54C2.688 16.5 2 15.828 2 15V2C2 1.172 2.69.5 3.538.5h6.542c.407 0 .798.16 1.087.44l2.689 2.623c.288.278.452.662.452 1.059m-4.103-2.5V4.5h2.44zM12.77 15V6H9.436a.76.76 0 0 1-.77-.75V2H3.539v13z"
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("clipPath", {
                    id: "document_svg__a",
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 .5h16v16H0z"
                    })
                })
            })
        ]
    });
var $4cc1c2bd58f3df04$export$2e2bcd8739ae039 = $4cc1c2bd58f3df04$var$SvgDocument;


const $bd697c2e56815211$var$Icon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  width: 16px;
  height: 16px;
  fill: none;
`;
const $bd697c2e56815211$var$Status = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  align-items: center;
  small {
    color: ${({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue} !important;
    font-weight: 600;
    line-height: 20px;
    font-size: 16px;
  }
  margin-top: 46px;
`;
const $bd697c2e56815211$var$MessageHeader = ({ messageNumber: messageNumber, status: status })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($bd697c2e56815211$var$Status, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($bd697c2e56815211$var$Icon, {
                as: (0, $4cc1c2bd58f3df04$export$2e2bcd8739ae039)
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("small", {
                children: [
                    "Message #",
                    messageNumber,
                    " - ",
                    status
                ]
            })
        ]
    });
};
var $bd697c2e56815211$export$2e2bcd8739ae039 = $bd697c2e56815211$var$MessageHeader;



parcelRequire("dup7A");

var $5c1ca57cf6616ccf$exports = {};
"use strict";
var $238901e04262b8d1$exports = {};
$238901e04262b8d1$exports = function() {
    var selection = document.getSelection();
    if (!selection.rangeCount) return function() {};
    var active = document.activeElement;
    var ranges = [];
    for(var i = 0; i < selection.rangeCount; i++)ranges.push(selection.getRangeAt(i));
    switch(active.tagName.toUpperCase()){
        case 'INPUT':
        case 'TEXTAREA':
            active.blur();
            break;
        default:
            active = null;
            break;
    }
    selection.removeAllRanges();
    return function() {
        selection.type === 'Caret' && selection.removeAllRanges();
        if (!selection.rangeCount) ranges.forEach(function(range) {
            selection.addRange(range);
        });
        active && active.focus();
    };
};


var $5c1ca57cf6616ccf$var$clipboardToIE11Formatting = {
    "text/plain": "Text",
    "text/html": "Url",
    "default": "Text"
};
var $5c1ca57cf6616ccf$var$defaultMessage = "Copy to clipboard: #{key}, Enter";
function $5c1ca57cf6616ccf$var$format(message) {
    var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
    return message.replace(/#{\s*key\s*}/g, copyKey);
}
function $5c1ca57cf6616ccf$var$copy(text, options) {
    var debug, message, reselectPrevious, range, selection, mark, success = false;
    if (!options) options = {};
    debug = options.debug || false;
    try {
        reselectPrevious = $238901e04262b8d1$exports();
        range = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        // avoid screen readers from reading out loud the text
        mark.ariaHidden = "true";
        // reset user styles for span element
        mark.style.all = "unset";
        // prevents scrolling to the end of the page
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        // used to preserve spaces and line breaks
        mark.style.whiteSpace = "pre";
        // do not inherit user-select (it may be `none`)
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
            e.stopPropagation();
            if (options.format) {
                e.preventDefault();
                if (typeof e.clipboardData === "undefined") {
                    debug && console.warn("unable to use e.clipboardData");
                    debug && console.warn("trying IE specific stuff");
                    window.clipboardData.clearData();
                    var format = $5c1ca57cf6616ccf$var$clipboardToIE11Formatting[options.format] || $5c1ca57cf6616ccf$var$clipboardToIE11Formatting["default"];
                    window.clipboardData.setData(format, text);
                } else {
                    e.clipboardData.clearData();
                    e.clipboardData.setData(options.format, text);
                }
            }
            if (options.onCopy) {
                e.preventDefault();
                options.onCopy(e.clipboardData);
            }
        });
        document.body.appendChild(mark);
        range.selectNodeContents(mark);
        selection.addRange(range);
        var successful = document.execCommand("copy");
        if (!successful) throw new Error("copy command was unsuccessful");
        success = true;
    } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
            window.clipboardData.setData(options.format || "text", text);
            options.onCopy && options.onCopy(window.clipboardData);
            success = true;
        } catch (err) {
            debug && console.error("unable to copy using clipboardData: ", err);
            debug && console.error("falling back to prompt");
            message = $5c1ca57cf6616ccf$var$format("message" in options ? options.message : $5c1ca57cf6616ccf$var$defaultMessage);
            window.prompt(message, text);
        }
    } finally{
        if (selection) {
            if (typeof selection.removeRange == "function") selection.removeRange(range);
            else selection.removeAllRanges();
        }
        if (mark) document.body.removeChild(mark);
        reselectPrevious();
    }
    return success;
}
$5c1ca57cf6616ccf$exports = $5c1ca57cf6616ccf$var$copy;



var $dup7A = parcelRequire("dup7A");

var $dup7A = parcelRequire("dup7A");
function $e1bb021e408ddffa$export$2e2bcd8739ae039() {
    var mountedRef = (0, $dup7A.useRef)(false);
    var get = (0, $dup7A.useCallback)(function() {
        return mountedRef.current;
    }, []);
    (0, $dup7A.useEffect)(function() {
        mountedRef.current = true;
        return function() {
            mountedRef.current = false;
        };
    }, []);
    return get;
}



var $dup7A = parcelRequire("dup7A");
var $1605017c7ab5ea8b$var$useSetState = function(initialState) {
    if (initialState === void 0) initialState = {};
    var _a = (0, $dup7A.useState)(initialState), state = _a[0], set = _a[1];
    var setState = (0, $dup7A.useCallback)(function(patch) {
        set(function(prevState) {
            return Object.assign({}, prevState, patch instanceof Function ? patch(prevState) : patch);
        });
    }, []);
    return [
        state,
        setState
    ];
};
var $1605017c7ab5ea8b$export$2e2bcd8739ae039 = $1605017c7ab5ea8b$var$useSetState;


var $7fd1d6b11ea151c5$var$useCopyToClipboard = function() {
    var isMounted = (0, $e1bb021e408ddffa$export$2e2bcd8739ae039)();
    var _a = (0, $1605017c7ab5ea8b$export$2e2bcd8739ae039)({
        value: undefined,
        error: undefined,
        noUserInteraction: true
    }), state = _a[0], setState = _a[1];
    var copyToClipboard = (0, $dup7A.useCallback)(function(value) {
        if (!isMounted()) return;
        var noUserInteraction;
        var normalizedValue;
        try {
            // only strings and numbers casted to strings can be copied to clipboard
            if (typeof value !== 'string' && typeof value !== 'number') {
                var error = new Error("Cannot copy typeof " + typeof value + " to clipboard, must be a string");
                setState({
                    value: value,
                    error: error,
                    noUserInteraction: true
                });
                return;
            } else if (value === '') {
                var error = new Error("Cannot copy empty string to clipboard.");
                setState({
                    value: value,
                    error: error,
                    noUserInteraction: true
                });
                return;
            }
            normalizedValue = value.toString();
            noUserInteraction = (0, (/*@__PURE__*/$parcel$interopDefault($5c1ca57cf6616ccf$exports)))(normalizedValue);
            setState({
                value: normalizedValue,
                error: undefined,
                noUserInteraction: noUserInteraction
            });
        } catch (error) {
            setState({
                value: normalizedValue,
                error: error,
                noUserInteraction: noUserInteraction
            });
        }
    }, []);
    return [
        state,
        copyToClipboard
    ];
};
var $7fd1d6b11ea151c5$export$2e2bcd8739ae039 = $7fd1d6b11ea151c5$var$useCopyToClipboard;



parcelRequire("dup7A");
const $a46ca55c52605115$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fill: "#69C3FC",
            d: "M14.776 2.06 13.129.44A1.54 1.54 0 0 0 12.05 0H6.587c-.841 0-1.524.672-1.524 1.5V3h-2.54C1.684 3 1 3.672 1 4.5v10c0 .828.682 1.5 1.524 1.5h7.11c.842 0 1.525-.672 1.525-1.5V13h2.54c.841 0 1.523-.672 1.523-1.5V3.121c0-.398-.16-.779-.446-1.06M9.444 14.5h-6.73a.2.2 0 0 1-.134-.055.19.19 0 0 1-.056-.133V4.688c0-.05.02-.098.056-.133a.2.2 0 0 1 .134-.055h2.35v7c0 .828.682 1.5 1.523 1.5h3.048v1.313c0 .05-.02.097-.056.132a.2.2 0 0 1-.135.055m4.064-3h-6.73a.2.2 0 0 1-.135-.055.19.19 0 0 1-.056-.133V1.688c0-.05.02-.098.056-.133a.2.2 0 0 1 .135-.055h3.365v2.75c0 .414.341.75.762.75h2.793v6.313c0 .05-.02.097-.055.132a.2.2 0 0 1-.135.055m.19-8h-2.031v-2h.305c.051 0 .1.02.135.055l1.536 1.511a.19.19 0 0 1 .055.133z"
        })
    });
var $a46ca55c52605115$export$2e2bcd8739ae039 = $a46ca55c52605115$var$SvgCopy;




const $27b211fec267c408$var$StyledDiv = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  width: auto;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    width: 100%;
    word-wrap: break-word;
    margin-left: 2px;
  `)}

  .border {
    margin: 24px 0px;
    border: 1px solid ${({ theme: theme })=>theme.klerosUIComponentsStroke};
    height: 0px;
  }
`;
const $27b211fec267c408$var$InfoDiv = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    gap: 16px;
  `)}
  width: fit-content;
`;
const $27b211fec267c408$var$DataContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: grid;
  grid-row: 2;
  gap: 108px;
  width: fit-content;

  ${({ section: section })=>section === "Chain" ? (0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          display: flex;
          flex-direction: row;
          gap: 16px;
        `) : (0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          display: flex;
          flex-direction: column;
          gap: 4px;
        `)}
`;
const $27b211fec267c408$var$InfoText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).small`
  grid-column-start: 1;
  display: inline-block;
  width: 12vw;
  gap: 4px;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    width: auto;
  `)}
  color: ${({ theme: theme })=>theme.color.smoke};
`;
const $27b211fec267c408$var$DataText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).small`
  ${({ url: url })=>url ? (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          color: ${({ theme: theme })=>theme.klerosUIComponentsPrimaryBlue} !important;
          text-decoration: none;
        ` : (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          color: ${({ theme: theme })=>theme.klerosUIComponentsPrimaryText};
        `}
`;
const $27b211fec267c408$var$ValueDiv = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    width: 100%;
    gap: 4px;
    word-break: break-all;
  `)}

  ${({ section: section })=>section === "Chain" ? (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          gap: 4px;
        ` : (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
          gap: 9px;
        `}
`;
const $27b211fec267c408$var$Icon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  width: 16px;
  height: 16px;
  fill: none;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)``)}
`;
const $27b211fec267c408$var$Header = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).label`
  margin: 36px 0px 24px;
  width: fit-content;
  display: block;
`;
const $27b211fec267c408$var$DataDiv = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  grid-column-start: 2;
  display: flex;
  flex-direction: column;
  width: auto;
  gap: 4px;
`;
const $27b211fec267c408$var$CopyableDiv = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 9px;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    display: block;
  `)}
`;
const $27b211fec267c408$var$TxCard = ({ title: title, chain: chain, txHash: txHash, timestamp: timestamp, caller: caller, extraFields: extraFields })=>{
    const chainObject = (0, $039e8edd5249fb5b$export$f4608058c83a1dc2)(chain);
    const fields = [
        {
            key: "Chain",
            value: chainObject?.name,
            isCopy: false
        },
        {
            key: "Transaction ID",
            value: txHash,
            isCopy: true,
            url: `${chainObject?.blockExplorers?.default.url}/tx/${txHash}`
        },
        {
            key: "Timestamp",
            value: timestamp,
            isCopy: false
        },
        {
            key: "Caller",
            value: caller,
            isCopy: true,
            url: `${chainObject?.blockExplorers?.default.url}/address/${caller}`
        }
    ].concat(extraFields ?? []);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($27b211fec267c408$var$StyledDiv, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$Header, {
                children: title
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$InfoDiv, {
                children: fields.map((section, index)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($27b211fec267c408$var$DataContainer, {
                        section: section.key,
                        children: [
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$InfoText, {
                                children: section.key
                            }),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$DataDiv, {
                                children: section.key === "Chain" ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($27b211fec267c408$var$ValueDiv, {
                                    section: section.key,
                                    children: [
                                        /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$Icon, {
                                            as: chainObject?.logo
                                        }),
                                        /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$DataText, {
                                            children: section.value
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$ValueDiv, {
                                    section: section.key,
                                    children: section.url ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($27b211fec267c408$var$CopyableDiv, {
                                        children: [
                                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("a", {
                                                href: section.url,
                                                target: "_blank",
                                                style: {
                                                    textDecoration: "none"
                                                },
                                                rel: "noreferrer",
                                                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$DataText, {
                                                    url: section.url,
                                                    children: section.value
                                                })
                                            }),
                                            " ",
                                            section.isCopy && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$export$4f2558dd25106ae2, {
                                                value: section.value
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($27b211fec267c408$var$CopyableDiv, {
                                        children: [
                                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($27b211fec267c408$var$DataText, {
                                                children: [
                                                    section.value,
                                                    " "
                                                ]
                                            }),
                                            section.isCopy && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$export$4f2558dd25106ae2, {
                                                value: section.value
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }, section.key))
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("hr", {
                className: "border"
            })
        ]
    });
};
const $27b211fec267c408$export$4f2558dd25106ae2 = ({ value: value })=>{
    const [_, copyToClipboard] = (0, $7fd1d6b11ea151c5$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("button", {
        onClick: ()=>copyToClipboard(value),
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($27b211fec267c408$var$Icon, {
            as: (0, $a46ca55c52605115$export$2e2bcd8739ae039)
        })
    });
};
var $27b211fec267c408$export$2e2bcd8739ae039 = $27b211fec267c408$var$TxCard;



const $a37a4ef6c45b808d$export$fc7b06d6a4abcacf = (timestamp)=>{
    timestamp = Number(timestamp);
    const date = new Date(timestamp * 1000);
    const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ];
    const year = date.getFullYear();
    const month = months[date.getMonth()];
    const day = date.getDate();
    const hour = date.getHours();
    const minute = "0" + date.getMinutes();
    const second = "0" + date.getSeconds();
    const formattedDate = `${month} ${day}, ${year} ${hour}:${minute.slice(-2)}:${second.slice(-2)} ${hour >= 12 ? "pm" : "am"}`;
    return formattedDate;
};


const $f9e60c951ebd170d$var$messageStatusRoles = {
    Inboxed: "Sender",
    Relayed: "Relayer"
};
const $f9e60c951ebd170d$var$Message = ({ messageInboxData: messageInboxData, messageOutboxData: messageOutboxData, bridgeId: bridgeId })=>{
    const [messageStatus, setMessageStatus] = (0, $dup7A.useState)("");
    const bridgeInfo = (0, $039e8edd5249fb5b$export$f55bcf30472c04eb)(bridgeId);
    (0, $dup7A.useEffect)(()=>{
        calculateMessageStatus(messageOutboxData);
    }, [
        messageOutboxData
    ]);
    const calculateMessageStatus = (messageOutboxData)=>{
        if (!messageOutboxData) setMessageStatus("Inboxed");
        else setMessageStatus("Relayed");
    };
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $bd697c2e56815211$export$2e2bcd8739ae039), {
                status: messageStatus,
                messageNumber: parseInt(messageInboxData?.id)
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $27b211fec267c408$export$2e2bcd8739ae039), {
                title: $f9e60c951ebd170d$var$messageStatusRoles[messageStatus],
                chain: bridgeInfo?.from,
                txHash: messageInboxData?.txHash,
                timestamp: (0, $a37a4ef6c45b808d$export$fc7b06d6a4abcacf)(messageInboxData?.timestamp),
                caller: messageInboxData?.from
            })
        ]
    }, messageInboxData?.id);
};
var $f9e60c951ebd170d$export$2e2bcd8739ae039 = $f9e60c951ebd170d$var$Message;



var $dup7A = parcelRequire("dup7A");
var $0d4e850212c78411$exports = {};
'use strict';

$0d4e850212c78411$exports = (parcelRequire("03MXH"));



var $dup7A = parcelRequire("dup7A");
var $091f3e3ff9fee239$exports = {};

$parcel$export($091f3e3ff9fee239$exports, "FOCUS_EVENT", () => $091f3e3ff9fee239$export$831c820ad60f9d12);
$parcel$export($091f3e3ff9fee239$exports, "RECONNECT_EVENT", () => $091f3e3ff9fee239$export$24e9454cb99a11dc);
$parcel$export($091f3e3ff9fee239$exports, "MUTATE_EVENT", () => $091f3e3ff9fee239$export$75ea288459391154);
$parcel$export($091f3e3ff9fee239$exports, "ERROR_REVALIDATE_EVENT", () => $091f3e3ff9fee239$export$b019c3839228f243);
const $091f3e3ff9fee239$export$831c820ad60f9d12 = 0;
const $091f3e3ff9fee239$export$24e9454cb99a11dc = 1;
const $091f3e3ff9fee239$export$75ea288459391154 = 2;
const $091f3e3ff9fee239$export$b019c3839228f243 = 3;


var $f376f8bac1809411$var$has = Object.prototype.hasOwnProperty;
function $f376f8bac1809411$export$de8294bb3be0322f(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $f376f8bac1809411$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($f376f8bac1809411$var$has.call(foo, ctor) && ++len && !$f376f8bac1809411$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$f376f8bac1809411$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


'use client';
// Global state used to deduplicate requests and store listeners
const $bb76ebcb41332aaa$export$8b22cf2602fb60ce = new WeakMap();
// Shared state between server components and client components
const $bb76ebcb41332aaa$export$ebd11618f299a286 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08 = /*#__NOINLINE__*/ $bb76ebcb41332aaa$export$ebd11618f299a286();
const $bb76ebcb41332aaa$export$c4ce752e73470fba = Object;
const $bb76ebcb41332aaa$export$f1e1789686576879 = (v)=>v === $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08;
const $bb76ebcb41332aaa$export$407448d2b89b1813 = (v)=>typeof v == 'function';
const $bb76ebcb41332aaa$export$953cecd6e717a553 = (a, b)=>({
        ...a,
        ...b
    });
const $bb76ebcb41332aaa$export$ef35774e6d314e91 = (x)=>$bb76ebcb41332aaa$export$407448d2b89b1813(x.then);
const $bb76ebcb41332aaa$var$EMPTY_CACHE = {};
const $bb76ebcb41332aaa$var$INITIAL_CACHE = {};
const $bb76ebcb41332aaa$var$STR_UNDEFINED = 'undefined';
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $bb76ebcb41332aaa$export$23f2a1d2818174ef = typeof window != $bb76ebcb41332aaa$var$STR_UNDEFINED;
const $bb76ebcb41332aaa$export$efccba1c4a2ef57b = typeof document != $bb76ebcb41332aaa$var$STR_UNDEFINED;
const $bb76ebcb41332aaa$export$d141bba7fdc215a3 = $bb76ebcb41332aaa$export$23f2a1d2818174ef && 'Deno' in window;
const $bb76ebcb41332aaa$export$4a5767248b18ef41 = ()=>$bb76ebcb41332aaa$export$23f2a1d2818174ef && typeof window['requestAnimationFrame'] != $bb76ebcb41332aaa$var$STR_UNDEFINED;
const $bb76ebcb41332aaa$export$df995fae86a55f06 = (cache, key)=>{
    const state = $bb76ebcb41332aaa$export$8b22cf2602fb60ce.get(cache);
    return [
        // Getter
        ()=>!$bb76ebcb41332aaa$export$f1e1789686576879(key) && cache.get(key) || $bb76ebcb41332aaa$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$bb76ebcb41332aaa$export$f1e1789686576879(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $bb76ebcb41332aaa$var$INITIAL_CACHE)) $bb76ebcb41332aaa$var$INITIAL_CACHE[key] = prev;
                state[5](key, $bb76ebcb41332aaa$export$953cecd6e717a553(prev, info), prev || $bb76ebcb41332aaa$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$bb76ebcb41332aaa$export$f1e1789686576879(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $bb76ebcb41332aaa$var$INITIAL_CACHE) return $bb76ebcb41332aaa$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$bb76ebcb41332aaa$export$f1e1789686576879(key) && cache.get(key) || $bb76ebcb41332aaa$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $bb76ebcb41332aaa$var$online = true;
const $bb76ebcb41332aaa$var$isOnline = ()=>$bb76ebcb41332aaa$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$bb76ebcb41332aaa$var$onWindowEvent, $bb76ebcb41332aaa$var$offWindowEvent] = $bb76ebcb41332aaa$export$23f2a1d2818174ef && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $bb76ebcb41332aaa$export$ebd11618f299a286,
    $bb76ebcb41332aaa$export$ebd11618f299a286
];
const $bb76ebcb41332aaa$var$isVisible = ()=>{
    const visibilityState = $bb76ebcb41332aaa$export$efccba1c4a2ef57b && document.visibilityState;
    return $bb76ebcb41332aaa$export$f1e1789686576879(visibilityState) || visibilityState !== 'hidden';
};
const $bb76ebcb41332aaa$var$initFocus = (callback)=>{
    // focus revalidate
    if ($bb76ebcb41332aaa$export$efccba1c4a2ef57b) document.addEventListener('visibilitychange', callback);
    $bb76ebcb41332aaa$var$onWindowEvent('focus', callback);
    return ()=>{
        if ($bb76ebcb41332aaa$export$efccba1c4a2ef57b) document.removeEventListener('visibilitychange', callback);
        $bb76ebcb41332aaa$var$offWindowEvent('focus', callback);
    };
};
const $bb76ebcb41332aaa$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $bb76ebcb41332aaa$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $bb76ebcb41332aaa$var$online = false;
    };
    $bb76ebcb41332aaa$var$onWindowEvent('online', onOnline);
    $bb76ebcb41332aaa$var$onWindowEvent('offline', onOffline);
    return ()=>{
        $bb76ebcb41332aaa$var$offWindowEvent('online', onOnline);
        $bb76ebcb41332aaa$var$offWindowEvent('offline', onOffline);
    };
};
const $bb76ebcb41332aaa$export$ffb5f4729a158638 = {
    isOnline: $bb76ebcb41332aaa$var$isOnline,
    isVisible: $bb76ebcb41332aaa$var$isVisible
};
const $bb76ebcb41332aaa$export$9e5f44173e64f162 = {
    initFocus: $bb76ebcb41332aaa$var$initFocus,
    initReconnect: $bb76ebcb41332aaa$var$initReconnect
};
const $bb76ebcb41332aaa$export$9bb611d729802a56 = !(0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).useId;
const $bb76ebcb41332aaa$export$43caf9889c228507 = !$bb76ebcb41332aaa$export$23f2a1d2818174ef || $bb76ebcb41332aaa$export$d141bba7fdc215a3;
// Polyfill requestAnimationFrame
const $bb76ebcb41332aaa$export$625550452a3fa3ec = (f)=>$bb76ebcb41332aaa$export$4a5767248b18ef41() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $bb76ebcb41332aaa$export$3b14a55fb2447963 = $bb76ebcb41332aaa$export$43caf9889c228507 ? (0, $dup7A.useEffect) : (0, $dup7A.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $bb76ebcb41332aaa$var$navigatorConnection = typeof navigator !== 'undefined' && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $bb76ebcb41332aaa$export$90a7f3efeed30595 = !$bb76ebcb41332aaa$export$43caf9889c228507 && $bb76ebcb41332aaa$var$navigatorConnection && ([
    'slow-2g',
    '2g'
].includes($bb76ebcb41332aaa$var$navigatorConnection.effectiveType) || $bb76ebcb41332aaa$var$navigatorConnection.saveData);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $bb76ebcb41332aaa$var$table = new WeakMap();
const $bb76ebcb41332aaa$var$isObjectType = (value, type)=>$bb76ebcb41332aaa$export$c4ce752e73470fba.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $bb76ebcb41332aaa$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $bb76ebcb41332aaa$export$882b5998b3b9117c = (arg)=>{
    const type = typeof arg;
    const isDate = $bb76ebcb41332aaa$var$isObjectType(arg, 'Date');
    const isRegex = $bb76ebcb41332aaa$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $bb76ebcb41332aaa$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($bb76ebcb41332aaa$export$c4ce752e73470fba(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $bb76ebcb41332aaa$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$bb76ebcb41332aaa$var$counter + '~';
        $bb76ebcb41332aaa$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $bb76ebcb41332aaa$export$882b5998b3b9117c(arg[index]) + ',';
            $bb76ebcb41332aaa$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $bb76ebcb41332aaa$export$c4ce752e73470fba.keys(arg).sort();
            while(!$bb76ebcb41332aaa$export$f1e1789686576879(index = keys.pop()))if (!$bb76ebcb41332aaa$export$f1e1789686576879(arg[index])) result += index + ':' + $bb76ebcb41332aaa$export$882b5998b3b9117c(arg[index]) + ',';
            $bb76ebcb41332aaa$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $bb76ebcb41332aaa$export$2408f22a0fab9ae5 = (key)=>{
    if ($bb76ebcb41332aaa$export$407448d2b89b1813(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $bb76ebcb41332aaa$export$882b5998b3b9117c(key) : '';
    return [
        key,
        args
    ];
};
// Global timestamp.
let $bb76ebcb41332aaa$var$__timestamp = 0;
const $bb76ebcb41332aaa$export$ae1af26003f05816 = ()=>++$bb76ebcb41332aaa$var$__timestamp;
async function $bb76ebcb41332aaa$export$7ccc53e8f1e7dfc5(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $bb76ebcb41332aaa$export$953cecd6e717a553({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === 'boolean' ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === 'function' ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($bb76ebcb41332aaa$export$407448d2b89b1813(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $bb76ebcb41332aaa$export$2408f22a0fab9ae5(_k);
        if (!key) return;
        const [get, set] = $bb76ebcb41332aaa$export$df995fae86a55f06(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $bb76ebcb41332aaa$export$8b22cf2602fb60ce.get(cache);
        const startRevalidate = ()=>{
            const revalidators = EVENT_REVALIDATORS[key];
            const revalidate = $bb76ebcb41332aaa$export$407448d2b89b1813(options.revalidate) ? options.revalidate(get().data, _k) : options.revalidate !== false;
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($091f3e3ff9fee239$export$75ea288459391154).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $bb76ebcb41332aaa$export$ae1af26003f05816();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$bb76ebcb41332aaa$export$f1e1789686576879(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $bb76ebcb41332aaa$export$f1e1789686576879(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $bb76ebcb41332aaa$export$407448d2b89b1813(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($bb76ebcb41332aaa$export$407448d2b89b1813(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $bb76ebcb41332aaa$export$ef35774e6d314e91(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: committedData,
                    _c: $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($bb76ebcb41332aaa$export$407448d2b89b1813(populateCache)) {
                    const populateCachedData = populateCache(data, committedData);
                    set({
                        data: populateCachedData,
                        error: $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08,
                        _c: $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08
                    });
                } else // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08,
                    _c: $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $bb76ebcb41332aaa$export$ae1af26003f05816();
        // Update existing SWR Hooks' internal states:
        Promise.resolve(startRevalidate()).then(()=>{
            // The mutation and revalidation are ended, we can clear it since the data is
            // not an optimistic value anymore.
            set({
                _c: $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08
            });
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return data;
    }
}
const $bb76ebcb41332aaa$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $bb76ebcb41332aaa$export$dda1d9f60106f0e9 = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$bb76ebcb41332aaa$export$8b22cf2602fb60ce.has(provider)) {
        const opts = $bb76ebcb41332aaa$export$953cecd6e717a553($bb76ebcb41332aaa$export$9e5f44173e64f162, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = Object.create(null);
        const mutate = $bb76ebcb41332aaa$export$7ccc53e8f1e7dfc5.bind($bb76ebcb41332aaa$export$3a6d5c9ae78a2c08, provider);
        let unmount = $bb76ebcb41332aaa$export$ebd11618f299a286;
        const subscriptions = Object.create(null);
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$bb76ebcb41332aaa$export$8b22cf2602fb60ce.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $bb76ebcb41332aaa$export$8b22cf2602fb60ce.set(provider, [
                    EVENT_REVALIDATORS,
                    Object.create(null),
                    Object.create(null),
                    Object.create(null),
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$bb76ebcb41332aaa$export$43caf9889c228507) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($bb76ebcb41332aaa$export$3a6d5c9ae78a2c08, $bb76ebcb41332aaa$var$revalidateAllKeys.bind($bb76ebcb41332aaa$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $091f3e3ff9fee239$export$831c820ad60f9d12)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($bb76ebcb41332aaa$export$3a6d5c9ae78a2c08, $bb76ebcb41332aaa$var$revalidateAllKeys.bind($bb76ebcb41332aaa$export$3a6d5c9ae78a2c08, EVENT_REVALIDATORS, $091f3e3ff9fee239$export$24e9454cb99a11dc)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $bb76ebcb41332aaa$export$8b22cf2602fb60ce.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $bb76ebcb41332aaa$export$8b22cf2602fb60ce.get(provider)[4]
    ];
};
// error retry
const $bb76ebcb41332aaa$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$bb76ebcb41332aaa$export$f1e1789686576879(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $bb76ebcb41332aaa$export$342063e11d6c3cad = (0, $f376f8bac1809411$export$de8294bb3be0322f);
// Default cache provider
const [$bb76ebcb41332aaa$export$db3b6bfb95261072, $bb76ebcb41332aaa$export$35e795649ee09318] = $bb76ebcb41332aaa$export$dda1d9f60106f0e9(new Map());
// Default config
const $bb76ebcb41332aaa$export$4368d992c4eafac0 = $bb76ebcb41332aaa$export$953cecd6e717a553({
    // events
    onLoadingSlow: $bb76ebcb41332aaa$export$ebd11618f299a286,
    onSuccess: $bb76ebcb41332aaa$export$ebd11618f299a286,
    onError: $bb76ebcb41332aaa$export$ebd11618f299a286,
    onErrorRetry: $bb76ebcb41332aaa$var$onErrorRetry,
    onDiscarded: $bb76ebcb41332aaa$export$ebd11618f299a286,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $bb76ebcb41332aaa$export$90a7f3efeed30595 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $bb76ebcb41332aaa$export$90a7f3efeed30595 ? 5000 : 3000,
    compare: // providers
    $bb76ebcb41332aaa$export$342063e11d6c3cad,
    isPaused: ()=>false,
    cache: $bb76ebcb41332aaa$export$db3b6bfb95261072,
    mutate: $bb76ebcb41332aaa$export$35e795649ee09318,
    fallback: {}
}, $bb76ebcb41332aaa$export$ffb5f4729a158638);
const $bb76ebcb41332aaa$export$2d1720544b23b823 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $bb76ebcb41332aaa$export$953cecd6e717a553(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $bb76ebcb41332aaa$export$953cecd6e717a553(f1, f2);
    }
    return v;
};
const $bb76ebcb41332aaa$export$25ce5a424b770e84 = (0, $dup7A.createContext)({});
const $bb76ebcb41332aaa$export$39b482c5e57630a8 = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $dup7A.useContext)($bb76ebcb41332aaa$export$25ce5a424b770e84);
    const isFunctionalConfig = $bb76ebcb41332aaa$export$407448d2b89b1813(value);
    const config = (0, $dup7A.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $dup7A.useMemo)(()=>isFunctionalConfig ? config : $bb76ebcb41332aaa$export$2d1720544b23b823(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $dup7A.useRef)($bb76ebcb41332aaa$export$3a6d5c9ae78a2c08);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $bb76ebcb41332aaa$export$dda1d9f60106f0e9(provider(extendedConfig.cache || $bb76ebcb41332aaa$export$db3b6bfb95261072), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $bb76ebcb41332aaa$export$3b14a55fb2447963(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $dup7A.createElement)($bb76ebcb41332aaa$export$25ce5a424b770e84.Provider, $bb76ebcb41332aaa$export$953cecd6e717a553(props, {
        value: extendedConfig
    }));
};



const $fecd49fdf8025c57$export$8667f065faedc62c = '$inf$';



var $dup7A = parcelRequire("dup7A");

// @ts-expect-error
const $00d1ac2946866634$var$enableDevtools = (0, $bb76ebcb41332aaa$export$23f2a1d2818174ef) && window.__SWR_DEVTOOLS_USE__;
const $00d1ac2946866634$var$use = $00d1ac2946866634$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $00d1ac2946866634$var$setupDevTools = ()=>{
    if ($00d1ac2946866634$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A)));
};
const $00d1ac2946866634$export$a3295358bff77e = (args)=>{
    return (0, $bb76ebcb41332aaa$export$407448d2b89b1813)(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $00d1ac2946866634$export$f1dc0e282d4c1c0 = ()=>{
    return (0, $bb76ebcb41332aaa$export$953cecd6e717a553)((0, $bb76ebcb41332aaa$export$4368d992c4eafac0), (0, $dup7A.useContext)((0, $bb76ebcb41332aaa$export$25ce5a424b770e84)));
};
const $00d1ac2946866634$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = (0, $bb76ebcb41332aaa$export$2408f22a0fab9ae5)(key_);
    const [, , , PRELOAD] = (0, $bb76ebcb41332aaa$export$8b22cf2602fb60ce).get((0, $bb76ebcb41332aaa$export$db3b6bfb95261072));
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $00d1ac2946866634$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = (0, $bb76ebcb41332aaa$export$2408f22a0fab9ae5)(key_);
            const [, , , PRELOAD] = (0, $bb76ebcb41332aaa$export$8b22cf2602fb60ce).get((0, $bb76ebcb41332aaa$export$db3b6bfb95261072));
            if (key.startsWith((0, $fecd49fdf8025c57$export$8667f065faedc62c))) // we want the infinite fetcher to be called.
            // handling of the PRELOAD cache happens there.
            return fetcher_(...args);
            const req = PRELOAD[key];
            if ((0, $bb76ebcb41332aaa$export$f1e1789686576879)(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $00d1ac2946866634$var$BUILT_IN_MIDDLEWARE = $00d1ac2946866634$var$use.concat($00d1ac2946866634$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $00d1ac2946866634$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $00d1ac2946866634$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $00d1ac2946866634$export$a3295358bff77e(args);
        // Merge configurations.
        const config = (0, $bb76ebcb41332aaa$export$2d1720544b23b823)(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($00d1ac2946866634$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $00d1ac2946866634$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $00d1ac2946866634$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $00d1ac2946866634$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$00d1ac2946866634$var$setupDevTools();


// Shared state between server components and client components
const $bf4543ca6fdad7aa$var$noop = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $bf4543ca6fdad7aa$var$UNDEFINED = /*#__NOINLINE__*/ $bf4543ca6fdad7aa$var$noop();
const $bf4543ca6fdad7aa$var$OBJECT = Object;
const $bf4543ca6fdad7aa$var$isUndefined = (v)=>v === $bf4543ca6fdad7aa$var$UNDEFINED;
const $bf4543ca6fdad7aa$var$isFunction = (v)=>typeof v == 'function';
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $bf4543ca6fdad7aa$var$table = new WeakMap();
const $bf4543ca6fdad7aa$var$isObjectType = (value, type)=>$bf4543ca6fdad7aa$var$OBJECT.prototype.toString.call(value) === `[object ${type}]`;
// counter of the key
let $bf4543ca6fdad7aa$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $bf4543ca6fdad7aa$var$stableHash = (arg)=>{
    const type = typeof arg;
    const isDate = $bf4543ca6fdad7aa$var$isObjectType(arg, 'Date');
    const isRegex = $bf4543ca6fdad7aa$var$isObjectType(arg, 'RegExp');
    const isPlainObject = $bf4543ca6fdad7aa$var$isObjectType(arg, 'Object');
    let result;
    let index;
    if ($bf4543ca6fdad7aa$var$OBJECT(arg) === arg && !isDate && !isRegex) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $bf4543ca6fdad7aa$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$bf4543ca6fdad7aa$var$counter + '~';
        $bf4543ca6fdad7aa$var$table.set(arg, result);
        if (Array.isArray(arg)) {
            // Array.
            result = '@';
            for(index = 0; index < arg.length; index++)result += $bf4543ca6fdad7aa$var$stableHash(arg[index]) + ',';
            $bf4543ca6fdad7aa$var$table.set(arg, result);
        }
        if (isPlainObject) {
            // Object, sort keys.
            result = '#';
            const keys = $bf4543ca6fdad7aa$var$OBJECT.keys(arg).sort();
            while(!$bf4543ca6fdad7aa$var$isUndefined(index = keys.pop()))if (!$bf4543ca6fdad7aa$var$isUndefined(arg[index])) result += index + ':' + $bf4543ca6fdad7aa$var$stableHash(arg[index]) + ',';
            $bf4543ca6fdad7aa$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == 'symbol' ? arg.toString() : type == 'string' ? JSON.stringify(arg) : '' + arg;
    return result;
};
const $bf4543ca6fdad7aa$var$serialize = (key)=>{
    if ($bf4543ca6fdad7aa$var$isFunction(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = '';
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == 'string' ? key : (Array.isArray(key) ? key.length : key) ? $bf4543ca6fdad7aa$var$stableHash(key) : '';
    return [
        key,
        args
    ];
};
const $bf4543ca6fdad7aa$export$dbab534a48e651ef = (key)=>$bf4543ca6fdad7aa$var$serialize(key)[0];
/// <reference types="react/experimental" />
const $bf4543ca6fdad7aa$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).use || // This extra generic is to avoid TypeScript mixing up the generic and JSX sytax
// and emitting an error.
// We assume that this is only for the `use(thenable)` case, not `use(context)`.
// https://github.com/facebook/react/blob/aed00dacfb79d17c53218404c52b1c7aa59c4a89/packages/react-server/src/ReactFizzThenable.js#L45
((thenable)=>{
    switch(thenable.status){
        case 'pending':
            throw thenable;
        case 'fulfilled':
            return thenable.value;
        case 'rejected':
            throw thenable.reason;
        default:
            thenable.status = 'pending';
            thenable.then((v)=>{
                thenable.status = 'fulfilled';
                thenable.value = v;
            }, (e)=>{
                thenable.status = 'rejected';
                thenable.reason = e;
            });
            throw thenable;
    }
});
const $bf4543ca6fdad7aa$var$WITH_DEDUPE = {
    dedupe: true
};
const $bf4543ca6fdad7aa$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $bb76ebcb41332aaa$export$8b22cf2602fb60ce).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $bb76ebcb41332aaa$export$2408f22a0fab9ae5)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $dup7A.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $dup7A.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $dup7A.useRef)(key);
    const fetcherRef = (0, $dup7A.useRef)(fetcher);
    const configRef = (0, $dup7A.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $bb76ebcb41332aaa$export$df995fae86a55f06)(cache, key);
    const stateDependencies = (0, $dup7A.useRef)({}).current;
    // Resolve the fallback data from either the inline option, or the global provider.
    // If it's a promise, we simply let React suspend and resolve it for us.
    const fallback = (0, $bb76ebcb41332aaa$export$f1e1789686576879)(fallbackData) ? (0, $bb76ebcb41332aaa$export$f1e1789686576879)(config.fallback) ? (0, $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08) : config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === 'data') {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $bb76ebcb41332aaa$export$f1e1789686576879)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $dup7A.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $bb76ebcb41332aaa$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            return revalidateIfStale !== false;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $bb76ebcb41332aaa$export$953cecd6e717a553)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $0d4e850212c78411$exports.useSyncExternalStore)((0, $dup7A.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $bb76ebcb41332aaa$export$f1e1789686576879)(cachedData) ? fallback && (0, $bb76ebcb41332aaa$export$ef35774e6d314e91)(fallback) ? $bf4543ca6fdad7aa$var$use(fallback) : fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $dup7A.useRef)(data);
    const returnedData = keepPreviousData ? (0, $bb76ebcb41332aaa$export$f1e1789686576879)(cachedData) ? (0, $bb76ebcb41332aaa$export$f1e1789686576879)(laggyDataRef.current) ? data : laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $bb76ebcb41332aaa$export$f1e1789686576879)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $bb76ebcb41332aaa$export$f1e1789686576879)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $bb76ebcb41332aaa$export$f1e1789686576879)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $bb76ebcb41332aaa$export$f1e1789686576879)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $bb76ebcb41332aaa$export$f1e1789686576879)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $bb76ebcb41332aaa$export$f1e1789686576879)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $dup7A.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $bb76ebcb41332aaa$export$9bb611d729802a56) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $bb76ebcb41332aaa$export$f1e1789686576879)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $bb76ebcb41332aaa$export$f1e1789686576879)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $bb76ebcb41332aaa$export$ae1af26003f05816)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $bb76ebcb41332aaa$export$f1e1789686576879)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $bb76ebcb41332aaa$export$407448d2b89b1813)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (!getConfig().revalidateOnFocus || !getConfig().revalidateOnReconnect || isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $091f3e3ff9fee239$exports).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    const boundMutate = (0, $dup7A.useCallback)((...args)=>{
        return (0, $bb76ebcb41332aaa$export$7ccc53e8f1e7dfc5)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $bb76ebcb41332aaa$export$3b14a55fb2447963)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $bb76ebcb41332aaa$export$f1e1789686576879)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $bb76ebcb41332aaa$export$3b14a55fb2447963)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $bb76ebcb41332aaa$export$3a6d5c9ae78a2c08), $bf4543ca6fdad7aa$var$WITH_DEDUPE);
        let nextFocusRevalidatedAt = 0;
        if (getConfig().revalidateOnFocus) {
            const initNow = Date.now();
            nextFocusRevalidatedAt = initNow + getConfig().focusThrottleInterval;
        }
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $091f3e3ff9fee239$exports).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $091f3e3ff9fee239$exports).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $091f3e3ff9fee239$exports).MUTATE_EVENT) return revalidate();
            else if (type == (0, $091f3e3ff9fee239$exports).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $00d1ac2946866634$export$e005210ed621746)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $bb76ebcb41332aaa$export$f1e1789686576879)(data) || (0, $bb76ebcb41332aaa$export$43caf9889c228507)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $bb76ebcb41332aaa$export$625550452a3fa3ec)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $bb76ebcb41332aaa$export$3b14a55fb2447963)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $bb76ebcb41332aaa$export$407448d2b89b1813)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($bf4543ca6fdad7aa$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $dup7A.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $bb76ebcb41332aaa$export$f1e1789686576879)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any fallback data. This causes hydration errors. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $bb76ebcb41332aaa$export$9bb611d729802a56) && (0, $bb76ebcb41332aaa$export$43caf9889c228507)) throw new Error('Fallback data is required when using Suspense in SSR.');
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $bb76ebcb41332aaa$export$f1e1789686576879)(req)) {
            const promise = boundMutate(req);
            $bf4543ca6fdad7aa$var$use(promise);
        }
        if ((0, $bb76ebcb41332aaa$export$f1e1789686576879)(error)) {
            const promise = revalidate($bf4543ca6fdad7aa$var$WITH_DEDUPE);
            if (!(0, $bb76ebcb41332aaa$export$f1e1789686576879)(returnedData)) {
                promise.status = 'fulfilled';
                promise.value = true;
            }
            $bf4543ca6fdad7aa$var$use(promise);
        } else throw error;
    }
    const swrResponse = {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
    return swrResponse;
};
const $bf4543ca6fdad7aa$export$4c7bbecdacc3ca2c = (0, $bb76ebcb41332aaa$export$c4ce752e73470fba).defineProperty((0, $bb76ebcb41332aaa$export$39b482c5e57630a8), 'defaultValue', {
    value: (0, $bb76ebcb41332aaa$export$4368d992c4eafac0)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error, isLoading } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (isLoading) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $bf4543ca6fdad7aa$export$2e2bcd8739ae039 = (0, $00d1ac2946866634$export$84d44e54e14b0133)($bf4543ca6fdad7aa$var$useSWRHandler);




const $67ef9927b9930cd3$export$b2a21208083dec7 = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getMessages($skip: Int!, $snapshot: String!, $snapshotID: ID!) {
    messages(
      first: 5
      skip: $skip
      orderBy: timestamp
      orderDirection: desc
      where: { snapshot: $snapshot }
    ) {
      id
      txHash
      timestamp
      from
      to
      data
    }
    snapshot(id: $snapshotID) {
      numberMessages
    }
  }
`);



const $fcdc4acfd9797c1a$export$48d78797c81f126d = (0, $9aed2896e1d7bbe9$export$1eb4e7c0ed67b035)(`
  query getRelay($id: ID!) {
    message(id: $id) {
      timestamp
      txHash
      relayer
      proof
    }
  }
`);


var $3ecb954f3d350801$exports = {};
"use strict";
var $3ecb954f3d350801$var$__createBinding = $3ecb954f3d350801$exports && $3ecb954f3d350801$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3ecb954f3d350801$var$__setModuleDefault = $3ecb954f3d350801$exports && $3ecb954f3d350801$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3ecb954f3d350801$var$__importStar = $3ecb954f3d350801$exports && $3ecb954f3d350801$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3ecb954f3d350801$var$__createBinding(result, mod, k);
    }
    $3ecb954f3d350801$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($3ecb954f3d350801$exports, "__esModule", {
    value: true
});
$3ecb954f3d350801$exports.request = $3ecb954f3d350801$exports.rawRequest = $3ecb954f3d350801$exports.GraphQLClient = $3ecb954f3d350801$exports.ClientError = $3ecb954f3d350801$exports.batchRequests = $3ecb954f3d350801$exports.resolveRequestDocument = $3ecb954f3d350801$exports.GraphQLWebSocketClient = $3ecb954f3d350801$exports.gql = void 0;
var $d98a2c3d80b8f921$exports = {};
"use strict";
Object.defineProperty($d98a2c3d80b8f921$exports, "__esModule", {
    value: true
});
$d98a2c3d80b8f921$exports.defaultJsonSerializer = void 0;
$d98a2c3d80b8f921$exports.defaultJsonSerializer = JSON;


var $bf4c7cf031dc9294$exports = {};
"use strict";
Object.defineProperty($bf4c7cf031dc9294$exports, "__esModule", {
    value: true
});
$bf4c7cf031dc9294$exports.HeadersInstanceToPlainObject = $bf4c7cf031dc9294$exports.uppercase = void 0;
const $bf4c7cf031dc9294$var$uppercase = (str)=>str.toUpperCase();
$bf4c7cf031dc9294$exports.uppercase = $bf4c7cf031dc9294$var$uppercase;
/**
 * Convert Headers instance into regular object
 */ const $bf4c7cf031dc9294$var$HeadersInstanceToPlainObject = (headers)=>{
    const o = {};
    headers.forEach((v, k)=>{
        o[k] = v;
    });
    return o;
};
$bf4c7cf031dc9294$exports.HeadersInstanceToPlainObject = $bf4c7cf031dc9294$var$HeadersInstanceToPlainObject;


var $7cb39c267daa5a82$exports = {};
"use strict";
Object.defineProperty($7cb39c267daa5a82$exports, "__esModule", {
    value: true
});
$7cb39c267daa5a82$exports.parseRawRequestExtendedArgs = $7cb39c267daa5a82$exports.parseRequestExtendedArgs = $7cb39c267daa5a82$exports.parseBatchRequestArgs = $7cb39c267daa5a82$exports.parseRawRequestArgs = $7cb39c267daa5a82$exports.parseRequestArgs = void 0;
const $7cb39c267daa5a82$var$parseRequestArgs = (documentOrOptions, variables, requestHeaders)=>{
    return documentOrOptions.document ? documentOrOptions : {
        document: documentOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRequestArgs = $7cb39c267daa5a82$var$parseRequestArgs;
const $7cb39c267daa5a82$var$parseRawRequestArgs = (queryOrOptions, variables, requestHeaders)=>{
    return queryOrOptions.query ? queryOrOptions : {
        query: queryOrOptions,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRawRequestArgs = $7cb39c267daa5a82$var$parseRawRequestArgs;
const $7cb39c267daa5a82$var$parseBatchRequestArgs = (documentsOrOptions, requestHeaders)=>{
    return documentsOrOptions.documents ? documentsOrOptions : {
        documents: documentsOrOptions,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseBatchRequestArgs = $7cb39c267daa5a82$var$parseBatchRequestArgs;
const $7cb39c267daa5a82$var$parseRequestExtendedArgs = (urlOrOptions, document, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.document ? urlOrOptions : {
        url: urlOrOptions,
        document: document,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRequestExtendedArgs = $7cb39c267daa5a82$var$parseRequestExtendedArgs;
const $7cb39c267daa5a82$var$parseRawRequestExtendedArgs = (urlOrOptions, query, ...variablesAndRequestHeaders)=>{
    const [variables, requestHeaders] = variablesAndRequestHeaders;
    return urlOrOptions.query ? urlOrOptions : {
        url: urlOrOptions,
        query: query,
        variables: variables,
        requestHeaders: requestHeaders,
        signal: undefined
    };
};
$7cb39c267daa5a82$exports.parseRawRequestExtendedArgs = $7cb39c267daa5a82$var$parseRawRequestExtendedArgs;


var $70379170ad08a388$exports = {};
"use strict";
Object.defineProperty($70379170ad08a388$exports, "__esModule", {
    value: true
});
$70379170ad08a388$exports.resolveRequestDocument = void 0;
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $aa138920f9209e70$export$c10d0b04eaa80a43(value) {
    return typeof value == 'object' && value !== null;
}


function $114305077f875ea3$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}


const $518283d6324f0738$var$LineRegExp = /\r\n|[\n\r]/g;
function $518283d6324f0738$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($518283d6324f0738$var$LineRegExp)){
        typeof match.index === 'number' || (0, $114305077f875ea3$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $442b76678fd98ce6$export$96a9681e539deed(location) {
    return $442b76678fd98ce6$export$867940333fd9f869(location.source, (0, $518283d6324f0738$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $442b76678fd98ce6$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = ''.padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $442b76678fd98ce6$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    '|',
                    subLine
                ]),
            [
                '|',
                '^'.padStart(subLineColumnNum)
            ],
            [
                '|',
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $442b76678fd98ce6$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            '|',
            '^'.padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $442b76678fd98ce6$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? ' ' + line : '')).join('\n');
}


function $b9bb4b6875d2cb38$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $b9bb4b6875d2cb38$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $b9bb4b6875d2cb38$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = 'GraphQLError';
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $b9bb4b6875d2cb38$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $b9bb4b6875d2cb38$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $518283d6324f0738$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $518283d6324f0738$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $aa138920f9209e70$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, 'stack', {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $b9bb4b6875d2cb38$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return 'GraphQLError';
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += '\n\n' + (0, $442b76678fd98ce6$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += '\n\n' + (0, $442b76678fd98ce6$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $b9bb4b6875d2cb38$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $b9bb4b6875d2cb38$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $b9bb4b6875d2cb38$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $df0689dd60b7ce92$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $b9bb4b6875d2cb38$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $1aac86d3fd4247cf$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $1aac86d3fd4247cf$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $1aac86d3fd4247cf$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $1aac86d3fd4247cf$var$kindValues = new Set(Object.keys($1aac86d3fd4247cf$export$4fcd777a40ccf407));
function $1aac86d3fd4247cf$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $1aac86d3fd4247cf$var$kindValues.has(maybeKind);
}
/** Name */ var $1aac86d3fd4247cf$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($1aac86d3fd4247cf$export$f58c50edb4aef9d4 || ($1aac86d3fd4247cf$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $fe45191b121d6c96$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation['QUERY'] = 'QUERY';
    DirectiveLocation['MUTATION'] = 'MUTATION';
    DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
    DirectiveLocation['FIELD'] = 'FIELD';
    DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
    DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
    DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
    DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
    DirectiveLocation['SCHEMA'] = 'SCHEMA';
    DirectiveLocation['SCALAR'] = 'SCALAR';
    DirectiveLocation['OBJECT'] = 'OBJECT';
    DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
    DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
    DirectiveLocation['INTERFACE'] = 'INTERFACE';
    DirectiveLocation['UNION'] = 'UNION';
    DirectiveLocation['ENUM'] = 'ENUM';
    DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
    DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
    DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})($fe45191b121d6c96$export$b45ffd2948484c41 || ($fe45191b121d6c96$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $004e90072ac44791$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($004e90072ac44791$export$a84bdc57c5122798 || ($004e90072ac44791$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $b594b69ebba3d31f$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $b594b69ebba3d31f$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $b594b69ebba3d31f$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $b594b69ebba3d31f$export$45a677ea7cb6d5c8(code) {
    return $b594b69ebba3d31f$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $b594b69ebba3d31f$export$d3f406ff46035894(code) {
    return $b594b69ebba3d31f$export$79c5d5217943d6a7(code) || $b594b69ebba3d31f$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $1ce970437e2eeb43$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $1ce970437e2eeb43$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $1ce970437e2eeb43$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $b594b69ebba3d31f$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $1ce970437e2eeb43$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $1ce970437e2eeb43$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $b594b69ebba3d31f$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $b594b69ebba3d31f$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $34dd16813e0454d6$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind['SOF'] = '<SOF>';
    TokenKind['EOF'] = '<EOF>';
    TokenKind['BANG'] = '!';
    TokenKind['DOLLAR'] = '$';
    TokenKind['AMP'] = '&';
    TokenKind['PAREN_L'] = '(';
    TokenKind['PAREN_R'] = ')';
    TokenKind['SPREAD'] = '...';
    TokenKind['COLON'] = ':';
    TokenKind['EQUALS'] = '=';
    TokenKind['AT'] = '@';
    TokenKind['BRACKET_L'] = '[';
    TokenKind['BRACKET_R'] = ']';
    TokenKind['BRACE_L'] = '{';
    TokenKind['PIPE'] = '|';
    TokenKind['BRACE_R'] = '}';
    TokenKind['NAME'] = 'Name';
    TokenKind['INT'] = 'Int';
    TokenKind['FLOAT'] = 'Float';
    TokenKind['STRING'] = 'String';
    TokenKind['BLOCK_STRING'] = 'BlockString';
    TokenKind['COMMENT'] = 'Comment';
})($34dd16813e0454d6$export$8b9d26ab11394711 || ($34dd16813e0454d6$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $0c187fd033e6b576$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $1aac86d3fd4247cf$export$50792b0e93539fde)((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return 'Lexer';
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $0c187fd033e6b576$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $0c187fd033e6b576$export$59ac0f4da287406a(kind) {
    return kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BANG || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).AMP || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).AT || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE || kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $0c187fd033e6b576$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $0c187fd033e6b576$var$isSupplementaryCodePoint(body, location) {
    return $0c187fd033e6b576$var$isLeadingSurrogate(body.charCodeAt(location)) && $0c187fd033e6b576$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $0c187fd033e6b576$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $0c187fd033e6b576$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $0c187fd033e6b576$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */ function $0c187fd033e6b576$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $1aac86d3fd4247cf$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $0c187fd033e6b576$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $0c187fd033e6b576$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $0c187fd033e6b576$var$readBlockString(lexer, position);
                return $0c187fd033e6b576$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $0c187fd033e6b576$var$readNumber(lexer, position, code);
         // Name
        if ((0, $b594b69ebba3d31f$export$45a677ea7cb6d5c8)(code)) return $0c187fd033e6b576$var$readName(lexer, position);
        throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?' : $0c187fd033e6b576$var$isUnicodeScalarValue(code) || $0c187fd033e6b576$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    }
    return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $0c187fd033e6b576$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) ++position;
        else if ($0c187fd033e6b576$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $0c187fd033e6b576$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(code)) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $0c187fd033e6b576$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $0c187fd033e6b576$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $0c187fd033e6b576$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $b594b69ebba3d31f$export$45a677ea7cb6d5c8)(code)) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    return $0c187fd033e6b576$var$createToken(lexer, isFloat ? (0, $34dd16813e0454d6$export$8b9d26ab11394711).FLOAT : (0, $34dd16813e0454d6$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $0c187fd033e6b576$var$readDigits(lexer, start, firstCode) {
    if (!(0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(firstCode)) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$0c187fd033e6b576$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $b594b69ebba3d31f$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $0c187fd033e6b576$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = '';
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $0c187fd033e6b576$var$readEscapedUnicodeVariableWidth(lexer, position) : $0c187fd033e6b576$var$readEscapedUnicodeFixedWidth(lexer, position) : $0c187fd033e6b576$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) ++position;
        else if ($0c187fd033e6b576$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.
function $0c187fd033e6b576$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$0c187fd033e6b576$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $0c187fd033e6b576$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $0c187fd033e6b576$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $0c187fd033e6b576$var$read16BitHexCode(body, position + 2);
    if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($0c187fd033e6b576$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $0c187fd033e6b576$var$read16BitHexCode(body, position + 8);
            if ($0c187fd033e6b576$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $0c187fd033e6b576$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position)) << 12 | $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $0c187fd033e6b576$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $0c187fd033e6b576$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $0c187fd033e6b576$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '\u0022',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: '\u005c',
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: '\u002f',
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: '\u0008',
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: '\u000c',
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: '\u000a',
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: '\u000d',
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: '\u0009',
                size: 2
            };
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $0c187fd033e6b576$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = '';
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $1ce970437e2eeb43$export$d5ee19b441e8d2ae)(blockLines).join('\n'));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = '';
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($0c187fd033e6b576$var$isUnicodeScalarValue(code)) ++position;
        else if ($0c187fd033e6b576$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$0c187fd033e6b576$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $0c187fd033e6b576$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $b594b69ebba3d31f$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $0c187fd033e6b576$var$createToken(lexer, (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}


function $f87670c0082d22dd$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $0a7d676629377c88$var$MAX_ARRAY_LENGTH = 10;
const $0a7d676629377c88$var$MAX_RECURSIVE_DEPTH = 2;
function $0a7d676629377c88$export$9dec5d1b3b6a130d(value) {
    return $0a7d676629377c88$var$formatValue(value, []);
}
function $0a7d676629377c88$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $0a7d676629377c88$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $0a7d676629377c88$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($0a7d676629377c88$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $0a7d676629377c88$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $0a7d676629377c88$var$formatArray(value, seenValues);
    return $0a7d676629377c88$var$formatObject(value, seenValues);
}
function $0a7d676629377c88$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $0a7d676629377c88$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $0a7d676629377c88$var$MAX_RECURSIVE_DEPTH) return '[' + $0a7d676629377c88$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $0a7d676629377c88$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $0a7d676629377c88$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $0a7d676629377c88$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($0a7d676629377c88$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($0a7d676629377c88$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $0a7d676629377c88$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}



/* c8 ignore next 3 */ const $8853ab9b8a132e03$var$isProduction = globalThis.process && // eslint-disable-next-line no-undef
true;
const $8853ab9b8a132e03$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
$8853ab9b8a132e03$var$isProduction ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === 'object' && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $0a7d676629377c88$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $50492008785479b9$export$1d2df86270c81ecb {
    constructor(body, name = 'GraphQL request', locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === 'string' || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $0a7d676629377c88$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, 'column in locationOffset is 1-indexed and must be positive.');
    }
    get [Symbol.toStringTag]() {
        return 'Source';
    }
}
function $50492008785479b9$export$75135ee9ed6e435b(source) {
    return (0, $8853ab9b8a132e03$export$ca03416d6c9e029e)(source, $50492008785479b9$export$1d2df86270c81ecb);
}



function $57a14ff8f0fcf417$export$98e6a39c04603d36(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    const document = parser.parseDocument();
    Object.defineProperty(document, 'tokenCount', {
        enumerable: false,
        value: parser.tokenCount
    });
    return document;
}
function $57a14ff8f0fcf417$export$5303528d1070ff6f(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF);
    return value;
}
function $57a14ff8f0fcf417$export$e14c466bd0916f7a(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF);
    return value;
}
function $57a14ff8f0fcf417$export$28b8f402ccc88182(source, options) {
    const parser = new $57a14ff8f0fcf417$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF);
    return type;
}
class $57a14ff8f0fcf417$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $50492008785479b9$export$75135ee9ed6e435b)(source) ? source : new (0, $50492008785479b9$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $0c187fd033e6b576$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    get tokenCount() {
        return this._tokenCounter;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $34dd16813e0454d6$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case 'schema':
                    return this.parseSchemaDefinition();
                case 'scalar':
                    return this.parseScalarTypeDefinition();
                case 'type':
                    return this.parseObjectTypeDefinition();
                case 'interface':
                    return this.parseInterfaceTypeDefinition();
                case 'union':
                    return this.parseUnionTypeDefinition();
                case 'enum':
                    return this.parseEnumTypeDefinition();
                case 'input':
                    return this.parseInputObjectTypeDefinition();
                case 'directive':
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, 'Unexpected description, descriptions are supported only on type definitions.');
            switch(keywordToken.value){
                case 'query':
                case 'mutation':
                case 'subscription':
                    return this.parseOperationDefinition();
                case 'fragment':
                    return this.parseFragmentDefinition();
                case 'extend':
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case 'query':
                return (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).QUERY;
            case 'mutation':
                return (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).MUTATION;
            case 'subscription':
                return (0, $1aac86d3fd4247cf$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, item, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).STRING:
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case 'true':
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case 'false':
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case 'null':
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).LIST,
            values: this.any((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L, item, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, item, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $004e90072ac44791$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).STRING) || this.peek((0, $34dd16813e0454d6$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword('implements') ? this.delimitedMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $34dd16813e0454d6$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === 'true' || this._lexer.token.value === 'false' || this._lexer.token.value === 'null') throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$57a14ff8f0fcf417$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $34dd16813e0454d6$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $34dd16813e0454d6$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $004e90072ac44791$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $34dd16813e0454d6$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $fe45191b121d6c96$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $1aac86d3fd4247cf$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$57a14ff8f0fcf417$var$getTokenKindDesc(kind)}, found ${$57a14ff8f0fcf417$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$57a14ff8f0fcf417$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $34dd16813e0454d6$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$57a14ff8f0fcf417$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (token.kind !== (0, $34dd16813e0454d6$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (maxTokens !== undefined && this._tokenCounter > maxTokens) throw (0, $df0689dd60b7ce92$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $57a14ff8f0fcf417$var$getTokenDesc(token) {
    const value = token.value;
    return $57a14ff8f0fcf417$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $57a14ff8f0fcf417$var$getTokenKindDesc(kind) {
    return (0, $0c187fd033e6b576$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $48fd700e2bddeea1$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($48fd700e2bddeea1$var$escapedRegExp, $48fd700e2bddeea1$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $48fd700e2bddeea1$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $48fd700e2bddeea1$var$escapedReplacer(str) {
    return $48fd700e2bddeea1$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $48fd700e2bddeea1$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];






const $7c617355af910c01$export$a89c95c098ac2a58 = Object.freeze({});
function $7c617355af910c01$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $1aac86d3fd4247cf$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $004e90072ac44791$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $7c617355af910c01$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = {
                        ...node
                    };
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $1aac86d3fd4247cf$export$8ee0fc9ee280b4ee)(node) || (0, $f87670c0082d22dd$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $0a7d676629377c88$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $7c617355af910c01$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $1aac86d3fd4247cf$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $7c617355af910c01$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $004e90072ac44791$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $7c617355af910c01$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $7c617355af910c01$export$a89c95c098ac2a58) skipping[i] = $7c617355af910c01$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $7c617355af910c01$export$a89c95c098ac2a58) skipping[i] = $7c617355af910c01$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $7c617355af910c01$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $7c617355af910c01$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $7c617355af910c01$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $6ecfe3fd0f5ba15e$export$c2d084dc44961371(ast) {
    return (0, $7c617355af910c01$export$bf638b60ea8b89b7)(ast, $6ecfe3fd0f5ba15e$var$printDocASTReducer);
}
const $6ecfe3fd0f5ba15e$var$MAX_LINE_LENGTH = 80;
const $6ecfe3fd0f5ba15e$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$6ecfe3fd0f5ba15e$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $6ecfe3fd0f5ba15e$var$wrap('(', $6ecfe3fd0f5ba15e$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $6ecfe3fd0f5ba15e$var$join([
                node.operation,
                $6ecfe3fd0f5ba15e$var$join([
                    node.name,
                    varDefs
                ]),
                $6ecfe3fd0f5ba15e$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $6ecfe3fd0f5ba15e$var$wrap(' = ', defaultValue) + $6ecfe3fd0f5ba15e$var$wrap(' ', $6ecfe3fd0f5ba15e$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$6ecfe3fd0f5ba15e$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $6ecfe3fd0f5ba15e$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $6ecfe3fd0f5ba15e$var$wrap('(', $6ecfe3fd0f5ba15e$var$join(args, ', '), ')');
            if (argsLine.length > $6ecfe3fd0f5ba15e$var$MAX_LINE_LENGTH) argsLine = prefix + $6ecfe3fd0f5ba15e$var$wrap('(\n', $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(args, '\n')), '\n)');
            return $6ecfe3fd0f5ba15e$var$join([
                argsLine,
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $6ecfe3fd0f5ba15e$var$wrap(' ', $6ecfe3fd0f5ba15e$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$6ecfe3fd0f5ba15e$var$join([
                '...',
                $6ecfe3fd0f5ba15e$var$wrap('on ', typeCondition),
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$6ecfe3fd0f5ba15e$var$wrap('(', $6ecfe3fd0f5ba15e$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$6ecfe3fd0f5ba15e$var$wrap('', $6ecfe3fd0f5ba15e$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $1ce970437e2eeb43$export$adb6ca997eeb1f45)(value) : (0, $48fd700e2bddeea1$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $6ecfe3fd0f5ba15e$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $6ecfe3fd0f5ba15e$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $6ecfe3fd0f5ba15e$var$wrap('(', $6ecfe3fd0f5ba15e$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                'schema',
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                'scalar',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                'type',
                name,
                $6ecfe3fd0f5ba15e$var$wrap('implements ', $6ecfe3fd0f5ba15e$var$join(interfaces, ' & ')),
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + name + ($6ecfe3fd0f5ba15e$var$hasMultilineItems(args) ? $6ecfe3fd0f5ba15e$var$wrap('(\n', $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(args, '\n')), '\n)') : $6ecfe3fd0f5ba15e$var$wrap('(', $6ecfe3fd0f5ba15e$var$join(args, ', '), ')')) + ': ' + type + $6ecfe3fd0f5ba15e$var$wrap(' ', $6ecfe3fd0f5ba15e$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                name + ': ' + type,
                $6ecfe3fd0f5ba15e$var$wrap('= ', defaultValue),
                $6ecfe3fd0f5ba15e$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                'interface',
                name,
                $6ecfe3fd0f5ba15e$var$wrap('implements ', $6ecfe3fd0f5ba15e$var$join(interfaces, ' & ')),
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                'union',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$wrap('= ', $6ecfe3fd0f5ba15e$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                'enum',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + $6ecfe3fd0f5ba15e$var$join([
                'input',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$6ecfe3fd0f5ba15e$var$wrap('', description, '\n') + 'directive @' + name + ($6ecfe3fd0f5ba15e$var$hasMultilineItems(args) ? $6ecfe3fd0f5ba15e$var$wrap('(\n', $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(args, '\n')), '\n)') : $6ecfe3fd0f5ba15e$var$wrap('(', $6ecfe3fd0f5ba15e$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $6ecfe3fd0f5ba15e$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$6ecfe3fd0f5ba15e$var$join([
                'extend schema',
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$6ecfe3fd0f5ba15e$var$join([
                'extend scalar',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$join([
                'extend type',
                name,
                $6ecfe3fd0f5ba15e$var$wrap('implements ', $6ecfe3fd0f5ba15e$var$join(interfaces, ' & ')),
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$join([
                'extend interface',
                name,
                $6ecfe3fd0f5ba15e$var$wrap('implements ', $6ecfe3fd0f5ba15e$var$join(interfaces, ' & ')),
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$6ecfe3fd0f5ba15e$var$join([
                'extend union',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$wrap('= ', $6ecfe3fd0f5ba15e$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$6ecfe3fd0f5ba15e$var$join([
                'extend enum',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$6ecfe3fd0f5ba15e$var$join([
                'extend input',
                name,
                $6ecfe3fd0f5ba15e$var$join(directives, ' '),
                $6ecfe3fd0f5ba15e$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $6ecfe3fd0f5ba15e$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $6ecfe3fd0f5ba15e$var$block(array) {
    return $6ecfe3fd0f5ba15e$var$wrap('{\n', $6ecfe3fd0f5ba15e$var$indent($6ecfe3fd0f5ba15e$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $6ecfe3fd0f5ba15e$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $6ecfe3fd0f5ba15e$var$indent(str) {
    return $6ecfe3fd0f5ba15e$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $6ecfe3fd0f5ba15e$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}


/**
 * helpers
 */ const $70379170ad08a388$var$extractOperationName = (document)=>{
    let operationName = undefined;
    const operationDefinitions = document.definitions.filter((definition)=>definition.kind === `OperationDefinition`);
    if (operationDefinitions.length === 1) operationName = operationDefinitions[0]?.name?.value;
    return operationName;
};
const $70379170ad08a388$var$resolveRequestDocument = (document)=>{
    if (typeof document === `string`) {
        let operationName = undefined;
        try {
            const parsedDocument = (0, $57a14ff8f0fcf417$export$98e6a39c04603d36)(document);
            operationName = $70379170ad08a388$var$extractOperationName(parsedDocument);
        } catch (err) {
        // Failed parsing the document, the operationName will be undefined
        }
        return {
            query: document,
            operationName: operationName
        };
    }
    const operationName = $70379170ad08a388$var$extractOperationName(document);
    return {
        query: (0, $6ecfe3fd0f5ba15e$export$c2d084dc44961371)(document),
        operationName: operationName
    };
};
$70379170ad08a388$exports.resolveRequestDocument = $70379170ad08a388$var$resolveRequestDocument;


var $2f9eee8a6b649b81$exports = {};
"use strict";
Object.defineProperty($2f9eee8a6b649b81$exports, "__esModule", {
    value: true
});
$2f9eee8a6b649b81$exports.ClientError = void 0;
class $2f9eee8a6b649b81$var$ClientError extends Error {
    constructor(response, request){
        const message = `${$2f9eee8a6b649b81$var$ClientError.extractMessage(response)}: ${JSON.stringify({
            response: response,
            request: request
        })}`;
        super(message);
        Object.setPrototypeOf(this, $2f9eee8a6b649b81$var$ClientError.prototype);
        this.response = response;
        this.request = request;
        // this is needed as Safari doesn't support .captureStackTrace
        if (typeof Error.captureStackTrace === `function`) Error.captureStackTrace(this, $2f9eee8a6b649b81$var$ClientError);
    }
    static extractMessage(response) {
        return response.errors?.[0]?.message ?? `GraphQL Error (Code: ${response.status})`;
    }
}
$2f9eee8a6b649b81$exports.ClientError = $2f9eee8a6b649b81$var$ClientError;


Object.defineProperty($3ecb954f3d350801$exports, "ClientError", {
    enumerable: true,
    get: function() {
        return $2f9eee8a6b649b81$exports.ClientError;
    }
});

const $3ecb954f3d350801$var$cross_fetch_1 = $3ecb954f3d350801$var$__importStar((parcelRequire("aUQjb"))), $3ecb954f3d350801$var$CrossFetch = $3ecb954f3d350801$var$cross_fetch_1;
/**
 * Convert the given headers configuration into a plain object.
 */ const $3ecb954f3d350801$var$resolveHeaders = (headers)=>{
    let oHeaders = {};
    if (headers) {
        if (typeof Headers !== `undefined` && headers instanceof Headers || $3ecb954f3d350801$var$CrossFetch && $3ecb954f3d350801$var$CrossFetch.Headers && headers instanceof $3ecb954f3d350801$var$CrossFetch.Headers) oHeaders = (0, $bf4c7cf031dc9294$exports.HeadersInstanceToPlainObject)(headers);
        else if (Array.isArray(headers)) headers.forEach(([name, value])=>{
            if (name && value !== undefined) oHeaders[name] = value;
        });
        else oHeaders = headers;
    }
    return oHeaders;
};
/**
 * Clean a GraphQL document to send it via a GET query
 */ const $3ecb954f3d350801$var$cleanQuery = (str)=>str.replace(/([\s,]|#[^\n\r]+)+/g, ` `).trim();
/**
 * Create query string for GraphQL request
 */ const $3ecb954f3d350801$var$buildRequestConfig = (params)=>{
    if (!Array.isArray(params.query)) {
        const params_ = params;
        const search = [
            `query=${encodeURIComponent($3ecb954f3d350801$var$cleanQuery(params_.query))}`
        ];
        if (params.variables) search.push(`variables=${encodeURIComponent(params_.jsonSerializer.stringify(params_.variables))}`);
        if (params_.operationName) search.push(`operationName=${encodeURIComponent(params_.operationName)}`);
        return search.join(`&`);
    }
    if (typeof params.variables !== `undefined` && !Array.isArray(params.variables)) throw new Error(`Cannot create query with given variable type, array expected`);
    // Batch support
    const params_ = params;
    const payload = params.query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: $3ecb954f3d350801$var$cleanQuery(currentQuery),
            variables: params_.variables ? params_.jsonSerializer.stringify(params_.variables[index]) : undefined
        });
        return acc;
    }, []);
    return `query=${encodeURIComponent(params_.jsonSerializer.stringify(payload))}`;
};
const $3ecb954f3d350801$var$createHttpMethodFetcher = (method)=>async (params)=>{
        const { url: url, query: query, variables: variables, operationName: operationName, fetch: fetch, fetchOptions: fetchOptions, middleware: middleware } = params;
        const headers = {
            ...params.headers
        };
        let queryParams = ``;
        let body = undefined;
        if (method === `POST`) {
            body = $3ecb954f3d350801$var$createRequestBody(query, variables, operationName, fetchOptions.jsonSerializer);
            if (typeof body === `string`) // @ts-expect-error todo
            headers[`Content-Type`] = `application/json`;
        } else // @ts-expect-error todo needs ADT for TS to understand the different states
        queryParams = $3ecb954f3d350801$var$buildRequestConfig({
            query: query,
            variables: variables,
            operationName: operationName,
            jsonSerializer: fetchOptions.jsonSerializer ?? $d98a2c3d80b8f921$exports.defaultJsonSerializer
        });
        const init = {
            method: method,
            headers: headers,
            body: body,
            ...fetchOptions
        };
        let urlResolved = url;
        let initResolved = init;
        if (middleware) {
            const result = await Promise.resolve(middleware({
                ...init,
                url: url,
                operationName: operationName,
                variables: variables
            }));
            const { url: urlNew, ...initNew } = result;
            urlResolved = urlNew;
            initResolved = initNew;
        }
        if (queryParams) urlResolved = `${urlResolved}?${queryParams}`;
        return await fetch(urlResolved, initResolved);
    };
/**
 * GraphQL Client.
 */ class $3ecb954f3d350801$var$GraphQLClient {
    constructor(url, requestConfig = {}){
        this.url = url;
        this.requestConfig = requestConfig;
        /**
         * Send a GraphQL query to the server.
         */ this.rawRequest = async (...args)=>{
            const [queryOrOptions, variables, requestHeaders] = args;
            const rawRequestOptions = (0, $7cb39c267daa5a82$exports.parseRawRequestArgs)(queryOrOptions, variables, requestHeaders);
            const { headers: headers, fetch: fetch = $3ecb954f3d350801$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
            const { url: url } = this;
            if (rawRequestOptions.signal !== undefined) fetchOptions.signal = rawRequestOptions.signal;
            const { operationName: operationName } = (0, $70379170ad08a388$exports.resolveRequestDocument)(rawRequestOptions.query);
            return $3ecb954f3d350801$var$makeRequest({
                url: url,
                query: rawRequestOptions.query,
                variables: rawRequestOptions.variables,
                headers: {
                    ...$3ecb954f3d350801$var$resolveHeaders($3ecb954f3d350801$var$callOrIdentity(headers)),
                    ...$3ecb954f3d350801$var$resolveHeaders(rawRequestOptions.requestHeaders)
                },
                operationName: operationName,
                fetch: fetch,
                method: method,
                fetchOptions: fetchOptions,
                middleware: requestMiddleware
            }).then((response)=>{
                if (responseMiddleware) responseMiddleware(response);
                return response;
            }).catch((error)=>{
                if (responseMiddleware) responseMiddleware(error);
                throw error;
            });
        };
    }
    async request(documentOrOptions, ...variablesAndRequestHeaders) {
        const [variables, requestHeaders] = variablesAndRequestHeaders;
        const requestOptions = (0, $7cb39c267daa5a82$exports.parseRequestArgs)(documentOrOptions, variables, requestHeaders);
        const { headers: headers, fetch: fetch = $3ecb954f3d350801$var$cross_fetch_1.default, method: method = `POST`, requestMiddleware: requestMiddleware, responseMiddleware: responseMiddleware, ...fetchOptions } = this.requestConfig;
        const { url: url } = this;
        if (requestOptions.signal !== undefined) fetchOptions.signal = requestOptions.signal;
        const { query: query, operationName: operationName } = (0, $70379170ad08a388$exports.resolveRequestDocument)(requestOptions.document);
        return $3ecb954f3d350801$var$makeRequest({
            url: url,
            query: query,
            variables: requestOptions.variables,
            headers: {
                ...$3ecb954f3d350801$var$resolveHeaders($3ecb954f3d350801$var$callOrIdentity(headers)),
                ...$3ecb954f3d350801$var$resolveHeaders(requestOptions.requestHeaders)
            },
            operationName: operationName,
            fetch: fetch,
            method: method,
            fetchOptions: fetchOptions,
            middleware: requestMiddleware
        }).then((response)=>{
            if (responseMiddleware) responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (responseMiddleware) responseMiddleware(error);
            throw error;
        });
    }
    // prettier-ignore
    batchRequests(documentsOrOptions, requestHeaders) {
        const batchRequestOptions = (0, $7cb39c267daa5a82$exports.parseBatchRequestArgs)(documentsOrOptions, requestHeaders);
        const { headers: headers, ...fetchOptions } = this.requestConfig;
        if (batchRequestOptions.signal !== undefined) fetchOptions.signal = batchRequestOptions.signal;
        const queries = batchRequestOptions.documents.map(({ document: document })=>(0, $70379170ad08a388$exports.resolveRequestDocument)(document).query);
        const variables = batchRequestOptions.documents.map(({ variables: variables })=>variables);
        return $3ecb954f3d350801$var$makeRequest({
            url: this.url,
            query: queries,
            variables: // @ts-expect-error TODO reconcile batch variables into system.
            variables,
            headers: {
                ...$3ecb954f3d350801$var$resolveHeaders($3ecb954f3d350801$var$callOrIdentity(headers)),
                ...$3ecb954f3d350801$var$resolveHeaders(batchRequestOptions.requestHeaders)
            },
            operationName: undefined,
            fetch: this.requestConfig.fetch ?? $3ecb954f3d350801$var$cross_fetch_1.default,
            method: this.requestConfig.method || `POST`,
            fetchOptions: fetchOptions,
            middleware: this.requestConfig.requestMiddleware
        }).then((response)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(response);
            return response.data;
        }).catch((error)=>{
            if (this.requestConfig.responseMiddleware) this.requestConfig.responseMiddleware(error);
            throw error;
        });
    }
    setHeaders(headers) {
        this.requestConfig.headers = headers;
        return this;
    }
    /**
     * Attach a header to the client. All subsequent requests will have this header.
     */ setHeader(key, value) {
        const { headers: headers } = this.requestConfig;
        if (headers) // todo what if headers is in nested array form... ?
        //@ts-expect-error todo
        headers[key] = value;
        else this.requestConfig.headers = {
            [key]: value
        };
        return this;
    }
    /**
     * Change the client endpoint. All subsequent requests will send to this endpoint.
     */ setEndpoint(value) {
        this.url = value;
        return this;
    }
}
$3ecb954f3d350801$exports.GraphQLClient = $3ecb954f3d350801$var$GraphQLClient;
const $3ecb954f3d350801$var$makeRequest = async (params)=>{
    const { query: query, variables: variables, fetchOptions: fetchOptions } = params;
    const fetcher = $3ecb954f3d350801$var$createHttpMethodFetcher((0, $bf4c7cf031dc9294$exports.uppercase)(params.method ?? `post`));
    const isBatchingQuery = Array.isArray(params.query);
    const response = await fetcher(params);
    const result = await $3ecb954f3d350801$var$getResult(response, fetchOptions.jsonSerializer ?? $d98a2c3d80b8f921$exports.defaultJsonSerializer);
    const successfullyReceivedData = Array.isArray(result) ? !result.some(({ data: data })=>!data) : Boolean(result.data);
    const successfullyPassedErrorPolicy = Array.isArray(result) || !result.errors || Array.isArray(result.errors) && !result.errors.length || fetchOptions.errorPolicy === `all` || fetchOptions.errorPolicy === `ignore`;
    if (response.ok && successfullyPassedErrorPolicy && successfullyReceivedData) {
        // @ts-expect-error TODO fixme
        const { errors: _, ...rest } = Array.isArray(result) ? result : result;
        const data = fetchOptions.errorPolicy === `ignore` ? rest : result;
        const dataEnvelope = isBatchingQuery ? {
            data: data
        } : data;
        // @ts-expect-error TODO
        return {
            ...dataEnvelope,
            headers: response.headers,
            status: response.status
        };
    } else {
        const errorResult = typeof result === `string` ? {
            error: result
        } : result;
        throw new $2f9eee8a6b649b81$exports.ClientError(// @ts-expect-error TODO
        {
            ...errorResult,
            status: response.status,
            headers: response.headers
        }, {
            query: query,
            variables: variables
        });
    }
};
/**
 * Send a GraphQL Query to the GraphQL server for execution.
 */ const $3ecb954f3d350801$var$rawRequest = async (...args)=>{
    const [urlOrOptions, query, ...variablesAndRequestHeaders] = args;
    const requestOptions = (0, $7cb39c267daa5a82$exports.parseRawRequestExtendedArgs)(urlOrOptions, query, ...variablesAndRequestHeaders);
    const client = new $3ecb954f3d350801$var$GraphQLClient(requestOptions.url);
    return client.rawRequest({
        ...requestOptions
    });
};
$3ecb954f3d350801$exports.rawRequest = $3ecb954f3d350801$var$rawRequest;
// prettier-ignore
// eslint-disable-next-line
async function $3ecb954f3d350801$var$request(urlOrOptions, document, ...variablesAndRequestHeaders) {
    const requestOptions = (0, $7cb39c267daa5a82$exports.parseRequestExtendedArgs)(urlOrOptions, document, ...variablesAndRequestHeaders);
    const client = new $3ecb954f3d350801$var$GraphQLClient(requestOptions.url);
    return client.request({
        ...requestOptions
    });
}
$3ecb954f3d350801$exports.request = $3ecb954f3d350801$var$request;
/**
 * Send a batch of GraphQL Document to the GraphQL server for execution.
 *
 * @example
 *
 * ```ts
 * // You can pass a raw string
 *
 * await batchRequests('https://foo.bar/graphql', [
 * {
 *  query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * },
 * {
 *   query: `
 *   {
 *     query {
 *       users
 *     }
 *   }`
 * }])
 *
 * // You can also pass a GraphQL DocumentNode as query. Convenient if you
 * // are using graphql-tag package.
 *
 * import gql from 'graphql-tag'
 *
 * await batchRequests('https://foo.bar/graphql', [{ query: gql`...` }])
 * ```
 */ const $3ecb954f3d350801$var$batchRequests = async (...args)=>{
    const params = $3ecb954f3d350801$var$parseBatchRequestsArgsExtended(args);
    const client = new $3ecb954f3d350801$var$GraphQLClient(params.url);
    return client.batchRequests(params);
};
$3ecb954f3d350801$exports.batchRequests = $3ecb954f3d350801$var$batchRequests;
const $3ecb954f3d350801$var$parseBatchRequestsArgsExtended = (args)=>{
    if (args.length === 1) return args[0];
    else return {
        url: args[0],
        documents: args[1],
        requestHeaders: args[2],
        signal: undefined
    };
};
const $3ecb954f3d350801$var$createRequestBody = (query, variables, operationName, jsonSerializer)=>{
    const jsonSerializer_ = jsonSerializer ?? $d98a2c3d80b8f921$exports.defaultJsonSerializer;
    if (!Array.isArray(query)) return jsonSerializer_.stringify({
        query: query,
        variables: variables,
        operationName: operationName
    });
    if (typeof variables !== `undefined` && !Array.isArray(variables)) throw new Error(`Cannot create request body with given variable type, array expected`);
    // Batch support
    const payload = query.reduce((acc, currentQuery, index)=>{
        acc.push({
            query: currentQuery,
            variables: variables ? variables[index] : undefined
        });
        return acc;
    }, []);
    return jsonSerializer_.stringify(payload);
};
const $3ecb954f3d350801$var$getResult = async (response, jsonSerializer)=>{
    let contentType;
    response.headers.forEach((value, key)=>{
        if (key.toLowerCase() === `content-type`) contentType = value;
    });
    if (contentType && (contentType.toLowerCase().startsWith(`application/json`) || contentType.toLowerCase().startsWith(`application/graphql+json`) || contentType.toLowerCase().startsWith(`application/graphql-response+json`))) return jsonSerializer.parse(await response.text());
    else return response.text();
};
const $3ecb954f3d350801$var$callOrIdentity = (value)=>{
    return typeof value === `function` ? value() : value;
};
/**
 * Convenience passthrough template tag to get the benefits of tooling for the gql template tag. This does not actually parse the input into a GraphQL DocumentNode like graphql-tag package does. It just returns the string with any variables given interpolated. Can save you a bit of performance and having to install another package.
 *
 * @example
 * ```
 * import { gql } from 'graphql-request'
 *
 * await request('https://foo.bar/graphql', gql`...`)
 * ```
 *
 * @remarks
 *
 * Several tools in the Node GraphQL ecosystem are hardcoded to specially treat any template tag named "gql". For example see this prettier issue: https://github.com/prettier/prettier/issues/4360. Using this template tag has no runtime effect beyond variable interpolation.
 */ const $3ecb954f3d350801$var$gql = (chunks, ...variables)=>{
    return chunks.reduce((acc, chunk, index)=>`${acc}${chunk}${index in variables ? String(variables[index]) : ``}`, ``);
};
$3ecb954f3d350801$exports.gql = $3ecb954f3d350801$var$gql;
var $b68213ba3fc67dce$exports = {};
"use strict";
Object.defineProperty($b68213ba3fc67dce$exports, "__esModule", {
    value: true
});
$b68213ba3fc67dce$exports.GraphQLWebSocketClient = void 0;


// import type WebSocket from 'ws'
const $b68213ba3fc67dce$var$CONNECTION_INIT = `connection_init`;
const $b68213ba3fc67dce$var$CONNECTION_ACK = `connection_ack`;
const $b68213ba3fc67dce$var$PING = `ping`;
const $b68213ba3fc67dce$var$PONG = `pong`;
const $b68213ba3fc67dce$var$SUBSCRIBE = `subscribe`;
const $b68213ba3fc67dce$var$NEXT = `next`;
const $b68213ba3fc67dce$var$ERROR = `error`;
const $b68213ba3fc67dce$var$COMPLETE = `complete`;
class $b68213ba3fc67dce$var$GraphQLWebSocketMessage {
    get type() {
        return this._type;
    }
    get id() {
        return this._id;
    }
    get payload() {
        return this._payload;
    }
    constructor(type, payload, id){
        this._type = type;
        this._payload = payload;
        this._id = id;
    }
    get text() {
        const result = {
            type: this.type
        };
        if (this.id != null && this.id != undefined) result.id = this.id;
        if (this.payload != null && this.payload != undefined) result.payload = this.payload;
        return JSON.stringify(result);
    }
    static parse(data, f) {
        const { type: type, payload: payload, id: id } = JSON.parse(data);
        return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage(type, f(payload), id);
    }
}
class $b68213ba3fc67dce$var$GraphQLWebSocketClient {
    constructor(socket, { onInit: onInit, onAcknowledged: onAcknowledged, onPing: onPing, onPong: onPong }){
        this.socketState = {
            acknowledged: false,
            lastRequestId: 0,
            subscriptions: {}
        };
        this.socket = socket;
        socket.addEventListener(`open`, async (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
            socket.send($b68213ba3fc67dce$var$ConnectionInit(onInit ? await onInit() : null).text);
        });
        socket.addEventListener(`close`, (e)=>{
            this.socketState.acknowledged = false;
            this.socketState.subscriptions = {};
        });
        socket.addEventListener(`error`, (e)=>{
            console.error(e);
        });
        socket.addEventListener(`message`, (e)=>{
            try {
                const message = $b68213ba3fc67dce$var$parseMessage(e.data);
                switch(message.type){
                    case $b68213ba3fc67dce$var$CONNECTION_ACK:
                        if (this.socketState.acknowledged) console.warn(`Duplicate CONNECTION_ACK message ignored`);
                        else {
                            this.socketState.acknowledged = true;
                            if (onAcknowledged) onAcknowledged(message.payload);
                        }
                        return;
                    case $b68213ba3fc67dce$var$PING:
                        if (onPing) onPing(message.payload).then((r)=>socket.send($b68213ba3fc67dce$var$Pong(r).text));
                        else socket.send($b68213ba3fc67dce$var$Pong(null).text);
                        return;
                    case $b68213ba3fc67dce$var$PONG:
                        if (onPong) onPong(message.payload);
                        return;
                }
                if (!this.socketState.acknowledged) // Web-socket connection not acknowledged
                return;
                if (message.id === undefined || message.id === null || !this.socketState.subscriptions[message.id]) // No subscription identifer or subscription indentifier is not found
                return;
                const { query: query, variables: variables, subscriber: subscriber } = this.socketState.subscriptions[message.id];
                switch(message.type){
                    case $b68213ba3fc67dce$var$NEXT:
                        if (!message.payload.errors && message.payload.data) subscriber.next && subscriber.next(message.payload.data);
                        if (message.payload.errors) subscriber.error && subscriber.error(new $2f9eee8a6b649b81$exports.ClientError({
                            ...message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b68213ba3fc67dce$var$ERROR:
                        subscriber.error && subscriber.error(new $2f9eee8a6b649b81$exports.ClientError({
                            errors: message.payload,
                            status: 200
                        }, {
                            query: query,
                            variables: variables
                        }));
                        return;
                    case $b68213ba3fc67dce$var$COMPLETE:
                        subscriber.complete && subscriber.complete();
                        delete this.socketState.subscriptions[message.id];
                        return;
                }
            } catch (e) {
                // Unexpected errors while handling graphql-ws message
                console.error(e);
                socket.close(1006);
            }
            socket.close(4400, `Unknown graphql-ws message.`);
        });
    }
    makeSubscribe(query, operationName, subscriber, variables) {
        const subscriptionId = (this.socketState.lastRequestId++).toString();
        this.socketState.subscriptions[subscriptionId] = {
            query: query,
            variables: variables,
            subscriber: subscriber
        };
        this.socket.send($b68213ba3fc67dce$var$Subscribe(subscriptionId, {
            query: query,
            operationName: operationName,
            variables: variables
        }).text);
        return ()=>{
            this.socket.send($b68213ba3fc67dce$var$Complete(subscriptionId).text);
            delete this.socketState.subscriptions[subscriptionId];
        };
    }
    rawRequest(query, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.rawSubscribe(query, {
                next: (data, extensions)=>result = {
                        data: data,
                        extensions: extensions
                    },
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    request(document, variables) {
        return new Promise((resolve, reject)=>{
            let result;
            this.subscribe(document, {
                next: (data)=>result = data,
                error: reject,
                complete: ()=>resolve(result)
            }, variables);
        });
    }
    subscribe(document, subscriber, variables) {
        const { query: query, operationName: operationName } = (0, $70379170ad08a388$exports.resolveRequestDocument)(document);
        return this.makeSubscribe(query, operationName, subscriber, variables);
    }
    rawSubscribe(query, subscriber, variables) {
        return this.makeSubscribe(query, undefined, subscriber, variables);
    }
    ping(payload) {
        this.socket.send($b68213ba3fc67dce$var$Ping(payload).text);
    }
    close() {
        this.socket.close(1000);
    }
}
$b68213ba3fc67dce$var$GraphQLWebSocketClient.PROTOCOL = `graphql-transport-ws`;
$b68213ba3fc67dce$exports.GraphQLWebSocketClient = $b68213ba3fc67dce$var$GraphQLWebSocketClient;
// Helper functions
function $b68213ba3fc67dce$var$parseMessage(data, f = (a)=>a) {
    const m = $b68213ba3fc67dce$var$GraphQLWebSocketMessage.parse(data, f);
    return m;
}
function $b68213ba3fc67dce$var$ConnectionInit(payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$CONNECTION_INIT, payload);
}
function $b68213ba3fc67dce$var$Ping(payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$PING, payload, undefined);
}
function $b68213ba3fc67dce$var$Pong(payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$PONG, payload, undefined);
}
function $b68213ba3fc67dce$var$Subscribe(id, payload) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$SUBSCRIBE, payload, id);
}
function $b68213ba3fc67dce$var$Complete(id) {
    return new $b68213ba3fc67dce$var$GraphQLWebSocketMessage($b68213ba3fc67dce$var$COMPLETE, undefined, id);
}


Object.defineProperty($3ecb954f3d350801$exports, "GraphQLWebSocketClient", {
    enumerable: true,
    get: function() {
        return $b68213ba3fc67dce$exports.GraphQLWebSocketClient;
    }
});

Object.defineProperty($3ecb954f3d350801$exports, "resolveRequestDocument", {
    enumerable: true,
    get: function() {
        return $70379170ad08a388$exports.resolveRequestDocument;
    }
});
$3ecb954f3d350801$exports.default = $3ecb954f3d350801$var$request;


const $da38e843980dc0a7$export$4d17e2d9c5348842 = (snapshot, bridgeId, skip, getRelays)=>{
    return (0, $bf4543ca6fdad7aa$export$2e2bcd8739ae039)(`${snapshot}-${bridgeId}-${skip}-${getRelays}`, async ()=>{
        const { inboxEndpoint: inboxEndpoint, outboxEndpoint: outboxEndpoint } = (0, $039e8edd5249fb5b$export$4cc9423ec3f21f7c)[bridgeId];
        const [messages, totalMessages] = await (0, $3ecb954f3d350801$exports.request)(inboxEndpoint, (0, $67ef9927b9930cd3$export$b2a21208083dec7), {
            skip: skip,
            snapshot: snapshot,
            snapshotID: snapshot
        }).then((result)=>[
                result.messages,
                result.snapshot?.numberMessages
            ]);
        return {
            messages: await Promise.all(messages.map(async (message)=>{
                return [
                    message,
                    getRelays ? await (0, $3ecb954f3d350801$exports.request)(outboxEndpoint, (0, $fcdc4acfd9797c1a$export$48d78797c81f126d), {
                        id: message.id
                    }).then((result)=>result.message) : null
                ];
            })),
            totalMessages: totalMessages
        };
    });
};


const $2691653cb227257e$var$MESSAGES_PER_PAGE = 5;
const $2691653cb227257e$var$PaginationContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  margin: 24px 12px;
`;
const $2691653cb227257e$var$DisplayMessages = ({ snapshotId: snapshotId, bridgeId: bridgeId })=>{
    const [currentPage, setCurrentPage] = (0, $dup7A.useState)(1);
    const { data: data } = (0, $da38e843980dc0a7$export$4d17e2d9c5348842)(snapshotId, bridgeId, (currentPage - 1) * $2691653cb227257e$var$MESSAGES_PER_PAGE, false);
    const totalMessages = parseInt(data?.totalMessages);
    const pageCount = Math.ceil(totalMessages / $2691653cb227257e$var$MESSAGES_PER_PAGE);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)((0, $975c4832af85a2cd$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($2691653cb227257e$var$PaginationContainer, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("small", {
                        children: [
                            "Page ",
                            currentPage
                        ]
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $43afcb05ca3681f6$exports.CompactPagination), {
                        currentPage: currentPage,
                        callback: setCurrentPage,
                        numPages: pageCount ? pageCount : currentPage
                    })
                ]
            }),
            data?.messages.map(([messageInboxData, messageOutboxData])=>{
                return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $f9e60c951ebd170d$export$2e2bcd8739ae039), {
                    messageInboxData: messageInboxData,
                    messageOutboxData: messageOutboxData,
                    bridgeId: bridgeId
                }, messageInboxData?.id);
            })
        ]
    });
};
var $2691653cb227257e$export$2e2bcd8739ae039 = $2691653cb227257e$var$DisplayMessages;



parcelRequire("dup7A");

const $9ca43a9736d082d7$var$SnapshotDetails = ({ transactions: transactions })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $975c4832af85a2cd$exports.Fragment), {
        children: Object.values(transactions).map((txInfo)=>txInfo && /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $27b211fec267c408$export$2e2bcd8739ae039), {
                ...txInfo
            }, txInfo.title))
    });
};
var $9ca43a9736d082d7$export$2e2bcd8739ae039 = $9ca43a9736d082d7$var$SnapshotDetails;


const $63867ade5479fa01$var$StyledSnapshotDetailsButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  width: 141px;
  height: 31px;
  text-align: center;
  p {
    color: ${({ theme: theme })=>theme.color.blue} !important;
    font-size: 14px !important;
    line-height: 17.5px !important;
    font-weight: normal !important;
  }
  :hover {
    background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  }
  border-radius: 300px;
  border: ${({ theme: theme, snapshotDetailsVisible: snapshotDetailsVisible })=>snapshotDetailsVisible ? "1px solid " + theme.color.blue : "none"};
`;
const $63867ade5479fa01$var$StyledNewMessagesButton = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.Button))`
  background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  width: 130px;
  height: 31px;
  text-align: center;
  p {
    color: ${({ theme: theme })=>theme.color.blue} !important;
    font-size: 14px !important;
    line-height: 17.5px !important;
    font-weight: normal !important;
  }

  :hover {
    background-color: ${({ theme: theme })=>theme.color.midnightPurple};
  }

  margin-left: 8px;
  border-radius: 300px;
  border: ${({ theme: theme, snapshotDetailsVisible: snapshotDetailsVisible })=>!snapshotDetailsVisible ? "1px solid " + theme.color.blue : "none"};
`;
const $63867ade5479fa01$var$StyledButtonsContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: row;
  padding-bottom: 12px;
`;
const $63867ade5479fa01$var$AccordionBody = ({ bridgeId: bridgeId, snapshotId: snapshotId, transactions: transactions })=>{
    const [snapshotDetailsVisible, setSnapshotDetailsVisible] = (0, $dup7A.useState)(true);
    const handleClickSnapshotDetails = ()=>{
        setSnapshotDetailsVisible(true);
    };
    const handleClickNewMessages = ()=>{
        setSnapshotDetailsVisible(false);
    };
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)((0, $975c4832af85a2cd$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($63867ade5479fa01$var$StyledButtonsContainer, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($63867ade5479fa01$var$StyledSnapshotDetailsButton, {
                        text: "Snapshot Details",
                        snapshotDetailsVisible: snapshotDetailsVisible,
                        onClick: handleClickSnapshotDetails
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($63867ade5479fa01$var$StyledNewMessagesButton, {
                        text: "New Messages",
                        snapshotDetailsVisible: snapshotDetailsVisible,
                        onClick: handleClickNewMessages
                    })
                ]
            }),
            snapshotDetailsVisible ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $9ca43a9736d082d7$export$2e2bcd8739ae039), {
                transactions: transactions
            }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $2691653cb227257e$export$2e2bcd8739ae039), {
                snapshotId: snapshotId,
                bridgeId: bridgeId
            })
        ]
    });
};
var $63867ade5479fa01$export$2e2bcd8739ae039 = $63867ade5479fa01$var$AccordionBody;



parcelRequire("dup7A");


parcelRequire("dup7A");

const $04fdaee17971f80d$var$StyledChainAndAddress = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-direction: row;
`;
const $04fdaee17971f80d$var$StyledTruncatedAddress = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).a`
  display: flex;
  padding-top: 3.5px;
  color: ${({ theme: theme })=>theme.color.blue};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;
const $04fdaee17971f80d$var$ChainIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  position: relative;
  width: 24px;
  height: 28px;
  fill: none;
  margin-right: 8px;
  padding-bottom: 2px;
`;
const $04fdaee17971f80d$var$ChainAndAddress = ({ chainObject: chainObject, address: address })=>{
    const truncatedAddress = `${address.slice(0, 6)}...${address.slice(-4)}`;
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($04fdaee17971f80d$var$StyledChainAndAddress, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($04fdaee17971f80d$var$ChainIcon, {
                as: chainObject?.logo
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($04fdaee17971f80d$var$StyledTruncatedAddress, {
                onClick: (event)=>event.stopPropagation(),
                href: `${chainObject?.blockExplorers?.default.url}/address/${address}`,
                target: "_blank",
                rel: "noreferrer",
                children: truncatedAddress
            })
        ]
    });
};
var $04fdaee17971f80d$export$2e2bcd8739ae039 = $04fdaee17971f80d$var$ChainAndAddress;



parcelRequire("dup7A");


const $9745418b2907d1b5$export$300a21b9577a7e8c = {
    Invalid: "lightRed",
    Saved: "lightYellow",
    Claimed: "turquoise",
    Challenged: "lightPurple",
    Verified: "darkBlue",
    Expired: "smoke",
    Resolving: "teal",
    Resolved: "green"
};
const $9745418b2907d1b5$var$ColorWrapper = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  div {
    background-color: ${({ theme: theme, variant: variant })=>theme.color[$9745418b2907d1b5$export$300a21b9577a7e8c[variant]]};
    pointer-events: none;
    p {
      color: ${({ theme: theme })=>theme.color.secondaryPurple};
      font-size: 14px;
      line-height: 17.5px;
    }
    width: 100px;
  }
`;
const $9745418b2907d1b5$var$ColoredLabel = ({ text: text, variant: variant, ...props })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($9745418b2907d1b5$var$ColorWrapper, {
        variant: variant,
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $43afcb05ca3681f6$exports.Tag), {
            as: "div",
            text: text
        })
    });
};
var $9745418b2907d1b5$export$2e2bcd8739ae039 = $9745418b2907d1b5$var$ColoredLabel;



parcelRequire("dup7A");

const $f512a188bc65d36c$var$StyledEpoch = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.color.lightBlue};
  width: 35%;
`;
const $f512a188bc65d36c$var$Epoch = ({ epoch: epoch })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($f512a188bc65d36c$var$StyledEpoch, {
        children: [
            epoch,
            " "
        ]
    });
};
var $f512a188bc65d36c$export$2e2bcd8739ae039 = $f512a188bc65d36c$var$Epoch;



parcelRequire("dup7A");

const $7efbe2b9a287a996$var$StyledTimestamp = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  color: ${({ theme: theme })=>theme.color.lightBlue};
  white-space: nowrap;
`;
const $7efbe2b9a287a996$var$Timestamp = ({ timestamp: timestamp })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($7efbe2b9a287a996$var$StyledTimestamp, {
        children: [
            timestamp,
            " "
        ]
    });
};
var $7efbe2b9a287a996$export$2e2bcd8739ae039 = $7efbe2b9a287a996$var$Timestamp;



parcelRequire("dup7A");
const $76dcb344d4658ac7$var$SvgRightArrow = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 17 8",
        ...props,
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
            fill: "#DAF0FF",
            d: "M11.712 2.504H.93a.43.43 0 0 0-.429.428v2c0 .237.192.429.429.429h10.783v1.645c0 .764.923 1.146 1.463.606l3.074-3.074a.857.857 0 0 0 0-1.212L13.175.253c-.54-.54-1.463-.158-1.463.606z"
        })
    });
var $76dcb344d4658ac7$export$2e2bcd8739ae039 = $76dcb344d4658ac7$var$SvgRightArrow;




const $5f9304d10027893d$var$StyledSnapshotAccordionTitle = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  width: 95%;
`;
const $5f9304d10027893d$var$StyledChainsAndAddressesContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  color: ${({ theme: theme })=>theme.color.blue};
`;
const $5f9304d10027893d$var$ArrowContainer = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  position: relative;
  padding-left: 18px;
  padding-right: 10px;
  padding-top: 3.5px;
`;
const $5f9304d10027893d$var$StyledRightArrowIcon = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).svg`
  position: relative;
  width: 17px;
  height: 17px;
  fill: none;
`;
const $5f9304d10027893d$var$StyledColoredLabel = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $9745418b2907d1b5$export$2e2bcd8739ae039))`
  margin-left: auto;
  padding-right: calc(12px - (12) * (100vw - 370px) / (1250 - 370));
`;
const $5f9304d10027893d$var$StyledEpochAndTimestamp = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  justify-content: start;
  gap: 24px;
  margin-right: auto;
`;
const $5f9304d10027893d$var$SnapshotAccordionTitle = ({ epoch: epoch, bridgeId: bridgeId, timestamp: timestamp, status: status })=>{
    const { network: network } = (0, $0cbc3af4abf88a1e$export$616ead5bf0ef583b)();
    const bridgeInfo = (0, $039e8edd5249fb5b$export$f55bcf30472c04eb)(bridgeId);
    const titleParams = {
        epoch: epoch,
        timestamp: timestamp,
        fromChain: bridgeInfo.from,
        fromAddress: bridgeInfo.contracts[network].veaInbox,
        toChain: bridgeInfo.to,
        toAddress: bridgeInfo.contracts[network].veaOutbox
    };
    const fromChainObject = (0, $039e8edd5249fb5b$export$f4608058c83a1dc2)(titleParams.fromChain);
    const toChainObject = (0, $039e8edd5249fb5b$export$f4608058c83a1dc2)(titleParams.toChain);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($5f9304d10027893d$var$StyledSnapshotAccordionTitle, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($5f9304d10027893d$var$StyledEpochAndTimestamp, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $f512a188bc65d36c$export$2e2bcd8739ae039), {
                        epoch: epoch
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $7efbe2b9a287a996$export$2e2bcd8739ae039), {
                        timestamp: titleParams.timestamp
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($5f9304d10027893d$var$StyledChainsAndAddressesContainer, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $04fdaee17971f80d$export$2e2bcd8739ae039), {
                        chainObject: fromChainObject,
                        address: titleParams.fromAddress
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($5f9304d10027893d$var$ArrowContainer, {
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($5f9304d10027893d$var$StyledRightArrowIcon, {
                            as: (0, $76dcb344d4658ac7$export$2e2bcd8739ae039)
                        })
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $04fdaee17971f80d$export$2e2bcd8739ae039), {
                        chainObject: toChainObject,
                        address: titleParams.toAddress
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($5f9304d10027893d$var$StyledColoredLabel, {
                text: $5f9304d10027893d$var$parseStatus(status),
                variant: $5f9304d10027893d$var$parseStatus(status)
            })
        ]
    });
};
const $5f9304d10027893d$var$parseStatus = ({ resolved: resolved, resolving: resolving, challenged: challenged, verified: verified, claimed: claimed })=>{
    if (resolved) return "Resolved";
    if (resolving) return "Resolving";
    if (challenged) return "Challenged";
    if (verified) return "Verified";
    if (claimed) return "Claimed";
    return "Saved";
};
var $5f9304d10027893d$export$2e2bcd8739ae039 = $5f9304d10027893d$var$SnapshotAccordionTitle;


const $af95aaa2cd6c8c6c$var$StyledSnapshotAccordionGlobal = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.CustomAccordion))`
  display: flex;
  width: 100%;
  justify-content: center;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    padding: 0px;
  `)}

  .accordion-button {
    border: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-radius: 3px;
    padding: 16px;
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      padding: 16px calc(6px + (10) * (100vw - 370px) / (1250 - 370));
    `)}
  }

  .accordion-svg {
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      align-self: end;
      margin-bottom: 9px;
    `)}
  }

  .accordion-item__Body-sc-17yp2l-2 {
    background-color: ${({ theme: theme })=>theme.color.secondaryPurple};
    border-right: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-left: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-bottom: 1px solid ${({ theme: theme })=>theme.color.secondaryBlue};
    border-radius: 3px;

    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      width: 100%;
      padding-left: 16px;
      padding-right: 16px;
    `)}
  }

  svg.accordion-svg path {
    fill: ${({ theme: theme })=>theme.color.blue};
  }
`;
const $af95aaa2cd6c8c6c$var$SnapshotAccordion = ({ items: items })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($af95aaa2cd6c8c6c$var$StyledSnapshotAccordionGlobal, {
        items: items.map(({ epoch: epoch, bridgeId: bridgeId, snapshotId: snapshotId, status: status, transactions: transactions }, index)=>({
                key: index,
                title: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $5f9304d10027893d$export$2e2bcd8739ae039), {
                    epoch: epoch,
                    bridgeId: bridgeId,
                    timestamp: transactions[0].timestamp,
                    status: status
                }),
                body: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $63867ade5479fa01$export$2e2bcd8739ae039), {
                    transactions: transactions,
                    snapshotId: snapshotId,
                    bridgeId: bridgeId,
                    epoch: epoch
                })
            }))
    });
};
var $af95aaa2cd6c8c6c$export$2e2bcd8739ae039 = $af95aaa2cd6c8c6c$var$SnapshotAccordion;



parcelRequire("dup7A");




parcelRequire("dup7A");



const $24d42755e30f61f2$var$FilterItem = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039)((0, $43afcb05ca3681f6$exports.DropdownSelect))`
  ${(props)=>props.disabled && (0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      pointer-events: none;
      opacity: 0.5;
    `}
  .item-icon {
    margin-right: 8px;
    width: 16px;
    height: 16px;
  }
  h1 {
    font-family: "Oxanium";
    font-size: 14px;
    font-weight: 400;
    line-height: 17.5px;
  }
  svg {
    height: 8px;
    width: 8px;
  }

  p {
    font-family: "Open Sans";
  }

  .cOGsRq {
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      right: auto;
    `)}
  }

  .iVPRzL {
    ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
      right: auto;
    `)}
  }
`;
const $24d42755e30f61f2$export$d21937a90300cd7a = ({ isSimpleButton: isSimpleButton, isAlignRight: isAlignRight, itemData: itemData, value: value, callback: callback, disabled: disabled })=>{
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($24d42755e30f61f2$var$FilterItem, {
        items: itemData,
        defaultValue: value,
        simpleButton: isSimpleButton,
        alignRight: isAlignRight,
        callback: callback,
        disabled: disabled
    });
};



parcelRequire("dup7A");





parcelRequire("dup7A");
const $1da5830468d0da8e$var$SvgGlobe = (props)=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("g", {
                clipPath: "url(#globe_svg__a)",
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                    fill: "#69C3FC",
                    d: "M7.946 0C3.565 0 0 3.589 0 8s3.565 8 7.946 8 7.946-3.589 7.946-8-3.565-8-7.946-8m7.079 8c0 .686-.097 1.35-.278 1.979h-2.95c.064-.648.101-1.312.101-1.975 0-.664-.037-1.327-.1-1.976h2.951c.18.627.276 1.288.276 1.972m-.64-2.96h-2.71c-.215-1.392-.583-2.668-1.1-3.657 1.688.682 3.056 2 3.81 3.658m-3.47 2.964c0 .685-.038 1.342-.102 1.975h-5.68a19.5 19.5 0 0 1 0-3.95h5.68c.064.632.101 1.29.101 1.975M9.138.974c.697.783 1.255 2.245 1.548 4.067H5.262c.295-1.83.856-3.298 1.558-4.078a7 7 0 0 1 2.32.011m-3.754.382c-.524.992-.897 2.279-1.11 3.685H1.506a7.14 7.14 0 0 1 3.879-3.685M4.149 9.979H1.145A7.2 7.2 0 0 1 .867 8c0-.684.096-1.345.275-1.972h3.01a20 20 0 0 0-.101 1.976c0 .663.037 1.327.098 1.975m-2.64.988h2.766c.215 1.402.587 2.685 1.109 3.677a7.14 7.14 0 0 1-3.874-3.677m5.303 4.069c-.698-.782-1.256-2.246-1.55-4.07h5.425c-.292 1.816-.847 3.274-1.54 4.058a7 7 0 0 1-2.335.012m3.772-.423c.514-.987.88-2.259 1.094-3.646h2.704a7.14 7.14 0 0 1-3.798 3.646"
                })
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("clipPath", {
                    id: "globe_svg__a",
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });
var $1da5830468d0da8e$export$2e2bcd8739ae039 = $1da5830468d0da8e$var$SvgGlobe;



const $96cb9c734242dcde$var$Container = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 50px;
  position: relative;
  right: 40px;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    right: 0px;
  `)}
`;
const $96cb9c734242dcde$var$DropdownTag = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px;
  align-items: center;
  min-width: 140px;
  white-space: nowrap;
  small {
    font-size: 14px;
    line-height: 17.5px;
    color: ${({ theme: theme })=>theme.color.blue} !important;
  }
`;
const { toChains: $96cb9c734242dcde$var$toChains, fromChains: $96cb9c734242dcde$var$fromChains } = (0, $039e8edd5249fb5b$export$4cc9423ec3f21f7c).reduce(({ toChains: toChains, fromChains: fromChains, uniqueToChains: uniqueToChains, uniqueFromChains: uniqueFromChains }, { to: to, from: from })=>{
    if (!uniqueFromChains.has(from)) {
        const fromChain = (0, $039e8edd5249fb5b$export$f4608058c83a1dc2)(from);
        fromChains.push({
            text: fromChain.name,
            Icon: fromChain.logo,
            value: fromChain.id
        });
        uniqueFromChains.add(fromChain.id);
    }
    if (!uniqueToChains.has(to)) {
        const toChain = (0, $039e8edd5249fb5b$export$f4608058c83a1dc2)(to);
        toChains.push({
            text: toChain.name,
            Icon: toChain.logo,
            value: toChain.id
        });
        uniqueToChains.add(toChain.id);
    }
    return {
        toChains: toChains,
        fromChains: fromChains,
        uniqueToChains: uniqueToChains,
        uniqueFromChains: uniqueFromChains
    };
}, {
    toChains: [
        {
            text: "All Networks",
            Icon: (0, $1da5830468d0da8e$export$2e2bcd8739ae039),
            value: 0
        }
    ],
    fromChains: [
        {
            text: "All Networks",
            Icon: (0, $1da5830468d0da8e$export$2e2bcd8739ae039),
            value: 0
        }
    ],
    uniqueToChains: new Set(),
    uniqueFromChains: new Set()
});
const $96cb9c734242dcde$var$NetworkFilters = ()=>{
    const { fromChain: fromChain, setFromChain: setFromChain, toChain: toChain, setToChain: setToChain } = (0, $0cbc3af4abf88a1e$export$616ead5bf0ef583b)();
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($96cb9c734242dcde$var$Container, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($96cb9c734242dcde$var$DropdownTag, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                        children: "From: "
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $24d42755e30f61f2$export$d21937a90300cd7a), {
                        isAlignRight: false,
                        isSimpleButton: true,
                        itemData: $96cb9c734242dcde$var$fromChains,
                        value: fromChain,
                        callback: setFromChain
                    })
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($96cb9c734242dcde$var$DropdownTag, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                        children: "To: "
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $24d42755e30f61f2$export$d21937a90300cd7a), {
                        isAlignRight: false,
                        isSimpleButton: true,
                        itemData: $96cb9c734242dcde$var$toChains,
                        value: toChain,
                        callback: setToChain
                    })
                ]
            })
        ]
    });
};
var $96cb9c734242dcde$export$2e2bcd8739ae039 = $96cb9c734242dcde$var$NetworkFilters;


const $9efc7dbfce3cd1fd$var$HeaderText = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).h5`
  font-size: 24px;
  text-transform: lowercase;
  color: ${({ theme: theme })=>theme.color.lightBlue};
  line-height: 24px;
`;
const $9efc7dbfce3cd1fd$var$SnapshotHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 64px;
  margin: 76px auto 24px auto;
  width: 100%;

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    margin-top: 60px;
  `)}
`;
const $9efc7dbfce3cd1fd$var$FilterHeader = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  margin-left: 33px;
  align-items: start;
  flex-wrap: wrap;
  justify-content: space-between;
  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    margin-left: calc(0px + (33) * (100vw - 370px) / (1250 - 370));
    gap: 12px;
  `)}
`;
const $9efc7dbfce3cd1fd$var$DropdownTag = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 4px;
  align-items: center;
  min-width: 140px;
  white-space: nowrap;
  small {
    font-size: 14px;
    line-height: 17.5px;
    color: ${({ theme: theme })=>theme.color.blue} !important;
  }
`;
const $9efc7dbfce3cd1fd$var$EpochAndTimeTag = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 30px;
  margin-right: 180px;
  small {
    font-family: "Oxanium";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${({ theme: theme })=>theme.color.lightBlue} !important;
  }

  ${(0, $9c70c842094d28bf$export$863f8b1efd907ec3)((0, $e9f8389e4f70b5af$export$dbf350e5966cf602)`
    display: none;
  `)}
`;
const $9efc7dbfce3cd1fd$var$TxFilterHeader = ()=>{
    const { statusItems: statusItems, statusFilter: statusFilter, setStatusFilter: setStatusFilter, debouncedSearch: debouncedSearch, network: network } = (0, $0cbc3af4abf88a1e$export$616ead5bf0ef583b)();
    const isSearchEmpty = debouncedSearch === "";
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($9efc7dbfce3cd1fd$var$SnapshotHeader, {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($9efc7dbfce3cd1fd$var$HeaderText, {
                children: [
                    "Latest ",
                    network,
                    " Snapshots"
                ]
            }),
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($9efc7dbfce3cd1fd$var$FilterHeader, {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($9efc7dbfce3cd1fd$var$EpochAndTimeTag, {
                        children: [
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                                children: "Epoch ID"
                            }),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                                children: "Timestamp"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $96cb9c734242dcde$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)($9efc7dbfce3cd1fd$var$DropdownTag, {
                        children: [
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("small", {
                                children: "Status: "
                            }),
                            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $24d42755e30f61f2$export$d21937a90300cd7a), {
                                value: statusFilter,
                                isAlignRight: true,
                                isSimpleButton: true,
                                itemData: statusItems,
                                callback: setStatusFilter,
                                disabled: !isSearchEmpty
                            }, statusFilter)
                        ]
                    })
                ]
            })
        ]
    });
};
var $9efc7dbfce3cd1fd$export$2e2bcd8739ae039 = $9efc7dbfce3cd1fd$var$TxFilterHeader;








const $3be6a6f87d391414$export$b48399ba0dc32743 = (shownSnapshots = new Set(), lastTimestamp = "9999999999", snapshotsPerPage = 5)=>{
    const adjustedTimestamp = (BigInt(lastTimestamp) - BigInt(1)).toString();
    const { debouncedSearch: debouncedSearch, fromChain: fromChain, toChain: toChain, queryInfo: queryInfo, statusFilter: statusFilter, network: network } = (0, $0cbc3af4abf88a1e$export$616ead5bf0ef583b)();
    return (0, $bf4543ca6fdad7aa$export$2e2bcd8739ae039)(`${fromChain}${toChain}${lastTimestamp}${statusFilter}${debouncedSearch}${network}`, async ()=>{
        const { sortedSnapshots: sortedSnapshots } = await $3be6a6f87d391414$var$getSortedSnapshots(network, adjustedTimestamp, debouncedSearch, fromChain, toChain, snapshotsPerPage, queryInfo.query);
        const filteredSnapshots = sortedSnapshots.filter((snapshot)=>!shownSnapshots.has($3be6a6f87d391414$export$62d6658c8a4d60c4(snapshot)));
        const pageSnapshots = filteredSnapshots.slice(0, snapshotsPerPage);
        const res = {
            snapshots: await Promise.all(pageSnapshots.map((snapshot)=>$3be6a6f87d391414$var$getSecondaryData(network, snapshot, debouncedSearch, queryInfo.order))),
            isMorePages: filteredSnapshots.length > snapshotsPerPage
        };
        return res;
    });
};
const $3be6a6f87d391414$var$getSortedSnapshots = async (network, lastTimestamp, debouncedSearch, from, to, snapshotsPerPage, query)=>{
    const filteredBridges = (0, $039e8edd5249fb5b$export$4cc9423ec3f21f7c).filter((bridge)=>{
        if (from > 0 && bridge.from !== from) return false;
        if (to > 0 && bridge.to !== to) return false;
        return true;
    });
    const queryQueue = filteredBridges.map((bridge)=>(0, $3ecb954f3d350801$exports.request)($3be6a6f87d391414$var$getEndpoint(query, bridge, debouncedSearch), $3be6a6f87d391414$var$getQueryDocument(query, debouncedSearch), {
            lastTimestamp: lastTimestamp,
            snapshotsPerPage: snapshotsPerPage + 1,
            value: debouncedSearch,
            contract: $3be6a6f87d391414$var$getQueryContract(query, debouncedSearch, bridge, network)
        }).then((queryResult)=>{
            const getSnapshots = ()=>{
                if (debouncedSearch) return queryResult.snapshotQuery;
                else if ((0, $0cbc3af4abf88a1e$export$219a9e7e4111be17)(query)) return queryResult.snapshots;
                else return queryResult.claims;
            };
            return getSnapshots().map((snapshot)=>({
                    ...snapshot,
                    bridgeId: bridge.id
                }));
        }));
    const snapshotsWithBridgeId = await Promise.all(queryQueue).then((result)=>result.flat());
    return {
        sortedSnapshots: snapshotsWithBridgeId.sort((a, b)=>parseInt(b.timestamp) - parseInt(a.timestamp))
    };
};
const $3be6a6f87d391414$var$getEndpoint = (query, bridge, debouncedSearch)=>{
    if (debouncedSearch || (0, $0cbc3af4abf88a1e$export$219a9e7e4111be17)(query)) return bridge.inboxEndpoint;
    return bridge.outboxEndpoint;
};
const $3be6a6f87d391414$var$getQueryDocument = (query, debouncedSearch)=>debouncedSearch ? (0, $72674c05516c5d85$export$a92bfde441f2bbcc) : query;
const $3be6a6f87d391414$var$getQueryContract = (query, debouncedSearch, bridge, network)=>{
    if (debouncedSearch || (0, $0cbc3af4abf88a1e$export$219a9e7e4111be17)(query)) return bridge.contracts[network].veaInbox;
    return bridge.contracts[network].veaOutbox;
};
const $3be6a6f87d391414$var$getSecondaryData = async (network, snapshot, debouncedSearch, order)=>{
    const isFirstInbox = order === (0, $0cbc3af4abf88a1e$export$11e75bce9f7ea886).firstInbox;
    const bridge = (0, $039e8edd5249fb5b$export$f55bcf30472c04eb)(snapshot.bridgeId);
    const fallbackEndpoint = isFirstInbox ? bridge.outboxEndpoint : bridge.inboxEndpoint;
    const endpoint = debouncedSearch !== "" ? bridge.outboxEndpoint : fallbackEndpoint;
    const secondaryData = await (0, $3ecb954f3d350801$exports.request)(endpoint, isFirstInbox ? (0, $c01bc8aa182cc810$export$4f062a25be074082) : (0, $72674c05516c5d85$export$2532f3c0a33feede), {
        epoch: snapshot.epoch.toString(),
        contract: isFirstInbox ? bridge.contracts[network].veaOutbox : bridge.contracts[network].veaInbox
    }).then((result)=>isFirstInbox ? result.claims[0] : result.snapshots[0]);
    const filteredData = isFirstInbox ? [
        snapshot,
        secondaryData
    ] : [
        {
            ...secondaryData,
            bridgeId: snapshot.bridgeId
        },
        snapshot
    ];
    return filteredData;
};
const $3be6a6f87d391414$export$62d6658c8a4d60c4 = ({ bridgeId: bridgeId, epoch: epoch })=>`${bridgeId.toString() + epoch}`;




var $d6353409f4b7c3c7$export$5b6f3f92d1c86928 = /*#__PURE__*/ function(ClaimStatus) {
    ClaimStatus[ClaimStatus["UNKNOWN"] = -1] = "UNKNOWN";
    ClaimStatus[ClaimStatus["CLAIMED"] = 1] = "CLAIMED";
    ClaimStatus[ClaimStatus["CHALLENGED"] = 2] = "CHALLENGED";
    ClaimStatus[ClaimStatus["VERIFIED"] = 3] = "VERIFIED";
    ClaimStatus[ClaimStatus["RESOLVING"] = 4] = "RESOLVING";
    ClaimStatus[ClaimStatus["RESOLVED"] = 5] = "RESOLVED";
    return ClaimStatus;
}({});
/**
 * Helper function to calculate the current claim status.
 */ const $d6353409f4b7c3c7$var$calculateCurrentStatus = (status)=>{
    if (status.resolved) return 5;
    if (status.resolving) return 4;
    if (status.challenged) return 2;
    if (status.verified) return 3;
    if (status.claimed) return 1;
    return -1;
};
const $d6353409f4b7c3c7$export$5387f0ecb238326e = (snapshotsData, statusFilter)=>{
    const data = snapshotsData.map(([inboxData, outboxData])=>{
        const bridgeInfo = (0, $039e8edd5249fb5b$export$4cc9423ec3f21f7c)[inboxData?.bridgeId];
        const transactions = [
            inboxData?.txHash ? {
                title: "Creator",
                chain: bridgeInfo?.from,
                txHash: inboxData?.txHash,
                timestamp: (0, $a37a4ef6c45b808d$export$fc7b06d6a4abcacf)(inboxData?.timestamp),
                caller: inboxData?.caller,
                extraFields: [
                    {
                        key: "State Root",
                        value: inboxData?.stateRoot,
                        isCopy: true
                    }
                ]
            } : null,
            outboxData?.txHash ? {
                title: "Oracle",
                chain: bridgeInfo?.to,
                txHash: outboxData.txHash,
                timestamp: (0, $a37a4ef6c45b808d$export$fc7b06d6a4abcacf)(outboxData.timestamp),
                caller: outboxData.bridger,
                extraFields: [
                    {
                        key: "State Root",
                        value: outboxData.stateroot,
                        isCopy: true
                    }
                ]
            } : null,
            outboxData?.challenge?.txHash ? {
                title: "Challenger",
                chain: bridgeInfo?.to,
                txHash: outboxData.challenge.txHash,
                timestamp: (0, $a37a4ef6c45b808d$export$fc7b06d6a4abcacf)(outboxData.challenge.timestamp),
                caller: outboxData.challenge.challenger
            } : null,
            inboxData?.fallback && Array.isArray(inboxData.fallback) && inboxData.fallback.length > 0 && inboxData.fallback[0]?.txHash ? {
                title: "Fallback Sender",
                chain: bridgeInfo?.from,
                txHash: inboxData.fallback[0].txHash,
                timestamp: (0, $a37a4ef6c45b808d$export$fc7b06d6a4abcacf)(inboxData.fallback[0].timestamp),
                caller: inboxData.fallback[0].executor
            } : null,
            outboxData?.verification?.verifiedTxHash ? {
                title: outboxData?.challenge?.txHash ? "Fallback Executor" : "Verifier",
                chain: bridgeInfo?.to,
                txHash: outboxData.verification.verifiedTxHash,
                timestamp: (0, $a37a4ef6c45b808d$export$fc7b06d6a4abcacf)(outboxData.verification.verifiedTimestamp),
                caller: outboxData.verification.verifiedCaller
            } : null
        ].filter(Boolean);
        const status = {
            claimed: typeof outboxData?.txHash !== "undefined",
            verified: !outboxData?.challenged && outboxData?.verified,
            challenged: outboxData?.challenged,
            resolving: outboxData?.challenged && inboxData?.resolving,
            resolved: outboxData?.challenged && outboxData?.verified
        };
        const currentStatus = $d6353409f4b7c3c7$var$calculateCurrentStatus(status);
        return {
            bridgeId: inboxData.bridgeId,
            epoch: inboxData?.epoch ?? outboxData?.epoch,
            snapshotId: inboxData.id,
            status: {
                claimed: typeof outboxData?.txHash !== "undefined",
                verified: !outboxData?.challenged && outboxData?.verified,
                challenged: outboxData?.challenged,
                resolving: outboxData?.challenged && inboxData?.resolving,
                resolved: outboxData?.challenged && outboxData?.verified
            },
            currentStatus: currentStatus,
            transactions: transactions
        };
    });
    const filteredData = statusFilter !== 0 ? data.filter((item)=>item.currentStatus == statusFilter) : data;
    return filteredData;
};




const $7735de36cd8a0af5$var$SNAPSHOTS_PER_PAGE = 5;
const $7735de36cd8a0af5$var$StyledPagination = (0, $e9f8389e4f70b5af$export$2e2bcd8739ae039).div`
  margin-top: 32px;
  margin-left: auto;
`;
const $7735de36cd8a0af5$var$App = ()=>{
    const [currentPage, setCurrentPage] = (0, $dup7A.useState)(1);
    const [pageTracking, { push: pushPageTracking, removeAt: removeAtPageTracking, clear: clearPageTracking }] = (0, $225f8088c132ce63$export$2e2bcd8739ae039)();
    const { data: data } = (0, $3be6a6f87d391414$export$b48399ba0dc32743)(pageTracking.at(-1)?.shownSnapshots, pageTracking.at(-1)?.timestamp, $7735de36cd8a0af5$var$SNAPSHOTS_PER_PAGE);
    const { fromChain: fromChain, toChain: toChain, statusFilter: statusFilter, setNetwork: setNetwork } = (0, $0cbc3af4abf88a1e$export$616ead5bf0ef583b)();
    (0, $dup7A.useEffect)(()=>{
        const hostname = window.location.hostname.toLowerCase();
        if (hostname.startsWith("testnet.")) setNetwork((0, $039e8edd5249fb5b$export$95be4ae94445245a).TESTNET);
        setNetwork((0, $039e8edd5249fb5b$export$95be4ae94445245a).TESTNET);
    }, []);
    (0, $dup7A.useEffect)(()=>{
        if (currentPage !== 1) {
            clearPageTracking();
            setCurrentPage(1);
        }
    }, [
        fromChain,
        toChain,
        statusFilter
    ]);
    const handlePageChange = (0, $dup7A.useCallback)((newPage)=>{
        if (newPage > currentPage) pushPageTracking({
            timestamp: data?.snapshots.at(-1)?.[0].timestamp,
            shownSnapshots: new Set(data?.snapshots.map((snapshot)=>(0, $3be6a6f87d391414$export$62d6658c8a4d60c4)(snapshot[0])))
        });
        else removeAtPageTracking(-1);
        setCurrentPage(newPage);
    }, [
        data,
        currentPage,
        pushPageTracking,
        removeAtPageTracking
    ]);
    return /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)((0, $96065926c92644df$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $9efc7dbfce3cd1fd$export$2e2bcd8739ae039), {}),
            data ? /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)((0, $975c4832af85a2cd$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $af95aaa2cd6c8c6c$export$2e2bcd8739ae039), {
                        items: (0, $d6353409f4b7c3c7$export$5387f0ecb238326e)(data.snapshots, statusFilter)
                    }, currentPage),
                    /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($7735de36cd8a0af5$var$StyledPagination, {
                        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $43afcb05ca3681f6$exports.StandardPagination), {
                            numPages: data.isMorePages ? currentPage + 1 : currentPage,
                            currentPage: currentPage,
                            callback: handlePageChange,
                            hideNumbers: true
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)("p", {
                children: "loading..."
            })
        ]
    });
};
var $7735de36cd8a0af5$export$2e2bcd8739ae039 = $7735de36cd8a0af5$var$App;


const $ab0ed18dcefdb06b$var$WebApp = ()=>/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dup7A))).StrictMode, {
        children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsxs)((0, $e9f8389e4f70b5af$export$d8964aec282183a3), {
            theme: $36383d7ccd515376$export$bca14c5b3b88a9c9,
            children: [
                /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $8869b1e060a1f334$export$f05794e648629f6c), {}),
                /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $0cbc3af4abf88a1e$export$2e3feefe77201a07), {
                    children: /*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)((0, $7735de36cd8a0af5$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
const $ab0ed18dcefdb06b$var$container = document.getElementById("app");
if ($ab0ed18dcefdb06b$var$container) {
    const root = (0, $1c1c7e7d360f5af6$export$882461b6382ed46c)($ab0ed18dcefdb06b$var$container);
    root.render(/*#__PURE__*/ (0, $975c4832af85a2cd$exports.jsx)($ab0ed18dcefdb06b$var$WebApp, {}));
}


//# sourceMappingURL=veascan-web.4cfab82c.js.map
